webpackJsonp([4],{

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('WidgetView', ["$sce", "$filter", function ($sce, $filter) {
    var WidgetView = function WidgetView(widget, index, loadSub, domainView, pWidgetView) {
        this.index = index;
        this.domainView = domainView;
        this.pWidgetView = pWidgetView !== undefined ? pWidgetView : null;
        this.x = 0;
        this.y = 0;
        this.width = 4;
        this.height = 7;
        this.effect = null;
        this.widgetsView = [];
        this.isGalery = false; //view only
        this.isDefault = false; //view only
        this.displaySelectorLarge = true; //view only
        this.defaultCardEffect = 'f0_card';
        //SUBOBJECT
        this.img = null;
        this.type = null; //text / object / fullscreen-offer / default-offer / video / title
        this.object = null;
        this.objectType = null;
        this.spHtml = false;
        this.blockBgColor = null;
        this.shadowColor = null;
        this.fontColor = null;
        this.blockPos = "mid";
        this.spImg = false;
        this.isActive = false;
        this.textHtml = null;
        this.visible = false;
        this.imgUrl = null;
        if (widget !== undefined && widget != null) this.loadDataFrom(widget, loadSub);
    };
    WidgetView.prototype.loadItems = function (items) {
        //remove service/product/cure/loyalty if isOnHome : False
        if (this.widgetsView) for (var i = 0; i < this.widgetsView.length; i++) {
            switch (this.widgetsView[i].objectType) {
                case "service":
                case "product":
                case "cure":
                    if (this.widgetsView[i].object && !this.widgetsView[i].object.isOnHome) {
                        this.removeWidgetView(this.widgetsView[i]);
                        i--;
                    }
                    break;
            }
        } // loadItems from item list based on service/product/cure/loyalty/isOnHome : true
        for (var i = 0; i < items.length; i++) {
            if (!this.hasObject(items[i].item)) {
                var widgetView = new WidgetView(null, i, false, this.domainView, this);
                widgetView.setObject(items[i].item, items[i].type);
                this.widgetsView.push(widgetView);
            }
        }
    };
    WidgetView.prototype.hasObject = function (object) {
        if (this.widgetsView) for (var i = 0; i < this.widgetsView.length; i++) {
            if (this.widgetsView[i].object == object) return true;
        }return false;
    };
    WidgetView.prototype.loadDataFrom = function (widget, loadSub) {
        this.displaySelectorLarge = false; //not new

        this.x = widget.x;
        this.y = widget.y;
        this.width = widget.width;
        this.height = widget.height;
        if (this.domainView && this.domainView.ad.view.isOnMobile) //optimize display on mobile
            {
                this.height = Math.round(this.height * 4 / this.width); //proportion
                this.width = 4;
            }
        if (widget.imgId) {
            this.img = this.domainView.getImagesViewById(widget.imgId);
        }
        if (widget.type) this.type = widget.type;
        this.effect = widget.effect;
        if (widget.blockBgColor) this.blockBgColor = widget.blockBgColor;
        if (widget.shadowColor) this.shadowColor = widget.shadowColor;
        if (widget.fontColor) this.fontColor = widget.fontColor;
        if (widget.blockPos) this.blockPos = widget.blockPos;
        if (widget.textHtml && widget.textHtml != "") this.textHtml = widget.textHtml;
        this.imgUrl = widget.imgUrl;
        if (widget.objectType && this.domainView) {
            this.spHtml = widget.spHtml;
            this.spImg = widget.spImg;
            var object = null;
            switch (widget.objectType) {
                case "service":
                    object = this.domainView.getServiceViewById(widget.objectId);
                    break;
                case "category":
                    object = this.domainView.getCategoryViewById(widget.objectId);
                    break;
                case "product":
                    object = this.domainView.getProductViewById(widget.objectId);
                    break;
                case "productCategory":
                    object = this.domainView.getProductCategoryViewById(widget.objectId);
                    break;
                case "cure":
                    object = this.domainView.getCureViewById(widget.objectId);
                    break;
                case "cureCategory":
                    object = this.domainView.getCureCategoryViewById(widget.objectId);
                    break;
                case "gift":
                    object = widget.object;
                    break;
            }
            if (object) this.setObject(object, widget.objectType, false);
        }

        var subWidget;
        if (widget.widgets && loadSub) {
            this.widgetsView = [];
            for (var i = 0; i < widget.widgets.length; i++) {
                subWidget = new WidgetView(widget.widgets[i], i, false, this.domainView, this);
                subWidget.pWidgetView = this;
                if (subWidget.objectType != "object" || subWidget.object) //object must has been instanciate
                    this.widgetsView.push(subWidget);
            }
        }
        this.isGalery = this.widgetsView.length > 1;
        this.updateParentType();
    };
    WidgetView.prototype.changeWidgetPosition = function (widgetView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // serviceView : service to move to indexTarget

        var index = this.widgetsView.indexOf(widgetView);
        if (indexTarget != -1 && index != -1 && indexTarget <= this.widgetsView.length) {
            this.widgetsView.splice(index, 1); //remove it
            if (indexTarget == this.widgetsView.length) this.widgetsView.push(widgetView);else this.widgetsView.splice(indexTarget, 0, widgetView); //insert
        }
    };
    WidgetView.prototype.setVideo = function (src) {
        var index = src.indexOf("watch?v=");
        var embed = null;
        var id = null;
        var imgVid = null;
        if (index != -1) id = src.substring(index + 8);else {
            index = src.indexOf("embed/");
            if (index != -1) id = src.substring(index + 6);else {
                index = src.indexOf("youtu.be/");
                if (index != -1) id = src.substring(index + 9);
            }
        }
        if (id) {
            index = id.indexOf("/");
            if (index != -1) id = id.substring(0, index);
            index = id.indexOf("&");
            if (index != -1) id = id.substring(0, index);
            imgVid = "https://img.youtube.com/vi/" + id + "/hqdefault.jpg";
            this.imgUrl = imgVid;
            embed = "https://www.youtube.com/embed/" + id;
            this.textHtml = '<img class="ta-insert-video" src="' + imgVid + '" ta-insert-video="' + embed + '" contenteditable="false" allowfullscreen="true" frameborder="0" style="width: 100%;height=100%">';
        }
    };
    WidgetView.prototype.setType = function (type, isParent) {
        this.displaySelectorLarge = false;
        if (isParent) {
            var widgetView = new WidgetView(null, this.widgetsView.length, false, this.domainView, this);
            widgetView.setType(type, false);
            this.widgetsView.push(widgetView);
            this.isGalery = this.widgetsView.length > 1;
            this.type = type;
            if (type == "title") {
                this.width = 12;
                this.height = 2;
            }
            if (type == "text") this.width = 6;
            this.updateParentType();
        } else {
            this.type = type;
        }
    };
    WidgetView.prototype.setImage = function (img, isParent) {
        this.displaySelectorLarge = false;
        if (isParent) {
            var widgetView = new WidgetView(null, this.widgetsView.length, false, this.domainView, this);
            widgetView.setImage(img, false);
            this.widgetsView.push(widgetView);
            this.isGalery = this.widgetsView.length > 1;
            this.updateParentType();
        } else {
            if (this.type == 'object') this.spImg = true;else this.type = "image";
            this.img = img;
        }
    };
    WidgetView.prototype.removeWidgetView = function (widgetView) {
        var index = this.widgetsView.indexOf(widgetView);
        if (index != -1) this.widgetsView.splice(index, 1);
    };

    WidgetView.prototype.setObject = function (object, objectType, isParent) {
        this.displaySelectorLarge = false;

        if (isParent) {
            var widgetView = new WidgetView(null, this.widgetsView.length, false, this.domainView, this);
            widgetView.setObject(object, objectType, false);
            this.widgetsView.push(widgetView);
            this.isGalery = this.widgetsView.length > 1;
            if (!this.isGalery) {
                this.shadowColor = "black";
                this.fontColor = "white";
                this.effect = this.defaultCardEffect;
            }
            this.updateParentType();
        } else {
            this.type = 'object';
            this.object = object;
            this.objectType = objectType;
            if (object) {
                if (this.object.imageDisplayed && !this.spImg) this.img = this.object.imageDisplayed;
                if (!this.spHtml) this.textHtml = this.getAutoText(object, objectType);
                if (this.objectType == "gift") this.imgUrl = "/img/exemplebon.svg";
            }
        }
    };
    WidgetView.prototype.getAutoText = function (object, objectType) {
        var textHtml = "";
        switch (objectType) {
            case "service":
            case "product":
            case "cure":
                if (this.pWidgetView && this.pWidgetView.type == "default-offer") textHtml = '<h2>' + this.object.label + '</h2>';else textHtml = '<h2 style="text-align: center;">' + this.object.label + '</h2>';
                if (this.object.description && this.object.description != '' && this.pWidgetView) if (this.pWidgetView.type == "default-offer") if (this.object.description.indexOf("<p>") == 0) textHtml += this.object.description;else textHtml += '<p>' + this.object.description + '</p>';

                break;
            case "category":
            case "productCategory":
            case "loyaltyCardCategory":
            case "cureCategory":
                if (this.pWidgetView && this.pWidgetView.type == "default-offer") textHtml = '<h2>' + this.object.label + '</h2>';else textHtml = '<h2 style="text-align: center;">' + this.object.label + '</h2>';
                break;
            case "gift":
                var tag = "div";
                if (this.pWidgetView && (this.pWidgetView.type == "default-offer" || this.pWidgetView.type == "fullscreen-offer")) tag = "h2";
                var style = "";
                if (this.pWidgetView && this.pWidgetView.type == "fullscreen-offer") var style = "text-align: center;";
                if (object == "delivery") textHtml = '<' + tag + ' style="' + style + '">Un chèque cadeau livré chez vous ?</' + tag + '>';
                if (object == "mailPrint") textHtml = '<' + tag + ' style="' + style + '">Un chèque cadeau imprimable ?</' + tag + '>';
                if (object == "mail") textHtml = '<' + tag + ' style="' + style + '">Un chèque cadeau envoyé par email ?</' + tag + '>';
                break;
        }
        return textHtml;
    };
    WidgetView.prototype.updateParentType = function () {
        if (this.type != "title" && this.type != "text" && this.type != "fullscreen-offer" && this.type != "default-offer") {
            if (this.widgetsView.length != 0) this.type = this.widgetsView[0].type;
            for (var i = 1; i < this.widgetsView.length; i++) {
                if (this.type != this.widgetsView[i].type && this.type != "mixed") this.type = "mixed";
            }
        }
    };
    WidgetView.prototype.updateFromDefault = function (widgetView) {
        if (this.type != "title") {
            this.effect = widgetView.effect;
            this.blockBgColor = widgetView.blockBgColor;
            this.fontColor = widgetView.fontColor;
            this.shadowColor = widgetView.shadowColor;
        }
    };
    WidgetView.prototype.updateTextHtml = function () {
        if (!this.spHtml) this.textHtml = this.getAutoText(this.object, this.objectType);
        if (this.widgetsView) for (var i = 0; i < this.widgetsView.length; i++) {
            this.widgetsView[i].updateTextHtml();
        }
    };

    WidgetView.prototype.onUpdateTextHtml = function () {
        if (this.type == "object") this.spHtml = this.textHtml != this.getAutoText(this.object, this.objectType);
    };
    WidgetView.prototype.getObjectResource = function () {
        var resource = {};
        resource.x = this.x;
        resource.y = this.y;
        resource.width = this.width;
        resource.height = this.height;
        if (this.img) resource.imgId = this.img.id;
        resource.effect = this.effect;
        resource.type = this.type;
        resource.blockBgColor = this.blockBgColor;
        resource.fontColor = this.fontColor;
        resource.shadowColor = this.shadowColor;
        resource.spHtml = this.spHtml;
        resource.spImg = this.spImg;
        resource.blockPos = this.blockPos;
        resource.imgUrl = this.imgUrl;
        if (this.object) {
            if (typeof this.object !== "string" && this.object.getModel()) resource.objectId = this.object.getModel().id;else resource.object = this.object;
            resource.objectType = this.objectType;
        }
        resource.widgets = [];
        if (this.widgetsView) for (var i = 0; i < this.widgetsView.length; i++) {
            resource.widgets.push(this.widgetsView[i].getObjectResource());
        }resource.textHtml = this.textHtml;
        return resource;
    };

    return WidgetView;
}]);

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CategoryView', ["$log", "ServiceView", "CategoryData", "ServiceData", "Category", "CategorySrv", "ServiceSrv", "StyleColor", "ItemCategoryView", "gettextCatalog", "Auth", "Constants", function ($log, ServiceView, CategoryData, ServiceData, Category, CategorySrv, ServiceSrv, StyleColor, ItemCategoryView, gettextCatalog, Auth, Constants) {
    var styleDefaut = { background: 'white' };
    var CategoryView = function CategoryView(category, catIndex, parentCategoryView, domainView) {
        ItemCategoryView.call(this);

        this.catIndex = catIndex;
        this.domainView = domainView;
        this.label = "";
        this.description = "";
        this.servicesView = [];
        this.categoriesView = [];
        this.image = null;
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.styleView = {}; //styleView is an object and category.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.parentCategoryView = null;
        this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
        this.selectedServiceView = null;
        this.displayType = "array"; // only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
        this.displayServiceImages = true; // only on view if children images are different than son
        this.isVisible = true;
        if (parentCategoryView !== undefined && parentCategoryView != null) {
            this.parentCategoryView = parentCategoryView;
        }

        this.styleView = this.getStyleFrom(category);
        if (this.styleView) {
            this.colorPicker = this.styleView.background;
        }

        if (category !== undefined && category != null) {
            this.loadDataFrom(category);
            for (var i = 0; i < category.categories.length; i++) {
                this.categoriesView.push(new CategoryView(category.categories[i], CategoryData.getIndexOf(category.categories[i]), this, domainView));
            }for (var j = 0; j < category.services.length; j++) {
                var serviceView = void 0;
                if (this.domainView && this.domainView.findServiceView !== undefined) {
                    serviceView = this.domainView.findServiceView(category.services[j]);
                    if (serviceView != undefined) this.servicesView.push(serviceView);
                }
                if (!serviceView) {
                    serviceView = new ServiceView(category.services[j], ServiceData.getIndexOf(category.services[j]), this, domainView);
                    this.servicesView.push(serviceView);
                    if (this.domainView && this.domainView.addServiceViewIndex !== undefined) {
                        this.domainView.addServiceViewIndex(serviceView);
                    }
                }
            }
        }
    };

    CategoryView.prototype = Object.create(ItemCategoryView.prototype); //inherit functions from ItemCategoryView

    CategoryView.prototype.setImage = function (image) {
        for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j].image == null && !this.servicesView[j].specificImage) //if same than previous change
                this.servicesView[j].setImage(image);
        }this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    CategoryView.prototype.setCompanyImage = function (companyImage) {
        for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j].companyImage == null && !this.servicesView[j].specificImage) //if same than previous change
                this.servicesView[j].setImage(companyImage);
        }this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };
    CategoryView.prototype.loadProductsView = function () {
        for (var j = 0; j < this.servicesView.length; j++) {
            this.servicesView[j].loadProductsView();
        }for (var z = 0; z < this.categoriesView.length; z++) {
            this.categoriesView[z].loadProductsView();
        }
    };
    CategoryView.prototype.getCategoryView = function (category) {
        var categoryView = null;
        if (this.getModel() === category) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryView(category);
        }return categoryView;
    };
    CategoryView.prototype.getCategoryViewByLabel = function (label) {
        var categoryView = null;
        if (this.label == label) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryViewByLabel(label);
        }return categoryView;
    };

    CategoryView.prototype.getServiceView = function (service) {
        var serviceView = null;
        for (var j = 0; j < this.servicesView.length && !serviceView; j++) {
            if (this.servicesView[j].getModel() === service) return this.servicesView[j];else if (this.servicesView[j].isPackage) serviceView = this.servicesView[j].getSubServiceView(service);
        }for (var z = 0; z < this.categoriesView.length && !serviceView; z++) {
            serviceView = this.categoriesView[z].getServiceView(service);
        }return serviceView;
    };

    CategoryView.prototype.copyDataTo = function (category) {
        //Assume here than the object in parameter contains only id (must load them)
        category.label = this.label;
        category.description = this.description;
        if (this.parentCategoryView && this.styleView === this.parentCategoryView.styleView) // if is specific set it
            category.style = null;else category.style = angular.toJson(this.styleView);
        category.image = this.image;
        category.companyImage = this.companyImage;
        category.specificImage = this.specificImage;
        category.isVisibleOnWebSite = this.isVisibleOnWebSite;
        category.isVisible = this.isVisible;
    };
    CategoryView.prototype.loadDataFrom = function (category) {
        this.label = category.label;
        this.description = category.description;
        this.image = category.image;
        this.companyImage = category.companyImage;
        this.specificImage = category.specificImage;
        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;
        this.isVisibleOnWebSite = category.isVisibleOnWebSite;
    };
    CategoryView.prototype.onStyleViewChange = function () {
        var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
        if (!this.styleView || this.styleView.background != this.colorPicker) {

            if (!this.styleView || //if undefined
            this.parentCategoryView && this.parentCategoryView.styleView === this.styleView) {
                // if same than parent : break inheritance

                var newStyle = {
                    background: this.colorPicker,
                    color: fontColor
                };
                this.updateStyleView(newStyle);
                this.styleView = newStyle;
            } else {
                this.styleView.background = this.colorPicker;
                this.styleView.color = fontColor;
            }
        }
    };
    CategoryView.prototype.updateStyleView = function (styleView) {
        //update colorpicker from subcategories
        for (var j = 0; j < this.categoriesView.length; j++) {
            if (this.categoriesView[j].styleView === this.styleView) {
                this.categoriesView[j].colorPicker = styleView.background;
                this.categoriesView[j].updateStyleView(styleView);
                this.categoriesView[j].styleView = styleView;
            }
        }

        //update colorpicker from subservices
        for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j].styleView === this.styleView) {
                this.servicesView[j].styleView = styleView;
                this.servicesView[j].colorPicker = styleView.background;
            }
        }
    };
    CategoryView.prototype.getStyleFrom = function (category) {
        var styleView = null;
        if (category) if (category.style && category.style.indexOf('{') != 0) //Previous type before 1.5 was not contains a jsonSTring
            styleView = null;else try {
            styleView = angular.fromJson(category.style);
        } catch (ex) {
            console.log("Error loading style");
        }
        if (!styleView) if (this.parentCategoryView != null) styleView = this.parentCategoryView.styleView;else styleView = styleDefaut;
        return styleView;
    };
    CategoryView.prototype.isChanged = function () {
        var category = this.getModel();
        if (category) {
            /*var image = category.image;
            if ((image==null||image=="") &&this.parentCategoryView)
                image = this.parentCategoryView.image;*/
            var styleView = this.getStyleFrom(category);
            var styleChanged = this.styleView && !styleView || !this.styleView && styleView || this.styleView && styleView && this.styleView.background != styleView.background;
            return this.label != category.label || this.description != category.description || styleChanged || this.image != category.image || this.companyImage != category.companyImage;
        } else return true;
    };

    CategoryView.prototype.getAllServicesView = function () {
        var servicesView = [];
        for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j]) servicesView.push(this.servicesView[j]);
        }for (var z = 0; z < this.categoriesView.length; z++) {
            servicesView = servicesView.concat(this.categoriesView[z].getAllServicesView());
        }return servicesView;
    };

    CategoryView.prototype.getServicesViewByLabel = function (label) {
        var servicesView = [];
        for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j].label && this.servicesView[j].label.toLowerCase().indexOf(label) != -1) servicesView.push(this.servicesView[j]);
        }for (var z = 0; z < this.categoriesView.length; z++) {
            servicesView = servicesView.concat(this.categoriesView[z].getServicesViewByLabel(label));
        }return servicesView;
    };
    CategoryView.prototype.getServiceViewById = function (id) {
        var service;
        for (var j = 0; j < this.servicesView.length; j++) {
            service = this.servicesView[j].getModel();
            if (service && service.id == id) return this.servicesView[j];
        }
        var serviceView = null;
        for (var z = 0; z < this.categoriesView.length && !serviceView; z++) {
            serviceView = this.categoriesView[z].getServiceViewById(id);
        }return serviceView;
    };
    CategoryView.prototype.getCategoryViewById = function (id) {
        var categoryView = null;
        var category = this.getModel();
        if (category && category.id == id) return this;
        for (var z = 0; z < this.categoriesView.length && !categoryView; z++) {
            categoryView = this.categoriesView[z].getCategoryViewById(id);
        }return categoryView;
    };

    CategoryView.prototype.getModel = function () {
        if (this.catIndex != -1) return CategoryData.getByIndex(this.catIndex);
        return null;
    };
    CategoryView.prototype.restoreModel = function () {
        //undeleted
        var category = this.getModel();
        if (category) {
            if (category.parentCategory) category.parentCategory.addCategory(category);
            CategorySrv.restore(category);
        }
    };
    CategoryView.prototype.updateModel = function (successFunction, errorFunction) {
        var category = this.getModel();
        if (category == null) {
            category = new Category();
            this.catIndex = CategoryData.getIndexOf(category);
        }

        this.copyDataTo(category);
        if (this.parentCategoryView) {
            var parentCategory = this.parentCategoryView.getModel();
            if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory) category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
        }
        category.categories = [];
        for (var i = 0; i < this.categoriesView.length; i++) {
            category.addCategory(this.categoriesView[i].getModel());
        }category.services = [];
        for (var i = 0; i < this.servicesView.length; i++) {
            category.addService(this.servicesView[i].getModel());
        }CategorySrv.save(category, successFunction, function () {
            this.checkForRootSaveError();
            if (errorFunction) {
                errorFunction();
            }
        });
    };

    CategoryView.prototype.computeViewsImpactedByImportAndCountServices = function () {
        var importData = {
            categoryViewsToUpdate: [],
            serviceCount: 0
        };
        if (this.impactedByImport) {
            importData.categoryViewsToUpdate.push(this);
            this.impactedByImport = false;
        }
        for (var j = 0; j < this.servicesView.length; j++) {
            importData.serviceCount = importData.serviceCount + 1;
        }
        for (var _j = 0; _j < this.categoriesView.length; _j++) {
            var subCategoryTreeImportData = this.categoriesView[_j].computeViewsImpactedByImportAndCountServices();
            importData.categoryViewsToUpdate = importData.categoryViewsToUpdate.concat(subCategoryTreeImportData.categoryViewsToUpdate);
            importData.serviceCount = importData.serviceCount + subCategoryTreeImportData.serviceCount;
        }
        return importData;
    };

    CategoryView.prototype.reloadModel = function () {
        var category = this.getModel();
        if (category == null) {
            this.parentCategoryView.removeCategoryView(this);
        } else {
            var styleView = this.getStyleFrom(category);
            if (this.styleView && styleView) {
                this.styleView.background = styleView.background;
                this.styleView.color = styleView.color;
            } else this.styleView = styleView;
            this.colorPicker = this.styleView.background;

            this.loadDataFrom(category);
        }
    };
    CategoryView.prototype.removeModel = function () {
        var category = this.getModel();
        if (category != null) {
            category.parentCategory.removeCategory(category);
            CategorySrv.remove(category);
        }
    };

    CategoryView.prototype.setSkills = function (resource) {
        //if one service is known by resource : category is known
        this.isSelResKnow = false;
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.isSelResKnow = this.categoriesView[i].setSkills(resource) || this.isSelResKnow;
        }for (var j = 0; j < this.servicesView.length; j++) {
            this.isSelResKnow = this.servicesView[j].setSkills(resource) || this.isSelResKnow;
        }return this.isSelResKnow;
    };
    CategoryView.prototype.removeSelections = function () {
        //if one service is known by humanResource : category is known
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].removeSelections();
        }for (var j = 0; j < this.servicesView.length; j++) {
            this.servicesView[j].isSelected = false;
        }
    };
    CategoryView.prototype.removeCustomerSelections = function () {
        //if one service is known by humanResource : category is known
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].removeCustomerSelections();
        }for (var j = 0; j < this.servicesView.length; j++) {
            this.servicesView[j].nbSelectableForCure = 0;
            this.servicesView[j].nbSelectableForGift = 0;
        }
    };
    CategoryView.prototype.addCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index == -1) {
            this.categoriesView.push(categoryView);

            var hasNoStyle = false;
            if (!categoryView.styleView || //if undefined
            categoryView.parentCategoryView && categoryView.parentCategoryView.styleView === categoryView.styleView) // if same than parent : break inheritance
                hasNoStyle = true;

            categoryView.parentCategoryView = this;

            if (hasNoStyle) {
                categoryView.updateStyleView(this.styleView);
                categoryView.styleView = this.styleView;
            }
        }
    };

    CategoryView.prototype.removeCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index != -1) this.categoriesView.splice(index, 1);
    };
    CategoryView.prototype.addServiceView = function (serviceView) {
        var index = this.servicesView.indexOf(serviceView);
        if (index == -1) {
            this.servicesView.push(serviceView);

            var hasNoStyle = false;
            if (!serviceView.styleView || //if undefined
            serviceView.parentCategoryView && serviceView.parentCategoryView.styleView === serviceView.styleView) // if same than parent : break inheritance
                hasNoStyle = true;

            serviceView.parentCategoryView = this;

            if (hasNoStyle) serviceView.styleView = this.styleView;
        }
    };

    CategoryView.prototype.removeServiceView = function (serviceView) {
        var index = this.servicesView.indexOf(serviceView);
        if (index != -1) {
            this.servicesView.splice(index, 1);
        }
    };

    CategoryView.prototype.populateHomeItemsView = function (homeItemsView) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateHomeItemsView(homeItemsView);
        }for (var j = 0; j < this.servicesView.length; j++) {
            if (this.servicesView[j].isOnHome) homeItemsView.push({ type: 'service', item: this.servicesView[j], active: false });
        }
    };
    //CategoryView.prototype.loadWidgetsView = function() {
    //    for (var i=0;i< this.categoriesView.length;i++)
    //        this.categoriesView[i].loadWidgetsView();
    //    for (var j=0;j< this.servicesView.length;j++)
    //        this.servicesView[j].loadWidgetsView();
    //};


    CategoryView.prototype.changeCategoryPosition = function (scope, categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget
        var category = this.getModel();
        var index = this.categoriesView.indexOf(categoryView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            category.categories.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY Two APPLYs ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.categoriesView.length) {
                this.categoriesView.push(categoryView);
                category.categories.push(categoryView.getModel());
            } else {
                this.categoriesView.splice(indexTarget, 0, categoryView); //insert
                category.categories.splice(indexTarget, 0, categoryView.getModel());
            }
            CategorySrv.save(category, null, this.checkForRootSaveError);
        }
        scope.$apply();
    };
    CategoryView.prototype.changeCategoryPositionView = function (categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget
        var index = this.categoriesView.indexOf(categoryView);
        if (indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            if (indexTarget == this.categoriesView.length) this.categoriesView.push(categoryView);else this.categoriesView.splice(indexTarget, 0, categoryView); //insert
        }
    };
    CategoryView.prototype.changeServicePosition = function (scope, serviceView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // serviceView : service to move to indexTarget

        var category = this.getModel();
        var index = this.servicesView.indexOf(serviceView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.servicesView && indexTarget <= this.servicesView.length) {
            this.servicesView.splice(index, 1); //remove it
            category.services.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY TO APPLY ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.servicesView.length) {
                this.servicesView.push(serviceView);
                category.services.push(serviceView.getModel());
            } else {
                this.servicesView.splice(indexTarget, 0, serviceView); //insert
                category.services.splice(indexTarget, 0, serviceView.getModel());
            }
            CategorySrv.save(category, null, this.checkForRootSaveError);
            scope.$apply();
        }
    };
    CategoryView.prototype.changeServicePositionView = function (serviceView, indexTarget) {
        //Change the service position

        var index = this.servicesView.indexOf(serviceView);
        //Todo check indexTarget!=index
        if (indexTarget != -1 && index != -1 && this.servicesView && indexTarget <= this.servicesView.length) {
            this.servicesView.splice(index, 1); //remove it
            if (indexTarget == this.servicesView.length) this.servicesView.push(serviceView);else this.servicesView.splice(indexTarget, 0, serviceView); //insert
        }
    };
    CategoryView.prototype.duplicateCategory = function (successFunction, errorFunction) {
        var category = this.getModel();
        if (category) {
            CategorySrv.duplicateCategory(category, successFunction, errorFunction);
        }
    };
    CategoryView.prototype.countCurrentServices = function (successFunction, errorFunction) {
        return CategorySrv.countCurrentServices(successFunction, errorFunction);
    };
    CategoryView.prototype.moveService = function (serviceView) {
        if (serviceView) {
            var service = serviceView.getModel();
            var category = this.getModel();
            if (service && category) {
                if (serviceView.parentCategoryView) {
                    var index = serviceView.parentCategoryView.servicesView.indexOf(serviceView);
                    if (index != -1) {
                        serviceView.parentCategoryView.servicesView.splice(index, 1);
                        service.parentCategory.services.splice(index, 1);
                    }
                }
                this.addServiceView(serviceView);
                category.addService(service);
                ServiceSrv.save(service);
            }
        }
    };
    CategoryView.prototype.moveCategory = function (categoryView) {
        if (categoryView) {
            var categoryToMove = categoryView.getModel();
            var category = this.getModel();
            if (categoryToMove && category) {
                if (categoryView.parentCategoryView) {
                    var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                    if (index != -1) {
                        categoryView.parentCategoryView.categoriesView.splice(index, 1);
                        categoryToMove.parentCategory.categories.splice(index, 1);
                    }
                }
                this.addCategoryView(categoryView);
                category.addCategory(categoryToMove);
                CategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
            }
        }
    };
    CategoryView.prototype.canSave = function () {
        return this.label && this.label !== "";
    };
    CategoryView.prototype.initWebDisplay = function (forceTo) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].initWebDisplay(forceTo);
        }
        this.displayServiceImages = false;
        for (var j = 0; j < this.servicesView.length && !this.displayServiceImages; j++) {
            if (this.servicesView[j].imageDisplayed !== this.imageDisplayed) {
                this.displayServiceImages = true;
            }
        }
        for (var _j2 = 0; _j2 < this.categoriesView.length && !this.displayServiceImages; _j2++) {
            if (this.categoriesView[_j2].imageDisplayed !== this.imageDisplayed) {
                this.displayServiceImages = true;
            }
        }
        if (forceTo !== undefined && forceTo != "") {
            this.displayType = forceTo;
        } else {
            if (this.displayServiceImages) {
                this.displayType = "thumbnail";
            } else {
                this.displayType = "array";
            }
        }
    };
    CategoryView.prototype.populateDisplayTypeResource = function (array) {
        var defaultDType = this.displayServiceImages ? "thumbnail" : "array";
        if (this.displayType != defaultDType) {
            var cat = this.getModel();
            if (cat) array.push({ id: cat.id, type: this.displayType });
        }
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateDisplayTypeResource(array);
        }
    };

    return CategoryView;
}]);

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureCategoryView', ["$log", "CureView", "CureCategoryData", "CureData", "CureCategory", "CureCategorySrv", "CureSrv", "StyleColor", "ItemCategoryView", function ($log, CureView, CureCategoryData, CureData, CureCategory, CureCategorySrv, CureSrv, StyleColor, ItemCategoryView) {

    var CureCategoryView = function CureCategoryView(category, catIndex, parentCategoryView, domainView) {
        ItemCategoryView.call(this);

        this.catIndex = catIndex;
        this.domainView = domainView;
        this.label = "";
        this.description = "";
        this.curesView = [];
        this.categoriesView = [];
        this.image = null;
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.styleView = {}; //styleView is an object and category.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.parentCategoryView = null;
        this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
        this.selectedCureView = null;
        this.displayType = "array"; // only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
        this.displayCureImages = true; // only on view if children images are different than son

        if (parentCategoryView !== undefined && parentCategoryView != null) this.parentCategoryView = parentCategoryView;

        this.styleView = this.getStyleFrom(category);
        if (this.styleView) this.colorPicker = this.styleView.background;

        if (category !== undefined && category != null) {
            var cureView;
            this.loadDataFrom(category);
            for (var i = 0; i < category.categories.length; i++) {
                this.categoriesView.push(new CureCategoryView(category.categories[i], CureCategoryData.getIndexOf(category.categories[i]), this, domainView));
            }for (var j = 0; j < category.cures.length; j++) {
                cureView = new CureView(category.cures[j], CureData.getIndexOf(category.cures[j]), this, domainView);
                this.curesView.push(cureView);
                if (this.domainView && this.domainView.addCureViewIndex !== undefined) this.domainView.addCureViewIndex(cureView);
            }
        }
    };

    CureCategoryView.prototype = Object.create(ItemCategoryView.prototype); //inherit functions from ItemCategoryView

    CureCategoryView.prototype.setImage = function (image) {
        for (var j = 0; j < this.curesView.length; j++) {
            if (this.curesView[j].image == null && !this.curesView[j].specificImage) //if same than previous change
                this.curesView[j].setImage(image);
        }this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    CureCategoryView.prototype.setCompanyImage = function (companyImage) {
        for (var j = 0; j < this.curesView.length; j++) {
            if (this.curesView[j].companyImage == null && !this.curesView[j].specificImage) //if same than previous change
                this.curesView[j].setImage(companyImage);
        }this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    CureCategoryView.prototype.getCategoryView = function (category) {
        var categoryView = null;
        if (this.getModel() === category) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryView(category);
        }return categoryView;
    };

    CureCategoryView.prototype.getCureView = function (cure) {
        var cureView = null;
        for (var j = 0; j < this.curesView.length; j++) {
            if (this.curesView[j].getModel() === cure) return this.curesView[j];
        }for (var z = 0; z < this.categoriesView.length && !cureView; z++) {
            cureView = this.categoriesView[z].getCureView(cure);
        }return cureView;
    };
    CureCategoryView.prototype.getCureViewById = function (id) {
        var cure;
        for (var j = 0; j < this.curesView.length; j++) {
            cure = this.curesView[j].getModel();
            if (cure && cure.id == id) return this.curesView[j];
        }
        var cureView = null;
        for (var z = 0; z < this.categoriesView.length && !cureView; z++) {
            cureView = this.categoriesView[z].getCureViewById(id);
        }return cureView;
    };
    CureCategoryView.prototype.getCategoryViewById = function (id) {
        var categoryView = null;
        var category = this.getModel();
        if (category && category.id == id) return this;
        for (var z = 0; z < this.categoriesView.length && !categoryView; z++) {
            categoryView = this.categoriesView[z].getCategoryViewById(id);
        }return categoryView;
    };

    CureCategoryView.prototype.getAllCuresView = function (cure) {
        var lCuresView = this.curesView.slice(0);

        var array;
        for (var z = 0; z < this.categoriesView.length; z++) {
            array = this.categoriesView[z].getAllCuresView();
            if (array) for (var j = 0; j < array.length; j++) {
                lCuresView.push(array[j]);
            }
        }

        return lCuresView;
    };

    CureCategoryView.prototype.getCureViewByCode = function (code) {
        var cureView = null;
        for (var j = 0; j < this.curesView.length; j++) {
            if (this.curesView[j].code == code) return this.curesView[j];
        }for (var z = 0; z < this.categoriesView.length && !cureView; z++) {
            cureView = this.categoriesView[z].getCureViewByCode(code);
        }return cureView;
    };

    CureCategoryView.prototype.copyDataTo = function (category) {
        //Assume here than the object in parameter contains only id (must load them)
        category.label = this.label;
        category.description = this.description;
        if (this.parentCategoryView && this.styleView === this.parentCategoryView.styleView) // if is specific set it
            category.style = null;else category.style = angular.toJson(this.styleView);
        category.image = this.image;
        category.companyImage = this.companyImage;
        category.specificImage = this.specificImage;
        category.isVisibleOnWebSite = this.isVisibleOnWebSite;
    };

    CureCategoryView.prototype.loadDataFrom = function (category) {
        this.label = category.label;
        this.description = category.description;
        this.image = category.image;
        this.companyImage = category.companyImage;
        this.specificImage = category.specificImage;
        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;
        this.isVisibleOnWebSite = category.isVisibleOnWebSite;
    };

    CureCategoryView.prototype.onStyleViewChange = function () {
        var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
        if (!this.styleView || this.styleView.background != this.colorPicker) {
            if (!this.styleView || //if undefined
            this.parentCategoryView && this.parentCategoryView.styleView === this.styleView) // if same than parent : break inheritance
                this.styleView = {};
            this.styleView.background = this.colorPicker;
            this.styleView.color = fontColor;
            this.updateStyleView();
        }
    };

    CureCategoryView.prototype.updateStyleView = function (styleView) {
        for (var j = 0; j < this.categoriesView.length; j++) {
            if (this.categoriesView[j].styleView == null) //if same than previous change
                this.categoriesView[j].updateStyleView(styleView);
        }
    };

    CureCategoryView.prototype.getStyleFrom = function (category) {
        var styleView = null;
        if (category) if (category.style && category.style.indexOf('{') != 0) //Previous type before 1.5 was not contains a jsonSTring
            styleView = null;else try {
            styleView = angular.fromJson(category.style);
        } catch (ex) {
            console.log("Error loading style");
        }
        if (!styleView) if (this.parentCategoryView != null) styleView = this.parentCategoryView.styleView;
        return styleView;
    };

    CureCategoryView.prototype.populateHomeItemsView = function (homeItemsView) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateHomeItemsView(homeItemsView);
        }for (var j = 0; j < this.curesView.length; j++) {
            if (this.curesView[j].isOnHome) homeItemsView.push({ type: 'cure', item: this.curesView[j], active: false });
        }
    };

    CureCategoryView.prototype.isChanged = function () {
        var category = this.getModel();
        if (category) {
            /*var image = category.image;
            if ((image==null||image=="") &&this.parentCategoryView)
                image = this.parentCategoryView.image;*/
            var styleView = this.getStyleFrom(category);
            var styleChanged = this.styleView && !styleView || !this.styleView && styleView || this.styleView && styleView && this.styleView.background != styleView.background;
            return this.label != category.label || this.description != category.description || styleChanged || this.image != category.image || this.companyImage != category.companyImage;
        } else return true;
    };

    CureCategoryView.prototype.getModel = function () {
        if (this.catIndex != -1) return CureCategoryData.getByIndex(this.catIndex);
        return null;
    };

    CureCategoryView.prototype.restoreModel = function () {
        //undeleted
        var category = this.getModel();
        if (category) {
            if (category.parentCategory) category.parentCategory.addCategory(category);
            CureCategorySrv.restore(category);
        }
    };

    CureCategoryView.prototype.updateModel = function () {
        var category = this.getModel();
        if (category == null) {
            category = new CureCategory();
            this.catIndex = CureCategoryData.getIndexOf(category);
        }

        this.copyDataTo(category);
        if (this.parentCategoryView) {
            var parentCategory = this.parentCategoryView.getModel();
            if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory) category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
        }
        category.categories = [];
        for (var i = 0; i < this.categoriesView.length; i++) {
            category.addCategory(this.categoriesView[i].getModel());
        }category.cures = [];
        for (var i = 0; i < this.curesView.length; i++) {
            category.addCure(this.curesView[i].getModel());
        } //modify order of categories

        CureCategorySrv.save(category, null, this.checkForRootSaveError);
    };

    CureCategoryView.prototype.reloadModel = function () {
        var category = this.getModel();
        if (category == null) {
            this.parentCategoryView.removeCategoryView(this);
        } else {
            var styleView = this.getStyleFrom(category);
            if (this.styleView && styleView) {
                this.styleView.background = styleView.background;
                this.styleView.color = styleView.color;
            } else this.styleView = styleView;

            if (this.styleView) this.colorPicker = this.styleView.background;

            this.loadDataFrom(category);
        }
    };

    CureCategoryView.prototype.removeModel = function () {
        var category = this.getModel();
        if (category != null) {
            if (category.parentCategory) category.parentCategory.removeCategory(category);
            CureCategorySrv.remove(category);
        }
    };

    CureCategoryView.prototype.removeSelections = function () {
        //if one cure is known by humanResource : category is known
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].removeSelections();
        }for (var j = 0; j < this.curesView.length; j++) {
            this.curesView[j].isSelected = false;
        }
    };

    CureCategoryView.prototype.addCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index == -1) {
            this.categoriesView.push(categoryView);
            categoryView.parentCategoryView = this;
        }
    };

    CureCategoryView.prototype.removeCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index != -1) this.categoriesView.splice(index, 1);
    };

    CureCategoryView.prototype.addCureView = function (cureView) {
        var index = this.curesView.indexOf(cureView);
        if (index == -1) {
            this.curesView.push(cureView);
            cureView.parentCategoryView = this;
        }
    };

    CureCategoryView.prototype.removeCureView = function (cureView) {
        var index = this.curesView.indexOf(cureView);
        if (index != -1) {
            this.curesView.splice(index, 1);
        }
    };

    CureCategoryView.prototype.changeCategoryPosition = function (scope, categoryView, indexTarget) {
        var category = this.getModel();
        var index = this.categoriesView.indexOf(categoryView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            category.categories.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY Two APPLYs ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.categoriesView.length) {
                this.categoriesView.push(categoryView);
                category.categories.push(categoryView.getModel());
            } else {
                this.categoriesView.splice(indexTarget, 0, categoryView); //insert
                category.categories.splice(indexTarget, 0, categoryView.getModel());
            }
            CureCategorySrv.save(category, null, this.checkForRootSaveError);
        }
        scope.$apply();
    };

    CureCategoryView.prototype.changeCategoryPositionView = function (categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget
        var index = this.categoriesView.indexOf(categoryView);
        if (indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            if (indexTarget == this.categoriesView.length) this.categoriesView.push(categoryView);else this.categoriesView.splice(indexTarget, 0, categoryView); //insert
        }
    };

    CureCategoryView.prototype.changeCurePositionView = function (cureView, indexTarget) {
        //Change the cure position

        var index = this.curesView.indexOf(cureView);
        //Todo check indexTarget!=index
        if (indexTarget != -1 && index != -1 && this.curesView && indexTarget <= this.curesView.length) {
            this.curesView.splice(index, 1); //remove it
            if (indexTarget == this.curesView.length) this.curesView.push(cureView);else this.curesView.splice(indexTarget, 0, cureView); //insert
        }
    };

    CureCategoryView.prototype.changeCurePosition = function (scope, cureView, indexTarget) {

        var category = this.getModel();
        var index = this.curesView.indexOf(cureView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.curesView && indexTarget <= this.curesView.length) {
            this.curesView.splice(index, 1); //remove it
            category.cures.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY TO APPLY ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.curesView.length) {
                this.curesView.push(cureView);
                category.cures.push(cureView.getModel());
            } else {
                this.curesView.splice(indexTarget, 0, cureView); //insert
                category.cures.splice(indexTarget, 0, cureView.getModel());
            }
            CureCategorySrv.save(category, null, this.checkForRootSaveError);
            scope.$apply();
        }
    };

    CureCategoryView.prototype.moveCure = function (cureView) {
        if (cureView) {
            var cure = cureView.getModel();
            var category = this.getModel();
            if (cure && category) {
                if (cureView.parentCategoryView) {
                    var index = cureView.parentCategoryView.curesView.indexOf(cureView);
                    if (index != -1) {
                        cureView.parentCategoryView.curesView.splice(index, 1);
                        cure.parentCategory.cures.splice(index, 1);
                    }
                }
                this.addCureView(cureView);
                category.addCure(cure);
                CureSrv.save(cure);
            }
        }
    };

    CureCategoryView.prototype.moveCategory = function (categoryView) {
        if (categoryView) {
            var categoryToMove = categoryView.getModel();
            var category = this.getModel();
            if (categoryToMove && category) {
                if (categoryView.parentCategoryView) {
                    var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                    if (index != -1) {
                        categoryView.parentCategoryView.categoriesView.splice(index, 1);
                        categoryToMove.parentCategory.categories.splice(index, 1);
                    }
                }
                this.addCategoryView(categoryView);
                category.addCategory(categoryToMove);
                CureCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
            }
        }
    };

    CureCategoryView.prototype.canSave = function () {
        return this.label && this.label != "";
    };

    CureCategoryView.prototype.initWebDisplay = function (forceTo) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].initWebDisplay(forceTo);
        }this.displayCureImages = false;
        for (var j = 0; j < this.curesView.length && !this.displayCureImages; j++) {
            if (this.curesView[j].imageDisplayed !== this.imageDisplayed) this.displayCureImages = true;
        }for (var j = 0; j < this.categoriesView.length && !this.displayServiceImages; j++) {
            if (this.categoriesView[j].imageDisplayed !== this.imageDisplayed) this.displayCureImages = true;
        }if (forceTo !== undefined && forceTo != "") this.displayType = forceTo;else if (this.displayCureImages) this.displayType = "thumbnail";else this.displayType = "array";
    };

    CureCategoryView.prototype.populateDisplayTypeResource = function (array) {
        var defaultDType = this.displayCureImages ? "thumbnail" : "array";
        if (this.displayType != defaultDType) {
            var cat = this.getModel();
            if (cat) array.push({ id: cat.id, type: this.displayType });
        }
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateDisplayTypeResource(array);
        }
    };

    return CureCategoryView;
}]);

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageView', ["CureItemToServiceUsageData", "CureItemToServiceUsage", "CureItemToServiceUsageSrv", "ReadOnlyBookingServiceView", function (CureItemToServiceUsageData, CureItemToServiceUsage, CureItemToServiceUsageSrv, ReadOnlyBookingServiceView) {

    var CureItemToServiceUsageView = function CureItemToServiceUsageView(cureItemToServiceUsage, ciIndex, cureItemToServiceView, domainView) {
        this.ciIndex = ciIndex; //model index
        this.domainView = domainView;
        this.cureItemToServiceView = cureItemToServiceView;
        this.hrView = null;
        this.usedQuantity = 0;
        this.usageTime = null;
        this.bookingServiceView = null;
        this.chronogicalIndex = null;
        this.useForm = {
            serviceView: cureItemToServiceView ? cureItemToServiceView.serviceView : null
        };
        if (cureItemToServiceUsage) this.loadDataFrom(cureItemToServiceUsage);

        this.chronogicalIndex = 0;
    };
    CureItemToServiceUsageView.prototype.getModel = function () {
        if (this.ciIndex != -1) {
            return CureItemToServiceUsageData.getByIndex(this.ciIndex);
        }
        return null;
    };
    CureItemToServiceUsageView.prototype.loadDataFrom = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) {
            this.usedQuantity = cureItemToServiceUsage.usedQuantity;
            this.usageTime = cureItemToServiceUsage.usageTime;
            if (cureItemToServiceUsage.humanResource && this.domainView && this.domainView.getHrView !== undefined) this.hrView = this.domainView.getHrView(cureItemToServiceUsage.humanResource);
            if (cureItemToServiceUsage.bookingService) this.bookingServiceView = new ReadOnlyBookingServiceView(cureItemToServiceUsage.bookingService, -1, null);
        }
    };
    CureItemToServiceUsageView.prototype.reloadModel = function () {
        var cureItemToServiceUsage = this.getModel();
        if (cureItemToServiceUsage != null) {
            this.loadDataFrom(cureItemToServiceUsage);
        }
    };

    CureItemToServiceUsageView.prototype.copyDataTo = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) {
            cureItemToServiceUsage.usedQuantity = this.usedQuantity;
            cureItemToServiceUsage.usageTime = this.usageTime;
            if (this.hrView) cureItemToServiceUsage.humanResource = this.hrView.getModel();else cureItemToServiceUsage.humanResource = null;
            if (this.bookingServiceView) cureItemToServiceUsage.bookingService = this.bookingServiceView.getModel();else cureItemToServiceUsage.bookingService = null;

            if (this.cureItemToServiceView) {
                var newCureItemToService = this.cureItemToServiceView.getModel();
                if (newCureItemToService) if (cureItemToServiceUsage.cureItemToService) //already exist
                    {
                        if (newCureItemToService !== cureItemToServiceUsage.cureItemToService) //changed
                            {
                                cureItemToServiceUsage.cureItemToService.removeCureItemToServiceUsage(cureItemToServiceUsage);
                                newCureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);
                            }
                    } else newCureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);
            }
        }
    };
    CureItemToServiceUsageView.prototype.duplicate = function (bsView) {
        if (this.cureItemToServiceView && bsView) {
            if (this.cureItemToServiceView.isUsed()) return null;
            var cureItemToServiceUsageView = new CureItemToServiceUsageView();
            cureItemToServiceUsageView.usedQuantity = this.usedQuantity;
            if (bsView.bookingView && bsView.bookingView.plgDayView && bsView.period) cureItemToServiceUsageView.usageTime = new Date(bsView.bookingView.plgDayView.date.getTime() + bsView.period.start.getTime() * 60000);
            if (bsView.plgDayHrView) cureItemToServiceUsageView.hrView = bsView.plgDayHrView.hrView;
            cureItemToServiceUsageView.bookingServiceView = bsView;
            bsView.price = 0;

            this.cureItemToServiceView.addCureItemToServiceUsageView(cureItemToServiceUsageView);
            return cureItemToServiceUsageView;
        }
        return null;
    };

    CureItemToServiceUsageView.prototype.initFromBookingServiceView = function (cureItemToServiceView, bsView) {
        if (bsView) {
            if (bsView.bookingView && bsView.bookingView.plgDayView && bsView.period) this.usageTime = new Date(bsView.bookingView.plgDayView.date.getTime() + bsView.period.start.getTime() * 60000);
            this.cureItemToServiceView = cureItemToServiceView;
            this.bookingServiceView = bsView;
            if (bsView.plgDayHrView) this.hrView = bsView.plgDayHrView.hrView;
            this.usedQuantity = 1;
            bsView.cureItemToServiceUsageView = this;
        }
    };

    CureItemToServiceUsageView.prototype.updateModel = function (saveUsage) {
        var cureItemToServiceUsage = this.getModel();
        if (cureItemToServiceUsage == null) {
            cureItemToServiceUsage = new CureItemToServiceUsage();
            this.ciIndex = CureItemToServiceUsageData.getIndexOf(cureItemToServiceUsage);
        }
        this.copyDataTo(cureItemToServiceUsage);
        if (saveUsage) CureItemToServiceUsageSrv.save(cureItemToServiceUsage);
    };
    CureItemToServiceUsageView.prototype.isChanged = function () {
        var cureItemToServiceUsage = this.getModel();
        if (cureItemToServiceUsage == null) return true;else {
            var humanResource = null;
            if (this.hrView) humanResource = this.hrView.getModel();
            var bookingService = null;
            if (this.bookingServiceView) bookingService = this.bookingServiceView.getModel();

            return +cureItemToServiceUsage.usageTime !== +this.usageTime || cureItemToServiceUsage.usedQuantity != this.usedQuantity || cureItemToServiceUsage.humanResource !== humanResource || cureItemToServiceUsage.bookingService !== bookingService;
        }
    };
    CureItemToServiceUsageView.prototype.addUsageFromBookingServiceView = function (bsView) {
        if (bsView) this.usedQuantity++;
    };

    CureItemToServiceUsageView.prototype.removeModel = function () {};
    CureItemToServiceUsageView.prototype.onChangeServiceView = function () {
        if (this.cureItemToServiceView && this.useForm.serviceView !== this.cureItemToServiceView.serviceView) ;
        {
            this.cureItemToServiceView.removeCureItemToServiceUsageView(this);
            var newCureItemToServiceView = this.cureItemToServiceView.cureItemView.getFirstCureItemToServiceViewByServiceView(this.useForm.serviceView);
            if (newCureItemToServiceView) newCureItemToServiceView.addCureItemToServiceUsageView(this);
        }
    };

    CureItemToServiceUsageView.prototype.initUseForm = function () {
        this.useForm.serviceView = this.cureItemToServiceView ? this.cureItemToServiceView.serviceView : null;
    };
    return CureItemToServiceUsageView;
}]);

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceView', ["CureItemToServiceData", "CureItemToService", "CureItemToServiceUsageView", "CureItemToServiceUsageData", "CureItemToServiceUsage", "CureItemToServiceUsageSrv", "$filter", function (CureItemToServiceData, CureItemToService, CureItemToServiceUsageView, CureItemToServiceUsageData, CureItemToServiceUsage, CureItemToServiceUsageSrv, $filter) {

    var CureItemToServiceView = function CureItemToServiceView(cureItemToService, ciIndex, cureItemView, domainView) {
        this.ciIndex = ciIndex; //model index
        this.domainView = domainView;
        this.cureItemView = cureItemView;
        this.serviceView = null;
        this.quantity = 0;
        this.usedQuantity = 0;
        this.cureItemToServiceUsagesView = [];

        if (cureItemToService) this.loadDataFrom(cureItemToService);
    };
    CureItemToServiceView.prototype.getModel = function () {
        if (this.ciIndex != -1) {
            return CureItemToServiceData.getByIndex(this.ciIndex);
        }
        return null;
    };
    CureItemToServiceView.prototype.loadDataFrom = function (cureItemToService) {
        if (cureItemToService) {
            this.quantity = cureItemToService.quantity;
            if (cureItemToService.service && this.domainView && this.domainView.getServiceView !== undefined) this.serviceView = this.domainView.getServiceView(cureItemToService.service);

            var cureItemToServiceUsageView;
            this.cureItemToServiceUsagesView = [];
            for (var i = 0; i < cureItemToService.cureItemToServiceUsages.length; i++) {
                cureItemToServiceUsageView = new CureItemToServiceUsageView(cureItemToService.cureItemToServiceUsages[i], CureItemToServiceUsageData.getIndexOf(cureItemToService.cureItemToServiceUsages[i]), this, this.domainView);
                this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
            }
            this.updateChronogicalIndexCureItemToServiceUsageView();
            this.updateUsedQuantity();
        }
    };
    CureItemToServiceView.prototype.reloadModel = function () {
        var cureItemToService = this.getModel();
        if (cureItemToService != null) {

            var cureItemToServiceUsageView;
            var previousCureItemToServiceUsagesView = this.cureItemToServiceUsagesView;
            this.cureItemToServiceUsagesView = [];
            for (var i = 0; i < cureItemToService.cureItemToServiceUsages.length; i++) {
                cureItemToServiceUsageView = null;
                for (var j = 0; j < previousCureItemToServiceUsagesView.length && !cureItemToServiceUsageView; j++) {
                    if (previousCureItemToServiceUsagesView[j].getModel() === cureItemToService.cureItemToServiceUsages[i]) cureItemToServiceUsageView = previousCureItemToServiceUsagesView[j];
                }if (cureItemToServiceUsageView) cureItemToServiceUsageView.reloadModel();else cureItemToServiceUsageView = new CureItemToServiceUsageView(cureItemToService.cureItemToServiceUsages[i], CureItemToServiceUsageData.getIndexOf(cureItemToService.cureItemToServiceUsages[i]), this, this.domainView);
                this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
            }
            this.updateChronogicalIndexCureItemToServiceUsageView();
            this.updateUsedQuantity();
        }
    };
    CureItemToServiceView.prototype.isUsed = function () {
        return this.quantity == this.usedQuantity;
    };
    CureItemToServiceView.prototype.updateUsedQuantity = function () {
        this.usedQuantity = 0;
        for (var i = 0; i < this.cureItemToServiceUsagesView.length; i++) {
            this.usedQuantity += this.cureItemToServiceUsagesView[i].usedQuantity;
        }
    };

    CureItemToServiceView.prototype.copyDataTo = function (cureItemToService) {
        if (cureItemToService) {
            cureItemToService.quantity = this.quantity;
            if (this.serviceView) cureItemToService.service = this.serviceView.getModel();else cureItemToService.service = null;
        }
    };
    CureItemToServiceView.prototype.init = function (cureItemView, cureToServiceView) {
        this.cureItemView = cureItemView;
        this.serviceView = cureToServiceView.serviceView;
        this.quantity = cureToServiceView.quantity;
    };
    CureItemToServiceView.prototype.addNewUsage = function () {
        var usageView = new CureItemToServiceUsageView(null, -1, this);
        usageView.usageTime = new Date();
        usageView.usedQuantity = 1;
        if (this.domainView && this.domainView.humanResourcesView && this.domainView.humanResourcesView.length > 0) usageView.hrView = this.domainView.humanResourcesView[0];
        this.cureItemToServiceUsagesView.push(usageView);
        if (this.cureItemView) this.cureItemView.useForm.cureItemToServiceUsagesView.push(usageView);
        this.updateUsedQuantity();
        this.updateChronogicalIndexCureItemToServiceUsageView();
    };
    CureItemToServiceView.prototype.hasCureItemUsage = function () {
        var hasUsage = false;
        for (var i = 0; i < this.cureItemToServiceUsagesView.length && !hasUsage; i++) {
            hasUsage = this.cureItemToServiceUsagesView[i].usedQuantity != 0;
        }return hasUsage;
    };
    CureItemToServiceView.prototype.removeUsageView = function (usageView) {
        if (usageView) {
            var index = this.cureItemToServiceUsagesView.indexOf(usageView);
            if (index != -1) this.cureItemToServiceUsagesView.splice(index, 1);
            if (this.cureItemView) {
                index = this.cureItemView.useForm.cureItemToServiceUsagesView.indexOf(usageView);
                if (index != -1) this.cureItemView.useForm.cureItemToServiceUsagesView.splice(index, 1);
            }
            this.updateChronogicalIndexCureItemToServiceUsageView();
            this.updateUsedQuantity();
        }
    };
    CureItemToServiceView.prototype.updateModel = function (saveUsage) {
        var cureItemToService = this.getModel();
        if (cureItemToService == null) {
            cureItemToService = new CureItemToService();
            this.ciIndex = CureItemToServiceData.getIndexOf(cureItemToService);
        } else {
            var cureItemToServiceUsage = null;
            var newCureItemToServiceUsages = [];
            for (var i = 0; i < this.cureItemToServiceUsagesView.length; i++) {
                cureItemToServiceUsage = this.cureItemToServiceUsagesView[i].getModel();
                if (!cureItemToServiceUsage) //new
                    {
                        cureItemToServiceUsage = new CureItemToServiceUsage(null, null, this.getModel());
                        this.cureItemToServiceUsagesView[i].ciIndex = CureItemToServiceUsageData.getIndexOf(cureItemToServiceUsage);
                    }
                if (this.cureItemToServiceUsagesView[i].isChanged()) {
                    this.cureItemToServiceUsagesView[i].updateModel(saveUsage);
                }
                newCureItemToServiceUsages.push(cureItemToServiceUsage);
            }
            // Check removed and softDelete them
            for (var i = 0; i < cureItemToService.cureItemToServiceUsages.length; i++) {
                if (newCureItemToServiceUsages.indexOf(cureItemToService.cureItemToServiceUsages[i]) == -1) //remove
                    CureItemToServiceUsageSrv.remove(cureItemToService.cureItemToServiceUsages[i]);
            } // Copy new list to current object
            cureItemToService.cureItemToServiceUsages = newCureItemToServiceUsages;
        }
        this.copyDataTo(cureItemToService);
    };
    CureItemToServiceView.prototype.updateServiceSelectableForCure = function () //
    {
        if (this.serviceView) {
            this.serviceView.nbSelectableForCure += this.quantity - this.usedQuantity;
            return this.serviceView;
        }
        return null;
    };
    CureItemToServiceView.prototype.getCureItemToServiceUsageView = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) for (var i = 0; i < this.cureItemToServiceUsagesView.length; i++) {
            if (this.cureItemToServiceUsagesView[i].getModel() === cureItemToServiceUsage) return this.cureItemToServiceUsagesView[i];
        }return null;
    };
    CureItemToServiceView.prototype.addUsageFromBookingServiceView = function (bsView) {
        if (bsView) {
            var cUsageView = new CureItemToServiceUsageView(null, this);
            cUsageView.initFromBookingServiceView(this, bsView);
            this.cureItemToServiceUsagesView.push(cUsageView);
            this.updateUsedQuantity();
            this.updateChronogicalIndexCureItemToServiceUsageView();
        }
    };
    CureItemToServiceView.prototype.updateChronogicalIndexCureItemToServiceUsageView = function () {
        var orderedcureItemToServiceUsages = $filter('orderBy')(this.cureItemToServiceUsagesView, 'usageTime');

        for (var i = 0; i < orderedcureItemToServiceUsages.length; i++) {
            orderedcureItemToServiceUsages[i].chronogicalIndex = i + 1;
        }
    };
    CureItemToServiceView.prototype.addCureItemToServiceUsageView = function (cureItemToServiceUsageView) {
        if (cureItemToServiceUsageView) {
            var index = this.cureItemToServiceUsagesView.indexOf(cureItemToServiceUsageView);
            if (index == -1) this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
            cureItemToServiceUsageView.cureItemToServiceView = this;
            this.updateUsedQuantity();
            this.updateChronogicalIndexCureItemToServiceUsageView();
        }
    };

    CureItemToServiceView.prototype.removeCureItemToServiceUsageView = function (cureItemToServiceUsageView) {
        if (cureItemToServiceUsageView) {
            var index = this.cureItemToServiceUsagesView.indexOf(cureItemToServiceUsageView);
            if (index != -1) this.cureItemToServiceUsagesView.splice(index, 1);
            //cureItemToServiceUsageView.cureItemToServiceView =null; keep for duplicate
            this.updateUsedQuantity();
            this.updateChronogicalIndexCureItemToServiceUsageView();
        }
    };
    CureItemToServiceView.prototype.initUseForm = function () {
        if (this.cureItemView) {
            if (this.serviceView && this.cureItemView.useForm.servicesView.indexOf(this.serviceView) == -1) this.cureItemView.useForm.servicesView.push(this.serviceView);
            for (var i = 0; i < this.cureItemToServiceUsagesView.length; i++) {
                this.cureItemToServiceUsagesView[i].initUseForm();
                this.cureItemView.useForm.cureItemToServiceUsagesView.push(this.cureItemToServiceUsagesView[i]);
            }
        }
    };

    return CureItemToServiceView;
}]);

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemView', ["$sce", "$dialog", "CureItemData", "CureSrv", "CureItem", "CureItemToServiceView", "CureItemToService", "CureItemToServiceData", "CureItemSrv", "gettextCatalog", function ($sce, $dialog, CureItemData, CureSrv, CureItem, CureItemToServiceView, CureItemToService, CureItemToServiceData, CureItemSrv, gettextCatalog) {

    var CureItemView = function CureItemView(cureItem, cIndex, saleCureView, domainView) {
        this.cIndex = cIndex;
        this.domainView = domainView;
        this.saleCureView = saleCureView;
        this.cureItemToServicesView = [];
        this.cureItemId = null;
        this.useForm = {
            displayError: false,
            servicesView: [], //global array sorted by date
            cureItemToServiceUsagesView: [] //global array sorted by date
        };
        this.isUsed = false;
        this.isClosed = false;
        if (cureItem !== undefined && cureItem != null) this.loadDataFrom(cureItem);
    };
    CureItemView.prototype.getModel = function () {
        if (this.cIndex != -1) {
            return CureItemData.getByIndex(this.cIndex);
        }
        return null;
    };

    CureItemView.prototype.loadDataFrom = function (cureItem) {
        this.cureItemToServicesView = [];
        this.cureItemId = cureItem.id;
        this.isClosed = cureItem.isClosed;
        this.isUsed = cureItem.isUsed();
        var cureToServiceView;
        for (var i = 0; i < cureItem.cureItemToServices.length; i++) {
            cureToServiceView = new CureItemToServiceView(cureItem.cureItemToServices[i], CureItemToServiceData.getIndexOf(cureItem.cureItemToServices[i]), this, this.domainView);
            this.cureItemToServicesView.push(cureToServiceView);
        }
    };
    CureItemView.prototype.reloadModel = function () {
        // consider cureItemToServicesView list is never changed (can't add or remove after creation)
        var cureItem = this.getModel();
        if (cureItem != null) {
            for (var i = 0; i < this.cureItemToServicesView.length; i++) {
                this.cureItemToServicesView[i].reloadModel();
            }
        }
    };

    CureItemView.prototype.close = function (callbackFunction) {
        var cureItem = this.getModel();
        if (cureItem && !cureItem.isUsed()) {
            var ciV = this;
            var msgDescription = gettextCatalog.getString("Attention, cette opération ne peut pas être annulée");
            var msgQuestion = gettextCatalog.getString("Voulez-vous vraiment clôturer cette cure");
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["question"] = msgQuestion + " ?";
                        tableModel["description"] = msgDescription;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    ciV.isClosed = true;
                    ciV.updateModel(true, callbackFunction);
                    //load views

                    if (cureItem && cureItem.saleCure && cureItem.saleCure.sale && cureItem.saleCure.sale.customer) {
                        var customerView = ciV.domainView.getCustomerView(cureItem.saleCure.sale.customer);
                        if (customerView) customerView.initHistoryView();
                    }
                    if (ciV.domainView && ciV.domainView.posView && ciV.domainView.posView.posSaleHistoryView) ciV.domainView.posView.posSaleHistoryView.loadCuresData();
                }
            });
        }
    };

    CureItemView.prototype.copyDataTo = function (cureItem) {

        if (cureItem) {
            var oldCureItemToServices = cureItem.cureItemToServices;
            cureItem.isClosed = this.isClosed;
            cureItem.cureItemToServices = [];
            var cureItemToService = null;
            for (var i = 0; i < this.cureItemToServicesView.length; i++) {
                if (i < oldCureItemToServices.length) //copy exising
                    cureItemToService = oldCureItemToServices[i];else cureItemToService = new CureItemToService(null, cureItem);

                this.cureItemToServicesView[i].copyDataTo(cureItemToService);
                cureItem.cureItemToServices.push(cureItemToService);
            }
        }
    };
    CureItemView.prototype.hasCureItemUsage = function () {
        var hasUsage = false;
        for (var i = 0; i < this.cureItemToServicesView.length && !hasUsage; i++) {
            hasUsage = this.cureItemToServicesView[i].hasCureItemUsage();
        }return hasUsage;
    };
    CureItemView.prototype.updateServiceSelectableForCure = function (servicesView) //
    {
        var serviceView = null;
        for (var i = 0; i < this.cureItemToServicesView.length; i++) {
            serviceView = this.cureItemToServicesView[i].updateServiceSelectableForCure();
            if (serviceView && servicesView && servicesView.indexOf(serviceView) == -1) servicesView.push(serviceView);
        }
    };
    CureItemView.prototype.getCureItemToServiceUsageView = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage && cureItemToServiceUsage.cureItemToService) for (var i = 0; i < this.cureItemToServicesView.length; i++) {
            if (this.cureItemToServicesView[i].getModel() === cureItemToServiceUsage.cureItemToService) return this.cureItemToServicesView[i].getCureItemToServiceUsageView(cureItemToServiceUsage);
        }return null;
    };
    CureItemView.prototype.init = function (saleCureView) {
        this.saleCureView = saleCureView;
        if (saleCureView && saleCureView.cureView) {
            var cureItemToServiceView;
            for (var i = 0; i < saleCureView.cureView.cureToServicesView.length; i++) {
                cureItemToServiceView = new CureItemToServiceView();
                cureItemToServiceView.init(this, saleCureView.cureView.cureToServicesView[i]);
                this.cureItemToServicesView.push(cureItemToServiceView);
            }
        }
    };
    CureItemView.prototype.addNewUsage = function () {
        // add by default on first cureItem
        if (this.cureItemToServicesView.length > 0) this.cureItemToServicesView[0].addNewUsage();
    };
    CureItemView.prototype.getFirstCureItemToServiceViewByServiceView = function (serviceView) {
        var cureItemToServiceView = null;
        for (var i = 0; i < this.cureItemToServicesView.length && !cureItemToServiceView; i++) {
            if (this.cureItemToServicesView[i].serviceView === serviceView && !this.cureItemToServicesView[i].isUsed()) cureItemToServiceView = this.cureItemToServicesView[i];
        }return cureItemToServiceView;
    };
    CureItemView.prototype.updateModelUsage = function () {
        for (var i = 0; i < this.cureItemToServicesView.length; i++) {
            this.cureItemToServicesView[i].updateModel(true);
        }
    };
    CureItemView.prototype.updateModel = function (save, callbackFunction) {
        var cureItem = this.getModel();
        if (cureItem == null) {
            cureItem = new CureItem();
            this.cIndex = CureItemData.getIndexOf(cureItem);
        }

        this.copyDataTo(cureItem);
        if (save !== undefined && save) {
            CureItemSrv.save(cureItem, callbackFunction);
        }
    };

    CureItemView.prototype.canSave = function () {
        for (var i = 0; i < this.cureItemToServicesView.length; i++) {
            if (this.cureItemToServicesView[i].usedQuantity > this.cureItemToServicesView[i].quantity) return false;
        }return true;
    };
    CureItemView.prototype.removeModel = function () {};
    CureItemView.prototype.initUseForm = function () {
        this.useForm.displayError = false;
        this.useForm.servicesView = []; //global array sorted by date
        this.useForm.cureItemToServiceUsagesView = []; //global array sorted by date
        for (var i = 0; i < this.cureItemToServicesView.length; i++) {
            this.cureItemToServicesView[i].initUseForm();
        }
    };

    return CureItemView;
}]);

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureView', ["$sce", "CureData", "CureSrv", "Cure", "SupplierView", "$filter", "$locale", "ServiceData", "CurrencyManager", "NumberSeparatorType", function ($sce, CureData, CureSrv, Cure, SupplierView, $filter, $locale, ServiceData, CurrencyManager, NumberSeparatorType) {
    var CureView = function CureView(cure, cIndex, parentCategoryView, domainView) {
        this.cIndex = cIndex;
        this.domainView = domainView;
        this.categoryType = "cure";
        this.categoryTypeSortOrder = 2;
        this.label = "";
        this.code = "";
        this.description = "";
        this.descriptionHtml = "";
        this.price = 0;
        this.priceInput = $filter("currencyFormatFilter")(0);
        this.hasInternetPrice = false;
        this.internetPrice = 0;
        this.internetPriceInput = $filter("currencyFormatFilter")(0);
        this.internetDiscountPercent = 0;
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.isBuyableOnWebSite = true;
        this.isOnHome = false;
        this.homeOrder = 0;
        //for views
        this.isSelected = false;
        this.isSmsSelected = false;
        this.isNotificationSelected = false;
        this.cureToServicesView = [];
        this.cureToServicesPrice = 0;
        this.cureToServicesToolTip = "";
        this.cureToServicesQuantity = 0;
        this.canSave = false;
        this.form = {
            displayError: false,
            displayErrorInternetPrice: false
        };
        if (parentCategoryView) {
            this.parentCategoryView = parentCategoryView;
        }
        if (cure) {
            this.loadDataFrom(cure);
        }
    };
    CureView.prototype.getModel = function () {
        if (this.cIndex != -1) {
            return CureData.getByIndex(this.cIndex);
        }
        return null;
    };

    CureView.prototype.loadDataFrom = function (cure) {
        //Assume here than the object in parameter contains only id (must load them)
        this.label = cure.label;
        this.code = cure.code;
        this.description = cure.description;
        this.isVisibleOnWebSite = cure.isVisibleOnWebSite;
        this.isBuyableOnWebSite = cure.isBuyableOnWebSite;
        if (this.description) {
            this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));
        }
        this.price = cure.price;
        this.priceInput = $filter('currencyFormatFilter')(this.price);
        if (cure.internetPrice != null) {
            this.internetPrice = cure.internetPrice;
            if (this.internetPrice == 0 && this.price != 0) {
                this.internetDiscountPercent = 100;
            } else {
                this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
            }
        } else {
            this.internetPrice = this.price;
        }
        this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
        this.isOnHome = cure.isOnHome;
        this.homeOrder = cure.homeOrder;
        this.hasInternetPrice = cure.hasInternetPrice;
        this.specificImage = cure.specificImage;
        this.image = cure.image;
        this.companyImage = cure.companyImage;
        //for ascendencing compatibility
        if (this.image || this.companyImage) {
            this.specificImage = true;
        }
        if (this.parentCategoryView && this.image == null && this.specificImage == false) {
            this.image = this.parentCategoryView.image;
        }
        if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) {
            this.companyImage = this.parentCategoryView.companyImage;
        }
        this.imageDisplayed = this.companyImage ? this.companyImage : this.image;
        this.updateCureToServicesView(cure);
    };

    /**
     * Pour toutes les prestations (cureToServices: Array) de la cure on récupère la vue 
     * de la prestation (serviceView: Object) et on la stocke dans (cureToServicesView: Array).
     *
     * @param cure the cure model
     */
    CureView.prototype.updateCureToServicesView = function (cure) {
        var _this = this;

        this.cureToServicesView = [];
        cure.cureToServices.forEach(function (element) {
            var serviceView = _this.domainView.getServiceView(element.service);
            if (serviceView) {
                serviceView.addLinkToCureView(_this);
            }
            var cureToServiceView = {
                serviceView: serviceView,
                quantity: element.quantity
            };
            _this.cureToServicesView.push(cureToServiceView);
            //update all fields
            _this.onChangeQuantity(cureToServiceView);
        });
    };

    CureView.prototype.updateCureToServicesToolTip = function () {
        this.cureToServicesToolTip = "";
        for (var i = 0; i < this.cureToServicesView.length; i++) {
            if (this.cureToServicesView[i].serviceView) {
                this.cureToServicesToolTip += this.cureToServicesView[i].serviceView.label + "(" + this.cureToServicesView[i].quantity + ")";
                if (i + 1 < this.cureToServicesView.length) this.cureToServicesToolTip += ", ";
            }
        }
    };

    CureView.prototype.updatePriceInputArrow = function (number) {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);;
            var price = parseFloat(priceStr);
            if (price !== "NaN") price += number;

            this.priceInput = $filter('currencyFormatFilter')(price);
            this.onPriceInputChange();
        }
    };

    CureView.prototype.onPriceInputChange = function () {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (price !== "NaN") this.price = price;else this.price = null;
        }
        this.checkHasWrongInternetPrice();
        this.updateCanSave();
    };

    CureView.prototype.isChanged = function () {
        var cure = this.getModel();
        if (cure) {
            var image = cure.image;
            if (image == null && cure.parentCategory && cure.specificImage == false) image = cure.parentCategory.image;
            var companyImage = cure.companyImage;
            if (companyImage == null && cure.parentCategory && cure.specificImage == false) companyImage = cure.parentCategory.companyImage;

            return this.label != cure.label || this.description != cure.description || this.price != cure.price || this.specificImage != cure.specificImage || this.hasInternetPrice != cure.hasInternetPrice || this.internetPrice != cure.internetPrice || this.image !== image || this.companyImage !== companyImage;
        } else return true;
    };
    CureView.prototype.setImage = function (image) {
        this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };
    CureView.prototype.setCompanyImage = function (companyImage) {
        this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };
    CureView.prototype.initInternetPrice = function () {
        if (this.hasInternetPrice && this.internetPrice == 0) {
            this.internetPrice = this.price;
            this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
            this.onInternetPriceInputChange();
        }
        this.checkHasWrongInternetPrice();
        this.updateCanSave();
    };

    CureView.prototype.updateInternetPriceInputArrow = function (number) {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (internetPrice !== "NaN") if (internetPrice + number < 0) internetPrice = 0;else {
                if (internetPrice + number < this.price) internetPrice += number;else internetPrice = this.price;
            }
            this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
            this.onInternetPriceInputChange();
        }
    };
    CureView.prototype.onInternetPriceInputChange = function () {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (internetPrice !== "NaN") this.internetPrice = internetPrice;else this.internetPrice = null;
            if (this.internetPrice == 0 && this.price != 0) this.internetDiscountPercent = 100;else this.internetDiscountPercent = Math.round(100 * (100 - 100 * this.internetPrice / this.price)) / 100;
        }
        this.checkHasWrongInternetPrice();
        this.updateCanSave();
    };

    CureView.prototype.copyDataTo = function (cure) {
        var _this2 = this;

        //Assume here than the object in parameter contains only id (must load them)
        cure.label = this.label;
        cure.code = this.code;
        cure.description = this.description;
        cure.price = this.price;
        cure.image = this.image;
        cure.companyImage = this.companyImage;
        cure.specificImage = this.specificImage;
        cure.hasInternetPrice = this.hasInternetPrice;
        cure.isOnHome = this.isOnHome;
        cure.homeOrder = this.homeOrder;
        cure.internetPrice = this.internetPrice;
        cure.isVisibleOnWebSite = this.isVisibleOnWebSite;
        cure.isBuyableOnWebSite = this.isBuyableOnWebSite;
        cure.cureToServices = [];
        this.cureToServicesView.forEach(function (element) {
            if (element.serviceView) {
                cure.cureToServices.push({
                    service: element.serviceView.getModel(),
                    quantity: element.quantity
                });
                element.serviceView.addLinkToCureView(_this2);
            }
        });
    };

    CureView.prototype.onSpecificImageChange = function () {
        if (!this.specificImage) {
            this.image = null;
            this.companyImage = null;
        }
    };

    CureView.prototype.updateModel = function () {
        var cure = this.getModel();
        if (cure == null) {
            cure = new Cure();
            this.cIndex = CureData.getIndexOf(cure);
        }
        if (!this.specificImage && this.parentCategoryView !== undefined && this.parentCategoryView.label !== "Racine") {
            this.image = this.parentCategoryView.image;
            cure.image = this.image;
        }
        this.copyDataTo(cure);

        var category = this.parentCategoryView.getModel();
        // change of category
        if (category && category !== cure.parentCategory) {
            if (cure.parentCategory) {
                cure.parentCategory.removeCure(cure);
            }
            category.addCure(cure);
        }
        CureSrv.save(cure);
    };

    CureView.prototype.removeModel = function () {
        var cure = this.getModel();
        if (cure != null) {
            cure.parentCategory.removeCure(cure);
            CureSrv.remove(cure);
        }
    };

    CureView.prototype.reloadModel = function () {
        var cure = this.getModel();
        if (cure == null) {
            this.parentCategoryView.removeCureView(this);
        } else {
            this.loadDataFrom(cure);
        }
    };

    CureView.prototype.restoreModel = function () {
        //undeleted
        var cure = this.getModel();
        if (cure) {
            if (cure.parentCategory) {
                cure.parentCategory.addCure(cure);
            }
            CureSrv.restore(cure);
        }
    };

    CureView.prototype.checkHasWrongInternetPrice = function () {
        if (this.hasInternetPrice && (this.internetPrice === 0 || this.internetPrice == null) && this.price === 0) {
            this.form.displayErrorInternetPrice = true;
        } else {
            this.form.displayErrorInternetPrice = false;
        }
    };

    CureView.prototype.updateCanSave = function () {
        var quantityInt = parseInt(this.quantity);
        if (quantityInt !== "NaN" && quantityInt !== "") {
            this.quantity = quantityInt;
        } else {
            this.quantity = null;
        }

        if (this.label && this.label !== "" && //titre
        this.price != null && this.price >= 0 && //prix (décimal)
        this.cureToServicesQuantity !== 0 && !this.form.displayErrorInternetPrice) {
            this.canSave = true;
        } else {
            this.canSave = false;
        }
    };

    CureView.prototype.search = function (searchedTextLC) {
        return searchedTextLC && this.label && this.label.toLowerCase().indexOf(searchedTextLC) != -1 || this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC) != -1;
    };

    CureView.prototype.updateCureToServiceVar = function () {
        var _this3 = this;

        this.cureToServicesPrice = 0;
        this.cureToServicesQuantity = 0;
        this.cureToServicesView.forEach(function (element) {
            _this3.cureToServicesQuantity += element.quantity;
            _this3.cureToServicesPrice += element.price;
        });
    };

    CureView.prototype.addServiceViewOnCure = function (serviceView) {
        var existingCtS = this.cureToServicesView.find(function (element) {
            return element.serviceView == serviceView;
        });
        if (existingCtS) {
            existingCtS.quantity++;
            this.onChangeQuantity(existingCtS);
        } else {
            var service = ServiceData.getById(serviceView.serviceId);
            this.cureToServicesView.push({
                serviceView: serviceView,
                quantity: 1,
                price: serviceView.price
            });
            if (this.getModel()) {
                this.getModel().serviceTab.push(service);
                service.cures.push(this.getModel());
            }
        }
        this.updateCureToServiceVar();
        this.updateCureToServicesToolTip();
        this.updateCanSave();
    };

    CureView.prototype.removeServiceViewOnCure = function (cureToServiceView) {
        this.cureToServicesView = this.cureToServicesView.filter(function (element) {
            return element !== cureToServiceView;
        });
        var service = null;
        if (cureToServiceView && cureToServiceView.serviceView) {
            cureToServiceView.serviceView.removeLinkToCureView(this);
            service = ServiceData.getById(cureToServiceView.serviceView.serviceId);
            var cure = this.getModel();
            if (cure && service && service.cures) {
                for (var i = 0; i < service.cures.length; i++) {
                    if (service.cures[i].id === cure.id) {
                        for (var j = 0; j < service.cures[i].serviceTab.length; j++) {
                            if (service.cures[i].serviceTab[j].id === cureToServiceView.serviceView.serviceId) {
                                service.cures[i].serviceTab.splice(j, 1);
                            }
                        }
                        service.cures.splice(i, 1);
                    }
                }
            }

            this.updateCureToServiceVar();
            this.updateCureToServicesToolTip();
            this.updateCanSave();
        }
    };

    CureView.prototype.onChangeQuantity = function (cureToServiceView) {
        if (cureToServiceView && cureToServiceView.serviceView) {
            cureToServiceView.price = cureToServiceView.serviceView.price * cureToServiceView.quantity;
        }
        this.updateCureToServiceVar();
        this.updateCureToServicesToolTip();
        this.updateCanSave();
    };
    return CureView;
}]);

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CustomerView', ["$log", "$filter", "$dialog", "$timeout", "Customer", "CustomerData", "CustomerSrv", "ReadOnlyBookingView", "Format", "DayData", "SaleData", "GiftItemData", "GiftItemView", "CureItemView", "CureItemData", "BookingData", "HumanResourceData", "LoyaltyCardItemData", "OptInOutData", "OptInOutView", "PhoneFormat", "CustomerPostData", "CustomerPostView", "IOSDevice", "SaleStatus", "Images", function ($log, $filter, $dialog, $timeout, Customer, CustomerData, CustomerSrv, ReadOnlyBookingView, Format, DayData, SaleData, GiftItemData, GiftItemView, CureItemView, CureItemData, BookingData, HumanResourceData, LoyaltyCardItemData, OptInOutData, OptInOutView, PhoneFormat, CustomerPostData, CustomerPostView, IOSDevice, SaleStatus, Images) {
    //"Manessiez Beatrice"
    var CustomerView = function CustomerView(customer, cIndex, domainView) {
        this.cIndex = cIndex;
        this.domainView = domainView;
        this.lastName = null;
        this.firstName = null;
        this.gender = null;
        this.label = null;
        this.customerLabelSearch = null;
        this.labelLowerCase = null;
        this.phone = null;
        this.landline = null;
        this.email = null;
        this.login = null;
        this.comment = null;
        this.isVerified = false;
        this.password = null;
        this.passwordAgain = null;
        this.currentPassword = null;
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.postCode = null;
        this.origin = null;
        this.online = 'A'; //A:active /B : blocked / P : only payment allowed
        this.isBirthDate = false;
        this.birthDate = null;
        this.birthDateString = null;
        this.pastBookingsView = null; //SimpleBookingView
        this.futureBookingsView = null; //SimpleBookingView
        this.historyBookingsView = [];
        this.historySoldSalesView = [];
        this.globalHistoryView = [];
        this.techNoteHistory = [];
        this.historySoldPrice = 0;
        this.historyRealPaidPrice = 0;
        this.historyCaPrice = 0;
        this.nbNotCameBookings = 0;
        this.nbCameBookings = 0;
        this.nbSoldSales = 0;
        this.nbWaitingSales = 0;
        this.nbEstimationSales = 0;
        this.nbUnpaidSales = 0;
        this.nbAdvanceSales = 0;
        this.lastVisitDate = null;
        this.cureItemsUsedView = [];
        this.cureItemsNotUsedView = [];
        this.nbCureItemUsed = 0;
        this.nbCureItemNotUsed = 0;
        this.giftItemsUsedView = [];
        this.giftItemsNotUsedView = [];
        this.giftItemsCanceledView = [];
        this.loyaltyCardItemsUsedView = [];
        this.loyaltyCardItemsNotUsedView = [];
        this.nbGiftItemsUsed = 0;
        this.nbGiftItemsNotUsed = 0;
        this.nbLoyaltyCardItemNotUsed = 0;
        this.nbLoyaltyCardItemUsed = 0;
        this.nbTechNotes = 0;
        this.customerInterNationalMobileNumber = null;
        this.customerNationalMobileNumber = null;
        this.customerInterNationalLandlineNumber = null;
        this.customerNationalLandlineNumber = null;
        this.hasWebPwd = false;
        this.hasMobileApp = false;
        this.optInOutView = new OptInOutView(null, null);
        this.isCGVAccepted = null;
        this.phoneDisplay = '';
        this.idReserveWithGoogle = null;
        this.isHistoryInit = false;
        this.loadDataFromWithoutInitHistory(customer);
        this.bookingStatusImage = Images.saleStatus;
    };
    CustomerView.prototype.getModel = function () {
        if (this.cIndex != -1) return CustomerData.getByIndex(this.cIndex);
        return null;
    };

    //Dupplicate method with customer model to avoid nullPointer on customer creation
    CustomerView.prototype.loadCustomerLabelSearch = function (customer) {
        if (customer.customerLabelSearch) {
            this.customerLabelSearch = customer.customerLabelSearch;
        } else {
            this.customerLabelSearch = customer.lastName + " " + customer.firstName + " | ";
            if (customer.phone) {
                var phone = customer.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
                this.customerLabelSearch += phone;
            } else if (customer.landline) {
                this.customerLabelSearch += PhoneFormat.formatNumberWithoutCountry(customer.landline);
            }
        }
    };

    //Dupplicate method with customer model to avoid nullPointer on customer creation
    CustomerView.prototype.createInterNationalAndNationalPhoneFormat = function (customer) {
        if (customer) {
            this.customerNationalMobileNumber = customer.customerNationalMobileNumber;
            this.customerInterNationalMobileNumber = customer.customerInterNationalMobileNumber;
            this.customerInterNationalLandlineNumber = customer.customerInterNationalLandlineNumber;
            this.customerNationalLandlineNumber = customer.customerNationalLandlineNumber;
        } else {
            this.customerNationalMobileNumber = PhoneFormat.returnNationalFormat(this.phone).replace(/\s/g, '');
            this.customerInterNationalMobileNumber = PhoneFormat.returnInternationalFormat(this.phone).replace(/\s/g, '');
            this.customerInterNationalLandlineNumber = PhoneFormat.returnInternationalFormat(this.landline).replace(/\s/g, '');
            this.customerNationalLandlineNumber = PhoneFormat.returnNationalFormat(this.landline).replace(/\s/g, '');
        }
    };

    CustomerView.prototype.loadDataFrom = function (customer) {
        if (customer !== undefined && customer) {
            this.loadDataFromWithoutInitHistory(customer);
            this.initCustomerHistoryDatas(customer);
        }
    };

    CustomerView.prototype.initCustomerHistoryDatas = function (customer) {
        if (customer !== undefined && customer) {
            this.initHistoryView();
            this.initGiftItemsView();
            this.optInOutView = new OptInOutView(customer.optInOut, OptInOutData.getIndexOf(customer.optInOut));
            this.optInOutView.customerId = customer.id;
        }
    };

    CustomerView.prototype.loadDataFromWithoutInitHistory = function (customer) {
        if (customer !== undefined && customer) {
            this.lastName = customer.lastName;
            this.firstName = customer.firstName;

            if (customer.phone) this.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
            this.createInterNationalAndNationalPhoneFormat(customer);
            this.loadCustomerLabelSearch(customer);

            this.label = customer.lastName + " " + customer.firstName;
            if (this.label) this.labelLowerCase = this.label.toLowerCase();
            this.phone = customer.phone;
            this.landline = customer.landline;
            this.customerPhone = customer.phone;
            if (customer.email) this.email = customer.email.toLowerCase();
            this.comment = customer.comment;
            this.gender = customer.gender;
            this.isVerified = customer.isVerified;
            this.address1 = customer.address1;
            this.address2 = customer.address2;
            this.city = customer.city;
            this.postCode = customer.postCode;
            this.origin = customer.origin;
            if (customer.online) this.online = customer.online;
            this.isBirthDate = customer.isBirthDate;
            this.birthDate = customer.birthDate;
            if (customer.birthDate) this.birthDateString = $filter('date')(customer.birthDate, 'shortDate');
            this.hasWebPwd = customer.hasWebPwd;
            this.hasMobileApp = customer.hasMobileApp;
            this.isCGVAccepted = customer.isCGVAccepted;
            this.idReserveWithGoogle = customer.idReserveWithGoogle;
        }
    };
    CustomerView.prototype.copyDataTo = function (customer) {
        customer.lastName = this.lastName;
        customer.firstName = this.firstName;
        if (this.phone != null) {
            customer.phone = this.phone;
            if (this.phoneCountry && this.phoneCountry != PhoneFormat.unknowFormat || this.phoneCountry == null) this.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(this.phone);

            if (this.phoneCountry && this.phoneCountry != PhoneFormat.unknowFormat) customer.phone = PhoneFormat.formatNumberWithInternationalFormat(this.phone, this.phoneCountry);
            customer.phone = customer.phone.replace(/\s/g, '');
        } else {
            customer.phone = null;
            this.phoneDisplay = null;
        }

        if (this.landline != null) customer.landline = this.landline.replace(/\s/g, '');else customer.landline = null;
        customer.email = this.email;
        customer.comment = this.comment;
        customer.gender = this.gender;

        customer.isVerified = this.isVerified;
        customer.address1 = this.address1;
        customer.address2 = this.address2;
        customer.city = this.city;
        customer.postCode = this.postCode;
        customer.origin = this.origin;
        customer.online = this.online;
        customer.birthDate = this.birthDate;
        customer.isBirthDate = this.isBirthDate;
        customer.isCGVAccepted = this.isCGVAccepted;

        if (this.password) customer.password = this.password;
        if (this.currentPassword) customer.currentPassword = this.currentPassword;

        customer.idReserveWithGoogle = this.idReserveWithGoogle;
    };

    CustomerView.prototype.addLine = function (date, iconStatus, techNote, iconTechnote) {
        var lineContent = "";
        lineContent += '<tr>' + '<td style="border-top: 1px solid #000000;width: 75px;margin-top: 2px;">' + (date ? date : '&nbsp;') + '</td>' + '<td style="border-top: 1px solid #000000;width: 15px;margin-top: 2px;">' + iconStatus + '</td>' + '<td style="border-top: 1px solid #000000;width: 75px;margin-top: 2px;"><span>' + iconTechnote + '&nbsp;' + techNote + '</span>' + '</td>' + '</tr>';
        return lineContent;
    };

    CustomerView.prototype.getIconStatus = function (status, isUnpaid) {
        switch (status) {
            case 'came':
                return '<span><i class="fal fa-thumbs-up booking-icon-came" style="padding:0 1px"></i></span>';
            case 'notCame':
                return '<span><i class="fal fa-thumbs-down booking-icon-not-came" style="padding:0 1px"></i></span>';
            case 'waiting':
                return '<span><i class="fas fa-pause" style="  position: absolute;left: 9px;top: 12px;font-size: 6px;"></i><img ng-src="{{bookingStatusImage.waiting}}" alt="waiting-sale"/></span>';
            case 'sold':
                if (isUnpaid) return '<span class="fa-stack" style="width: 1em;height: 1em;line-height: 1em;">\n' + '<i class="fal fa-euro fa-stack-1x"></i><i class="fal fa-ban fa-stack-2x" style="color:#e20000;font-size: 1.4em;top: -4px;left: -1px;"></i></span>';else return '<span><img ng-src="{{bookingStatusImage.paid}}" alt="paid-sale"/></span>';
            case 'soldProcess':
                return '<span><i class="fal fa-circle-o-notch fa-spin" style="padding:1px 0px"></i></span>';
            case 'advanceKeeped':
            case 'advance':
                return '<span><img ng-src="{{bookingStatusImage.advance}}" alt="advance-sale"/></span>';
            case 'advanceProcess':
                return '<span><i class="fal fa-circle-o-notch fa-spin" style="padding:1px 0px"></i></span>';
            default:
                return '';
        }
    };

    CustomerView.prototype.getIconTechNote = function (items) {
        var cpt = 0;
        var labels = "";
        for (var i = 0; i < items.length; i++) {
            if (items[i].type && items[i].type === 'service') {
                cpt++;
            }
            if (cpt > 1) {
                labels += '<span>,' + items[i].label + '</span>';
            } else {
                labels += '<span>' + items[i].label + '</span>';
            }
        }
        var icon = cpt === 0 ? 'fal fa-tag' : 'fal fa-tags';
        return '<i class="' + icon + '" style="padding:1px 0px"></i>&nbsp;' + labels;
    };

    CustomerView.prototype.printTechnicalSheet = function () {
        var onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
        if (IOSDevice.isIOSDevice()) {
            onLoadContent = "window.print();";
        }
        var documentContent = '<!DOCTYPE html><html><head>' + '<link rel="stylesheet" type="text/css" href="/css/print.css" />' + '<link rel="stylesheet" href="//netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.css"/>' + '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' + '<script src="/lib/barcode/JsBarcode.js"></script>' + '<script src="/lib/barcode/EAN_UPC.js"></script>' + '</head><body onload="' + onLoadContent + '"><div class="reward-body">' + '<div class="name">' + this.firstName + '&nbsp;' + this.lastName + '</div>' + '<div class="adress">' + (this.email ? this.email : "") + '</div>' + '<div class="phone">' + (this.phone ? this.phone : "") + '</div><br/>';

        documentContent += '<table class="bill" style="width: 100%">';
        documentContent += '' + '<tr>' + '<th class="price-tva" style="width:30px;text-align: left">Date</th>' + '<th class="price-tva" style="width:15px;text-align: left"><i class="fal fa-info-circle"></th>' + '<th class="price-tva" style="width:30px;text-align: left">Fiche technique</th>' + '</tr>' + '<tbody >';

        for (var i = 0; i < this.techNoteHistory.length; i++) {
            var bookOfSaleView = this.techNoteHistory[i];
            if (bookOfSaleView.techNote) {
                var iconStatus = this.getIconStatus(bookOfSaleView.status, bookOfSaleView.unpaid);
                documentContent += this.addLine($filter('date')(bookOfSaleView.date, 'dd/MM/yyyy'), iconStatus, bookOfSaleView.techNote, this.getIconTechNote(bookOfSaleView.items));
            }
        }
        documentContent += '</tbody></table>';
        documentContent += '</div></body></html>';
        this.printWindow.document.write(documentContent);
        this.printWindow.document.title = "Imprimer";
        this.printWindow.document.close();
    };

    CustomerView.prototype.openPrintWindow = function () {
        var left = screen.width / 2 - 800 / 2;
        var top = screen.height / 2 - 500 / 2;
        this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        if (this.printWindow) {
            this.printWindow.window.focus();
        }
    };

    CustomerView.prototype.addBookingView = function (bookingView) {
        if (bookingView && bookingView.date) {
            var now = new Date();
            var bookingsView = void 0;
            var bookingViewTime = bookingView.date.getTime() + bookingView.period.start.getTime() * 60000;
            if (bookingViewTime < now.getTime()) {
                bookingsView = this.pastBookingsView;
            } else {
                bookingsView = this.futureBookingsView;
            }
            if (!bookingsView) {
                bookingsView = [];
            }
            var index = bookingsView.indexOf(bookingView);
            if (index == -1) {
                //insert sorted
                for (var i = 0; i < bookingsView.length; i++) {
                    if (bookingViewTime <= bookingsView[i].date.getTime() + bookingsView[i].period.start.getTime() * 60000) {
                        //insert
                        bookingsView.splice(i, 0, bookingView);
                        return; //Stop
                    }
                }bookingsView.push(bookingView);
            }
        }
    };

    CustomerView.prototype.removeBookingView = function (bookingView) //
    {
        var index = this.futureBookingsView.indexOf(bookingView);
        if (index != -1) //insert sorted
            {
                this.futureBookingsView.splice(index, 1);
            }
    };

    CustomerView.prototype.onBirthDateStringKeyup = function (event) //
    {
        if (this.birthDateString) if (!(event && (event.which == 8 || event.which == 46))) //if key delete detected : clear supplier
            {
                if ((this.birthDateString.length == 4 || this.birthDateString.length == 7) && this.birthDateString[this.birthDateString.length - 1] == '/') this.birthDateString = this.birthDateString.substr(0, this.birthDateString.length - 2);

                if (this.birthDateString.length == 2 || this.birthDateString.length == 5) this.birthDateString += "/";
            }
    };
    CustomerView.prototype.displayCustomerDatePickerF = function () {
        var customerView = this;
        $timeout(function () {
            customerView.birthDatePickerOpened = true;
        });
    };
    CustomerView.prototype.onBirthDateStringUpdate = function () //
    {
        if (this.birthDateString && this.birthDateString.length == 10) {
            var year = this.birthDateString.substring(6, 10);
            var month = this.birthDateString.substring(3, 5);
            var day = this.birthDateString.substring(0, 2);
            this.birthDate = new Date(year + '/' + month + '/' + day);
            if (this.birthDate) if (Object.prototype.toString.call(this.birthDate) === "[object Date]") {
                if (isNaN(this.birthDate.getTime())) this.birthDate = null;
            } else {
                this.birthDate = null;
            }
        } else this.birthDate = null;
    };
    CustomerView.prototype.updateBirthDateString = function () {
        if (this.birthDate) this.birthDateString = $filter('date')(this.birthDate, 'shortDate');
    };

    CustomerView.prototype.displayBirthDay = function () {
        if (this.birthDate) return $filter('date')(this.birthDate, 'dd-MMM');
    };

    CustomerView.prototype.initGiftItemsView = function (isOnWebSite) {
        this.giftItemsUsedView = [];
        this.giftItemsNotUsedView = [];
        this.giftItemsCanceledView = [];
        var customer = this.getModel();
        var saleView;
        var dayView;
        if (customer && customer.giftItems) for (var i = 0; i < customer.giftItems.length; i++) {
            if (isOnWebSite || customer.giftItems[i].sale && customer.giftItems[i].sale.status == "sold") //on webSite giftItems[i].sale is null
                {
                    var giftItemView = {
                        giIndex: GiftItemData.getIndexOf(customer.giftItems[i]),
                        index: i,
                        code: GiftItemView.getFormattedCode(customer.giftItems[i].code),
                        originalPrice: customer.giftItems[i].originalPrice,
                        validityDate: customer.giftItems[i].validityDate,
                        customerView: this,
                        serviceView: customer.giftItems[i].service ? this.domainView.getServiceView(customer.giftItems[i].service) : null,
                        getCustomerOfSale: function getCustomerOfSale() {
                            var customerOfSale = null;
                            if (customer.giftItems[this.index] && customer.giftItems[this.index].sale && customer.giftItems[this.index].sale.customer) {
                                customerOfSale = customer.giftItems[this.index].sale.customer;
                            }
                            return customerOfSale;
                        }
                    };
                    if (customer.giftItems[i].isCanceled) this.giftItemsCanceledView.push(giftItemView);else if (customer.giftItems[i].isUsed) this.giftItemsUsedView.push(giftItemView);else this.giftItemsNotUsedView.push(giftItemView);
                }
        }
        this.nbGiftItemsUsed = this.giftItemsUsedView.length;
        this.nbGiftItemsNotUsed = this.giftItemsNotUsedView.length;
    };
    CustomerView.prototype.updateGiftItemsView = function (giftItemView) {
        if (giftItemView) {
            var index = this.giftItemsNotUsedView.indexOf(giftItemView);
            if (index != -1) {
                if (giftItemView.isUsed) {
                    this.giftItemsNotUsedView.splice(index, 1);
                    this.giftItemsUsedView.push(giftItemView);
                }
            } else {
                index = this.giftItemsUsedView.indexOf(giftItemView);
                if (index != -1) {
                    if (!giftItemView.isUsed) {
                        this.giftItemsUsedView.splice(index, 1);
                        this.giftItemsNotUsedView.push(giftItemView);
                    }
                }
            }
            this.nbGiftItemsUsed = this.giftItemsUsedView.length;
            this.nbGiftItemsNotUsed = this.giftItemsNotUsedView.length;
        }
    };

    CustomerView.prototype.updateCureItemViewFromModel = function (cureItem) //
    {
        var cCureItem;
        for (var i = 0; i < this.cureItemsNotUsedView.length; i++) {
            cCureItem = this.cureItemsNotUsedView[i].getModel();
            if (cCureItem && cCureItem.id == cureItem.id) {
                this.cureItemsNotUsedView[i].loadDataFrom(cureItem);
                return;
            }
        }
        for (var i = 0; i < this.cureItemsUsedView.length; i++) {
            cCureItem = this.cureItemsUsedView[i].getModel();
            if (cCureItem && cCureItem.id == cureItem.id) {
                this.cureItemsUsedView[i].loadDataFrom(cureItem);
                return;
            }
        }
    };

    CustomerView.prototype.updateServiceSelectable = function () //
    {
        var todoServices = [];
        for (var i = 0; i < this.cureItemsNotUsedView.length; i++) {
            this.cureItemsNotUsedView[i].updateServiceSelectableForCure(todoServices);
        }for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
            if (this.giftItemsNotUsedView[i].serviceView) {
                var giftItem = GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex);
                if (giftItem.service) {
                    var serviceView = this.domainView.getServiceView(giftItem.service);
                    if (serviceView) {
                        if (todoServices.indexOf(serviceView) == -1) todoServices.push(serviceView);
                        serviceView.nbSelectableForGift++;
                    }
                }
            }
        }
        ;
        this.proposedServices = [];
        for (var i = 0; i < todoServices.length; i++) {
            this.proposedServices.push({
                bsView: { serviceView: todoServices[i] },
                occ: 0,
                isRealBookingService: false
            });
        }var found = -1;
        for (var i = 0; i < this.historyBookingsView.length; i++) {
            for (var j = 0; j < this.historyBookingsView[i].bookingServicesView.length; j++) {
                found = -1;
                for (var k = 0; k < this.proposedServices.length && found == -1; k++) {
                    if (this.proposedServices[k].bsView.serviceView === this.historyBookingsView[i].bookingServicesView[j].serviceView) found = k;
                }
                if (found == -1) this.proposedServices.push({
                    bsView: this.historyBookingsView[i].bookingServicesView[j],
                    occ: 1,
                    isRealBookingService: true
                });else {
                    if (!this.proposedServices[found].isRealBookingService) {
                        this.proposedServices[found].bsView = this.historyBookingsView[i].bookingServicesView[j];
                        this.proposedServices[found].isRealBookingService = true;
                    }
                    this.proposedServices[found].occ++;
                }
            }
        }
    };

    CustomerView.prototype.initHistoryView = function () {
        var customer = this.getModel();
        if (customer && customer.bookings) {
            this.nbNotCameBookings = 0;
            this.nbCameBookings = 0;
            this.nbSoldSales = 0;
            this.nbWaitingSales = 0;
            this.nbEstimationSales = 0;
            this.nbUnpaidSales = 0;
            this.nbAdvanceSales = 0;
            this.nbLoyaltyCardItemNotUsed = 0;
            this.nbLoyaltyCardItemUsed = 0;
            this.globalHistoryView = [];
            this.techNoteHistory = [];
            this.historyBookingsView = [];
            this.historySoldSalesView = [];
            this.historySoldPrice = 0;
            this.historyRealPaidPrice = 0;
            this.historyCaPrice = 0;
            this.loyaltyCardItemsUsedView = [];
            this.loyaltyCardItemsNotUsedView = [];
            this.nbTechNotes = 0;

            var prevCureItemsUsedView = this.cureItemsNotUsedView;
            this.cureItemsUsedView = [];
            var prevCureItemsNotUsedView = this.cureItemsNotUsedView;
            this.cureItemsNotUsedView = [];
            var readOnlyBookingsView = [];
            var booking = void 0,
                bs = void 0;
            var hr = void 0,
                hrLabel = void 0;
            var lView = void 0;
            var saleCureMinView = void 0,
                cureItem = void 0,
                cureItemView = void 0;
            for (var i = 0; i < customer.bookings.length; i++) {
                booking = new ReadOnlyBookingView(customer.bookings[i], this);
                var date = null;
                if (customer.bookings[i].day) {
                    date = customer.bookings[i].day.getDate();
                }
                var techNoteServiceItems = [];
                var minBooking = {
                    index: BookingData.getIndexOf(customer.bookings[i]),
                    price: customer.bookings[i].sale ? customer.bookings[i].sale.price : customer.bookings[i].price,
                    date: date,
                    isBooking: true,
                    bookingTime: null,
                    status: "",
                    items: [],
                    unpaid: false,
                    bookingPeriod: customer.bookings[i].period
                };
                if (customer.bookings[i].period) {
                    minBooking.bookingTime = customer.bookings[i].period.start.getLabel();
                }
                if (customer.bookings[i].sale) {
                    minBooking.status = customer.bookings[i].sale.status;
                } else {
                    minBooking.status = customer.bookings[i].status;
                }
                if (customer.bookings[i].sale && customer.bookings[i].sale.status === "sold") {
                    if (customer.bookings[i].sale.hasPaymentType("UNPAID")) {
                        this.nbUnpaidSales++;
                        minBooking.unpaid = true;
                    } else {
                        this.nbSoldSales++;
                    }
                    for (var j = 0; j < customer.bookings[i].bookingServices.length; j++) {
                        if (customer.bookings[i].bookingServices[j].cureItemToServiceUsage) {
                            //add services with cureItemToServiceUsage (because not inside sale)
                            hrLabel = "";
                            if (customer.bookings[i].bookingServices[j].isPackage) {
                                bs = customer.bookings[i].bookingServices[j];
                                for (var k = 0; k < bs.subBookingServices.length; k++) {
                                    if (bs.subBookingServices[k].dayHr && bs.subBookingServices[k].dayHr.humanResourceId) {
                                        hr = HumanResourceData.getById(bs.subBookingServices[k].dayHr.humanResourceId);
                                        if (hr && hrLabel.indexOf(hr.label) === -1) {
                                            if (hrLabel !== "") {
                                                hrLabel += " ";
                                            }
                                            hrLabel += hr.label;
                                        }
                                    }
                                }
                            } else if (customer.bookings[i].bookingServices[j].dayHr && customer.bookings[i].bookingServices[j].dayHr.humanResourceId) {
                                hr = HumanResourceData.getById(customer.bookings[i].bookingServices[j].dayHr.humanResourceId);
                                if (hr) {
                                    hrLabel = hr.label;
                                }
                            }
                            minBooking.items.push({
                                type: "service",
                                label: customer.bookings[i].bookingServices[j].label,
                                hrLabel: hrLabel
                            });
                            techNoteServiceItems.push({
                                label: customer.bookings[i].bookingServices[j].label
                            });
                        }
                    }
                    for (var _j = 0; _j < customer.bookings[i].sale.saleServices.length; _j++) {
                        minBooking.items.push({
                            type: "service",
                            label: customer.bookings[i].sale.saleServices[_j].label,
                            hrLabel: customer.bookings[i].sale.saleServices[_j].humanResource ? customer.bookings[i].sale.saleServices[_j].humanResource.label : null
                        });

                        techNoteServiceItems.push({
                            label: customer.bookings[i].sale.saleServices[_j].label
                        });
                    }
                    for (var _j2 = 0; _j2 < customer.bookings[i].sale.saleProducts.length; _j2++) {
                        minBooking.items.push({
                            type: "product",
                            label: customer.bookings[i].sale.saleProducts[_j2].label,
                            hrLabel: customer.bookings[i].sale.saleProducts[_j2].humanResource ? customer.bookings[i].sale.saleProducts[_j2].humanResource.label : null
                        });
                    }
                    for (var _j3 = 0; _j3 < customer.bookings[i].sale.saleCures.length; _j3++) {
                        for (var _k = 0; _k < customer.bookings[i].sale.saleCures[_j3].cureItems.length; _k++) {
                            cureItem = customer.bookings[i].sale.saleCures[_j3].cureItems[_k];
                            if (cureItem.isUsed()) {
                                saleCureMinView = {
                                    label: customer.bookings[i].sale.saleCures[_j3].label,
                                    price: customer.bookings[i].sale.saleCures[_j3].price
                                };
                                //search if already exist
                                cureItemView = null;
                                for (var l = 0; l < prevCureItemsUsedView.length && !cureItemView; l++) {
                                    if (prevCureItemsUsedView[l].getModel() === cureItem) {
                                        cureItemView = prevCureItemsUsedView[l];
                                    }
                                }
                                if (cureItemView) {
                                    cureItemView.reloadModel();
                                } else {
                                    cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                }
                                this.cureItemsUsedView.push(cureItemView);
                            } else {
                                saleCureMinView = {
                                    label: customer.bookings[i].sale.saleCures[_j3].label,
                                    price: customer.bookings[i].sale.saleCures[_j3].price
                                };
                                //search if already exist
                                cureItemView = null;
                                for (var _l = 0; _l < prevCureItemsNotUsedView.length && !cureItemView; _l++) {
                                    if (prevCureItemsNotUsedView[_l].getModel() === cureItem) {
                                        cureItemView = prevCureItemsNotUsedView[_l];
                                    }
                                }
                                if (cureItemView) {
                                    cureItemView.reloadModel();
                                } else {
                                    cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                }
                                this.cureItemsNotUsedView.push(cureItemView);
                            }
                        }
                        minBooking.items.push({
                            type: "cure",
                            label: customer.bookings[i].sale.saleCures[_j3].label,
                            hrLabel: customer.bookings[i].sale.saleCures[_j3].humanResource ? customer.bookings[i].sale.saleCures[_j3].humanResource.label : null
                        });
                    }
                    for (var _j4 = 0; _j4 < customer.bookings[i].sale.loyaltyCardItems.length; _j4++) {
                        lView = {
                            index: LoyaltyCardItemData.getIndexOf(customer.bookings[i].sale.loyaltyCardItems[_j4]),
                            label: customer.bookings[i].sale.loyaltyCardItems[_j4].label,
                            validityDate: customer.bookings[i].sale.loyaltyCardItems[_j4].validityDate,
                            pts: customer.bookings[i].sale.loyaltyCardItems[_j4].pts
                        };
                        if (customer.bookings[i].sale.loyaltyCardItems[_j4].isUsed) {
                            this.loyaltyCardItemsUsedView.push(lView);
                        } else {
                            this.loyaltyCardItemsNotUsedView.push(lView);
                        }
                        minBooking.items.push({
                            type: "loyaltyCard",
                            label: customer.bookings[i].sale.loyaltyCardItems[_j4].label,
                            hrLabel: customer.bookings[i].sale.loyaltyCardItems[_j4].humanResource ? customer.bookings[i].sale.loyaltyCardItems[_j4].humanResource.label : null
                        });
                    }
                    for (var _j5 = 0; _j5 < customer.bookings[i].sale.giftItems.length; _j5++) {
                        minBooking.items.push({
                            type: "gift",
                            label: "Bon cadeau de " + $filter('currencyFormatFilter')(customer.bookings[i].sale.giftItems[_j5].originalPrice),
                            hrLabel: customer.bookings[i].sale.giftItems[_j5].humanResource ? customer.bookings[i].sale.giftItems[_j5].humanResource.label : null
                        });
                    }
                    this.historySoldPrice += customer.bookings[i].sale.price;
                    this.historyRealPaidPrice += customer.bookings[i].sale.realPaidPrice;
                    this.historyCaPrice += customer.bookings[i].sale.price - customer.bookings[i].sale.giftItemsPrice;
                } else {
                    if (customer.bookings[i].sale && customer.bookings[i].sale.status === "waiting") {
                        this.nbWaitingSales++;
                    }
                    if (customer.bookings[i].sale && customer.bookings[i].sale.status === "advance") {
                        this.nbAdvanceSales++;
                    }
                    for (var _j6 = 0; _j6 < customer.bookings[i].bookingServices.length; _j6++) {
                        hrLabel = "";
                        if (customer.bookings[i].bookingServices[_j6].isPackage) {
                            bs = customer.bookings[i].bookingServices[_j6];
                            for (var _k2 = 0; _k2 < bs.subBookingServices.length; _k2++) {
                                if (bs.subBookingServices[_k2].dayHr && bs.subBookingServices[_k2].dayHr.humanResourceId) {
                                    hr = HumanResourceData.getById(bs.subBookingServices[_k2].dayHr.humanResourceId);
                                    if (hr && hrLabel.indexOf(hr.label) === -1) {
                                        if (hrLabel !== "") hrLabel += " ";
                                        hrLabel += hr.label;
                                    }
                                }
                            }
                        } else if (customer.bookings[i].bookingServices[_j6].dayHr && customer.bookings[i].bookingServices[_j6].dayHr.humanResourceId) {
                            hr = HumanResourceData.getById(customer.bookings[i].bookingServices[_j6].dayHr.humanResourceId);
                            if (hr) {
                                hrLabel = hr.label;
                            }
                        }
                        minBooking.items.push({
                            type: "service",
                            label: customer.bookings[i].bookingServices[_j6].label,
                            hrLabel: hrLabel
                        });
                        techNoteServiceItems.push({
                            label: customer.bookings[i].bookingServices[_j6].label
                        });
                    }
                }
                readOnlyBookingsView.push(booking);
                this.globalHistoryView.push(minBooking);
                if (!(customer.bookings[i].sale && (customer.bookings[i].sale.status === SaleStatus.WAITING || customer.bookings[i].sale.status === SaleStatus.SOLD || customer.bookings[i].sale.status === SaleStatus.ADVANCE))) {
                    switch (customer.bookings[i].status) {
                        case 'notCame':
                            this.nbNotCameBookings++;
                            break;
                        case 'came':
                            this.nbCameBookings++;
                            break;
                    }
                }
                if (customer.bookings[i].day && (!this.lastVisitDate || this.lastVisitDate.getTime() < customer.bookings[i].day.getDate().getTime())) {
                    this.lastVisitDate = customer.bookings[i].day.getDate();
                }
                if (!customer.bookings[i].sale && customer.bookings[i].techNote && customer.bookings[i].techNote !== '') {
                    this.addTechNoteToHistoryFromBooking(customer.bookings[i], customer.bookings[i].techNote, techNoteServiceItems);
                }
            }
            this.historyBookingsView = $filter('orderBy')(readOnlyBookingsView, 'date', true); //execute angular filter

            for (var _i = 0; _i < customer.sales.length; _i++) {
                var _techNoteServiceItems = [];
                if (customer.sales[_i].status === SaleStatus.WAITING || customer.sales[_i].status === SaleStatus.ESTIMATION || customer.sales[_i].status === SaleStatus.SOLD || customer.sales[_i].status === SaleStatus.ADVANCE) {
                    if (!customer.sales[_i].booking) {
                        var _date = null;
                        if (customer.sales[_i].day) {
                            _date = customer.sales[_i].day.getDate();
                        }
                        var minSale = {
                            index: SaleData.getIndexOf(customer.sales[_i]),
                            price: customer.sales[_i].price,
                            date: _date,
                            isBooking: false,
                            status: customer.sales[_i].status,
                            items: [],
                            unpaid: false
                        };
                        if (customer.sales[_i].status === "waiting" && customer.sales[_i].booking) {
                            for (var _j7 = 0; _j7 < customer.sales[_i].booking.bookingServices.length; _j7++) {
                                minSale.items.push({
                                    type: "service",
                                    label: customer.sales[_i].booking.bookingServices[_j7].label,
                                    hrLabel: null
                                });
                                _techNoteServiceItems.push({
                                    label: customer.sales[_i].booking.bookingServices[_j7].label
                                });
                            }
                        } else {
                            for (var _j8 = 0; _j8 < customer.sales[_i].saleServices.length; _j8++) {
                                minSale.items.push({
                                    type: "service",
                                    label: customer.sales[_i].saleServices[_j8].label,
                                    hrLabel: customer.sales[_i].saleServices[_j8].humanResource ? customer.sales[_i].saleServices[_j8].humanResource.label : null
                                });
                                _techNoteServiceItems.push({
                                    label: customer.sales[_i].saleServices[_j8].label
                                });
                            }
                        }
                        for (var _j9 = 0; _j9 < customer.sales[_i].saleProducts.length; _j9++) {
                            minSale.items.push({
                                type: "product",
                                label: customer.sales[_i].saleProducts[_j9].label,
                                hrLabel: customer.sales[_i].saleProducts[_j9].humanResource ? customer.sales[_i].saleProducts[_j9].humanResource.label : null
                            });
                        }
                        if (customer.sales[_i].status !== "waiting") {
                            for (var _j10 = 0; _j10 < customer.sales[_i].loyaltyCardItems.length; _j10++) {
                                lView = {
                                    index: LoyaltyCardItemData.getIndexOf(customer.sales[_i].loyaltyCardItems[_j10]),
                                    label: customer.sales[_i].loyaltyCardItems[_j10].label,
                                    validityDate: customer.sales[_i].loyaltyCardItems[_j10].validityDate,
                                    pts: customer.sales[_i].loyaltyCardItems[_j10].pts
                                };
                                if (customer.sales[_i].loyaltyCardItems[_j10].isUsed) {
                                    this.loyaltyCardItemsUsedView.push(lView);
                                } else {
                                    this.loyaltyCardItemsNotUsedView.push(lView);
                                }
                                minSale.items.push({
                                    type: "loyaltyCard",
                                    label: customer.sales[_i].loyaltyCardItems[_j10].label,
                                    hrLabel: customer.sales[_i].loyaltyCardItems[_j10].humanResource ? customer.sales[_i].loyaltyCardItems[_j10].humanResource.label : null
                                });
                            }
                        }
                        for (var _j11 = 0; _j11 < customer.sales[_i].saleCures.length; _j11++) {
                            for (var _k3 = 0; _k3 < customer.sales[_i].saleCures[_j11].cureItems.length; _k3++) {
                                cureItem = customer.sales[_i].saleCures[_j11].cureItems[_k3];
                                if (cureItem.isUsed()) {
                                    saleCureMinView = {
                                        label: customer.sales[_i].saleCures[_j11].label,
                                        price: customer.sales[_i].saleCures[_j11].originalPrice
                                    };
                                    if (customer.sales[_i].status === "sold") {
                                        //search if already exist
                                        cureItemView = null;
                                        for (var _l2 = 0; _l2 < prevCureItemsUsedView.length && !cureItemView; _l2++) {
                                            if (prevCureItemsUsedView[_l2].getModel() === cureItem) {
                                                cureItemView = prevCureItemsUsedView[_l2];
                                            }
                                        }if (cureItemView) {
                                            cureItemView.reloadModel();
                                        } else {
                                            cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                        }
                                        this.cureItemsUsedView.push(cureItemView);
                                    }
                                } else {
                                    saleCureMinView = {
                                        label: customer.sales[_i].saleCures[_j11].label,
                                        price: customer.sales[_i].saleCures[_j11].originalPrice
                                    };
                                    if (customer.sales[_i].status === "sold") {
                                        //search if already exist
                                        cureItemView = null;
                                        for (var _l3 = 0; _l3 < prevCureItemsNotUsedView.length && !cureItemView; _l3++) {
                                            if (prevCureItemsNotUsedView[_l3].getModel() === cureItem) {
                                                cureItemView = prevCureItemsNotUsedView[_l3];
                                            }
                                        }if (cureItemView) {
                                            cureItemView.reloadModel();
                                        } else {
                                            cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                        }
                                        this.cureItemsNotUsedView.push(cureItemView);
                                    }
                                }
                            }
                            minSale.items.push({
                                type: "cure",
                                label: customer.sales[_i].saleCures[_j11].label,
                                hrLabel: customer.sales[_i].saleCures[_j11].humanResource ? customer.sales[_i].saleCures[_j11].humanResource.label : null
                            });
                        }
                        for (var _j12 = 0; _j12 < customer.sales[_i].giftItems.length; _j12++) {
                            minSale.items.push({
                                type: "gift",
                                label: "Bon cadeau de " + $filter('currencyFormatFilter')(customer.sales[_i].giftItems[_j12].originalPrice),
                                hrLabel: customer.sales[_i].giftItems[_j12].humanResource ? customer.sales[_i].giftItems[_j12].humanResource.label : null
                            });
                        }
                        if (customer.sales[_i].status === "waiting") {
                            this.nbWaitingSales++;
                        } else if (customer.sales[_i].status === "estimation") {
                            this.nbEstimationSales++;
                        } else if (customer.sales[_i].status === "advance") {
                            this.nbAdvanceSales++;
                        } else if (customer.sales[_i].status === "sold") {
                            if (customer.sales[_i].hasPaymentType("UNPAID")) {
                                minSale.unpaid = true;
                                this.nbUnpaidSales++;
                            } else {
                                this.nbSoldSales++;
                            }
                            this.historySoldSalesView.push(minSale);
                            this.historySoldPrice += customer.sales[_i].price;
                            this.historyCaPrice += customer.sales[_i].price - customer.sales[_i].giftItemsPrice;
                            this.historyRealPaidPrice += customer.sales[_i].realPaidPrice;
                        }
                        this.globalHistoryView.push(minSale);
                    } else {
                        for (var _j13 = 0; _j13 < customer.sales[_i].booking.bookingServices.length; _j13++) {
                            _techNoteServiceItems.push({
                                label: customer.sales[_i].booking.bookingServices[_j13].label
                            });
                        }
                    }
                    this.addTechNotesBySale(customer.sales[_i], _techNoteServiceItems);
                }
                if (customer.sales[_i].day && (!this.lastVisitDate || this.lastVisitDate.getTime() < customer.sales[_i].day.getDate().getTime())) {
                    this.lastVisitDate = customer.sales[_i].day.getDate();
                }
            }
            this.globalHistoryView = $filter('orderBy')(this.globalHistoryView, 'date', true);
            this.nbCureItemNotUsed = this.cureItemsNotUsedView.length;
            this.nbCureItemUsed = this.cureItemsUsedView.length;
            this.nbLoyaltyCardItemNotUsed = this.loyaltyCardItemsNotUsedView.length;
            this.nbLoyaltyCardItemUsed = this.loyaltyCardItemsUsedView.length;
            this.techNoteHistory = $filter('orderBy')(this.techNoteHistory, 'date', true);
            this.isHistoryInit = true;
        }
    };

    CustomerView.prototype.addTechNotesBySale = function (sale, techNoteServiceItems) {
        if (sale.booking && sale.booking.techNote || sale.techNote) {

            if (sale.techNote) {
                this.addTechNoteToHistoryFromSale(sale, sale.techNote, techNoteServiceItems);
            }
            if (sale.booking && sale.booking.techNote) {
                this.addTechNoteToHistoryFromBooking(sale.booking, sale.booking.techNote, techNoteServiceItems);
            }
        }
    };

    CustomerView.prototype.addTechNoteToHistoryFromBooking = function (booking, techNoteDescription, techNoteServiceItems) {
        if (booking && techNoteDescription) {
            var date = booking.day.getDate();
            var techNoteDatas = {
                index: BookingData.getIndexOf(booking),
                date: date,
                techNote: techNoteDescription,
                status: booking.status,
                isBooking: true,
                items: techNoteServiceItems
            };
            this.nbTechNotes++;
            this.techNoteHistory.push(techNoteDatas);
        }
    };
    CustomerView.prototype.addTechNoteToHistoryFromSale = function (sale, techNoteDescription, techNoteServiceItems) {
        if (sale && techNoteDescription) {
            var date = sale.day.getDate();
            var techNoteDatas = {
                index: SaleData.getIndexOf(sale),
                date: date,
                techNote: techNoteDescription,
                status: sale.status,
                isBooking: false,
                items: techNoteServiceItems
            };
            this.nbTechNotes++;
            this.techNoteHistory.push(techNoteDatas);
        }
    };
    CustomerView.prototype.getFirstCureItemToServiceViewByServiceView = function (serviceView) {
        var cureItemToServiceView = null;
        for (var i = 0; i < this.cureItemsNotUsedView.length && !cureItemToServiceView; i++) {
            cureItemToServiceView = this.cureItemsNotUsedView[i].getFirstCureItemToServiceViewByServiceView(serviceView);
        }return cureItemToServiceView;
    };
    CustomerView.prototype.getFirstGiftItemViewByServiceView = function (serviceView) {
        var giftItemView = null;
        if (serviceView) for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
            if (this.giftItemsNotUsedView[i].serviceView) {
                var giftItem = GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex);
                if (giftItem.service === serviceView.getModel()) giftItemView = this.giftItemsNotUsedView[i];
            }
        }
        return giftItemView;
    };
    CustomerView.prototype.getCureItemToServiceUsageView = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage && cureItemToServiceUsage.cureItemToService && cureItemToServiceUsage.cureItemToService.cureItem) for (var i = 0; i < this.cureItemsNotUsedView.length; i++) {
            if (this.cureItemsNotUsedView[i].getModel() === cureItemToServiceUsage.cureItemToService.cureItem) return this.cureItemsNotUsedView[i].getCureItemToServiceUsageView(cureItemToServiceUsage);
        }return null;
    };
    CustomerView.prototype.getGiftItemView = function (giftItem) {
        if (giftItem) {
            for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
                if (GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex) === giftItem) return this.giftItemsNotUsedView[i];
            }for (var i = 0; i < this.giftItemsUsedView.length; i++) {
                if (GiftItemData.getByIndex(this.giftItemsUsedView[i].giIndex) === giftItem) return this.giftItemsUsedView[i];
            }
        }
        return null;
    };
    CustomerView.prototype.isChanged = function () {
        var customer = this.getModel();
        if (customer) return this.firstName !== customer.firstName || this.lastName !== customer.lastName || this.phone !== Format.formatNumber(customer.phone) || this.landline !== Format.formatNumber(customer.landline) || this.email !== customer.email || this.comment !== customer.comment || this.gender !== customer.gender || this.isVerified !== customer.isVerified || this.address1 !== customer.address1 || this.address2 !== customer.address2 || this.city !== customer.city || this.postCode !== customer.postCode || this.origin !== customer.origin || this.online !== customer.online || this.birthDate !== customer.birthDate || this.isBirthDate !== customer.isBirthDate;else return true;
    };
    CustomerView.prototype.update = function () {
        this.label = this.lastName + " " + this.firstName;
        if (this.label) this.labelLowerCase = this.label.toLowerCase();
    };
    CustomerView.prototype.hasAddress = function () {
        return this.address1 && this.address1 !== "" && this.city && this.city !== "" && this.postCode && this.postCode !== "";
    };
    CustomerView.prototype.removeModel = function () {
        var cust = this.getModel();
        if (cust != null) CustomerSrv.remove(cust);
    };
    CustomerView.prototype.reloadModel = function () {
        var cust = this.getModel();
        if (cust != null) this.loadDataFrom(cust);
    };
    CustomerView.prototype.updateModel = function (save, successFunction, errorFunction) {
        this.update();
        var customer = this.getModel();
        if (!customer) {
            customer = new Customer();
            this.cIndex = CustomerData.getIndexOf(customer);
        }

        this.copyDataTo(customer);

        this.loadCustomerLabelSearch(customer);

        if (save === undefined || save) {
            CustomerSrv.save(customer, successFunction, errorFunction);
        }
        this.isBirthDate = this.computeBirthDate();
    };
    CustomerView.prototype.restoreModel = function () {
        var customer = this.getModel();
        if (customer) CustomerSrv.restore(customer);
    };
    CustomerView.prototype.canSave = function () {
        if (this.birthDateString && this.birthDateString !== "" && !this.birthDate) //String defined but no birthdate
            return false;
        return this.firstName && this.firstName !== "" && this.lastName && this.lastName !== "";
    };

    CustomerView.prototype.canRegisterOnWeb = function (updatePwd) {
        return this.canSaveAccountOnWeb(updatePwd) && this.isCGVAccepted;
    };

    CustomerView.prototype.canSaveAccountOnWeb = function (updatePwd) {

        var can = this.firstName && this.firstName !== "" && this.lastName && this.lastName !== "" && this.email && this.email !== "" && this.email.indexOf('@') !== -1;
        if (this.birthDateString && this.birthDateString !== "" && !this.birthDate) //string defined but no birthdate
            return false;
        if (updatePwd) can = can && this.canChangePwdOnWeb();
        return can;
    };
    CustomerView.prototype.canChangePwdOnWeb = function () {
        return this.password && this.password !== "" && this.passwordAgain && this.passwordAgain !== "" && this.password === this.passwordAgain;
    };
    CustomerView.prototype.canLoginOnWeb = function () {
        return this.login && this.login !== "" && this.password && this.password !== "";
    };
    //FIX ME : DUPLICATED FUNCTION
    CustomerView.prototype.hasValidCellPhone = function (isMandatory) {
        // if customer has a valid cellphone number
        if (!isMandatory) {
            // if not mandatory, phone number is not an obligation
            if (this.phone == null || this.phone === "") return true;
        }
        if (this.phone && this.phone.length > 0) {
            if (this.phone[0] === '0' && this.phone.replace(/[^0-9]/g, '').length === 10 && this.phone.length === 14 && (this.phone[1] === '6' || this.phone[1] === '7')) {
                // if length with only numbers equals 10 and if the first two numbers are 06 or 07
                // french number
                return true;
            }
            if (this.phone[0] === '+' && this.phone.length > 9) {
                // international number
                return true;
            }
        }
        return false;
    };

    CustomerView.prototype.hasValidLandLine = function () {
        // if site has a valid work phone number
        if (this.landline == null || this.landline === "") return true;
        if (this.landline && this.landline.length > 0) {
            if (this.landline[0] === '0' && this.landline.replace(/[^0-9]/g, '').length === 10 && this.landline.length === 14) {
                // if length with only numbers equals 10 and if the first number is 0
                // french number
                return true;
            }
            if (this.landline[0] === '+') {
                // international number
                return true;
            }
        }

        return false;
    };

    CustomerView.prototype.canReceiveEmailMarketing = function () {
        var canReceive = true;
        if (this.optInOutView && this.optInOutView.isAgreementKnown() && !this.optInOutView.isEmailCampaignAllowed) canReceive = false;
        if (this.email == null || this.email === "") canReceive = false;

        return canReceive;
    };

    CustomerView.prototype.canReceiveSmsMarketing = function () {
        var canReceive = true;
        if (this.optInOutView && this.optInOutView.isAgreementKnown() && !this.optInOutView.isSmsCampaignAllowed) canReceive = false;
        if (this.phone == null || this.phone === "") canReceive = false;

        return canReceive;
    };

    CustomerView.prototype.canReceiveEmailOptInReminder = function () {
        var canReceive = true;
        if (this.optInOutView.isAgreementKnown()) canReceive = false;
        if (!this.getModel() || this.getModel().email == null || this.getModel().email === "") canReceive = false;

        return canReceive;
    };

    CustomerView.prototype.canReceiveSmsOptInReminder = function () {
        var canReceiveSms = true;
        if (this.optInOutView.isAgreementKnown()) canReceiveSms = false;else if (this.phone == null || this.phone === "") canReceiveSms = false;

        return canReceiveSms;
    };

    CustomerView.prototype.getVisibleOnWebSiteNotUsedGiftItems = function () {
        var webSiteNotUsedGiftItems = new Array();
        for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
            if (this.giftItemsNotUsedView[i] && this.giftItemsNotUsedView[i].getCustomerOfSale() && this.giftItemsNotUsedView[i].customerView && this.giftItemsNotUsedView[i].customerView.getModel() && this.giftItemsNotUsedView[i].getCustomerOfSale() === this.giftItemsNotUsedView[i].customerView.getModel()) {
                webSiteNotUsedGiftItems.push(this.giftItemsNotUsedView[i]);
            }
        }
        return webSiteNotUsedGiftItems;
    };

    CustomerView.prototype.getModelEmail = function () {
        var model = this.getModel(),
            email = null;
        if (model) email = model.email;
        return email;
    };

    CustomerView.prototype.computeBirthDate = function () {
        var copyBirthDate = new Date(this.birthDate);
        if (copyBirthDate) {
            var now = new Date();
            var minLocalDate = now.setDate(now.getDate() - 14);
            var maxLocalDate = now.setDate(now.getDate() + 28);
            var compareLocalBirthDay = copyBirthDate.setUTCFullYear(now.getUTCFullYear());
            return compareLocalBirthDay > minLocalDate && compareLocalBirthDay < maxLocalDate;
        }
        return false;
    };

    CustomerView.prototype.getPostsViewByCustomerId = function () {
        var posts = CustomerPostData.getActiveList(),
            customerPostViews = [];

        if (this.getModel()) {
            var customerId = this.getModel().getId();
            for (var i = 0; i < posts.length; i++) {
                //Don't replace this == by a === in this method. We need implicit cast comparison
                if (customerId == posts[i].customerId) {
                    var customerPostView = new CustomerPostView(posts[i], i);
                    customerPostViews.push(customerPostView);
                }
            }
        }
        return customerPostViews;
    };

    return CustomerView;
}]);

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('GiftItemView', ["$sce", "$dialog", "GiftItemData", "GiftItem", "$filter", "GiftItemSrv", "CurrencyManager", "gettextCatalog", "NumberSeparatorType", function ($sce, $dialog, GiftItemData, GiftItem, $filter, GiftItemSrv, CurrencyManager, gettextCatalog, NumberSeparatorType) {

    var GiftItemView = function GiftItemView(giftItem, giIndex, billPosition, saleView) {
        this.giIndex = giIndex; //model index
        this.posView = saleView ? saleView.posView : null;
        this.saleView = saleView;
        this.serviceView = null;
        this.paymentSaleView = null;
        this.categoryType = "giftItem";
        this.categoryTypeSortOrder = 4;
        this.code = null;
        this.isUsed = false;
        this.isCanceled = false;
        this.closingDate = null;
        this.price = 0;
        this.priceHT = 0;
        this.vat = 0;
        this.vatCode = "T0"; //vat 0
        this.originalPrice = 0;
        this.originalPriceInput = "";
        this.originalPriceSelect = 50;
        this.discountPercent = 0;
        this.hrView = null;
        this.validityDate = null;
        this.validityDateStr = null;
        this.editionType = ""; //printOnTicket / manual / email / delivery / delivered
        this.customerView = null; //beneficiary
        this.customerLabel = ""; //beneficiary
        this.billPosition = billPosition; //position inside sale ->
        this.barcodeData = ""; //write only
        this.message = "";
        this.messageTitle = "";
        this.imageUrl = "";
        this.comment = "";

        if (giftItem) {
            this.loadDataFrom(giftItem);
        }
    };

    GiftItemView.getFormattedCode = function (code) {
        return code && code.length == 13 ? code.substring(0, 4) + "-" + code.substring(4, 8) + "-" + code.substring(8, 12) + "-" + code.substring(12) : code;
    };

    GiftItemView.prototype.getModel = function () {
        if (this.giIndex != -1) {
            return GiftItemData.getByIndex(this.giIndex);
        }
        return null;
    };

    GiftItemView.prototype.loadDataFrom = function (giftItem) {
        //Assume here than the object in parameter contains only id (must load them)
        if (giftItem) {
            if (giftItem.code) this.code = GiftItemView.getFormattedCode(giftItem.code);
            if (giftItem.service && this.posView) this.serviceView = this.posView.domainView.getServiceView(giftItem.service);
            this.price = giftItem.price;
            if (giftItem.vatCode) {
                this.vat = giftItem.vat;
                this.vatCode = giftItem.vatCode;
            } else {
                if (this.saleView) {
                    this.vat = this.saleView.vat;
                    this.vatCode = this.saleView.vatCode;
                }
            }

            this.isUsed = giftItem.isUsed;
            this.isCanceled = giftItem.isCanceled;
            if (giftItem.closingDate) {
                this.closingDate = giftItem.closingDate;
            }
            this.updatePriceHT();
            if (giftItem.originalPrice != null) this.originalPrice = giftItem.originalPrice;else this.originalPrice = this.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.discountPercent = giftItem.discountPercent;
            if (giftItem.humanResource && this.posView) this.hrView = this.posView.domainView.getHrView(giftItem.humanResource);
            this.validityDate = giftItem.validityDate;
            if (this.validityDate) this.validityDateStr = $filter('date')(this.validityDate, 'shortDate');

            this.editionType = giftItem.editionType;
            if (giftItem.customer && this.posView) this.customerView = this.posView.domainView.getCustomerView(giftItem.customer);
            this.barcodeData = giftItem.barcodeData;
            this.message = giftItem.message;
            this.messageTitle = giftItem.messageTitle;
            this.imageUrl = giftItem.imageUrl;
            this.comment = giftItem.comment;
            this.updateCustomerLabel();
        }
    };

    GiftItemView.prototype.updateCustomerLabel = function () //
    {
        if (this.customerView) {
            this.customerLabel = this.customerView.lastName;
            if (this.customerView.firstName) this.customerLabel = +" " + this.customerView.firstName;
        } else this.customerLabel = "";
    };

    GiftItemView.prototype.updateFromModel = function () {
        var giftItem = this.getModel();
        if (giftItem) this.loadDataFrom(giftItem);
    };

    GiftItemView.prototype.copyDataTo = function (giftItem) {
        if (giftItem) {
            if (this.serviceView) giftItem.service = this.serviceView.getModel();
            giftItem.price = this.price;
            giftItem.vat = this.vat;
            giftItem.vatCode = this.vatCode;
            giftItem.isUsed = this.isUsed;
            giftItem.isCanceled = this.isCanceled;
            if (this.closingDate) {
                giftItem.closingDate = this.closingDate;
            }
            giftItem.originalPrice = this.originalPrice;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                giftItem.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                giftItem.discountPercent = parseFloat(giftItem.discountPercent);
            } else giftItem.discountPercent = this.discountPercent;
            if (this.code) giftItem.code = this.code.replace(/-/g, "");
            var newSale = this.saleView.getModel();
            if (giftItem.sale && newSale !== giftItem.sale) //remove
                giftItem.sale.removeGiftItem(giftItem);
            if (newSale) //Force add because removed by sale.updateModel
                newSale.addGiftItem(giftItem);
            if (this.hrView) giftItem.humanResource = this.hrView.getModel();
            giftItem.validityDate = this.validityDate;
            giftItem.editionType = this.editionType;
            if (this.customerView) {
                var customer = this.customerView.getModel();
                if (customer !== giftItem.customer) {
                    if (giftItem.customer) {
                        giftItem.customer.removeGiftItem(giftItem);
                        if (this.posView) {
                            var previousCustomerView = this.posView.domainView.getCustomerView(giftItem.customer);
                            if (previousCustomerView) previousCustomerView.initGiftItemsView();
                        }
                    }
                    if (customer) customer.addGiftItem(giftItem);
                    giftItem.customer = customer;
                }
                this.customerView.initGiftItemsView();
            } else {
                if (giftItem.customer) {
                    giftItem.customer.removeGiftItem(giftItem);
                    if (this.posView) {
                        var previousCustomerView = this.posView.domainView.getCustomerView(giftItem.customer);
                        if (previousCustomerView) previousCustomerView.initGiftItemsView();
                    }
                }
                giftItem.customer = null;
            }
            giftItem.barcodeData = this.barcodeData;
            giftItem.message = this.message;
            giftItem.messageTitle = this.messageTitle;
            giftItem.imageUrl = this.imageUrl;
            giftItem.comment = this.comment;
        }
    };

    GiftItemView.prototype.getClone = function (saleView) {
        var spView = new GiftItemView(null, -1, this.billPosition, saleView);
        spView.vatCode = this.vatCode;
        spView.vat = this.vat;
        spView.serviceView = this.serviceView;
        spView.code = this.code;
        spView.price = this.price;
        spView.originalPrice = this.originalPrice;
        spView.originalPriceInput = this.originalPriceInput;
        spView.discountPercent = this.discountPercent;
        spView.hrView = this.hrView;
        spView.isUsed = this.isUsed;
        spView.isCanceled = this.isCanceled;
        if (this.closingDate) {
            spView.closingDate = this.closingDate;
        }
        spView.validityDate = this.validityDate;
        spView.editionType = this.editionType;
        spView.comment = this.comment;
        spView.customerView = this.customerView;
        spView.updateCustomerLabel();
        return spView;
    };

    GiftItemView.prototype.canceled = function (callbackFunction) {
        var msgConfirmation = gettextCatalog.getString("Voulez-vous vraiment clôturer ce chèque cadeau valable jusqu'au");
        var msgWarning = gettextCatalog.getString("Attention, cette opération ne peut pas être annulée");

        var gi = this;
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = msgConfirmation + " " + (gi.validityDateStr ? gi.validityDateStr : "") + " ?";
                    tableModel["description"] = msgWarning;
                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                gi.isCanceled = true;
                gi.closingDate = new Date();
                gi.updateModel(true, callbackFunction);

                if (gi.posView && gi.posView.posSaleHistoryView) {
                    gi.posView.posSaleHistoryView.onSearchGiftItemInputKeyDown(gi.posView.posSaleHistoryView.filters.type);
                }
            }
        });
    };

    GiftItemView.prototype.updateOriginalPriceInputArrow = function (number) {
        if ((!this.saleView || !this.saleView.isReadOnly) && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") originalPrice += number;

            this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
            this.originalPrice = originalPrice;
            this.updatePrice();
        }
    };

    GiftItemView.prototype.onOriginalPriceInputChange = function () {
        if ((!this.saleView || !this.saleView.isReadOnly) && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") {
                this.originalPrice = originalPrice;
            } else {
                this.originalPrice = null;
            }
            this.updatePrice();
        }
    };

    GiftItemView.prototype.setHrView = function (hrView) {
        this.hrView = hrView;
    };
    GiftItemView.prototype.updatePriceHT = function () {
        // no vat
        this.priceHT = this.price;
    };
    GiftItemView.prototype.increaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (step + this.discountPercent > 100) this.discountPercent = 100;else this.discountPercent += step;
            this.updatePrice();
        }
    };
    GiftItemView.prototype.decreaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (this.discountPercent - step < 0) this.discountPercent = 0;else this.discountPercent -= step;
            this.updatePrice();
        }
    };

    GiftItemView.prototype.updatePrice = function () {
        var oriPrice = this.originalPrice;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.updatePriceHT();
            if (this.saleView) {
                this.saleView.resetPayments();
                this.saleView.calculateSaleFields();
            }
        }
        this.saleView.checkForInvalidAmounts();
    };

    GiftItemView.prototype.onCustomerInputKeyDown = function (event) {
        var keyCode = event.which;
        //if key delete detected : clear customer
        if (keyCode == 8 || keyCode == 46) this.customerView = null;
    };

    GiftItemView.prototype.updateEditionType = function (type, save) {
        this.editionType = type;
        this.updateModel(save);
    };

    GiftItemView.prototype.updateModel = function (save, endFunction) {
        if (this.customerView) {
            if (this.posView && !this.customerView.getModel()) //Add to view
                {
                    this.posView.domainView.addCustomerView(this.customerView);
                }
            this.customerView.updateModel(false);
        }
        var giftItem = this.getModel();
        if (giftItem == null) {
            giftItem = new GiftItem();
            this.giIndex = GiftItemData.getIndexOf(giftItem);
        }
        this.copyDataTo(giftItem);
        var giftItemView = this;
        if (save !== undefined && save) //save directly in order to get id
            GiftItemSrv.save(giftItem, function () {
                if (giftItem.code) {
                    giftItemView.code = GiftItemView.getFormattedCode(giftItem.code);
                    if (endFunction != undefined) {
                        endFunction();
                    }
                }
            });
    };

    GiftItemView.prototype.canSave = function () {
        if (!this.productView) {
            return false;
        }

        var priceFloat = parseFloat(this.price);
        if (priceFloat !== "NaN" && priceFloat !== "") {
            this.price = priceFloat;
        } else {
            this.price = "";
        }
        return this.label && this.label != "" && this.price && this.price >= 0;
    };

    GiftItemView.prototype.sendMail = function () {
        var giftItem = this.getModel();
        if (giftItem && this.canSendGiftItemMail()) {
            GiftItemSrv.sendMail(giftItem);
        }
    };

    GiftItemView.prototype.canSendGiftItemMail = function () {
        var canSendMail = true;

        if (!this.hasCustomerWithEmail() && !this.saleView.hasCustomerWithEmail()) {
            canSendMail = false;
        }

        return canSendMail;
    };

    GiftItemView.prototype.hasCustomerWithEmail = function () {
        return this.customerView && this.customerView.email;
    };

    GiftItemView.prototype.getCustomerOfSale = function () {
        var customerOfSale = null;
        if (this.saleView && this.saleView.customerView && this.saleView.customerView.getModel()) {
            customerOfSale = this.saleView.customerView.getModel();
        }
        return customerOfSale;
    };

    return GiftItemView;
}]);

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:51
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('HumanResourceView', ["HumanResourceData", "HumanResourceSrv", "HumanResource", "CompanyImageData", function (HumanResourceData, HumanResourceSrv, HumanResource, CompanyImageData) {

    var HumanResourceView = function HumanResourceView(humanResource, hrIndex, domainView, order) {
        this.hrIndex = hrIndex;
        this.domainView = domainView;
        this.label = null;
        this.firstName = null;
        this.lastName = null;
        this.phone = null;
        this.email = null;
        this.description = null;
        this.gender = null;
        this.color = null;
        this.photo = null;
        this.photoId = null;
        this.hasPlanning = true;
        this.onLineBooking = true;
        this.order = null;
        this.display = true;
        this.hasPhoto = false;

        if (humanResource) this.loadDataFrom(humanResource);

        if (order != undefined && order != null) {
            this.order = order;
        }
    };

    HumanResourceView.prototype.loadDataFrom = function (humanResource) {
        if (humanResource.id) {
            this.id = humanResource.id;
        }
        this.label = humanResource.label;
        this.firstName = humanResource.firstName;
        this.lastName = humanResource.lastName;
        this.phone = humanResource.phone;
        this.email = humanResource.email;
        this.description = humanResource.description;
        this.gender = humanResource.gender;
        this.color = humanResource.color;
        this.photoId = humanResource.photoId;
        if (this.photoId) {
            this.photo = CompanyImageData.getById(this.photoId);
        }
        this.hasPhoto = this.photoId != null;
        this.hasPlanning = humanResource.hasPlanning;
        this.order = humanResource.order;
    };
    HumanResourceView.prototype.copyDataTo = function (humanResource) {
        humanResource.id = this.id;
        humanResource.label = this.label;
        humanResource.firstName = this.firstName;
        humanResource.lastName = this.lastName;
        humanResource.phone = this.phone;
        humanResource.email = this.email;
        humanResource.description = this.description;
        humanResource.gender = this.gender;
        humanResource.color = this.color;
        humanResource.photoId = this.photoId;
        humanResource.hasPlanning = this.hasPlanning;
        humanResource.onLineBooking = this.onLineBooking;
        humanResource.order = this.order;
    };
    HumanResourceView.prototype.isChanged = function () {
        var hr = this.getModel();
        if (hr) return this.label != hr.label || this.firstName != hr.firstName || this.lastName != hr.lastName || this.phone != hr.phone || this.email != hr.email || this.description != hr.description || this.gender != hr.gender || this.color != hr.color || this.photoId != hr.photoId || this.hasPlanning != hr.hasPlanning || this.onLineBooking != hr.onLineBooking || this.order != hr.order;else return true;
    };
    HumanResourceView.prototype.getModel = function () {
        if (this.hrIndex != -1) return HumanResourceData.getByIndex(this.hrIndex);
        return null;
    };

    HumanResourceView.prototype.initHrData = function () {
        var humanResource = this.getModel();
        if (humanResource == null) {
            humanResource = new HumanResource();
            this.hrIndex = HumanResourceData.getIndexOf(humanResource);
        }
        this.copyDataTo(humanResource);
        return humanResource;
    };

    HumanResourceView.prototype.updateModel = function () {
        if (!this.isChanged()) {
            var humanResourceView = this;
            var humanResource = this.initHrData();
            HumanResourceSrv.save(humanResource, function () {
                if (humanResource.id) {
                    humanResourceView.id = humanResource.id;
                }
            });
        }
    };

    HumanResourceView.prototype.updateModelWithPromise = function () {
        var humanResourceView = this;
        return new Promise(function (resolve, reject) {
            if (!humanResourceView.isChanged()) {
                return resolve();
            }
            var humanResource = humanResourceView.initHrData();
            HumanResourceSrv.save(humanResource, function () {
                if (humanResource.id) {
                    humanResourceView.id = humanResource.id;
                }
                return resolve();
            }, reject);
        });
    };

    HumanResourceView.prototype.reloadModel = function () {
        var hr = this.getModel();
        if (hr != null) this.loadDataFrom(hr);
    };
    HumanResourceView.prototype.removeModel = function () {
        var hr = this.getModel();
        if (hr != null) HumanResourceSrv.remove(hr);
    };
    HumanResourceView.prototype.restoreModel = function () {
        var hr = this.getModel();
        if (hr) HumanResourceSrv.restore(hr);
    };

    HumanResourceView.prototype.knowsServiceView = function (serviceView) {
        if (serviceView) {
            var hr = this.getModel();
            if (hr) {
                return hr.hasService(serviceView.getModel());
            }
        }
        return false;
    };
    HumanResourceView.prototype.canSave = function () {
        return this.firstName && this.firstName != "" && this.lastName && this.lastName != "" && this.label && this.label != "" && (this.hasPhoto && this.photoId != null || !this.hasPhoto && this.photoId == null);
    };

    HumanResourceView.prototype.setCompanyImage = function (photo) {
        //do not changed this method name, is used in companyImageCtrl.onUploadCompanyImageSuccess()
        this.photo = photo;
        this.photoId = photo ? photo.id : null;
    };

    return HumanResourceView;
}]);

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategoryView', ["$log", "LoyaltyCardView", "LoyaltyCardCategoryData", "LoyaltyCardData", "LoyaltyCardCategory", "LoyaltyCardCategorySrv", "LoyaltyCardSrv", "StyleColor", "ItemCategoryView", function ($log, LoyaltyCardView, LoyaltyCardCategoryData, LoyaltyCardData, LoyaltyCardCategory, LoyaltyCardCategorySrv, LoyaltyCardSrv, StyleColor, ItemCategoryView) {

    var LoyaltyCardCategoryView = function LoyaltyCardCategoryView(category, catIndex, parentCategoryView, domainView) {
        ItemCategoryView.call(this);

        this.catIndex = catIndex;
        this.domainView = domainView;
        this.label = "";
        this.description = "";
        this.loyaltyCardsView = [];
        this.categoriesView = [];
        this.image = null;
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.styleView = {}; //styleView is an object and category.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.parentCategoryView = null;
        this.selectedLoyaltyCardView = null;
        this.displayType = "array"; // only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
        this.displayLoyaltyCardImages = true; // only on view if children images are different than son

        if (parentCategoryView !== undefined && parentCategoryView != null) this.parentCategoryView = parentCategoryView;

        this.styleView = this.getStyleFrom(category);
        if (this.styleView) this.colorPicker = this.styleView.background;

        if (category !== undefined && category != null) {
            var loyaltyCardView;
            this.loadDataFrom(category);
            for (var i = 0; i < category.categories.length; i++) {
                this.categoriesView.push(new LoyaltyCardCategoryView(category.categories[i], LoyaltyCardCategoryData.getIndexOf(category.categories[i]), this, domainView));
            }for (var j = 0; j < category.loyaltyCards.length; j++) {
                loyaltyCardView = new LoyaltyCardView(category.loyaltyCards[j], LoyaltyCardData.getIndexOf(category.loyaltyCards[j]), this, domainView);
                this.loyaltyCardsView.push(loyaltyCardView);
                if (this.domainView && this.domainView.addLoyaltyCardViewIndex !== undefined) this.domainView.addLoyaltyCardViewIndex(loyaltyCardView);
            }
        }
    };

    LoyaltyCardCategoryView.prototype = Object.create(ItemCategoryView.prototype); //inherit functions from ItemCategoryView

    LoyaltyCardCategoryView.prototype.setImage = function (image) {
        for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            if (this.loyaltyCardsView[j].image == null && !this.loyaltyCardsView[j].specificImage) //if same than previous change
                this.loyaltyCardsView[j].setImage(image);
        }this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    LoyaltyCardCategoryView.prototype.setCompanyImage = function (companyImage) {
        for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            if (this.loyaltyCardsView[j].companyImage == null && !this.loyaltyCardsView[j].specificImage) //if same than previous change
                this.loyaltyCardsView[j].setImage(companyImage);
        }this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    LoyaltyCardCategoryView.prototype.getCategoryView = function (category) {
        var categoryView = null;
        if (this.getModel() === category) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryView(category);
        }return categoryView;
    };

    LoyaltyCardCategoryView.prototype.getLoyaltyCardView = function (loyaltyCard) {
        var loyaltyCardView = null;
        for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            if (this.loyaltyCardsView[j].getModel() === loyaltyCard) return this.loyaltyCardsView[j];
        }for (var z = 0; z < this.categoriesView.length && !loyaltyCardView; z++) {
            loyaltyCardView = this.categoriesView[z].getLoyaltyCardView(loyaltyCard);
        }return loyaltyCardView;
    };
    LoyaltyCardCategoryView.prototype.getLoyaltyCardViewById = function (id) {
        var loyaltyCard;
        for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            loyaltyCard = this.loyaltyCardsView[j].getModel();
            if (loyaltyCard && loyaltyCard.id == id) return this.loyaltyCardsView[j];
        }
        var loyaltyCardView = null;
        for (var z = 0; z < this.categoriesView.length && !loyaltyCardView; z++) {
            loyaltyCardView = this.categoriesView[z].getLoyaltyCardViewById(id);
        }return loyaltyCardView;
    };
    LoyaltyCardCategoryView.prototype.getCategoryViewById = function (id) {
        var categoryView = null;
        var category = this.getModel();
        if (category && category.id == id) return this;
        for (var z = 0; z < this.categoriesView.length && !categoryView; z++) {
            categoryView = this.categoriesView[z].getCategoryViewById(id);
        }return categoryView;
    };
    LoyaltyCardCategoryView.prototype.getAllLoyaltyCardsView = function (loyaltyCard) {
        var lLoyaltyCardsView = this.loyaltyCardsView.slice(0);

        var array;
        for (var z = 0; z < this.categoriesView.length; z++) {
            array = this.categoriesView[z].getAllLoyaltyCardsView();
            if (array) for (var j = 0; j < array.length; j++) {
                lLoyaltyCardsView.push(array[j]);
            }
        }

        return lLoyaltyCardsView;
    };

    LoyaltyCardCategoryView.prototype.getLoyaltyCardViewByCode = function (code) {
        var loyaltyCardView = null;
        for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            if (this.loyaltyCardsView[j].code == code) return this.loyaltyCardsView[j];
        }for (var z = 0; z < this.categoriesView.length && !loyaltyCardView; z++) {
            loyaltyCardView = this.categoriesView[z].getLoyaltyCardViewByCode(code);
        }return loyaltyCardView;
    };

    LoyaltyCardCategoryView.prototype.copyDataTo = function (category) {
        //Assume here than the object in parameter contains only id (must load them)
        category.label = this.label;
        category.description = this.description;
        if (this.parentCategoryView && this.styleView === this.parentCategoryView.styleView) // if is specific set it
            category.style = null;else category.style = angular.toJson(this.styleView);
        category.image = this.image;
        category.companyImage = this.companyImage;
        category.specificImage = this.specificImage;
        category.isVisibleOnWebSite = this.isVisibleOnWebSite;
    };
    LoyaltyCardCategoryView.prototype.loadDataFrom = function (category) {
        this.label = category.label;
        this.description = category.description;
        this.image = category.image;
        this.companyImage = category.companyImage;
        this.specificImage = category.specificImage;
        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;
        this.isVisibleOnWebSite = category.isVisibleOnWebSite;
    };
    LoyaltyCardCategoryView.prototype.onStyleViewChange = function () {
        var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
        if (!this.styleView || this.styleView.background != this.colorPicker) {
            if (!this.styleView || //if undefined
            this.parentCategoryView && this.parentCategoryView.styleView === this.styleView) // if same than parent : break inheritance
                this.styleView = {};
            this.styleView.background = this.colorPicker;
            this.styleView.color = fontColor;
            this.updateStyleView();
        }
    };
    LoyaltyCardCategoryView.prototype.updateStyleView = function (styleView) {
        for (var j = 0; j < this.categoriesView.length; j++) {
            if (this.categoriesView[j].styleView == null) //if same than previous change
                this.categoriesView[j].updateStyleView(styleView);
        }
    };
    LoyaltyCardCategoryView.prototype.getStyleFrom = function (category) {
        var styleView = null;
        if (category) if (category.style && category.style.indexOf('{') != 0) //Previous type before 1.5 was not contains a jsonSTring
            styleView = null;else try {
            styleView = angular.fromJson(category.style);
        } catch (ex) {
            console.log("Error loading style");
        }
        if (!styleView) if (this.parentCategoryView != null) styleView = this.parentCategoryView.styleView;
        return styleView;
    };
    LoyaltyCardCategoryView.prototype.isChanged = function () {
        var category = this.getModel();
        if (category) {
            /*var image = category.image;
            if ((image==null||image=="") &&this.parentCategoryView)
                image = this.parentCategoryView.image;*/
            var styleView = this.getStyleFrom(category);
            var styleChanged = this.styleView && !styleView || !this.styleView && styleView || this.styleView && styleView && this.styleView.background != styleView.background;
            return this.label != category.label || this.description != category.description || styleChanged || this.image != category.image || this.companyImage != category.companyImage;
        } else return true;
    };
    LoyaltyCardCategoryView.prototype.getModel = function () {
        if (this.catIndex != -1) return LoyaltyCardCategoryData.getByIndex(this.catIndex);
        return null;
    };
    LoyaltyCardCategoryView.prototype.restoreModel = function () {
        //undeleted
        var category = this.getModel();
        if (category) {
            if (category.parentCategory) category.parentCategory.addCategory(category);
            LoyaltyCardCategorySrv.restore(category);
        }
    };
    LoyaltyCardCategoryView.prototype.updateModel = function () {
        var category = this.getModel();
        if (category == null) {
            category = new LoyaltyCardCategory();
            this.catIndex = LoyaltyCardCategoryData.getIndexOf(category);
        }

        this.copyDataTo(category);
        if (this.parentCategoryView) {
            var parentCategory = this.parentCategoryView.getModel();
            if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory) category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
        }
        //modify order of categories
        category.categories = [];
        for (var i = 0; i < this.categoriesView.length; i++) {
            category.addCategory(this.categoriesView[i].getModel());
        }category.loyaltyCards = [];
        for (var i = 0; i < this.loyaltyCardsView.length; i++) {
            category.addLoyaltyCard(this.loyaltyCardsView[i].getModel());
        }LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
    };

    LoyaltyCardCategoryView.prototype.reloadModel = function () {
        var category = this.getModel();
        if (category == null) {
            this.parentCategoryView.removeCategoryView(this);
        } else {
            var styleView = this.getStyleFrom(category);
            if (this.styleView && styleView) {
                this.styleView.background = styleView.background;
                this.styleView.color = styleView.color;
            } else this.styleView = styleView;
            if (this.styleView) this.colorPicker = this.styleView.background;

            this.loadDataFrom(category);
        }
    };
    LoyaltyCardCategoryView.prototype.removeModel = function () {
        var category = this.getModel();
        if (category != null) {
            if (category.parentCategory) category.parentCategory.removeCategory(category);
            LoyaltyCardCategorySrv.remove(category);
        }
    };

    LoyaltyCardCategoryView.prototype.removeSelections = function () {
        //if one loyaltyCard is known by humanResource : category is known
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].removeSelections();
        }for (var j = 0; j < this.loyaltyCardsView.length; j++) {
            this.loyaltyCardsView[j].isSelected = false;
        }
    };

    LoyaltyCardCategoryView.prototype.addCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index == -1) {
            this.categoriesView.push(categoryView);
            categoryView.parentCategoryView = this;
        }
    };

    LoyaltyCardCategoryView.prototype.removeCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index != -1) this.categoriesView.splice(index, 1);
    };
    LoyaltyCardCategoryView.prototype.addLoyaltyCardView = function (loyaltyCardView) {
        var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
        if (index == -1) {
            this.loyaltyCardsView.push(loyaltyCardView);
            loyaltyCardView.parentCategoryView = this;
        }
    };

    LoyaltyCardCategoryView.prototype.removeLoyaltyCardView = function (loyaltyCardView) {
        var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
        if (index != -1) {
            this.loyaltyCardsView.splice(index, 1);
        }
    };
    LoyaltyCardCategoryView.prototype.changeCategoryPosition = function (scope, categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget

        var category = this.getModel();
        var index = this.categoriesView.indexOf(categoryView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            category.categories.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY Two APPLYs ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.categoriesView.length) {
                this.categoriesView.push(categoryView);
                category.categories.push(categoryView.getModel());
            } else {
                this.categoriesView.splice(indexTarget, 0, categoryView); //insert
                category.categories.splice(indexTarget, 0, categoryView.getModel());
            }
            LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
        }
        scope.$apply();
    };
    LoyaltyCardCategoryView.prototype.changeLoyaltyCardPosition = function (scope, loyaltyCardView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // loyaltyCardView : loyaltyCard to move to indexTarget
        var category = this.getModel();
        var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.loyaltyCardsView && indexTarget <= this.loyaltyCardsView.length) {
            this.loyaltyCardsView.splice(index, 1); //remove it
            category.loyaltyCards.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY TO APPLY ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.loyaltyCardsView.length) {
                this.loyaltyCardsView.push(loyaltyCardView);
                category.loyaltyCards.push(loyaltyCardView.getModel());
            } else {
                this.loyaltyCardsView.splice(indexTarget, 0, loyaltyCardView); //insert
                category.loyaltyCards.splice(indexTarget, 0, loyaltyCardView.getModel());
            }
            LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
            scope.$apply();
        }
    };
    LoyaltyCardCategoryView.prototype.changeCategoryPositionView = function (categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget
        var index = this.categoriesView.indexOf(categoryView);
        if (indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            if (indexTarget == this.categoriesView.length) this.categoriesView.push(categoryView);else this.categoriesView.splice(indexTarget, 0, categoryView); //insert
        }
    };
    LoyaltyCardCategoryView.prototype.changeLoyaltyCardPositionView = function (loyaltyCardView, indexTarget) {
        //Change the loyaltyCard position

        var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
        //Todo check indexTarget!=index
        if (indexTarget != -1 && index != -1 && this.loyaltyCardsView && indexTarget <= this.loyaltyCardsView.length) {
            this.loyaltyCardsView.splice(index, 1); //remove it
            if (indexTarget == this.loyaltyCardsView.length) this.loyaltyCardsView.push(loyaltyCardView);else this.loyaltyCardsView.splice(indexTarget, 0, loyaltyCardView); //insert
        }
    };
    LoyaltyCardCategoryView.prototype.moveLoyaltyCard = function (loyaltyCardView) {
        if (loyaltyCardView) {
            var loyaltyCard = loyaltyCardView.getModel();
            var category = this.getModel();
            if (loyaltyCard && category) {
                if (loyaltyCardView.parentCategoryView) {
                    var index = loyaltyCardView.parentCategoryView.loyaltyCardsView.indexOf(loyaltyCardView);
                    if (index != -1) {
                        loyaltyCardView.parentCategoryView.loyaltyCardsView.splice(index, 1);
                        loyaltyCard.parentCategory.loyaltyCards.splice(index, 1);
                    }
                }
                this.addLoyaltyCardView(loyaltyCardView);
                category.addLoyaltyCard(loyaltyCard);
                LoyaltyCardSrv.save(loyaltyCard);
            }
        }
    };
    LoyaltyCardCategoryView.prototype.moveCategory = function (categoryView) {
        if (categoryView) {
            var categoryToMove = categoryView.getModel();
            var category = this.getModel();
            if (categoryToMove && category) {
                if (categoryView.parentCategoryView) {
                    var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                    if (index != -1) {
                        categoryView.parentCategoryView.categoriesView.splice(index, 1);
                        categoryToMove.parentCategory.categories.splice(index, 1);
                    }
                }
                this.addCategoryView(categoryView);
                category.addCategory(categoryToMove);
                LoyaltyCardCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
            }
        }
    };
    LoyaltyCardCategoryView.prototype.canSave = function () {
        return this.label && this.label != "";
    };
    LoyaltyCardCategoryView.prototype.initWebDisplay = function () {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].initWebDisplay();
        }this.displayLoyaltyCardImages = false;
        for (var j = 0; j < this.loyaltyCardsView.length && !this.displayLoyaltyCardImages; j++) {
            if (this.loyaltyCardsView[j].imageDisplayed !== this.imageDisplayed) this.displayLoyaltyCardImages = true;
        }for (var j = 0; j < this.categoriesView.length && !this.displayServiceImages; j++) {
            if (this.categoriesView[j].imageDisplayed !== this.imageDisplayed) this.displayLoyaltyCardImages = true;
        }if (this.displayLoyaltyCardImages) this.displayType = "thumbnail";else this.displayType = "array";
    };
    LoyaltyCardCategoryView.prototype.populateDisplayTypeResource = function (array) {
        var defaultDType = this.displayLoyaltyCardImages ? "thumbnail" : "array";
        if (this.displayType != defaultDType) {
            var cat = this.getModel();
            if (cat) array.push({ id: cat.id, type: this.displayType });
        }
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateDisplayTypeResource(array);
        }
    };

    return LoyaltyCardCategoryView;
}]);

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardItemView', ["LoyaltyCardItemData", "LoyaltyCardItemSrv", "LoyaltyCardItem", "SaleData", "$filter", "$timeout", "CurrencyManager", "NumberSeparatorType", "gettextCatalog", function (LoyaltyCardItemData, LoyaltyCardItemSrv, LoyaltyCardItem, SaleData, $filter, $timeout, CurrencyManager, NumberSeparatorType, gettextCatalog) {

    var LoyaltyCardItemView = function LoyaltyCardItemView(loyaltyCardItem, lIndex, billPosition, saleView, posView) {
        this.lIndex = lIndex;
        this.posView = saleView ? saleView.posView : posView;
        this.saleView = saleView; // creation sale
        this.label = "";
        this.type = null; // nbSales / pts / subs
        this.itemType = null; // nbSales / pts / subs
        this.color = "";
        this.ptsByCa = 0;
        this.ptsBySale = 0;
        this.monthValidity = 0;
        this.validityExtend = true;
        this.validityDate = null;
        this.updateValidityDateString();
        this.alertExp = 0;
        this.description = "";
        this.price = 0;
        this.priceHT = 0;
        this.vat = null;
        this.vatCode = null;
        this.priceInput = $filter("currencyFormatFilter")(0);
        this.originalPrice = 0;
        this.originalPriceInput = "";
        this.originalPriceSelect = "";
        this.discountPercent = 0;
        this.hrView = null;
        this.loyaltyCardView = null;
        this.customerView = null;
        this.pts = 0;
        this.goalPts = null;
        this.goalType = null; // special, discountValue,discountPercent
        this.goalAmount = null;
        this.goalText = null;
        this.isUsed = false;
        this.billPosition = billPosition; // view
        this.validityDatePickerOpened = false;
        this.linkedSalesView = []; //view
        this.discountTypeText = gettextCatalog.getString("Remise de");
        this.nextRewardsText = gettextCatalog.getString("à la prochaine récompense");
        this.discountTypeSymbol = "%";
        if (loyaltyCardItem !== undefined && loyaltyCardItem != null) this.loadDataFrom(loyaltyCardItem);
    };
    LoyaltyCardItemView.prototype.getModel = function () {
        if (this.lIndex != -1) {
            return LoyaltyCardItemData.getByIndex(this.lIndex);
        }
        return null;
    };
    LoyaltyCardItemView.prototype.loadDataFrom = function (loyaltyCardItem) {
        //Assume here than the object in parameter contains only id (must load them)
        this.label = loyaltyCardItem.label;
        this.color = loyaltyCardItem.color;
        this.type = loyaltyCardItem.type;
        this.itemType = loyaltyCardItem.itemType;
        this.ptsByCa = loyaltyCardItem.ptsByCa;
        this.ptsBySale = loyaltyCardItem.ptsBySale;
        this.pts = loyaltyCardItem.pts;
        this.goalPts = loyaltyCardItem.goalPts;
        this.goalType = loyaltyCardItem.goalType;
        this.goalAmount = loyaltyCardItem.goalAmount;
        this.goalText = loyaltyCardItem.goalText;
        this.monthValidity = loyaltyCardItem.monthValidity;
        this.validityExtend = loyaltyCardItem.validityExtend;
        this.alertExp = loyaltyCardItem.alertExp;
        if (loyaltyCardItem.validityDate) {
            this.validityDate = new Date(loyaltyCardItem.validityDate);
            this.validityDateString = $filter('date')(loyaltyCardItem.validityDate, 'shortDate');
        }
        this.description = loyaltyCardItem.description;
        this.price = loyaltyCardItem.price;
        this.priceInput = $filter('currencyFormatFilter')(this.price);
        if (loyaltyCardItem.vatCode) {
            this.vat = loyaltyCardItem.vat;
            this.vatCode = loyaltyCardItem.vatCode;
        } else {
            if (this.saleView) {
                this.vat = this.saleView.vat;
                this.vatCode = this.saleView.vatCode;
            }
        }
        this.vat = loyaltyCardItem.vat;
        this.vatCode = loyaltyCardItem.vatCode;
        this.originalPrice = loyaltyCardItem.originalPrice;
        this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
        this.discountPercent = loyaltyCardItem.discountPercent;
        this.updatePriceHT();

        if (loyaltyCardItem.loyaltyCard && this.posView) this.loyaltyCardView = this.posView.domainView.getLoyaltyCardView(loyaltyCardItem.loyaltyCard);
        if (loyaltyCardItem.humanResource && this.posView) this.hrView = this.posView.domainView.getHrView(loyaltyCardItem.humanResource);

        this.isUsed = loyaltyCardItem.isUsed;
    };
    LoyaltyCardItemView.prototype.setLoyaltyCard = function (loyaltyCardView, isOnInternet) {
        this.loyaltyCardView = loyaltyCardView;
        if (loyaltyCardView != null) {
            if (this.posView && this.posView.domainView) {
                var vatView = this.posView.domainView.getDefaultVatView();
                if (vatView) {
                    this.vat = vatView.tax;
                    this.vatCode = vatView.code;
                }
            }
            this.label = loyaltyCardView.label;
            if (loyaltyCardView.styleView) this.color = loyaltyCardView.styleView.background;
            this.type = loyaltyCardView.type;
            this.itemType = loyaltyCardView.itemType;
            this.monthValidity = loyaltyCardView.monthValidity;
            this.validityExtend = loyaltyCardView.validityExtend;
            this.alertExp = loyaltyCardView.alertExp;
            this.originalPrice = loyaltyCardView.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.goalPts = loyaltyCardView.goalPts;
            this.goalType = loyaltyCardView.goalType;
            this.goalAmount = loyaltyCardView.goalAmount;
            this.goalText = loyaltyCardView.goalText;
            this.validityDate = new Date();
            this.validityDate.setHours(0, 0, 0, 0);
            this.validityDate.setMonth(this.validityDate.getMonth() + this.monthValidity);
            if (isOnInternet !== undefined && isOnInternet && loyaltyCardView.hasInternetPrice) {
                this.discountPercent = loyaltyCardView.internetDiscountPercent;
            }
            if ("pts" === loyaltyCardView.type) {
                this.ptsByCa = 1;
                this.ptsBySale = 0;
            } else if ("nbSales" === loyaltyCardView.type) {
                this.ptsByCa = 0;
                this.ptsBySale = 1;
            } else {
                this.ptsByCa = 0;
                this.ptsBySale = 0;
            }
            this.updatePrice();
        }
    };
    LoyaltyCardItemView.prototype.updatePrice = function () {
        var oriPrice = this.originalPrice;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            this.updatePriceHT();
            if (this.saleView) {
                this.saleView.resetPayments();
                this.saleView.calculateSaleFields();
            }
        }
        this.saleView.checkForInvalidAmounts();
    };
    LoyaltyCardItemView.prototype.updatePriceHT = function () {
        if (this.saleView) this.priceHT = Math.round(100 / (100 + this.saleView.vat) * this.price * 100) / 100;
    };
    LoyaltyCardItemView.prototype.updateOriginalPriceInputArrow = function (number) {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") originalPrice += number;

            this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
            this.originalPrice = originalPrice;
            this.updatePrice();
        }
    };

    LoyaltyCardItemView.prototype.onOriginalPriceInputChange = function () {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") {
                this.originalPrice = originalPrice;
            } else {
                this.originalPrice = null;
            }
            this.updatePrice();
        }
    };

    LoyaltyCardItemView.prototype.increaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (step + this.discountPercent > 100) this.discountPercent = 100;else this.discountPercent += step;
            this.updatePrice();
        }
    };
    LoyaltyCardItemView.prototype.decreaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (this.discountPercent - step < 0) this.discountPercent = 0;else this.discountPercent -= step;
            this.updatePrice();
        }
    };
    LoyaltyCardItemView.prototype.updatePercentOnPriceChange = function () {
        this.discountPercent = Math.round(100 * (100 - 100 * this.price / this.originalPrice)) / 100;
        this.updatePriceHT();
        if (this.saleView) {
            this.saleView.resetPayments();
            this.saleView.calculateSaleFields();
        }
    };
    LoyaltyCardItemView.prototype.copyDataTo = function (loyaltyCardItem) {
        //Assume here than the object in parameter contains only id (must load them)
        loyaltyCardItem.label = this.label;
        loyaltyCardItem.color = this.color;
        loyaltyCardItem.type = this.type;
        loyaltyCardItem.itemType = this.itemType;
        loyaltyCardItem.ptsByCa = this.ptsByCa;
        loyaltyCardItem.ptsBySale = this.ptsBySale;
        loyaltyCardItem.pts = this.pts;
        loyaltyCardItem.monthValidity = this.monthValidity;
        loyaltyCardItem.validityExtend = this.validityExtend;
        loyaltyCardItem.validityDate = this.validityDate;
        loyaltyCardItem.alertExp = this.alertExp;
        loyaltyCardItem.description = this.description;
        loyaltyCardItem.price = this.price;
        loyaltyCardItem.vat = this.vat;
        loyaltyCardItem.vatCode = this.vatCode;
        loyaltyCardItem.originalPrice = this.originalPrice;
        loyaltyCardItem.goalPts = this.goalPts;
        loyaltyCardItem.goalType = this.goalType;
        loyaltyCardItem.goalAmount = this.goalAmount;
        loyaltyCardItem.goalText = this.goalText;
        loyaltyCardItem.isUsed = this.isUsed;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            loyaltyCardItem.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            loyaltyCardItem.discountPercent = parseFloat(loyaltyCardItem.discountPercent);
        } else loyaltyCardItem.discountPercent = this.discountPercent;

        if (this.saleView) {
            var newSale = this.saleView.getModel();
            if (loyaltyCardItem.sale && newSale !== loyaltyCardItem.sale) //remove
                loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
            if (newSale) //Force add because removed by sale.updateModel
                newSale.addLoyaltyCardItem(loyaltyCardItem);
            this.customerView = this.saleView.customerView;
        }

        if (this.loyaltyCardView) loyaltyCardItem.loyaltyCard = this.loyaltyCardView.getModel();

        if (this.customerView) loyaltyCardItem.customer = this.customerView.getModel();

        if (this.hrView) loyaltyCardItem.humanResource = this.hrView.getModel();
    };
    LoyaltyCardItemView.prototype.toggleUsage = function (callbackFunction) {
        this.isUsed = !this.isUsed;
        this.updateModel(true, callbackFunction);
        if (this.customerView) this.customerView.initHistoryView();
    };

    LoyaltyCardItemView.prototype.updateModel = function (save, callbackFunction) {
        var loyaltyCardItem = this.getModel();
        if (loyaltyCardItem == null) {
            loyaltyCardItem = new LoyaltyCardItem();
            this.lIndex = LoyaltyCardItemData.getIndexOf(loyaltyCardItem);
        }

        this.copyDataTo(loyaltyCardItem);
        if (save) {
            LoyaltyCardItemSrv.save(loyaltyCardItem, callbackFunction);
        }
    };

    LoyaltyCardItemView.prototype.removeModel = function () {
        var loyaltyCardItem = this.getModel();
        if (loyaltyCardItem != null) {
            LoyaltyCardItemSrv.remove(loyaltyCardItem);
        }
    };

    LoyaltyCardItemView.prototype.reloadModel = function () {
        var loyaltyCardItem = this.getModel();
        if (loyaltyCardItem == null) {} else {
            this.loadDataFrom(loyaltyCardItem);
        }
    };

    LoyaltyCardItemView.prototype.restoreModel = function () {
        //undeleted
        var loyaltyCardItem = this.getModel();
        if (loyaltyCardItem) {
            LoyaltyCardItemSrv.restore(loyaltyCardItem);
        }
    };

    LoyaltyCardItemView.prototype.updateCanSave = function () {
        if (this.label && this.label != "" && //titre
        this.price != null && this.price >= 0) {
            this.canSave = true;
        } else {
            this.canSave = false;
        }
    };

    LoyaltyCardItemView.prototype.onValidityDateStringUpdate = function () //
    {
        if (this.validityDateString && this.validityDateString.length == 10) {
            var year = this.validityDateString.substring(6, 10);
            var month = this.validityDateString.substring(3, 5);
            var day = this.validityDateString.substring(0, 2);
            this.validityDate = new Date(year + '/' + month + '/' + day);
            this.validityDate.setHours(0, 0, 0, 0);
        } else this.validityDate = null;
    };

    LoyaltyCardItemView.prototype.updateValidityDateString = function () {
        if (this.validityDate) this.validityDateString = $filter('date')(this.validityDate, 'shortDate');
    };

    LoyaltyCardItemView.prototype.getValidityDateFromNow = function () {

        if (this.validityExtend) {
            var newV = new Date();
            if (this.validityDate) this.validityDate.setHours(0, 0, 0, 0);
            newV.setMonth(newV.getMonth() + this.monthValidity);
            return newV;
        } else return this.validityDate;
    };

    LoyaltyCardItemView.prototype.onValidityDateStringKeyup = function (event) //
    {
        if (this.validityDateString) if (!(event && (event.which == 8 || event.which == 46))) //if key delete detected : clear supplier
            {
                if ((this.validityDateString.length == 4 || this.validityDateString.length == 7) && this.validityDateString[this.validityDateString.length - 1] == '/') this.validityDateString = this.validityDateString.substr(0, this.validityDateString.length - 2);

                if (this.validityDateString.length == 2 || this.validityDateString.length == 5) this.validityDateString += "/";
            }
    };

    LoyaltyCardItemView.prototype.displayLoyaltyCardItemDatePickerF = function () {
        var loyaltycarditemView = this;
        $timeout(function () {
            loyaltycarditemView.validityDatePickerOpened = true;
        });
    };

    LoyaltyCardItemView.prototype.setHrView = function (hrView) {
        this.hrView = hrView;
    };

    LoyaltyCardItemView.prototype.getClone = function (saleView) {
        var loyaltyCardItemView = new LoyaltyCardItemView(null, -1, this.billPosition, saleView);
        loyaltyCardItemView.vatCode = this.vatCode;
        loyaltyCardItemView.vat = this.vat;
        loyaltyCardItemView.label = this.label;
        loyaltyCardItemView.color = this.color;
        loyaltyCardItemView.type = this.type;
        loyaltyCardItemView.itemType = this.itemType;
        loyaltyCardItemView.ptsByCa = this.ptsByCa;
        loyaltyCardItemView.ptsBySale = this.ptsBySale;
        loyaltyCardItemView.pts = this.pts;
        loyaltyCardItemView.monthValidity = this.monthValidity;
        loyaltyCardItemView.validityExtend = this.validityExtend;
        loyaltyCardItemView.validityDate = this.validityDate;
        loyaltyCardItemView.alertExp = this.alertExp;
        loyaltyCardItemView.description = this.description;
        loyaltyCardItemView.price = this.price;
        loyaltyCardItemView.originalPrice = this.originalPrice;
        loyaltyCardItemView.goalPts = this.goalPts;
        loyaltyCardItemView.goalType = this.goalType;
        loyaltyCardItemView.goalAmount = this.goalAmount;
        loyaltyCardItemView.goalText = this.goalText;
        loyaltyCardItemView.isUsed = this.isUsed;
        loyaltyCardItemView.discountPercent = this.discountPercent;
        loyaltyCardItemView.loyaltyCardView = this.loyaltyCardView;
        loyaltyCardItemView.customerView = this.customerView;
        loyaltyCardItemView.hrView = this.hrView;
        return loyaltyCardItemView;
    };

    LoyaltyCardItemView.prototype.updateLinkedSalesView = function () {
        var loyaltyCardItem = this.getModel();
        this.linkedSalesView = [];
        if (loyaltyCardItem) {
            var balance = 0;
            this.totalLoyaltyPtsWon = 0;
            this.totalLoyaltyPtsUse = 0;
            var linkedSales = [];

            for (var i = 0; i < SaleData.indexSales.length; i++) {
                if (loyaltyCardItem === SaleData.indexSales[i].loyaltyCardItem && SaleData.indexSales[i].status == "sold") linkedSales.push(SaleData.indexSales[i]);
            }linkedSales = $filter('orderBy')(linkedSales, 'saleNumber'); //execute angular filter
            for (var i = 0; i < linkedSales.length; i++) {
                balance += linkedSales[i].loyaltyPts;
                var linkedSaleView = {
                    saleNumber: linkedSales[i].saleNumber,
                    discountPercent: linkedSales[i].discountPercent,
                    loyaltyPtsBalance: balance,
                    goalAmount: linkedSales[i].loyaltyCardItem.goalAmount,
                    goalType: linkedSales[i].loyaltyCardItem.goalType,
                    goalText: linkedSales[i].loyaltyCardItem.goalText,
                    dayView: { date: linkedSales[i].day ? linkedSales[i].day.getDate() : null } };

                if (linkedSales[i].loyaltyPts >= 0) {
                    linkedSaleView.loyaltyPtsWon = linkedSales[i].loyaltyPts;
                    linkedSaleView.loyaltyPtsUse = 0;
                    this.totalLoyaltyPtsWon += linkedSales[i].loyaltyPts;
                } else {
                    linkedSaleView.loyaltyPtsUse = linkedSales[i].loyaltyPts;
                    linkedSaleView.loyaltyPtsWon = 0;
                    this.totalLoyaltyPtsUse += linkedSales[i].loyaltyPts;
                }
                this.linkedSalesView.push(linkedSaleView);
            }
        }
    };

    LoyaltyCardItemView.prototype.getDiscountToolTipContent = function () {
        if (this.goalType === "discountValue") this.discountTypeSymbol = CurrencyManager.getCurrencySymbol();else if (this.goalType === "special") return this.goalText;
        return this.discountTypeText + " " + this.goalAmount + " " + this.discountTypeSymbol + " " + this.nextRewardsText;
    };

    LoyaltyCardItemView.prototype.getGoalPoints = function () {
        if (this.nbLoyaltyCardGoal() > 0) return this.goalPts;else return 0;
    };

    LoyaltyCardItemView.prototype.getGoalAmount = function (nbLoyaltyCardGoal) {
        if (this.goalType === "discountValue") return this.goalAmount * nbLoyaltyCardGoal;else return this.goalAmount;
    };

    LoyaltyCardItemView.prototype.computeLoyaltyDiscount = function (loyaltyPoints) {
        if (this.goalType === "discountValue") return Math.abs(loyaltyPoints / this.goalPts) * this.goalAmount;else return this.goalAmount;
    };

    LoyaltyCardItemView.prototype.getNextGoalAmount = function (newPts) {
        if (this.goalType === "discountValue") {
            if (Math.floor((this.pts + newPts) / this.goalPts) >= 1) {
                return this.goalAmount; //add next points
            } else {
                return 0;
            }
        } else return this.goalAmount;
    };

    LoyaltyCardItemView.prototype.computeGoalAmountNextSale = function () {
        return this.pts >= this.goalPts ? this.goalAmount : 0;
    };

    LoyaltyCardItemView.prototype.nbLoyaltyCardGoal = function (salePrice, salePoints, hasLoyaltyCardInShoppingCart) {
        var nbLoyaltyCardGoal = 0;
        if (this.type === "subs") {
            nbLoyaltyCardGoal = hasLoyaltyCardInShoppingCart ? 0 : 1;
        } else {
            if (this.goalType === "discountValue" && salePrice !== undefined) // limited by salePrice if salePrice==0 || salePrice defined
                {
                    var points = salePoints;
                    if (!points) {
                        points = this.pts;
                    }
                    if (points > 0 && this.goalPts > 0) {
                        if (points >= this.goalPts && salePrice - this.getGoalAmount(nbLoyaltyCardGoal + 1) >= 0) {
                            nbLoyaltyCardGoal = 1;
                        }
                    }
                } else // discountPercent OR Next possible
                {
                    nbLoyaltyCardGoal = Math.floor(this.pts / this.goalPts) >= 1 ? 1 : 0;
                }
        }
        return nbLoyaltyCardGoal;
    };

    return LoyaltyCardItemView;
}]);

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardView', ["$sce", "LoyaltyCardData", "LoyaltyCardSrv", "LoyaltyCard", "SupplierView", "$filter", "StyleColor", "CurrencyManager", function ($sce, LoyaltyCardData, LoyaltyCardSrv, LoyaltyCard, SupplierView, $filter, StyleColor, CurrencyManager) {

    var LoyaltyCardView = function LoyaltyCardView(loyaltyCard, cIndex, parentCategoryView, domainView) {
        this.cIndex = cIndex;
        this.domainView = domainView;
        this.label = "";
        this.globalType = "subs"; // subs / pts (view only)
        this.type = "subs"; // nbSales / pts /subs
        this.itemType = null;
        this.categoryType = "loyaltyCard";
        this.categoryTypeSortOrder = 3;
        this.monthValidity = 6;
        this.alertExp = 2;
        this.isAlertExp = false;
        this.description = "";
        this.descriptionHtml = "";
        this.price = 0;
        this.priceInput = $filter("currencyFormatFilter")(0);
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.isBuyableOnWebSite = false;
        this.goalPts = 1;
        this.goalType = "discountPercent"; // discountPercent //discountValue
        this.goalAmount = 10;
        this.goalAmountInput = "10,00";
        this.goalText = null;
        //for views
        this.isSelected = false;
        this.isSmsSelected = false;
        this.isNotificationSelected = false;
        this.canSave = false;
        this.styleView = {}; //styleView is an object and category.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.mouseHover = false;
        this.form = {
            displayError: true,
            displayErrorPrice: false,
            displayErrorGoalAmount: false,
            displayErrorGoalPts: false
        };

        if (parentCategoryView !== undefined && parentCategoryView != null) {
            this.parentCategoryView = parentCategoryView;
        }
        if (loyaltyCard !== undefined && loyaltyCard != null) {
            this.loadDataFrom(loyaltyCard);
        } else {
            this.onChangeType();
        }
    };

    LoyaltyCardView.prototype.getModel = function () {
        if (this.cIndex != -1) {
            return LoyaltyCardData.getByIndex(this.cIndex);
        }
        return null;
    };

    LoyaltyCardView.prototype.loadDataFrom = function (loyaltyCard) {
        //Assume here than the object in parameter contains only id (must load them)
        this.label = loyaltyCard.label;
        this.type = loyaltyCard.type;
        this.itemType = loyaltyCard.itemType;
        if (this.type != "subs") {
            this.globalType = "pts";
        }
        this.monthValidity = loyaltyCard.monthValidity;
        this.alertExp = loyaltyCard.alertExp;
        this.isAlertExp = this.alertExp != 0;
        this.description = loyaltyCard.description;
        this.goalPts = loyaltyCard.goalPts;
        this.goalType = loyaltyCard.goalType;
        this.goalAmount = loyaltyCard.goalAmount;
        this.goalAmountInput = $filter('number')(this.goalAmount, 2);
        this.goalText = loyaltyCard.goalText;

        if (this.description) {
            this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));
        }

        this.price = loyaltyCard.price;
        this.priceInput = $filter('currencyFormatFilter')(this.price);

        this.isVisibleOnWebSite = loyaltyCard.isVisibleOnWebSite;
        this.isBuyableOnWebSite = loyaltyCard.isBuyableOnWebSite;

        this.specificImage = loyaltyCard.specificImage;
        this.image = loyaltyCard.image;
        this.companyImage = loyaltyCard.companyImage;
        if (this.image || this.companyImage) {
            //for ascendencing compatibility
            this.specificImage = true;
        }

        if (this.parentCategoryView && this.image == null && this.specificImage == false) {
            this.image = this.parentCategoryView.image;
        }

        if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) {
            this.companyImage = this.parentCategoryView.companyImage;
        }

        if (this.companyImage) {
            this.imageDisplayed = this.companyImage;
        } else {
            this.imageDisplayed = this.image;
        }

        if (loyaltyCard.style) {
            try {
                this.styleView = angular.fromJson(loyaltyCard.style);
                if (this.styleView) this.colorPicker = this.styleView.background;
            } catch (ex) {
                console.log("Error loading style");
            }
        }

        this.updateCanSave();
    };

    LoyaltyCardView.prototype.updatePriceInputArrow = function (number) {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price)) {
                this.form.displayErrorPrice = true;
            } else {
                price += number;
                price = price < 0 ? 0 : price;
                this.form.displayErrorPrice = false;
            }
            this.priceInput = $filter('currencyFormatFilter')(price);
            this.onPriceInputChange();
        }
    };

    LoyaltyCardView.prototype.onPriceInputChange = function () {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price) || price < 0) {
                this.price = 0;
                this.isBuyableOnWebSite = false;
                this.form.displayErrorPrice = true;
            } else if (price === 0) {
                this.price = 0;
                this.isBuyableOnWebSite = false;
                this.form.displayErrorPrice = false;
            } else {
                this.price = price;
                this.form.displayErrorPrice = false;
            }
        }
        this.updateCanSave();
    };

    LoyaltyCardView.prototype.updateGoalPtsInputArrow = function (number) {
        if (this.goalPts != null) {
            if (typeof this.goalPts === 'string') {
                var goalPtsStr = CurrencyManager.getPriceFromPriceInput(this.goalPts);
                var goalPts = parseInt(goalPtsStr);
                if (isNaN(goalPts)) {
                    this.form.displayErrorGoalPts = true;
                } else {
                    goalPts += number;
                }
                this.goalPts = $filter('number')(goalPts, 0);
            } else if (typeof this.goalPts === 'number') {
                this.goalPts += number;
            }
            this.onGoalPtsInputChange();
        }
    };

    LoyaltyCardView.prototype.onGoalPtsInputChange = function () {
        this.form.displayErrorGoalPts = isNaN(this.goalPts) || this.goalPts < 1 || this.goalPts > 700;
        this.updateCanSave();
    };

    LoyaltyCardView.prototype.updateGoalAmountInputArrow = function (number) {
        if (this.goalAmountInput != null && typeof this.goalAmountInput === 'string') {
            var goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.goalAmountInput);
            var goalAmount = parseFloat(goalAmountStr);
            if (isNaN(goalAmount)) {
                this.form.displayErrorGoalAmount = true;
            } else {
                goalAmount += number;
            }
            this.goalAmountInput = $filter('number')(goalAmount, 2);
            this.onGoalAmountInputChange();
        }
    };

    LoyaltyCardView.prototype.onGoalAmountInputChange = function () {
        if (this.goalAmountInput != null && typeof this.goalAmountInput === 'string') {
            var goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.goalAmountInput);
            var goalAmount = parseFloat(goalAmountStr);
            if (isNaN(goalAmount)) {
                this.form.displayErrorGoalAmount = true;
                this.goalAmount = null;
            } else if (goalAmount < 0) {
                this.form.displayErrorGoalAmount = true;
            } else if (goalAmount > 100 && this.goalType === 'discountPercent') {
                this.form.displayErrorGoalAmount = true;
            } else {
                this.form.displayErrorGoalAmount = false;
                this.goalAmount = goalAmount;
            }
        }
        this.updateCanSave();
    };

    LoyaltyCardView.prototype.onMonthValidityChange = function () {
        if (this.monthValidity != null && typeof this.monthValidity === 'string') {
            var goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.monthValidity);
            this.monthValidity = parseInt(goalAmountStr);
        }
        if (isNaN(this.monthValidity)) {
            this.form.displayErrorMonthValidity = true;
        } else {
            this.form.displayErrorMonthValidity = this.monthValidity <= 0;
        }
        this.updateCanSave();
    };

    LoyaltyCardView.prototype.onIsAlertExpChange = function () {
        if (this.isAlertExp) this.alertExp = 2;else this.alertExp = 0;
    };

    LoyaltyCardView.prototype.onAlertExpChange = function () {
        if (this.alertExp != null && typeof this.alertExp === 'string') {
            var goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.alertExp);
            this.alertExp = parseInt(goalAmountStr);
        }
        if (this.alertExp == 0) {
            this.isAlertExp = false;
        }
    };

    LoyaltyCardView.prototype.isChanged = function () {
        //TODO
        var loyaltyCard = this.getModel();
        if (loyaltyCard) {
            var image = loyaltyCard.image;
            if (image == null && loyaltyCard.parentCategory && loyaltyCard.specificImage == false) image = loyaltyCard.parentCategory.image;
            var companyImage = loyaltyCard.companyImage;
            if (companyImage == null && loyaltyCard.parentCategory && loyaltyCard.specificImage == false) companyImage = loyaltyCard.parentCategory.companyImage;

            return this.label != loyaltyCard.label || this.type != loyaltyCard.type || this.itemType != loyaltyCard.itemType || this.goalType != loyaltyCard.goalType || this.description != loyaltyCard.description || this.price != loyaltyCard.price || this.specificImage != loyaltyCard.specificImage || this.image !== image || this.companyImage !== companyImage;
        } else return true;
    };

    LoyaltyCardView.prototype.setImage = function (image) {
        this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    LoyaltyCardView.prototype.setCompanyImage = function (companyImage) {
        this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    LoyaltyCardView.prototype.copyDataTo = function (loyaltyCard) {
        //Assume here than the object in parameter contains only id (must load them)
        loyaltyCard.label = this.label;
        loyaltyCard.type = this.type;
        loyaltyCard.itemType = this.itemType;
        loyaltyCard.monthValidity = this.monthValidity;
        loyaltyCard.alertExp = this.alertExp;
        loyaltyCard.description = this.description;
        loyaltyCard.price = this.price;
        loyaltyCard.image = this.image;
        loyaltyCard.companyImage = this.companyImage;
        loyaltyCard.specificImage = this.specificImage;
        loyaltyCard.isVisibleOnWebSite = this.isVisibleOnWebSite;
        if (this.price < 0 && this.isBuyableOnWebSite) {
            loyaltyCard.isBuyableOnWebSite = false;
            this.isBuyableOnWebSite = false;
        } else {
            loyaltyCard.isBuyableOnWebSite = this.isBuyableOnWebSite;
        }

        if (this.goalPts <= 0 && this.type !== "subs") {
            loyaltyCard.goalPts = 300;
            this.goalPts = 300;
        } else {
            loyaltyCard.goalPts = this.goalPts;
        }

        loyaltyCard.goalType = this.goalType;
        loyaltyCard.goalAmount = this.goalAmount;
        loyaltyCard.goalText = this.goalText;

        if (this.styleView) loyaltyCard.style = angular.toJson(this.styleView);else loyaltyCard.style = null;
    };

    LoyaltyCardView.prototype.onSpecificImageChange = function () {
        if (!this.specificImage) {
            this.image = null;
            this.companyImage = null;
        }
    };

    LoyaltyCardView.prototype.updateModel = function () {
        var loyaltyCard = this.getModel();
        if (loyaltyCard == null) {
            loyaltyCard = new LoyaltyCard();
            this.cIndex = LoyaltyCardData.getIndexOf(loyaltyCard);
        }

        if (!this.specificImage && this.parentCategoryView !== undefined && this.parentCategoryView.label !== "Racine") {
            this.image = this.parentCategoryView.image;
            loyaltyCard.image = this.image;
        }

        this.copyDataTo(loyaltyCard);

        var category = this.parentCategoryView.getModel();
        if (category && category !== loyaltyCard.parentCategory) {
            // change of category
            if (loyaltyCard.parentCategory) loyaltyCard.parentCategory.removeLoyaltyCard(loyaltyCard);
            category.addLoyaltyCard(loyaltyCard);
        }
        LoyaltyCardSrv.save(loyaltyCard);
    };

    LoyaltyCardView.prototype.removeModel = function () {
        var loyaltyCard = this.getModel();
        if (loyaltyCard != null) {
            loyaltyCard.parentCategory.removeLoyaltyCard(loyaltyCard);
            LoyaltyCardSrv.remove(loyaltyCard);
        }
    };

    LoyaltyCardView.prototype.reloadModel = function () {
        var loyaltyCard = this.getModel();
        if (loyaltyCard == null) {
            this.parentCategoryView.removeLoyaltyCardView(this);
        } else {
            this.loadDataFrom(loyaltyCard);
        }
    };

    LoyaltyCardView.prototype.restoreModel = function () {
        //undeleted
        var loyaltyCard = this.getModel();
        if (loyaltyCard) {
            if (loyaltyCard.parentCategory) loyaltyCard.parentCategory.addLoyaltyCard(loyaltyCard);
            LoyaltyCardSrv.restore(loyaltyCard);
        }
    };

    LoyaltyCardView.prototype.updateCanSave = function () {
        if (this.label && this.label != "" && //titre
        !this.form.displayErrorPrice && !this.form.displayErrorGoalAmount && !this.form.displayErrorGoalPts) {
            this.canSave = true;
        } else {
            this.canSave = false;
        }
    };

    LoyaltyCardView.prototype.search = function (searchedTextLC) {
        if (searchedTextLC && this.label.toLowerCase().indexOf(searchedTextLC) != -1 || this.image && this.image.keyWords.indexOf(searchedTextLC) != -1) {
            return true;
        }
        return false;
    };

    LoyaltyCardView.prototype.onChangeType = function () {
        if (this.type == "subs") {
            this.goalPts = 0;
            this.goalType = "discountPercent";
            this.goalAmount = 10;
        } else if (this.type == "nbSales") {
            this.goalPts = 10;
            this.goalType = "discountPercent";
            this.goalAmount = 10;
        } else {
            this.goalPts = 300;
            this.goalAmount = 30;
            this.goalType = "discountValue";
        }
        this.goalAmountInput = $filter('number')(this.goalAmount, 2);
    };

    LoyaltyCardView.prototype.onStyleViewChange = function () {
        if (!this.styleView || this.styleView.color != this.colorPicker) {
            if (!this.styleView) {
                this.styleView = {};
            }

            this.styleView.color = StyleColor.getContrastYIQ(this.colorPicker);
            this.styleView.background = this.colorPicker;
        }
    };

    return LoyaltyCardView;
}]);

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('PaymentView', ["$timeout", "GiftItemData", "CheckDepositData", function ($timeout, GiftItemData, CheckDepositData) {

    var PaymentView = function PaymentView(payment, saleView) {
        this.type = null; //check enum in ConstantsSalePaymentType.js
        this.price = null;
        this.date = null;
        this.check = false;
        this.datePickerOpened = false;
        this.giftItemView = null;
        this.canChange = true;
        this.canDelete = true;
        this.saleView = saleView;
        this.cdIndex = -1; //checkDeposit index
        this.otherPaymentTypeView = null;
        if (payment !== undefined && payment != null) {
            this.type = payment.type;
            this.price = payment.price;
            this.check = payment.check;

            this.date = typeof payment.date === "number" ? new Date(payment.date) : payment.date;
            if (this.date) {
                var currentTime = new Date();
                this.date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
            }

            if (payment.otherPaymentType && this.saleView && this.saleView.posView) this.otherPaymentTypeView = this.saleView.posView.domainView.getOtherPaymentTypeView(payment.otherPaymentType);
            if (this.saleView) {
                this.canChange = this.saleView.status == "created" || this.saleView.status == "waiting" || this.type != "CBONLINE";
                this.canDelete = this.saleView.status == "created" || this.saleView.status == "waiting" || (this.saleView.status == "sold" || this.saleView.status == "advance") && this.canChange && this.type != "GIFT";
            }
            if (payment.checkDeposit) this.cdIndex = CheckDepositData.getIndexOf(payment.checkDeposit);
        }
    };
    PaymentView.prototype.getClone = function (saleView) {
        var paymentView = new PaymentView(saleView);
        paymentView.type = this.type;
        paymentView.price = this.price;
        paymentView.date = this.date;
        paymentView.giftItemView = this.giftItemView;
        paymentView.otherPaymentTypeView = this.otherPaymentTypeView;
        paymentView.cdIndex = this.cdIndex;
        return paymentView;
    };
    PaymentView.prototype.init = function (type, price, date, otherPaymentTypeView) {
        this.type = type;
        this.price = price;

        if (date !== undefined && date) this.date = date;else if (this.saleView && this.saleView.dayView) {
            this.date = new Date(this.saleView.dayView.date);
            var currentTime = new Date();
            this.date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

            var today = new Date();
            if (today.getTime() < this.date.getTime()) //use ticket date only if the ticket date is in the past.
                this.date = today;
        } else {
            this.date = new Date();
        }
        this.otherPaymentTypeView = otherPaymentTypeView;
        this.canChange = this.type != "CBONLINE";
        this.canDelete = this.canChange;
    };
    PaymentView.prototype.copyDataTo = function (payment) {
        payment.type = this.type;
        payment.price = this.price;
        payment.date = this.date;
        payment.check = this.check;;
        if (this.giftItemView) payment.giftItem = GiftItemData.getByIndex(this.giftItemView.giIndex);else payment.giftItem = null;
        if (this.otherPaymentTypeView) payment.otherPaymentType = this.otherPaymentTypeView.getModel();else payment.otherPaymentType = null;
        payment.checkDeposit = CheckDepositData.getByIndex(this.cdIndex);;
        return payment;
    };
    PaymentView.prototype.displayStartDatePickerF = function (open) {
        if (open) {
            var payment = this;
            $timeout(function () {
                payment.datePickerOpened = true;
            });
        }
    };
    return PaymentView;
}]);

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:51
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('PhysicalResourceView', ["PhysicalResourceData", "PhysicalResourceSrv", "PhysicalResource", function (PhysicalResourceData, PhysicalResourceSrv, PhysicalResource) {

    var PhysicalResourceView = function PhysicalResourceView(physicalResource, prIndex, domainView, order) {
        this.prIndex = prIndex;
        this.domainView = domainView;
        this.label = null;
        this.number = 1;
        this.hasPlanning = true;
        this.onLineBooking = true;
        this.order = null;

        this.display = true;

        if (physicalResource) {
            this.loadDataFrom(physicalResource);
        }

        if (order != undefined && order != null) {
            this.order = order;
        }
    };

    PhysicalResourceView.prototype.loadDataFrom = function (physicalResource) {
        if (physicalResource.id) {
            this.id = physicalResource.id;
        }
        this.label = physicalResource.label;
        this.number = physicalResource.number;
        this.hasPlanning = physicalResource.hasPlanning;
        this.onLineBooking = physicalResource.onLineBooking;
        this.order = physicalResource.order;
    };

    PhysicalResourceView.prototype.copyDataTo = function (physicalResource) {
        physicalResource.label = this.label;
        physicalResource.number = this.number;
        physicalResource.hasPlanning = this.hasPlanning;
        physicalResource.onLineBooking = this.onLineBooking;
        physicalResource.order = this.order;
    };

    PhysicalResourceView.prototype.isChanged = function () {
        var pr = this.getModel();
        if (pr) {
            return this.label != pr.label || this.number != pr.number || this.hasPlanning != pr.hasPlanning || this.onLineBooking != pr.onLineBooking || this.order != pr.order;
        } else {
            return true;
        }
    };

    PhysicalResourceView.prototype.getModel = function () {
        if (this.prIndex != -1) return PhysicalResourceData.getByIndex(this.prIndex);
        return null;
    };

    PhysicalResourceView.prototype.initPrData = function () {
        var physicalResource = this.getModel();
        if (physicalResource == null) {
            physicalResource = new PhysicalResource();
            this.prIndex = PhysicalResourceData.getIndexOf(physicalResource);
        }
        this.copyDataTo(physicalResource);
        return physicalResource;
    };

    PhysicalResourceView.prototype.updateModel = function () {
        if (!this.isChanged()) {
            var physicalResource = this.initPrData();
            PhysicalResourceSrv.save(physicalResource);
        }
    };

    PhysicalResourceView.prototype.updateModelWithPromise = function () {
        var physicalResourceView = this;
        return new Promise(function (resolve, reject) {
            if (!physicalResourceView.isChanged()) {
                return resolve();
            }
            var physicalResource = physicalResourceView.initPrData();
            PhysicalResourceSrv.save(physicalResource, resolve, reject);
        });
    };

    PhysicalResourceView.prototype.reloadModel = function () {
        var pr = this.getModel();
        if (pr != null) this.loadDataFrom(pr);
    };
    PhysicalResourceView.prototype.removeModel = function () {
        var pr = this.getModel();
        if (pr != null) PhysicalResourceSrv.remove(pr);
    };
    PhysicalResourceView.prototype.restoreModel = function () {
        var pr = this.getModel();
        if (pr) PhysicalResourceSrv.restore(pr);
    };
    PhysicalResourceView.prototype.knowsServiceView = function (serviceView) {
        if (serviceView) {
            var pr = this.getModel();
            if (pr) return pr.hasService(serviceView.getModel());
        }
        return false;
    };
    PhysicalResourceView.prototype.canSave = function () {
        return this.number && this.number > 0 && this.label && this.label != "";
    };

    return PhysicalResourceView;
}]);

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ProductCategoryView', ["$log", "ProductView", "ProductCategoryData", "ProductData", "ProductCategory", "ProductCategorySrv", "ProductSrv", "StyleColor", "ItemCategoryView", function ($log, ProductView, ProductCategoryData, ProductData, ProductCategory, ProductCategorySrv, ProductSrv, StyleColor, ItemCategoryView) {

    var ProductCategoryView = function ProductCategoryView(category, catIndex, parentCategoryView, domainView) {
        ItemCategoryView.call(this);

        this.catIndex = catIndex;
        this.domainView = domainView;
        this.label = "";
        this.description = "";
        this.productsView = [];
        this.categoriesView = [];
        this.image = null;
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.styleView = {}; //styleView is an object and category.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.parentCategoryView = null;
        this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
        this.selectedProductView = null;
        this.displayType = "array"; // only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
        this.displayProductImages = true; // only on view if children images are different than son

        if (parentCategoryView !== undefined && parentCategoryView != null) this.parentCategoryView = parentCategoryView;

        this.styleView = this.getStyleFrom(category);
        if (this.styleView) this.colorPicker = this.styleView.background;

        if (category !== undefined && category != null) {
            var productView;
            this.loadDataFrom(category);
            for (var i = 0; i < category.categories.length; i++) {
                this.categoriesView.push(new ProductCategoryView(category.categories[i], ProductCategoryData.getIndexOf(category.categories[i]), this, domainView));
            }for (var j = 0; j < category.products.length; j++) {
                productView = new ProductView(category.products[j], ProductData.getIndexOf(category.products[j]), this, domainView);
                this.productsView.push(productView);
                if (this.domainView && this.domainView.addProductViewIndex !== undefined) this.domainView.addProductViewIndex(productView);
            }
        }
    };

    ProductCategoryView.prototype = Object.create(ItemCategoryView.prototype); //inherit functions from ItemCategoryView

    ProductCategoryView.prototype.setImage = function (image) {
        for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].image == null && !this.productsView[j].specificImage) //if same than previous change
                this.productsView[j].setImage(image);
        }this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    ProductCategoryView.prototype.setCompanyImage = function (companyImage) {
        for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].companyImage == null && !this.productsView[j].specificImage) //if same than previous change
                this.productsView[j].setImage(companyImage);
        }this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    ProductCategoryView.prototype.getCategoryView = function (category) {
        var categoryView = null;
        if (this.getModel() === category) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryView(category);
        }return categoryView;
    };
    ProductCategoryView.prototype.getCategoryViewByLabel = function (label) {
        var categoryView = null;
        if (this.label == label) return this;
        for (var i = 0; i < this.categoriesView.length && categoryView == null; i++) {
            categoryView = this.categoriesView[i].getCategoryViewByLabel(label);
        }return categoryView;
    };
    ProductCategoryView.prototype.getProductView = function (product) {
        var productView = null;
        for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].getModel() === product) return this.productsView[j];
        }for (var z = 0; z < this.categoriesView.length && !productView; z++) {
            productView = this.categoriesView[z].getProductView(product);
        }return productView;
    };
    ProductCategoryView.prototype.getProductViewById = function (id) {
        var product;
        for (var j = 0; j < this.productsView.length; j++) {
            product = this.productsView[j].getModel();
            if (product && product.id == id) return this.productsView[j];
        }
        var productView = null;
        for (var z = 0; z < this.categoriesView.length && !productView; z++) {
            productView = this.categoriesView[z].getProductViewById(id);
        }return productView;
    };

    ProductCategoryView.prototype.getCategoryViewById = function (id) {
        var categoryView = null;
        var category = this.getModel();
        if (category && category.id == id) return this;
        for (var z = 0; z < this.categoriesView.length && !categoryView; z++) {
            categoryView = this.categoriesView[z].getCategoryViewById(id);
        }return categoryView;
    };

    ProductCategoryView.prototype.getAllProductsView = function (product) {
        var lProductsView = this.productsView.slice(0);

        var array;
        for (var z = 0; z < this.categoriesView.length; z++) {
            array = this.categoriesView[z].getAllProductsView();
            if (array) for (var j = 0; j < array.length; j++) {
                lProductsView.push(array[j]);
            }
        }

        return lProductsView;
    };
    ProductCategoryView.prototype.populateHomeItemsView = function (homeItemsView) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateHomeItemsView(homeItemsView);
        }for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].isOnHome) homeItemsView.push({ type: 'product', item: this.productsView[j], active: false });
        }
    };

    ProductCategoryView.prototype.getProductViewByCodeOrLabel = function (code) {
        var productsView = [];
        for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].code == code || this.productsView[j].label && this.productsView[j].label.toLowerCase().indexOf(code) != -1) productsView.push(this.productsView[j]);
        }for (var z = 0; z < this.categoriesView.length; z++) {
            productsView = productsView.concat(this.categoriesView[z].getProductViewByCodeOrLabel(code));
        }return productsView;
    };

    ProductCategoryView.prototype.getProductViewByReference = function (reference) {
        var productsView = [];
        for (var j = 0; j < this.productsView.length; j++) {
            if (this.productsView[j].reference == reference) productsView.push(this.productsView[j]);
        }for (var z = 0; z < this.categoriesView.length; z++) {
            productsView = productsView.concat(this.categoriesView[z].getProductViewByReference(reference));
        }return productsView;
    };

    ProductCategoryView.prototype.copyDataTo = function (category) {
        //Assume here than the object in parameter contains only id (must load them)
        category.label = this.label;
        category.description = this.description;
        if (this.parentCategoryView && this.styleView === this.parentCategoryView.styleView) // if is specific set it
            category.style = null;else category.style = angular.toJson(this.styleView);
        category.image = this.image;
        category.companyImage = this.companyImage;
        category.specificImage = this.specificImage;
        category.isVisibleOnWebSite = this.isVisibleOnWebSite;
    };
    ProductCategoryView.prototype.loadDataFrom = function (category) {
        this.label = category.label;
        this.description = category.description;
        this.image = category.image;
        this.companyImage = category.companyImage;
        this.specificImage = category.specificImage;
        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;
        this.isVisibleOnWebSite = category.isVisibleOnWebSite;
    };
    ProductCategoryView.prototype.onStyleViewChange = function () {
        var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
        if (!this.styleView || this.styleView.background != this.colorPicker) {
            if (!this.styleView || //if undefined
            this.parentCategoryView && this.parentCategoryView.styleView === this.styleView) // if same than parent : break inheritance
                this.styleView = {};
            this.styleView.background = this.colorPicker;
            this.styleView.color = fontColor;
            this.updateStyleView();
        }
    };
    ProductCategoryView.prototype.updateStyleView = function (styleView) {
        for (var j = 0; j < this.categoriesView.length; j++) {
            if (this.categoriesView[j].styleView == null) //if same than previous change
                this.categoriesView[j].updateStyleView(styleView);
        }
    };
    ProductCategoryView.prototype.getStyleFrom = function (category) {
        var styleView = null;
        if (category) if (category.style && category.style.indexOf('{') != 0) //Previous type before 1.5 was not contains a jsonSTring
            styleView = null;else try {
            styleView = angular.fromJson(category.style);
        } catch (ex) {
            console.log("Error loading style");
        }
        if (!styleView) if (this.parentCategoryView != null) styleView = this.parentCategoryView.styleView;
        return styleView;
    };
    ProductCategoryView.prototype.isChanged = function () {
        var category = this.getModel();
        if (category) {
            /*var image = category.image;
            if ((image==null||image=="") &&this.parentCategoryView)
                image = this.parentCategoryView.image;*/
            var styleView = this.getStyleFrom(category);
            var styleChanged = this.styleView && !styleView || !this.styleView && styleView || this.styleView && styleView && this.styleView.background != styleView.background;
            return this.label != category.label || this.description != category.description || styleChanged || this.image != category.image || this.companyImage != category.companyImage;
        } else return true;
    };
    ProductCategoryView.prototype.getModel = function () {
        if (this.catIndex != -1) return ProductCategoryData.getByIndex(this.catIndex);
        return null;
    };
    ProductCategoryView.prototype.restoreModel = function () {
        //undeleted
        var category = this.getModel();
        if (category) {
            if (category.parentCategory) category.parentCategory.addCategory(category);
            ProductCategorySrv.restore(category);
        }
    };
    ProductCategoryView.prototype.updateModel = function (endFunction) {
        var category = this.getModel();
        if (category == null) {
            category = new ProductCategory();
            this.catIndex = ProductCategoryData.getIndexOf(category);
        }

        this.copyDataTo(category);
        if (this.parentCategoryView) {
            var parentCategory = this.parentCategoryView.getModel();
            if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory) category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
        }
        //modify order of categories
        category.categories = [];
        for (var i = 0; i < this.categoriesView.length; i++) {
            category.addCategory(this.categoriesView[i].getModel());
        }category.products = [];
        for (var i = 0; i < this.productsView.length; i++) {
            category.addProduct(this.productsView[i].getModel());
        }ProductCategorySrv.save(category, endFunction, this.checkForRootSaveError);
    };
    ProductCategoryView.prototype.updateModelTree = function () {
        var cat = this;
        this.updateModel(function () {
            for (var j = 0; j < cat.productsView.length; j++) {
                cat.productsView[j].updateModel();
            }for (var j = 0; j < cat.categoriesView.length; j++) {
                cat.categoriesView[j].updateModelTree();
            }
        });
    };

    ProductCategoryView.prototype.reloadModel = function () {
        var category = this.getModel();
        if (category == null) {
            this.parentCategoryView.removeCategoryView(this);
        } else {
            var styleView = this.getStyleFrom(category);
            if (this.styleView && styleView) {
                this.styleView.background = styleView.background;
                this.styleView.color = styleView.color;
            } else this.styleView = styleView;
            if (this.styleView) this.colorPicker = this.styleView.background;

            this.loadDataFrom(category);
        }
    };
    ProductCategoryView.prototype.removeModel = function () {
        var category = this.getModel();
        if (category != null) {
            if (category.parentCategory) category.parentCategory.removeCategory(category);
            ProductCategorySrv.remove(category);
        }
    };

    ProductCategoryView.prototype.removeSelections = function () {
        //if one product is known by humanResource : category is known
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].removeSelections();
        }for (var j = 0; j < this.productsView.length; j++) {
            this.productsView[j].isSelected = false;
            var product = this.productsView[j].getModel();
            if (product) this.productsView[j].quantity = product.quantity;
        }
    };

    ProductCategoryView.prototype.addCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index == -1) {
            this.categoriesView.push(categoryView);
            categoryView.parentCategoryView = this;
        }
    };

    ProductCategoryView.prototype.removeCategoryView = function (categoryView) {
        var index = this.categoriesView.indexOf(categoryView);
        if (index != -1) this.categoriesView.splice(index, 1);
    };
    ProductCategoryView.prototype.addProductView = function (productView) {
        var index = this.productsView.indexOf(productView);
        if (index == -1) {
            this.productsView.push(productView);
            productView.parentCategoryView = this;
        }
    };

    ProductCategoryView.prototype.removeProductView = function (productView) {
        var index = this.productsView.indexOf(productView);
        if (index != -1) {
            this.productsView.splice(index, 1);
        }
    };

    ProductCategoryView.prototype.changeCategoryPosition = function (scope, categoryView, indexTarget) {

        var category = this.getModel();
        var index = this.categoriesView.indexOf(categoryView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            category.categories.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY Two APPLYs ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.categoriesView.length) {
                this.categoriesView.push(categoryView);
                category.categories.push(categoryView.getModel());
            } else {
                this.categoriesView.splice(indexTarget, 0, categoryView); //insert
                category.categories.splice(indexTarget, 0, categoryView.getModel());
            }
            ProductCategorySrv.save(category, null, this.checkForRootSaveError);
        }
        scope.$apply();
    };
    ProductCategoryView.prototype.changeCategoryPositionView = function (categoryView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // categoryView : category to move to indexTarget
        var index = this.categoriesView.indexOf(categoryView);
        if (indexTarget != -1 && index != -1 && this.categoriesView && indexTarget <= this.categoriesView.length) {
            this.categoriesView.splice(index, 1); //remove it
            if (indexTarget == this.categoriesView.length) this.categoriesView.push(categoryView);else this.categoriesView.splice(indexTarget, 0, categoryView); //insert
        }
    };
    ProductCategoryView.prototype.changeProductPositionView = function (productView, indexTarget) {
        //Change the product position

        var index = this.productsView.indexOf(productView);
        //Todo check indexTarget!=index
        if (indexTarget != -1 && index != -1 && this.productsView && indexTarget <= this.productsView.length) {
            this.productsView.splice(index, 1); //remove it
            if (indexTarget == this.productsView.length) this.productsView.push(productView);else this.productsView.splice(indexTarget, 0, productView); //insert
        }
    };
    ProductCategoryView.prototype.changeProductPosition = function (scope, productView, indexTarget) {

        var category = this.getModel();
        var index = this.productsView.indexOf(productView);
        //Todo check indexTarget!=index
        if (category && indexTarget != -1 && index != -1 && this.productsView && indexTarget <= this.productsView.length) {
            this.productsView.splice(index, 1); //remove it
            category.products.splice(index, 1);
            scope.$apply(); //TODO CHECK WHY TO APPLY ARE NEEDED
            if (index < indexTarget) indexTarget--;
            if (indexTarget == this.productsView.length) {
                this.productsView.push(productView);
                category.products.push(productView.getModel());
            } else {
                this.productsView.splice(indexTarget, 0, productView); //insert
                category.products.splice(indexTarget, 0, productView.getModel());
            }
            ProductCategorySrv.save(category, null, this.checkForRootSaveError);
            scope.$apply();
        }
    };
    ProductCategoryView.prototype.moveProduct = function (productView) {
        if (productView) {
            var product = productView.getModel();
            var category = this.getModel();
            if (product && category) {
                if (productView.parentCategoryView) {
                    var index = productView.parentCategoryView.productsView.indexOf(productView);
                    if (index != -1) {
                        productView.parentCategoryView.productsView.splice(index, 1);
                        product.parentCategory.products.splice(index, 1);
                    }
                }
                this.addProductView(productView);
                category.addProduct(product);
                ProductSrv.save(product);
            }
        }
    };
    ProductCategoryView.prototype.moveCategory = function (categoryView) {
        if (categoryView) {
            var categoryToMove = categoryView.getModel();
            var category = this.getModel();
            if (categoryToMove && category) {
                if (categoryView.parentCategoryView) {
                    var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                    if (index != -1) {
                        categoryView.parentCategoryView.categoriesView.splice(index, 1);
                        categoryToMove.parentCategory.categories.splice(index, 1);
                    }
                }
                this.addCategoryView(categoryView);
                category.addCategory(categoryToMove);
                ProductCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
            }
        }
    };
    ProductCategoryView.prototype.canSave = function () {
        return this.label && this.label != "";
    };
    ProductCategoryView.prototype.initWebDisplay = function (forceTo) {
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].initWebDisplay(forceTo);
        }this.displayProductImages = false;
        for (var j = 0; j < this.productsView.length && !this.displayProductImages; j++) {
            if (this.productsView[j].imageDisplayed !== this.imageDisplayed) this.displayProductImages = true;
        }for (var j = 0; j < this.categoriesView.length && !this.displayServiceImages; j++) {
            if (this.categoriesView[j].imageDisplayed !== this.imageDisplayed) this.displayProductImages = true;
        }if (forceTo !== undefined && forceTo != "") this.displayType = forceTo;else if (this.displayProductImages) this.displayType = "thumbnail";else this.displayType = "array";
    };
    ProductCategoryView.prototype.populateDisplayTypeResource = function (array) {
        var defaultDType = this.displayProductImages ? "thumbnail" : "array";
        if (this.displayType != defaultDType) {
            var cat = this.getModel();
            if (cat) array.push({ id: cat.id, type: this.displayType });
        }
        for (var i = 0; i < this.categoriesView.length; i++) {
            this.categoriesView[i].populateDisplayTypeResource(array);
        }
    };

    return ProductCategoryView;
}]);

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ProductView', ["$sce", "ProductData", "ProductSrv", "Product", "SupplierView", "$filter", "SaleData", "OrderData", "UsageProductData", "$locale", "CurrencyManager", "NumberSeparatorType", function ($sce, ProductData, ProductSrv, Product, SupplierView, $filter, SaleData, OrderData, UsageProductData, $locale, CurrencyManager, NumberSeparatorType) {

    var ProductView = function ProductView(product, prdIndex, parentCategoryView, domainView) {
        this.prdIndex = prdIndex;
        this.domainView = domainView;
        this.categoryType = "product";
        this.categoryTypeSortOrder = 1;
        this.label = "";
        this.code = "";
        this.reference = "";
        this.description = "";
        this.descriptionHtml = "";
        this.buyingPrice = 0;
        this.buyingPriceInput = $filter("currencyFormatFilter")(0);
        this.price = 0;
        this.priceInput = $filter("currencyFormatFilter")(0);
        this.hasQuantity = true;
        this.hasInternetPrice = false;
        this.internetPrice = 0;
        this.internetPriceInput = $filter("currencyFormatFilter")(0);
        this.internetDiscountPercent = 0;
        this.quantity = 0;
        this.quantityInput = 0;
        this.quantityModel = 0;
        this.supplierView = null;
        this.supplierInputLabel = "";
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.specificImage = null;
        this.isVisibleOnWebSite = true;
        this.isOnHome = false;
        this.homeOrder = 0;
        this.isBuyableOnWebSite = true;
        this.vatView = domainView && domainView.getDefaultVatView !== undefined ? domainView.getDefaultVatView() : null;
        this.tax = 0;
        //for views
        this.isSelected = false;
        this.isSmsSelected = false;
        this.isNotificationSelected = false;
        this.form = {
            supplierEditMode: false,
            displayError: false,
            displayErrorMobile: false,
            displayErrorLandLine: false,
            displayErrorInternetPrice: false,
            quantityHistory: [],
            qhMessage: false
        };
        if (parentCategoryView) {
            this.parentCategoryView = parentCategoryView;
        }
        if (product) {
            this.loadDataFrom(product);
        }
    };
    ProductView.prototype.getModel = function () {
        if (this.prdIndex != -1) {
            return ProductData.getByIndex(this.prdIndex);
        }
        return null;
    };

    ProductView.prototype.loadDataFrom = function (product) {
        //Assume here than the object in parameter contains only id (must load them)
        this.label = product.label;
        this.code = product.code;
        this.reference = product.reference;
        this.description = product.description;
        this.isOnHome = product.isOnHome;
        this.homeOrder = product.homeOrder;
        this.hasInternetPrice = product.hasInternetPrice;
        this.isVisibleOnWebSite = product.isVisibleOnWebSite;
        this.isBuyableOnWebSite = product.isBuyableOnWebSite;

        if (this.description) this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));

        this.price = product.price;
        this.priceInput = $filter('currencyFormatFilter')(this.price);
        this.buyingPrice = product.buyingPrice;
        this.buyingPriceInput = $filter('currencyFormatFilter')(this.buyingPrice);

        if (product.internetPrice != null) {
            this.internetPrice = product.internetPrice;
            if (this.internetPrice == 0 && this.price != 0) this.internetDiscountPercent = 100;else this.internetDiscountPercent = Math.round(100 * (100 - 100 * this.internetPrice / this.price)) / 100;
        } else this.internetPrice = this.price;
        this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);

        if (product.hasQuantity !== undefined) this.hasQuantity = product.hasQuantity;
        this.quantity = product.quantity;
        this.quantityInput = product.quantity;
        this.quantityModel = product.quantity;
        if (product.supplier) {
            if (this.domainView.getSupplierView !== undefined) this.supplierView = this.domainView.getSupplierView(product.supplier);
            if (this.supplierView) {
                this.supplierInputLabel = this.supplierView.label;
                this.form.supplierEditMode = true;
            }
        }
        if (product.vat) {
            if (this.domainView && this.domainView.getVatView !== undefined) this.vatView = this.domainView.getVatView(product.vat);
        } else if (this.domainView && this.domainView.getDefaultVatView !== undefined) this.vatView = this.domainView.getDefaultVatView();

        this.specificImage = product.specificImage;
        this.image = product.image;
        this.companyImage = product.companyImage;
        if (this.image || this.companyImage) //for ascendencing compatibility
            this.specificImage = true;

        if (this.parentCategoryView && this.image == null && this.specificImage == false) this.image = this.parentCategoryView.image;

        if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) this.companyImage = this.parentCategoryView.companyImage;

        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;
        this.updateTax();
    };
    ProductView.prototype.updateTax = function () {
        if (this.vatView) this.tax = this.price - this.price * 100 / (100 + this.vatView.tax);
    };

    ProductView.prototype.checkHasWrongInternetPrice = function () {
        if (this.hasInternetPrice && (this.internetPrice === 0 || this.internetPrice == null) && this.price === 0) {
            this.form.displayErrorInternetPrice = true;
        } else {
            this.form.displayErrorInternetPrice = false;
        }
    };

    ProductView.prototype.updatePriceInputArrow = function (number) {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price)) this.price = null;else {
                price += number;
                this.priceInput = $filter('currencyFormatFilter')(price);
                this.onPriceInputChange();
            }
        }
    };
    ProductView.prototype.onPriceInputChange = function () {
        if (this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price)) this.price = null;else this.price = price;
            this.updateTax();
        }
        this.checkHasWrongInternetPrice();
    };

    ProductView.prototype.onQuantityInputChange = function () {
        if (this.quantityInput != null) {
            var quantity = parseInt(this.quantityInput);
            if (isNaN(quantity)) this.quantity = null;else this.quantity = quantity;
        } else this.quantity = null;
    };
    ProductView.prototype.updateQuantityInputArrow = function (number) {
        if (this.quantityInput != null) {
            var quantity = parseInt(this.quantityInput);
            if (isNaN(quantity)) this.quantity = null;else {
                quantity += number;
                this.quantityInput = quantity;
                this.onQuantityInputChange();
            }
        }
    };
    ProductView.prototype.updateBuyingPriceInputArrow = function (number) {
        if (this.buyingPriceInput != null && typeof this.buyingPriceInput === 'string') {
            var buyingPriceStr = CurrencyManager.getPriceFromPriceInput(this.buyingPriceInput);
            var buyingPrice = parseFloat(buyingPriceStr);
            if (isNaN(buyingPrice)) this.buyingPrice = null;else {
                buyingPrice += number;
                this.buyingPriceInput = $filter('currencyFormatFilter')(buyingPrice);
                this.onBuyingPriceInputChange();
            }
        }
    };
    ProductView.prototype.onBuyingPriceInputChange = function () {
        if (this.buyingPriceInput != null && typeof this.buyingPriceInput === 'string') {
            var buyingPriceStr = CurrencyManager.getPriceFromPriceInput(this.buyingPriceInput);
            var buyingPrice = parseFloat(buyingPriceStr);
            if (isNaN(buyingPrice)) this.buyingPrice = null;else this.buyingPrice = buyingPrice;
        }
    };

    ProductView.prototype.initInternetPrice = function () {
        if (this.hasInternetPrice && this.internetPrice == 0) {
            this.internetPrice = this.price;
            this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
            this.onInternetPriceInputChange();
        }
        this.checkHasWrongInternetPrice();
    };

    ProductView.prototype.updateInternetPriceInputArrow = function (number) {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (isNaN(internetPrice)) this.internetPrice = null;else {
                if (internetPrice + number < 0) internetPrice = 0;else if (internetPrice + number < this.price) internetPrice += number;else internetPrice = this.price;
                this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
            }
            this.onInternetPriceInputChange();
        }
    };
    ProductView.prototype.onInternetPriceInputChange = function () {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (isNaN(internetPrice)) this.internetPrice = null;else this.internetPrice = internetPrice;

            if (this.internetPrice == 0 && this.price != 0) this.internetDiscountPercent = 100;else this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
        }
        this.checkHasWrongInternetPrice();
    };

    ProductView.prototype.isChanged = function () {
        var product = this.getModel();
        if (product) {
            var image = product.image;
            if (image == null && product.parentCategory && product.specificImage == false) image = product.parentCategory.image;
            var companyImage = product.companyImage;
            if (companyImage == null && product.parentCategory && product.specificImage == false) companyImage = product.parentCategory.companyImage;

            var vat = null;
            if (this.vatView && this.domainView.getDefaultVatView() != this.vatView) //null == default
                vat = this.vatView.getModel();

            var supplierChanged = false;
            if (this.supplierView) {
                if (!product.supplier) supplierChanged = true;else supplierChanged = this.supplierView.getModel() != product.supplier;
                if (!supplierChanged) supplierChanged = this.supplierView.isChanged();
            } else supplierChanged = product.supplier != null;

            return this.label != product.label || this.code != product.code || this.reference != product.reference || this.description != product.description || this.buyingPrice != product.buyingPrice || this.hasInternetPrice != product.hasInternetPrice || this.isVisibleOnWebSite != product.isVisibleOnWebSite || this.isBuyableOnWebSite != product.isBuyableOnWebSite || this.internetPrice != product.internetPrice || this.price != product.price || this.quantity != product.quantity || this.hasQuantity != product.hasQuantity || this.specificImage != product.specificImage || this.image !== image || this.companyImage !== companyImage || supplierChanged || vat !== product.vat || this.isOnHome !== product.isOnHome || this.homeOrder !== product.homeOrder;
        } else return true;
    };
    ProductView.prototype.activeSupplierEditMode = function () {
        this.supplierView = new SupplierView(null, -1, this.domainView);
        if (this.supplierInputLabel && typeof this.supplierInputLabel == "string") this.supplierView.label = this.supplierInputLabel;
        this.form.supplierEditMode = true;
    };
    ProductView.prototype.cancelSupplierEditMode = function () {
        this.supplierView = null;
        this.supplierInputLabel = "";
        this.form.supplierEditMode = false;
    };

    ProductView.prototype.onSupplierSelect = function (supplierView) {
        //call when supplier is selected
        this.supplierView = supplierView;
        this.form.supplierEditMode = true;
    };
    ProductView.prototype.setImage = function (image) {
        this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };
    ProductView.prototype.setCompanyImage = function (companyImage) {
        this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    ProductView.prototype.getClone = function () {
        var clone = new ProductView(null, -1, this.parentCategoryView, this.domainView);
        clone.label = this.label;
        clone.code = this.code;
        clone.reference = this.reference;
        clone.description = this.description;
        clone.descriptionHtml = this.descriptionHtml;
        clone.buyingPrice = this.buyingPrice;
        clone.buyingPriceInput = this.buyingPriceInput;
        clone.price = this.price;
        clone.priceInput = this.priceInput;
        clone.hasQuantity = this.hasQuantity;
        clone.hasInternetPrice = this.hasInternetPrice;
        clone.internetPrice = this.internetPrice;
        clone.internetPriceInput = this.internetPriceInput;
        clone.internetDiscountPercent = this.internetDiscountPercent;
        clone.quantity = 0;
        clone.quantityInput = 0;
        clone.quantityModel = 0;
        clone.supplierView = this.supplierView;
        clone.supplierInputLabel = this.supplierInputLabel;
        if (this.imageDisplayed) {
            clone.setImage(this.imageDisplayed);
        }
        if (this.companyImage) {
            clone.setCompanyImage(this.companyImage);
        }
        clone.specificImage = this.specificImage;
        clone.isVisibleOnWebSite = this.isVisibleOnWebSite;
        clone.isOnHome = this.isOnHome;
        clone.homeOrder = this.homeOrder;
        clone.isBuyableOnWebSite = this.isBuyableOnWebSite;
        clone.vatView = this.vatView;
        clone.tax = this.tax;

        return clone;
    };

    ProductView.prototype.copyDataTo = function (product) {
        //Assume here than the object in parameter contains only id (must load them)
        product.label = this.label;
        product.code = this.code;
        product.reference = this.reference;
        product.description = this.description;
        product.buyingPrice = this.buyingPrice;
        product.price = this.price;
        product.originalPrice = this.originalPrice;
        product.quantity = this.quantity;
        this.quantityModel = this.quantity; //Align quantity
        product.hasQuantity = this.hasQuantity;
        product.hasInternetPrice = this.hasInternetPrice;
        product.isOnHome = this.isOnHome;
        product.homeOrder = this.homeOrder;
        product.internetPrice = this.internetPrice;

        if (this.vatView && this.domainView.getDefaultVatView() != this.vatView) //do not set if = default -> allow to change default
            product.vat = this.vatView.getModel();else product.vat = null;
        if (this.supplierView) {
            var supplier = this.supplierView.getModel();
            if (supplier !== product.customer) {
                if (product.customer) product.customer.removeProduct(product);
                if (supplier) supplier.addProduct(product);
                product.supplier = supplier;
            }
        } else product.supplier = null;
        product.image = this.image;
        product.companyImage = this.companyImage;
        product.specificImage = this.specificImage;
        product.isVisibleOnWebSite = this.isVisibleOnWebSite;
        product.isBuyableOnWebSite = this.isBuyableOnWebSite;
    };
    ProductView.prototype.onSpecificImageChange = function () {
        if (!this.specificImage) {
            this.image = null;
            this.companyImage = null;
        }
    };
    ProductView.prototype.updateModel = function (noQuantity) {
        if (this.isChanged()) {
            var product = this.getModel();
            if (product == null) {
                product = new Product();
                this.prdIndex = ProductData.getIndexOf(product);
            }

            if (!this.specificImage && this.parentCategoryView !== undefined && this.parentCategoryView.label !== "Racine") {
                this.image = this.parentCategoryView.image;
                product.image = this.image;
            }

            if (this.supplierView) {
                if (!this.supplierView.getModel() && this.domainView) //Add to view
                    this.domainView.addSupplierView(this.supplierView);
                this.supplierView.updateModel(false);
            }
            this.copyDataTo(product);

            var category = this.parentCategoryView.getModel();
            if (category && category !== product.parentCategory) // change of category
                {
                    if (product.parentCategory) product.parentCategory.removeProduct(product);
                    category.addProduct(product);
                }
            if (noQuantity !== undefined && noQuantity) ProductSrv.saveNoQuantity(product);else ProductSrv.save(product);
        }
    };

    ProductView.prototype.removeModel = function () {
        var product = this.getModel();
        if (product != null) {
            product.parentCategory.removeProduct(product);
            ProductSrv.remove(product);
        }
    };
    ProductView.prototype.reloadModel = function () {
        var product = this.getModel();
        if (product == null) {
            this.parentCategoryView.removeProductView(this);
        } else {
            this.loadDataFrom(product);
        }
        if (this.supplierView) this.supplierView.reloadModel();
    };
    ProductView.prototype.restoreModel = function () {
        //undeleted
        var product = this.getModel();
        if (product) {
            if (product.parentCategory) product.parentCategory.addProduct(product);
            ProductSrv.restore(product);
        }
    };
    ProductView.prototype.getQuantityHistory = function () {
        var product = this.getModel();
        var productView = this;
        if (product) {
            this.form.quantityHistory = null;
            ProductSrv.getQuantityHistory(product, function (productHistory) {
                var sale, saleNumber, order, orderNumber, up, upNumber, isCanceled;
                productView.form.qhMessage = false;
                if (productHistory && productHistory.productVersions) {
                    productView.form.quantityHistory = [];

                    //update quantity
                    productView.quantity = product.quantity;
                    productView.quantityModel = product.quantity;
                    productView.quantityInput = product.quantity;

                    for (var i = 0; i < productHistory.productVersions.length; i++) {
                        isCanceled = false;
                        saleNumber = null;
                        if (productHistory.productVersions[i].saleId) {
                            sale = SaleData.getById(productHistory.productVersions[i].saleId);
                            if (sale) {
                                saleNumber = sale.saleNumber;
                                isCanceled = i > 0 && productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity > 0 && sale.status == "canceled";
                            }
                            if (!saleNumber) saleNumber = "En attente";
                        }
                        orderNumber = null;
                        if (productHistory.productVersions[i].orderId) {
                            order = OrderData.getById(productHistory.productVersions[i].orderId);
                            if (order) {
                                orderNumber = order.orderNumber;
                                isCanceled = i > 0 && productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity < 0;
                            }
                        }
                        upNumber = null;
                        if (productHistory.productVersions[i].usageProductId) {
                            up = UsageProductData.getById(productHistory.productVersions[i].usageProductId);
                            if (up) {
                                upNumber = up.upNumber;
                                isCanceled = i > 0 && productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity > 0;
                            }
                        }
                        if (productHistory.productVersions[i].hide) productView.form.qhMessage = true;else productView.form.quantityHistory.push({
                            versionDate: new Date(productHistory.productVersions[i].versionDate),
                            quantity: productHistory.productVersions[i].quantity,
                            delta: i > 0 ? productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity : productHistory.productVersions[i].quantity,
                            saleNumber: saleNumber,
                            orderNumber: orderNumber,
                            upNumber: upNumber,
                            isCanceled: isCanceled,
                            directSave: productHistory.productVersions[i].directSave

                        });
                    }
                }
            });
        }
    };
    ProductView.prototype.canSave = function () {
        if (!this.form.quantityHistory || this.form.displayErrorInternetPrice) return false;

        if (this.supplierView && this.supplierView.canSave != undefined) if (!this.supplierView.canSave() || this.form.displayErrorLandLine || this.form.displayErrorMobile) return false;
        if (this.supplierInputLabel && this.supplierInputLabel != "" && !this.supplierView) //must use button New supplier
            return false;

        if (this.label && this.label != "" && //titre
        this.buyingPrice != null && this.buyingPrice >= 0 //prix (décimal)
        && this.price != null && this.price >= 0 //prix (décimal)
        && (!this.hasQuantity || this.quantity != null) && this.internetPrice != null && this.internetPrice >= 0 //prix (décimal)
        ) {
                return true;
            } else {
            return false;
        }
    };
    ProductView.prototype.search = function (searchedTextLC) {
        if (!searchedTextLC) {
            return false;
        }

        if (this.label.toLowerCase().indexOf(searchedTextLC) !== -1 || this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC) !== -1) {
            return true;
        }

        return false;
    };

    return ProductView;
}]);

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ReadOnlyBookingServiceView', ["ActivityData", "Period", "HumanResourceData", function (ActivityData, Period, HumanResourceData) {

    var ReadOnlyBookingServiceView = function ReadOnlyBookingServiceView(bookingService, bsIndex, bookingView) {
        //bookingService : model object
        //bsIndex : index inside booking
        //bookingView : bookingView parent
        this.actIndex = ActivityData.getIndexOf(bookingService);
        this.bsIndex = bsIndex; //model index on booking
        this.bookingView = bookingView;
        this.serviceView = null;
        this.price = 0;
        this.billPosition = bsIndex + 1; //position inside booking ->
        this.label = null;
        this.period = null; //period of activity
        this.hrView = null; //special direct access to hrView without need to implement DayHr
        this.hrRequest = false;
        this.loadDataFrom(bookingService);
    };

    ReadOnlyBookingServiceView.prototype.loadDataFrom = function (bookingService) {
        //Manage specifics fields of BookingServiceView
        this.price = bookingService.price;
        this.label = bookingService.label;
        this.isPackage = bookingService.isPackage;
        this.hrRequest = bookingService.hrRequest;
        if (bookingService.period) this.period = new Period(bookingService.period);else this.period = null;
        if (this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView) {
            if (bookingService.service && this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView && this.bookingView.customerView.domainView.getServiceView !== undefined) this.serviceView = this.bookingView.customerView.domainView.getServiceView(bookingService.service);
            if (bookingService.dayHr && this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView && this.bookingView.customerView.domainView.getHrView !== undefined) this.hrView = this.bookingView.customerView.domainView.getHrView(HumanResourceData.getById(bookingService.dayHr.humanResourceId));
        }
    };

    ReadOnlyBookingServiceView.prototype.getModel = function () {
        if (this.actIndex != -1) return ActivityData.getByIndex(this.actIndex);
        return null;
    };
    return ReadOnlyBookingServiceView;
}]);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ReadOnlyBookingView', ["$log", "Period", "DaySrv", "ReadOnlyBookingServiceView", "BookingData", function ($log, Period, DaySrv, ReadOnlyBookingServiceView, BookingData) {

    var BookingView = function BookingView(booking, customerView) {
        this.bookingIndex = BookingData.getIndexOf(booking);
        this.label = null;
        this.price = 0;
        this.status = '';
        this.customerView = customerView;
        this.period = new Period(); //period of booking
        this.date = null;
        //information selected by user
        // usePeriodStart : Store the fact that the adding action had been done -> next adding will use other rules
        this.bookingServicesView = []; // all linePeriods of the table selected

        if (booking) this.loadDataFrom(booking);else this.date = new Date();
    };
    BookingView.prototype.loadDataFrom = function (booking) //
    {
        if (booking) {
            this.label = booking.label;
            this.price = booking.price;
            this.status = booking.status;
            this.setPeriod(booking.period);
            if (booking.day) this.date = DaySrv.getDateFromId(booking.day.id);else this.date = new Date();

            var bsV;
            this.bookingServicesView = [];
            for (var i = 0; i < booking.bookingServices.length; i++) {
                bsV = new ReadOnlyBookingServiceView(booking.bookingServices[i], i, this);
                this.bookingServicesView.push(bsV);
            }
        }
    };

    BookingView.prototype.setPeriod = function (period) {
        if (period) this.period = new Period(period);
    };

    BookingView.prototype.getBookingServiceViewById = function (id) {
        var bs;
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            bs = this.bookingServicesView[i].getModel();
            if (bs && bs.id == id) return this.bookingServicesView[i];
        }
        return null;
    };

    BookingView.prototype.getModel = function () {
        if (this.bookingIndex != -1) return BookingData.getByIndex(this.bookingIndex);
        return null;
    };

    return BookingView;
}]);

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleAdvanceView', ["$log", "$filter", "$dialog", "SiteData", "Payment", "SaleData", "DaySrv", "SaleProductView", "SaleServiceView", "SaleCureView", "LoyaltyCardItemView", "Transaction", "SaleSrv", "Sale", "CustomerView", "DayView", "BookingData", "DayData", "GiftItemView", "PaymentView", "Day", "HumanResourceData", "CurrencyManager", "NumberSeparatorType", "gettextCatalog", "IOSDevice", "Countries", "SaleStatus", "SalePaymentType", "BookingSaveTransactionOrigin", "SalePaymentTypeFactory", "BasicAuthRoleFactory", "PaymentDataObject", "SaleSettings", "SalePartnerSettingsFactory", "Brand", "HumanResourceView", "SiteView", function ($log, $filter, $dialog, SiteData, Payment, SaleData, DaySrv, SaleProductView, SaleServiceView, SaleCureView, LoyaltyCardItemView, Transaction, SaleSrv, Sale, CustomerView, DayView, BookingData, DayData, GiftItemView, PaymentView, Day, HumanResourceData, CurrencyManager, NumberSeparatorType, gettextCatalog, IOSDevice, Countries, SaleStatus, SalePaymentType, BookingSaveTransactionOrigin, SalePaymentTypeFactory, BasicAuthRoleFactory, PaymentDataObject, SaleSettings, SalePartnerSettingsFactory, Brand, HumanResourceView, SiteView) {

    var SaleAdvanceView = function SaleAdvanceView(saleAdvance, posView) {
        this.id = null;
        this.status = "advance";
        this.timeCreated = null;
        this.timeModified = null;
        this.customerView = null;
        this.customerLabel = "";
        this.bookingView = null; // TODO GET BOOKING VIEW
        this.dayId = null;
        this.dayView = null;
        this.posView = null;
        this.estimationNumber = null;
        this.advanceNumber = null;
        this.hrSellerView = null;
        this.hrOpView = null;
        this.siteView = null;
        this.siteV = null;
        this.softV = null;
        this.signature = null;
        this.pSignature = null;
        this.signatureCode = null;
        this.dsignatureCode = null;
        this.vat = 0;
        this.vatCode = null;
        this.oExt = null;
        this.servicesPrice = 0;
        this.productsPrice = 0;
        this.curesPrice = 0;
        this.giftItemsPrice = 0;
        this.loyaltyCardsPrice = 0;
        this.servicesPriceWithD = 0;
        this.productsPriceWithD = 0;
        this.curesPriceWithD = 0;
        this.giftItemsPriceWithD = 0;
        this.loyaltyCardsPriceWithD = 0;
        this.price = 0;
        this.priceHT = 0;
        this.priceTurnover = 0;
        this.priceTurnoverHT = 0;
        this.vatPrice = 0;
        this.advancePrice = 0;
        this.advancePercent = posView && posView.domainView && posView.domainView.advancePercent ? posView.domainView.advancePercent : 30; //only for view
        this.realPaidPrice = 0;
        this.payedPrice = 0;
        this.discountPercent = 0;
        this.isCreatedByCustomer = false;
        this.isOccasionalCustomer = false;
        this.nbPrint = 0;
        this.loyaltyCardItemView = null;
        this.nbLoyaltyCardGoal = 0;
        this.loyaltyDiscount = 0;
        this.loyaltyPts = 0;
        this.loyaltyUsedPts = 0;
        this.totalLoyaltyPts = 0;
        this.hasLoyaltyDiscount = false;
        this.isValidLoyaltyPoints = true;
        this.loyaltyDate = null;
        this.companyName = null;
        this.hasUnpaid = false;
        this.paymentsView = [];
        this.saleServicesView = [];
        this.saleProductsView = [];
        this.saleCuresView = [];
        this.giftItemsView = [];
        this.loyaltyCardItemsView = [];

        this.hasGiftItems = false;
        this.vatLines = []; // list of taxes applied (only on view)  {tax,amount}
        this.printWindow = null;

        this.customerLastname = null;
        this.customerFirstname = null;
        this.customerAddress = null;
        this.customerZip = null;
        this.customerCity = null;
        this.shareCapital = null;
        this.greffeCity = null;
        this.juridicForm = null;

        this.loadDataFrom(saleAdvance, posView);
    };

    SaleAdvanceView.prototype.loadDataFrom = function (saleAdvance, posView) {
        if (saleAdvance) {
            this.loadPropertiesDataFrom(saleAdvance, posView);
            this.loadSaleServicesDataFrom(saleAdvance);
            this.loadSaleProductsDataFrom(saleAdvance);
            this.loadSaleCuresDataFrom(saleAdvance);
            this.loadGiftItemsDataFrom(saleAdvance);
            this.loadLoyaltyCardItemsDataFrom(saleAdvance);
        }
        this.calculateSaleFields();
    };

    SaleAdvanceView.prototype.loadPropertiesDataFrom = function (saleAdvance, posView) {
        if (saleAdvance) {
            this.id = saleAdvance.id;
            this.posView = posView;
            this.timeCreated = typeof saleAdvance.timeCreated === "number" ? new Date(saleAdvance.timeCreated) : saleAdvance.timeCreated;
            this.timeModified = typeof saleAdvance.timeModified === "number" ? new Date(saleAdvance.timeModified) : saleAdvance.timeModified;
            this.customerId = saleAdvance.customerId;
            if (saleAdvance.customer !== null) {
                this.customerView = new CustomerView(saleAdvance.customer);
                this.customerLabel = saleAdvance.customer.lastName + " " + saleAdvance.customer.firstName;
            } else {
                this.isOccasionalCustomer = true;
            }

            this.dayId = saleAdvance.dayId;
            if (saleAdvance.day !== null) {
                var dayIndex = DayData.getIndexOf(saleAdvance.day);
                this.dayView = new DayView(dayIndex);
            }

            this.estimationNumber = saleAdvance.estimationNumber;
            this.advanceNumber = saleAdvance.advanceNumber;
            this.hrSellerId = saleAdvance.hrSellerId;
            if (saleAdvance.hrSeller !== null) {
                this.hrSellerView = new HumanResourceView(saleAdvance.hrSeller);
            }
            if (saleAdvance.hrOp !== null) {
                this.hrOpView = new HumanResourceView(saleAdvance.hrOp);
            }
            if (saleAdvance.site) {
                this.siteView = new SiteView(saleAdvance.site);
            }
            this.siteV = saleAdvance.siteV;
            this.softV = saleAdvance.softV;
            this.signature = saleAdvance.signature;
            this.pSignature = saleAdvance.pSignature;
            this.signatureCode = saleAdvance.signatureCode;
            this.dsignatureCode = saleAdvance.dsignatureCode;
            this.vat = saleAdvance.vat;
            this.vatCode = saleAdvance.vatCode;
            this.servicesPrice = saleAdvance.servicesPrice;
            this.productsPrice = saleAdvance.productsPrice;
            this.curesPrice = saleAdvance.curesPrice;
            this.giftItemsPrice = saleAdvance.giftItemsPrice;
            this.loyaltyCardsPrice = saleAdvance.loyaltyCardsPrice;
            this.productsPriceWithD = this.productsPrice - this.productsPrice * this.discountPercent / 100;
            this.servicesPriceWithD = this.servicesPrice - this.servicesPrice * this.discountPercent / 100;
            this.curesPriceWithD = this.curesPrice - this.curesPrice * this.discountPercent / 100;
            this.giftItemsPriceWithD = this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100;
            this.loyaltyCardsPriceWithD = this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100;
            this.price = saleAdvance.price;
            this.priceHT = saleAdvance.priceHT;
            this.priceTurnover = saleAdvance.priceTurnover;
            this.priceTurnoverHT = saleAdvance.priceTurnoverHT;
            this.vatPrice = saleAdvance.vatPrice;
            this.advancePrice = saleAdvance.advancePrice;
            this.oExt = saleAdvance.oExt;
            this.discountPercent = saleAdvance.discountPercent;
            this.isCreatedByCustomer = saleAdvance.isCreatedByCustomer;
            this.nbPrint = saleAdvance.nbPrint;
            this.loyaltyCardItemId = saleAdvance.loyaltyCardItemId;
            if (saleAdvance.loyaltyCardItem !== null) {
                this.loyaltyCardItemView = new LoyaltyCardItemView(saleAdvance.loyaltyCardItem, null, 0, null, this.posView);
                var allItemsPrice = saleAdvance.getAllItemsPrice();
                this.calculateUsedLoyaltyPts(allItemsPrice);
            }
            this.loyaltyPts = saleAdvance.loyaltyPts;
            this.totalLoyaltyPts = saleAdvance.totalLoyaltyPts;
            this.hasLoyaltyDiscount = saleAdvance.hasLoyaltyDiscount;
            this.loyaltyDate = saleAdvance.loyaltyDate;
            this.companyName = saleAdvance.companyName;
            this.paymentsView = [];
            if (saleAdvance.payments) {
                for (var i = 0; i < saleAdvance.payments.length; i++) {
                    var payment = saleAdvance.payments[i];
                    this.paymentsView.push(new PaymentView(payment));
                    if (payment.type === "UNPAID") {
                        this.hasUnpaid = true;
                    }
                    if (this.paymentsView[i].type !== "UNPAID" && this.paymentsView[i].type !== "GIFT") {
                        this.realPaidPrice += this.paymentsView[i].price;
                    }
                }
            }
            this.customerLastname = saleAdvance.customerLastname;
            this.customerFirstname = saleAdvance.customerFirstname;
            this.customerAddress = saleAdvance.customerAddress;
            this.customerZip = saleAdvance.customerZip;
            this.customerCity = saleAdvance.customerCity;
            this.shareCapital = saleAdvance.shareCapital;
            this.greffeCity = saleAdvance.greffeCity;
            this.juridicForm = saleAdvance.juridicForm;
        }
    };

    SaleAdvanceView.prototype.loadSaleServicesDataFrom = function (saleAdvance) {
        if (saleAdvance) {
            for (var i = 0; i < saleAdvance.saleServices.length; i++) {
                var saleService = saleAdvance.saleServices[i];
                var saleServiceView = new SaleServiceView(saleService, null, i + 1);
                this.saleServicesView.push(saleServiceView);
            }
        }
    };

    SaleAdvanceView.prototype.loadSaleProductsDataFrom = function (saleAdvance) {
        if (saleAdvance) {
            for (var i = 0; i < saleAdvance.saleProducts.length; i++) {
                var saleProduct = saleAdvance.saleProducts[i];
                var saleProductView = new SaleProductView(saleProduct, null, i + 1);
                this.saleProductsView.push(saleProductView);
            }
        }
    };

    SaleAdvanceView.prototype.loadSaleCuresDataFrom = function (saleAdvance) {
        if (saleAdvance) {
            for (var i = 0; i < saleAdvance.saleCures.length; i++) {
                var saleCure = saleAdvance.saleCures[i];
                var billPosition = this.saleProductsView.length + i + 1;
                var saleCureView = new SaleCureView(saleCure, null, billPosition, this);
                this.saleCuresView.push(saleCureView);
            }
        }
    };

    SaleAdvanceView.prototype.loadGiftItemsDataFrom = function (saleAdvance) {
        if (saleAdvance) {
            for (var i = 0; i < saleAdvance.giftItems.length; i++) {
                var giftItem = saleAdvance.giftItems[i];
                var billPosition = this.saleProductsView.length + this.saleCuresView.length + i + 1;
                var giftItemView = new GiftItemView(giftItem, null, billPosition, this);
                this.giftItemsView.push(giftItemView);
            }
        }
    };

    SaleAdvanceView.prototype.loadLoyaltyCardItemsDataFrom = function (saleAdvance) {
        if (saleAdvance) {
            var oneLoyaltyCardItemView = void 0;
            for (var i = 0; i < saleAdvance.loyaltyCardItems.length; i++) {
                var oneLoyaltyCardItem = saleAdvance.loyaltyCardItems[i];
                var billPosition = this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + i + 1;
                oneLoyaltyCardItemView = new LoyaltyCardItemView(oneLoyaltyCardItem, null, billPosition, this);
                this.loyaltyCardItemsView.push(oneLoyaltyCardItemView);
            }
            if (this.status === SaleStatus.WAITING && !this.loyaltyDate && oneLoyaltyCardItemView) {
                this.loyaltyDate = oneLoyaltyCardItemView.validityDate;
            }
        }
    };

    SaleAdvanceView.prototype.calculateSaleFields = function () {
        var discountValue = 0;

        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }

        var allItemsPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
        if (this.loyaltyCardItemView) {
            if (this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType !== "special") {
                discountPercent = 0;
                discountValue = 0;
            }

            this.calculateUsedLoyaltyPts(allItemsPrice);
            this.hasLoyaltyDiscount = false;
            if (this.nbLoyaltyCardGoal > 0) //goal reached : apply discount
                {
                    this.loyaltyDiscount += this.loyaltyCardItemView.computeLoyaltyDiscount(this.loyaltyPts);
                    this.hasLoyaltyDiscount = this.loyaltyDiscount > 0;
                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                        discountValue += this.loyaltyDiscount;
                    }
                    if (this.loyaltyCardItemView.goalType === "discountPercent" && this.loyaltyCardsPrice === 0) {
                        //Can apply if discount is loyaltyCardsPrice has price
                        discountPercent += this.loyaltyDiscount;
                    }
                }
        }

        if (discountPercent && discountPercent !== 0) {
            discountValue += discountPercent * allItemsPrice / 100;
        }
        this.price = Math.round((allItemsPrice - discountValue) * 100) / 100;
        this.priceInput = $filter('currencyFormatFilter')(this.price);
        if (this.loyaltyCardItemView) {
            this.updatePercent();
        }
        this.productsPriceWithD = Math.round((this.productsPrice - this.productsPrice * this.discountPercent / 100) * 100) / 100;
        this.curesPriceWithD = Math.round((this.curesPrice - this.curesPrice * this.discountPercent / 100) * 100) / 100;
        this.servicesPriceWithD = Math.round((this.servicesPrice - this.servicesPrice * this.discountPercent / 100) * 100) / 100;
        this.giftItemsPriceWithD = Math.round((this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100) * 100) / 100;
        this.loyaltyCardsPriceWithD = Math.round((this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100) * 100) / 100;

        this.payedPrice = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            this.payedPrice += this.paymentsView[i].price;
        }
        this.currentPayment = this.price - this.payedPrice;

        this.calculateVatLines();
        this.calculateEarnedLoyaltyPts();
    };

    SaleAdvanceView.prototype.updatePercent = function () {
        var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
        if (originalPrice !== 0) {
            this.discountPercent = Math.round(10000000 * (100 - 100 * this.price / originalPrice)) / 10000000;
        } else {
            this.discountPercent = 0;
        }
    };

    SaleAdvanceView.prototype.calculateEarnedLoyaltyPts = function () {
        this.loyaltyPts = 0;
        if (this.loyaltyCardItemView) {
            var loyaltyBasedPrice = this.price - this.loyaltyCardsPriceWithD;
            if (this.paymentsView.length !== 0) {
                var giftPrice = 0;
                for (var i = 0; i < this.paymentsView.length; i++) {
                    if (this.paymentsView[i].type === "GIFT") {
                        giftPrice += this.paymentsView[i].price;
                    }
                }
                loyaltyBasedPrice -= giftPrice;
            }
            this.loyaltyPts = Math.round(this.loyaltyCardItemView.ptsByCa * loyaltyBasedPrice + this.loyaltyCardItemView.ptsBySale);
        }
    };

    SaleAdvanceView.prototype.calculateUsedLoyaltyPts = function (allItemsPrice) {
        this.loyaltyPts = 0;
        this.loyaltyUsedPts = 0;
        if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal !== -1) {
            var hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
            this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, null, hasLoyaltyCardInShoppingCart);
        }
        if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal === 1) {
            //-> Not goal reached : generate points
            this.loyaltyPts = -this.loyaltyCardItemView.getGoalPoints(allItemsPrice); //goal reached -> generate negative points
            this.loyaltyUsedPts = this.loyaltyPts;
        }
    };

    SaleAdvanceView.prototype.calculateVatLines = function () {
        this.vatLines = this.initVatLines();
        var defaultVat = null;

        if (this.posView && this.posView.domainView) {
            defaultVat = this.posView.domainView.getDefaultVatTax();
        }

        if (defaultVat != null) {
            var priceWithD = void 0;
            if (this.bookingView) {
                for (var i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                    priceWithD = this.bookingView.bookingServicesView[i].price - this.bookingView.bookingServicesView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
            } else {
                for (var _i = 0; _i < this.saleServicesView.length; _i++) {
                    priceWithD = this.saleServicesView[_i].price - this.saleServicesView[_i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
            }
            for (var _i2 = 0; _i2 < this.saleCuresView.length; _i2++) {
                priceWithD = this.saleCuresView[_i2].price - this.saleCuresView[_i2].price * this.discountPercent / 100;
                this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
            }
            for (var _i3 = 0; _i3 < this.loyaltyCardItemsView.length; _i3++) {
                priceWithD = this.loyaltyCardItemsView[_i3].price - this.loyaltyCardItemsView[_i3].price * this.discountPercent / 100;
                this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
            }

            for (var _i4 = 0; _i4 < this.saleProductsView.length; _i4++) {
                priceWithD = this.saleProductsView[_i4].price - this.saleProductsView[_i4].price * this.discountPercent / 100;
                if (this.saleProductsView[_i4].vat == null) {
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                } else {
                    this.addVatAmount(this.saleProductsView[_i4].vat, priceWithD - priceWithD * 100 / (100 + this.saleProductsView[_i4].vat), priceWithD * 100 / (100 + this.saleProductsView[_i4].vat));
                }
            }
        }

        var totalVat = 0;
        var maxAmount = 0;
        for (var _i5 = 0; _i5 < this.vatLines.length; _i5++) {
            this.vatLines[_i5].amount = Math.round(this.vatLines[_i5].amount * 100) / 100;
            totalVat += this.vatLines[_i5].amount;
            if (this.vatLines[_i5].amount >= maxAmount) {
                maxAmount = this.vatLines[_i5].amount;
                this.vat = this.vatLines[_i5].tax;
                this.vatCode = this.vatLines[_i5].code;
            }
        }

        if (totalVat === 0) {
            var maxHt = 0;
            for (var _i6 = 0; _i6 < this.vatLines.length; _i6++) {
                this.vatLines[_i6].amount = Math.round(this.vatLines[_i6].amount * 100) / 100;
                if (this.vatLines[_i6].ht >= maxHt) {
                    maxHt = this.vatLines[_i6].ht;
                    this.vat = this.vatLines[_i6].tax;
                    this.vatCode = this.vatLines[_i6].code;
                }
            }
        }
        this.priceHT = this.price - totalVat;
    };

    SaleAdvanceView.prototype.initVatLines = function () {
        var vatTaxes = [];

        if (this.posView && this.posView.domainView) {
            var vatsView = this.posView.domainView.getVatsView();
            if (vatsView) {
                for (var i = 0; i < vatsView.length; i++) {
                    if (vatsView[i].isUsable) {
                        vatTaxes.push({ tax: vatsView[i].tax, code: vatsView[i].code, amount: 0, ht: 0 });
                    }
                }
            }
        }
        return vatTaxes;
    };

    SaleAdvanceView.prototype.addVatAmount = function (tax, amount, ht) {
        var vatLine = null;
        for (var i = 0; i < this.vatLines.length; i++) {
            if (this.vatLines[i].tax === tax) {
                vatLine = this.vatLines[i];
            }
        }
        if (!vatLine) {
            this.vatLines.push({ tax: tax, amount: amount, ht: ht });
        } else {
            vatLine.amount += amount;
            vatLine.ht += ht;
        }
    };

    SaleAdvanceView.prototype.hasCustomerWithEmail = function () {
        return this.customerView && this.customerView.email;
    };

    SaleAdvanceView.prototype.openPrintWindow = function () {
        var left = screen.width / 2 - 800 / 2;
        var top = screen.height / 2 - 500 / 2;
        this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        if (this.printWindow) {
            this.printWindow.window.focus();
        }
    };

    SaleAdvanceView.prototype.getDiscount = function (saleAdvanceItem, quantity) {
        var discountTTC = 0;
        if (saleAdvanceItem.discountPercent > 0) {
            if (saleAdvanceItem.discountPercent === 100) {
                discountTTC = saleAdvanceItem.originalPrice * quantity;
            } else {
                discountTTC = saleAdvanceItem.price / (1 - saleAdvanceItem.discountPercent / 100) - saleAdvanceItem.price;
            }
        }
        return discountTTC;
    };

    SaleAdvanceView.prototype.getDiscountGlobalTTC = function (saleItem, discountTTC) {
        var discountRemise = 0;
        if (this.discountPercent > 0 && discountTTC !== saleItem.originalPrice) {
            discountRemise += saleItem.price * this.discountPercent / 100;
        }
        return discountRemise;
    };

    SaleAdvanceView.prototype.addLineOnPrint = function (saleItem, quantity, discountTTC, label) {
        var vat = saleItem.vat || saleItem.vat === 0 ? saleItem.vat : "20";
        var price = saleItem.originalPrice;
        var priceHT = saleItem.originalPrice / (vat / 100 + 1);
        var finalLabel = priceHT === 0 ? label + "</br>" + gettextCatalog.getString("Code 328 gratuité totale") : label;
        var lineContent = '' + '<tr>' + '<td style="width:13px">' + quantity + '</td>' + '<td>' + finalLabel + '</td>' + '<td>' + gettextCatalog.getString("Code TVA") + " : " + saleItem.vatCode + '</td>' + '<td>' + gettextCatalog.getString("TVA") + ' = ' + vat + '%</td>' + '<td>' + gettextCatalog.getString("Prix Unitaire HT") + ' = ' + $filter('currencyFormatFilter')(priceHT) + '</td>' + '<td>' + gettextCatalog.getString("Prix Unitaire TTC") + ' = ' + $filter('currencyFormatFilter')(price) + '</td>' + '<td>' + gettextCatalog.getString("Prix Total HT") + ' = ' + $filter('currencyFormatFilter')(priceHT * quantity) + '</td>' + '<td>' + gettextCatalog.getString("Prix Total TTC") + ' = ' + $filter('currencyFormatFilter')(price * quantity) + '</td>' + '</tr>';
        var discountP = discountTTC * 100 / (saleItem.originalPrice * quantity);
        if (discountP > 0) {
            lineContent += '' + '<tr>' + '<td style="width:13px"></td>' + '<td style="font-style: italic"><span>' + gettextCatalog.getString("Remise de") + '</span> ' + $filter('number')(discountP, 2) + '%</td>' + '<td></td>' + '<td class="price">-' + $filter('currencyFormatFilter')(discountTTC) + '</td>' + '</tr>';
        }
        return lineContent;
    };

    SaleAdvanceView.prototype.printSell = function () {
        if (this.printWindow) {
            var site = this.siteView ? this.siteView : SiteData.defaultSite;

            var onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
            if (IOSDevice.isIOSDevice()) {
                onLoadContent = "window.print();";
            }

            var documentContent = '<!DOCTYPE html><html><head>' + '<link rel="stylesheet" type="text/css" href="/css/print.css" />' + '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' + '<script src="/lib/barcode/JsBarcode.js"></script>' + '<script src="/lib/barcode/EAN_UPC.js"></script>' + '</head><body onload="' + onLoadContent + '"><div class="reward-body">' + '<div class="company">' + '<div class="name">' + site.name + '</div>';

            if (site.siret && site.siret !== "" && site.country === Countries.FRANCE.countryCode) {
                documentContent += '<div class="address">' + gettextCatalog.getString("N° siret") + " : " + site.siret + '</div>';
            }
            if (site.vatNumber && site.vatNumber !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("N° TVA") + " : " + site.vatNumber + '</div>';
            }
            if (site.rcs && site.rcs !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("N°RCS") + " : " + site.rcs + '</div>';
            }
            if (site.nafCode && site.nafCode !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("Code NAF") + " : " + site.nafCode + '</div>';
            }

            var juridicForm = this.juridicForm ? this.juridicForm : '';
            var greffeCity = this.greffeCity ? ' Immatriculé au Greffe de : ' + this.greffeCity : '';
            var shareCapital = this.shareCapital ? 'Société au capital de : ' + this.shareCapital : '';
            documentContent += '<div class="address"> ' + juridicForm + greffeCity + '</div>';
            documentContent += '<div class="address">' + shareCapital + '</div>';

            if (site.address && site.address !== "") {
                documentContent += '<div class="address">' + site.address + '</div>';
                documentContent += '<div class="address">' + site.postalCode + ' ' + site.city;

                if (Countries.map[site.country]) {
                    documentContent += ' ' + Countries.map[site.country].countryName;
                }
                documentContent += '</div>';
            }

            if (site.phone && site.phone !== "") {
                documentContent += '<div class="phone">' + site.phone + '</div>';
            }
            if (this.dayView) {
                var currentDateTime = new Date();
                var labelDate = $filter('date')(currentDateTime, 'EEEE d MMMM yyyy');
                var labelTime = gettextCatalog.getString("A_TIME") + ' ' + $filter('date')(currentDateTime, "H':'mm':'ss.sss");
                var labelDateTimeCapitalized = labelDate.charAt(0).toUpperCase() + labelDate.substring(1) + ' ' + labelTime;
                documentContent += '</div>' + '<div class="global-info">' + '<div class="date">' + gettextCatalog.getString("Date") + " : " + labelDateTimeCapitalized + '</div>';
            }
            if (this.hrSellerView) {
                documentContent += '<div class="hr">' + gettextCatalog.getString("Encaissé par") + " : " + this.hrSellerView.label + '</div>';
            }

            if (this.customerView && this.customerLastname && this.customerFirstname) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerFirstname + ' ' + this.customerLastname + '</div>';
                if (this.customerAddress && this.customerZip && this.customerCity) {
                    documentContent += '<div class="customer">' + this.customerAddress + ' ' + this.customerCity + ' ' + this.customerZip + '</div>';
                }
            } else {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + gettextCatalog.getString("De passage") + '</div>';
            }

            var nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
            documentContent += '<div class="customer">' + gettextCatalog.getString("Facture d'acompte n°") + " : " + this.advanceNumber + ' (' + nbItems + ' lig.)</div>';

            if (this.signatureCode) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Signature ticket") + " : " + this.signatureCode + '</div>';
            }
            if (this.posView && this.posView.domainView.scope.ad.loggedUser.serverIdentification.version) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Logiciel") + " : " + Brand.label + ' V' + this.computeSoftV() + '(NF525)</div>';
            }
            documentContent += '</div><table class="bill">';

            var saleDiscountTTC = 0;
            var saleItemDiscountTTC = 0;
            var totalTTC = 0;

            for (var i = 0; i < this.saleServicesView.length; i++) {
                var discountTTC = this.getDiscount(this.saleServicesView[i], 1);
                totalTTC += this.saleServicesView[i].originalPrice;
                saleDiscountTTC += discountTTC;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleServicesView[i], discountTTC) + saleItemDiscountTTC;
                documentContent += this.addLineOnPrint(this.saleServicesView[i], 1, discountTTC, this.saleServicesView[i].label);
            }

            for (var _i7 = 0; _i7 < this.saleProductsView.length; _i7++) {
                var _discountTTC = this.getDiscount(this.saleProductsView[_i7], this.saleProductsView[_i7].quantity);
                totalTTC += this.saleProductsView[_i7].originalPrice * this.saleProductsView[_i7].quantity;
                saleDiscountTTC += _discountTTC;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleProductsView[_i7], _discountTTC) + saleItemDiscountTTC;
                documentContent += this.addLineOnPrint(this.saleProductsView[_i7], this.saleProductsView[_i7].quantity, _discountTTC, this.saleProductsView[_i7].label);
            }

            for (var _i8 = 0; _i8 < this.saleCuresView.length; _i8++) {
                var _discountTTC2 = this.getDiscount(this.saleCuresView[_i8], this.saleCuresView[_i8].quantity);
                totalTTC += this.saleCuresView[_i8].originalPrice * this.saleCuresView[_i8].quantity;
                saleDiscountTTC += _discountTTC2;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleCuresView[_i8], _discountTTC2) + saleItemDiscountTTC;
                documentContent += this.addLineOnPrint(this.saleCuresView[_i8], this.saleCuresView[_i8].quantity, _discountTTC2, this.saleCuresView[_i8].label);
            }

            for (var _i9 = 0; _i9 < this.loyaltyCardItemsView.length; _i9++) {
                var _discountTTC3 = this.getDiscount(this.loyaltyCardItemsView[_i9], 1);
                totalTTC += this.loyaltyCardItemsView[_i9].originalPrice;
                saleDiscountTTC += _discountTTC3;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.loyaltyCardItemsView[_i9], _discountTTC3) + saleItemDiscountTTC;
                documentContent += this.addLineOnPrint(this.loyaltyCardItemsView[_i9], 1, _discountTTC3, this.loyaltyCardItemsView[_i9].label);
            }

            var totalDiscountTTC = saleItemDiscountTTC + saleDiscountTTC;
            if (this.discountPercent !== 0 && saleItemDiscountTTC) {
                var gratuityLabel = this.discountPercent >= 100 ? gettextCatalog.getString("</br>Code 328 gratuité totale") : "";
                documentContent += '' + '<tr>' + '<td colspan="3" style="width:30px">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%' + gratuityLabel + '</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(saleItemDiscountTTC) + '</td>' + '</tr>';
            }

            if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                documentContent += '' + '<tr>' + '<td colspan="3" style="font-weight: bold">' + gettextCatalog.getString("Total TTC") + '</td>' + '<td class="price" style="font-weight: bold">' + $filter('currencyFormatFilter')(totalTTC - totalDiscountTTC) + '</td>' + '</tr>';
            }

            if (totalDiscountTTC) {
                documentContent += '' + '<tr>' + '<td colspan="3">' + gettextCatalog.getString("Total remises TTC") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(totalDiscountTTC) + '</td>' + '</tr>';
            }

            documentContent += '</table>';

            documentContent += '<table class="bill">';

            var giftGlobalDiscountTTC = 0;
            var documentContentGift = '';
            for (var _i10 = 0; _i10 < this.giftItemsView.length; _i10++) {
                var giftItemView = this.giftItemsView[_i10];
                var giftDiscountTTC = this.getDiscount(giftItemView, 1);
                giftGlobalDiscountTTC += this.getDiscountGlobalTTC(giftItemView, giftDiscountTTC);
                documentContentGift += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("1 Chèque cadeau") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(giftItemView.originalPrice) + '</td>' + '</tr>';
                if (giftDiscountTTC) {
                    documentContentGift += '' + '<td colspan="4" style="width:30px">' + gettextCatalog.getString("Remise de") + ' ' + $filter('number')(giftItemView.discountPercent, 2) + '%</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(giftDiscountTTC) + '</td>' + '</tr>';
                }
            }

            if (giftGlobalDiscountTTC) {
                documentContentGift += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(giftGlobalDiscountTTC) + '</td>' + '</tr>';
            }

            if (documentContentGift !== '') {
                documentContent += documentContentGift;
            }

            if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                documentContent += '' + '<tr>' + '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Code") + '</td>' + '<td class="price-tva" style="width:30px"></td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL TVA") + '</td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL HT") + '</td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL TTC") + '</td>' + '</tr>';

                var totalVat = 0,
                    totalHT = 0,
                    _totalTTC = 0;

                for (var _i11 = 0; _i11 < this.vatLines.length; _i11++) {
                    if (this.posView && this.posView.domainView && this.posView.domainView.getDefaultVatTax() === this.vatLines[_i11].tax || this.vatLines[_i11].amount !== 0 || this.vatLines[_i11].ht !== 0) {

                        //var ht = this.vatLines[i].amount / (this.vatLines[i].tax) * 100;
                        var ht = this.vatLines[_i11].ht;

                        totalVat += this.vatLines[_i11].amount ? this.vatLines[_i11].amount : 0;
                        totalHT += ht ? ht : 0;
                        _totalTTC += (this.vatLines[_i11].amount ? this.vatLines[_i11].amount : 0) + (ht ? ht : 0);

                        documentContent += '' + '<tr>' + '<td class="price-tva" style="text-align:left">' + this.vatLines[_i11].code + '</td>' + '<td class="price-tva">' + $filter('number')(this.vatLines[_i11].tax, 2) + '%' + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[_i11].amount) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(ht) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[_i11].amount + ht) + '</td>' + '</tr>';
                    }
                }
                documentContent += '' + '<tr>' + '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Total") + '</td>' + '<td class="price-tva" style="width:30px"></td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(totalVat) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(totalHT) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(_totalTTC) + '</td>' + '</tr>';
            }

            documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Règlement(s)") + '</td>' + '<td></td>' + '</tr>';

            if (this.advancePrice !== 0) {
                documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Montant de l\'acompte : ") + '</td>' + '<td>' + $filter('currencyFormatFilter')(this.advancePrice) + '</td>' + '</tr>';

                documentContent += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Taux : ") + '</td>' + '<td>' + $filter('number')(Math.abs(this.advancePrice / this.price * 100), 2) + '%</td>' + '</tr>' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>';
            }

            var payed = 0;
            var advanceNumberAdded = false;
            for (var _i12 = 0; _i12 < this.paymentsView.length; _i12++) {
                documentContent += '' + '<tr>' + '<td>';

                if (this.paymentsView[_i12].type !== 'UNPAID') {
                    documentContent += $filter('date')(this.paymentsView[_i12].date, 'shortDate');
                }
                documentContent += '</td><td colspan="3">';

                var salePaymentType = SalePaymentTypeFactory.from(this.paymentsView[_i12].type);
                if (salePaymentType) {
                    documentContent += salePaymentType.label;
                } else if (this.paymentsView[_i12].otherPaymentTypeView) {
                    documentContent += this.paymentsView[_i12].otherPaymentTypeView.label;
                }

                if (!advanceNumberAdded && this.advanceNumber) {
                    documentContent += " " + gettextCatalog.getString("Acompte n°") + this.advanceNumber;
                    advanceNumberAdded = true;
                }

                documentContent += '' + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(this.paymentsView[_i12].price) + '</td>' + '</tr>';
                payed += this.paymentsView[_i12].price;
            }
            if (this.price - payed > 0) {
                documentContent += '' + '<tr>' + '<td></td>' + '<td colspan="3">' + gettextCatalog.getString("Reste à payer") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(this.price - payed) + '</td>' + '</tr>';
            }

            documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '</table>';

            if (this.loyaltyCardItemView) {
                documentContent += "<table class=\"loyalty\">";
                documentContent += '<tr><td>' + gettextCatalog.getString("Fidélité") + '</td><td>' + this.loyaltyCardItemView.label + "</td></tr>";
                if (this.loyaltyCardItemView.type !== "subs") {
                    documentContent += '<tr><td>' + gettextCatalog.getString("Nouveau solde") + '</td><td>' + this.totalLoyaltyPts + " pts</td></tr>";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Ancien solde") + '</td><td>' + (this.totalLoyaltyPts - this.loyaltyPts) + " pts</td></tr>";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Point cumulé") + '</td><td>' + (this.hasLoyaltyDiscount ? this.loyaltyPts + this.loyaltyCardItemView.goalPts : this.loyaltyPts) + " pts</td></tr>";
                    if (this.nbLoyaltyCardGoal <= 0) {
                        documentContent += "<tr><td>";

                        if (this.loyaltyCardItemView.pts < this.loyaltyCardItemView.goalPts) {
                            documentContent += gettextCatalog.getString("Prochaine récompense") + ' </td><td>' + this.loyaltyCardItemView.goalPts + " pts";
                        } else {
                            documentContent += gettextCatalog.getString("Au prochain achat") + '</td><td>';
                            if (this.loyaltyCardItemView.goalType === "special") {
                                documentContent += this.loyaltyCardItemView.goalText;
                            } else {
                                documentContent += "Remise de " + this.loyaltyCardItemView.computeGoalAmountNextSale();
                                if (this.loyaltyCardItemView.goalType === "discountValue") {
                                    documentContent += " " + CurrencyManager.getCurrencySymbol();
                                } else {
                                    documentContent += " %";
                                }
                            }
                            documentContent += "</td></tr>";
                        }
                    }
                }

                if (this.loyaltyCardItemView.validityDate) {
                    documentContent += '<tr><td>' + gettextCatalog.getString("Validité") + '</td><td>' + $filter('date')(this.loyaltyCardItemView.validityDate, 'shortDate') + "</td></tr></table>";
                }
            }

            if (this.posView && this.posView.domainView.ticketEndText && this.posView.domainView.ticketEndText !== '') {
                documentContent += '<div>' + this.posView.domainView.ticketEndText + '</div>';
            }

            for (var _i13 = 0; _i13 < this.giftItemsView.length; _i13++) {
                if (this.giftItemsView[_i13].editionType !== "manual") {
                    documentContent += '<div style="border: 1px dotted black;margin: 5px;padding: 5px;text-align: center"><div style="font-size: 16px;padding-bottom: 3px">' + gettextCatalog.getString("Chèque cadeau de") + " " + $filter('currencyFormatFilter')(this.giftItemsView[_i13].originalPrice) + '</div><div><img id="barcode' + _i13 + '"/></div><div>';
                    documentContent += this.giftItemsView[_i13].code;
                    documentContent += '</div><div>' + gettextCatalog.getString("Valable jusqu'au") + " " + $filter('date')(this.giftItemsView[_i13].validityDate, 'shortDate') + '</div></div><script>$(document).ready(function() {$("#barcode' + _i13 + '").JsBarcode("';
                    documentContent += this.giftItemsView[_i13].code.replace(/-/g, "");
                    documentContent += '",{format:"EAN",displayValue:false,fontSize:16,height: 50});});</script>';
                }
            }

            if (this.posView && this.posView.domainView.ticketEndDisplayBooking) {
                var now = new Date();

                if (this.customerView && this.customerView.globalHistoryView) {
                    var nextBooking = '<table class="bill" style="border: 1px dotted black;padding: 5px;text-align: center"><tr><th colspan="2" style="text-align:left">' + gettextCatalog.getString("Prochains rendez-vous") + '</th></tr>',
                        clonedHistory = this.customerView.globalHistoryView.copyWithin(0, 0),
                        hasNextBooking = false;

                    clonedHistory.sort(function (a, b) {
                        if (a.date < b.date) {
                            return -1;
                        }
                        if (a.date > b.date) {
                            return 1;
                        }
                        return 0;
                    });

                    for (var _i14 = 0; _i14 < clonedHistory.length; _i14++) {
                        var bookingTime = null;
                        if (clonedHistory[_i14].bookingPeriod && clonedHistory[_i14].bookingPeriod.start) {
                            bookingTime = clonedHistory[_i14].date.getTime() + clonedHistory[_i14].bookingPeriod.start.getTimeInMilli();
                        }

                        var filterdHistory = $filter('filter')(clonedHistory[_i14].items, { type: "service" });

                        if (bookingTime && bookingTime > now.getTime() && filterdHistory && filterdHistory.length !== 0) {
                            hasNextBooking = true;
                            nextBooking += '<tr>' + '<td style="width:120px;vertical-align:top;text-align:left;">' + $filter('date')(clonedHistory[_i14].date, 'shortDate') + " " + gettextCatalog.getString("à") + " " + clonedHistory[_i14].bookingTime + '</td>' + '<td style="vertical-align:top;text-align:left;padding-left:5px">' + '<span>' + filterdHistory[0].label + '</span>';

                            for (var j = 1; j < filterdHistory.length; j++) {
                                nextBooking += '<span>, ' + filterdHistory[j].label + '</span>';
                            }
                            nextBooking += '</td></tr>';
                        }
                    }
                    nextBooking += '</table>';
                    if (hasNextBooking) {
                        documentContent += nextBooking;
                    }
                }
            }

            documentContent += '</div></body></html>';
            this.printWindow.document.write(documentContent);
            this.printWindow.document.title = gettextCatalog.getString("Imprimer");
            this.printWindow.document.close();
        }
    };

    SaleAdvanceView.prototype.computeSoftV = function () {
        var softV = void 0;
        if (this.softV) {
            softV = this.softV.includes("backend") ? this.softV.substr(8) : this.softV;
            softV = softV.includes(".") ? softV.substr(0, softV.indexOf(".")) : softV;
        } else {
            softV = this.posView.domainView.scope.ad.loggedUser.serverIdentification.version;
        }
        return softV;
    };

    return SaleAdvanceView;
}]);

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SaleCureView', ["$sce", "SaleCureData", "SaleCure", "$filter", "CureItemView", "CureItem", "CureItemData", "CurrencyManager", "NumberSeparatorType", function ($sce, SaleCureData, SaleCure, $filter, CureItemView, CureItem, CureItemData, CurrencyManager, NumberSeparatorType) {

    var SaleCureView = function SaleCureView(saleCure, scIndex, billPosition, saleView) {
        this.scIndex = scIndex; //model index
        this.posView = saleView ? saleView.posView : null;
        this.saleView = saleView;
        this.cureView = null;
        this.label = "";
        this.price = 0;
        this.priceHT = 0;
        this.vat = null;
        this.vatCode = null;
        this.originalPrice = 0;
        this.originalPriceInput = "";
        this.discountPercent = 0;
        this.quantity = 0;
        this.quantityInput = 0; //input value binded
        this.hrView;
        this.billPosition = billPosition; //position inside sale ->
        this.cureItemsView = [];
        if (saleCure) this.loadDataFrom(saleCure);
    };
    SaleCureView.prototype.getModel = function () {
        if (this.scIndex != -1) {
            return SaleCureData.getByIndex(this.scIndex);
        }
        return null;
    };
    SaleCureView.prototype.loadDataFrom = function (saleCure) {
        //Assume here than the object in parameter contains only id (must load them)
        if (saleCure) {
            if (saleCure.cure && this.posView && this.posView.domainView) this.cureView = this.posView.domainView.getCureView(saleCure.cure);
            this.label = saleCure.label;
            this.price = saleCure.price;
            if (saleCure.vatCode) {
                this.vat = saleCure.vat;
                this.vatCode = saleCure.vatCode;
            } else {
                if (this.saleView) {
                    this.vat = this.saleView.vat;
                    this.vatCode = this.saleView.vatCode;
                }
            }
            this.updatePriceHT();
            if (saleCure.originalPrice != null) this.originalPrice = saleCure.originalPrice;else this.originalPrice = this.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.discountPercent = saleCure.discountPercent;
            this.quantity = saleCure.quantity;
            this.quantityInput = saleCure.quantity;
            if (saleCure.humanResource && this.posView && this.posView.domainView) this.hrView = this.posView.domainView.getHrView(saleCure.humanResource);

            this.loadCureItems(saleCure);
        }
    };
    SaleCureView.prototype.loadCureItems = function (saleCure) {
        this.cureItemsView = [];
        if (saleCure && saleCure.cureItems && this.posView) for (var i = 0; i < saleCure.cureItems.length; i++) {
            this.cureItemsView.push(new CureItemView(saleCure.cureItems[i], CureItemData.getIndexOf(saleCure.cureItems[i]), this, this.posView.domainView));
        }
    };

    SaleCureView.prototype.copyDataTo = function (saleCure) {
        if (saleCure) {
            saleCure.label = this.label;
            if (this.cureView) saleCure.cure = this.cureView.getModel();
            saleCure.price = this.price;
            saleCure.vat = this.vat;
            saleCure.vatCode = this.vatCode;
            saleCure.originalPrice = this.originalPrice;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                saleCure.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                saleCure.discountPercent = parseFloat(saleCure.discountPercent);
            } else saleCure.discountPercent = this.discountPercent;
            saleCure.quantity = this.quantity;

            var newSale = this.saleView.getModel();
            if (saleCure.sale && newSale !== saleCure.sale) //remove
                saleCure.sale.removeSaleCure(saleCure);
            if (newSale) //Force add because removed by sale.updateModel
                newSale.addSaleCure(saleCure);
            if (this.hrView) saleCure.humanResource = this.hrView.getModel();

            if (saleCure.cureItems) {
                var oldCureitems = saleCure.cureItems;
                saleCure.cureItems = [];
                var cureItem = null;
                for (var i = 0; i < this.cureItemsView.length; i++) {
                    if (i < oldCureitems.length) //copy exising
                        cureItem = oldCureitems[i];else cureItem = new CureItem(null, saleCure);

                    this.cureItemsView[i].copyDataTo(cureItem);
                    saleCure.addCureItem(cureItem);
                }
            }
        }
    };

    SaleCureView.prototype.getClone = function (saleView) {
        var spView = new SaleCureView(null, -1, this.billPosition, saleView);
        spView.vatCode = this.vatCode;
        spView.vat = this.vat;
        spView.label = this.label;
        spView.cureView = this.cureView;
        spView.price = this.price;
        spView.originalPrice = this.originalPrice;
        spView.originalPriceInput = this.originalPriceInput;
        spView.discountPercent = this.discountPercent;
        spView.quantity = this.quantity;
        spView.quantityInput = this.quantityInput;
        spView.hrView = this.hrView;
        spView.updateCureItems();
        return spView;
    };
    SaleCureView.prototype.selectCure = function () {
        if (this.cureView) this.cureView.isSelected = true;
    };

    SaleCureView.prototype.updateOriginalPriceInputArrow = function (number) {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") originalPrice += number;

            this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
            this.originalPrice = originalPrice;
            this.updatePrice();
        }
    };

    SaleCureView.prototype.onOriginalPriceInputChange = function () {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") {
                this.originalPrice = originalPrice;
            } else {
                this.originalPrice = null;
            }
            this.updatePrice();
        }
    };

    SaleCureView.prototype.setCure = function (cureView, isOnInternet) {
        this.cureView = cureView;
        if (cureView != null) {
            if (this.posView && this.posView.domainView) {
                var vatView = this.posView.domainView.getDefaultVatView();
                if (vatView) {
                    this.vat = vatView.tax;
                    this.vatCode = vatView.code;
                }
            }
            this.label = cureView.label;
            this.originalPrice = cureView.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.quantity++;
            this.quantityInput++;
            if (isOnInternet !== undefined && isOnInternet && cureView.hasInternetPrice) this.discountPercent = cureView.internetDiscountPercent;
            this.updatePrice();
            var cureItemView = new CureItemView();
            this.cureItemsView.push(cureItemView);
            cureItemView.init(this);
        }
    };
    SaleCureView.prototype.hasCureItemUsage = function () {
        var hasUsage = false;
        for (var i = 0; i < this.cureItemsView.length && !hasUsage; i++) {
            hasUsage = this.cureItemsView[i].hasCureItemUsage();
        }return hasUsage;
    };
    SaleCureView.prototype.setHrView = function (hrView) {
        this.hrView = hrView;
    };
    SaleCureView.prototype.updatePriceHT = function () {
        this.priceHT = Math.round(100 / (100 + this.saleView.vat) * this.price * 100) / 100;
    };
    SaleCureView.prototype.onChangeQuantity = function () {
        if (this.cureView != null) {
            if (this.quantityInput <= 0) {
                this.quantityInput = 1;
            }
            this.quantity = this.quantityInput;
            this.updatePrice();
            this.updateCureItems();
        }
    };
    SaleCureView.prototype.updateCureItems = function () {
        var oldCureitemsView = this.cureItemsView;
        this.cureItemsView = [];
        var cureItemView = null;
        for (var i = 0; i < this.quantity; i++) {
            if (i < oldCureitemsView.length) this.cureItemsView.push(oldCureitemsView[i]);else {
                cureItemView = new CureItemView();
                this.cureItemsView.push(cureItemView);
                cureItemView.init(this);
            }
        }
    };
    SaleCureView.prototype.increaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (step + this.discountPercent > 100) this.discountPercent = 100;else this.discountPercent += step;
            this.updatePrice();
        }
    };
    SaleCureView.prototype.decreaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (this.discountPercent - step < 0) this.discountPercent = 0;else this.discountPercent -= step;
            this.updatePrice();
        }
    };

    SaleCureView.prototype.updatePrice = function () {
        var oriPrice = this.originalPrice * this.quantity;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.updatePriceHT();
            this.saleView.resetPayments();
            this.saleView.calculateSaleFields();
        }
        this.saleView.checkForInvalidAmounts();
    };
    SaleCureView.prototype.updateModel = function () {
        var saleCure = this.getModel();
        if (saleCure == null) {
            saleCure = new SaleCure();
            this.scIndex = SaleCureData.getIndexOf(saleCure);
        }
        this.copyDataTo(saleCure);
    };

    SaleCureView.prototype.removeModel = function () {};
    SaleCureView.prototype.reloadModel = function () {
        var saleCure = this.getModel();
        if (saleCure == null) {
            //this.parentCategoryView.removeSaleCureView(this);
        } else {
            this.loadDataFrom(saleCure);
        }
    };

    SaleCureView.prototype.canSave = function () {
        if (!this.cureView) return false;
        var quantityInt = parseInt(this.quantity);
        if (quantityInt !== "NaN" && quantityInt !== "") {
            this.quantity = quantityInt;
        } else {
            this.quantity = null;
        }
        var priceFloat = parseFloat(this.price);
        if (priceFloat !== "NaN" && priceFloat !== "") {
            this.price = priceFloat;
        } else {
            this.price = "";
        }

        if (this.label && this.label != "" && //titre
        this.price && this.price >= 0 //prix (décimal)
        && this.quantity != null && this.quantity > 0 //durée (entier)
        ) {
                return true;
            } else {
            return false;
        }
    };

    return SaleCureView;
}]);

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SaleProductView', ["$sce", "SaleProductData", "SaleProduct", "$filter", "CurrencyManager", "NumberSeparatorType", function ($sce, SaleProductData, SaleProduct, $filter, CurrencyManager, NumberSeparatorType) {

    var SaleProductView = function SaleProductView(saleProduct, spIndex, billPosition, saleView) {
        this.spIndex = spIndex; //model index
        this.posView = saleView ? saleView.posView : null;
        this.saleView = saleView;
        this.productView = null;
        this.label = "";
        this.price = 0;
        this.priceHT = 0;
        this.vat = null;
        this.vatCode = null;
        this.originalPrice = 0;
        this.originalPriceInput = "";
        this.discountPercent = 0;
        this.quantity = 0;
        this.quantityInput = 0; //input value binded
        this.hrView;
        this.billPosition = billPosition; //position inside sale ->
        if (saleProduct) this.loadDataFrom(saleProduct);
    };
    SaleProductView.prototype.getModel = function () {
        if (this.spIndex != -1) {
            return SaleProductData.getByIndex(this.spIndex);
        }
        return null;
    };
    SaleProductView.prototype.loadDataFrom = function (saleProduct) {
        //Assume here than the object in parameter contains only id (must load them)
        if (saleProduct) {
            if (saleProduct.product && this.posView && this.posView.domainView) this.productView = this.posView.domainView.getProductView(saleProduct.product);
            this.label = saleProduct.label;
            this.price = saleProduct.price;
            this.vat = saleProduct.vat;
            if (saleProduct.vatCode) this.vatCode = saleProduct.vatCode;
            this.updatePriceHT();
            if (saleProduct.originalPrice != null) this.originalPrice = saleProduct.originalPrice;else this.originalPrice = this.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.discountPercent = saleProduct.discountPercent;
            this.quantity = saleProduct.quantity;
            this.quantityInput = saleProduct.quantity;
            if (saleProduct.humanResource && this.posView && this.posView.domainView) this.hrView = this.posView.domainView.getHrView(saleProduct.humanResource);
        }
    };

    SaleProductView.prototype.copyDataTo = function (saleProduct) {
        if (saleProduct) {
            saleProduct.label = this.label;
            if (this.productView) saleProduct.product = this.productView.getModel();
            saleProduct.price = this.price;
            saleProduct.originalPrice = this.originalPrice;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                saleProduct.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                saleProduct.discountPercent = parseFloat(saleProduct.discountPercent);
            } else saleProduct.discountPercent = this.discountPercent;
            saleProduct.quantity = this.quantity;
            saleProduct.vat = this.vat;
            saleProduct.vatCode = this.vatCode;
            var newBooking = this.saleView.getModel();
            if (saleProduct.sale && newBooking !== saleProduct.sale) //remove
                saleProduct.sale.removeSaleProduct(saleProduct);
            if (newBooking) //Force add because removed by sale.updateModel
                newBooking.addSaleProduct(saleProduct);
            if (this.hrView) saleProduct.humanResource = this.hrView.getModel();
        }
    };

    SaleProductView.prototype.getClone = function (saleView) {
        var spView = new SaleProductView(null, -1, this.billPosition, saleView);
        spView.label = this.label;
        spView.productView = this.productView;
        spView.price = this.price;
        spView.originalPrice = this.originalPrice;
        spView.vat = this.vat;
        spView.vatCode = this.vatCode;
        spView.originalPriceInput = this.originalPriceInput;
        spView.discountPercent = this.discountPercent;
        spView.quantity = this.quantity;
        spView.quantityInput = this.quantityInput;
        spView.hrView = this.hrView;
        return spView;
    };
    SaleProductView.prototype.selectProduct = function () {
        if (this.productView) this.productView.isSelected = true;
    };

    SaleProductView.prototype.updateOriginalPriceInputArrow = function (number) {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") originalPrice += number;

            this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
            this.originalPrice = originalPrice;
            this.updatePrice();
        }
    };

    SaleProductView.prototype.onOriginalPriceInputChange = function () {
        if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") {
                this.originalPrice = originalPrice;
            } else {
                this.originalPrice = null;
            }
            this.updatePrice();
        }
    };

    SaleProductView.prototype.setProduct = function (productView, isOnInternet, ignoreProductQuantity) {
        this.productView = productView;
        if (productView != null) {
            this.label = productView.label;
            this.originalPrice = productView.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            if (productView.hasQuantity && !ignoreProductQuantity) productView.quantity--;
            this.quantity++;
            this.quantityInput++;
            if (productView.vatView) {
                this.vat = productView.vatView.tax;
                this.vatCode = productView.vatView.code;
            } else if (this.posView && this.posView.domainView) {
                var vatView = this.posView.domainView.getDefaultVatView();
                if (vatView) {
                    this.vat = vatView.tax;
                    this.vatCode = vatView.code;
                }
            }
            if (isOnInternet !== undefined && isOnInternet && productView.hasInternetPrice) this.discountPercent = productView.internetDiscountPercent;
            this.updatePrice();
        }
    };

    SaleProductView.prototype.setHrView = function (hrView) {
        this.hrView = hrView;
    };
    SaleProductView.prototype.updatePriceHT = function () {
        this.priceHT = Math.round(100 / (100 + this.vat) * this.price * 100) / 100;
    };
    SaleProductView.prototype.onChangeQuantity = function (refuseOverStock) {
        var ignoreQuantity = this.saleView != null && this.saleView.isEstimationCost();

        if (this.productView != null && this.saleView && !this.saleView.isReadOnly) {
            if (this.productView.hasQuantity && !ignoreQuantity) {
                var newProductQt = this.productView.quantity + this.quantity - this.quantityInput;
                if (refuseOverStock !== undefined && refuseOverStock && newProductQt < 0) this.quantityInput = this.quantity;else this.productView.quantity = newProductQt;
            }
            this.quantity = this.quantityInput;
            this.updatePrice();
        }
    };
    SaleProductView.prototype.updateQuantity = function (step, allowOverStock) {
        var update = false;
        if (!isNaN(this.quantityInput)) this.quantityInput = Number(this.quantityInput);else if (this.quantityInput == "") this.quantityInput = 0;
        if (this.productView != null && this.saleView && !this.saleView.isReadOnly && this.quantityInput + step >= 0) {
            if (this.productView.hasQuantity) {
                var newProductQt = 0;
                if (step == 0) {
                    //if quantity is updated by ng-change (not arrow click), productQt = new quantity - old quantity.
                    newProductQt = this.productView.quantity - (this.quantityInput - this.quantity);
                } else {
                    newProductQt = this.productView.quantity - step;
                }

                if (allowOverStock || newProductQt >= 0) {
                    update = true;
                    this.quantityInput += step;
                } else if (step == 0 && newProductQt < 0) {
                    this.quantityInput = this.quantity;
                }
            } else {
                update = true;
                this.quantityInput += step;
            }
            if (update) this.onChangeQuantity();
        }
        return update;
    };
    SaleProductView.prototype.increaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (step + this.discountPercent > 100) this.discountPercent = 100;else this.discountPercent += step;
            this.updatePrice();
        }
    };
    SaleProductView.prototype.decreaseDiscountPercent = function (step) {
        if (this.saleView && !this.saleView.isReadOnly) {
            if (this.discountPercent - step < 0) this.discountPercent = 0;else this.discountPercent -= step;
            this.updatePrice();
        }
    };
    SaleProductView.prototype.updatePrice = function () {
        var oriPrice = this.originalPrice * this.quantity;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.updatePriceHT();
            this.saleView.resetPayments();
            this.saleView.calculateSaleFields();
        }
        this.saleView.checkForInvalidAmounts();
    };
    SaleProductView.prototype.updateModel = function (previousSaleStatus) {
        var saleProduct = this.getModel();
        if (saleProduct == null) {
            saleProduct = new SaleProduct();
            this.spIndex = SaleProductData.getIndexOf(saleProduct);
        } else if (saleProduct.product && saleProduct.product.hasQuantity && previousSaleStatus !== 'estimation') //add quantity to old product
            saleProduct.product.quantity += saleProduct.quantity;
        this.copyDataTo(saleProduct);
        if (saleProduct.product && saleProduct.product.hasQuantity && this.saleView && (this.saleView.status === "advance" || this.saleView.status === "waiting" || this.saleView.status === "sold")) saleProduct.product.quantity -= saleProduct.quantity;
    };

    SaleProductView.prototype.removeModel = function () {
        var saleProduct = this.getModel();
        if (saleProduct && saleProduct.product && saleProduct.product.hasQuantity) //add quantity to old product
            saleProduct.product.quantity += saleProduct.quantity;
    };
    SaleProductView.prototype.reloadModel = function () {
        var saleProduct = this.getModel();
        if (saleProduct == null) {
            //this.parentCategoryView.removeSaleProductView(this);
        } else {
            this.loadDataFrom(saleProduct);
        }
    };

    SaleProductView.prototype.canSave = function () {
        if (!this.productView) return false;
        var quantityInt = parseInt(this.quantity);
        if (quantityInt !== "NaN" && quantityInt !== "") {
            this.quantity = quantityInt;
        } else {
            this.quantity = null;
        }
        var priceFloat = parseFloat(this.price);
        if (priceFloat !== "NaN" && priceFloat !== "") {
            this.price = priceFloat;
        } else {
            this.price = "";
        }

        if (this.label && this.label != "" && //titre
        this.price && this.price >= 0 //prix (décimal)
        && this.quantity != null && this.quantity > 0 //durée (entier)
        ) {
                return true;
            } else {
            return false;
        }
    };

    return SaleProductView;
}]);

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change @his template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SaleServiceView', ["$sce", "SaleServiceData", "SaleService", "$filter", "CurrencyManager", "NumberSeparatorType", function ($sce, SaleServiceData, SaleService, $filter, CurrencyManager, NumberSeparatorType) {

    var SaleServiceView = function SaleServiceView(saleService, ssIndex, billPosition, saleView, parentSaleServiceView) {
        this.ssIndex = ssIndex; //model index
        this.posView = saleView ? saleView.posView : null;
        this.saleView = saleView;
        this.serviceView = null;
        this.label = "";
        this.price = 0;
        this.priceInput = "";
        this.vat = null;
        this.vatCode = null;
        this.priceHT = 0;
        this.originalPrice = 0;
        this.originalPriceInput = "";
        this.discountPercent = 0;
        this.hrView;
        this.subSaleServicesView = [];
        this.billPosition = billPosition; //position inside sale ->
        this.isSubSaleServicesViewHidden = true;
        this.uniqueSubSaleServiceHr = null;
        this.initialProportion = 0;

        if (parentSaleServiceView !== undefined && parentSaleServiceView != null) this.parentSaleServiceView = parentSaleServiceView;else this.parentSaleServiceView = null;

        if (saleService) this.loadDataFrom(saleService);else this.initVat();
    };
    SaleServiceView.prototype.getModel = function () {
        if (this.ssIndex != -1) {
            return SaleServiceData.getByIndex(this.ssIndex);
        }
        return null;
    };
    SaleServiceView.prototype.loadDataFrom = function (saleService) {
        //Assume here than the object in parameter contains only id (must load them)
        if (saleService) {
            if (saleService.service && this.getSaleView() && this.getPosView() && this.getPosView().domainView) this.serviceView = this.getPosView().domainView.getServiceView(saleService.service);
            this.label = saleService.label;
            this.price = saleService.price;
            if (saleService.vatCode) {
                this.vat = saleService.vat;
                this.vatCode = saleService.vatCode;
            } else {
                if (this.getSaleView()) {
                    this.vat = this.getSaleView().vat;
                    this.vatCode = this.getSaleView().vatCode;
                }
            }
            this.updatePriceHT();
            if (saleService.originalPrice != null) {
                this.originalPrice = saleService.originalPrice;
            } else {
                this.originalPrice = this.price;
            }
            this.calculateSubSaleInitialProportion(this);

            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            this.discountPercent = saleService.discountPercent;
            if (saleService.humanResource && this.getSaleView() && this.getSaleView().posView) this.hrView = this.getSaleView().posView.domainView.getHrView(saleService.humanResource);

            this.loadSubSaleServiceView(saleService);
        }
    };

    SaleServiceView.prototype.loadSubSaleServiceView = function (saleService) {
        if (saleService && saleService.service) {
            this.subSaleServicesView = [];
            var sumSubServicesPrice = 0;
            for (var j = 0; j < saleService.subSaleServices.length; j++) {
                var sssView = new SaleServiceView(saleService.subSaleServices[j], SaleServiceData.getIndexOf(saleService.subSaleServices[j]), String.fromCharCode(97 + j), null, this);
                this.addSubSaleServiceView(sssView);
                sumSubServicesPrice += sssView.price;
            }

            this.updateUniqueSubServiceHr();
        }
    };

    SaleServiceView.prototype.copyDataTo = function (saleService, parentSaleService) {
        if (saleService) {
            saleService.label = this.label;
            if (this.serviceView) saleService.service = this.serviceView.getModel();
            saleService.price = this.price;
            saleService.vat = this.vat;
            saleService.vatCode = this.vatCode;
            saleService.parentSaleService = parentSaleService;

            saleService.originalPrice = this.originalPrice;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                saleService.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                saleService.discountPercent = parseFloat(saleService.discountPercent);
            } else saleService.discountPercent = this.discountPercent;

            var newSale = this.saleView ? this.saleView.getModel() : null;
            if (saleService.sale && newSale !== saleService.sale) //remove
                saleService.sale.removeSaleService(saleService);
            if (newSale) //Force add because removed by sale.updateModel
                newSale.addSaleService(saleService);

            if (this.hrView) saleService.humanResource = this.hrView.getModel();

            saleService.subSaleServices = [];
            var subSaleService = null;

            for (var i = 0; i < this.subSaleServicesView.length; i++) {
                subSaleService = this.subSaleServicesView[i].getModel();

                if (subSaleService == null) {
                    subSaleService = new SaleService();
                    this.subSaleServicesView[i].servIndex = SaleServiceData.getIndexOf(subSaleService);
                }
                this.subSaleServicesView[i].copyDataTo(subSaleService, saleService);
                saleService.subSaleServices.push(subSaleService);
            }
        }
    };

    SaleServiceView.prototype.getClone = function (saleView, parentClone) {
        var ssView = new SaleServiceView(null, -1, this.billPosition, saleView, parentClone);
        ssView.label = this.label;
        ssView.vatCode = this.vatCode;
        ssView.vat = this.vat;
        ssView.serviceView = this.serviceView;
        ssView.price = this.price;
        ssView.priceInput = this.priceInput;
        ssView.originalPrice = this.originalPrice;
        ssView.originalPriceInput = this.originalPriceInput;
        ssView.discountPercent = this.discountPercent;
        ssView.hrView = this.hrView;

        for (var i = 0; i < this.subSaleServicesView.length; i++) {
            ssView.subSaleServicesView.push(this.subSaleServicesView[i].getClone(null, this));
        }return ssView;
    };

    SaleServiceView.prototype.calculateSubSaleInitialProportion = function (subSaleServiceView) {
        if (subSaleServiceView.parentSaleServiceView) {
            var originalPrice = subSaleServiceView.parentSaleServiceView.originalPrice;
            if (originalPrice === 0 || isNaN(originalPrice)) {
                var subServiceView = subSaleServiceView.serviceView;
                if (subServiceView && subServiceView.parentServiceView && subServiceView.parentServiceView.price !== 0) {
                    subSaleServiceView.initialProportion = subServiceView.price / subServiceView.parentServiceView.price;
                }
            } else {
                subSaleServiceView.initialProportion = subSaleServiceView.originalPrice / originalPrice;
            }
        }
    };

    SaleServiceView.prototype.setPriceAsCredit = function () {
        this.price = -this.price;
        for (var i = 0; i < this.subSaleServicesView.length; i++) {
            this.subSaleServicesView[i].price = -this.subSaleServicesView[i].price;
        }
    };
    SaleServiceView.prototype.loadBookingServiceView = function (bsView) {
        this.label = bsView.label;
        this.serviceView = bsView.serviceView;
        this.price = bsView.price;
        this.priceInput = bsView.priceInput;
        this.originalPrice = bsView.originalPrice;
        this.originalPriceInput = bsView.originalPriceInput;
        this.discountPercent = bsView.discountPercent;
        if (bsView.plgDayHrView) this.hrView = bsView.plgDayHrView.hrView;
    };

    SaleServiceView.prototype.updateOriginalPriceInputArrow = function (number) {
        if (this.getSaleView() && !this.getSaleView().isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);
            if (originalPrice !== "NaN") {
                originalPrice += number;
            }
            this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
            this.updateOriginalPrice(originalPrice);
            this.updatePrice();
        }
    };

    SaleServiceView.prototype.onOriginalPriceInputChange = function () {
        if (this.getSaleView() && !this.getSaleView().isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
            var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
            var originalPrice = parseFloat(originalPriceStr);

            this.updateOriginalPrice(originalPrice);
            this.updatePrice();
        }
    };

    SaleServiceView.prototype.updateOriginalPrice = function (newOriginalPrice) {
        if (newOriginalPrice && newOriginalPrice !== "NaN") {
            this.originalPrice = newOriginalPrice;
        } else {
            this.originalPrice = null;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this.subSaleServicesView[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var subSaleServiceView = _step.value;

                var subServiceNewOriginalPrice = subSaleServiceView.initialProportion * newOriginalPrice;
                if (subServiceNewOriginalPrice !== "NaN" && !isNaN(subServiceNewOriginalPrice)) {
                    subSaleServiceView.originalPrice = subServiceNewOriginalPrice;
                } else {
                    subSaleServiceView.originalPrice = null;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    SaleServiceView.prototype.updatePriceInputArrow = function (number) {
        if (this.getSaleView() && !this.getSaleView().isReadOnly && this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (price !== "NaN") price += number;

            this.price = price;
            this.priceInput = $filter('currencyFormatFilter')(price);
        }
    };

    SaleServiceView.prototype.updateDiscountPercentSubServices = function () {
        if (this.subSaleServicesView.length > 0) {
            for (var i = 0; i < this.subSaleServicesView.length; i++) {
                this.subSaleServicesView[i].discountPercent = this.discountPercent;
            }
        }
    };

    SaleServiceView.prototype.onDiscountPercentInputChange = function () {
        this.getSaleView().checkForInvalidAmounts();
        this.updateDiscountPercentSubServices();
        this.updatePrice();
    };

    SaleServiceView.prototype.onPriceInputChange = function () {
        if (this.getSaleView() && !this.getSaleView().isReadOnly && this.priceInput != null && typeof this.priceInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (price !== "NaN") {
                this.price = price;
                this.priceInput = $filter('currencyFormatFilter')(this.price);
            } else this.price = null;
        }
    };

    SaleServiceView.prototype.hasSubSaleServiceView = function (saleServiceView) {
        return this.subSaleServicesView.indexOf(saleServiceView) != -1;
    };

    SaleServiceView.prototype.addSubSaleServiceView = function (saleServiceView) {
        if (saleServiceView && !this.hasSubSaleServiceView(saleServiceView)) {
            this.subSaleServicesView.push(saleServiceView);
            this.updateUniqueSubServiceHr();
        }
    };

    SaleServiceView.prototype.setService = function (serviceView) {
        this.serviceView = serviceView;
        if (serviceView != null) {
            this.label = serviceView.label;
            this.originalPrice = serviceView.price;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);

            if (serviceView.isPackage && serviceView.subServicesView && serviceView.subServicesView.length != 0) {
                var sumSubServicesPrice = 0;

                for (var j = 0; j < serviceView.subServicesView.length; j++) {
                    var sssView = new SaleServiceView(null, -1, String.fromCharCode(97 + j), null, this);
                    sssView.setService(serviceView.subServicesView[j]); //set activity end using service duration
                    this.addSubSaleServiceView(sssView);

                    if (this.originalPrice !== 0) {
                        sssView.initialProportion = sssView.originalPrice / this.originalPrice;
                    } else if (serviceView.getDurationWithHR() !== 0) {
                        sssView.initialProportion = serviceView.subServicesView[j].getDurationWithHR() / serviceView.getDurationWithHR();
                    }
                    sumSubServicesPrice += sssView.price;
                }
            }
            this.updatePrice();
        }
    };

    SaleServiceView.prototype.initVat = function () {
        if (this.getPosView() && this.getPosView().domainView) {
            var vatView = this.getPosView().domainView.getDefaultVatView();
            if (vatView) {
                this.vat = vatView.tax;
                this.vatCode = vatView.code;
            }
        }
    };

    SaleServiceView.prototype.onHrViewInputChange = function (hrView) {
        this.setHrView(hrView);
        if (this.parentSaleServiceView) this.parentSaleServiceView.updateUniqueSubServiceHr();
    };

    SaleServiceView.prototype.setHrView = function (hrView) {
        this.hrView = hrView;
    };

    SaleServiceView.prototype.updateUniqueSubServiceHr = function () {
        var uniqueSubServiceHR = null;
        var isHidden = true;
        if (this.subSaleServicesView.length != 0) {
            uniqueSubServiceHR = this.subSaleServicesView[0].hrView;

            for (var i = 1; i < this.subSaleServicesView.length; i++) {
                if (this.subSaleServicesView[i].serviceView && this.subSaleServicesView[i].serviceView.nbHrsNeeded && this.subSaleServicesView[i].hrView !== uniqueSubServiceHR) {
                    uniqueSubServiceHR = null;
                    isHidden = false;
                    break;
                }
            }
        }
        this.uniqueSubSaleServiceHr = uniqueSubServiceHR;
        if (uniqueSubServiceHR) this.isSubSaleServicesViewHidden = isHidden;else this.isSubSaleServicesViewHidden = false;
    };

    SaleServiceView.prototype.hasUniqueSubSaleServiceHR = function () {
        var isUniqueHR = true;

        for (var i = 0; i < this.subSaleServicesView.length; i++) {
            if (this.subSaleServicesView[i].hrView !== hrView) {
                isUniqueHR = false;
                break;
            }
        }
        return isUniqueHR;
    };

    SaleServiceView.prototype.getSaleView = function () {
        if (this.parentSaleServiceView) return this.parentSaleServiceView.getSaleView();else return this.saleView;
    };

    SaleServiceView.prototype.getPosView = function () {
        if (this.parentSaleServiceView) return this.parentSaleServiceView.getPosView();else return this.posView;
    };

    SaleServiceView.prototype.updatePriceHT = function () {
        this.priceHT = Math.round(100 / (100 + this.vat) * this.price * 100) / 100;
    };

    SaleServiceView.prototype.updateDiscountPercent = function (step) {
        if (this.getSaleView() && !this.getSaleView().isReadOnly) {
            var newDiscountPercent = this.discountPercent * 1 + step; //multiplication by 1 in order to use javascript auto-conversion in number
            if (newDiscountPercent > 100) this.discountPercent = 100;else if (newDiscountPercent < 0) this.discountPercent = 0;else this.discountPercent = newDiscountPercent;
        }
    };

    SaleServiceView.prototype.onDiscountPercentInputArrowClick = function (step) {
        this.updateDiscountPercent(step);
        this.updateDiscountPercentSubServices();
        this.updatePrice();
    };

    SaleServiceView.prototype.updatePercentOnPriceChange = function () {
        this.discountPercent = Math.round(100 * (100 - 100 * this.price / this.originalPrice)) / 100;
        this.updatePriceHT();
        this.getSaleView().resetPayments();
        this.getSaleView().calculateSaleFields();
    };

    SaleServiceView.prototype.updatePrice = function () {
        var oriPrice = this.originalPrice;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (discountPercent && typeof discountPercent === 'string') {
            discountPercent = discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            this.updatePriceHT();
            this.getSaleView().resetPayments();
            this.getSaleView().calculateSaleFields();
        }
        this.updateSubServicesPrice();
        this.getSaleView().checkForInvalidAmounts();
    };

    SaleServiceView.prototype.updateSubServicesPrice = function () {
        if (this.subSaleServicesView.length > 0) {
            for (var i = 0; i < this.subSaleServicesView.length; i++) {
                this.subSaleServicesView[i].updatePrice();
            }
        }
    };

    SaleServiceView.prototype.selectService = function () {
        if (this.serviceView) this.serviceView.isSelected = true;
    };

    SaleServiceView.prototype.updateModel = function () {
        var saleService = this.getModel();
        if (saleService == null) {
            saleService = new SaleService();
            this.ssIndex = SaleServiceData.getIndexOf(saleService);
        }
        this.copyDataTo(saleService);
    };

    SaleServiceView.prototype.removeModel = function () {
        var saleService = this.getModel();
    };

    SaleServiceView.prototype.reloadModel = function () {
        var saleService = this.getModel();
        if (saleService == null) {
            //this.parentCategoryView.removeSaleServiceView(this);
        } else {
            this.loadDataFrom(saleService);
        }
    };

    SaleServiceView.prototype.canSave = function () {
        if (!this.serviceView) return false;

        if (this.originalPrice == "NaN" || this.originalPrice == "") this.originalPrice = null;

        return this.label && this.label != "" && //titre
        this.originalPrice && this.originalPrice >= 0; //prix (décimal)
    };

    return SaleServiceView;
}]);

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SaleView', ["$log", "$filter", "$dialog", "SiteData", "Payment", "SaleData", "DaySrv", "SaleProductView", "SaleServiceView", "SaleCureView", "LoyaltyCardItemView", "LoyaltyCardItemData", "Transaction", "SaleSrv", "Sale", "CustomerView", "DayView", "BookingData", "DayData", "SaleServiceData", "SaleProductData", "SaleCureData", "GiftItemView", "GiftItemData", "PaymentView", "Day", "HumanResourceData", "CurrencyManager", "NumberSeparatorType", "gettextCatalog", "IOSDevice", "Countries", "SaleStatus", "SalePaymentType", "BookingSaveTransactionOrigin", "SalePaymentTypeFactory", "BasicAuthRoleFactory", "PaymentDataObject", "SaleSettings", "SalePartnerSettingsFactory", "Brand", "LaunchDarklyFeatureFlagData", "Site", "SlackSrv", "NfConstant", function ($log, $filter, $dialog, SiteData, Payment, SaleData, DaySrv, SaleProductView, SaleServiceView, SaleCureView, LoyaltyCardItemView, LoyaltyCardItemData, Transaction, SaleSrv, Sale, CustomerView, DayView, BookingData, DayData, SaleServiceData, SaleProductData, SaleCureData, GiftItemView, GiftItemData, PaymentView, Day, HumanResourceData, CurrencyManager, NumberSeparatorType, gettextCatalog, IOSDevice, Countries, SaleStatus, SalePaymentType, BookingSaveTransactionOrigin, SalePaymentTypeFactory, BasicAuthRoleFactory, PaymentDataObject, SaleSettings, SalePartnerSettingsFactory, Brand, LaunchDarklyFeatureFlagData, Site, SlackSrv, NfConstant) {

    var SaleView = function SaleView(sale, saleIndex, dayView, bookingView, posView) {
        this.saleIndex = -1;
        this.dayView = dayView;
        this.bookingView = bookingView;
        this.status = "created"; //created,estimation,waiting,advance,advanceProcess,advanceKeeped,soldProcess,canceled,credit  or sold
        this.isCreatedByCustomer = false;
        this.nbPrint = 0;
        this.posView = posView;
        this.displayGiftItemMailRecipientError = false;
        this.saleNumber = null;
        this.advanceNumber = null;
        this.estimationNumber = null;
        this.signatureCode = null;
        this.canceledSaleNumber = null;
        this.dayId = null;
        this.timeCreated = new Date();
        this.customerView = null;
        this.isOccasionalCustomer = false;
        this.customerLabel = "";
        this.vat = null; //default percent
        this.vatCode = null; //default code
        this.servicesPrice = 0; //TTC sum of service
        this.productsPrice = 0; //TTC sum of service
        this.curesPrice = 0; //TTC sum of service
        this.giftItemsPrice = 0; //TTC sum of giftItems
        this.loyaltyCardsPrice = 0; //TTC sum of loyaltyCardItems
        this.servicesPriceWithD = 0; //TTC sum of service with global discount
        this.productsPriceWithD = 0;
        this.curesPriceWithD = 0;
        this.giftItemsPriceWithD = 0;
        this.loyaltyCardsPriceWithD = 0;
        this.price = 0;
        this.priceInput = "";
        this.priceHT = 0;
        this.discountPercent = 0;
        this.change = 0; //only for view
        this.saleServicesView = []; // saleServices View
        this.saleProductsView = []; // saleProducts View
        this.saleCuresView = []; // saleCures View
        this.giftItemsView = [];
        this.loyaltyCardItemsView = [];
        this.currentPayment = 0; //only for view
        this.advancePercent = posView && posView.domainView && posView.domainView.advancePercent ? posView.domainView.advancePercent : 30; //only for view
        this.paymentsView = []; //Payment type
        this.cancelReason = "";
        this.copyOnCancel = false; // used on cancel form to know if a new ticket must be created from current
        this.refundOnCancel = true; // used on cancel form to know if a online ticket must be refund
        this.transformToGiftOnCancel = true; // used on cancel form to know if a online ticket must be changed to gift
        this.creditDayView = false; // used on cancel form to display a date confirmation for credit
        this.creditDateAsSale = true; // used on cancel form to know if the credit date must be equal to sale date or today
        this.isReadOnly = false;
        this.hasGiftItems = false;
        this.payedPrice = 0;
        this.paymentCardId;
        this.oriSaleMinView = null;
        this.vatLines = []; // list of taxes applied (only on view)  {tax,amount}
        this.loyaltyCardItemView = null; //imputed card
        this.nbLoyaltyCardGoal = 0;
        this.loyaltyPts = 0;
        this.loyaltyUsedPts = 0;
        this.loyaltyDate = null;
        this.loyaltyDiscount = 0;
        this.hasLoyaltyDiscount = false;
        this.isValidLoyaltyPoints = true;
        this.hasUnpaid = false;
        this.delivery = null; //address
        this.deliveryMsg = null;
        this.productsOfServicesView = [];
        this.hrSellerView = null;
        this.hrOpView = null;
        this.techNotes = null;
        this.isCommentVisible = false;
        this.comment = null;
        this.sendByMail = false;
        this.sendGiftByMail = false;
        this.hasInvalidAmounts = false;
        this.customerLastname = null;
        this.customerFirstname = null;
        this.customerAddress = null;
        this.customerZip = null;
        this.customerCity = null;
        this.shareCapital = null;
        this.greffeCity = null;
        this.juridicForm = null;
        this.canAccessBookingUserStory = LaunchDarklyFeatureFlagData.canAccessBookingUserStory;
        this.form = {
            displayError: false,
            displayErrorGiftItem: false,
            displayErrorMobile: false,
            displayErrorCustomer: false,
            displayErrorLandLine: false,
            displayErrorPrice: false,
            displayChangeMsg: false,
            displayCustomerButton: null,
            displayMoreFields: false,
            displayOverPaymentError: false,
            displayGlobalDiscount: false,
            displayOtherActions: false,
            canChangeFuturePayment: false,
            displayErrorCurrentPayment: false,
            nbPayments: 1,
            paymentActionsTab: 0, // 0 = menu OtherActions; 1 = subMenu multiplePayment; 2 = subMenu multipleType; 3 = subMenu returnMoney
            titleOtherActions: ""
            //For view only
        };this.paymentsForADate = new PaymentDataObject();
        this.paymentsForADate.otherPaymentTypePrices = [];
        this.paymentsForADate.price = 0;
        this.paymentsForADate.priceHT = 0;
        this.paymentsForADate.hasSamePriceThanSale = false;
        this.paymentsForADate.hasSpecificPaymentDate = false;
        this.paymentsForADate.paymentNumber = 1; //for a date
        this.paymentsForADate.nbPayments = 1; //for dates

        this.printWindow = null;
        this.softV = null;
        this.totalLoyaltyPts = 0;
        this.hasLoyaltyDiscount = false;
        this.advancePrice = 0;
        this.site = null;

        this.loadDataFrom(sale);
        if (saleIndex !== undefined) this.saleIndex = saleIndex;

        this.originalAdvanceLabel = gettextCatalog.getString("Imprimer un reçu");
        this.originalSaleLabel = gettextCatalog.getString("Enregistrer et imprimer le ticket");
        this.advanceDuplicataLabel = gettextCatalog.getString("Imprimer duplicata n°");
        this.saleDuplicataLabel = gettextCatalog.getString("Enregistrer et imprimer duplicata n°");
        this.printLabel = gettextCatalog.getString("Imprimer");
        this.saleSettings = SaleSettings;
        this.basicAuthRoleFactory = BasicAuthRoleFactory;
        this.basicAuthRole = null;
        this.canRefundGiftItem = false;
        this.statusLabel = {
            sold: "Encaissé",
            credit: "Crédit d'annulation"
        };
    };

    SaleView.prototype.loadDataFrom = function (sale) {
        if (sale) {
            this.loadPropertiesDataFrom(sale);
            this.loadSaleServicesDataFrom(sale);
            this.loadSaleProductsDataFrom(sale);
            this.loadSaleCuresDataFrom(sale);
            this.loadGiftItemsDataFrom(sale);
            this.loadLoyaltyCardItemsDataFrom(sale);
        }
        this.calculateSaleFields();
    };

    SaleView.prototype.displayError = function () {
        if ((this.customerView == null || this.customerView == undefined) && !this.isOccasionalCustomer) {
            this.form.displayErrorCustomer = true;
        }
        if (this.giftItemsView.length === 0) {
            this.form.displayErrorGiftItem = true;
        }

        this.form.displayError = true;
    };

    SaleView.prototype.displayErrorCurrentPayment = function () {
        if (this.currentPayment < 0) {
            this.form.displayErrorCurrentPayment = true;
        } else {
            this.form.displayError = true;
        }
    };

    SaleView.prototype.loadPropertiesDataFrom = function (sale) {
        if (sale) {
            this.id = sale.id;
            this.saleNumber = sale.saleNumber;
            this.advanceNumber = sale.advanceNumber;
            this.estimationNumber = sale.estimationNumber;
            this.customerLastname = sale.customerLastname;
            this.customerFirstname = sale.customerFirstname;
            this.customerAddress = sale.customerAddress;
            this.customerZip = sale.customerZip;
            this.customerCity = sale.customerCity;
            this.shareCapital = sale.shareCapital;
            this.greffeCity = sale.greffeCity;
            this.juridicForm = sale.juridicForm;
            this.signatureCode = sale.signatureCode;
            this.canceledSaleNumber = sale.canceledSaleNumber;
            this.vat = sale.vat;
            this.vatCode = sale.vatCode;
            this.servicesPrice = sale.servicesPrice;
            this.productsPrice = sale.productsPrice;
            if (sale.curesPrice) this.curesPrice = sale.curesPrice;
            if (sale.giftItemsPrice) this.giftItemsPrice = sale.giftItemsPrice;
            if (sale.loyaltyCardsPrice) this.loyaltyCardsPrice = sale.loyaltyCardsPrice;
            this.price = sale.price;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            this.priceHT = sale.priceHT;
            this.discountPercent = sale.discountPercent;
            this.productsPriceWithD = this.productsPrice - this.productsPrice * this.discountPercent / 100;
            this.servicesPriceWithD = this.servicesPrice - this.servicesPrice * this.discountPercent / 100;
            this.curesPriceWithD = this.curesPrice - this.curesPrice * this.discountPercent / 100;
            this.giftItemsPriceWithD = this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100;
            this.loyaltyCardsPriceWithD = this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100;
            this.paymentsView = [];
            this.timeCreated = sale.timeCreated;
            this.cancelReason = sale.cancelReason;
            this.isCreatedByCustomer = sale.isCreatedByCustomer;
            this.nbPrint = sale.nbPrint;
            this.delivery = sale.delivery;
            this.deliveryMsg = sale.deliveryMsg;
            this.techNote = sale.techNote;
            this.comment = sale.comment;
            this.totalLoyaltyPts = sale.totalLoyaltyPts;
            this.site = sale.site;
            this.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;
            this.setStatus(sale.status);
            if (sale.giftItems && sale.giftItems.length > 0) {
                this.hasGiftItems = true;
            }
            this.softV = sale.softV;
            this.advancePrice = sale.advancePrice;

            if (sale.hrSeller && this.posView) this.hrSellerView = this.posView.domainView.getHrView(sale.hrSeller);
            if (sale.hrOp && this.posView) this.hrOpView = this.posView.domainView.getHrView(sale.hrOp);

            var paymentView = void 0,
                saleView = void 0;
            if (sale.customer) {
                if (this.posView && this.posView.domainView) this.customerView = this.posView.domainView.getCustomerView(sale.customer);
                this.updateCustomerLabel();
            } else this.isOccasionalCustomer = true;

            this.hasUnpaid = false;
            if (sale.payments) {

                for (var i = 0; i < sale.payments.length; i++) {
                    saleView = null;
                    paymentView = new PaymentView(sale.payments[i], this);
                    if (sale.payments[i].giftItem) {
                        if (this.customerView) paymentView.giftItemView = this.customerView.getGiftItemView(sale.payments[i].giftItem);

                        if (!paymentView.giftItemView) {
                            if (sale.payments[i].giftItem.sale && this.posView) saleView = new SaleView(sale.payments[i].giftItem.sale, SaleData.getIndexOf(sale.payments[i].giftItem.sale), null, null, null); //don't set this.posView in order to not load related data to avoid loop on booking
                            paymentView.giftItemView = new GiftItemView(sale.payments[i].giftItem, GiftItemData.getIndexOf(sale.payments[i].giftItem), -1, saleView);
                        }
                        if (this.status !== "canceled" && this.status !== "credit") //link only to a giftItem of sale sold or waiting
                            paymentView.giftItemView.paymentSaleView = this;
                    }
                    this.form.canChangeFuturePayment = this.form.canChangeFuturePayment || paymentView.canChange;
                    if (paymentView.type === "UNPAID") this.hasUnpaid = true;
                    this.paymentsView.push(paymentView);
                }
            }

            if (sale.oriSale) this.oriSaleMinView = { saleIndex: SaleData.getIndexOf(sale.oriSale), saleNumber: sale.oriSale.saleNumber };
            if (sale.booking && !this.bookingView) //not created by Booking view
                {
                    var bookingIndex = BookingData.getIndexOf(sale.booking);
                    if (sale.booking.day) {
                        var bPlgDayView = null;
                        var plgBookingView = null;
                        var bDayIndex = DayData.getIndexOf(sale.booking.day);
                        if (this.posView && this.posView.domainView.pTView && this.posView.domainView.pTView.getPlgDayViewByDayIndex !== undefined) bPlgDayView = this.posView.domainView.pTView.getPlgDayViewByDayIndex(bDayIndex, true);
                        if (bPlgDayView) plgBookingView = bPlgDayView.getBookingViewByIndex(bookingIndex, true);
                        if (plgBookingView) {
                            this.bookingView = plgBookingView;
                        }
                    }
                }
            var allItemsPrice = sale.getAllItemsPrice();
            if (sale.status === "waiting" || sale.status === "advance") {
                if (sale.loyaltyCardItem) {
                    this.loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItem, LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItem), 0, null, this.posView);
                    this.calculateUsedLoyaltyPts(allItemsPrice);
                    this.updateLoyaltyCardItemAction(false);
                }
                this.updateLoyaltyCardItemAction(false);
            } else {
                if (sale.loyaltyCardItem) {
                    this.loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItem, LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItem), 0, null, this.posView);
                    this.loyaltyDate = sale.loyaltyDate;
                    this.loyaltyPts = sale.loyaltyPts;
                    this.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;
                    if (this.loyaltyPts < 0) {
                        //nbLoyaltyCardGoal get a positive value for parameter loyaltyPoints.
                        var hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
                        this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, -this.loyaltyPts, hasLoyaltyCardInShoppingCart);
                    }
                }
            }
        }
    };

    SaleView.prototype.loadSaleServicesDataFrom = function (sale) {
        if (sale) {
            var bsV = void 0;
            this.saleServicesView = [];
            for (var i = 0; i < sale.saleServices.length; i++) {
                bsV = new SaleServiceView(sale.saleServices[i], SaleServiceData.getIndexOf(sale.saleServices[i]), i + 1, this);
                this.saleServicesView.push(bsV);
            }
        }
    };

    SaleView.prototype.loadSaleProductsDataFrom = function (sale) {
        if (sale) {
            var bsV = void 0;
            this.saleProductsView = [];
            for (var i = 0; i < sale.saleProducts.length; i++) {
                bsV = new SaleProductView(sale.saleProducts[i], SaleProductData.getIndexOf(sale.saleProducts[i]), i + 1, this);
                this.saleProductsView.push(bsV);
            }
        }
    };

    SaleView.prototype.loadSaleCuresDataFrom = function (sale) {
        if (sale) {
            var bsV = void 0;
            this.saleCuresView = [];
            for (var i = 0; i < sale.saleCures.length; i++) {
                bsV = new SaleCureView(sale.saleCures[i], SaleCureData.getIndexOf(sale.saleCures[i]), this.saleProductsView.length + i + 1, this);
                this.saleCuresView.push(bsV);
            }
        }
    };

    SaleView.prototype.getProductsOfServices = function () {
        var productsOfServicesView = [];
        for (var i = 0; i < this.saleServicesView.length; i++) {
            if (this.saleServicesView[i].serviceView) {
                for (var j = 0; j < this.saleServicesView[i].serviceView.productsView.length; j++) {
                    if (this.saleServicesView.indexOf(this.saleServicesView[i].serviceView.productsView[j])) productsOfServicesView.push(this.saleServicesView[i].serviceView.productsView[j]);
                }
            }
        }
        return productsOfServicesView;
    };

    SaleView.prototype.loadLoyaltyCardItemsDataFrom = function (sale) {
        if (sale) {
            var loyaltyCardItemView = void 0;
            this.loyaltyCardItemsView = [];
            for (var i = 0; i < sale.loyaltyCardItems.length; i++) {
                loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItems[i], LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItems[i]), this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + i + 1, this);
                this.loyaltyCardItemsView.push(loyaltyCardItemView);
            }
            if (this.status === SaleStatus.WAITING && !this.loyaltyDate && loyaltyCardItemView) {
                this.loyaltyDate = loyaltyCardItemView.validityDate;
            }
        }
    };

    SaleView.prototype.loadGiftItemsDataFrom = function (sale) {
        if (sale) {
            var bsV = void 0;
            this.giftItemsView = [];
            for (var i = 0; i < sale.giftItems.length; i++) {
                bsV = new GiftItemView(sale.giftItems[i], GiftItemData.getIndexOf(sale.giftItems[i]), this.saleProductsView.length + this.saleCuresView.length + i + 1, this);
                this.giftItemsView.push(bsV);
            }
        }
    };

    SaleView.prototype.updateCustomerLabel = function () {
        if (this.customerView) {
            this.customerLabel = this.customerView.lastName;
            if (this.customerView.firstName) this.customerLabel = +" " + this.customerView.firstName;
        }
    };

    SaleView.prototype.copyDataTo = function (sale, previousStatus) {
        sale.canceledSaleNumber = this.canceledSaleNumber;
        sale.vat = this.vat;
        sale.vatCode = this.vatCode;
        sale.price = this.price;
        sale.servicesPrice = this.servicesPrice;
        sale.productsPrice = this.productsPrice;
        sale.curesPrice = this.curesPrice;
        sale.giftItemsPrice = this.giftItemsPrice;
        sale.loyaltyCardsPrice = this.loyaltyCardsPrice;
        this.updateSellerFromItems();
        sale.hrSeller = this.hrSellerView;
        sale.priceHT = this.priceHT;
        sale.status = this.status;
        sale.delivery = this.delivery;
        sale.deliveryMsg = this.deliveryMsg;
        if (this.techNote === '') {
            this.techNote = null;
        }
        sale.techNote = this.techNote;
        sale.comment = this.comment;
        sale.isCreatedByCustomer = this.isCreatedByCustomer;
        sale.nbPrint = this.nbPrint;
        sale.timeCreated = this.timeCreated;
        sale.sendByMail = this.sendByMail;
        sale.sendGiftByMail = this.sendGiftByMail;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            sale.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            sale.discountPercent = parseFloat(sale.discountPercent);
        } else {
            sale.discountPercent = this.discountPercent;
        }
        sale.cancelReason = this.cancelReason;
        sale.paymentCardId = this.paymentCardId;
        sale.totalLoyaltyPts = this.totalLoyaltyPts;
        sale.site = this.site;
        sale.hasLoyaltyDiscount = this.hasLoyaltyDiscount;

        if (this.hrSellerView) {
            sale.hrSeller = this.hrSellerView.getModel();
        }
        if (this.hrOpView) {
            sale.hrOp = this.hrOpView.getModel();
        }

        //remove usage
        for (var i = 0; i < sale.payments.length; i++) {
            if (sale.payments[i].giftItem) {
                sale.payments[i].giftItem.paymentSale = null;
                if (!sale.booking || !sale.booking.containsGiftOnBs(sale.payments[i].giftItem)) {
                    sale.payments[i].giftItem.isUsed = false;
                }
            }
        }
        sale.payments = [];
        for (var _i = 0; _i < this.paymentsView.length; _i++) {
            var payment = new Payment();
            this.paymentsView[_i].copyDataTo(payment);
            sale.payments.push(payment);
            this.form.canChangeFuturePayment = this.form.canChangeFuturePayment || this.paymentsView[_i].canChange;
        }
        sale.updateRealPaymentPrice();
        //set usage
        var initCustomerGiftItems = false;
        if (this.status === SaleStatus.CREATED || this.status === SaleStatus.SOLD) {
            for (var _i2 = 0; _i2 < sale.payments.length; _i2++) {
                if (sale.payments[_i2].giftItem) {
                    sale.payments[_i2].giftItem.isUsed = true;
                    sale.payments[_i2].giftItem.paymentSale = sale;
                    initCustomerGiftItems = true;
                }
            }
        }
        if (this.bookingView) {
            var booking = this.bookingView.getModel();
            if (booking !== sale.booking) {
                if (booking && this.status !== "canceled" && this.status !== "credit") {
                    //no link from booking for this status
                    booking.sale = sale;
                }
                sale.booking = booking;
            }
        }

        sale.loyaltyPts = this.loyaltyPts + this.loyaltyUsedPts;
        sale.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
        sale.loyaltyDate = this.loyaltyDate;
        if (this.loyaltyCardItemView) {
            sale.loyaltyCardItem = this.loyaltyCardItemView.getModel();
            if (sale.loyaltyCardItem) {
                if (this.status === "sold" && previousStatus !== "sold") {
                    sale.loyaltyCardItem.pts += sale.loyaltyPts;
                    sale.loyaltyCardItem.validityDate = sale.loyaltyDate;
                    this.loyaltyCardItemView.pts += this.loyaltyPts + this.loyaltyUsedPts; //for print
                } else if (this.status === "canceled") {
                    sale.loyaltyCardItem.pts -= sale.loyaltyPts;
                    this.loyaltyCardItemView.pts -= this.loyaltyPts + this.loyaltyUsedPts;
                }
            }
        } else {
            sale.loyaltyCardItem = null;
        }

        if (this.customerView || this.isOccasionalCustomer) {
            var customer = this.customerView ? this.customerView.getModel() : null;
            if (customer !== sale.customer) {
                if (sale.customer) {
                    sale.customer.removeSale(sale);
                    if (this.posView && this.posView.domainView) {
                        var previousCustomerView = this.posView.domainView.getCustomerView(sale.customer);
                        if (previousCustomerView) {
                            previousCustomerView.initHistoryView();
                        }
                    }
                }
                if (customer) {
                    customer.addSale(sale);
                }
                sale.customer = customer;
            }
            if (this.customerView) {
                this.customerView.initHistoryView();
                if (initCustomerGiftItems) {
                    this.customerView.initGiftItemsView();
                }
            }
        }
        if (this.oriSaleMinView && this.oriSaleMinView.saleIndex !== -1) {
            sale.oriSale = SaleData.getByIndex(this.oriSaleMinView.saleIndex);
        }
        if (this.dayView) {
            sale.day = this.dayView.getModel();
        }
        sale.advancePrice = this.advancePrice;
    };

    SaleView.prototype.getModel = function () {
        if (this.saleIndex !== -1) return SaleData.getByIndex(this.saleIndex);
        return null;
    };

    SaleView.prototype.getClone = function (dayView) {
        var saleView = new SaleView(null, -1, dayView, this.bookingView, this.posView);
        saleView.vat = this.vat;
        saleView.vatCode = this.vatCode;
        saleView.price = this.price;
        saleView.priceInput = this.priceInput;
        saleView.servicesPrice = this.servicesPrice;
        saleView.productsPrice = this.productsPrice;
        saleView.curesPrice = this.curesPrice;
        saleView.giftItemsPrice = this.giftItemsPrice;
        saleView.loyaltyCardsPrice = this.loyaltyCardsPrice;
        saleView.servicesPriceWithD = this.servicesPriceWithD;
        saleView.productsPriceWithD = this.productsPriceWithD;
        saleView.curesPriceWithD = this.curesPriceWithD;
        saleView.giftItemsPriceWithD = this.giftItemsPriceWithD;
        saleView.loyaltyCardsPriceWithD = this.loyaltyCardsPriceWithD;
        saleView.priceHT = this.priceHT;
        saleView.status = this.status;
        saleView.customerView = this.customerView;
        saleView.customerLabel = this.customerLabel;
        saleView.isOccasionalCustomer = this.isOccasionalCustomer;
        saleView.change = this.change; //only for view
        saleView.currentPayment = this.currentPayment; //only for view
        saleView.discountPercent = this.discountPercent;
        saleView.payedPrice = this.payedPrice;
        saleView.site = this.site;
        saleView.totalLoyaltyPts = this.totalLoyaltyPts;
        saleView.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
        saleView.advancePrice = this.advancePrice;
        saleView.paymentsView = [];

        for (var i = 0; i < this.paymentsView.length; i++) {
            if (this.paymentsView[i].type !== "CBONLINE") saleView.paymentsView.push(this.paymentsView[i].getClone(saleView));
        }for (var _i3 = 0; _i3 < this.saleServicesView.length; _i3++) {
            saleView.addSaleServiceView(this.saleServicesView[_i3].getClone(saleView), false);
        }for (var _i4 = 0; _i4 < this.saleProductsView.length; _i4++) {
            saleView.addSaleProductView(this.saleProductsView[_i4].getClone(saleView), false);
        }for (var _i5 = 0; _i5 < this.saleCuresView.length; _i5++) {
            saleView.addSaleCureView(this.saleCuresView[_i5].getClone(saleView), false);
        }for (var _i6 = 0; _i6 < this.giftItemsView.length; _i6++) {
            saleView.addGiftItemView(this.giftItemsView[_i6].getClone(saleView), false);
        }for (var _i7 = 0; _i7 < this.loyaltyCardItemsView.length; _i7++) {
            saleView.addLoyaltyCardItemView(this.loyaltyCardItemsView[_i7].getClone(saleView), false);
        }return saleView;
    };

    SaleView.prototype.initFromBookingView = function (bookingView) {
        bookingView.saleView = this;
        this.customerView = bookingView.customerView;
        this.isOccasionalCustomer = bookingView.isOccasionalCustomer;
        //manage payments for bookingService linked to giftitem

        for (var i = 0; i < bookingView.bookingServicesView.length; i++) {
            var currentBSView = bookingView.bookingServicesView[i];
            this.addBookingServiceOnSale(currentBSView);
            if (!currentBSView.giftItemView) {
                continue;
            }
            var giftItemSale = GiftItemData.getByCode(currentBSView.giftItemView.code);
            var giftItemSaleStatus = giftItemSale && giftItemSale.sale ? giftItemSale.sale.status : null;

            if (giftItemSaleStatus === SaleStatus.SOLD) {
                if (currentBSView.price !== currentBSView.serviceView.price) currentBSView.setService(currentBSView.serviceView, currentBSView);

                if (currentBSView.giftItemView.originalPrice > currentBSView.price) {
                    this.currentPayment = currentBSView.price;
                    this.posView.selectors.giftItemToUse.giftItemView = currentBSView.giftItemView;
                    this.posView.edited.saleView = this;
                    this.posView.useSelectedGiftItem();
                    this.calculateSaleFields();
                } else {
                    if (currentBSView.giftItemView.originalPrice < currentBSView.price) //set discount to match giftitem price
                        {
                            currentBSView.price = currentBSView.giftItemView.originalPrice;
                            currentBSView.discountPercent = Math.round(100 * (100 - 100 * currentBSView.price / currentBSView.originalPrice)) / 100;
                        }

                    this.calculateSaleFields();
                    this.currentPayment = currentBSView.price;
                    this.addPaymentView("GIFT", currentBSView.giftItemView);
                }
            }
        }
        this.updateLoyaltyCardItem();
    };

    SaleView.prototype.activeEditCustomerMode = function () {
        if (this.customerView == null) this.customerView = this.createCustomerFromString(this.customerLabel);
        if (this.bookingView) this.bookingView.customerView = this.customerView;

        if (this.posView) {
            this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            this.posView.selectors.customerProposedItems.update(this.customerView);
        }
    };

    SaleView.prototype.createEmptyCustomer = function () {
        this.customerView = new CustomerView(null, -1, this.posView ? this.posView.domainView : null);
        if (this.bookingView) this.bookingView.customerView = this.customerView;
        this.loyaltyCardItemView = null;
        if (this.posView) {
            this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            this.posView.selectors.customerProposedItems.update(this.customerView);
        }
    };

    SaleView.prototype.onCustomerSelect = function (item) {
        //call when customer is selected
        if (!item.isHistoryInit) {
            item.initCustomerHistoryDatas(item.getModel());
        }
        this.customerView = item;
        if (this.bookingView) this.bookingView.customerView = this.customerView;
        if (this.posView) {
            this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            this.posView.selectors.customerProposedItems.update(this.customerView);
        }
        this.updateLoyaltyCardItem();

        //change view
        this.activeEditCustomerMode();
        this.displayGiftItemMailRecipientError = false;
    };

    SaleView.prototype.updateLoyaltyCardItem = function (isOnLine) {
        if (this.customerView && this.customerView.nbLoyaltyCardItemNotUsed !== 0) {
            this.updateLoyaltyCardItemAction(isOnLine);
            this.calculateSaleFields();
        }
    };

    SaleView.prototype.updateToOccasionalCustomer = function () {
        this.isOccasionalCustomer = true;
        this.displayGiftItemMailRecipientError = false;
        if (this.bookingView) {
            this.bookingView.isOccasionalCustomer = true;
            this.bookingView.customerView = null;
        }
    };

    SaleView.prototype.updateLoyaltyCardItemAction = function (isOnLine) {
        if (this.customerView && this.customerView.nbLoyaltyCardItemNotUsed !== 0) {
            if (!this.loyaltyCardItemView) this.loyaltyCardItemView = new LoyaltyCardItemView(LoyaltyCardItemData.getByIndex(this.customerView.loyaltyCardItemsNotUsedView[0].index), this.customerView.loyaltyCardItemsNotUsedView[0].index, 0, null, this.posView);
            this.loyaltyDate = this.loyaltyCardItemView.getValidityDateFromNow();
            if (isOnLine && this.loyaltyCardItemView.goalType === "special") this.nbLoyaltyCardGoal = -1; // don't apply automatically special discount on website
            this.loyaltyCardItemsView = [];
        }
    };

    SaleView.prototype.closeEditCustomerMode = function () {
        this.customerView = null;
        this.customerLabel = "";
        this.form.editCustomerMode = false;
        this.form.displayCustomerButton = null;
        this.form.displayError = false;
        this.isOccasionalCustomer = false;

        if (this.loyaltyCardItemsView && this.loyaltyCardItemsView.length === 0) this.loyaltyCardItemView = null;else this.loyaltyCardItemView = this.loyaltyCardItemsView[0];
        if (this.posView) {
            this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            this.posView.selectors.customerProposedItems.update(this.customerView);
        }
    };

    SaleView.prototype.cancelCustomer = function () {
        if (this.customerView && this.customerView.cIndex !== -1) //Customer exist
            {
                this.customerView.reloadModel();
                this.form.displayCustomerButton = null;
                this.form.displayError = false;
                this.form.displayCustomerButton = null;
            } else {
            this.closeEditCustomerMode();
        }
    };

    SaleView.prototype.createCustomerFromString = function (customerLabel) {
        //CustomerView is a string and must copied to a new customerView.lastName + firstName
        var custView = new CustomerView(null, -1, this.posView ? this.posView.domainView : null);
        var indexSpace = customerLabel.indexOf(' ');
        if (indexSpace !== -1) {
            custView.lastName = customerLabel.substring(0, indexSpace);
            custView.firstName = customerLabel.substring(indexSpace + 1);
        } else custView.lastName = customerLabel;
        custView.label = customerLabel;
        return custView;
    };

    //Cures
    SaleView.prototype.getSaleProductViewById = function (id) {
        var bs = void 0;
        for (var i = 0; i < this.saleProductsView.length; i++) {
            bs = this.saleProductsView[i].getModel();
            if (bs && bs.id === id) return this.saleProductsView[i];
        }
        return null;
    };

    SaleView.prototype.getSaleCureViewById = function (id) {
        var bs;
        for (var i = 0; i < this.saleCuresView.length; i++) {
            bs = this.saleCuresView[i].getModel();
            if (bs && bs.id === id) return this.saleCuresView[i];
        }
        return null;
    };

    SaleView.prototype.setStatus = function (status) {
        this.isReadOnly = status == "sold" || status == "canceled" || status == "credit" || status == "soldProcess" || status == "advanceProcess" || status == "advanceKeeped";
        this.status = status;
    };

    SaleView.prototype.isOnlineAccount = function () {
        return this.status === "advance" && this.isCreatedByCustomer;
    };

    SaleView.prototype.setDelivery = function (delivery, manageProduct, amount) {
        this.delivery = delivery;
        if (manageProduct) {
            var saleProductViewDelivery = null;
            for (var i = this.saleProductsView.length - 1; i >= 0; i--) {
                if (!this.saleProductsView[i].productView && this.saleProductsView[i].label == "Frais de port") {
                    if (delivery != "address" || this.saleProductsView[i].price < amount) // change to deliver on site or new deliveryPrice > old price
                        this.removeSaleProductView(this.saleProductsView[i]);else saleProductViewDelivery = this.saleProductsView[i];
                }
            }if (delivery == "address" && !saleProductViewDelivery) {
                var saleProductView = new SaleProductView(null, -1, 0, this);
                saleProductView.label = "Frais de port";
                saleProductView.originalPrice = amount;
                saleProductView.price = amount;
                saleProductView.quantity = 1;
                saleProductView.updatePriceHT();
                var vatView = this.posView.domainView.getDefaultVatView();
                if (vatView) {
                    saleProductView.vat = vatView.tax;
                    saleProductView.vatCode = vatView.code;
                }
                this.saleProductViewDelivery = saleProductView;
                this.addSaleProductView(saleProductView, true);
            }
            this.calculateSaleFields();
        }
    };

    SaleView.prototype.addProductOnSale = function (productView, hrView, isOnInternet) {
        var ignoreQuantity = this.isEstimationCost();
        if (productView) {
            for (var i = this.saleProductsView.length - 1; i >= 0; i--) {
                if (this.saleProductsView[i].productView === productView) {
                    this.saleProductsView[i].quantityInput++;
                    this.saleProductsView[i].onChangeQuantity();
                    return;
                }
            }

            var spView = new SaleProductView(null, -1, this.saleProductsView.length, this);
            spView.setProduct(productView, isOnInternet, ignoreQuantity); //set activity end using service duration
            spView.hrView = hrView;
            this.addSaleProductView(spView, true); //add bs to sale view

            //Set selection
            productView.isSelected = true;

            //close on mobile
            if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat) this.posView.selectors.product.display = false;
            if (this.posView && this.posView.resizeBasket) //on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                this.posView.resizeBasket();
        }
    };

    SaleView.prototype.addCureOnSale = function (cureView, hrView, isOnInternet) {

        if (cureView) {
            var scView = new SaleCureView(null, -1, 0, this);
            scView.setCure(cureView, isOnInternet);
            scView.hrView = hrView;
            this.addSaleCureView(scView, true); //add scView to sale view

            //Set selection
            cureView.isSelected = true;

            //close on mobile
            if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat) this.posView.selectors.cure.display = false;
            if (this.posView && this.posView.resizeBasket) //on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                this.posView.resizeBasket();
        }
    };

    SaleView.prototype.addLoyaltyCardOnSale = function (loyaltyCardView, hrView, isOnInternet) {

        if (loyaltyCardView) {
            var lciView = new LoyaltyCardItemView(null, -1, 0, this);
            lciView.setLoyaltyCard(loyaltyCardView, isOnInternet);
            lciView.hrView = hrView;
            this.addLoyaltyCardItemView(lciView, true); //add lciView to sale view

            //Set selection
            loyaltyCardView.isSelected = true;

            //close on mobile
            if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat) this.posView.selectors.loyaltyCard.display = false;
            if (this.posView && this.posView.resizeBasket) //on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                this.posView.resizeBasket();
        }
    };

    SaleView.prototype.addGiftItemView = function (giView, updateSaleFields) {
        var index = this.giftItemsView.indexOf(giView);
        if (index == -1) {
            this.giftItemsView.push(giView);
            this.hasGiftItems = true;
            giView.saleView = this;
            if (updateSaleFields) {
                this.remvoveLoyaltyGoal();
                this.calculateSaleFields();
                this.resetPayments();
                this.updateBillPosition();
            }
            if (this.posView && this.posView.resizeBasket) //on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                this.posView.resizeBasket();
        }
    };

    SaleView.prototype.addLoyaltyCardItemView = function (lcView, updateSaleFields) {
        var index = this.loyaltyCardItemsView.indexOf(lcView);
        if (index == -1) {
            this.loyaltyCardItemsView.push(lcView);
            lcView.saleView = this;
            this.loyaltyCardItemView = lcView; //assign it as used Loyalty card
            this.loyaltyDate = this.loyaltyCardItemView.getValidityDateFromNow();
            if (updateSaleFields) {
                this.calculateSaleFields();
                this.resetPayments();
                this.updateBillPosition();
            }
        }
    };

    SaleView.prototype.createAndAddGiftItemView = function (serviceView, price, editionType, hrView, validityDate, customerView, isFromUsage) {
        var giftItemView = new GiftItemView(null, -1, this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + 1, this);
        giftItemView.price = price;
        giftItemView.originalPrice = price;
        giftItemView.originalPriceInput = $filter('currencyFormatFilter')(giftItemView.originalPrice);
        giftItemView.serviceView = serviceView;
        giftItemView.updatePriceHT();
        giftItemView.hrView = hrView;
        giftItemView.validityDate = validityDate;
        giftItemView.editionType = editionType;
        giftItemView.customerView = customerView;
        giftItemView.updateModel(true);
        this.giftItemsView.push(giftItemView);
        this.hasGiftItems = true;
        this.remvoveLoyaltyGoal();
        this.discountPercent = 0;
        this.calculateSaleFields();
        if (!isFromUsage) this.resetPayments();
        this.posView.resetGiftItemSelector();
        return giftItemView;
    };

    SaleView.prototype.addSaleProductView = function (bpView, updateSaleFields) {
        var index = this.saleProductsView.indexOf(bpView);
        if (index === -1) {
            this.saleProductsView.push(bpView);
            bpView.saleView = this;
            bpView.billPosition = this.saleProductsView.length;
            if (updateSaleFields) {
                this.updateBillPosition();
                this.calculateSaleFields();
                this.resetPayments();
            }
        }
    };

    SaleView.prototype.addSaleCureView = function (bsView, updateSaleFields) {
        var index = this.saleCuresView.indexOf(bsView);
        if (index == -1) {
            this.saleCuresView.push(bsView);
            bsView.saleView = this;
            if (updateSaleFields) {
                this.updateBillPosition();
                this.calculateSaleFields();
                this.resetPayments();
            }
        }
    };

    SaleView.prototype.removeProductOnSale = function (productView) {
        for (var i = this.saleProductsView.length - 1; i >= 0; i--) {
            if (this.saleProductsView[i].productView === productView) {
                this.saleProductsView[i].quantityInput--;
                this.saleProductsView[i].onChangeQuantity();
                if (this.saleProductsView[i].quantity == 0) this.removeSaleProductView(this.saleProductsView[i]);else this.calculateSaleFields();
                return;
            }
        }
    };

    SaleView.prototype.removeCureOnSale = function (cureView) {

        for (var i = this.saleCuresView.length - 1; i >= 0; i--) {
            if (this.saleCuresView[i].cureView === cureView) {
                this.saleCuresView[i].quantityInput--;
                this.saleCuresView[i].onChangeQuantity();
                if (this.saleCuresView[i].quantity == 0) this.removeSaleCureView(this.saleCuresView[i]);else this.calculateSaleFields();
                return;
            }
        }
    };

    SaleView.prototype.removeSaleProductViewAndManageQuantity = function (bsView) {
        bsView.quantityInput = 0;
        bsView.onChangeQuantity();
        this.resetDiscountPercentForEmptySale();
        this.removeSaleProductView(bsView);
        this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
    };

    SaleView.prototype.removeSaleCureViewAndManageQuantity = function (bsView) {
        bsView.quantityInput = 0;
        bsView.onChangeQuantity();
        this.resetDiscountPercentForEmptySale();
        this.removeSaleCureView(bsView);
        this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
    };

    SaleView.prototype.removeSaleProductView = function (bsView) {
        var index = this.saleProductsView.indexOf(bsView);
        if (index === -1) return; //TODO raise error
        this.saleProductsView.splice(index, 1);
        if (bsView.productView) bsView.productView.isSelected = false;
        this.resetPayments();
        this.updateBillPosition();
    };

    SaleView.prototype.removeSaleCureView = function (scView) {
        var index = this.saleCuresView.indexOf(scView);
        if (index == -1) return; //TODO raise error
        this.saleCuresView.splice(index, 1);
        if (scView.cureView) scView.cureView.isSelected = false;
        this.resetPayments();
        this.updateBillPosition();
    };

    SaleView.prototype.selectServices = function () {
        if (this.bookingView) this.bookingView.selectServices();
        for (var i = 0; i < this.saleServicesView.length; i++) {
            this.saleServicesView[i].selectService();
        }
    };

    SaleView.prototype.selectProducts = function () {
        for (var i = 0; i < this.saleProductsView.length; i++) {
            this.saleProductsView[i].selectProduct();
        }
    };

    SaleView.prototype.selectCures = function () {
        for (var i = 0; i < this.saleCuresView.length; i++) {
            this.saleCuresView[i].selectCure();
        }
    };

    SaleView.prototype.updateBillPosition = function () {
        var billPosition = 1;
        for (var i = 0; i < this.saleProductsView.length; i++) {
            this.saleProductsView[i].billPosition = billPosition++;
        }for (var i = 0; i < this.saleCuresView.length; i++) {
            this.saleCuresView[i].billPosition = billPosition++;
        }for (var i = 0; i < this.giftItemsView.length; i++) {
            this.giftItemsView[i].billPosition = billPosition++;
        }for (var i = 0; i < this.loyaltyCardItemsView.length; i++) {
            this.loyaltyCardItemsView[i].billPosition = billPosition++;
        }
    };

    SaleView.prototype.hasProduct = function (productView) {
        for (var i = 0; i < this.saleProductsView.length; i++) {
            if (this.saleProductsView[i].productView === productView) return true;
        }return false;
    };

    SaleView.prototype.hasProductNotNull = function () {
        for (var i = 0; i < this.saleProductsView.length; i++) {
            if (this.saleProductsView[i].productView) return true;
        }return false;
    };

    SaleView.prototype.hasGiftItemEditionType = function (editionType) {
        for (var i = 0; i < this.giftItemsView.length; i++) {
            if (this.giftItemsView[i].editionType === editionType) return true;
        }return false;
    };

    SaleView.prototype.hasCure = function (cureView) {
        for (var i = 0; i < this.saleCuresView.length; i++) {
            if (this.saleCuresView[i].cureView === cureView) return true;
        }return false;
    };

    SaleView.prototype.removeGiftItemView = function (giView) {
        var index = this.giftItemsView.indexOf(giView);
        if (index === -1) return; //TODO raise error
        this.giftItemsView.splice(index, 1);
        this.resetPayments();
        this.resetDiscountPercentForEmptySale();
        this.nbLoyaltyCardGoal = 0;
        if (this.giftItemsView.length === 0) {
            this.hasGiftItems = false;
        }
        this.calculateSaleFields();
        this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
    };

    SaleView.prototype.removeLoyaltyCardItemView = function (lciView) {
        var index = this.loyaltyCardItemsView.indexOf(lciView);
        if (index === -1) return; //TODO raise error
        this.loyaltyCardItemsView.splice(index, 1);
        if (lciView.loyaltyCardView) lciView.loyaltyCardView.isSelected = false;
        this.resetPayments();
        if (this.loyaltyCardItemsView.length == 0) {
            this.loyaltyCardItemView = null;
            this.nbLoyaltyCardGoal = 0;
        } else this.loyaltyCardItemView = this.loyaltyCardItemsView[0];
        this.calculateSaleFields(null, true);
        this.calculateEarnedLoyaltyPts();
        this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
    };

    //Services
    SaleView.prototype.getSaleServiceViewById = function (id) {
        var bs;
        for (var i = 0; i < this.saleServicesView.length; i++) {
            bs = this.saleServicesView[i].getModel();
            if (bs && bs.id == id) return this.saleServicesView[i];
        }
        return null;
    };

    SaleView.prototype.getGiftItemViewById = function (id) {
        var bs;
        for (var i = 0; i < this.giftItemsView.length; i++) {
            bs = this.giftItemsView[i].getModel();
            if (bs && bs.id == id) return this.giftItemsView[i];
        }
        return null;
    };

    SaleView.prototype.getGiftItemViewByIdOnPayments = function (id) {
        var bs;
        for (var i = 0; i < this.paymentsView.length; i++) {
            if (this.paymentsView[i].giftItemView) {
                bs = GiftItemData.getByIndex(this.paymentsView[i].giftItemView.giIndex);
                if (bs && bs.id == id) return this.paymentsView[i].giftItemView;
            }
        }return null;
    };

    SaleView.prototype.addServiceOnSale = function (serviceView, hrView) {
        if (!this.posView.domainView.scope.isReadOnly() && serviceView && hrView) {
            if (this.bookingView && (this.status == 'created' || this.status == 'waiting' || this.status == 'advance')) // created from bookingView
                {
                    this.bookingView.setSelectedByUserHrView(hrView);
                    this.bookingView.addServiceOnBookingOnUserSelect(serviceView);
                } else {
                var ssView = new SaleServiceView(null, -1, this.saleServicesView.length, this);
                ssView.setService(serviceView); //set activity end using service duration

                if (ssView.subSaleServicesView.length == 0) {
                    ssView.hrView = hrView;
                } else {

                    var hrHasSubservices = false;
                    var hrHasAllSubservices = true;

                    var subServicesWithHR = $filter('filter')(ssView.subSaleServicesView, function (subSaleSV, index, array) {
                        return subSaleSV.serviceView.nbHrsNeeded;
                    });

                    var hr = hrView.getModel();

                    //general traitement : subservice are assigned to the HR selected ih the HR have the skill
                    //otherwhise the subservice is assigned to the first HR which have the skill
                    for (var i = 0; i < subServicesWithHR.length; i++) {
                        if (hr.hasService(subServicesWithHR[i].serviceView.getModel())) {
                            hrHasSubservices = true;
                            subServicesWithHR[i].hrView = hrView;
                        } else {
                            if (subServicesWithHR[i].serviceView.nbHrsNeeded) {
                                hrHasAllSubservices = false;
                                var hrs = HumanResourceData.getActiveList();
                                var filterdHistory = $filter('filter')(hrs, function (hr, index, array) {
                                    return hr.hasService(subServicesWithHR[i].serviceView.getModel());
                                });
                                if (filterdHistory.length != 0) {
                                    subServicesWithHR[i].hrView = this.posView.domainView.getHrView(filterdHistory[0]);
                                }
                            }
                        }
                    }

                    if (!hrHasSubservices) {
                        //HR has the skill for no subservice
                        for (var i = 0; i < subServicesWithHR.length; i++) {
                            subServicesWithHR[i].hrView = hrView;
                        }
                    }

                    if (!hrHasSubservices || hrHasAllSubservices) {
                        ssView.uniqueSubSaleServiceHr = hr;
                        ssView.isSubSaleServicesViewHidden = true;
                    } else {
                        ssView.uniqueSubSaleServiceHr = null;
                        ssView.isSubSaleServicesViewHidden = false;
                    }
                }

                this.addSaleServiceView(ssView, true); //add bs to sale view

                //Set selection
                serviceView.isSelected = true;

                //close on mobile
                if (this.posView && this.posView.domainView.pTView.dim.mobileFormat) this.posView.selectors.service.display = false;
            }
            if (this.posView && this.posView.resizeBasket) //on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                this.posView.resizeBasket();
        }
    };

    SaleView.prototype.addSaleServiceView = function (ssView, updateSaleFields) {
        var index = this.saleServicesView.indexOf(ssView);
        if (index === -1) {
            this.saleServicesView.push(ssView);
            ssView.saleView = this;
            ssView.billPosition = this.saleServicesView.length;
            if (updateSaleFields) {
                this.calculateSaleFields();
                this.resetPayments();
            }
        }
    };

    SaleView.prototype.addBookingServiceOnSale = function (bsView) {
        var ssView = null;
        if (bsView) {
            ssView = new SaleServiceView(null, -1, this.saleServicesView.length, this);
            ssView.loadBookingServiceView(bsView);

            var sumSubServicesPrice = 0;

            for (var j = 0; j < bsView.subBsView.length; j++) {
                var sssView = new SaleServiceView(null, -1, String.fromCharCode(97 + j), null, ssView);
                sssView.loadBookingServiceView(bsView.subBsView[j]);
                ssView.addSubSaleServiceView(sssView);

                sumSubServicesPrice += sssView.price;
                //now the discount percent must be well initialised
                //ssView.updateDiscountPercentSubServices();
                //ssView.updatePrice();
            }
            this.addSaleServiceView(ssView, false); //add bs to sale view
        }
        return ssView;
    };

    SaleView.prototype.removeServiceOnSale = function (serviceView) {

        for (var i = this.saleServicesView.length - 1; i >= 0; i--) {
            if (this.saleServicesView[i].serviceView === serviceView) {
                this.saleServicesView[i].quantityInput--;
                this.saleServicesView[i].onChangeQuantity();
                if (this.saleServicesView[i].quantity === 0) this.removeSaleServiceView(this.saleServicesView[i]);else this.calculateSaleFields();
                return;
            }
        }
    };

    SaleView.prototype.removeSaleServiceView = function (bsView) {
        var index = this.saleServicesView.indexOf(bsView);
        if (index === -1) return; //TODO raise error
        this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
        this.saleServicesView.splice(index, 1);
        if (bsView.serviceView) bsView.serviceView.isSelected = false;
        this.resetPayments();
        this.resetDiscountPercentForEmptySale();
        this.calculateSaleFields();
    };

    SaleView.prototype.hasService = function (serviceView) {
        for (var i = 0; i < this.saleServicesView.length; i++) {
            if (this.saleServicesView[i].serviceView === serviceView) return true;
        }return false;
    };

    SaleView.prototype.resetDiscountPercentForEmptySale = function () {
        if (this.saleServicesView.length === 0 && this.saleProductsView.length === 0 && this.saleCuresView.length === 0 && this.giftItemsView.length === 0 && this.loyaltyCardItemsView.length === 0 && this.loyaltyDiscount > 0) this.discountPercent = 0;
    };

    SaleView.prototype.calculateSaleFields = function (ignoreUpdatePriceInput, loyaltyCardDeleted) {
        this.servicesPrice = 0;
        this.productsPrice = 0;
        this.curesPrice = 0;
        this.giftItemsPrice = 0;
        this.loyaltyCardsPrice = 0;
        this.loyaltyDiscount = 0;
        var discountValue = 0;

        var discountPercent = this.discountPercent;
        if (this.discountPercent && typeof this.discountPercent === 'string') {
            discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }

        if (this.bookingView && (this.status === "created" || this.status === "waiting" || this.status === "advance" || this.status === "soldProcess" || this.status === "advanceProcess")) for (var _i8 = 0; _i8 < this.bookingView.bookingServicesView.length; _i8++) {
            this.servicesPrice += this.bookingView.bookingServicesView[_i8].price;
        } else for (var _i9 = 0; _i9 < this.saleServicesView.length; _i9++) {
            this.servicesPrice += this.saleServicesView[_i9].price;
        }for (var _i10 = 0; _i10 < this.saleProductsView.length; _i10++) {
            this.productsPrice += this.saleProductsView[_i10].price;
        }for (var _i11 = 0; _i11 < this.saleCuresView.length; _i11++) {
            this.curesPrice += this.saleCuresView[_i11].price;
        }for (var _i12 = 0; _i12 < this.giftItemsView.length; _i12++) {
            this.giftItemsPrice += this.giftItemsView[_i12].price;
        }for (var _i13 = 0; _i13 < this.loyaltyCardItemsView.length; _i13++) {
            this.loyaltyCardsPrice += this.loyaltyCardItemsView[_i13].price;
        }var allItemsPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
        if (this.loyaltyCardItemView && !loyaltyCardDeleted && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
            if (this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType !== "special") {
                discountPercent = 0; //drived by loyalty
                discountValue = 0;
            }
            this.calculateUsedLoyaltyPts(allItemsPrice);
            this.hasLoyaltyDiscount = false;
            if (this.nbLoyaltyCardGoal > 0) //goal reached : apply discount
                {
                    this.loyaltyDiscount += this.loyaltyCardItemView.computeLoyaltyDiscount(this.loyaltyPts);
                    this.hasLoyaltyDiscount = this.loyaltyDiscount > 0;
                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                        discountValue += this.loyaltyDiscount;
                    }
                    if (this.loyaltyCardItemView.goalType === "discountPercent" && this.loyaltyCardsPrice === 0) {
                        //Can apply if discount is loyaltyCardsPrice has price
                        discountPercent += this.loyaltyDiscount;
                    }
                }
        } else if (loyaltyCardDeleted) {
            discountValue = 0;
            discountPercent = 0;
            this.discountPercent = 0;
        }

        if (discountPercent && discountPercent !== 0) discountValue += discountPercent * allItemsPrice / 100;
        this.price = Math.round((allItemsPrice - discountValue) * 100) / 100;
        if (ignoreUpdatePriceInput == undefined || !ignoreUpdatePriceInput) this.priceInput = $filter('currencyFormatFilter')(this.price);
        if (this.loyaltyCardItemView) this.updatePercent();
        this.productsPriceWithD = Math.round((this.productsPrice - this.productsPrice * this.discountPercent / 100) * 100) / 100;
        this.curesPriceWithD = Math.round((this.curesPrice - this.curesPrice * this.discountPercent / 100) * 100) / 100;
        this.servicesPriceWithD = Math.round((this.servicesPrice - this.servicesPrice * this.discountPercent / 100) * 100) / 100;
        this.giftItemsPriceWithD = Math.round((this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100) * 100) / 100;
        this.loyaltyCardsPriceWithD = Math.round((this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100) * 100) / 100;

        this.payedPrice = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            this.payedPrice += this.paymentsView[i].price;
        }this.currentPayment = this.price - this.payedPrice;

        if (this.status === SaleStatus.ADVANCE && this.currentPayment >= 0) {
            this.form.displayErrorCurrentPayment = false;
        }

        this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
        this.calculateVatLines();
        this.updateSellerFromItems();
        this.calculateEarnedLoyaltyPts();
        this.checkForInvalidAmounts();
    };

    SaleView.prototype.calculateEarnedLoyaltyPts = function () {
        if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
            this.loyaltyPts = 0;
            if (this.loyaltyCardItemView) {
                var loyaltyBasedPrice = this.price - this.loyaltyCardsPriceWithD;
                if (this.paymentsView.length != 0) {
                    var giftPrice = 0;
                    for (var i = 0; i < this.paymentsView.length; i++) {
                        if (this.paymentsView[i].type === "GIFT") giftPrice += this.paymentsView[i].price;
                    }loyaltyBasedPrice -= giftPrice;
                }
                this.loyaltyPts = Math.round(this.loyaltyCardItemView.ptsByCa * loyaltyBasedPrice + this.loyaltyCardItemView.ptsBySale);
            }
        }
    };

    SaleView.prototype.calculateUsedLoyaltyPts = function (allItemsPrice) {
        if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
            this.loyaltyPts = 0;
            this.loyaltyUsedPts = 0;
            if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal !== -1) {
                var hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
                this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, null, hasLoyaltyCardInShoppingCart);
            }
            if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal === 1) {
                //-> Not goal reached : generate points
                this.loyaltyPts = -this.loyaltyCardItemView.getGoalPoints(allItemsPrice); //goal reached -> generate negative points
                this.loyaltyUsedPts = this.loyaltyPts;
            }
        }
    };

    SaleView.prototype.remvoveLoyaltyGoal = function () {
        this.nbLoyaltyCardGoal = -1;
        this.hasLoyaltyDiscount = false;
        if (this.loyaltyCardItemView && this.loyaltyCardItemView.goalType != "special") this.discountPercent = 0;
        this.calculateSaleFields();
    };

    SaleView.prototype.calculateVatLines = function () {
        this.vatLines = this.initVatLines();
        var defaultVat = null;

        if (this.posView && this.posView.domainView) defaultVat = this.posView.domainView.getDefaultVatTax();

        if (defaultVat != null) //Can be 0
            {
                var priceWithD;
                if ((this.status == "created" || this.status == "waiting" || this.status == "advance") && this.bookingView) for (var i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                    priceWithD = this.bookingView.bookingServicesView[i].price - this.bookingView.bookingServicesView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                } else for (var i = 0; i < this.saleServicesView.length; i++) {
                    priceWithD = this.saleServicesView[i].price - this.saleServicesView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                for (var i = 0; i < this.saleCuresView.length; i++) {
                    priceWithD = this.saleCuresView[i].price - this.saleCuresView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                for (var i = 0; i < this.loyaltyCardItemsView.length; i++) {
                    priceWithD = this.loyaltyCardItemsView[i].price - this.loyaltyCardItemsView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                //not vat gor gifitem
                // Product can have a specific VAT
                for (var i = 0; i < this.saleProductsView.length; i++) {
                    priceWithD = this.saleProductsView[i].price - this.saleProductsView[i].price * this.discountPercent / 100;
                    if (this.saleProductsView[i].vat == null) this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));else this.addVatAmount(this.saleProductsView[i].vat, priceWithD - priceWithD * 100 / (100 + this.saleProductsView[i].vat), priceWithD * 100 / (100 + this.saleProductsView[i].vat));
                }
            }

        var totalVat = 0;
        var maxAmount = 0;
        // calculate total vat and set Sale.vat to max amount or maxItemConcerned by vat type

        for (var _i14 = 0; _i14 < this.vatLines.length; _i14++) {
            this.vatLines[_i14].amount = Math.round(this.vatLines[_i14].amount * 100) / 100;
            totalVat += this.vatLines[_i14].amount;
            if (this.vatLines[_i14].amount >= maxAmount) {
                maxAmount = this.vatLines[_i14].amount;
                this.vat = this.vatLines[_i14].tax;
                this.vatCode = this.vatLines[_i14].code;
            }
        }
        //when the total VAT is 0 we choose the VAT line that has the largest amount HT
        if (totalVat === 0) {
            var maxHt = 0;
            for (var _i15 = 0; _i15 < this.vatLines.length; _i15++) {
                this.vatLines[_i15].amount = Math.round(this.vatLines[_i15].amount * 100) / 100;
                if (this.vatLines[_i15].ht >= maxHt) {
                    maxHt = this.vatLines[_i15].ht;
                    this.vat = this.vatLines[_i15].tax;
                    this.vatCode = this.vatLines[_i15].code;
                }
            }
        }
        this.priceHT = this.price - totalVat;
    };

    SaleView.prototype.initVatLines = function () {
        var vatTaxes = [];

        if (this.posView && this.posView.domainView) {
            var vatsView = this.posView.domainView.getVatsView();
            if (vatsView) for (var i = 0; i < vatsView.length; i++) {
                if (vatsView[i].isUsable) vatTaxes.push({ tax: vatsView[i].tax, code: vatsView[i].code, amount: 0, ht: 0 });
            }
        }
        return vatTaxes;
    };

    SaleView.prototype.addVatAmount = function (tax, amount, ht) {
        var vatLine = null;
        for (var i = 0; i < this.vatLines.length; i++) {
            if (this.vatLines[i].tax == tax) vatLine = this.vatLines[i];
        }if (!vatLine) this.vatLines.push({ tax: tax, amount: amount, ht: ht });else {
            vatLine.amount += amount;
            vatLine.ht += ht;
        }
    };

    SaleView.prototype.validateCustomer = function (save) {
        if (this.customerView) {
            if (!this.customerView.canSave()) this.form.displayError = true;else {
                if (!this.customerView.getModel() && this.posView && this.posView.domainView) //Add to view
                    this.posView.domainView.addCustomerView(this.customerView);
                this.customerView.updateModel(save);
                this.form.displayError = false;
                this.form.displayCustomerButton = null;
            }
            this.displayGiftItemMailRecipientError = false;
        }
    };

    SaleView.prototype.initModel = function () {
        var sale = null;
        this.validateCustomer(false);

        if (this.saleIndex === -1) // creation
            {
                var day = null;
                if (this.dayView) day = this.dayView.getModel();

                sale = new Sale(null, day, null, null, false);
                this.saleIndex = SaleData.getIndexOf(sale);
                if (day) day.addSale(sale);

                sale.status = this.status; //must be done before giftitem update
                for (var i = 0; i < this.saleServicesView.length; i++) {
                    this.saleServicesView[i].updateModel();
                }for (var _i16 = 0; _i16 < this.saleProductsView.length; _i16++) {
                    this.saleProductsView[_i16].updateModel();
                }for (var _i17 = 0; _i17 < this.saleCuresView.length; _i17++) {
                    this.saleCuresView[_i17].updateModel();
                }for (var _i18 = 0; _i18 < this.giftItemsView.length; _i18++) {
                    this.giftItemsView[_i18].updateModel();
                }for (var _i19 = 0; _i19 < this.loyaltyCardItemsView.length; _i19++) {
                    this.loyaltyCardItemsView[_i19].updateModel();
                } //must be done after cure update

                this.copyDataTo(sale, null);
            } else {
            sale = this.getModel();
            if (this.dayView) {
                var newDay = this.dayView.getModel();
                if (newDay !== sale.day) {
                    sale.day.removeSale(sale);
                    newDay.addSale(sale);
                }
            }
            var previousStatus = sale.status;
            sale.status = this.status; //must be done before giftitem update

            sale.saleServices = [];
            for (var _i20 = 0; _i20 < this.saleServicesView.length; _i20++) {
                this.saleServicesView[_i20].updateModel();
            }sale.saleProducts = [];
            for (var _i21 = 0; _i21 < this.saleProductsView.length; _i21++) {
                this.saleProductsView[_i21].updateModel(previousStatus);
            }sale.saleCures = [];
            for (var _i22 = 0; _i22 < this.saleCuresView.length; _i22++) {
                this.saleCuresView[_i22].updateModel();
            }sale.giftItems = [];
            for (var _i23 = 0; _i23 < this.giftItemsView.length; _i23++) {
                this.giftItemsView[_i23].updateModel();
            }sale.loyaltyCardItems = [];
            for (var _i24 = 0; _i24 < this.loyaltyCardItemsView.length; _i24++) {
                this.loyaltyCardItemsView[_i24].updateModel();
            } //must be done after cure update
            this.copyDataTo(sale, previousStatus);
        }

        return sale;
    };

    SaleView.prototype.updateModel = function (transaction, endFunction, errorFunction) {
        var saleTransaction = null;
        if (transaction === undefined || !transaction) saleTransaction = new Transaction();else saleTransaction = transaction;

        var sale = this.initModel();

        saleTransaction.addObject(sale);
        var saleView = this;
        if (transaction === undefined || !transaction) //if yes transaction had been created by "this". Then execute it
            SaleSrv.executeTransaction(saleTransaction, function (data) {
                saleView.saleNumber = sale.saleNumber;
                saleView.advanceNumber = sale.advanceNumber;
                saleView.advancePrice = sale.advancePrice;
                saleView.estimationNumber = sale.estimationNumber;
                saleView.signatureCode = sale.signatureCode;
                saleView.softV = sale.softV;
                saleView.site = sale.site;
                saleView.totalLoyaltyPts = sale.totalLoyaltyPts;
                saleView.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;

                if (endFunction !== undefined) endFunction(data);
            }, errorFunction);

        if (this.form) this.form.displayChangeMsg = false;
        return true;
    };

    SaleView.prototype.reloadModel = function () {
        var sale = this.getModel();
        if (sale) {
            if (this.customerView) this.customerView.reloadModel();
            if (this.dayView) // Sale has been changed of day put it again inside day
                {
                    if (this.dayView.getModel() !== sale.day) {
                        /*                  //TODO
                                            var dayView = this.pTView.getPlanningDayViewById(sale.day.id);
                                            if (!dayView)
                                                return;
                                            this.dayView.removeSaleView(this);
                                            plgDayView.addSaleView(this);
                        */
                    }
                } else if (sale.day) {
                /*
                                    var plgDayView = this.pTView.getPlanningDayViewById(sale.day.id);
                                    if (!plgDayView)
                                        return;
                                    plgDayView.addSaleView(this);
                */
            }

            this.loadDataFrom(sale); //reset
        }
        if (this.form) this.form.displayChangeMsg = false;
    };

    SaleView.prototype.remove = function (successFunction, errorFunction) {
        var saleView = this;
        if (saleView.status === "advanceProcess") {
            if (!saleView.timeCreated) return;
            var nowTime = new Date().getTime();
            var deleteTime = saleView.timeCreated.getTime() + 1000 * 60 * 60; //1 hour
            if (saleView.timeCreated && nowTime < deleteTime) {
                var deleleDate = new Date(deleteTime);
                var _opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = gettextCatalog.getString("Vous ne pouvez pas supprimer ce ticket pour le moment. Traitement en cours jusqu'à");+" " + $filter('date')(deleleDate, "H'h'mm");
                            return tableModel;
                        } } };

                $dialog.dialog(_opts).open();
                return;
            }
        }
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/removeConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    if (saleView.isEstimationCost()) {
                        if (saleView.customerView) tableModel["label"] = " " + gettextCatalog.getString("le devis pour") + " " + saleView.customerView.label;else tableModel["label"] = " " + gettextCatalog.getString("le devis en cours");
                    } else {
                        if (saleView.customerView) tableModel["label"] = " " + gettextCatalog.getString("le ticket pour") + " " + saleView.customerView.label;else tableModel["label"] = " " + gettextCatalog.getString("le ticket en cours");
                    }
                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                saleView.removeModel(undefined, successFunction, errorFunction);
            }
        });
    };

    SaleView.prototype.removeModel = function (transaction, successFunction, errorFunction) {
        if (this.bookingView) this.bookingView.saleView = null;
        var sale = this.getModel();
        if (sale) {
            sale.isDeleted = true;
            if (sale.customer) sale.customer.removeSale(sale);
            if (this.customerView) this.customerView.initHistoryView();
            if (sale.day) sale.day.removeSale(sale);
            if (sale.booking) sale.booking.sale = null;
            for (var i = 0; i < sale.payments.length; i++) {
                if (sale.payments[i].giftItem) //gift item is no more used
                    {
                        sale.payments[i].giftItem.isUsed = false;
                        sale.payments[i].giftItem.paymentSale = null;
                    }
            }if (transaction !== undefined && transaction) {
                transaction.addObject(sale);
            } else {
                SaleSrv.remove(sale, successFunction, errorFunction);
            }
        }
        for (var _i25 = 0; _i25 < this.saleProductsView.length; _i25++) {
            if (this.saleProductsView[_i25].productView && this.saleProductsView[_i25].productView.hasQuantity && !this.isEstimationCost()) {
                this.saleProductsView[_i25].productView.quantity += this.saleProductsView[_i25].quantity;
                this.saleProductsView[_i25].removeModel();
            }
        }
        for (var i = 0; i < this.paymentsView.length; i++) {
            if (this.paymentsView[i].giftItemView) //gift item is no more used
                {
                    this.paymentsView[i].giftItemView.isUsed = false;
                    this.paymentsView[i].giftItemView.paymentSaleView = null;
                }
        }
    };

    SaleView.prototype.getFirstHrView = function () {

        var hrView = null;
        if ((this.status == "created" || this.status == "waiting" || this.status == "advance") && this.bookingView) for (var i = 0; i < this.bookingView.bookingServicesView.length && !hrView; i++) {
            if (this.bookingView.bookingServicesView[i].plgDayHrView) hrView = this.bookingView.bookingServicesView[i].plgDayHrView.hrView;
        } else for (var i = 0; i < this.saleServicesView.length && !hrView; i++) {
            hrView = this.saleServicesView[i].hrView;
        }for (var i = 0; i < this.saleProductsView.length && !hrView; i++) {
            hrView = this.saleProductsView[i].hrView;
        }for (var i = 0; i < this.saleCuresView.length && !hrView; i++) {
            hrView = this.saleCuresView[i].hrView;
        }for (var i = 0; i < this.giftItemsView.length && !hrView; i++) {
            hrView = this.giftItemsView[i].hrView;
        }for (var i = 0; i < this.loyaltyCardItemsView.length && !hrView; i++) {
            hrView = this.loyaltyCardItemsView[i].hrView;
        }return hrView;
    };

    SaleView.prototype.updateCurrentPaymentInputArrow = function (number) {
        if (this.currentPaymentInput != null && typeof this.currentPaymentInput === 'string') {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.currentPaymentInput);
            var price = parseFloat(priceStr);
            if (price !== "NaN") {
                price += number;
                this.currentPayment = price;
                this.currentPaymentInput = $filter('currencyFormatFilter')(price);
            }
        }
    };

    SaleView.prototype.increaseDiscountPercent = function (step) {
        if (!this.isReadOnly && !this.hasGiftItems && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
            if (step + this.discountPercent > 100) this.discountPercent = 100;else this.discountPercent += step;
            this.resetPayments();
            this.calculateSaleFields();
        }
    };

    SaleView.prototype.decreaseDiscountPercent = function (step) {
        if (!this.isReadOnly && !this.hasGiftItems && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
            if (this.discountPercent - step < 0) this.discountPercent = 0;else this.discountPercent -= step;
            this.resetPayments();
            this.calculateSaleFields();
        }
    };

    SaleView.prototype.updateAdvancePercent = function (number) {
        if (this.advancePercent + number >= 0 && this.advancePercent + number <= 50) {
            this.advancePercent += number;

            this.currentPayment = Math.round(this.price * this.advancePercent) / 100;
            this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
        }
    };

    SaleView.prototype.updateAdvancePercentFromCurrentPayment = function () {
        this.advancePercent = this.currentPayment / this.price * 100;
    };

    SaleView.prototype.onCurrentPaymentInputChange = function () {
        if (this.currentPaymentInput != null && typeof this.currentPaymentInput === 'string') {
            var currentPaymentStr = CurrencyManager.getPriceFromPriceInput(this.currentPaymentInput);
            var currentPayment = parseFloat(currentPaymentStr);
            if (currentPayment !== "NaN") this.currentPayment = currentPayment;else this.currentPayment = null;
        }
    };

    SaleView.prototype.updateHasUnpaid = function () {
        this.hasUnpaid = false;
        for (var i = 0; i < this.paymentsView.length; i++) {
            if (this.paymentsView[i].type === "UNPAID") this.hasUnpaid = true;
        }
    };

    SaleView.prototype.setCurrentPaymentToMax = function () {
        this.payedPrice = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            this.payedPrice += this.paymentsView[i].price;
        }this.currentPayment = this.price - this.payedPrice;
        this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
    };

    SaleView.prototype.setCurrentPayment = function (price) {
        this.currentPayment = price;
        this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
    };

    SaleView.prototype.addPaymentView = function (type, giftItemView, otherPaymentTypeView) {
        //type : type of payment ex : CB
        //giftItemView : giftItem used for payment
        // otherPaymentTypeView : other type of payment
        this.payedPrice = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            this.payedPrice += this.paymentsView[i].price;
        }var price = this.currentPayment;
        var letToPay = this.price - this.payedPrice - this.currentPayment;
        if (letToPay <= 0) {
            price = this.price - this.payedPrice;
            this.change = -letToPay;
        } else this.change = 0;
        if (letToPay < 0) letToPay = 0;
        if (price <= 0) alert("Le montant du paiement ne peut dépasser la somme à payer.");else {
            if (this.form.nbPayments != null && typeof this.form.nbPayments === 'string') {
                var nbPaymentsStr = CurrencyManager.getPriceFromPriceInput(this.form.nbPayments);
                this.form.nbPayments = parseInt(nbPaymentsStr);
            }
            this.currentPayment = letToPay;
            this.currentPaymentInput = $filter('currencyFormatFilter')(letToPay);
            this.payedPrice += price;
            var date = null;
            if (this.form.nbPayments > 1) {
                var dividedPrice = Math.round(price / this.form.nbPayments * 100) / 100;

                if (this.paymentsView.length !== 0 && this.paymentsView[this.paymentsView.length - 1].date != null) // If another payment exist add one month to set first payment of multi payments
                    {
                        date = new Date(this.paymentsView[this.paymentsView.length - 1].date);
                        date.setMonth(date.getMonth() + 1);
                    }
                for (var _i26 = 0; _i26 < this.form.nbPayments - 1; _i26++) {
                    var _paymentView = new PaymentView(null, this);
                    _paymentView.init(type, dividedPrice, date, otherPaymentTypeView);
                    this.paymentsView.push(_paymentView);
                    price -= dividedPrice;
                    date = new Date(_paymentView.date);
                    date.setMonth(date.getMonth() + 1);
                }
                this.form.nbPayments = 1;
            }

            var paymentView = new PaymentView(null, this);
            paymentView.init(type, price, date, otherPaymentTypeView);
            this.paymentsView.push(paymentView);

            if (giftItemView !== undefined && giftItemView) {
                if (this.bookingView) paymentView.canDelete = !this.bookingView.containsGiftOnBs(giftItemView);
                paymentView.giftItemView = giftItemView;
                giftItemView.isUsed = true;
                giftItemView.paymentSaleView = this;
                if (this.posView) this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            }
            this.form.displayError = false;
        }
        if (type === "GIFT") this.calculateEarnedLoyaltyPts();
        if (type === "UNPAID") this.hasUnpaid = true;

        if (this.payedPrice >= this.price) // HasFullPayment
            if (this.paymentsView && this.paymentsView.length === 1) //close menu if only one payment
                this.manageOtherActionsMenu(false, 0);else this.manageOtherActionsMenu(true, 0); //Go to root page of but don't close menu
    };

    SaleView.prototype.sendMails = function () {
        var sale = this.getModel();
        if (sale) SaleSrv.sendMails(sale);
    };

    SaleView.prototype.removeAllPaymentView = function () {

        for (var i = 0, sec = 0; i < this.paymentsView.length && sec < 100; sec++) {
            if (this.paymentsView[i].canDelete) this.removePaymentView(this.paymentsView[i]);else i++;
        }
    };

    SaleView.prototype.removePaymentView = function (paymentView) {
        if (paymentView) {
            var index = this.paymentsView.indexOf(paymentView);
            if (index != -1) {
                this.paymentsView.splice(index, 1);

                this.payedPrice = 0;
                for (var i = 0; i < this.paymentsView.length; i++) {
                    this.payedPrice += this.paymentsView[i].price;
                }var letToPay = this.price - this.payedPrice;
                if (letToPay < 0) letToPay = 0;
                this.currentPayment = letToPay;
                this.currentPaymentInput = $filter('currencyFormatFilter')(letToPay);
                this.change = 0;
                if (paymentView.giftItemView) {
                    paymentView.giftItemView.isUsed = false;
                    paymentView.giftItemView.paymentSaleView = null;
                    if (this.posView) this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                }
                if (paymentView.type == "GIFT") this.calculateEarnedLoyaltyPts();
            }
            this.updateHasUnpaid();
        }
    };

    SaleView.prototype.canSale = function () {
        return !this.posView.domainView.scope.isReadOnly() && this.price >= 0 && this.hasFullPayment() && this.canSave() && this.posView && !this.posView.selectors.giftItem.display && this.hasMailAddressForGiftItems();
    };

    SaleView.prototype.canSaleForAdvance = function () {
        var canSale = this.canSale();
        if (this.status === SaleStatus.ADVANCE) {
            canSale = canSale && this.currentPayment >= 0;
        }
        return canSale;
    };

    //duplication of hasItems with a new comportment for the pos
    SaleView.prototype.hasItemsPos = function () {
        if (this.bookingView) {
            if (this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) return false;
        } else if (this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) return false;
        return true;
    };

    SaleView.prototype.hasItems = function () {
        if (this.bookingView) {
            if (this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0 || this.saleCuresView.length != 0 && !this.customerView) //cant sale a cure if no customer
                return false;
        } else if (this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0 || this.saleCuresView.length != 0 && !this.customerView) //cant sale a cure if no customer
            return false;
        return true;
    };

    SaleView.prototype.hasItemsOtherThanService = function () {
        return this.saleProductsView.length != 0 || this.saleCuresView.length != 0 || this.giftItemsView.length != 0 || this.loyaltyCardItemsView.length != 0;
    };

    SaleView.prototype.canSave = function () {
        if (this.posView.domainView.scope.isReadOnly()) {
            return false;
        }
        if (this.hasInvalidAmounts) {
            return false;
        }
        if (!this.dayView || !this.customerView && !this.isOccasionalCustomer || this.customerView && !this.customerView.canSave() || this.customerView && (this.form.displayErrorLandLine || this.form.displayErrorMobile)) return false;
        if (this.bookingView) {
            if (!this.bookingView.canSave()) return false;
            if (this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0 || this.saleCuresView.length != 0 && !this.customerView) //cant sale a cure if no customer
                return false;
        } else if (this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0 || this.saleCuresView.length != 0 && !this.customerView) //cant sale a cure if no customer
            return false;
        var originalPrice = Math.round((this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice) * 100) / 100;
        if (this.price > originalPrice || !this.isValidLoyaltyPoints) {
            return false;
        }
        return true;
    };

    SaleView.prototype.hasMailAddressForGiftItems = function () {
        var hasMail = true;
        if (!this.hasCustomerWithEmail()) {
            if (this.giftItemsView.length > 0) {
                for (var i = 0; i < this.giftItemsView.length; i++) {
                    if (this.giftItemsView[i].editionType === "email" && !this.giftItemsView[i].hasCustomerWithEmail()) {
                        hasMail = false;
                        this.displayGiftItemMailRecipientError = true;
                        break;
                    }
                }
            }
        }
        return hasMail;
    };

    SaleView.prototype.hasCustomerWithEmail = function () {
        return this.customerView && this.customerView.email;
    };

    SaleView.prototype.hasFullPayment = function () {
        var payed = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            payed += this.paymentsView[i].price;
        }payed = Math.round(payed * 100);
        return Math.round(this.price * 100) - payed <= 0;
    };

    SaleView.prototype.hasGiftItemPayment = function () {
        var hasGiftItemPayment = this.paymentsView.find(function (paymentView) {
            return paymentView.type === "GIFT";
        });
        return hasGiftItemPayment != null;
    };

    SaleView.prototype.resetPayments = function (force) {
        if (this.status != "advance" || force) //no reset on advance
            {
                if (this.bookingView) {
                    for (var i = 0; i < this.paymentsView.length;) {
                        // remove only if bookingservice isnt linked to payment.gift or online payment
                        if (this.paymentsView[i].type != "CBONLINE" && (!this.paymentsView[i].giftItemView || !this.bookingView.containsGiftOnBs(this.paymentsView[i].giftItemView))) this.paymentsView.splice(i, 1);else i++;
                    }
                } else this.paymentsView = [];
                this.change = 0;
                this.payedPrice = 0;
                if (this.posView && this.posView.selectors && this.posView.selectors.giftItemToUse) this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            }
    };

    SaleView.prototype.updatePaymentsForADate = function (date, otherPaymentTypesView) {
        this.paymentsForADate.initSalePaymentsPrice();
        this.paymentsForADate.hasSpecificPaymentDate = false;
        this.paymentsForADate.otherPaymentTypePrices = this.initOtherPaymentTypeForADate(otherPaymentTypesView);
        this.paymentsForADate.price = 0;
        this.paymentsForADate.nbPayments = 0;
        this.paymentsForADate.priceHT = 0;
        if (this.status != "canceled" && this.status != "credit") {
            var fullYear = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            if (this.timeCreated) this.paymentsForADate.hasSpecificPaymentDate = !(this.timeCreated.getFullYear() == fullYear && this.timeCreated.getMonth() == month && this.timeCreated.getDate() == day);
            var paymentsDate = [];
            var index = 0;
            var dayId;
            var time;
            var match = false;
            for (var j = 0; j < this.paymentsView.length; j++) {
                time = this.paymentsView[j].date.getTime();

                match = false;
                if (this.paymentsView[j].date && time != 0 && !isNaN(time)) {
                    dayId = DaySrv.getIdFromDate(this.paymentsView[j].date);
                    index = paymentsDate.indexOf(dayId);
                    if (index == -1) paymentsDate.push(dayId);
                } else match = true;
                if (!match) match = this.paymentsView[j].date.getFullYear() == fullYear && this.paymentsView[j].date.getMonth() == month && this.paymentsView[j].date.getDate() == day;
                if (match) {
                    var salePaymentType = SalePaymentTypeFactory.from(sale.payments[j].type);
                    if (salePaymentType) {
                        this.paymentsForADate[salePaymentType.keyPrice] += this.paymentsView[j].price;
                    } else if (this.paymentsView[j].otherPaymentTypeView) {
                        this.addOtherPaymentTypeForADate(otherPaymentTypesView, this.paymentsForADate.otherPaymentTypePrices, this.paymentsView[j].otherPaymentTypeView, this.paymentsView[j].price);
                    }
                }
            }
            paymentsDate.sort();
            this.paymentsForADate.nbPayments = paymentsDate.length;
            this.paymentsForADate.paymentNumber = paymentsDate.indexOf(DaySrv.getIdFromDate(date)) + 1;
            this.paymentsForADate.price = Math.round(this.paymentsForADate.computeTotalSalePaymentsPrice() * 100) / 100;

            for (var j = 0; j < this.paymentsForADate.otherPaymentTypePrices.length; j++) {
                this.paymentsForADate.price += this.paymentsForADate.otherPaymentTypePrices[j];
            }this.paymentsForADate.price = Math.round(this.paymentsForADate.price * 100) / 100;

            //this.paymentsForADate.priceHT = Math.round((this.paymentsForADate.price  * 1000/(100+this.vat))*100)/1000;  //TODO
            this.paymentsForADate.hasSamePriceThanSale = Math.round(this.paymentsForADate.price * 100) / 100 == Math.round(this.price * 100) / 100;
        }
    };

    SaleView.prototype.initOtherPaymentTypeForADate = function (otherPaymentTypesView) {
        var optypes = [];
        if (otherPaymentTypesView) for (var i = 0; i < otherPaymentTypesView.length; i++) {
            optypes.push(0);
        }return optypes;
    };

    SaleView.prototype.addOtherPaymentTypeForADate = function (otherPaymentTypesView, otherPaymentTypePrices, optView, amount) {
        if (otherPaymentTypesView) {
            for (var i = 0; i < otherPaymentTypesView.length; i++) {
                if (otherPaymentTypesView[i] === optView) {
                    otherPaymentTypePrices[i] += amount;
                    return;
                }
            }
        }
    };

    SaleView.prototype.sell = function (successFunction, errorFunction) {
        if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
            if (this.bookingView) {
                this.saleServicesView = [];
                for (var i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                    if (!this.bookingView.bookingServicesView[i].cureItemToServiceUsageView) this.addBookingServiceOnSale(this.bookingView.bookingServicesView[i]);
                }
            }
            this.setStatus("sold");
        }
        var saleView = this;
        this.updateSellerFromItems();
        if (this.bookingView) this.bookingView.updateModel(null, BookingSaveTransactionOrigin.SOLD_SALE); //must be done before sale creation, bookingId managed by ServerSrv pool
        this.updateModel(null, successFunction, errorFunction);
    };

    SaleView.prototype.keepAdvance = function (endFunction) {
        if (this.status == "advance") {
            this.remvoveLoyaltyGoal(); //Force remove of Loyalty to avoid negative tickets
            this.saleServicesView = [];
            this.saleProductsView = [];
            this.saleCuresView = [];
            this.giftItemsView = [];
            this.loyaltyCardItemsView = [];
            var saleProductView = new SaleProductView(null, -1, 0, this);
            saleProductView.label = "Acompte conservé";
            saleProductView.originalPrice = this.payedPrice;
            saleProductView.price = this.payedPrice;
            saleProductView.quantity = 1;
            saleProductView.updatePriceHT();
            this.addSaleProductView(saleProductView, true);
            this.setStatus("advanceKeeped");
        }
        var saleView = this;
        this.updateModel(null, endFunction);
    };

    SaleView.prototype.cancelSaleAction = function (successFunction, errorFunction) {

        if (this.isCreatedByCustomer && (!this.canRefundGiftItem || !this.transformToGiftOnCancel)) //try to refund
            {
                var saleView = this;
                if (saleView.posView) saleView.posView.domainView.pTView.loading = true;

                SaleSrv.refund(this.getModel(), function () {
                    saleView.cancelSaleFinalAction(successFunction, errorFunction);
                    if (saleView.posView) {
                        saleView.posView.domainView.pTView.loading = false;
                        saleView.posView.loadSale();
                    }
                }, function (error) {
                    var sentence = "Erreur remboursement impossible.";
                    if (error && error.data) {
                        if (error.data.errorCode == "005407") sentence = "Vous ne pouvez pas effectuer deux demandes de remboursement la même journée";
                        if (error.data.errorCode == "002999") sentence = "Vous devez certifier votre compte de paiement " + Brand.label + " (KYC)";
                        if (error.data.errorCode == "005405") sentence = "Vous ne disposez pas d'assez d'argent sur votre compte " + Brand.label;
                    }
                    saleView.posView.domainView.pTView.loading = false;
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/errorDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function dialogsModel() {
                                var tableModel = [];
                                tableModel["label"] = sentence;
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                });
            } else this.cancelSaleFinalAction(successFunction, errorFunction);
    };

    SaleView.prototype.cancelSaleFinalAction = function (successFunction, errorFunction) {
        if (this.status === "sold" || this.status === "advance") {
            this.setStatus("canceled");
            var creditSaleView = this.getClone(this.creditDayView);
            creditSaleView.advanceNumber = this.advanceNumber;
            creditSaleView.estimationNumber = this.estimationNumber;
            creditSaleView.canceledSaleNumber = this.saleNumber;
            creditSaleView.isCreatedByCustomer = this.isCreatedByCustomer;
            creditSaleView.delivery = this.delivery;
            creditSaleView.deliveryMsg = this.deliveryMsg;
            creditSaleView.techNote = this.techNote;
            creditSaleView.comment = this.comment;
            creditSaleView.advancePrice = this.advancePrice;
            creditSaleView.setStatus("credit");
            creditSaleView.price = -creditSaleView.price;
            creditSaleView.priceHT = -creditSaleView.priceHT;
            creditSaleView.servicesPrice = -creditSaleView.servicesPrice;
            creditSaleView.productsPrice = -creditSaleView.productsPrice;
            creditSaleView.curesPrice = -creditSaleView.curesPrice;
            creditSaleView.giftItemsPrice = -creditSaleView.giftItemsPrice;
            creditSaleView.loyaltyCardsPrice = -creditSaleView.loyaltyCardsPrice;
            creditSaleView.servicesPriceWithD = -creditSaleView.servicesPriceWithD;
            creditSaleView.productsPriceWithD = -creditSaleView.productsPriceWithD;
            creditSaleView.curesPriceWithD = -creditSaleView.curesPriceWithD;
            creditSaleView.giftItemsPriceWithD = -creditSaleView.giftItemsPriceWithD;
            creditSaleView.loyaltyCardsPriceWithD = -creditSaleView.loyaltyCardsPriceWithD;

            for (var i = 0; i < creditSaleView.paymentsView.length; i++) {
                creditSaleView.paymentsView[i].price = -creditSaleView.paymentsView[i].price;
                if (creditSaleView.paymentsView[i].giftItemView) //gift item is no more used
                    {
                        if (!this.bookingView || !this.bookingView.containsGiftOnBs(creditSaleView.paymentsView[i].giftItemView)) creditSaleView.paymentsView[i].giftItemView.isUsed = false;
                        creditSaleView.paymentsView[i].giftItemView.paymentSaleView = null;
                    }
            }

            for (var i = 0; i < this.saleServicesView.length; i++) {
                creditSaleView.saleServicesView[i].setPriceAsCredit();
            }for (var i = 0; i < this.saleProductsView.length; i++) {
                creditSaleView.saleProductsView[i].price = -creditSaleView.saleProductsView[i].price;

                if (this.saleProductsView[i].productView && this.saleProductsView[i].productView.hasQuantity) //reput product on productview stock
                    this.saleProductsView[i].productView.quantity += this.saleProductsView[i].quantity;
            }
            for (var i = 0; i < this.saleCuresView.length; i++) {
                creditSaleView.saleCuresView[i].price = -creditSaleView.saleCuresView[i].price;
            }for (var i = 0; i < this.giftItemsView.length; i++) {
                creditSaleView.giftItemsView[i].price = -creditSaleView.giftItemsView[i].price;
            }for (var i = 0; i < this.loyaltyCardItemsView.length; i++) {
                creditSaleView.loyaltyCardItemsView[i].price = -creditSaleView.loyaltyCardItemsView[i].price;
            }if (this.bookingView) {
                this.bookingView.saleView = null;
                this.bookingView.updateModel(null, BookingSaveTransactionOrigin.CANCELED_SALE);
            }

            var saleTransaction = new Transaction();
            this.updateModel(saleTransaction);
            creditSaleView.updateModel(saleTransaction);
            if (this.isCreatedByCustomer) {
                // SlackSrv.sendMessage("GiftItem cancelSale - SaleView - cancelSaleFinalAction " + this.id);
            }
            SaleSrv.executeTransaction(saleTransaction, successFunction, errorFunction);
        }
    };

    SaleView.prototype.checkCreditDayView = function () {

        this.creditDayView = null;
        if (this.dayView) {
            var oDay = DayData.getOpenDay(-1);
            if (oDay) {
                var cDay = this.dayView.getModel();
                if (cDay === oDay) this.creditDayView = this.dayView;else {
                    this.creditDayView = new DayView(DayData.getIndexOf(oDay));
                }
            } else {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = "Vous ne pouvez pas annuler ce ticket car il n'existe aucune journée ouverte.";
                            return tableModel;
                        }
                    }
                };
                $dialog.dialog(opts).open();
                return false;
            }
        }
        return this.creditDayView != null;
    };

    SaleView.prototype.cancelSale = function (successFunction, errorFunction) {
        var saleView = this;
        //check if can cancel
        if (this.checkCreditDayView() && this.canCancelSale()) {
            this.updateRefundGiftItem();
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/planningPos/pos/form/cancelConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        if (saleView.customerView) tableModel["label"] = " le ticket pour " + saleView.customerView.label;else tableModel["label"] = " le ticket en cours";
                        tableModel["saleView"] = saleView;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    saleView.cancelSaleAction(function () {
                        if (successFunction !== undefined) successFunction();
                    }, function (data) {
                        if (data !== undefined && errorFunction !== undefined) errorFunction(data);
                    });
                }
            });
        }
    };

    SaleView.prototype.canChangeDay = function () {

        if (this.status === "created" || this.status === "waiting") return true;
        if (this.status === "advance" || this.status === "sold" && this.dayView) {
            var cDay = this.dayView.getModel();
            if (cDay && !(cDay.closure && cDay.closure.status === "closed")) return true;
        }
        return false;
    };

    SaleView.prototype.canChangeDayTo = function (dayId) {

        if (this.status === "created" || this.status === "waiting") return true;
        var cDay = this.dayView.getModel();
        if (cDay && cDay.id != dayId) {
            var tDay = DayData.getById(dayId);
            var dayView = new DayView(DayData.getIndexOf(tDay));
            if (dayView) {
                if ((this.status == "sold" || this.status == "advance") && !(tDay.closure && tDay.closure.status == "closed")) return true;
            }
        }
        return false;
    };

    SaleView.prototype.hasGiftItemUsed = function () {
        var usedGiftItemView = this.giftItemsView.find(function (giftItemView) {
            return giftItemView.isUsed === true;
        });
        return usedGiftItemView != null;
    };

    SaleView.prototype.hasSaleCureWithUsage = function () {
        var saleCureWithCureItem = this.saleCuresView.find(function (saleCureView) {
            return saleCureView.hasCureItemUsage();
        });
        return saleCureWithCureItem != null;
    };

    SaleView.prototype.save = function () {
        this.setStatus("waiting");
        if (this.bookingView) this.bookingView.updateModel(null, BookingSaveTransactionOrigin.WAITING_SALE); //generate id

        this.updateModel();
    };

    SaleView.prototype.openPrintWindow = function () {
        var left = screen.width / 2 - 800 / 2;
        var top = screen.height / 2 - 500 / 2;
        this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        if (this.printWindow) this.printWindow.window.focus();
    };

    SaleView.prototype.onLoyaltyPtsChange = function () {
        if (this.loyaltyPts != null) {
            if (typeof this.loyaltyPts === 'string') {
                var loyaltyPtsStr = CurrencyManager.getPriceFromPriceInput(this.loyaltyPts);
                this.loyaltyPts = parseInt(loyaltyPtsStr);
            }
            this.checkLoyaltyPointsValid();
        }
    };

    SaleView.prototype.onLoyaltyUsedPtsChange = function () {
        if (this.loyaltyUsedPts != null) {
            if (typeof this.loyaltyUsedPts === 'string') {
                var loyaltyPtsStr = CurrencyManager.getPriceFromPriceInput(this.loyaltyUsedPts);
                this.loyaltyUsedPts = parseInt(loyaltyPtsStr);
            }
        }
    };

    SaleView.prototype.checkLoyaltyPointsValid = function () {
        if (isNaN(this.loyaltyPts) || this.loyaltyCardItemView.pts + this.loyaltyPts < 0) {
            this.isValidLoyaltyPoints = false;
        } else {
            this.isValidLoyaltyPoints = true;
        }
    };

    SaleView.prototype.increaseLoyaltyPts = function (step) {
        if (!this.isReadOnly) {
            if (typeof step === 'string') {
                step = parseInt(step);
            }
            this.loyaltyPts += step;
            this.checkLoyaltyPointsValid();
        }
    };

    SaleView.prototype.increaseLoyaltyUsedPts = function (step) {
        if (!this.isReadOnly) {
            if (typeof step === 'string') {
                step = parseInt(step);
            }
            this.loyaltyUsedPts += step;
        }
    };

    SaleView.prototype.updateSellerFromItems = function () {
        this.hrSellerView = null;
        if (this.bookingView && (this.status == "created" || this.status == "waiting" || this.status == "advance" || this.status == "soldProcess" || this.status == "advanceProcess") && this.bookingView.bookingServicesView.length > 0 && this.bookingView.bookingServicesView[0].plgDayHrView && this.bookingView.bookingServicesView[0].plgDayHrView.hrView) this.hrSellerView = this.bookingView.bookingServicesView[0].plgDayHrView.hrView;else {
            if (this.saleServicesView.length > 0) {
                if (this.saleServicesView[0].subSaleServicesView.length > 0 && this.saleServicesView[0].subSaleServicesView[0].hrView) {
                    this.hrSellerView = this.saleServicesView[0].subSaleServicesView[0].hrView;
                } else if (this.saleServicesView[0].hrView) {
                    this.hrSellerView = this.saleServicesView[0].hrView;
                }
            }
            if (!this.hrSellerView && this.saleProductsView.length > 0 && this.saleProductsView[0].hrView) this.hrSellerView = this.saleProductsView[0].hrView;
            if (!this.hrSellerView && this.saleCuresView.length > 0 && this.saleCuresView[0].hrView) this.hrSellerView = this.saleCuresView[0].hrView;
            if (!this.hrSellerView && this.giftItemsView.length > 0 && this.giftItemsView[0].hrView) this.hrSellerView = this.giftItemsView[0].hrView;
            if (!this.hrSellerView && this.loyaltyCardItemsView.length > 0 && this.loyaltyCardItemsView[0].hrView) this.hrSellerView = this.loyaltyCardItemsView[0].hrView;
        }

        if (this.hrSellerView == null) this.hrOpView = null;else if (this.hrOpView == null) this.hrOpView = this.hrSellerView;
    };

    SaleView.prototype.getDiscount = function (saleItem, quantity) {
        var discountTTC = 0;
        if (saleItem.discountPercent > 0) {
            if (saleItem.discountPercent == 100) discountTTC = saleItem.originalPrice * quantity;else {
                discountTTC = saleItem.price / (1 - saleItem.discountPercent / 100) - saleItem.price;
            }
        }
        return discountTTC;
    };

    SaleView.prototype.getDiscountGlobalTTC = function (saleItem, discountTTC) {
        var discountRemise = 0;
        if (this.discountPercent > 0 && discountTTC != saleItem.originalPrice) {
            discountRemise += saleItem.price * this.discountPercent / 100;
        }
        return discountRemise;
    };

    SaleView.prototype.addLine = function (saleItem, quantity, discountTTC, label) {
        var vat = saleItem.vat || saleItem.vat === 0 ? saleItem.vat : "20";
        var price = saleItem.originalPrice;
        var priceHT = saleItem.originalPrice / (vat / 100 + 1);
        var finalLabel = priceHT == 0 ? label + "</br>" + gettextCatalog.getString("Code 328 gratuité totale") : label;
        var lineContent = '' + '<tr>' + '<td style="width:13px">' + quantity + '</td>' + '<td>' + finalLabel + '</td>' + '<td>' + gettextCatalog.getString("Code TVA") + " : " + saleItem.vatCode + '</td>' + '<td>' + gettextCatalog.getString("TVA") + ' = ' + vat + '%</td>' + '<td>' + gettextCatalog.getString("Prix Unitaire HT") + ' = ' + $filter('currencyFormatFilter')(priceHT) + '</td>' + '<td>' + gettextCatalog.getString("Prix Unitaire TTC") + ' = ' + $filter('currencyFormatFilter')(price) + '</td>' + '<td>' + gettextCatalog.getString("Prix Total HT") + ' = ' + $filter('currencyFormatFilter')(priceHT * quantity) + '</td>' + '<td>' + gettextCatalog.getString("Prix Total TTC") + ' = ' + $filter('currencyFormatFilter')(price * quantity) + '</td>' + '</tr>';
        var discountP = discountTTC * 100 / (saleItem.originalPrice * quantity);
        if (discountP > 0) {
            lineContent += '' + '<tr>' + '<td style="width:13px"></td>' + '<td style="font-style: italic"><span>' + gettextCatalog.getString("Remise de") + '</span> ' + $filter('number')(discountP, 2) + '%</td>' + '<td></td>' + '<td class="price">-' + $filter('currencyFormatFilter')(discountTTC) + '</td>' + '</tr>';
        }
        return lineContent;
    };

    SaleView.prototype.printSell = function (printSite, dSignatureCode) {
        var site = printSite;
        if (this.printWindow) {
            if (this.site) {
                site = new Site(this.site);
            } else if (!site) {
                site = SiteData.defaultSite;
            }

            //'</head><body onload="window.print();setTimeout(function(){window.close();}, 1);"><div class="reward-body">' +
            var onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
            if (IOSDevice.isIOSDevice()) {
                onLoadContent = "window.print();";
            }

            var documentContent = '<!DOCTYPE html><html><head>' + '<link rel="stylesheet" type="text/css" href="/css/print.css" />' + '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' + '<script src="/lib/barcode/JsBarcode.js"></script>' + '<script src="/lib/barcode/EAN_UPC.js"></script>' + '</head><body onload="' + onLoadContent + '"><div class="reward-body">' + '<div class="company">' + '<div class="name">' + site.name + '</div>';

            if (site.siret && site.siret !== "" && site.isFrenchLocation()) {
                documentContent += '<div class="address">' + gettextCatalog.getString("N° siret") + " : " + site.siret + '</div>';
            }
            if (site.vatNumber && site.vatNumber !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("N° TVA") + " : " + site.vatNumber + '</div>';
            }
            if (site.rcs && site.rcs !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("N°RCS") + " : " + site.rcs + '</div>';
            }
            if (site.nafCode && site.nafCode !== "") {
                documentContent += '<div class="address">' + gettextCatalog.getString("Code NAF") + " : " + site.nafCode + '</div>';
            }
            if (this.status === 'advance') {
                var juridicForm = this.juridicForm ? this.juridicForm : '';
                var greffeCity = this.greffeCity ? ' Immatriculé au Greffe de : ' + this.greffeCity : '';
                var shareCapital = this.shareCapital ? 'Société au capital de : ' + this.shareCapital : '';
                documentContent += '<div class="address"> ' + juridicForm + greffeCity + '</div>';
                documentContent += '<div class="address">' + shareCapital + '</div>';
            }
            if (site.address && site.address !== "") {
                documentContent += '<div class="address">' + site.address + '</div>';
                documentContent += '<div class="address">' + site.postalCode + ' ' + site.city;

                if (Countries.map[site.country]) {
                    documentContent += ' ' + Countries.map[site.country].countryName;
                }
                documentContent += '</div>';
            }

            if (site.phone && site.phone !== "") {
                documentContent += '<div class="phone">' + site.phone + '</div>';
            }
            if (this.dayView) {
                var currentDateTime = new Date();
                var labelDate = $filter('date')(currentDateTime, 'EEEE d MMMM yyyy');
                var labelTime = gettextCatalog.getString("A_TIME") + ' ' + $filter('date')(currentDateTime, "H':'mm':'ss.sss");
                var labelDateTimeCapitalized = labelDate.charAt(0).toUpperCase() + labelDate.substring(1) + ' ' + labelTime;
                documentContent += '</div>' + '<div class="global-info">' + '<div class="date">' + gettextCatalog.getString("Date") + " : " + labelDateTimeCapitalized + '</div>';
            }
            if (this.hrSellerView && this.isEstimationCost()) {
                documentContent += '<div class="hr">' + gettextCatalog.getString("Créé par") + ' : ' + this.hrSellerView.label + '</div>';
            } else if (this.hrSellerView) {
                documentContent += '<div class="hr">' + gettextCatalog.getString("Encaissé par") + " : " + this.hrSellerView.label + '</div>';
            }
            if (this.customerView && this.status !== 'advance') {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerView.firstName + ' ' + this.customerView.lastName + '</div>';
            } else if (this.customerLastname && this.customerFirstname) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerFirstname + ' ' + this.customerLastname + '</div>';
                if (this.customerAddress && this.customerZip && this.customerCity) {
                    documentContent += '<div class="customer">' + this.customerAddress + ' ' + this.customerCity + ' ' + this.customerZip + '</div>';
                }
            } else {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + gettextCatalog.getString("De passage") + '</div>';
            }

            if (this.saleNumber) {
                var nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                documentContent += '<div class="customer">' + gettextCatalog.getString("Ticket n°") + " : " + this.saleNumber + ' (' + nbItems + ' lig.) / ' + this.statusLabel[this.status] + '</div>';
            } else if (this.advanceNumber) {
                var _nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                documentContent += '<div class="customer">' + gettextCatalog.getString("Facture d'acompte n°") + " : " + this.advanceNumber + ' (' + _nbItems + ' lig.)</div>';
            }

            if (this.estimationNumber) {
                var estimationLabel = gettextCatalog.getString("Devis n°");
                var _nbItems2 = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                documentContent += '<div class="customer">' + estimationLabel + ' : ' + this.estimationNumber + ' (' + _nbItems2 + ' lig.)</div>';
            }

            if (this.signatureCode && !this.isEstimationCost()) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Signature ticket") + " : " + this.signatureCode + '</div>';
            }
            if (this.posView && this.posView.domainView.scope.ad.loggedUser.serverIdentification.version) {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Logiciel") + " : " + Brand.label + ' V' + this.computeSoftV() + '(NF525)</div>';
            }

            if (this.nbPrint > 1 && this.status !== 'estimation') {
                documentContent += '<div class="customer">' + gettextCatalog.getString("Duplicata n°") + (this.nbPrint - 1);
                if (dSignatureCode !== undefined && dSignatureCode && dSignatureCode !== '') {
                    documentContent += ' (' + dSignatureCode + ')';
                }
                documentContent += '</div>';
            }
            documentContent += '</div><table class="bill">';

            var saleDiscountTTC = 0;
            var saleItemDiscountTTC = 0;
            var totalTTC = 0;

            for (var i = 0; i < this.saleServicesView.length; i++) {
                var discountTTC = this.getDiscount(this.saleServicesView[i], 1);
                totalTTC += this.saleServicesView[i].originalPrice;
                saleDiscountTTC += discountTTC;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleServicesView[i], discountTTC) + saleItemDiscountTTC;
                documentContent += this.addLine(this.saleServicesView[i], 1, discountTTC, this.saleServicesView[i].label);
            }

            for (var _i27 = 0; _i27 < this.saleProductsView.length; _i27++) {
                var _discountTTC = this.getDiscount(this.saleProductsView[_i27], this.saleProductsView[_i27].quantity);
                totalTTC += this.saleProductsView[_i27].originalPrice * this.saleProductsView[_i27].quantity;
                saleDiscountTTC += _discountTTC;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleProductsView[_i27], _discountTTC) + saleItemDiscountTTC;
                documentContent += this.addLine(this.saleProductsView[_i27], this.saleProductsView[_i27].quantity, _discountTTC, this.saleProductsView[_i27].label);
            }

            for (var _i28 = 0; _i28 < this.saleCuresView.length; _i28++) {
                var _discountTTC2 = this.getDiscount(this.saleCuresView[_i28], this.saleCuresView[_i28].quantity);
                totalTTC += this.saleCuresView[_i28].originalPrice * this.saleCuresView[_i28].quantity;
                saleDiscountTTC += _discountTTC2;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleCuresView[_i28], _discountTTC2) + saleItemDiscountTTC;
                documentContent += this.addLine(this.saleCuresView[_i28], this.saleCuresView[_i28].quantity, _discountTTC2, this.saleCuresView[_i28].label);
            }

            for (var _i29 = 0; _i29 < this.loyaltyCardItemsView.length; _i29++) {
                var _discountTTC3 = this.getDiscount(this.loyaltyCardItemsView[_i29], 1);
                totalTTC += this.loyaltyCardItemsView[_i29].originalPrice;
                saleDiscountTTC += _discountTTC3;
                saleItemDiscountTTC = this.getDiscountGlobalTTC(this.loyaltyCardItemsView[_i29], _discountTTC3) + saleItemDiscountTTC;
                documentContent += this.addLine(this.loyaltyCardItemsView[_i29], 1, _discountTTC3, this.loyaltyCardItemsView[_i29].label);
            }

            var totalDiscountTTC = saleItemDiscountTTC + saleDiscountTTC;

            if (this.discountPercent !== 0 && saleItemDiscountTTC) {
                var gratuityLabel = this.discountPercent >= 100 ? gettextCatalog.getString("</br>Code 328 gratuité totale") : "";
                documentContent += '' + '<tr>' + '<td colspan="3" style="width:30px">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%' + gratuityLabel + '</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(saleItemDiscountTTC) + '</td>' + '</tr>';
            }

            if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                documentContent += '' + '<tr>' + '<td colspan="3" style="font-weight: bold">' + gettextCatalog.getString("Total TTC") + '</td>' + '<td class="price" style="font-weight: bold">' + $filter('currencyFormatFilter')(totalTTC - totalDiscountTTC) + '</td>' + '</tr>';
            }

            if (totalDiscountTTC) {
                documentContent += '' + '<tr>' + '<td colspan="3">' + gettextCatalog.getString("Total remises TTC") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(totalDiscountTTC) + '</td>' + '</tr>';
            }

            documentContent += '</table>';

            documentContent += '<table class="bill">';

            var giftGlobalDiscountTTC = 0;
            var documentContentGift = '';
            for (var _i30 = 0; _i30 < this.giftItemsView.length; _i30++) {
                var giftItemView = this.giftItemsView[_i30];
                var giftDiscountTTC = this.getDiscount(giftItemView, 1);
                giftGlobalDiscountTTC += this.getDiscountGlobalTTC(giftItemView, giftDiscountTTC);
                documentContentGift += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("1 Chèque cadeau") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(giftItemView.originalPrice) + '</td>' + '</tr>';
                if (giftDiscountTTC) {
                    documentContentGift += '' + '<td colspan="4" style="width:30px">' + gettextCatalog.getString("Remise de") + ' ' + $filter('number')(giftItemView.discountPercent, 2) + '%</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(giftDiscountTTC) + '</td>' + '</tr>';
                }
            }

            if (giftGlobalDiscountTTC) {
                documentContentGift += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%</td>' + '<td class="price">-' + $filter('currencyFormatFilter')(giftGlobalDiscountTTC) + '</td>' + '</tr>';
            }

            if (documentContentGift !== '') {
                documentContent += documentContentGift;
            }

            if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                documentContent += '' + '<tr>' + '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Code") + '</td>' + '<td class="price-tva" style="width:30px"></td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL TVA") + '</td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL HT") + '</td>' + '<td class="price-tva">' + gettextCatalog.getString("TOTAL TTC") + '</td>' + '</tr>';

                var totalVat = 0,
                    totalHT = 0,
                    _totalTTC = 0;

                for (var _i31 = 0; _i31 < this.vatLines.length; _i31++) {
                    if (this.posView && this.posView.domainView && this.posView.domainView.getDefaultVatTax() === this.vatLines[_i31].tax || this.vatLines[_i31].amount !== 0 || this.vatLines[_i31].ht !== 0) {

                        //var ht = this.vatLines[i].amount / (this.vatLines[i].tax) * 100;
                        var ht = this.vatLines[_i31].ht;

                        totalVat += this.vatLines[_i31].amount ? this.vatLines[_i31].amount : 0;
                        totalHT += ht ? ht : 0;
                        _totalTTC += (this.vatLines[_i31].amount ? this.vatLines[_i31].amount : 0) + (ht ? ht : 0);

                        documentContent += '' + '<tr>' + '<td class="price-tva" style="text-align:left">' + this.vatLines[_i31].code + '</td>' + '<td class="price-tva">' + $filter('number')(this.vatLines[_i31].tax, 2) + '%' + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[_i31].amount) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(ht) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[_i31].amount + ht) + '</td>' + '</tr>';
                    }
                }
                documentContent += '' + '<tr>' + '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Total") + '</td>' + '<td class="price-tva" style="width:30px"></td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(totalVat) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(totalHT) + '</td>' + '<td class="price-tva">' + $filter('currencyFormatFilter')(_totalTTC) + '</td>' + '</tr>';
            }

            documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Règlement(s)") + '</td>' + '<td></td>' + '</tr>';

            if (this.advancePrice !== 0) {
                documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Montant de l\'acompte : ") + '</td>' + '<td>' + $filter('currencyFormatFilter')(this.advancePrice) + '</td>' + '</tr>';

                documentContent += '' + '<tr>' + '<td colspan="4">' + gettextCatalog.getString("Taux : ") + '</td>' + '<td>' + $filter('number')(Math.abs(this.advancePrice / this.price * 100), 2) + '%</td>' + '</tr>' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>';
            }

            var payed = 0;
            var advanceNumberAdded = false;
            for (var _i32 = 0; _i32 < this.paymentsView.length; _i32++) {
                documentContent += '' + '<tr>' + '<td>';

                if (this.paymentsView[_i32].type !== 'UNPAID') {
                    documentContent += $filter('date')(this.paymentsView[_i32].date, 'shortDate');
                }
                documentContent += '</td><td colspan="3">';

                var salePaymentType = SalePaymentTypeFactory.from(this.paymentsView[_i32].type);
                if (salePaymentType) {
                    documentContent += salePaymentType.label;
                } else if (this.paymentsView[_i32].otherPaymentTypeView) {
                    documentContent += this.paymentsView[_i32].otherPaymentTypeView.label;
                }

                if (!advanceNumberAdded && this.advanceNumber) {
                    documentContent += " " + gettextCatalog.getString("Acompte n°") + this.advanceNumber;
                    advanceNumberAdded = true;
                }

                documentContent += '' + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(this.paymentsView[_i32].price) + '</td>' + '</tr>';
                payed += this.paymentsView[_i32].price;
            }
            if (this.price - payed > 0) {
                documentContent += '' + '<tr>' + '<td></td>' + '<td colspan="3">' + gettextCatalog.getString("Reste à payer") + '</td>' + '<td class="price">' + $filter('currencyFormatFilter')(this.price - payed) + '</td>' + '</tr>';
            }

            documentContent += '' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '<tr>' + '<td colspan="5" class="separator"></td>' + '</tr>' + '</table>';

            if (this.loyaltyCardItemView) {
                documentContent += "<table class=\"loyalty\">";
                documentContent += '<tr><td>' + gettextCatalog.getString("Fidélité") + '</td><td>' + this.loyaltyCardItemView.label + "</td></tr>";
                if (this.loyaltyCardItemView.type !== "subs") {
                    documentContent += '<tr><td>' + gettextCatalog.getString("Nouveau solde") + '</td><td>' + this.totalLoyaltyPts + " pts</td></tr>";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Ancien solde") + '</td><td>' + (this.totalLoyaltyPts - this.loyaltyPts) + " pts</td></tr>";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Point cumulé") + '</td><td>' + (this.hasLoyaltyDiscount ? this.loyaltyPts + this.loyaltyCardItemView.goalPts : this.loyaltyPts) + " pts</td></tr>";
                    if (this.nbLoyaltyCardGoal <= 0) {
                        documentContent += "<tr><td>";

                        if (this.loyaltyCardItemView.pts < this.loyaltyCardItemView.goalPts) {
                            documentContent += gettextCatalog.getString("Prochaine récompense") + ' </td><td>' + this.loyaltyCardItemView.goalPts + " pts";
                        } else {
                            documentContent += gettextCatalog.getString("Au prochain achat") + '</td><td>';
                            if (this.loyaltyCardItemView.goalType === "special") {
                                documentContent += this.loyaltyCardItemView.goalText;
                            } else {
                                documentContent += "Remise de " + this.loyaltyCardItemView.computeGoalAmountNextSale();
                                if (this.loyaltyCardItemView.goalType === "discountValue") {
                                    documentContent += " " + CurrencyManager.getCurrencySymbol();
                                } else {
                                    documentContent += " %";
                                }
                            }
                            documentContent += "</td></tr>";
                        }
                    }
                }

                if (this.loyaltyCardItemView.validityDate) {
                    documentContent += '<tr><td>' + gettextCatalog.getString("Validité") + '</td><td>' + $filter('date')(this.loyaltyCardItemView.validityDate, 'shortDate') + "</td></tr></table>";
                }
            }

            //Specific text
            if (this.posView && this.posView.domainView.ticketEndText && this.posView.domainView.ticketEndText !== '' && !this.isEstimationCost()) {
                documentContent += '<div>' + this.posView.domainView.ticketEndText + '</div>';
            } else if (this.isEstimationCost() && this.comment != null && this.comment !== "") {
                documentContent += '<div>' + this.comment + '</div>';
            }

            for (var _i33 = 0; _i33 < this.giftItemsView.length; _i33++) {
                if (this.giftItemsView[_i33].editionType !== "manual") {
                    documentContent += '<div style="border: 1px dotted black;margin: 5px;padding: 5px;text-align: center"><div style="font-size: 16px;padding-bottom: 3px">' + gettextCatalog.getString("Chèque cadeau de") + " " + $filter('currencyFormatFilter')(this.giftItemsView[_i33].originalPrice) + '</div><div><img id="barcode' + _i33 + '"/></div><div>';
                    documentContent += this.giftItemsView[_i33].code;
                    documentContent += '</div><div>' + gettextCatalog.getString("Valable jusqu'au") + " " + $filter('date')(this.giftItemsView[_i33].validityDate, 'shortDate') + '</div></div><script>$(document).ready(function() {$("#barcode' + _i33 + '").JsBarcode("';
                    documentContent += this.giftItemsView[_i33].code.replace(/-/g, "");
                    documentContent += '",{format:"EAN",displayValue:false,fontSize:16,height: 50});});</script>';
                }
            }

            if (this.posView && this.posView.domainView.ticketEndDisplayBooking) {
                var now = new Date();

                if (this.customerView && this.customerView.globalHistoryView) {
                    var nextBooking = '<table class="bill" style="border: 1px dotted black;padding: 5px;text-align: center"><tr><th colspan="2" style="text-align:left">' + gettextCatalog.getString("Prochains rendez-vous") + '</th></tr>',
                        clonedHistory = this.customerView.globalHistoryView.copyWithin(0, 0),
                        hasNextBooking = false;

                    clonedHistory.sort(function (a, b) {
                        if (a.date < b.date) {
                            return -1;
                        }
                        if (a.date > b.date) {
                            return 1;
                        }
                        return 0;
                    });

                    for (var _i34 = 0; _i34 < clonedHistory.length; _i34++) {
                        var bookingTime = null;
                        if (clonedHistory[_i34].bookingPeriod && clonedHistory[_i34].bookingPeriod.start) {
                            bookingTime = clonedHistory[_i34].date.getTime() + clonedHistory[_i34].bookingPeriod.start.getTimeInMilli();
                        }

                        var filterdHistory = $filter('filter')(clonedHistory[_i34].items, { type: "service" });

                        if (bookingTime && bookingTime > now.getTime() && filterdHistory && filterdHistory.length != 0) {
                            hasNextBooking = true;
                            nextBooking += '<tr>' + '<td style="width:120px;vertical-align:top;text-align:left;">' + $filter('date')(clonedHistory[_i34].date, 'shortDate') + " " + gettextCatalog.getString("à") + " " + clonedHistory[_i34].bookingTime + '</td>' + '<td style="vertical-align:top;text-align:left;padding-left:5px">' + '<span>' + filterdHistory[0].label + '</span>';

                            for (var j = 1; j < filterdHistory.length; j++) {
                                nextBooking += '<span>, ' + filterdHistory[j].label + '</span>';
                            }
                            nextBooking += '</td></tr>';
                        }
                    }
                    nextBooking += '</table>';
                    if (hasNextBooking) {
                        documentContent += nextBooking;
                    }
                }
            }

            documentContent += '</div></body></html>';
            this.printWindow.document.write(documentContent);
            this.printWindow.document.title = gettextCatalog.getString("Imprimer");
            this.printWindow.document.close();
        }
    };

    SaleView.prototype.computeSoftV = function () {
        var softV = void 0;
        if (this.softV) {
            softV = this.softV.includes("backend") ? this.softV.substr(8) : this.softV;
            softV = softV.includes(".") ? softV.substr(0, softV.indexOf(".")) : softV;
        } else {
            softV = this.posView.domainView.scope.ad.loggedUser.serverIdentification.version;
        }
        return softV;
    };

    SaleView.prototype.updatePriceInputArrow = function (number) {
        if (this.canChangePriceDirectly()) {
            var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
            if (number > 0 && this.price >= originalPrice) return;
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price)) this.form.displayErrorPrice = true;else {
                this.form.displayErrorPrice = false;
                price += number;
            }

            this.price = price;
            this.priceInput = $filter('currencyFormatFilter')(price);
            this.updatePercentOnPriceChange();
        }
    };

    SaleView.prototype.onPriceInputChange = function () {
        if (this.canChangePriceDirectly()) {
            var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
            var price = parseFloat(priceStr);
            if (isNaN(price)) {
                this.form.displayErrorPrice = true;
                this.price = null;
            } else {
                var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
                this.form.displayErrorPrice = price > originalPrice;
                this.price = price;
            }
            this.updatePercentOnPriceChange();
        }
        this.checkForInvalidAmounts();
    };

    SaleView.prototype.canChangePriceDirectly = function () {
        if (!this.isReadOnly && this.priceInput != null && typeof this.priceInput === 'string' && !this.hasGiftItems && this.checkSalePartnerSettings(SaleSettings.UPDATE_PRICE)) {
            if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType != 'special') {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = gettextCatalog.getString("Vous ne pouvez pas changer le prix directement si une remise fidélité est appliquée.");
                            return tableModel;
                        }
                    }
                };
                $dialog.dialog(opts).open();
                this.priceInput = $filter('currencyFormatFilter')(this.price);
            } else {
                return true;
            }
        }
        return false;
    };

    SaleView.prototype.updatePercent = function () {
        var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
        if (originalPrice !== 0) {
            this.discountPercent = Math.round(10000000 * (100 - 100 * this.price / originalPrice)) / 10000000;
        } else {
            this.discountPercent = 0;
        }
    };

    SaleView.prototype.updatePercentOnPriceChange = function () {
        this.updatePercent();

        this.resetPayments();
        this.calculateVatLines();
        this.currentPayment = this.price;
        this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
        this.calculateSaleFields(true); //force recalculate (to manage loyalty card by example) / Don't update priceinput
        if (this.discountPercent > 0) this.form.displayGlobalDiscount = true;
    };

    SaleView.prototype.displayDatePickerF = function () {
        if (this.status === "sold" || this.status === "canceled" || this.status === "credit") alert("Vous ne pouvez pas changer la date d'un ticket encaissé");else if (this.dayView) this.dayView.displayDatePickerF();
    };

    SaleView.prototype.onTechNoteSelection = function (minBookView) {
        if (minBookView) {
            this.techNote = minBookView.techNote;
        }
    };

    SaleView.prototype.isActiveGlobalDiscount = function () {
        return !(this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView && this.loyaltyCardItemView.goalType !== 'special');
    };

    SaleView.prototype.isOnePaymentCalendarDisplayed = function () {
        var isOnePaymentCalendarDisplayed = false;
        for (var i = 0; i < this.paymentsView.length; i++) {
            if (this.paymentsView[i].datePickerOpened) {
                isOnePaymentCalendarDisplayed = true;
                break;
            }
        }
        return isOnePaymentCalendarDisplayed;
    };

    SaleView.prototype.manageOtherActionsMenu = function (displayMenu, indexPanel, title) {
        this.form.displayOtherActions = displayMenu;
        this.form.paymentActionsTab = indexPanel;
        if (this.form.paymentActionsTab === 0) this.form.nbPayments = 1;
        if (title == null) title = "";
        this.form.titleOtherActions = title;
        if (this.posView && this.posView.resizeBasketAfterAction) this.posView.resizeBasketAfterAction(!displayMenu); //animate only on close
    };

    SaleView.prototype.getNbPaymentInType = function (paymentType) {
        var nbPaymentInType = 0;
        for (var i = 0; i < this.paymentsView.length; i++) {
            if (paymentType && paymentType.label && this.paymentsView[i].otherPaymentTypeView) {
                if (paymentType.label === this.paymentsView[i].otherPaymentTypeView.label) {
                    nbPaymentInType++;
                }
            } else if (this.paymentsView[i].type === paymentType) {
                nbPaymentInType++;
            }
        }
        return nbPaymentInType;
    };

    SaleView.prototype.createSaleFromEstimation = function () {
        this.status = 'created';
        this.calculateSaleFields(true);

        for (var i = 0; i < this.saleProductsView.length; i++) {
            var productView = this.saleProductsView[i].productView;
            if (productView.hasQuantity) productView.quantity = productView.quantity - this.saleProductsView[i].quantity;
        }
    };

    SaleView.prototype.isEstimationCost = function () {
        return this.status === 'estimation';
    };

    SaleView.prototype.displaySaleLabel = function (statut) {

        var saleLabel = null;
        if (statut !== 'advance' && statut !== 'sold' && statut !== 'credit') {
            saleLabel = this.printLabel;
        } else {
            if (this.nbPrint >= 1) {
                if (statut === 'advance') {
                    saleLabel = this.advanceDuplicataLabel + " " + this.nbPrint;
                } else if (statut === 'sold' || statut === 'credit') {
                    saleLabel = this.saleDuplicataLabel + " " + this.nbPrint;
                }
            } else {
                if (statut === 'advance') {
                    saleLabel = this.originalAdvanceLabel;
                } else if (statut === 'sold' || statut === 'credit') {
                    saleLabel = this.originalSaleLabel;
                }
            }
        }

        return saleLabel;
    };

    SaleView.prototype.canCancelSale = function () {
        if (this.hasGiftItemUsed() || this.hasSaleCureWithUsage()) {
            return false;
        }

        var basicAuthRole = this.computeIfNeededAndGetBasicAuthRole();
        return !basicAuthRole || basicAuthRole.basicAuthRoleSaleCreationBehavior.cancelSale(this.status, this.paymentsView);
    };

    SaleView.prototype.checkSalePartnerSettings = function (setting) {
        var checkSalePartnerSettings = true;
        if (this.bookingView && this.bookingView.creator) {
            checkSalePartnerSettings = SalePartnerSettingsFactory.checkSalePartnerSettings(setting, this.bookingView.creator);
        }
        return checkSalePartnerSettings;
    };

    SaleView.prototype.computeIfNeededAndGetBasicAuthRole = function () {
        if (!this.basicAuthRole && this.bookingView) {
            this.basicAuthRole = this.basicAuthRoleFactory.getBasicAuthByBookingCreator(this.bookingView.creator);
        }
        return this.basicAuthRole;
    };

    SaleView.prototype.displaySaleAlert = function () {
        return this.computeIfNeededAndGetBasicAuthRole() && this.computeIfNeededAndGetBasicAuthRole().displaySaleAlert(this.status);
    };

    SaleView.prototype.canPartnerUpdatePayment = function () {
        return !this.computeIfNeededAndGetBasicAuthRole() || this.computeIfNeededAndGetBasicAuthRole().canPartnerUpdatePayment(this.status, this.checkSalePartnerSettings(SaleSettings.UPDATE_PAYMENT));
    };

    SaleView.prototype.updateRefundGiftItem = function () {
        var hasSaleProductsNoDelivery = false;
        for (var i = 0; i < this.saleProductsView.length; i++) {
            if (this.saleProductsView[i].productView) {
                hasSaleProductsNoDelivery = true;
                break;
            }
        }
        this.canRefundGiftItem = this.saleCuresView.length == 0 && (this.saleServicesView.length != 0 || hasSaleProductsNoDelivery || this.loyaltyCardItemsView.length != 0);
    };

    SaleView.prototype.checkForInvalidAmounts = function () {
        this.hasInvalidAmounts = this.areAmountsInvalid(this.price, this.discountPercent) || this.checkSaleItemsForInvalidAmounts(this.saleServicesView) || this.checkSaleItemsForInvalidAmounts(this.saleProductsView) || this.checkSaleItemsForInvalidAmounts(this.saleCuresView) || this.checkSaleItemsForInvalidAmounts(this.loyaltyCardItemsView) || this.checkSaleItemsForInvalidAmounts(this.giftItemsView);
    };

    SaleView.prototype.checkSaleItemsForInvalidAmounts = function (saleItemViews) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = saleItemViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var saleItemView = _step.value;

                if (this.areAmountsInvalid(saleItemView.originalPrice, saleItemView.discountPercent)) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return false;
    };

    SaleView.prototype.areAmountsInvalid = function (price, discountPercent) {
        return price == null || isNaN(price) || price < 0 || discountPercent == null || isNaN(discountPercent);
    };

    return SaleView;
}]);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ServiceView', ["$sce", "ServiceData", "ServiceSrv", "Service", "HumanResourceSrv", "PhysicalResourceSrv", "$filter", "WidgetView", "StyleColor", "CurrencyManager", "NumberSeparatorType", "AppData", "ResourceSrv", "Resource", "BasicAuthRole", "Brand", function ($sce, ServiceData, ServiceSrv, Service, HumanResourceSrv, PhysicalResourceSrv, $filter, WidgetView, StyleColor, CurrencyManager, NumberSeparatorType, AppData, ResourceSrv, Resource, BasicAuthRole, Brand) {

    var ServiceView = function ServiceView(service, servIndex, parentCategoryView, domainView, parentServiceView, position) {
        this.servIndex = servIndex;
        this.domainView = domainView;
        this.categoryType = "service";
        this.categoryTypeSortOrder = 0;
        this.label = "";
        this.previousLabelShort = "", this.labelShort = "";
        this.labelPosition = position != null ? String.fromCharCode(97 + position) : "";
        this.description = "";
        this.descriptionHtml = "";
        this.isPackage = false; // if the service is a package
        this.isOnHome = false; // if the service is on web home page -> offer
        this.homeOrder = 0;
        this.price = 0;
        this.hasInternetPrice = false; // if the service is on web home page
        this.hasMandatoryPayment = false;
        this.internetPrice = 0;
        this.internetPriceInput = $filter("currencyFormatFilter")(0);
        this.internetDiscountPercent = 0;
        this.duration = 30; //default
        this.hasItnDuration = false;
        this.itnDuration = 0;
        this.itnDurationD = 0; //internet duration displayed
        this.companyImage = null;
        this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
        this.specificImage = null;
        this.isSelected = false; //on selected
        this.isSmsSelected = false;
        this.isNotificationSelected = false;
        this.nbSelectableForCure = 0;
        this.nbSelectableForGift = 0;
        this.isVisibleOnWebSite = true;
        this.subServicesView = [];
        this.productsView = [];
        this.cureViews = [];
        this.imgWidgetView = null;
        this.subWidgetsView = null;
        this.styleView = {}; //styleView is an object and service.style is a string
        this.colorPicker = ""; //value liked by the colorpicker
        this.serviceId = "";
        this.serviceSettingsReserveWithGoogleId = null;
        this.displayMessageMultiStep = false;
        this.displayMessageNbHrsNeeded = false;
        this.displayMessageNbPrsNeeded = false;
        this.displayMessageDuration = false;
        this.displayMessagePrice = false;
        if (this.domainView && this.domainView.getHasHr !== undefined && this.domainView.getHasHr()) {
            this.nbPrsNeeded = 0;
            this.nbPrsNeededCheck = false;
            this.nbHrsNeeded = 1; //default but depends type
            this.nbHrsNeededCheck = true;
        } else {
            this.nbPrsNeeded = 1;
            this.nbPrsNeededCheck = true;
            this.nbHrsNeeded = 0; //default but depends type
            this.nbHrsNeededCheck = false;
        }
        //View parameters
        this.isSelResKnow = false; // if the selected Ressource know the service
        this.hrSkillsView = null; // [{ hrView, active (boolean }]
        this.prSkillsView = null; // [{ prView, active (boolean }]

        this.serviceSettings = {};
        this.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role] = {
            id: null,
            view: null,
            label: BasicAuthRole.GOOGLE_ROLE.label,
            checkMultiStep: true,
            checkNbHrsNeeded: true,
            checkNbPrsNeeded: true,
            checkDuration: true,
            checkPrice: true
        };

        this.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role] = {
            id: null,
            view: null,
            label: Brand.marketplace.url.shortWebsite,
            checkMultiStep: true,
            checkNbHrsNeeded: true,
            checkNbPrsNeeded: true,
            checkDuration: true,
            checkPrice: false
        };

        this.serviceSettingsActive = 0;

        this.isBookableOnWebSite = true;
        if (parentCategoryView !== undefined && parentCategoryView != null) this.parentCategoryView = parentCategoryView;else this.parentCategoryView = null;

        if (parentServiceView !== undefined && parentServiceView != null) this.parentServiceView = parentServiceView;else this.parentServiceView = null;

        this.styleView = this.getStyleFrom(service);
        if (this.styleView) this.colorPicker = this.styleView.background;

        if (service) {
            this.loadDataFrom(service);
        }
        this.isVisible = true;
        this.impactedByImport = false;
    };

    ServiceView.prototype.setSubServiceLabelPosition = function () {
        for (var i = 0; i < this.subServicesView.length; i++) {
            this.subServicesView[i].labelPosition = String.fromCharCode(97 + i);
        }
    };

    ServiceView.prototype.getModel = function () {
        if (this.servIndex != -1) {
            return ServiceData.getByIndex(this.servIndex);
        }
        return null;
    };

    ServiceView.prototype.loadDataFrom = function (service) {
        //Assume here than the object in parameter contains only id (must load them)
        this.label = service.label;
        this.labelShort = service.labelShort;
        this.previousLabelShort = service.labelShort;
        this.description = service.description;
        if (this.description) this.description = this.description.replace(/(?:\r\n|\r|\n)/g, '<br />');
        this.isPackage = service.isPackage;
        this.isOnHome = service.isOnHome;
        this.homeOrder = service.homeOrder;
        this.hasInternetPrice = service.hasInternetPrice;
        this.hasMandatoryPayment = service.hasMandatoryPayment;
        this.isVisibleOnWebSite = service.isVisibleOnWebSite;
        this.isBookableOnWebSite = service.isBookableOnWebSite;
        this.serviceId = service.id;
        this.serviceSettingsReserveWithGoogleId = service.serviceSettingsReserveWithGoogleId;
        if (this.description) this.updateDescriptionHtml();

        this.price = service.price;
        // this.priceInput = $filter('currencyFormatFilter')(this.price);

        if (service.internetPrice != null) {
            this.internetPrice = service.internetPrice;
            if (this.internetPrice == 0 && this.price != 0) this.internetDiscountPercent = 100;else if (this.price != 0) {
                this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
            }
        } else this.internetPrice = this.price;
        this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
        this.duration = service.duration;
        if (service.itnDuration) this.itnDuration = service.itnDuration;
        this.hasItnDuration = service.hasItnDuration;
        if (this.hasItnDuration) this.itnDurationD = this.itnDuration;else this.itnDurationD = this.duration;
        this.specificImage = service.specificImage;
        this.image = service.image;
        this.companyImage = service.companyImage;
        if (this.image || this.companyImage) //for ascendencing compatibility
            this.specificImage = true;

        if (this.parentCategoryView && this.image == null && this.specificImage == false) this.image = this.parentCategoryView.image;

        if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) this.companyImage = this.parentCategoryView.companyImage;

        if (this.companyImage) this.imageDisplayed = this.companyImage;else this.imageDisplayed = this.image;

        if (service.nbPrsNeeded !== undefined && service.nbPrsNeeded != null) {
            this.nbPrsNeeded = service.nbPrsNeeded;
            this.nbPrsNeededCheck = this.nbPrsNeeded != 0;
        }
        if (service.nbHrsNeeded !== undefined && service.nbHrsNeeded != null) {
            this.nbHrsNeeded = service.nbHrsNeeded;
            this.nbHrsNeededCheck = this.nbHrsNeeded != 0;
        }
        this.loadSubServicesView(service);
        this.initSubServicesPrice();
        this.updateSubServicesInternetVariables();
    };

    ServiceView.prototype.initSubServicesPrice = function () {
        var subServicePricesInitialised = false;
        for (var i = 0; i < this.subServicesView.length; i++) {
            if (this.subServicesView[i].price != 0) {
                subServicePricesInitialised = true;
            }
        }

        if (!subServicePricesInitialised && this.price != 0) {
            this.updateSubServicesPrice();
        }
    };

    ServiceView.prototype.getDurationWithHR = function () {
        var totalDurationWithHR = 0;

        if (this.isPackage && this.subServicesView) {
            var subServiceWithHr = $filter('filter')(this.subServicesView, function (value, index, array) {
                var retour = false;
                if (value.nbHrsNeeded && value.nbHrsNeeded > 0) retour = true;
                return retour;
            });
            for (var i = 0; i < subServiceWithHr.length; i++) {
                totalDurationWithHR += subServiceWithHr[i].duration;
            }
        } else {
            if (this.nbHrsNeeded && this.nbHrsNeeded > 0) {
                totalDurationWithHR = this.duration;
            }
        }
        return totalDurationWithHR;
    };

    ServiceView.prototype.updateSubServicesPrice = function () {
        if (this.isPackage && this.subServicesView) {
            if (this.subServicesView) {
                for (var i = 0; i < this.subServicesView.length; i++) {
                    if (this.subServicesView[i].nbHrsNeeded) {
                        this.subServicesView[i].price = this.price / this.getDurationWithHR() * this.subServicesView[i].duration;
                    } else {
                        this.subServicesView[i].price = 0;
                    }
                }
            }
        }
    };

    ServiceView.prototype.updateSubServicesInternetVariables = function () {
        if (this.isPackage && this.subServicesView) {
            for (var i = 0; i < this.subServicesView.length; i++) {
                this.subServicesView[i].internetDiscountPercent = this.internetDiscountPercent;
                this.subServicesView[i].hasInternetPrice = this.hasInternetPrice;
                if (this.subServicesView[i].hasInternetPrice && this.internetDiscountPercent != 100) {
                    if (this.subServicesView[i].nbHrsNeeded) {
                        this.subServicesView[i].internetPrice = this.subServicesView[i].price - this.subServicesView[i].price / 100 * this.internetDiscountPercent;
                    } else {
                        this.subServicesView[i].internetPrice = 0;
                    }
                }
            }
        }
    };

    ServiceView.prototype.updatePriceOnPackage = function () {
        if (this.isPackage && this.subServicesView) {
            var newPrice = 0;

            for (var i = 0; i < this.subServicesView.length; i++) {
                newPrice += this.subServicesView[i].price;
            }
            this.price = newPrice;
            this.updateInternetDiscountPercent();
        }
    };

    ServiceView.prototype.updateDurationOnPackage = function () {
        if (this.isPackage) {
            this.duration = 0;
            for (var i = 0; i < this.subServicesView.length; i++) {
                this.duration += this.subServicesView[i].duration;
            }
        }
    };

    /*ServiceView.prototype.loadWidgetsView = function()
    {
        var service = this.getModel();
        if (service)
        {
            var widgetView=null;
            if (service.subWidgets)
            {
                this.subWidgetsView = [];
                var subWidgets =  JSON.parse(service.subWidgets);
                if (subWidgets)
                {
                    for (var i = 0;i<subWidgets.length;i++)
                    {
                        widgetView = new WidgetView(subWidgets[i],true,this.domainView);
                        this.subWidgetsView.push(widgetView);
                    }
                }
            }
            if (service.imgWidget)
            {
                var imgWidget =  JSON.parse(service.imgWidget);
                if (imgWidget)
                    this.imgWidgetView = new WidgetView(imgWidget,-1,true,this.domainView);
            }
        }
     }*/
    ServiceView.prototype.onStyleViewChange = function () {
        var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
        if (!this.styleView || this.styleView.background != this.colorPicker) {
            if (!this.styleView || //if undefined
            this.parentCategoryView && this.parentCategoryView.styleView === this.styleView) // if same than parent : break inheritance
                this.styleView = {};
            this.styleView.background = this.colorPicker;
            this.styleView.color = fontColor;
        } else {
            this.styleView.background = this.parentCategoryView.background;
            this.styleView.color = this.parentCategoryView.color;
        }
        if (this.subServicesView) {
            for (var i = 0; i < this.subServicesView.length; i++) {
                this.subServicesView[i].styleView = {};
                this.subServicesView[i].styleView.background = this.styleView.background;
                this.subServicesView[i].styleView.color = this.styleView.color;
            }
        }
    };

    ServiceView.prototype.onGlobalPriceInputChange = function () {
        if (this.isPackage && this.subServicesView) {
            this.updateSubServicesPrice();
        }
        this.updateInternetDiscountPercent();
        this.checkActivePrice();
    };

    ServiceView.prototype.onGlobalPriceInputArrowClick = function (number) {
        this.updatePriceInputArrow(number);
        if (this.isPackage && this.subServicesView) {
            this.updateSubServicesPrice();
        }
        this.checkActivePrice();
    };

    ServiceView.prototype.onSubServicePriceInputChange = function () {
        if (this.parentServiceView) this.parentServiceView.updatePriceOnPackage();
    };

    ServiceView.prototype.onSubServicePriceInputArrowClick = function (number) {
        this.updatePriceInputArrow(number);
        if (this.parentServiceView) this.parentServiceView.updatePriceOnPackage();
    };

    ServiceView.prototype.onDurationInputChange = function () {
        this.updateDuration();
        this.updateSubServicesPrice();
    };

    ServiceView.prototype.onDurationServiceInputChange = function () {

        this.checkActiveDuration();

        if (!this.displayMessageDuration) {
            this.onDurationInputChange();
        } else {
            this.duration = 1;
        }
    };

    ServiceView.prototype.updateDurationInputArrow = function (duration) {

        this.duration = duration;

        this.checkActiveDuration();

        if (!this.displayMessageDuration) {
            this.onDurationInputChange();
        } else {
            this.duration = duration + 5;
        }
    };

    ServiceView.prototype.onSubServiceDurationInputChange = function () {
        this.updateDuration();
        this.parentServiceView.updateDurationOnPackage();
        this.parentServiceView.updateSubServicesPrice();
    };

    ServiceView.prototype.getStyleFrom = function (service) {
        var styleView = null;
        if (service) if (service.style && service.style.indexOf('{') != 0) //Previous type before 1.5 was not contains a jsonSTring
            styleView = null;else try {
            styleView = angular.fromJson(service.style);
        } catch (ex) {
            console.log("Error loading style");
        }
        if (!styleView) {
            if (this.parentServiceView != null) styleView = this.parentServiceView.styleView;else if (this.parentCategoryView != null) styleView = this.parentCategoryView.styleView;else styleView = { background: 'white' };
        }
        return styleView;
    };

    ServiceView.prototype.createImgWidgetView = function () {
        if (!this.imgWidgetView) {
            this.imgWidgetView = new WidgetView(null, false, this.domainView);
            this.imgWidgetView.type = "object";
            this.imgWidgetView.object = this;
            this.imgWidgetView.objectType = "service";
            this.imgWidgetView.setImage(this.imageDisplayed.url, true);
        }
        return this.imgWidgetView;
    };

    ServiceView.prototype.createSubWidgetView = function () {
        var widgetView = null;
        if (!this.subWidgetsView) this.subWidgetsView = [];
        widgetView = new WidgetView(null, false, this.domainView);
        widgetView.type = "object";
        widgetView.object = this;
        widgetView.objectType = "service";
        this.subWidgetsView.push(widgetView);
        return widgetView;
    };

    ServiceView.prototype.getSubServiceView = function (service) {
        for (var j = 0; j < this.subServicesView.length; j++) {
            if (this.subServicesView[j].getModel() === service) return this.subServicesView[j];
        }return null;
    };

    ServiceView.prototype.updateDescriptionHtml = function () {
        this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));
    };

    ServiceView.prototype.onNbHrsNeededCheckChange = function () {
        this.nbHrsNeeded = this.nbHrsNeededCheck ? 1 : 0;
        var previousValue = this.nbHrsNeededCheck ? '0' : '1';
        this.manageResourceSkills(this.nbHrsNeeded, previousValue, this.hrSkillsView);
        if (this.parentServiceView) {
            this.parentServiceView.updateSubServicesPrice();
        }
    };

    ServiceView.prototype.onNbPrsNeededCheckChange = function () {
        this.nbPrsNeeded = this.nbPrsNeededCheck ? 1 : 0;
        var previousValue = this.nbPrsNeededCheck ? '0' : '1';
        this.manageResourceSkills(this.nbPrsNeeded, previousValue, this.prSkillsView);
    };

    ServiceView.prototype.onNbHrsNeededOptionInputChange = function (previousValue) {
        this.checkActiveNbHrsNeeded();
        if (!this.nbHrsNeeded) {
            this.nbHrsNeeded = 0;
        }
        this.manageResourceSkills(this.nbHrsNeeded, previousValue, this.hrSkillsView);
    };

    ServiceView.prototype.onNbPrsNeededOptionInputChange = function (previousValue) {
        this.checkActiveNbPrsNeeded();
        if (!this.nbPrsNeeded) {
            this.nbPrsNeeded = 0;
        }
        this.manageResourceSkills(this.nbPrsNeeded, previousValue, this.prSkillsView);
    };

    ServiceView.prototype.manageResourceSkills = function (newValue, previousValue, resourceSkillsView) {
        if (newValue === 0 && previousValue !== '0') {
            resourceSkillsView.forEach(function (resourceSkillView) {
                return resourceSkillView.active = false;
            });
        } else if (newValue >= 1 && previousValue === '0') {
            resourceSkillsView.forEach(function (resourceSkillView) {
                return resourceSkillView.active = true;
            });
        }
    };

    ServiceView.prototype.updateDuration = function () {
        if (this.duration != null && typeof this.duration === 'string') {
            var durationStr = this.duration.replace(" ", "");
            var duration = parseInt(durationStr);
            if (!isNaN(duration)) this.duration = duration;else this.duration = 0;
        }
    };

    ServiceView.prototype.updatePriceInputArrow = function (number) {
        if (this.price !== "NaN") this.price = this.price + number;
    };

    ServiceView.prototype.initInternetPrice = function () {
        if (this.hasInternetPrice && this.internetPrice == 0) {
            this.internetPrice = this.price;
            this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
            this.onInternetPriceInputChange();
        }
    };

    ServiceView.prototype.onHasInternetPriceInputChange = function () {
        this.updateSubServicesHasInternetPrice();
        this.initInternetPrice();
    };

    ServiceView.prototype.updateSubServicesHasInternetPrice = function () {
        for (var i = 0; i < this.subServicesView.length; i++) {
            this.subServicesView[i].hasInternetPrice = this.hasInternetPrice;
        }
    };

    ServiceView.prototype.updateInternetPriceInputArrow = function (number) {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (internetPrice !== "NaN") if (internetPrice + number < 0) internetPrice = 0;else if (internetPrice + number < this.price) internetPrice += number;else internetPrice = this.price;

            this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
            this.onInternetPriceInputChange();
        }
    };

    ServiceView.prototype.transformInternetPriceInNumber = function () {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
            var internetPrice = parseFloat(internetPriceStr);
            if (internetPrice !== "NaN") this.internetPrice = internetPrice;else this.internetPrice = null;
        }
    };

    ServiceView.prototype.updateInternetDiscountPercent = function () {
        if (this.internetPrice == 0 && this.price != 0) this.internetDiscountPercent = 100;else this.internetDiscountPercent = Math.round(100 * (100 - 100 * this.internetPrice / this.price)) / 100;
    };

    ServiceView.prototype.onInternetPriceInputChange = function () {
        if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
            this.transformInternetPriceInNumber();

            this.updateInternetDiscountPercent();

            if (this.isPackage && this.subServicesView) {
                this.updateSubServicesInternetVariables();
            }
        }
    };

    ServiceView.prototype.loadSubServicesView = function (service) {
        if (service) {
            this.subServicesView = [];
            for (var j = 0; j < service.subServices.length; j++) {
                var serviceView = new ServiceView(service.subServices[j], ServiceData.getIndexOf(service.subServices[j]), this.parentCategoryView, this.domainView, this, j);
                this.subServicesView.push(serviceView);
            }
        }
    };

    ServiceView.prototype.loadProductsView = function () {
        var service = this.getModel();
        if (service) {
            this.productsView = [];
            var productView;
            for (var i = 0; i < service.products.length; i++) {
                productView = this.domainView.getProductView(service.products[i]);
                if (productView) {
                    this.productsView.push(productView);
                }
            }
        }
    };

    /**
     * Add the link between the service view and the cure view.
     *
     * @param cureView
     */
    ServiceView.prototype.addLinkToCureView = function (cureView) {
        var isCureLinkedToServiceView = this.cureViews.some(function (element) {
            return element == cureView;
        });
        if (!isCureLinkedToServiceView) {
            this.cureViews.push(cureView);
        }
    };

    /**
     * Remove the link between the service view and the cure view.
     *
     * @param cureView
     */
    ServiceView.prototype.removeLinkToCureView = function (cureView) {
        this.cureViews = this.cureViews.filter(function (element) {
            return element !== cureView;
        });
    };

    ServiceView.prototype.addProductViewOnService = function (productView) {
        if (productView && this.productsView.indexOf(productView) == -1) this.productsView.push(productView);
        this.updateDurationOnPackage();
    };

    ServiceView.prototype.removeProductViewOnService = function (productView) {
        var index = this.productsView.indexOf(productView);
        if (index != -1) this.productsView.splice(index, 1);
        this.updateDurationOnPackage();
    };

    ServiceView.prototype.hasSubServiceView = function (serviceView) {
        return this.subServicesView.indexOf(serviceView) != -1;
    };

    ServiceView.prototype.addSubServiceView = function (serviceView) {
        if (serviceView && !this.hasSubServiceView(serviceView)) this.subServicesView.push(serviceView);
        this.updateDurationOnPackage();
        this.updateSubServicesPrice();
    };

    ServiceView.prototype.onPackageChange = function () {
        this.subServicesView = [];
        if (this.isPackage) {
            this.createAndAddSubServiceView();
            this.createAndAddSubServiceView(); //call two times to have 2 steps by default when multi step is activated
        }
    };

    ServiceView.prototype.onPackageInputChange = function () {
        this.checkActiveMultiStep();

        if (!this.displayMessageMultiStep) {
            this.onPackageChange();
        } else {
            this.isPackage = false;
        }
    };

    ServiceView.prototype.createAndAddSubServiceView = function () {
        var serviceView = new ServiceView(null, -1, this.parentCategoryView, this.domainView, this, this.subServicesView.length);
        if (this.domainView) serviceView.initSkills(this.domainView.getHumanResourcesView(), this.domainView.getPhysicalResourcesView());
        this.addSubServiceView(serviceView);
        return serviceView;
    };

    ServiceView.prototype.removeSubServiceView = function (serviceView) {
        if (serviceView) {
            var index = this.subServicesView.indexOf(serviceView);
            if (index != -1) this.subServicesView.splice(index, 1);
            this.updateDurationOnPackage();
            this.updateSubServicesPrice();
        }
    };

    ServiceView.prototype.isChanged = function () {
        var service = this.getModel();
        if (service) {
            var image = service.image;
            if (image == null && service.parentCategory && service.specificImage == false) image = service.parentCategory.image;
            var companyImage = service.companyImage;
            if (companyImage == null && service.parentCategory && service.specificImage == false) companyImage = service.parentCategory.companyImage;

            var styleView = this.getStyleFrom(service);
            var styleChanged = this.styleView && !styleView || !this.styleView && styleView || this.styleView && styleView && this.styleView.background != styleView.background;

            var isServiceSettingsPartnerViewChanged = false;

            for (var serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view) {
                    isServiceSettingsPartnerViewChanged = isServiceSettingsPartnerViewChanged && this.serviceSettings[serviceSettings].view.isChanged(this.serviceSettings[serviceSettings].view.getModel());
                }
            }

            return this.label != service.label || this.labelShort != service.labelShort || this.description != service.description || this.isPackage != service.isPackage || this.isOnHome != service.isOnHome || this.hasInternetPrice != service.hasInternetPrice || this.hasMandatoryPayment != service.hasMandatoryPayment || this.price != service.price || this.internetPrice != service.internetPrice || this.duration != service.duration || this.itnDuration != service.itnDuration || this.hasItnDuration != service.hasItnDuration || this.specificImage != service.specificImage || this.image !== image || this.companyImage !== companyImage || this.nbHrsNeeded != service.nbHrsNeeded || this.nbPrsNeeded != service.nbPrsNeeded || this.hrSkillsIsChanged() || this.prSkillsIsChanged() || isServiceSettingsPartnerViewChanged;
        } else return true;
    };

    ServiceView.prototype.setImage = function (image) {
        this.image = image;
        this.companyImage = null;
        this.imageDisplayed = this.image;
    };

    ServiceView.prototype.setCompanyImage = function (companyImage) {
        this.image = null;
        this.companyImage = companyImage;
        this.imageDisplayed = this.companyImage;
    };

    ServiceView.prototype.initSkills = function (humanResourcesView, physicalResourcesView) {
        if (this.isPackage) {
            for (var i = 0; i < this.subServicesView.length; i++) {
                this.subServicesView[i].initSkills(humanResourcesView, physicalResourcesView);
            }
        }
        var service = this.getModel();
        this.hrSkillsView = [];
        for (var i = 0; i < humanResourcesView.length; i++) {
            if (humanResourcesView[i].hasPlanning) {
                var hr = humanResourcesView[i].getModel();
                var hrSkillView = { hrView: humanResourcesView[i] };
                if (!service) hrSkillView.active = true; //active by default for a new service
                else hrSkillView.active = hr && hr.hasService(service);
                this.hrSkillsView.push(hrSkillView);
            }
        }
        this.prSkillsView = [];
        for (var i = 0; i < physicalResourcesView.length; i++) {
            if (physicalResourcesView[i].hasPlanning) {
                var pr = physicalResourcesView[i].getModel();
                var prSkillView = { prView: physicalResourcesView[i] };
                prSkillView.active = pr && pr.hasService(service);
                this.prSkillsView.push(prSkillView);
            }
        }
    };

    ServiceView.prototype.getClone = function (parentClone) {
        var clone = new ServiceView(null, -1, this.parentCategoryView, this.domainView, parentClone);
        clone.label = this.label;
        clone.labelShort = this.labelShort;
        clone.previousLabelShort = this.labelShort;
        clone.description = this.description;
        clone.isPackage = this.isPackage;
        clone.isOnHome = this.isOnHome;
        clone.homeOrder = this.homeOrder;
        clone.price = this.price;
        // clone.priceInput = this.priceInput ;
        clone.internetPriceInput = this.internetPriceInput;
        clone.internetDiscountPercent = this.internetDiscountPercent;
        clone.itnDurationD = this.itnDurationD; //internet duration displayed
        clone.hasInternetPrice = this.hasInternetPrice;
        clone.hasMandatoryPayment = this.hasMandatoryPayment;
        clone.internetPrice = this.internetPrice;
        clone.duration = this.duration;
        clone.itnDuration = this.itnDuration;
        clone.hasItnDuration = this.hasItnDuration;
        clone.image = this.image;
        clone.companyImage = this.companyImage;
        clone.specificImage = this.specificImage;
        clone.nbHrsNeeded = this.nbHrsNeeded;
        clone.nbPrsNeeded = this.nbPrsNeeded;
        clone.nbHrsNeededCheck = this.nbHrsNeededCheck;
        clone.nbPrsNeededCheck = this.nbPrsNeededCheck;
        clone.isVisibleOnWebSite = this.isVisibleOnWebSite;
        clone.displayMessageMultiStep = this.displayMessageMultiStep;
        clone.displayMessageNbHrsNeeded = this.displayMessageNbHrsNeeded;
        clone.displayMessageNbPrsNeeded = this.displayMessageNbPrsNeeded;
        clone.displayMessageDuration = this.displayMessageDuration;
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view) {
                clone.serviceSettings[serviceSettings].view = this.serviceSettings[serviceSettings].view.getClone();
            }
        }

        clone.isBookableOnWebSite = this.isBookableOnWebSite;
        if (!parentClone) {
            clone.styleView = {};
            clone.styleView.background = this.styleView.background;
            clone.styleView.color = this.styleView.color;
            clone.colorPicker = this.colorPicker;
        } else {
            clone.styleView = parentClone.styleView;
        }

        clone.subServicesView = [];

        for (var i = 0; i < this.subServicesView.length; i++) {
            clone.subServicesView.push(this.subServicesView[i].getClone(clone));
        }clone.productsView = [];
        for (var i = 0; i < this.productsView.length; i++) {
            clone.productsView.push(this.productsView[i]);
        }
        if (this.hrSkillsView) {
            clone.hrSkillsView = this.hrSkillsView.slice(0);
        }
        if (this.prSkillsView) {
            clone.prSkillsView = this.prSkillsView.slice(0);
        }
        clone.isVisible = this.isVisible;
        return clone;
    };

    ServiceView.prototype.copyDataTo = function (service) {
        //Assume here than the object in parameter contains only id (must load them)
        service.label = this.label;
        service.labelShort = this.labelShort;
        service.description = this.description;
        service.isPackage = this.isPackage;
        service.isOnHome = this.isOnHome;
        service.homeOrder = this.homeOrder;
        service.price = this.price;
        service.hasInternetPrice = this.hasInternetPrice;
        service.hasMandatoryPayment = this.hasMandatoryPayment;
        service.internetPrice = this.internetPrice;
        service.duration = this.duration;
        service.itnDuration = this.itnDuration;
        service.hasItnDuration = this.hasItnDuration;
        service.image = this.image;
        service.companyImage = this.companyImage;
        service.specificImage = this.specificImage;
        service.nbHrsNeeded = this.nbHrsNeeded;
        service.nbPrsNeeded = this.nbPrsNeeded;
        service.isVisibleOnWebSite = this.isVisibleOnWebSite;
        service.isBookableOnWebSite = this.isBookableOnWebSite;
        service.subServices = [];
        var subService = null;

        for (var i = 0; i < this.subServicesView.length; i++) {
            subService = this.subServicesView[i].getModel();
            if (subService == null) {
                subService = new Service();
                this.subServicesView[i].servIndex = ServiceData.getIndexOf(subService);
            }
            this.subServicesView[i].copyDataTo(subService);
            service.subServices.push(subService);
        }
        service.products = [];
        var product = null;
        for (var i = 0; i < this.productsView.length; i++) {
            product = this.productsView[i].getModel();
            if (product) {
                service.products.push(product);
            }
        }

        if (this.imgWidgetView) {
            service.imgWidget = JSON.stringify(this.imgWidgetView.getObjectResource());
        }
        if (this.subWidgetsView) {
            var widgets = [];
            for (var i = 0; i < this.subWidgetsView.length; i++) {
                widgets.push(this.subWidgetsView[i].getObjectResource());
            }
            service.subWidgets = JSON.stringify(widgets);
        }
        if (this.styleView) {
            service.style = angular.toJson(this.styleView);
        }
        service.isVisible = this.isVisible;
    };

    ServiceView.prototype.onSpecificImageChange = function () {
        if (!this.specificImage) {
            this.image = null;
            this.companyImage = null;
        }
    };

    ServiceView.prototype.updateModelAndCreateWithPartnerServiceSettings = function (activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
        var service = this.updateModelWithoutSave();
        var serviceView = this;
        ServiceSrv.createWithPartnerServiceSettings(service, activationByPartnerLabel, settingsByPartnerLabel, function (data) {
            if (successFunction) {
                successFunction();
            }
            serviceView.saveResourceSkills(data.id);
        }, errorFunction);
    };

    ServiceView.prototype.updateModel = function (successFunction, errorFunction) {
        var service = this.updateModelWithoutSave();
        var serviceView = this;
        ServiceSrv.save(service, function (data) {
            if (successFunction) {
                successFunction(data);
            }
            serviceView.saveResourceSkills(data.id);
        }, errorFunction);
    };

    ServiceView.prototype.updateModelWithoutSave = function () {
        if (this.hasItnDuration) {
            this.itnDurationD = this.itnDuration;
        } else {
            this.itnDurationD = this.duration;
        }
        var service = this.getModel();
        if (service == null) {
            service = new Service();
            this.servIndex = ServiceData.getIndexOf(service);
        }

        if (!this.specificImage && this.parentCategoryView && this.parentCategoryView.parentCategoryView) {
            this.image = this.parentCategoryView.image;
            service.image = this.image;
        }

        this.copyDataTo(service);

        var category = this.parentCategoryView.getModel();
        if (category && category !== service.parentCategory) {
            // change of category
            if (service.parentCategory) {
                service.parentCategory.removeService(service);
            }
            category.addService(service);
        }

        return service;
    };

    ServiceView.prototype.hrSkillsIsChanged = function () {
        var service = this.getModel();
        var previousActive;
        var isChanged = false;
        if (this.hrSkillsView) {
            var hr;
            for (var i = 0; i < this.hrSkillsView.length && !isChanged; i++) {
                hr = this.hrSkillsView[i].hrView.getModel();
                if (hr) {
                    previousActive = hr.hasService(service);
                    isChanged = previousActive != this.hrSkillsView[i].active; //must update and save hr
                }
            }
        }
        return isChanged;
    };

    ServiceView.prototype.prSkillsIsChanged = function () {
        var service = this.getModel();
        var previousActive;
        var isChanged = false;
        if (this.prSkillsView) {
            var pr;
            for (var i = 0; i < this.prSkillsView.length && !isChanged; i++) {
                pr = this.prSkillsView[i].prView.getModel();
                if (pr) {
                    previousActive = pr.hasService(service);
                    isChanged = previousActive != this.prSkillsView[i].active; //must update and save pr
                }
            }
        }
        return isChanged;
    };

    ServiceView.prototype.saveResourceSkills = function (serviceId) {
        if (this.isPackage) {
            if (this.hrSkillsView) {
                for (var i = 0; i < this.hrSkillsView.length; i++) {
                    for (var j = 0; j < this.subServicesView.length && !this.hrSkillsView[i].active; j++) {
                        if (this.subServicesView[j].hrSkillsView) {
                            this.hrSkillsView[i].active = this.hrSkillsView[i].active || this.subServicesView[j].hrSkillsView[i].active;
                        }
                    }
                }
            }
            if (this.prSkillsView) {
                for (var _i = 0; _i < this.prSkillsView.length; _i++) {
                    for (var _j = 0; _j < this.subServicesView.length && !this.prSkillsView[_i].active; _j++) {
                        if (this.subServicesView[_j].prSkillsView) {
                            this.prSkillsView[_i].active = this.prSkillsView[_i].active || this.subServicesView[_j].prSkillsView[_i].active;
                        }
                    }
                }
            }
        }
        this.saveResourceSkillsAction(serviceId);
    };

    ServiceView.prototype.saveResourceSkillsAction = function (serviceId) {
        var servicesViews = this.subServicesView.slice();
        servicesViews.push(this);
        var humanResources = [];
        var physicalResources = [];
        if (servicesViews) {
            for (var i = 0; i < servicesViews.length; i++) {
                servicesViews[i].updateResourceModelSkills(humanResources, servicesViews[i].hrSkillsView, true);
                servicesViews[i].updateResourceModelSkills(physicalResources, servicesViews[i].prSkillsView, false);
            }
        }
        if (humanResources.length > 0 || physicalResources.length > 0) {
            ResourceSrv.update(new Resource(humanResources, physicalResources, this.isPackage, serviceId));
        }
    };

    ServiceView.prototype.updateResourceModelSkills = function (resources, skillsView, isHumanResource) {
        var service = this.getModel();
        var previousActive = void 0;
        if (skillsView && service) {
            for (var i = 0; i < skillsView.length; i++) {
                var resource = isHumanResource ? skillsView[i].hrView.getModel() : skillsView[i].prView.getModel();
                if (resource) {
                    previousActive = resource.hasService(service);
                    if (previousActive !== skillsView[i].active) {
                        if (skillsView[i].active) {
                            resource.addService(service);
                        } else {
                            resource.removeService(service);
                        }
                        var index = this.findResource(resources, resource);
                        if (index !== -1) {
                            resources.splice(index, 1, resource);
                        } else {
                            resources.push(resource);
                        }
                    }
                }
            }
        }
    };

    ServiceView.prototype.findResource = function (resources, resource) {
        var index = void 0;
        for (var i = 0; i < resources.length; i++) {
            index = i;
            if (resource.id === resources[index].id) {
                return index;
            }
        }
        return -1;
    };

    ServiceView.prototype.hasPrSkillsActive = function () {
        if (this.prSkillsView) for (var i = 0; i < this.prSkillsView.length; i++) {
            if (this.prSkillsView[i].active) return true;
        }
        return false;
    };

    ServiceView.prototype.hasHrSkillsActive = function () {
        if (this.hrSkillsView) for (var i = 0; i < this.hrSkillsView.length; i++) {
            if (this.hrSkillsView[i].active) {
                return true;
            }
        }
        return false;
    };

    ServiceView.prototype.removeModel = function () {
        var service = this.getModel();
        if (service != null) {
            service.parentCategory.removeService(service);
            ServiceSrv.remove(service);
        }
    };

    ServiceView.prototype.reloadModel = function () {
        var service = this.getModel();
        if (service == null) {
            this.parentCategoryView.removeServiceView(this);
        } else {
            this.loadDataFrom(service);
        }
    };

    ServiceView.prototype.restoreModel = function () {
        //undeleted
        var service = this.getModel();
        if (service) {
            if (service.parentCategory) service.parentCategory.addService(service);
            ServiceSrv.restore(service);
        }
    };

    ServiceView.prototype.setSkills = function (resource) {
        this.isSelResKnow = !resource || resource.hasService(this.getModel());
        return this.isSelResKnow;
    };

    ServiceView.prototype.canSave = function () {
        var canSave = true;
        if (this.isPackage) {
            canSave = this.subServicesView.length > 1;
            if (canSave) {
                for (var i = 0; i < this.subServicesView.length; i++) {
                    canSave = canSave && this.subServicesView[i].canSave();
                }
            }
        }
        var durationInt = parseInt(this.duration);
        if (isNaN(durationInt)) {
            this.duration = null;
        } else {
            this.duration = durationInt;
        }
        canSave = canSave && this.duration != null && !!this.label && (!this.isPackage || !!this.labelShort) && this.price >= 0 //prix (décimal)
        && this.internetPrice >= 0 && ( //prix (décimal)) //durée (entier)
        !this.nbHrsNeeded > 0 || this.hasHrSkillsActive()) && (!this.nbPrsNeeded > 0 || this.hasPrSkillsActive());

        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                canSave = canSave && this.serviceSettings[serviceSettings].view.canSave();
            }
        }

        return canSave;
    };

    ServiceView.prototype.search = function (searchedTextLC) {
        if (searchedTextLC && this.label.toLowerCase().indexOf(searchedTextLC) != -1 || this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC) != -1) {
            return true;
        }
        return false;
    };

    ServiceView.prototype.checkActiveMultiStep = function () {
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkMultiStep) {
                this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration = false;
                this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded = false;
                this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded = false;
                if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    this.displayMessageMultiStep = true;
                    break;
                } else {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerMultiStep = false;
                    this.displayMessageMultiStep = false;
                }
            }
        }
    };

    ServiceView.prototype.checkActiveDuration = function () {
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkDuration) {
                if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner && this.duration <= 0) {
                    this.displayMessageDuration = true;
                    break;
                } else {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration = false;
                    this.displayMessageDuration = false;
                }
            }
        }
    };

    ServiceView.prototype.checkActivePrice = function () {
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkPrice) {
                if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    if (!this.serviceSettings[serviceSettings].view.isPriceEnabled) {
                        if (this.price <= 0) {
                            this.displayMessagePrice = true;
                            this.price = 0;
                            this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = true;
                            break;
                        } else {
                            this.serviceSettings[serviceSettings].view.price = this.price;
                        }
                    } else {
                        this.displayMessagePrice = false;
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = false;
                    }
                } else {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = false;
                    this.displayMessagePrice = false;
                }
            }
        }
    };

    ServiceView.prototype.checkActiveNbHrsNeeded = function () {
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkNbHrsNeeded) {
                if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    this.displayMessageNbHrsNeeded = true;
                    break;
                } else {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded = false;
                    this.displayMessageNbHrsNeeded = false;
                }
            }
        }
    };

    ServiceView.prototype.checkActiveNbPrsNeeded = function () {
        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkNbPrsNeeded) {
                if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    this.displayMessageNbPrsNeeded = true;
                    break;
                } else {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded = false;
                    this.displayMessageNbPrsNeeded = false;
                }
            }
        }
    };

    ServiceView.prototype.initAlertMessagePaymentOnline = function () {
        var serviceSettings = this.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role];
        if (serviceSettings.view) {
            serviceSettings.view.displayAlertMessagePaymentOnline = false;
            if (this.hasMandatoryPayment) {
                serviceSettings.view.displayAlertMessagePaymentOnline = true;
            } else {
                var webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    if (webSiteApp.getAppAttribute("hasBookingPaymentMandatory") && webSiteApp.getAppAttribute("hasBookingPaymentMandatory").value === "true") {
                        serviceSettings.view.displayAlertMessagePaymentOnline = true;
                    } else if (webSiteApp.getAppAttribute("hasBookingPaymentOnAmount") && webSiteApp.getAppAttribute("hasBookingPaymentOnAmount").value === "true") {
                        var price = this.price;
                        if (this.hasInternetPrice) {
                            price = this.internetPrice;
                        }
                        if (webSiteApp.getAppAttribute("bookingPaymentOnAmount") && parseInt(webSiteApp.getAppAttribute("bookingPaymentOnAmount").value) <= price) {
                            serviceSettings.view.displayAlertMessagePaymentOnline = true;
                        }
                    }
                }
            }
        }
    };

    ServiceView.prototype.checkActiveOption = function (serviceSettings) {
        if (serviceSettings.checkMultiStep) {
            this.checkMultiStepOnActivePartner(serviceSettings);
        }
        if (serviceSettings.checkNbHrsNeeded) {
            this.checkNbHrsNeededOnActivePartner(serviceSettings);
        }
        if (serviceSettings.checkNbPrsNeeded) {
            this.checkNbPrsNeededOnActivePartner(serviceSettings);
        }
        if (serviceSettings.checkDuration) {
            this.checkDurationOnActivePartner(serviceSettings);
        }
        if (serviceSettings.checkPrice) {
            this.checkPriceOnActivePartner(serviceSettings);
        }
    };

    ServiceView.prototype.onVisibleOnPartnerChange = function (serviceSettingsRole) {
        this.displayMessageNbHrsNeeded = false;
        this.displayMessageNbPrsNeeded = false;
        this.displayMessageMultiStep = false;
        this.displayMessageDuration = false;
        var serviceSettingsDisplayMessageNbHrsNeeded = [];
        var serviceSettingsDisplayMessageNbPrsNeeded = [];
        var serviceSettingsDisplayMessageDuration = [];
        var serviceSettingsDisplayMessagePartnerMultiStep = [];
        this.serviceSettingsActive = 0;

        for (var serviceSettings in this.serviceSettings) {
            if (this.serviceSettings.hasOwnProperty(serviceSettingsRole)) {
                if (this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    this.serviceSettingsActive = this.serviceSettingsActive + 1;
                }
                this.checkActiveOption(this.serviceSettings[serviceSettings]);

                if (this.serviceSettings[serviceSettings].view && (this.serviceSettings[serviceSettings].view.displayMessagePartnerMultiStep || this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration || this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded || this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded)) {
                    this.serviceSettings[serviceSettings].view.isVisibleOnPartner = false;
                } else {
                    this.displayMessageNbHrsNeeded = serviceSettingsDisplayMessageNbHrsNeeded.push(this.displayMessageNbHrsNeeded);
                    this.displayMessageNbPrsNeeded = serviceSettingsDisplayMessageNbPrsNeeded.push(this.displayMessageNbPrsNeeded);
                    this.displayMessageDuration = serviceSettingsDisplayMessageDuration.push(this.displayMessageDuration);
                    this.displayMessagePartnerMultiStep = serviceSettingsDisplayMessagePartnerMultiStep.push(this.displayMessagePartnerMultiStep);
                }
            }
        }

        this.displayMessageNbHrsNeeded = serviceSettingsDisplayMessageNbHrsNeeded.includes(true);
        this.displayMessageNbPrsNeeded = serviceSettingsDisplayMessageNbPrsNeeded.includes(true);
        this.displayMessageMultiStep = serviceSettingsDisplayMessageDuration.includes(true);
        this.displayMessageDuration = serviceSettingsDisplayMessagePartnerMultiStep.includes(true);
    };

    ServiceView.prototype.onPromoEnabledChange = function (serviceSettingRole) {
        var serviceSettings = this.serviceSettings[serviceSettingRole];
        if (serviceSettings.view.promoEnabled) {
            serviceSettings.view.isVisibleOnPartner = true;
        }
        this.onVisibleOnPartnerChange(serviceSettingRole);
        if (!serviceSettings.view.isVisibleOnPartner) {
            serviceSettings.view.promoEnabled = false;
        }
    };

    ServiceView.prototype.onPriceEnabledChange = function (serviceSettingRole) {
        var serviceSettings = this.serviceSettings[serviceSettingRole];
        serviceSettings.view.price = this.price;
        this.onVisibleOnPartnerChange(serviceSettingRole);
    };

    ServiceView.prototype.checkDurationOnActivePartner = function (serviceSettings) {
        if (serviceSettings.view) {
            if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkDuration) {
                if (this.isPackage) {
                    serviceSettings.view.displayMessagePartnerServiceDuration = false;
                } else {
                    if (this.duration <= 0) {
                        serviceSettings.view.displayMessagePartnerServiceDuration = true;
                    }
                }
            } else {
                this.displayMessageDuration = false;
                serviceSettings.view.displayMessagePartnerServiceDuration = false;
            }
        }
    };

    ServiceView.prototype.checkMultiStepOnActivePartner = function (serviceSettings) {
        if (serviceSettings.view) {
            if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkMultiStep) {
                if (this.isPackage) {
                    serviceSettings.view.displayMessagePartnerMultiStep = true;
                }
            } else {
                this.displayMessageMultiStep = false;
                serviceSettings.view.displayMessagePartnerMultiStep = false;
            }
        }
    };

    ServiceView.prototype.checkNbHrsNeededOnActivePartner = function (serviceSettings) {
        if (serviceSettings.view) {
            if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkNbHrsNeeded) {
                if (this.isPackage) {
                    serviceSettings.view.displayMessagePartnerNbHrsNeeded = false;
                } else {
                    if (this.nbHrsNeeded !== 1) {
                        serviceSettings.view.displayMessagePartnerNbHrsNeeded = true;
                    }
                    if (this.nbHrsNeeded === 1) {
                        this.displayMessageNbHrsNeeded = true;
                    }
                }
            } else {
                this.displayMessageNbHrsNeeded = false;
                serviceSettings.view.displayMessagePartnerNbHrsNeeded = false;
            }
        }
    };

    ServiceView.prototype.checkNbPrsNeededOnActivePartner = function (serviceSettings) {
        if (serviceSettings.view) {
            if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkNbPrsNeeded) {
                if (this.isPackage) {
                    serviceSettings.view.displayMessagePartnerNbPrsNeeded = false;
                } else {
                    if (this.nbPrsNeeded !== 0) {
                        serviceSettings.view.displayMessagePartnerNbPrsNeeded = true;
                    }
                    if (this.nbPrsNeeded === 0) {
                        this.displayMessageNbPrsNeeded = true;
                    }
                }
            } else {
                this.displayMessageNbPrsNeeded = false;
                serviceSettings.view.displayMessagePartnerNbPrsNeeded = false;
            }
        }
    };

    ServiceView.prototype.checkPriceOnActivePartner = function (serviceSettings) {
        if (serviceSettings.view) {
            if (serviceSettings.view.isVisibleOnPartner && !serviceSettings.view.isPriceEnabled) {
                if (this.price <= 0) {
                    serviceSettings.view.price = 0;
                    serviceSettings.view.displayMessagePartnerIsPriceEnabled = true;
                    this.displayMessagePrice = true;
                } else {
                    serviceSettings.view.price = this.price;
                    serviceSettings.view.displayMessagePartnerIsPriceEnabled = false;
                    this.displayMessagePrice = false;
                }
            } else {
                serviceSettings.view.displayMessagePartnerIsPriceEnabled = false;
                this.displayMessagePrice = false;
                if (serviceSettings.view.isDisplayMessagePartnerPriceNotValid) {
                    serviceSettings.view.isDisplayMessagePartnerPriceNotValid();
                }
            }
        }
    };

    ServiceView.prototype.updateMarketplaceVariantInLabel = function (previousVariantLabel, variantLabel) {
        if (variantLabel && previousVariantLabel) {
            this.label = this.label.replace(previousVariantLabel, variantLabel);
        } else if (!previousVariantLabel && variantLabel) {
            this.label = this.label + " - " + variantLabel;
        } else {
            this.label = this.label.replace(" - " + previousVariantLabel, "");
        }
    };

    ServiceView.prototype.updateSubServiceViewLabelShort = function () {
        this.labelShort = this.label;
    };

    return ServiceView;
}]);

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SupplierView', ["$filter", "Supplier", "SupplierData", "SupplierSrv", "Format", "PhoneFormat", function ($filter, Supplier, SupplierData, SupplierSrv, Format, PhoneFormat) {

    var SupplierView = function SupplierView(supplier, sIndex, domainView) {
        this.sIndex = sIndex;
        this.domainView = domainView;
        this.label = null;
        this.lastName = null;
        this.firstName = null;
        this.phone = null;
        this.landline = null;
        this.email = null;
        this.login = null;
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.postCode = null;
        this.productsView = [];
        this.loadDataFrom(supplier);
    };
    SupplierView.prototype.getModel = function () {
        if (this.sIndex != -1) return SupplierData.getByIndex(this.sIndex);
        return null;
    };
    SupplierView.prototype.loadDataFrom = function (supplier) {
        if (supplier !== undefined && supplier) {
            this.label = supplier.label;
            this.lastName = supplier.lastName;
            this.firstName = supplier.firstName;
            this.phone = PhoneFormat.formatNumberWithoutCountry(supplier.phone);
            this.landline = PhoneFormat.formatNumberWithoutCountry(supplier.landline);
            this.email = supplier.email;
            this.isVerified = supplier.isVerified;
            this.address1 = supplier.address1;
            this.address2 = supplier.address2;
            this.city = supplier.city;
            this.postCode = supplier.postCode;
        }
    };
    SupplierView.prototype.copyDataTo = function (supplier) //
    {
        supplier.label = this.label;
        supplier.lastName = this.lastName;
        supplier.firstName = this.firstName;
        if (this.phone != null) supplier.phone = this.phone.replace(/\s/g, '');else supplier.phone = null;
        if (this.landline != null) supplier.landline = this.landline.replace(/\s/g, '');else supplier.landline = null;
        supplier.email = this.email;
        supplier.isVerified = this.isVerified;
        supplier.address1 = this.address1;
        supplier.address2 = this.address2;
        supplier.city = this.city;
        supplier.postCode = this.postCode;
    };
    SupplierView.prototype.addProductView = function (productView) //
    {
        if (productView) {
            var index = this.productsView.indexOf(productView);
            if (index == -1) {
                this.productsView.push(productView);
            }
        }
    };
    SupplierView.prototype.removeProductView = function (productView) //
    {
        var index = this.productsView.indexOf(productView);
        if (index != -1) {
            this.productsView.splice(index, 1);
        }
    };
    SupplierView.prototype.isChanged = function () {
        var supplier = this.getModel();
        if (supplier) return this.label != supplier.label || this.firstName != supplier.firstName || this.lastName != supplier.lastName || this.phone != Format.formatNumber(supplier.phone) || this.landline != Format.formatNumber(supplier.landline) || this.email != supplier.email;else return true;
    };
    SupplierView.prototype.removeModel = function () {
        var supplier = this.getModel();
        if (supplier != null) SupplierSrv.remove(supplier);
    };
    SupplierView.prototype.reloadModel = function () {
        var supplier = this.getModel();
        if (supplier != null) this.loadDataFrom(supplier);
    };
    SupplierView.prototype.updateModel = function (save, endFunction) {
        //Save by default
        var supplier = this.getModel();
        if (!supplier) //create it
            {
                supplier = new Supplier();
                this.sIndex = SupplierData.getIndexOf(supplier);
            }

        this.copyDataTo(supplier);
        if (save === undefined || save) //Save by default
            SupplierSrv.save(supplier, endFunction);
    };
    SupplierView.prototype.restoreModel = function () {
        var supplier = this.getModel();
        if (supplier) SupplierSrv.restore(supplier);
    };
    SupplierView.prototype.canSave = function () {
        return this.label != null && this.label != "";
    };
    //FIX ME : DUPLICATED FUNCTION
    SupplierView.prototype.hasValidCellPhone = function (isMandatory) {
        // if supplier has a valid cellphone number
        if (!isMandatory) {
            // if not mandatory, phone number is not an obligation
            if (this.phone == null || this.phone == "") return true;
        }
        if (this.phone && this.phone.length > 0) {
            if (this.phone[0] == 0 && this.phone.replace(/[^0-9]/g, '').length == 10 && this.phone.length == 14 && (this.phone[1] == 6 || this.phone[1] == 7)) {
                // if length with only numbers equals 10 and if the first two numbers are 06 or 07
                // french number
                return true;
            }
            if (this.phone[0] == '+') {
                // international number
                return true;
            }
        }

        return false;
    };
    SupplierView.prototype.hasValidLandLine = function () {
        // if site has a valid work phone number
        if (this.landline == null || this.landline == "") return true;
        if (this.landline && this.landline.length > 0) {
            if (this.landline[0] == 0 && this.landline.replace(/[^0-9]/g, '').length == 10 && this.landline.length == 14) {
                // if length with only numbers equals 10 and if the first number is 0
                // french number
                return true;
            }
            if (this.landline[0] == '+') {
                // international number
                return true;
            }
        }

        return false;
    };
    return SupplierView;
}]);

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('VatView', ["$filter", "Vat", "VatData", "VatSrv", function ($filter, Vat, VatData, VatSrv) {

    var VatView = function VatView(vat, vIndex) {
        this.vIndex = vIndex;
        this.code = null;
        this.tax = null;
        this.taxInput = "";
        this.isDefault = null;
        this.isUsable = null;
        this.loadDataFrom(vat);
    };
    VatView.prototype.getModel = function () {
        if (this.vIndex != -1) return VatData.getByIndex(this.vIndex);
        return null;
    };
    VatView.prototype.loadDataFrom = function (vat) {
        if (vat !== undefined && vat) {
            this.code = vat.code;
            this.tax = vat.tax;
            this.taxInput = $filter('number')(this.tax, 2);
            this.isDefault = vat.isDefault;
            this.isUsable = vat.isUsable;
        }
    };
    VatView.prototype.copyDataTo = function (vat) //
    {
        vat.code = this.code;
        vat.tax = this.tax;
        vat.isDefault = this.isDefault;
        vat.isUsable = this.isUsable;
    };

    VatView.prototype.isChanged = function () {
        var vat = this.getModel();
        if (vat) return this.code != vat.code || this.tax != vat.tax || this.isDefault != vat.isDefault || this.isUsable != vat.isUsable;else return true;
    };
    VatView.prototype.onTaxInputChange = function () {
        if (this.taxInput != null && typeof this.taxInput === 'string') {
            var taxStr = this.taxInput.replace(",", ".").replace(" ", "");
            var tax = parseFloat(taxStr);
            if (tax !== "NaN") this.tax = tax;else this.tax = null;
        }
    };
    VatView.prototype.removeModel = function () {
        var vat = this.getModel();
        if (vat != null) VatSrv.remove(vat);
    };
    VatView.prototype.reloadModel = function () {
        var vat = this.getModel();
        if (vat != null) this.loadDataFrom(vat);
    };
    VatView.prototype.updateModel = function (save, endFunction) {
        //Save by default
        var vat = this.getModel();
        if (!vat) //create it
            {
                vat = new Vat();
                this.vIndex = VatData.getIndexOf(vat);
            }

        this.copyDataTo(vat);
        if (save === undefined || save) //Save by default
            VatSrv.save(vat, endFunction);
    };
    VatView.prototype.restoreModel = function () {
        var vat = this.getModel();
        if (vat) VatSrv.restore(vat);
    };
    VatView.prototype.canSave = function () {
        return true;
    };

    return VatView;
}]);

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('DayView', ["$filter", "$timeout", "DateSrv", "DayData", "DaySrv", function ($filter, $timeout, DateSrv, DayData, DaySrv) {
    //Special object fusion of Day and site->WorkingPeriodDay
    var DayView = function DayView(dayIndex) {
        this.dayIndex = -1; // index of currentVersion day
        this.dayOfWIndex = -1; // index of day (0 = monday)
        this.date = null;
        this.label = "";
        this.labelC = ""; //label capitalized
        this.labelDayOfWC = ""; //Day of week capitalized
        this.datePickerOpened = false;
        this.loadDayData(dayIndex);
    };
    DayView.prototype.loadDayData = function (dayIndex) {
        if (dayIndex != -1) {
            this.dayIndex = dayIndex;
            var day = DayData.getByIndex(dayIndex);
            if (day) {
                this.dayOfWIndex = day.getDayOfWIndex();
                this.date = day.getDate();
                if (this.date) this.label = $filter('date')(this.date, 'EEEE d MMMM'); //execute angular filter
                if (this.label.length > 0) this.labelC = this.label.charAt(0).toUpperCase() + this.label.substring(1);
                this.labelDayOfWC = DateSrv.daysOfWeekLabel[this.dayOfWIndex].charAt(0).toUpperCase() + DateSrv.daysOfWeekLabel[this.dayOfWIndex].substring(1);
            }
        }
    };
    DayView.prototype.updateCurrentDay = function (increase) {
        if (increase) this.loadDayData(this.dayIndex + 1);else this.loadDayData(this.dayIndex - 1);
    };

    DayView.prototype.displayTodayF = function () {
        this.displayDate(new Date());
    };
    DayView.prototype.displayDate = function (date) {
        if (date) {
            var dayId = DaySrv.getIdFromDate(date);
            var day = DaySrv.getByIdAdder(dayId, true);
            if (day) this.loadDayData(DayData.getIndexOf(day));
        }
    };
    DayView.prototype.getModel = function () {
        return DayData.getByIndex(this.dayIndex);
    };

    DayView.prototype.displayDatePickerF = function () {
        var dv = this;
        $timeout(function () {
            dv.datePickerOpened = true;
        });
    };

    DayView.prototype.updateFromDate = function () {
        var dayId = DaySrv.getIdFromDate(this.date);
        var day = DaySrv.getByIdAdder(dayId, true);
        this.loadDayData(DayData.getIndexOf(day));
    };

    return DayView;
}]);

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('PaymentDataObject', ["SalePaymentType", function (SalePaymentType) {
    var PaymentDataObject = function PaymentDataObject() {
        this.initSalePaymentsPrice();
        this.initSalePaymentsNumber();
    };
    PaymentDataObject.prototype.initSalePaymentsPrice = function () {
        for (var salePaymentType in SalePaymentType) {
            if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                this[SalePaymentType[salePaymentType].keyPrice] = 0;
            }
        }
    };
    PaymentDataObject.prototype.initSalePaymentsNumber = function () {
        for (var salePaymentType in SalePaymentType) {
            if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                this[SalePaymentType[salePaymentType].keyNumber] = 0;
            }
        }
    };
    PaymentDataObject.prototype.computeTotalSalePaymentsPrice = function () {
        var price = 0;
        for (var salePaymentType in SalePaymentType) {
            if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                price += this[SalePaymentType[salePaymentType].keyPrice];
            }
        }
        return price;
    };
    return PaymentDataObject;
}]);

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.Specification = __webpack_require__(215);
module.exports.SpecificationSync = __webpack_require__(214);


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Specification base class
 * @class
 */
var Specification = {
  and: function(spec) {
    return new AndSpecification(this, spec);
  },
  or: function(spec) {
    return new OrSpecification(this, spec);
  },
  not: function(spec) {
    return new NotSpecification(spec);
  }
}


/**
 * And specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function AndSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
AndSpecification.prototype = Object.create(Specification);
AndSpecification.prototype.isSatisfiedBy = function(obj) {
  var leftSat = false, rightSat = false;
  if (this.leftSpec && this.leftSpec.isSatisfiedBy) {
    leftSat = this.leftSpec.isSatisfiedBy(obj);
  }
  if (this.rightSpec && this.rightSpec.isSatisfiedBy) {
    rightSat = this.rightSpec.isSatisfiedBy(obj);
  }
  return leftSat && rightSat;
};


/**
 * Or specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function OrSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
OrSpecification.prototype = Object.create(Specification);
OrSpecification.prototype.isSatisfiedBy = function(obj) {
  var leftSat = false, rightSat = false;
  if (this.leftSpec && this.leftSpec.isSatisfiedBy) {
    leftSat = this.leftSpec.isSatisfiedBy(obj);
  }
  if (this.rightSpec && this.rightSpec.isSatisfiedBy) {
    rightSat = this.rightSpec.isSatisfiedBy(obj);
  }
  return leftSat || rightSat;
};


/**
 * Not specification
 * @class
 * @param {Specification} spec  Specification
 */
function NotSpecification(spec) {
  this.spec = spec;
}
NotSpecification.prototype = Object.create(Specification);
NotSpecification.prototype.isSatisfiedBy = function(obj) {
  if (!this.spec || !this.spec.isSatisfiedBy) {
    return false;
  }
  return !this.spec.isSatisfiedBy(obj);
};


module.exports = Specification;


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Specification base class
 * @class
 */
var Specification = {
  and: function(spec) {
    return new AndSpecification(this, spec);
  },
  or: function(spec) {
    return new OrSpecification(this, spec);
  },
  not: function(spec) {
    return new NotSpecification(spec);
  }
}


/**
 * And specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function AndSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
AndSpecification.prototype = Object.create(Specification);
AndSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  var self = this;
  if (self.leftSpec && self.leftSpec.isSatisfiedBy) {
    self.leftSpec.isSatisfiedBy(obj, function(err, satisfiesLeft) {
      if (self.rightSpec && self.rightSpec.isSatisfiedBy) {
        self.rightSpec.isSatisfiedBy(obj, function(err, satisfiedRight) {
          return cb(null, satisfiesLeft && satisfiedRight);
        });
      } else {
        return cb(null, false);
      }
    });
  } else {
    return cb(null, false);
  }
};


/**
 * Or specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function OrSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
OrSpecification.prototype = Object.create(Specification);
OrSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  var self = this;
  if (self.leftSpec && self.leftSpec.isSatisfiedBy) {
    self.leftSpec.isSatisfiedBy(obj, function(err, satisfiesLeft) {
      if (self.rightSpec && self.rightSpec.isSatisfiedBy) {
        self.rightSpec.isSatisfiedBy(obj, function(err, satisfiedRight) {
          return cb(null, satisfiesLeft || satisfiedRight);
        });
      } else {
        return cb(null, false);
      }
    });
  } else {
    return cb(null, false);
  }
};


/**
 * Not specification
 * @class
 * @param {Specification} spec  Specification
 */
function NotSpecification(spec) {
  this.spec = spec;
}
NotSpecification.prototype = Object.create(Specification);
NotSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  if (!this.spec || !this.spec.isSatisfiedBy) {
    return false;
  }
  this.spec.isSatisfiedBy(obj, function(err, satisfies) {
    cb(err, !satisfies);
  });
};


module.exports = Specification;


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('WebsiteConstants', [function () {
    return {
        checkoutDisplaySteps: {
            emailValidation: "emailValidation",
            sms: "sms",
            identity: "identity",
            recap: "recap",
            card: 'card',
            connect: 'connect'
        }
    };
}]);

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteAccountCtrl', ["$log", "$scope", "$rootScope", "CustomerView", "CustomerSrv", "CustomerData", "DaySrv", "BookingData", "BookingView", "$timeout", "CategoryData", "CategoryView", "WebsiteSubdomain", "DayView", "DayData", "SaleView", "SaleData", "LoyaltyCardItemView", "LoyaltyCardItemData", "OptInOutService", "Auth", "$routeParams", "WebPreLoaderData", "CustomerPostData", "ConstantsCustomerPosts", function ($log, $scope, $rootScope, CustomerView, CustomerSrv, CustomerData, DaySrv, BookingData, BookingView, $timeout, CategoryData, CategoryView, WebsiteSubdomain, DayView, DayData, SaleView, SaleData, LoyaltyCardItemView, LoyaltyCardItemData, OptInOutService, Auth, $routeParams, WebPreLoaderData, CustomerPostData, ConstantsCustomerPosts) {

    $scope.dd = {
        view: {
            displayView: 1, //Display first view by default
            changePwd: false, //on information view
            customerPostViews: [], // on customerPostViews
            modifiedCustomerView: null,
            removedBookingView: null,
            bookedBookingView: null,
            soldSaleView: null,
            loyaltyCardItemView: null,
            nbLoyaltyCardGoal: 0, //reached
            loading: true,
            waitServerResponse: false
        },
        waitingConfirmDelete: false,
        waitingConfirmDeleteId: -1,
        timoutOptInOut: null
    };
    if ($scope.ad.view.bookedBookingView) {
        $scope.dd.view.bookedBookingView = $scope.ad.view.bookedBookingView;
        $scope.ad.view.bookedBookingView = null;
    }
    if ($scope.ad.view.soldSaleView) {
        $scope.dd.view.soldSaleView = $scope.ad.view.soldSaleView;
        $scope.ad.view.soldSaleView = null;
    }
    if ($scope.ad.view.removedBookingView) {
        $scope.dd.view.removedBookingView = $scope.ad.view.removedBookingView;
        $scope.ad.view.removedBookingView = null;
    }

    $scope.updateOptInOut = function (customerId, optInOutView) {
        if (customerId) {
            OptInOutService.update({
                customerId: customerId,
                optInOut: optInOutView
            }).then(function (data) {
                $scope.afterConfidentialitySaveSuccess(data);
            }, function (error) {
                if (error && error.data) {
                    $scope.afterSaveError(error.status, error.data.message);
                }
            });
        }
    };

    $scope.createOptInOut = function (customerId, optInOutView) {
        if (customerId) {
            OptInOutService.create({
                customerId: customerId,
                optInOut: optInOutView
            }).then(function (data) {
                $scope.getOptInOut();
            }, function (error) {
                if (error && error.data) {
                    $scope.afterSaveError(error.status, error.data.message);
                }
            });
        }
    };
    $scope.$watch('ad.view.loaded', function (newValue, oldValue) {
        if (newValue) {
            var loginWithToken = function loginWithToken(id, successFunction, errorFunction) {
                Auth.loginToWebSiteByToken(null, WebPreLoaderData.companyCode, $routeParams.token);
                CustomerSrv.getById(id, function (customer) {
                    console.info("getById ok !!");
                    console.info(customer);
                    $scope.afterGetCustomerWithSuccess(customer);

                    if (successFunction) {
                        successFunction(customer);
                    }
                }, function () {
                    if (errorFunction) {
                        errorFunction("getById Nok !!");
                    }
                });
            };
            var agreementSuccessFunction = function agreementSuccessFunction(customer) {
                var customerAgreement = $routeParams.agreement == 'true';
                $scope.dd.view.displayView = 5;
                if (customerAgreement) {
                    $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed = true;
                    $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed = true;
                    $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed = true;
                } else if (!customerAgreement) {
                    $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed = false;
                    $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed = false;
                    $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed = false;
                }
                $scope.ad.view.customerView.optInOutView.isExternalOptInOut = false;
                $scope.ad.view.customerView.optInOutView.consentDate = new Date();

                if ($scope.ad.view.customerView.optInOutView && $scope.ad.view.customerView.optInOutView.id) {
                    $scope.updateOptInOut(customer.id, $scope.ad.view.customerView.optInOutView);
                } else {
                    $scope.createOptInOut(customer.id, $scope.ad.view.customerView.optInOutView);
                }

                afterLoaded();
            };
            var bookingSuccessFunction = function bookingSuccessFunction() {
                afterLoaded(function () {
                    var booking = BookingData.getById($routeParams.bookingId);
                    if (booking) {
                        $scope.ad.view.customerView.bookingInfoView = new BookingView(booking, BookingData.getIndexOf(booking), $scope);
                    }
                });
            };
            var initModifiedCustomerView = function initModifiedCustomerView() {
                var customer = $scope.ad.view.customerView.getModel();
                if (customer) {
                    $scope.dd.view.modifiedCustomerView = new CustomerView(customer, $scope.ad.view.customerView.cIndex, $scope);
                    $scope.dd.view.modifiedCustomerView.initCustomerHistoryDatas(customer);
                    $scope.dd.view.customerPostViews = $scope.dd.view.modifiedCustomerView.getPostsViewByCustomerId();
                    $scope.getOptInOut();
                }

                $scope.loadView();
            };
            var errorFunction = function errorFunction(errorMessage) {
                //remove cookie and login Anonymous
                console.info(errorMessage);
                Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                $scope.loginAnonymous();
            };
            var afterLoaded = function afterLoaded(endFunction) {
                if (!$scope.ad.view.customerView) {
                    console.info("!!!$scope.ad.view.customerView");
                    $scope.openLocation(WebsiteSubdomain.LOGIN);
                } else {
                    $scope.dd.bookingDataLoaded = false;
                    $scope.dd.saleDataLoaded = false;
                    $scope.dd.giftItemDataLoaded = false;
                    CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function () {
                        if (endFunction) {
                            endFunction();
                        }

                        initModifiedCustomerView();
                    });
                }
            };

            if (!$scope.ad.view.categoryRootView) {
                var categoryRoot = CategoryData.categoryRoot;
                $scope.ad.view.categoryRootView = new CategoryView(categoryRoot, CategoryData.getIndexOf(categoryRoot), null, $scope);
            }

            if ($routeParams.token && $routeParams.id && $routeParams.agreement) {
                loginWithToken($routeParams.id, agreementSuccessFunction, errorFunction);
            } else if ($scope.ad.locationPath.indexOf(WebsiteSubdomain.BOOKING) !== -1 && $routeParams.bookingId && $routeParams.customerId && $routeParams.token) {
                loginWithToken($routeParams.customerId, bookingSuccessFunction, errorFunction);
            } else {
                afterLoaded();
            }
        }
    });

    $scope.loadView = function () {
        var bookings = BookingData.indexBookings;

        if (bookings) {
            $scope.ad.view.customerView.pastBookingsView = [];
            $scope.ad.view.customerView.futureBookingsView = [];

            for (var i = 0; i < bookings.length; i++) {
                if (bookings[i].day) {
                    var bookingView = new BookingView(bookings[i], BookingData.getIndexOf(bookings[i]), $scope);
                    bookingView.date = DaySrv.getDateFromId(bookings[i].day.id);
                    $scope.ad.view.customerView.addBookingView(bookingView);
                }
            }
            //console.log($scope.ad.view.customerView);
            $scope.ad.view.customerView.initHistoryView();

            if ($scope.ad.view.customerView.loyaltyCardItemsNotUsedView.length != 0) {
                var loyaltyCardItem = LoyaltyCardItemData.getByIndex($scope.ad.view.customerView.loyaltyCardItemsNotUsedView[0].index);
                if (loyaltyCardItem.sale) {
                    var dayView = null;
                    if (loyaltyCardItem.sale && loyaltyCardItem.sale.day) dayView = new DayView(DayData.getIndexOf(loyaltyCardItem.sale.day));
                    var saleView = new SaleView(loyaltyCardItem.sale, SaleData.getIndexOf(loyaltyCardItem.sale), dayView, null, $scope.ad.view);
                    $scope.dd.view.loyaltyCardItemView = new LoyaltyCardItemView(loyaltyCardItem, LoyaltyCardItemData.getIndexOf(loyaltyCardItem), 0, saleView);
                    var hasLoyaltyCardInShoppingCart = saleView.loyaltyCardItemsView.length > 0;
                    $scope.dd.view.nbLoyaltyCardGoal = $scope.dd.view.loyaltyCardItemView.nbLoyaltyCardGoal(null, null, hasLoyaltyCardInShoppingCart);
                }
            }
            $scope.ad.view.customerView.initGiftItemsView(true);
        }
        if ($scope.ad.view.currentBookingView) {
            for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
                $scope.ad.view.currentBookingView.bookingServicesView[i].updateCureItemAfterReload($scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView));
            }
        }
        $scope.dd.view.loading = false;
        $timeout(function () {
            if (window.FB) {
                window.FB.XFBML.parse();
            }
        }, 200);
    };
    $scope.afterSaveSuccess = function (customer) {
        $scope.dd.view.waitServerResponse = false;
        console.log("afterSaveSuccess");
        console.log(customer);
        if (customer != null) {
            $scope.dd.view.modifiedCustomerView.password = null; //hide by security
            $scope.dd.view.modifiedCustomerView.passwordAgain = null; //hide by security
            $scope.dd.view.modifiedCustomerView.currentPassword = null; //hide by security
            $scope.ad.view.customerView.loadDataFrom(customer);
            $scope.dd.view.displayView = 1;
        }
    };

    $scope.afterConfidentialitySaveSuccess = function (optInOut) {
        if (optInOut !== null) {
            $scope.ad.view.customerView.optInOutView = optInOut;
            $scope.dd.view.displayView = 5;
        }
    };

    $scope.afterSaveError = function (errorCode, errorMessage) {
        console.log(errorMessage);
        $scope.dd.view.errorMessage = errorMessage;
        $scope.dd.view.waitServerResponse = false;
    };
    $scope.removeBookingView = function (bookingView) {
        if (bookingView) {
            $scope.dd.view.waitServerResponse = true;
            bookingView.removeModel(function () {
                // success
                if ($scope.ad.locationPath.indexOf(WebsiteSubdomain.BOOKING) !== -1) {
                    $scope.ad.view.removedBookingView = bookingView;
                    $scope.ad.view.customerView.bookingInfoView = null;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.openLocation(WebsiteSubdomain.ACCOUNT);
                } else {
                    $scope.dd.view.removedBookingView = bookingView;
                    $scope.dd.view.bookedBookingView = null;
                    $scope.dd.view.soldSaleView = null;
                }
            }, function () {
                // error
                $scope.dd.view.waitServerResponse = false;
            });
        }
    };
    $scope.saveAccount = function () {
        if ($scope.dd.view.modifiedCustomerView && !$scope.dd.view.waitServerResponse) if ($scope.dd.view.modifiedCustomerView.canSaveAccountOnWeb($scope.dd.view.changePwd)) {
            $scope.dd.view.displayError = false;
            $scope.dd.view.waitServerResponse = true;
            var customer = $scope.dd.view.modifiedCustomerView.getModel();
            $scope.dd.view.modifiedCustomerView.copyDataTo(customer);
            CustomerSrv.saveAccount(customer, $scope.afterSaveSuccess, $scope.afterSaveError);
        } else $scope.dd.view.displayError = true;
    };

    $scope.getOptInOut = function () {
        var customerView = $scope.ad.view.customerView.getModel();

        OptInOutService.get({
            customerId: customerView.id
        }).then(function (data) {
            if (data && $scope.dd.view.modifiedCustomerView) {
                $scope.dd.view.modifiedCustomerView.optInOutView = data;
            }
        }, function (error) {
            if (error && error.data) {
                $scope.afterSaveError(error.status, error.data.message);
            }
        });
    };

    $scope.saveOptInOut = function () {
        if ($scope.dd.view.modifiedCustomerView) {
            var customer = $scope.dd.view.modifiedCustomerView.getModel();

            if ($scope.dd.timoutOptInOut) {
                $timeout.cancel($scope.dd.timoutOptInOut);
            }

            $scope.dd.timoutOptInOut = $timeout(function () {
                var optInOutView = $scope.dd.view.modifiedCustomerView.optInOutView;
                optInOutView.isExternalOptInOut = false;
                optInOutView.consentDate = new Date();

                if (optInOutView && optInOutView.id) {
                    $scope.updateOptInOut(customer.id, optInOutView);
                } else {
                    $scope.createOptInOut(customer.id, optInOutView);
                }
            }, 1000);
        }
    };
    $scope.deleteCustomerPost = function (customerPostView) {
        var index = $scope.dd.view.customerPostViews.indexOf(customerPostView);
        if (index !== -1) {
            $scope.dd.view.customerPostViews.splice(index, 1);
        }
        customerPostView.removeModel();
    };

    $scope.setWaitingStateCustomer = function (customerPostV, isWaitingDelete) {
        if (isWaitingDelete) {
            $scope.dd.waitingConfirmDeleteId = customerPostV.getModel().getId();
        } else {
            $scope.dd.waitingConfirmDeleteId = -1;
        }
        $scope.dd.waitingConfirmDelete = isWaitingDelete;
    };

    $scope.getCharColor = function (firstName) {
        var color = ConstantsCustomerPosts[$scope.getFirstLetterFirstName(firstName)];
        return color;
    };

    $scope.getFirstLetterFirstName = function (firstName) {
        if (firstName != null) return firstName.charAt(0);else return "?";
    };
}]);

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteAdminCtrl', ["$scope", "$routeParams", "$spMenu", "$http", "CookieFactory", "WebPreLoaderData", function ($scope, $routeParams, $spMenu, $http, CookieFactory, WebPreLoaderData) {
    //LOADING PARAMETER
    if ($routeParams.tokenAdmin) {
        var tokenAdmin = $routeParams.tokenAdmin;
        var currentUser = CookieFactory.getCookie('flexyBeauty-pro-user'); //compare with pro token cookie to allow admin mode

        $scope.addHeadersForMangopay();
        if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin) {
            $scope.ad.tokenAdmin = tokenAdmin;
            $http.defaults.headers.common.Authorization = currentUser.token; //use admin session for save
        } else {
            currentUser = CookieFactory.getCookie('flexyBeauty-connect-user-' + WebPreLoaderData.companyCode); //compare with connect pro token cookie to allow admin mode
            if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin) {
                $scope.ad.tokenAdmin = tokenAdmin;
                $http.defaults.headers.common.Authorization = currentUser.token; //use admin session for save
            } else {
                currentUser = CookieFactory.getCookie('flexyBeauty-group-user'); //compare with group token cookie to allow admin mode

                if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin) {
                    $scope.ad.tokenAdmin = tokenAdmin;
                    $http.defaults.headers.common.Authorization = currentUser.token + "&" + WebPreLoaderData.companyCode; //use admin session for save
                } else {
                    currentUser = CookieFactory.getCookie('flexyBeauty-admin-user'); //compare with group admin cookie to allow admin mode

                    if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin) {
                        $scope.ad.tokenAdmin = tokenAdmin;
                        $http.defaults.headers.common.Authorization = currentUser.token + "&" + WebPreLoaderData.companyCode; //use admin session for save
                    }
                }
            }
        }

        $scope.loadAdminFunctions();
    }
}]);

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: sebastienbeaujard
* Date: 28/07/13
* Time: 09:22
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCartCtrl', ["$window", "$log", "$scope", "$filter", "$location", "$anchorScroll", "$routeParams", "HumanResourceData", "DaySrv", "AvailableTableView", "SiteData", "BookingView", "ServiceView", "ImageData", "$timeout", "SaleView", "DateSrv", "gettextCatalog", "CureItemData", "CureItemSrv", "moment", function ($window, $log, $scope, $filter, $location, $anchorScroll, $routeParams, HumanResourceData, DaySrv, AvailableTableView, SiteData, BookingView, ServiceView, ImageData, $timeout, SaleView, DateSrv, gettextCatalog, CureItemData, CureItemSrv, moment) {

    $scope.dd = {
        view: {
            displayError: false,
            waitServerResponse: false,
            errorMessage: '',
            warningBookingWeek: false,
            urlServiceMode: false,
            urlHrMode: false,
            cureDisplayError: false
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentServiceView)
            {
                if ($routeParams.serviceId) {
                    var serviceId = parseInt($routeParams.serviceId);
                    var serviceView = $scope.getServiceViewById(serviceId);
                    if (serviceView) {
                        if ($scope.ad.view.currentBookingView) //RESET
                            $scope.ad.view.currentBookingView = null;
                        $scope.addBookingServiceViewDirect(serviceView);
                        $scope.dd.view.urlServiceMode = true;
                    }

                    if ($routeParams.hrMail && $routeParams.hrMail != '') {
                        var hrView = $scope.getHrView(HumanResourceData.getByEmail($routeParams.hrMail));

                        if (hrView) $scope.dd.view.urlHrMode = true;
                        if ($scope.ad.view.currentBookingView != null) {
                            if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView) {
                                $scope.removeSelectedTime();
                                $scope.ad.view.aTableView = null;
                                $scope.ad.view.currentBookingView.date = new Date();
                            }
                            var isNextWeek = true;
                            DaySrv.getAvailablePeriods(new Date(), 7, isNextWeek, function (loadedDays, hrSelected, nextDay) {
                                $scope.afterGetAvailablePeriods(loadedDays, hrView, nextDay, isNextWeek);
                            });
                        }
                    } else {
                        if ($scope.ad.view.currentBookingView != null) {
                            if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView) {
                                $scope.removeSelectedTime();
                                $scope.ad.view.aTableView = null;
                                $scope.ad.view.currentBookingView.date = new Date();
                            }
                            DaySrv.getAvailablePeriods(new Date(), 7, true, $scope.afterGetAvailablePeriods);
                        }
                    }
                }
            }
    });

    $scope.addBookingServiceViewDirect = function (serviceView) {
        $scope.ad.view.currentServiceView = serviceView;

        if ($scope.ad.view.currentBookingView == null) $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
        var citsView = null;
        if ($scope.ad.view.customerView) citsView = $scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView(serviceView);
        if (citsView) $scope.addServiceOnBookingOnUserSelectCureItem(citsView);else {
            if ($scope.ad.view.currentSaleView && $scope.ad.view.currentBookingView) {
                $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
            }
            $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking($scope.ad.view.currentServiceView);
        }
    };

    $scope.afterGetAvailablePeriods = function (loadedDays, previousSelectedHr, nextAvailableDay, isNextWeek) {
        if (nextAvailableDay && nextAvailableDay !== $scope.ad.view.currentBookingView.date) {
            $scope.ad.view.currentBookingView.date = nextAvailableDay;
        }

        $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite, $scope);
        var availableHumanResources = [];
        var isAvailable = void 0;
        var dayHr = void 0;
        var hrId = void 0;

        for (var i = 0; i < $scope.ad.view.humanResourcesView.length; i++) {
            isAvailable = false;
            hrId = $scope.ad.view.humanResourcesView[i].getModel().id;
            for (var j = 0; j < loadedDays.length && !isAvailable; j++) {
                if (loadedDays[j]) {
                    dayHr = loadedDays[j].getDayHrByHrId(hrId);
                    if (dayHr && dayHr.availablePeriods && dayHr.availablePeriods.length > 0) {
                        isAvailable = true;
                    }
                }
            }
            if (isAvailable) {
                availableHumanResources.push($scope.ad.view.humanResourcesView[i]);
            }
        }

        if ($scope.ad.adminEdition && !$scope.ad.view.currentBookingServiceView.getModel()) {
            $scope.humanResourcesViewSelectable = availableHumanResources;
        } else if ($scope.ad.view.currentBookingView) {
            $scope.humanResourcesViewSelectable = $scope.ad.view.currentBookingView.getHumanResourcesViewWhoKnow(availableHumanResources); //check hr who know
        }
        //Only one HR : hide "Without Preference" box and select hr
        if ($scope.ad.appAttributes.allowChooseHr && $scope.humanResourcesViewSelectable && $scope.humanResourcesViewSelectable.length === 1 && $scope.ad.view.currentBookingView != null) {
            $scope.ad.view.aTableView.selected.humanResourceView = $scope.humanResourcesViewSelectable[0];
        } else {
            if (previousSelectedHr && ($scope.dd.view.urlHrMode || $scope.humanResourcesViewSelectable.indexOf(previousSelectedHr) !== -1)) {
                $scope.ad.view.aTableView.selected.humanResourceView = previousSelectedHr;
            }
        }
        $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);

        if ($scope.ad.appAttributes.discountDays) {
            $scope.ad.view.aTableView.setByDiscountDays($scope.ad.appAttributes.discountDays);
        }

        if ($scope.ad.view.aTableView && !$scope.ad.view.aTableView.selected.hasAvailability) {
            isNextWeek = isNextWeek === undefined ? true : isNextWeek;
            var currentMonday = moment(new Date()).day(1);
            if (moment($scope.ad.view.currentBookingView.date).isSameOrAfter(currentMonday, 'day')) {
                $scope.displayWeek(isNextWeek);
            }
        }
    };

    $scope.getClassForSelectedHumanResource = function (humanRessourceView, className) {
        if ($scope.isTheSelectedHumanResource(humanRessourceView)) return className;
        return "";
    };

    $scope.getClassForAllowBooking = function (className) {
        if ($scope.ad.view.aTableView != null && $scope.ad.view.aTableView.selected.aTimeView != null) return className;
        return "";
    };

    $scope.isTheSelectedHumanResource = function (humanRessourceView) {
        if ($scope.ad.view.aTableView != null && humanRessourceView === $scope.ad.view.aTableView.selected.humanResourceView) return true;else return false;
    };

    $scope.setSelectedHumanResource = function (humanRessourceView) {
        if ($scope.ad.view.currentBookingView != null && $scope.ad.view.aTableView && $scope.ad.view.aTableView.selected) {
            $scope.ad.view.aTableView.selected.humanResourceView = humanRessourceView;
            $scope.ad.view.aTableView.selected.aSlotView = null;
            $scope.ad.view.aTableView.selected.aTimeView = null;
            $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);
        }
    };

    $scope.displayWeek = function (next) {
        var numberDaysOfWeek = 7;
        if ($scope.ad.view.currentBookingView != null) {
            var date = new Date($scope.ad.view.currentBookingView.date);
            if (next) {
                date.setDate(date.getDate() + numberDaysOfWeek);
            } else {
                date.setDate(date.getDate() - numberDaysOfWeek);
            }

            var currentDate = new Date();
            if (DateSrv.daysBetween(date, currentDate) > numberDaysOfWeek * $scope.ad.appAttributes.nbBookingWeeks) {
                $scope.dd.view.warningBookingWeek = true;
            } else {
                var day = currentDate.getDay();
                var dayOfWeekDiff = day === 0 ? -6 : 1;
                if (moment(date).isSameOrAfter(moment(currentDate).day(dayOfWeekDiff), 'day')) {
                    $scope.dd.view.warningBookingWeek = false;
                    $scope.ad.view.currentBookingView.date = date;
                    var selectedHr = null;
                    if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && ($scope.dd.view.urlHrMode || $scope.ad.appAttributes.allowChooseHr)) {
                        //preserve hr selection when go to next week
                        selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                    }
                    $scope.ad.view.aTableView = null;
                    $scope.humanResourcesViewSelectable = [];
                    DaySrv.getAvailablePeriods(date, numberDaysOfWeek, next, function (loadedDays, hrSelected, nextDay) {
                        $scope.afterGetAvailablePeriods(loadedDays, selectedHr, nextDay, next);
                    });
                }
            }
        }
    };

    $scope.setSelectedSlotAndTime = function (aDayView, aSlotView, aTimeView) {
        $scope.setSelectedSlot(aDayView, aSlotView, true);
        $scope.setSelectedTime(aTimeView);
    };

    $scope.setSelectedSlot = function (aDayView, aSlotView, force) {
        if ($scope.ad.view.currentBookingView != null && aDayView != null && aSlotView && aSlotView.aTimesView.length > 0) {
            if (force !== undefined && force || $scope.ad.view.aTableView.selected.aSlotView !== aSlotView) {
                $scope.ad.view.currentBookingView.date = aDayView.date;
                $scope.ad.view.currentBookingView.aDayView = aDayView;
                $scope.ad.view.aTableView.selected.aSlotView = aSlotView;
            } else $scope.ad.view.aTableView.selected.aSlotView = null;
        }
    };

    $scope.removeSelectedTime = function () {
        if ($scope.ad.view.currentBookingView != null) {
            if ($scope.ad.view.aTableView.selected.aTimeView) //remove
                for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
                    $scope.ad.view.currentBookingView.bookingServicesView[i].updateService(); //restore price if time discout
                }
        }
        $scope.ad.view.aTableView.selected.aTimeView = null;
    };

    $scope.handleBookingServiceHrRequest = function (bookingServiceView) {
        var requestedHr = $scope.ad.view.aTableView.selected.humanResourceView;
        bookingServiceView.hrRequest = requestedHr && $scope.ad.appAttributes.allowChooseHr;
        bookingServiceView.subBsView.forEach(function (subBookingServiceView) {
            return subBookingServiceView.hrRequest = bookingServiceView.hrRequest;
        });
    };

    $scope.setSelectedTime = function (aTimeView) {
        if ($scope.ad.view.currentBookingView != null && aTimeView) {
            $scope.ad.view.aTableView.selected.aTimeView = aTimeView;
            $scope.ad.view.currentBookingView.moveToStart(aTimeView.period.start);

            $scope.ad.view.currentBookingView.bookingServicesView.forEach(function (bookingServiceView) {
                bookingServiceView.updateService();
                $scope.handleBookingServiceHrRequest(bookingServiceView);
                if ($scope.ad.view.aTableView.selected.aSlotView) {
                    bookingServiceView.addDiscount($scope.ad.view.aTableView.selected.aSlotView.discount);
                }
            });

            //scroll to verification time
            if ($(document).scrollTop() != 0) $timeout( //use timeout to allow angular to render view
            function () {
                $('html, body').animate({
                    scrollTop: $("#time-selected").offset().top
                }, 500);
            }, 100);
        }
    };

    $scope.checkOut = function () {
        if ($scope.ad.view.currentBookingView != null && $scope.ad.view.currentBookingView.aDayView && $scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && $scope.ad.view.aTableView.selected.aTimeView != null) {

            if ($scope.ad.view.currentBookingView.aDayView.setResourcesOnBooking($scope.ad.view.currentBookingView)) {
                if (!$scope.ad.view.currentSaleView) {
                    $scope.ad.view.currentSaleView = new SaleView(null, -1, null, $scope.ad.view.currentBookingView, $scope.ad.view);
                    $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                }
                $scope.openLocation("checkout");
            } else {
                $scope.ad.view.errorMessage = gettextCatalog.getString("Vous devez sélectionner une date pour votre réservation");
                var selectedHr = null;
                if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && ($scope.dd.view.urlHrMode || $scope.ad.appAttributes.allowChooseHr)) {
                    selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                }
                var date = $scope.ad.view.currentBookingView.date;
                $scope.removeSelectedTime();
                $scope.ad.view.aTableView = null;
                $scope.ad.view.currentBookingView.date = null;

                var isNextWeek = true;
                DaySrv.getAvailablePeriods(date, 7, isNextWeek, function (loadedDays, hrSelected, nextDay) {
                    $scope.afterGetAvailablePeriods(loadedDays, selectedHr, isNextWeek);
                });
            }
        } else {
            $scope.ad.view.errorMessage = gettextCatalog.getString("Vous devez sélectionner une date pour votre réservation");
        }
    };

    $scope.checkIfCureItemServicesIsUsedAndCheckOut = function (currentBookingView) {
        var cureItemsService = currentBookingView.getCureItemsService();
        CureItemSrv.checkCureItemServiceIsUsed(cureItemsService, function (data) {
            var cureItemServices = data.cureItemServices;
            if (cureItemServices != null && cureItemServices.length > 0) {
                for (var i = 0; i < currentBookingView.bookingServicesView.length; i++) {
                    for (var j = 0; j < cureItemServices.length; j++) {
                        if (currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId === cureItemServices[j].cureItemId) {
                            currentBookingView.bookingServicesView[i].price = currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.price;
                            $scope.ad.view.currentBookingView.price += currentBookingView.bookingServicesView[i].price;
                        }
                    }
                }
            }
            $scope.checkOut();
        }, function (data) {
            if (data == null || data.status == null || data.status !== "200") {
                $scope.dd.view.serverAlert = true;
            }
        });
    };

    $scope.afterSaveCurrentBooking = function (bookingRes) {
        $scope.dd.view.waitServerResponse = false;
        $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
        $scope.ad.view.currentBookingView = null;
        if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId != '') {
            var dataLayer = $window.dataLayer = $window.dataLayer || [];
            dataLayer.push({ event: 'page_change',
                attributes: {
                    route: '/rendezvous/finalise'
                }
            });
        }

        if (typeof analytics !== 'undefined' && analytics) analytics.track("Booking Demo Signed Up");

        $scope.openLocation("account");
    };

    $scope.afterSaveError = function (errorMessage) {
        DaySrv.getAvailablePeriods(new Date(), 7, true, function () {
            $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite, $scope);
            $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);
            $scope.dd.view.waitServerResponse = false;
            $scope.ad.view.errorMessage = errorMessage; //$scope.openLocation("account");
        });
    };

    $scope.canBook = function () {
        if (!$scope.ad.view.currentBookingView) {
            return false;
        }
        if ($scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) && $scope.ad.appAttributes.hasBookingPayment) {
            if ($scope.ad.appAttributes.hasBookingPaymentAdvance) {
                return true;
            } else {
                return !$scope.hasMandatoryPayment();
            }
        } else {
            return true;
        }
    };

    $scope.clearErrorMessage = function () {
        if (!$scope.ad.view.currentBookingView || $scope.ad.view.currentBookingView && !$scope.ad.view.currentBookingView.bookingServicesView || $scope.ad.view.currentBookingView && $scope.ad.view.currentBookingView.bookingServicesView && $scope.ad.view.currentBookingView.bookingServicesView.length === 0) {
            $scope.ad.view.errorMessage = "";
        }
    };

    $scope.hasMandatoryPayment = function () {
        if ($scope.ad.appAttributes.hasBookingPaymentMandatory) return true;
        if ($scope.ad.appAttributes.hasBookingPaymentOnAmount && $scope.ad.view.currentBookingView.price > $scope.ad.appAttributes.bookingPaymentOnAmount) return true;
        for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
            if ($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView.hasMandatoryPayment) return true;
        }return false;
    };

    $scope.displayPreviousWeekButton = function () {
        return moment($scope.ad.view.currentBookingView.date).isAfter(new Date(), 'day');
    };

    //START CODE
    $scope.clearErrorMessage();
    if ($scope.ad.adminEdition) {
        if ($scope.ad.view.currentBookingView == null) $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope.$parent);
        console.log($scope.ad.view.currentBookingView);
        if ($scope.ad.view.currentBookingView.bookingServicesView.length == 0) {
            var serviceViewExample = new ServiceView(null, -1, null, $scope);
            serviceViewExample.label = "Exemple de prestation";
            serviceViewExample.price = 59;
            serviceViewExample.itnDurationD = 40;
            serviceViewExample.nbHrsNeeded = 0;
            var images = ImageData.getActiveList("");
            if (images && images.length != 0) serviceViewExample.imageDisplayed = images[0];
            $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking(serviceViewExample);
            //$scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);
        }
    }
    if ($scope.ad.view.currentBookingView != null && !$scope.dd.view.urlServiceMode) {
        if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView) {
            $scope.removeSelectedTime();
            $scope.ad.view.aTableView = null;
            $scope.ad.view.currentBookingView.date = new Date();
        }
        DaySrv.getAvailablePeriods(new Date(), 7, true, $scope.afterGetAvailablePeriods);
    }
}]);

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCategoryCtrl', ["$scope", "$rootScope", "$routeParams", "CategoryData", function ($scope, $rootScope, $routeParams, CategoryData) {
    $scope.dd = {
        currentCategoryId: parseInt($routeParams.categoryId)
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCategoryView)
            {
                var category = CategoryData.getById($scope.dd.currentCategoryId);
                if (category && category.isVisibleOnWebSite) {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentCategoryView($scope.ad.view.categoryRootView.getCategoryView(category), false);
                } else {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus ou n'est plus réservable.";
                }
            }
    });
}]);

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCheckOutCtrl', ["$log", "$scope", "$rootScope", "$window", "CustomerView", "CustomerSrv", "CustomerData", "Customer", "WebPreLoaderData", "Auth", "$timeout", "CookieFactory", "BookingData", "OptInOut", "gettextCatalog", "CureItemData", "CureItemSrv", "SalePaymentType", "BookingView", "SaleDelivery", "Constants", "WebsiteConstants", "bugsnag", function ($log, $scope, $rootScope, $window, CustomerView, CustomerSrv, CustomerData, Customer, WebPreLoaderData, Auth, $timeout, CookieFactory, BookingData, OptInOut, gettextCatalog, CureItemData, CureItemSrv, SalePaymentType, BookingView, SaleDelivery, Constants, WebsiteConstants, bugsnag) {

    //Categories.query($scope,false);
    mangoPay.cardRegistration.clientId = "flexybeauty";
    if ($scope.ad.applicationId == "bsiflexyprod") mangoPay.cardRegistration.baseURL = "https://api.mangopay.com";

    $scope.dd = {
        view: {
            productsOfServicesView: [],
            displayError: false,
            isSmsActivationCodeValidated: false,
            isSmsActivationCodeSent: false,
            smsActivationCode: null,
            cureDisplayError: false,
            waitServerResponse: false,
            errorMessage: null,
            errorStockMessage: null,
            emailErrorMessage: null,
            serverAlert: false,
            displayStep: 'connect', //1 / 2 / 3 /  4
            displayCantSendSms: false,
            cookieError: false,
            savingDone: false,
            errorFinal: false,
            loading: true,
            customerEmailConfirmation: "",
            emailConfirmation: "",
            isWithoutPayment: false,
            checkoutDisplaySteps: WebsiteConstants.checkoutDisplaySteps,
            process: {
                connect: {
                    active: true,
                    num: 1
                },
                sms: {
                    active: false,
                    num: 0
                },
                identity: {
                    active: true,
                    num: 2
                },
                card: {
                    active: false,
                    num: 0
                },
                emailValidation: {
                    active: false,
                    num: 0
                },
                recap: {
                    active: true,
                    num: 3
                }

            },
            card: {
                formValidity: {
                    displayError: false,
                    global: false,
                    number: false,
                    expiration: false,
                    cvx: false,
                    onChangeNumber: function onChangeNumber(number) {
                        this.number = false;
                        if (number && number.length == 16 && /^\d+$/.test(number)) this.number = true;
                        this.global = this.number && this.expiration & this.cvx;
                    },
                    onChangeExpiration: function onChangeExpiration(month, year) {
                        this.expiration = month != "00" && year != "00";
                        this.global = this.number && this.expiration & this.cvx;
                    },
                    onChangeCvx: function onChangeCvx(cvx) {
                        this.cvx = false;
                        if (cvx && cvx.length == 3 && /^\d+$/.test(cvx)) this.cvx = true;
                        this.global = this.number && this.expiration & this.cvx;
                    }
                },
                registrationInitialized: false,
                registerProcessing: false,
                data: {
                    cardNumber: "",
                    cardExpirationDateMonth: "00",
                    cardExpirationDateYear: "00",
                    cardCvx: "",
                    cardType: "CB_VISA_MASTERCARD"
                }
            }
        },
        smsActivationCodeSent: null,
        emailRegex: Constants.EMAIL
    };

    if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId != '') {
        var dataLayer = $window.dataLayer = $window.dataLayer || [];
        dataLayer.push({ event: 'page_change',
            attributes: {
                route: '/rendezvous/formulaire'
            }
        });
    }

    if (typeof analytics !== 'undefined' && analytics) {
        analytics.track("Booking Demo Signed Up Form");
    }

    $scope.initProcess = function () {
        var start = 2;
        $scope.dd.view.customerEmailConfirmation = $scope.ad.view.customerView.email;
        $scope.dd.view.emailErrorMessage = null;
        if ($scope.ad.customerConnected) {
            $scope.dd.view.process.connect.active = false;
            start = 1;
        }
        $scope.dd.view.process.identity.num = start;
        $scope.dd.view.process.recap.num = start + 1;

        if ($scope.ad.view.currentSaleView && !$scope.ad.view.currentBookingView) {
            $scope.dd.view.process.sms.active = false;
            $scope.dd.view.process.sms.num = 0;
            $scope.dd.view.process.recap.num = start + 1;
            $scope.addCartToProcess();
            $scope.addEmailValidationToProcessIfNeeded();
        } else {
            if ($scope.ad.view.currentSaleView && $scope.hasMandatoryPayment() || $scope.mustPayAdvance()) {
                $scope.addCartToProcess();
                $scope.addEmailValidationToProcessIfNeeded();
            } else {
                if ($scope.ad.subscriptionsStatus.bookingSmsSecurity && !$scope.ad.customerConnected) {
                    $scope.dd.view.process.sms.active = true;
                    $scope.dd.view.process.sms.num = start;
                    $scope.dd.view.process.identity.num = start + 1;
                    $scope.dd.view.process.recap.num = start + 2;
                }
            }
        }

        if ($scope.ad.view.currentSaleView) {
            $scope.ad.view.currentSaleView.calculateSaleFields();
        }
    };

    $scope.addCartToProcess = function () {
        $scope.dd.view.process.card.num = $scope.dd.view.process.recap.num + 1;
        if ($scope.dd.view.process.emailValidation.active) {
            $scope.dd.view.process.card.num += 1;
        }
        $scope.dd.view.process.card.active = true;
    };

    $scope.goToRegisterTab = function () {
        if ($scope.dd.view.process.sms.active) $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.sms;else $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
    };

    $scope.login = function () {
        //if (!$scope.ad.view.customerView.email)
        //$scope.ad.view.customerView.email ="m@m.fr";
        if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse) if ($scope.ad.view.customerView.canLoginOnWeb()) {
            $scope.dd.view.waitServerResponse = true;
            var customer = new Customer();
            if ($scope.ad.view.customerView.login && $scope.ad.view.customerView.login != '') if ($scope.ad.view.customerView.login.indexOf("@") != -1) //email
                customer.email = $scope.ad.view.customerView.login;else customer.phone = $scope.ad.view.customerView.login;
            customer.password = $scope.ad.view.customerView.password;
            Auth.loginToWebSite(WebPreLoaderData.companyCode, customer, function () {
                //Success login get Customer data from it

                CustomerSrv.getData(customer, $scope.afterLoginSuccess, $scope.afterLoginError);
            }, $scope.afterLoginError);
        } else $scope.dd.view.displayError = true;
    };

    $scope.validateSmsActivationCode = function () {
        if ($scope.dd.smsActivationCodeSent == $scope.dd.view.smsActivationCode) {
            $scope.dd.view.isSmsActivationCodeValidated = true;
            $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
            $scope.dd.view.displayError = false;
            $scope.ad.view.customerView.isVerified = true;
        } else $scope.dd.view.displayError = true;
    };

    $scope.register = function () {
        if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse) if ($scope.ad.view.customerView.canRegisterOnWeb(true)) {
            $scope.dd.view.waitServerResponse = true;
            var customer = new Customer();
            $scope.ad.view.customerView.copyDataTo(customer);

            customer.optInOut = new OptInOut({
                isSmsCampaignAllowed: $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed,
                isEmailCampaignAllowed: $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed,
                isNotificationCampaignAllowed: $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed
            });

            Auth.registerToWebSite(customer, WebPreLoaderData.companyCode, $scope.afterLoginSuccess, $scope.afterLoginError);
        } else $scope.dd.view.displayError = true;
    };

    $scope.updateCustomer = function () {
        if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse) if ($scope.ad.view.customerView.canRegisterOnWeb(false)) {
            $scope.dd.view.waitServerResponse = true;
            $scope.ad.view.customerView.updateModel(true, function () {
                $scope.dd.view.waitServerResponse = false;
                $scope.dd.view.errorMessage = null;
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
            });
        } else $scope.dd.view.displayError = true;
    };

    $scope.afterLoginSuccess = function (customer) {
        $scope.dd.view.waitServerResponse = false;
        $scope.dd.view.errorMessage = null;
        if (customer != null) {
            $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
            $scope.ad.view.customerView.loadDataFrom(customer);
            CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function () {
                if ($scope.ad.view.currentBookingView) $scope.ad.view.currentBookingView.bookingIndex = -1; //reinit because loadRelatedData clear index
                if ($scope.ad.view.currentSaleView) $scope.ad.view.currentSaleView.saleIndex = -1; //reinit  because loadRelatedData clear index
                $scope.ad.view.customerView.initHistoryView();
                if ($scope.ad.view.currentSaleView) {
                    $scope.ad.view.currentSaleView.updateLoyaltyCardItem(true);
                }
                if ($scope.ad.view.currentBookingView && $scope.ad.view.currentBookingView.bookingServicesView) {
                    $scope.ad.view.currentBookingView.updateBookingsServicesFromCustomerCures($scope.ad.view.customerView);
                }
                $scope.dd.view.loading = false;
                $scope.ad.view.customerView.password = null; //hide by security
                $scope.ad.customerConnected = true;
                if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                    alert("Vous devez indiquer un email dans 'Mon compte'");
                    return;
                }
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
            }, function () {
                $scope.ad.view.currentBookingView = null;
                $scope.ad.view.currentSaleView = null;
                $scope.dd.view.errorMessage = "Le système de paiement n'est pas disponible.";
                $scope.dd.view.loading = false;
            });
        }
    };

    $scope.getCardRegistration = function () {
        if ($scope.ad.view.currentSaleView) {
            $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.card;
            CustomerSrv.getCardRegistration($scope.ad.view.customerView.getModel(), function (cardRegistration) {
                if (cardRegistration) {
                    mangoPay.cardRegistration.init({
                        cardRegistrationURL: cardRegistration.cardRegistrationURL,
                        preregistrationData: cardRegistration.preregistrationData,
                        accessKey: cardRegistration.accessKey,
                        Id: cardRegistration.id
                    });
                    $scope.dd.view.card.registrationInitialized = true;
                }
            }, function (message) {
                console.log(message);
                bugsnag.notify("WebsiteCheckOut.getCardRegistration - cardRegistration failed", "error message: " + message, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                $scope.dd.view.errorMessage = gettextCatalog.getString("Une erreur est survenue lors de l'obtention du formulaire d'enregistrement de la carte. ");
            });
        }
    };

    $scope.paidCheckOutBooking = function (status) {
        if ($scope.ad.view.currentBookingView != null) {
            $scope.ad.view.currentSaleView.status = status;
            if ($scope.ad.view.currentSaleView.status == "advanceProcess") $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price * $scope.ad.appAttributes.bookingPaymentAdvancePercent / 100;else $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
            $scope.ad.view.currentSaleView.paymentsView = [];
            $scope.ad.view.currentSaleView.change = 0;
            $scope.ad.view.currentSaleView.payedPrice = 0;
            $scope.ad.view.currentSaleView.addPaymentView(SalePaymentType.CBONLINE.type);
            $scope.getCardRegistration();
            $scope.addCartToProcess();
            $scope.addEmailValidationToProcessIfNeeded();
        }
    };

    $scope.addEmailValidationToProcessIfNeeded = function () {
        if ($scope.ad.view.customerView.email && !$scope.isValidCustomerEmail()) {
            if (!$scope.dd.view.isWithoutPayment) {
                $scope.dd.view.process.emailValidation.num = $scope.dd.view.process.card.num;
                $scope.dd.view.process.card.num += 1;
            } else {
                $scope.dd.view.process.emailValidation.num = $scope.dd.view.process.recap.num + 1;
            }
            $scope.dd.view.process.emailValidation.active = true;
            $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.emailValidation;
        }
    };

    $scope.paidCheckOutGift = function () {
        if (isNaN($scope.ad.view.currentSaleView.price)) {
            $scope.dd.view.errorFinal = true;
            $scope.dd.view.waitServerResponse = false;
            $scope.ad.view.currentSaleView = null;
            $scope.ad.view.currentBookingView = null;
            $scope.dd.view.errorMessage = "Montant incorrect, impossible d'effectuer la transaction.";
        } else if ($scope.ad.view.currentSaleView != null && $scope.ad.view.currentSaleView.customerView != null) {
            if ($scope.ad.view.currentSaleView.price != 0) {
                if ($scope.ad.view.currentSaleView.delivery === "address" && !$scope.ad.view.currentSaleView.customerView.hasAddress()) {
                    $scope.dd.view.errorMessage = "L'adresse de livraison n'est pas correcte";
                    return;
                } else {
                    $scope.dd.view.errorMessage = null;
                }
                $scope.ad.view.currentSaleView.status = "soldProcess";
                $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
                $scope.ad.view.currentSaleView.paymentsView = [];
                $scope.ad.view.currentSaleView.change = 0;
                $scope.ad.view.currentSaleView.payedPrice = 0;
                $scope.ad.view.currentSaleView.addPaymentView(SalePaymentType.CBONLINE.type);
                $scope.getCardRegistration();
                $scope.addCartToProcess();
                $scope.addEmailValidationToProcessIfNeeded();
            } else {
                $scope.ad.view.currentSaleView.status = "sold";
                $scope.ad.view.currentSaleView.updateModel(null, function (data) {
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.savingDone = true;
                    $scope.dd.view.errorMessage = null;
                    $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                    $scope.ad.view.currentSaleView = null;
                    $scope.ad.view.currentBookingView = null;
                    $scope.openLocation("account");
                }, function (res) {
                    console.log(res);
                    if (res && res.data && res.data.errorCode == "40900") $scope.dd.view.errorMessage = "La vente a été refusée. Merci de charger à nouveau le site internet et d'essayer à nouveau.";else $scope.dd.view.errorMessage = "La transaction a été refusée.";
                    $scope.dd.view.errorFinal = true;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.ad.view.currentSaleView = null;
                    $scope.ad.view.currentBookingView = null;
                });
            }
        }
    };

    $scope.afterLoginError = function (errorCode, errorMessage) {
        console.log(errorMessage);
        $scope.dd.view.errorMessage = errorMessage;
        $scope.dd.view.waitServerResponse = false;
    };

    $scope.registerCard = function () {
        $scope.dd.view.errorMessage = null;
        if (!$scope.dd.view.card.formValidity.global) $scope.dd.view.card.formValidity.displayError = true;else {
            if (!$scope.dd.view.card.registrationInitialized || $scope.dd.view.waitServerResponse) {
                $timeout(function () {
                    $scope.dd.view.errorMessage = "Merci d'essayer à nouveau, le système de paiement n'était pas disponible.";
                }, 2000);
            } else {
                // Register card
                $scope.dd.view.waitServerResponse = true;
                var cardData = {
                    cardNumber: $scope.dd.view.card.data.cardNumber,
                    cardExpirationDate: $scope.dd.view.card.data.cardExpirationDateMonth + $scope.dd.view.card.data.cardExpirationDateYear,
                    cardCvx: $scope.dd.view.card.data.cardCvx,
                    cardType: "CB_VISA_MASTERCARD"
                };
                mangoPay.cardRegistration.registerCard(cardData, function (res) {
                    if (res.CardId) {
                        $scope.ad.view.currentSaleView.paymentCardId = res.CardId;
                        if ($scope.ad.view.currentBookingView) $scope.saveCurrentBooking();else $scope.commitSale();
                    } else {
                        $scope.dd.view.errorMessage = "Echec de validation. Merci d'essayer à nouveau.";
                        $scope.getCardRegistration();
                        $scope.dd.view.waitServerResponse = false;
                    }

                    $scope.$apply();
                }, function (res) {
                    // Handle error, see res.ResultCode and res.ResultMessage
                    switch (res.ResultCode) {
                        case "105101":
                            $scope.dd.view.errorMessage = "Numéro de carte invalide";
                            break;
                        case "105102":
                            $scope.dd.view.errorMessage = "Possesseur de la carte invalide";
                            break;
                        case "105103":
                            $scope.dd.view.errorMessage = "Code pin invalide";
                            break;
                        case "105104":
                            $scope.dd.view.errorMessage = "Code pin invalide";
                            break;
                        case "105202":
                            $scope.dd.view.errorMessage = "Numéro de carte invalide";
                            break;
                        case "105203":
                            $scope.dd.view.errorMessage = "Date d'expiration invalide";
                            break;
                        case "105204":
                            $scope.dd.view.errorMessage = "Code sécurité invalide";
                            break;
                        default:
                            $scope.dd.view.errorMessage = res.ResultCode + " " + res.ResultMessage + " - " + gettextCatalog.getString("Contactez le support") + " " + ".";
                    }
                    $scope.dd.view.waitServerResponse = false;
                    $scope.$apply();
                });

                //Generate barcode if needed
                var giftItemView;
                if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.giftItemsView.length != 0) {
                    giftItemView = $scope.ad.view.currentSaleView.giftItemsView[0];
                    $scope.ad.view.currentSaleView.giftItemsView[0].updateModel(true, function () {
                        var elm = $("#barcode");
                        if (elm && elm[0]) {
                            giftItemView.updateFromModel();
                            var giftItem = giftItemView.getModel();
                            if (giftItem) {
                                elm.JsBarcode(giftItem.code, { format: "EAN", displayValue: false, fontSize: 16, height: 30 });
                                giftItemView.barcodeData = elm[0].currentSrc;
                            }
                        }
                    });
                }
            }
        }
    };

    $scope.commitSale = function () {
        if ($scope.ad.view.currentSaleView) {
            if ($scope.ad.view.currentSaleView.paymentCardId) {
                $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                $scope.dd.view.savingDone = false;
                $scope.dd.view.waitServerResponse = true;
                $scope.ad.view.currentSaleView.updateModel(null, function (data) {
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.savingDone = true;
                    $scope.dd.view.errorMessage = null;
                    if (data.sales && data.sales.length == 1) {

                        var sale = data.sales[0];
                        if (sale.resultPayIn) {
                            if (sale.resultPayIn.secureModeRedirectURL && sale.resultPayIn.secureModeRedirectURL != '') {
                                $scope.dd.view.errorMessage = "Redirection vers site 3D secure";
                                $window.open(sale.resultPayIn.secureModeRedirectURL, "_self");
                            } else {
                                if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.bookingView && $scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId != '') ga('send', 'pageview', '/rendezvous/finalise');
                                if (typeof analytics !== 'undefined' && analytics) analytics.track("Booking Demo Signed Up");

                                $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                                $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                                $scope.ad.view.currentSaleView = null;
                                $scope.ad.view.currentBookingView = null;
                                if (sale.resultPayIn.status == "FAILED") {
                                    $scope.dd.view.errorMessage = "La transaction a été refusée par la banque. Merci de vérifier vos autorisations de paiement par Internet";
                                    $scope.dd.view.errorFinal = true;
                                } else if (sale.resultPayIn.status == "CURRENCY_ERROR") {
                                    $scope.dd.view.errorMessage = "La transaction a rencontrée un problème. Merci de contacter le propriétaire du site web.";
                                    $scope.dd.view.errorFinal = true;
                                } else {
                                    $scope.openLocation("account");
                                }
                            }
                        } else {
                            $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                            $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                            $scope.ad.view.currentSaleView = null;
                            $scope.ad.view.currentBookingView = null;
                            $scope.dd.view.errorMessage = "La transaction a échoué suite à un problème technique.";
                            $scope.dd.view.errorFinal = true;
                        }
                    }
                }, function (res) {
                    console.log(res);
                    if (res && res.data && res.data.errorCode == "40900") $scope.dd.view.errorMessage = "La vente a été refusée. Merci de charger à nouveau le site internet et d'essayer à nouveau..";else $scope.dd.view.errorMessage = "La transaction a été refusée. Merci de vérifier vos autorisations de paiement par internet. Puis de charger à nouveau le site internet et d'essayer à nouveau.";
                    $scope.dd.view.errorFinal = true;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.ad.view.currentSaleView = null;
                    $scope.ad.view.currentBookingView = null;
                });
            } else $scope.dd.view.errorMessage = "La transaction a été refusée car votre carte n'a pas été validée.";
        }
    };

    $scope.removeSaleProductView = function (saleProductView) {
        if ($scope.ad.view.currentSaleView) {
            $scope.ad.view.currentSaleView.removeSaleProductView(saleProductView);
            if (!$scope.ad.view.currentSaleView.hasProductNotNull()) {
                $scope.ad.view.currentSaleView.setDelivery(null, true, 0);
                if ($scope.ad.view.currentSaleView.hasGiftItemEditionType("delivery") && $scope.ad.appAttributes.hasGiftItemDeliveryCharge) $scope.ad.view.currentSaleView.setDelivery("address", true, $scope.ad.appAttributes.giftItemDeliveryCharge);
            }
        }
    };

    $scope.changeProductQuantity = function (saleProductView, step) {
        $scope.dd.view.errorStockMessage = null;
        if (saleProductView.updateQuantity(step, false)) {
            if (saleProductView.quantity == 0) {
                $scope.removeSaleProductView(saleProductView);
            }
        } else $scope.dd.view.errorStockMessage = "Vous ne pouvez pas commander plus de produits car le stock est épuisé.";
    };

    $scope.onChangeCureQuantity = function (saleCureView) {
        saleCureView.onChangeQuantity();
        if (saleCureView.quantity == 0) $scope.ad.view.currentSaleView.removeSaleCureView(saleCureView);
    };

    $scope.removeGiftItemView = function (giftItemView) {
        if ($scope.ad.view.currentSaleView) {
            $scope.ad.view.currentSaleView.removeGiftItemView(giftItemView);
            if (!$scope.ad.view.currentSaleView.hasGiftItemEditionType("delivery")) {
                $scope.ad.view.currentSaleView.setDelivery(null, true, 0);
                if ($scope.ad.view.currentSaleView.hasProductNotNull() && $scope.ad.appAttributes.hasProductDeliveryCharge) $scope.ad.view.currentSaleView.setDelivery("address", true, $scope.ad.appAttributes.productDeliveryCharge);
            }
        }
    };

    $scope.cancel = function () {
        $scope.ad.view.currentSaleView = null;
        $scope.ad.view.currentBookingView = null;
        $scope.openLocation('home');
    };

    $scope.sendSmsActivationCode = function () {
        if (!$scope.ad.view.customerView || !$scope.ad.view.customerView.phone || $scope.dd.view.displayErrorPhoneNumber) {
            $scope.dd.view.displayError = true;
            return;
        }
        var customer = new Customer();
        $scope.ad.view.customerView.copyDataTo(customer);
        $scope.dd.view.waitServerResponse = true;
        $scope.dd.view.errorMessage = null;
        CustomerSrv.sendSmsActivationCode(customer, function (smsActivationCodeSent) {
            //success sent
            $scope.dd.smsActivationCodeSent = smsActivationCodeSent;
            console.log($scope.dd.smsActivationCodeSent);
            $scope.dd.view.isSmsActivationCodeSent = true;
            $scope.dd.view.waitServerResponse = false;
            $scope.dd.view.displayError = false;
            var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
            if (smsTries) {
                smsTries.nb++;
                smsTries.date = new Date();
                CookieFactory.setCookie('flexyBeauty-smsTries', smsTries);
                if (smsTries.nb >= 3) $scope.dd.view.displayCantSendSms = true;
            }
        }, function (errorCode, errorMessage) {
            $scope.dd.view.isSmsActivationCodeSent = false;
            $scope.dd.view.waitServerResponse = false;
            $scope.dd.view.displayError = true;
            $scope.dd.view.errorMessage = errorMessage;
        });
    };

    $scope.afterSaveCurrentBooking = function (booking) {
        if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId != '') {
            gtag('event', 'pageview', {
                'event_category': 'View',
                'event_label': '/rendezvous/finalise'
            });
        }
        if (typeof analytics !== 'undefined' && analytics) analytics.track("Booking Demo Signed Up");
        $scope.dd.view.waitServerResponse = false;
        $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
        $scope.ad.view.currentBookingView = null;
        $scope.dd.view.savingDone = false;
        $scope.openLocation("account");
    };

    $scope.afterSaveError = function (errorCode, errorMessage) {
        $scope.dd.view.waitServerResponse = false;
        if (errorCode == "40900") {
            $scope.ad.view.errorMessage = errorMessage;
            if ($scope.ad.view.currentSaleView) {
                $scope.ad.view.currentSaleView.paymentsView = [];
                $scope.ad.view.currentSaleView.change = 0;
                $scope.ad.view.currentSaleView.payedPrice = 0;
            }
            $scope.openLocation("cart");
        }
        if (errorCode == "40000") {
            $scope.ad.view.errorMessage = errorMessage;
            $scope.ad.view.currentSaleView = null;
            $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
            $scope.openLocation("cart");
        } else {
            $scope.dd.view.errorMessage = errorMessage;
            $scope.getCardRegistration();
        }
    };

    $scope.afterSaveSuccess = function (bookingRes) {
        $scope.dd.view.waitServerResponse = false;
        $scope.dd.view.savingDone = true;
        $scope.dd.view.errorMessage = null;
        if (bookingRes && bookingRes.sale && bookingRes.sale.resultPayIn) {

            var sale = bookingRes.sale;
            if (sale.resultPayIn.secureModeRedirectURL && sale.resultPayIn.secureModeRedirectURL != '') {
                $scope.dd.view.errorMessage = "Redirection vers site 3D secure";
                $window.open(sale.resultPayIn.secureModeRedirectURL, "_self");
            } else {
                $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                $scope.ad.view.currentSaleView = null;
                $scope.ad.view.currentBookingView = null;
                $scope.openLocation("account");
            }
        } else {
            $scope.dd.view.errorMessage = "La transaction a été refusée par la banque. Merci de vérifier vos autorisations de paiement par Internet";
            $scope.getCardRegistration(); //renew card registration
        }
    };

    $scope.saveCurrentBookingWithoutSale = function () {
        if ($scope.ad.view.currentBookingView) {
            $scope.ad.view.currentBookingView.saleView = null;
            $scope.ad.view.currentSaleView = null;
            $scope.saveCurrentBooking();
        }
    };

    $scope.checkCureItemServicesAndCheckOut = function (successFunction) {
        var currentBookingView = $scope.ad.view.currentBookingView;
        if (!$scope.isValidCustomerEmail()) {
            $scope.dd.view.isWithoutPayment = true;
            $scope.addEmailValidationToProcessIfNeeded();
        } else {
            if (currentBookingView && currentBookingView.getCureItemsService() && $scope.needToCheckIfCureIsUsed(currentBookingView)) {
                var cureItemsService = currentBookingView.getCureItemsService();

                CureItemSrv.checkCureItemServiceIsUsed(cureItemsService, function (data) {
                    var cureItemServices = data.cureItemServices;
                    if (cureItemServices != null && cureItemServices.length > 0) {
                        for (var i = 0; i < currentBookingView.bookingServicesView.length; i++) {
                            for (var j = 0; j < cureItemServices.length; j++) {
                                if (currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId === cureItemServices[j].cureItemId) {
                                    $scope.dd.view.cureDisplayError = true;
                                }
                            }
                        }
                        if (!$scope.dd.view.cureDisplayError) {
                            if (successFunction != undefined) successFunction();
                        }
                    } else if (successFunction != undefined) {
                        successFunction();
                    }
                }, function (data) {
                    if (data == null || data.status == null || data.status !== "200") {
                        $scope.dd.view.serverAlert = true;
                    }
                });
            } else if (successFunction != undefined) {
                successFunction();
            }
        }
    };

    $scope.needToCheckIfCureIsUsed = function (currentBookingView) {
        var needToCheckIfCureIsUsed = false;

        if (currentBookingView) {
            for (var i = 0; i < currentBookingView.bookingServicesView.length; i++) {

                var serviceIdFromBooking = currentBookingView.bookingServicesView[i].serviceView.serviceId,
                    servicePrice = currentBookingView.bookingServicesView[i].price;

                if (currentBookingView.bookingServicesView[i].cureItemToServiceUsageView && servicePrice === 0) {
                    var serviceIdFromCureItem = currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.serviceId;
                    if (serviceIdFromBooking === serviceIdFromCureItem) {
                        needToCheckIfCureIsUsed = true;
                        break;
                    }
                }
            }
        }
        return needToCheckIfCureIsUsed;
    };

    $scope.saveCurrentBooking = function () {
        $scope.dd.view.waitServerResponse = true;
        $scope.dd.view.savingDone = false;
        if ($scope.ad.view.currentBookingView && $scope.ad.view.currentBookingView.canBook()) {
            if ($scope.ad.view.currentSaleView) {
                var ssView;
                $scope.ad.view.currentSaleView.saleServicesView = [];
                for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
                    if (!$scope.ad.view.currentBookingView.bookingServicesView[i].cureItemToServiceUsageView) {
                        ssView = $scope.ad.view.currentSaleView.addBookingServiceOnSale($scope.ad.view.currentBookingView.bookingServicesView[i]);
                        if (ssView) {
                            //Set hr view on sale
                            if (!$scope.ad.view.currentBookingView.bookingServicesView[i].isPackage && $scope.ad.view.currentBookingView.bookingServicesView[i].aDayHrView) {
                                ssView.hrView = $scope.ad.view.currentBookingView.bookingServicesView[i].aDayHrView.hrView;
                            } else if ($scope.ad.view.currentBookingView.bookingServicesView[i].isPackage) {
                                for (var j = 0; j < ssView.subSaleServicesView.length; j++) {
                                    if ($scope.ad.view.currentBookingView.bookingServicesView[i].subBsView[j].aDayHrView && ssView.subSaleServicesView[j].serviceView.nbHrsNeeded) ssView.subSaleServicesView[j].hrView = $scope.ad.view.currentBookingView.bookingServicesView[i].subBsView[j].aDayHrView.hrView;
                                }
                            }
                        }
                    }
                }$scope.ad.view.currentSaleView.calculateVatLines();
                $scope.ad.view.currentBookingView.updateModel($scope.afterSaveSuccess, $scope.afterSaveError);
            } else $scope.ad.view.currentBookingView.updateModel($scope.afterSaveCurrentBooking, $scope.afterSaveError);
        }
    };

    $scope.saveCurrentCustomer = function () {
        $scope.dd.view.waitServerResponse = true;
        if ($scope.customerView) $scope.customerView.updateModel(true, $scope.afterSaveCurrentCustomer);
    };

    $scope.afterSaveCurrentCustomer = function () {
        $scope.currentCustomerFilled = true;
        $scope.dd.view.waitServerResponse = false;
    };

    $scope.hasMandatoryPayment = function () {
        if ($scope.ad.appAttributes.hasBookingPaymentMandatory) return true;
        if ($scope.ad.appAttributes.hasBookingPaymentOnAmount && $scope.ad.view.currentBookingView.price >= $scope.ad.appAttributes.bookingPaymentOnAmount) return true;
        for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
            if ($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView.hasMandatoryPayment) return true;
        }return false;
    };

    $scope.canBookWithoutPay = function () {
        if (!$scope.ad.view.currentBookingView) {
            return false;
        }
        if (!$scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) || !$scope.ad.appAttributes.hasBookingPayment) {
            return true;
        }
        //if cure exist can book without pay
        if ($scope.ad.view.currentBookingView.bookingServicesView.length == 1 && $scope.ad.view.currentBookingView.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[0].serviceView)) {
            return true;
        } else {
            return !$scope.hasMandatoryPayment();
        }
    };

    $scope.mustPayAdvance = function () {
        if (!$scope.ad.view.currentBookingView) {
            return false;
        }
        if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.hasItemsOtherThanService()) {
            return false;
        }
        if ($scope.ad.view.currentBookingView.bookingServicesView.length == 1 && $scope.ad.view.currentBookingView.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[0].serviceView)) {
            return false;
        }
        if ($scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) && $scope.ad.appAttributes.hasBookingPayment) {
            return $scope.ad.appAttributes.hasBookingPaymentAdvance && $scope.hasMandatoryPayment();
        } else {
            return false;
        }
    };

    $scope.start = function () {
        if (!$scope.ad.view.currentBookingView && !$scope.ad.view.currentSaleView) {
            $scope.openLocation("home");
            return;
        }

        if ($scope.ad.subscriptionsStatus.bookingSmsSecurity) {
            var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
            if (smsTries) {
                var now = new Date();
                var lastTry = new Date(smsTries.date);
                if (now - lastTry.getTime() < 1000 * 60 * 60 * 24) //less than one day
                    {
                        if (smsTries.nb >= 3) //last try was less than one day and 3 tries
                            $scope.dd.view.displayCantSendSms = true;
                    } else {
                    smsTries.nb = 0; //more than one day : reset to 0
                    CookieFactory.setCookie('flexyBeauty-smsTries', smsTries);
                }
            } else {
                CookieFactory.setCookie('flexyBeauty-smsTries', { nb: 0, date: new Date() }); //check that cookie can be saved
                smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
                if (!smsTries) {
                    $scope.dd.view.displayCantSendSms = true;
                    $scope.dd.view.cookieError = true;
                }
            }
        }

        if (!$scope.ad.view.customerView) {
            $scope.ad.view.customerView = new CustomerView();
            $scope.ad.view.customerView.domainView = $scope;
        }

        if ($scope.ad.view.currentBookingView) {
            if (!$scope.ad.view.currentBookingView.canBook()) {
                $scope.ad.view.currentBookingView = null;
                if ($scope.ad.view.currentSaleView) {
                    $scope.ad.view.currentSaleView.bookingView = null;
                    $scope.ad.view.currentSaleView.saleServicesView = [];
                }
            } else {
                $scope.ad.view.currentBookingView.customerView = $scope.ad.view.customerView;
                $scope.dd.view.productsOfServicesView = $scope.ad.view.currentBookingView.getProductsOfServices();
            }
        }

        if ($scope.ad.view.currentSaleView) $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
        // By default go to connect
        if ($scope.ad.view.customerView && $scope.ad.customerConnected) {
            if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
                $scope.dd.view.loading = false;
            } else {
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
                CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function () {
                    if ($scope.ad.view.currentBookingView) $scope.ad.view.currentBookingView.bookingIndex = -1; //reinit because loadRelatedData clear index
                    if ($scope.ad.view.currentSaleView) $scope.ad.view.currentSaleView.saleIndex = -1; //reinit  because loadRelatedData clear index
                    $scope.ad.view.customerView.initHistoryView();
                    if ($scope.ad.view.currentSaleView) $scope.ad.view.currentSaleView.updateLoyaltyCardItem(true);

                    $scope.dd.view.loading = false;
                }, function () {
                    $scope.ad.view.currentBookingView = null;
                    $scope.ad.view.currentSaleView = null;
                    $scope.dd.view.errorMessage = "Le système de paiement n'est pas disponible.";
                    $scope.dd.view.loading = false;
                });
            }
        } else $scope.dd.view.loading = false;

        $scope.initProcess();
    };

    $scope.displayIdentityStep = function () {
        $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
        $scope.dd.view.errorMessage = null;
    };

    $scope.isClickAndCollectMode = function () {
        var isClickAndCollectMode = false;
        if (!$scope.ad.appAttributes.hasProductDelivery) {
            $scope.ad.view.currentSaleView.setDelivery(SaleDelivery.SITE, true, $scope.ad.appAttributes.productDeliveryCharge);
            isClickAndCollectMode = true;
        } else if ($scope.ad.view.currentSaleView.delivery === SaleDelivery.SITE) {
            isClickAndCollectMode = true;
        }
        return isClickAndCollectMode;
    };

    $scope.saveCustomerAndContinuePaymentProcess = function () {
        $scope.ad.view.customerView.email = $scope.dd.view.customerEmailConfirmation;
        $scope.ad.view.customerView.updateModel(true, function () {
            if ($scope.dd.view.isWithoutPayment) {
                $scope.checkCureItemServicesAndCheckOut($scope.saveCurrentBookingWithoutSale());
            } else {
                $scope.getCardRegistration();
                $scope.addCartToProcess();
            }
            $scope.dd.view.process.emailValidation.active = false;
            $scope.dd.view.process.card.num -= 1;
            $scope.dd.view.emailErrorMessage = null;
        }, function () {
            $scope.dd.view.emailErrorMessage = gettextCatalog("Erreur durant la validation, veuillez réessayer.");
        });
    };

    $scope.canSaveCustomerEmail = function (event) {
        var canSaveCustomerEmail = void 0;
        if (!(event.$error.required || event.$error.pattern) && $scope.dd.view.customerEmailConfirmation === $scope.dd.view.emailConfirmation) {
            canSaveCustomerEmail = true;
        }
        return canSaveCustomerEmail;
    };

    $scope.start();
}]);

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteContactCtrl', ["$scope", "$rootScope", "$timeout", "CategoryData", function ($scope, $rootScope, $timeout, CategoryData) {
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCategoryView)
            {

                if ($scope.ad.appAttributes.displayFacebook) $timeout(function () {
                    if (window.FB) {
                        window.FB.XFBML.parse();
                    }
                }, 200);
            }
    });
}]);

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCtrl', ["$log", "$scope", "$location", "$http", "$timeout", "$window", "$anchorScroll", "$sce", "$dialog", "$filter", "$route", "$routeParams", "Loader", "Auth", "HumanResourceData", "PhysicalResourceData", "CategoryData", "SiteData", "CategoryView", "HumanResourceView", "PhysicalResourceView", "SiteView", "WebPreLoaderData", "CustomerSrv", "CustomerData", "CustomerView", "CompanyImageData", "ImageData", "AppData", "AppSrv", "App", "AppAttribute", "$spMenu", "SaleView", "BookingView", "CompanyImageSrv", "ServiceView", "VatData", "VatView", "ProductCategoryView", "ProductCategoryData", "CureCategoryView", "CureCategoryData", "LoyaltyCardCategoryView", "LoyaltyCardCategoryData", "ProductView", "CureView", "LoyaltyCardView", "AvailableTableView", "bugsnag", "DaySrv", "DateSrv", "WidgetView", "MobileDeviceSrv", "LanguageManager", "gettextCatalog", "PhoneFormat", "CurrencyManager", "CustomerPostSrv", "Countries", "MonitoringSrv", "MonitoringHealthState", "MonitoringApplication", "CureItemSrv", "CureItemData", "moment", "MeasureStore", "TimeMeasures", "Constants", "BasicAuthRole", "WebSiteSpecifications", "AppCode", "Brand", "OfferManager", "Images", "StoreAppCode", function ($log, $scope, $location, $http, $timeout, $window, $anchorScroll, $sce, $dialog, $filter, $route, $routeParams, Loader, Auth, HumanResourceData, PhysicalResourceData, CategoryData, SiteData, CategoryView, HumanResourceView, PhysicalResourceView, SiteView, WebPreLoaderData, CustomerSrv, CustomerData, CustomerView, CompanyImageData, ImageData, AppData, AppSrv, App, AppAttribute, $spMenu, SaleView, BookingView, CompanyImageSrv, ServiceView, VatData, VatView, ProductCategoryView, ProductCategoryData, CureCategoryView, CureCategoryData, LoyaltyCardCategoryView, LoyaltyCardCategoryData, ProductView, CureView, LoyaltyCardView, AvailableTableView, bugsnag, DaySrv, DateSrv, WidgetView, MobileDeviceSrv, LanguageManager, gettextCatalog, PhoneFormat, CurrencyManager, CustomerPostSrv, Countries, MonitoringSrv, MonitoringHealthState, MonitoringApplication, CureItemSrv, CureItemData, moment, MeasureStore, TimeMeasures, Constants, BasicAuthRole, WebSiteSpecifications, AppCode, Brand, OfferManager, Images, StoreAppCode) {

    console.time('globalLoading');

    if ("migration" === WebPreLoaderData.type && WebPreLoaderData.marketplaceUrl) {
        location.replace(WebPreLoaderData.marketplaceUrl);
    }

    MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME);

    gettextCatalog.debug = false;

    var bienvenue = gettextCatalog.getString("Bienvenue chez...");
    var tempUser = Auth.getCurrentUser();
    if (!tempUser) {
        var absUrl = $location.absUrl();
        var splitUrl = absUrl.split('/');
        tempUser = { token: splitUrl.pop() };
    }
    $scope.ad = {
        currentUser: tempUser,
        view: {
            bookingStatusImage: Images.saleStatus,
            domainView: $scope,
            vatsView: [],
            categoryRootView: null,
            productCategoryRootView: null,
            cureCategoryRootView: null,
            loyaltyCardCategoryRootView: null,
            customerView: null,
            currentCategoryView: null,
            currentProductCategoryView: null,
            currentCureCategoryView: null,
            currentLoyaltyCardCategoryView: null,
            cureDisplayError: false,
            currentServiceView: null,
            currentProductView: null,
            currentCureView: null,
            currentLoyaltyCardView: null,
            gTemplates: [],
            giftItemTypeSelected: "",
            giftItemMailImage: { urlPreview: "/img/exemplebon_mail.svg" },
            giftItemDeliveryImage: { urlPreview: "/img/exemplebon_box.svg" },
            giftItemPrintableImage: { urlPreview: "/img/exemplebon_print.svg" },
            templates: [],
            humanResourcesView: [],
            physicalResourcesView: [],
            currentBookingView: null,
            bookedBookingView: null, //booked
            currentSaleView: null,
            soldSaleView: null,
            homeItemsView: [],
            homeWidgetView: null,
            defaultWidgetView: null,
            homeGridWidgetsView: null,
            imagesServiceView: [],
            flexyFilteredImagesView: [],
            imagesCompanyView: [],
            imagesNoCustomer: [],
            imagesBgCompanyView: [],
            imagesGiftView: [],
            currentGiftItemImage: null,
            dialogWebSiteEditorCtrl: {
                subTab: 1
            },
            imagesAboutCompanyView: [],
            aTableView: null, //table of availabilities
            errorMessage: null, // by example return by server when saving
            currentBookingServiceView: null,
            currentParentCategoriesViewTree: [],
            siteView: null,
            servicesViewIndex: [], //Keep index
            productsViewIndex: [],
            curesViewIndex: [],
            searchedText: "",
            mobileHeaderCartVisible: false, //Manage display on mobile view of menu/cart
            mobileHeaderAccountVisible: false, //Manage display on mobile view of menu/account
            mobileHeaderSearchVisible: false,
            imagesBgTransparentView: [],
            imagesBgOpaqueView: [],
            adminEditPanelTab: 0,
            adminEditPanelDesignTab: 0,
            adminEditPanelDesignBgTab: 1,
            adminEditPanelDesignCreate: false,
            adminEditPanelPageTab: 0,
            adminEditPanelPageServiceTab: 1,
            adminEditPanelPageGiftTab: 1,
            logoImageUrl: null, //url to logo image
            homeTextEditPanel: false,
            logoEditPanel: false,
            logoEditPanelTab: 1,
            logoEditPanelFlowConfig: {
                target: '/rest/companyImageUpload',
                method: 'octet',
                query: { companyCode: WebPreLoaderData.companyCode, type: 'logo' },
                maxChunkRetries: 1,
                chunkRetryInterval: 10000,
                chunkSize: 1024 * 1024 * 5,
                simultaneousUploads: 1,
                singleFile: true,
                testChunks: false,
                headers: { Authorization: tempUser.token }
            },
            globalBgFlowConfig: {
                target: '/rest/companyImageUpload',
                method: 'octet',
                query: { companyCode: WebPreLoaderData.companyCode, type: 'background' },
                maxChunkRetries: 1,
                chunkRetryInterval: 10000,
                chunkSize: 1024 * 1024 * 5,
                simultaneousUploads: 1,
                singleFile: true,
                testChunks: false,
                headers: { Authorization: tempUser.token }
            },
            aboutFlowConfig: {
                target: '/rest/companyImageUpload',
                method: 'octet',
                query: { companyCode: WebPreLoaderData.companyCode, type: 'about' },
                maxChunkRetries: 1,
                chunkRetryInterval: 10000,
                chunkSize: 1024 * 1024 * 5,
                simultaneousUploads: 1,
                singleFile: true,
                testChunks: false,
                headers: { Authorization: tempUser.token }
            },
            giftItemsFlowConfig: {
                target: '/rest/companyImageUpload',
                method: 'octet',
                query: { companyCode: WebPreLoaderData.companyCode, type: 'giftItem' },
                maxChunkRetries: 1,
                chunkRetryInterval: 10000,
                chunkSize: 1024 * 1024 * 5,
                simultaneousUploads: 1,
                singleFile: true,
                testChunks: false,
                headers: { Authorization: tempUser.token }
            },
            menuEditPanel: false,
            loaded: false,
            isOnMobile: false,
            showMenuMobile: false,
            gridOptions: {
                cellHeight: 'auto',
                verticalMargin: 15,
                disableResize: true,
                disableDrag: true,
                auto: false,
                float: false
            },
            specialMenuVisible: false,
            fontOptions: [{ name: 'Abril', css: "'Abril Fatface', cursive", size: 100, padding_top: 0 }, { name: 'Arial', css: "Arial, Helvetica, sans-serif", size: 100, padding_top: 0 }, { name: 'Arvo', css: "'Arvo', serif", size: 90, padding_top: 0 }, { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif", size: 95, padding_top: 0 }, { name: 'Damion', css: "'Damion', cursive", size: 120, padding_top: 0 }, { name: 'Droid Sans', css: "'Droid Sans', sans-serif", size: 100, padding_top: 0 }, { name: 'Parisienne', css: "'Parisienne', cursive", size: 115, padding_top: 2 }, { name: 'Georgia', css: 'georgia, serif', size: 100, padding_top: 0 }, { name: 'IM Fell French', css: "'IM Fell French Canon', serif", size: 100, padding_top: 0 }, { name: 'Josefin', css: "'Josefin Slab', serif", size: 110, padding_top: 3 }, { name: 'Lato', css: 'Lato, sans-serif', size: 100, padding_top: 0 }, { name: 'Lucida Su', css: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', size: 95, padding_top: 0 }, { name: 'Open Sans', css: "'Open Sans', sans-serif", size: 95, padding_top: 0 }, { name: 'Old Standard', css: "'Old Standard TT', serif", size: 100, padding_top: 0 }, { name: 'Palatino', css: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", size: 100, padding_top: 2 }, { name: 'Playball', css: "'Playball', cursive ", size: 120, padding_top: 2 }, { name: 'Pinyon Script', css: "'Pinyon Script', cursive;line-height: 1.35", size: 120, padding_top: 3 }, { name: 'Times New Roman', css: "'Times New Roman', Times, serif", size: 105, padding_top: 0 }, { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif", size: 100, padding_top: 0 }, { name: 'Petit Formal S', css: "'Petit Formal Script', cursive", size: 90, padding_top: 2 }, { name: 'PT Sans', css: "'PT Sans', sans-serif", size: 100, padding_top: 0 }, { name: 'PT Serif', css: "'PT Serif', serif", size: 100, padding_top: 0 }, { name: 'Tahoma', css: 'Tahoma, Geneva, sans-serif', size: 100, padding_top: 0 }, { name: 'Tangerine', css: "'Tangerine', cursive;line-height: 0.9", size: 180, padding_top: 4 }, { name: 'Verdana', css: 'Verdana, Geneva, sans-serif', size: 90, padding_top: 0 }, { name: 'Vollkorn', css: "'Vollkorn', serif", size: 100, padding_top: 0 }],
            bithDateOptions: {
                startingDay: 1,
                showWeeks: false,
                datepickerMode: 'year',
                yearRange: 20,
                language: 'fr',
                format: 'dd/MM/yyyy'
            }
        },
        appAttributes: {
            homeDisplayType: "manual", //creative /  manual / default
            homeLabel: gettextCatalog.getString("Accueil"),
            displayAbout: false,
            aboutLabel: gettextCatalog.getString("Concept"),
            displayContact: false,
            contactLabel: gettextCatalog.getString("Contact"),
            displayServices: true,
            servicesLabel: gettextCatalog.getString("Prestations"),
            servicesProductsLabel: gettextCatalog.getString("Découvrez nos produits de qualité utilisés pour cette prestation"),
            servicesCuresLabel: gettextCatalog.getString("Découvrez nos forfaits qui proposent cette prestation"),
            displayProducts: false,
            productsLabel: gettextCatalog.getString("Produits"),
            displayCures: false,
            curesLabel: gettextCatalog.getString("Cures"),
            displayLoyaltyCards: false,
            loyaltyCardsLabel: gettextCatalog.getString("Fidélité"),
            displayCustomerPost: false,
            customerPostLabel: gettextCatalog.getString("Avis"),
            autoValidateCustomerPost: false,
            welcomePictureCustomerPost: true,
            giftsLabel: gettextCatalog.getString("Chèque cadeau"),
            giftItemMailImageId: "",
            giftItemDeliveryImageId: "",
            giftItemPrintableImageId: "",
            headerType: gettextCatalog.getString("default"),
            homeAbout: false,
            homeAboutSentence: gettextCatalog.getString("Découvrez notre salon"),
            homeOffer: true,
            homeOfferSentence: gettextCatalog.getString("Profitez de nos meilleures offres"),
            homeService: true,
            homeServiceSentence: gettextCatalog.getString("Réservez ou offrez des prestations"),
            homeCure: false,
            homeCureSentence: gettextCatalog.getString("Achetez des cures"),
            homeProduct: false,
            homeProductSentence: gettextCatalog.getString("Achetez des produits"),
            homeGiftItem: true,
            homeGiftItemSentence: gettextCatalog.getString("Offrez un chèque cadeau"),
            homeLoyaltyCard: false,
            homeLoyaltyCardSentence: gettextCatalog.getString("Prenez une carte de fidélité"),
            footerTime: true,
            footerAddress: true,
            footerMap: true,
            footerSocial: true,
            footerFacebook: null,
            footerTwitter: null,
            footerInstagram: null,
            footerPinterest: null,
            displayFacebook: false,
            facebookLabel: "",
            onlineBooking: false,
            allowChooseHr: false,
            allowBookingComment: false, //payment
            bookingCommentSentence: null,
            hasBookingPayment: true,
            hasBookingPaymentAdvance: false,
            bookingPaymentAdvancePercent: 10,
            hasBookingPaymentMandatory: true,
            hasBookingPaymentOnAmount: false,
            bookingPaymentOnAmount: 100,
            nbBookingWeeks: 12,
            nbBookingBeforeTime: 0,
            triesTime: 15,
            autoFilling: true,
            hasCurePayment: true,
            hasProductPayment: true,
            hasProductDelivery: true,
            hasProductDeliveryCharge: true,
            productDeliverySentence: gettextCatalog.getString("Vous recevrez vos produits dans un délai de 2 à 4 jours via Chronopost."),
            productDeliveryCharge: 5,
            hasLoyaltyCardPayment: true,
            hasGiftItem: false,
            hasServiceGift: false,
            hasGiftItemDelivery: true,
            giftItemDeliverySentence: gettextCatalog.getString("Vous recevrez votre bon cadeau dans un délai d'une semaine et vous pourrez l'offrir à la personne de votre choix."),
            hasGiftItemDeliveryCharge: false,
            giftItemDeliveryCharge: 5,
            hasGiftItemMail: true,
            minimalPlanningFilling: false,
            giftMonthValidity: 12,
            globalBgImageType: null,
            globalBgImage: "",
            globalBgImageSlides: [],
            globalBgImageUseSlide: false,
            globalBgImageOverlay: true,
            globalBgColor: "",
            footerBgColor: null,
            footerFontColor: null,
            globalObjectColor: null,
            globalObjectColorInserted: false,
            globalFontColor: "",
            globalFontFamilyInserted: false,
            globalFontFamily: null,
            logoFontColor: null,
            logoShadowColor: null,
            logoText: null,
            logoImageId: null,
            titleHomeLabel: gettextCatalog.getString("Carte des soins"),
            titleIsDisplayed: true,
            titleBgColorStart: "",
            titleBgColorEnd: "",
            titleFontColor: "",
            menuIsDisplayed: true,
            menuBgColorStart: "",
            menuBgColorEnd: "",
            menuFontColor: "",
            menuShadowColor: null,
            homeTextHtml: "<h2>" + bienvenue + "</h2><p>Votre description ...</p>",
            googleAnalyticsId: null,
            javascriptOnHeader: null,
            javascriptOnBody: null,
            cgvHtml: null,
            isBurgerOpen: false
        },
        subscriptionsStatus: {},
        activeOfferCode: WebPreLoaderData.activeOfferCode,
        startDate: null,
        dataLoaded: false,
        customerConnected: false,
        companyCode: WebPreLoaderData.companyCode,
        localeCode: WebPreLoaderData.localeCode === "null" ? null : WebPreLoaderData.localeCode,
        companyCountry: WebPreLoaderData.companyCountry,
        currencyCode: WebPreLoaderData.currencyCode === "null" ? null : WebPreLoaderData.currencyCode,
        currencySymbol: WebPreLoaderData.currencySymbol === "null" ? null : WebPreLoaderData.currencySymbol,
        currencyCodeIso: WebPreLoaderData.currencyCodeIso === "null" ? null : WebPreLoaderData.currencyCodeIso,
        applicationId: WebPreLoaderData.applicationId,
        nativeApp: null, //{token, os, osVersion}}
        tokenAdmin: null, //if defined the web site works in admin mode   defined by WebSiteAdminCtrl
        adminEdition: false,
        adminPanel: false,
        msgErrorService: "",
        msgErrorCategory: "",
        locationPath: $location.path(),
        dialog: {
            cure: false,
            product: false,
            giftItems: false,
            loyaltyCard: false,
            customerPost: false,
            contact: false,
            hour: false,
            payment: false,
            creative: false
        },
        subscriptions: WebPreLoaderData.subscriptionsStatus === "null" ? null : WebPreLoaderData.subscriptionsStatus,
        brand: Brand,
        offerManager: OfferManager,
        storeAppCode: StoreAppCode,
        type: WebPreLoaderData.type,
        marketplaceUrl: WebPreLoaderData.marketplaceUrl
    };
    $scope.isValidCustomerEmail = function () {
        var regex = new RegExp(Constants.EMAIL, 'i');
        return regex.test($scope.ad.view.customerView.email);
    };
    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.isFrenchLanguage = function () {
        return LanguageManager.isFrenchLanguage();
    };

    $scope.isFrenchLocation = function (country) {
        if (country === Countries.FRANCE.countryCode) {
            return true;
        } else {
            return false;
        }
    };

    $scope.getCurrencySymbol = function () {
        return CurrencyManager.getCurrencySymbol();
    };

    $scope.hasSubscriptionItem = function (itemCode) {
        var subscriptionsStatusIsActive = false;
        if (WebPreLoaderData.subscriptionsStatus) {
            for (var _i = 0; _i < WebPreLoaderData.subscriptionsStatus.length; _i++) {
                if (WebPreLoaderData.subscriptionsStatus[_i]) {
                    if (WebPreLoaderData.subscriptionsStatus[_i].storeAppCode === itemCode) {
                        subscriptionsStatusIsActive = WebPreLoaderData.subscriptionsStatus[_i].isActive;
                    }
                }
            }
        }
        return subscriptionsStatusIsActive;
    };

    $scope.$on('$routeChangeSuccess', function () {
        // $routeParams should be populated here
        if ($routeParams.nativeAppOsVersion && $routeParams.nativeAppOs) {
            $scope.ad.nativeApp = {
                os: $routeParams.nativeAppOs,
                osVersion: $routeParams.nativeAppOsVersion,
                token: null
            };

            if ($routeParams.nativeAppToken && $routeParams.nativeAppToken != undefined) $scope.ad.nativeApp.token = $routeParams.nativeAppToken;
        }
    });

    if (WebPreLoaderData.subscriptionsStatus) {
        for (var i = 0; i < WebPreLoaderData.subscriptionsStatus.length; i++) {
            $scope.ad.subscriptionsStatus[WebPreLoaderData.subscriptionsStatus[i].storeAppCode] = WebPreLoaderData.subscriptionsStatus[i].isActive;
        }console.log($scope.ad.subscriptionsStatus);
    }

    $scope.initBugsnag = function () {
        try {
            if (WebPreLoaderData.applicationId && WebPreLoaderData.version) {
                console.info("Initialisation of bugsnag");
                if (WebPreLoaderData.applicationId != "bsiflexyprod") bugsnag.releaseStage = "development";
                bugsnag.appVersion = WebPreLoaderData.version;
            }
            bugsnag.user = { id: WebPreLoaderData.companyCode };
        } catch (error) {
            console.error("Erreur during the initialisation of bugsnag");
            console.error(error);
        }
    };

    $scope.onChange = function (event, items) {};

    $scope.initLokalise = function () {
        try {
            if (LanguageManager.canAccessLiveEdit() && $scope.ad.tokenAdmin) {
                console.info("Initialisation of lokalise");
                window.LOKALISE_CONFIG = {
                    projectId: "625966535b44b267eeeae8.51499813",
                    locale: LanguageManager.getGetTextLocale()
                };
                (function () {
                    var a = document.createElement("script");
                    a.type = "text/javascript";
                    a.async = !0;
                    a.src = ["https://lokalise.co/live-js/script.min.js?", new Date().getTime()].join("");
                    document.body.appendChild(a);
                })();
            }
        } catch (error) {
            console.error("Erreur during the initialisation of lokalise");
            console.error(error);
        }
    };

    $scope.initFacebook = function () {
        try {
            console.info("Initialisation of facebook");
            window.fbAsyncInit = function () {
                FB.init({
                    appId: '635553289857009',
                    xfbml: true,
                    version: 'v2.3'
                });
            };
            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.async = true;
                if ($scope.ad.companyCountry == "" || $scope.ad.companyCountry == null) {
                    if ($scope.ad.languageCode && $scope.ad.languageCode != 'null' && $scope.ad.languageCode != "fr") {
                        js.src = "//connect.facebook.net/" + $scope.ad.languageCode + "_FR/all.js";
                    } else {
                        js.src = "//connect.facebook.net/fr_FR/all.js";
                    }
                } else {
                    if ($scope.ad.languageCode && $scope.ad.languageCode != 'null' && $scope.ad.languageCode != "fr") {
                        js.src = "//connect.facebook.net/" + $scope.ad.languageCode + "_" + $scope.ad.companyCountry + "/all.js";
                    } else {
                        js.src = "//connect.facebook.net/fr_" + $scope.ad.companyCountry + "/all.js";
                    }
                }
                fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'facebook-jssdk');
        } catch (error) {
            console.error("Erreur during the initialisation of facebook");
            console.error(error);
        }
    };

    //STARTING CODE
    Auth.init(false, WebPreLoaderData.companyCode);
    $scope.initBugsnag();

    Loader.loadWebData(WebPreLoaderData, function () {
        var afterLocalLoad = function afterLocalLoad() {
            try {
                CurrencyManager.set($scope.ad.currencySymbol, $scope.ad.currencyCode, $scope.ad.currencyCodeIso);
                DateSrv.doReload();
                $scope.ad.startDate = new Date();
                var vats = VatData.getActiveList();
                for (var i = 0; i < vats.length; i++) {
                    $scope.ad.view.vatsView.push(new VatView(vats[i], VatData.getIndexOf(vats[i])));
                }var humanResources = $filter('orderBy')(HumanResourceData.getActiveList(), 'order');
                for (var i = 0; i < humanResources.length; i++) {
                    if (humanResources[i].hasPlanning) $scope.ad.view.humanResourcesView.push(new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), this));
                }var physicalResources = $filter('orderBy')(PhysicalResourceData.getActiveList(), 'order');
                for (var i = 0; i < physicalResources.length; i++) {
                    $scope.ad.view.physicalResourcesView.push(new PhysicalResourceView(physicalResources[i], PhysicalResourceData.getIndexOf(physicalResources[i]), this));
                }$scope.ad.view.categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
                $scope.ad.view.currentCategoryView = $scope.ad.view.categoryRootView;
                $scope.ad.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
                $scope.ad.view.currentProductCategoryView = $scope.ad.view.productCategoryRootView;
                $scope.ad.view.cureCategoryRootView = new CureCategoryView(CureCategoryData.categoryRoot, CureCategoryData.getIndexOf(CureCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
                $scope.ad.view.currentCureCategoryView = $scope.ad.view.cureCategoryRootView;
                $scope.ad.view.loyaltyCardCategoryRootView = new LoyaltyCardCategoryView(LoyaltyCardCategoryData.categoryRoot, LoyaltyCardCategoryData.getIndexOf(LoyaltyCardCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
                $scope.ad.view.currentLoyaltyCardCategoryView = $scope.ad.view.loyaltyCardCategoryRootView;
                $scope.ad.view.homeItemsView = [];

                $scope.ad.view.siteView = new SiteView(SiteData.defaultSite);
                $scope.ad.view.imagesBgTransparentView = ImageData.getActiveList("webSiteBgTransparent");
                $scope.ad.view.imagesBgOpaqueView = ImageData.getActiveList("webSiteBgOpaque");
                $scope.ad.view.imagesServiceView = ImageData.getActiveList("");
                $scope.ad.view.imagesCompanyView = CompanyImageData.companyImages;
                $scope.ad.view.imagesAboutCompanyView = CompanyImageData.getActiveList("about");
                $scope.ad.view.imagesBgCompanyView = CompanyImageData.getActiveList("background");
                $scope.ad.view.imagesWithoutCustomer = CompanyImageData.getActiveListWithoutCustomerImages();

                $scope.ad.view.categoryRootView.loadProductsView();
                $scope.loadAppAttributes();
                $scope.initGoogleAnalyticsObject();
                $scope.initLokalise();

                $scope.redirectIfUnactiveStoreApp();

                $scope.ad.dataLoaded = true;
                $timeout(function () {
                    $scope.ad.view.loaded = true;
                }, 200);

                var setAttributeOnLiveEdit = function setAttributeOnLiveEdit() {
                    if ($('#lokalise-live-js-panel').is(':visible')) {
                        //if the container is visible on the page
                        $("#lokalise-live-js-panel").attr("websiteliveedit", true);
                    } else {
                        setTimeout(setAttributeOnLiveEdit, 50); //wait 50 ms, then try again
                    }
                };
                angular.element(document).ready(function () {
                    setAttributeOnLiveEdit();
                });

                console.timeEnd('globalLoading');

                MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                MonitoringSrv.logHealth(MonitoringApplication.WEBSITE, MonitoringHealthState.OK, JSON.stringify(MeasureStore));
            } catch (e) {
                MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                MonitoringSrv.logHealth(MonitoringApplication.WEBSITE, MonitoringHealthState.KO, JSON.stringify(MeasureStore));
            }
        };

        $scope.initFacebook();
        PhoneFormat.setLocalCountry($scope.ad.companyCountry);

        var afterConnexion = function afterConnexion() {
            $scope.addHeadersForMangopay();
            LanguageManager.initLanguageManager($scope.ad.localeCode).then(afterLocalLoad);
        };
        $scope.initConnexion(afterConnexion, afterConnexion);
    });

    $scope.unactiveStoreAppCodes = function () {
        var unactiveStoreAppCodes = [];
        var subscriptions = $scope.ad.subscriptions;
        if (subscriptions && subscriptions.length > 0) {
            for (var _i2 = 0; _i2 < subscriptions.length; _i2++) {
                if (!subscriptions[_i2].isActive) {
                    unactiveStoreAppCodes.push(subscriptions[_i2].storeAppCode);
                }
            }
        }
        return unactiveStoreAppCodes;
    };

    $scope.fetchProhibatedPaths = function () {
        var webSitePathByStoreAppCode = Constants.WEBSITE_PATH_BY_STORE_APP_CODE;
        var storeAppCodes = Object.keys(webSitePathByStoreAppCode);
        var unactiveStoreAppCodes = $scope.unactiveStoreAppCodes();
        var prohibatedPaths = [];

        for (var _i3 = 0; _i3 < storeAppCodes.length; _i3++) {
            if (unactiveStoreAppCodes.includes(storeAppCodes[_i3])) {
                var paths = webSitePathByStoreAppCode[storeAppCodes[_i3]];
                if (paths && paths.length) {
                    paths.forEach(function (path) {
                        return prohibatedPaths.push(path);
                    });
                }
            }
        }
        return prohibatedPaths;
    };

    $scope.urlWithoutCompanyCode = function () {
        var urlPaths = $location.url().split('/');
        if ($scope.ad.companyCode) {
            var companyCodeIndex = urlPaths.indexOf($scope.ad.companyCode);
            if (companyCodeIndex === -1) {
                companyCodeIndex = urlPaths.indexOf($scope.ad.companyCode + "#");
            }
            urlPaths.splice(0, companyCodeIndex + 1);
        }
        return urlPaths;
    };

    $scope.isRedirectionNeeded = function () {
        var urlPaths = $scope.urlWithoutCompanyCode();
        var prohibatedPaths = $scope.fetchProhibatedPaths();
        var isRedirectionNeeded = false;
        for (var _i4 = 0; _i4 < prohibatedPaths.length; _i4++) {
            if (urlPaths.includes(prohibatedPaths[_i4])) {
                isRedirectionNeeded = true;
            }
        }
        return isRedirectionNeeded;
    };

    $scope.redirectIfUnactiveStoreApp = function () {
        var isRedirectionNeeded = $scope.isRedirectionNeeded();
        if (isRedirectionNeeded) {
            $scope.openLocation('/home');
        }
    };

    $scope.removeGiftItemImageCompanyView = function (companyImage) {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/removeConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = companyImage.label;
                    return tableModel;
                } } },
            d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                var index = $scope.ad.view.imagesCompanyView.indexOf(companyImage);
                if (index !== -1) {
                    $scope.ad.view.imagesCompanyView.splice(index, 1);
                    CompanyImageSrv.remove(companyImage);
                }
            }
        });
    };

    $scope.initConnexion = function (successFunction, failureFunction) {
        if (!$scope.ad.nativeApp) {
            $.cookieBar({
                message: gettextCatalog.getString("En poursuivant votre navigation, vous acceptez l'utilisation de cookies."),
                acceptText: gettextCatalog.getString("J'ai compris"),
                acceptAnyClick: true
            });
        } else {
            //Manage special mobile mode during ios validation
            if (!$scope.ad.subscriptionsStatus.nativeApp) {
                if ($scope.ad.view.categoryRootView) $scope.ad.view.categoryRootView.initWebDisplay("array"); // force array displayType when nativeApp not set to true for allow apple validation
                if ($scope.ad.view.productCategoryRootView) $scope.ad.view.productCategoryRootView.initWebDisplay("array"); // force array displayType when nativeApp not set to true for allow apple validation
                if ($scope.ad.view.cureCategoryRootView) $scope.ad.view.cureCategoryRootView.initWebDisplay("array"); // force array displayType when nativeApp not set to true for allow apple validation
                $scope.ad.appAttributes.hasGiftItem = false; // hide for i
                $scope.ad.appAttributes.homeOffer = false;
                $scope.ad.appAttributes.homeCure = false;
                $scope.ad.appAttributes.homeProduct = false;
                $scope.ad.appAttributes.homeLoyaltyCard = false;
            }
        }

        if ($scope.ad.tokenAdmin) {
            $scope.ad.view.gridOptions.disableResize = false;
            $scope.ad.view.gridOptions.disableDrag = false;
            if (successFunction) successFunction();
        } else {
            if (!$route.current.params.token && !$route.current.params.id) {
                //not auto logging with a link
                var user = Auth.getCurrentUser();
                if (user) {
                    if (user.id) {
                        CustomerSrv.get(user.id, function (customer) {
                            $scope.afterGetCustomerWithSuccess(customer);
                            if (successFunction) successFunction();
                        }, function () {
                            CustomerSrv.getByEmail(user.email, function (customer) {
                                //success by mail
                                $scope.afterGetCustomerWithSuccess(customer);
                                if (successFunction) successFunction();
                            }, function () {
                                //error
                                //remove cookie and login Anonymous
                                console.log("login official error");
                                Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                                $scope.loginAnonymous(successFunction, failureFunction);
                            });
                        });
                    } else {
                        //Try by email
                        CustomerSrv.getByEmail(user.email, $scope.afterGetCustomerWithSuccess, //success by mail
                        function () {
                            //error
                            //remove cookie and login Anonymous
                            console.log("login official error");
                            Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                            $scope.loginAnonymous(successFunction, failureFunction);
                        });
                    }
                } else {
                    $scope.loginAnonymous(successFunction, failureFunction);
                }
            } else {
                $scope.ad.view.loaded = true;
                if (successFunction) successFunction();
            }
        }
    };

    $scope.initGoogleAnalyticsObject = function () {
        try {
            if ($scope.ad.appAttributes.googleAnalyticsId) {
                var gtag = function gtag() {
                    dataLayer.push(arguments);
                };

                console.info("Initialisation of googleAnalytics");
                var element = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + $scope.ad.appAttributes.googleAnalyticsId + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                var mover = angular.element(element);
                var body = angular.element(document).find('body').eq(0);
                body.append(mover);
                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', $scope.ad.appAttributes.googleAnalyticsId);

                window.dataLayer = window.dataLayer || [];

                gtag('js', new Date());
                gtag('config', $scope.ad.appAttributes.googleAnalyticsId);
            }
        } catch (error) {
            console.error("Erreur during the initialisation of googleAnalytics");
            console.error(error);
        }
    };

    $scope.afterGetCustomerWithSuccess = function (customer) {
        if ($scope.ad.nativeApp && $scope.ad.nativeApp.token) MobileDeviceSrv.setCustomer($scope.ad.nativeApp, customer.id);
        $scope.ad.view.customerView = new CustomerView();
        $scope.ad.view.customerView.domainView = $scope;
        $scope.ad.view.customerView.loadDataFrom(customer);
        $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
        $scope.ad.view.customerView.password = null; //hide by security
        $scope.ad.customerConnected = true;

        bugsnag.user = {
            id: WebPreLoaderData.companyCode,
            email: $scope.ad.view.customerView.email
        };
    };
    $scope.loginAnonymous = function (successFunction, failureFunction) {
        Auth.loginToWebSite(WebPreLoaderData.companyCode, null, function (res) {
            //Anonymous login
            $scope.ad.view.loaded = true;
            if (successFunction) successFunction();
        }, function (errorMessage) {
            $scope.processing = false;
            if (failureFunction) failureFunction();
        });
    };
    $scope.logout = function () {
        if ($scope.ad.customerConnected && $scope.ad.view.customerView) Auth.logoutFromWeb($scope.ad.view.customerView.getModel(), WebPreLoaderData.companyCode, function () {
            $scope.ad.customerConnected = false;
            $scope.ad.view.customerView = null;

            //$timeout($scope.loginAnonymous(), 0, false);
            $window.open("/" + WebPreLoaderData.companyCode + "/login", "_self");
        });
    };
    $scope.getDefaultVatTax = function () {
        for (var i = 0; i < $scope.ad.view.vatsView.length; i++) {
            if ($scope.ad.view.vatsView[i].isDefault) return $scope.ad.view.vatsView[i].tax;
        }return null;
    };
    $scope.getVatsView = function () {
        return $scope.ad.view.vatsView;
    };
    $scope.getDefaultVatView = function () {
        for (var i = 0; i < $scope.ad.view.vatsView.length; i++) {
            if ($scope.ad.view.vatsView[i].isDefault) return $scope.ad.view.vatsView[i];
        }
    };
    $scope.getVatView = function (vat) {
        for (var i = 0; i < $scope.ad.view.vatsView.length; i++) {
            if ($scope.ad.view.vatsView[i].getModel() === vat) return $scope.ad.view.vatsView[i];
        } // Not found : instanciate (could be a deleted)
        var vatView = new VatView(vat, VatData.getIndexOf(vat));
        if (!vat.isDeleted) $scope.ad.view.vatsView.push(vatView);
        return vatView;
    };
    $scope.getHrView = function (hr) {
        var hrView = null;
        if (hr) {
            for (var i = 0; i < $scope.ad.view.humanResourcesView.length; i++) {
                if ($scope.ad.view.humanResourcesView[i].getModel() === hr) return $scope.ad.view.humanResourcesView[i];
            }
        }
        return hrView;
    };
    $scope.getHumanResourcesView = function () {
        return $scope.ad.view.humanResourcesView;
    };

    $scope.getPhysicalResourcesView = function () {
        return $scope.ad.view.physicalResourcesView;
    };
    $scope.getCustomerView = function () {
        return $scope.ad.view.customerView;
    };
    $scope.getServiceView = function (service) {
        return $scope.ad.view.categoryRootView.getServiceView(service);
    };
    $scope.getServiceViewById = function (id) {
        return $scope.ad.view.categoryRootView.getServiceViewById(id);
    };
    $scope.getCategoryViewById = function (id) {
        return $scope.ad.view.categoryRootView.getCategoryViewById(id);
    };
    $scope.getProductViewById = function (id) {
        return $scope.ad.view.productCategoryRootView.getProductViewById(id);
    };
    $scope.getProductCategoryViewById = function (id) {
        return $scope.ad.view.productCategoryRootView.getCategoryViewById(id);
    };
    $scope.getCureViewById = function (id) {
        return $scope.ad.view.cureCategoryRootView.getCureViewById(id);
    };
    $scope.getCureCategoryViewById = function (id) {
        return $scope.ad.view.cureCategoryRootView.getCategoryViewById(id);
    };
    $scope.getLoyaltyCardViewById = function (id) {
        return $scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardViewById(id);
    };
    $scope.getLoyaltyCardCategoryViewById = function (id) {
        return $scope.ad.view.loyaltyCardCategoryRootView.getCategoryViewById(id);
    };
    $scope.getProductView = function (product) {
        return $scope.ad.view.productCategoryRootView.getProductView(product);
    };
    $scope.getHasHr = function () {
        return $scope.ad.view.humanResourcesView && $scope.ad.view.humanResourcesView.length != 0;
    };
    $scope.getCureView = function (cure) {
        return $scope.ad.view.cureCategoryRootView.getCureView(cure);
    };
    $scope.getLoyaltyCardView = function (lc) {
        return $scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardView(lc);
    };

    $scope.getImagesViewById = function (id) {
        var img = $scope.getImagesServiceViewById(id);
        return img ? img : $scope.getImagesCompanyViewById(id);
    };

    $scope.getImagesCompanyViewById = function (id) {
        for (var i = 0; i < $scope.ad.view.imagesCompanyView.length; i++) {
            if ($scope.ad.view.imagesCompanyView[i].id == id) return $scope.ad.view.imagesCompanyView[i];
        }
    };

    $scope.getImagesServiceViewById = function (id) {
        for (var i = 0; i < $scope.ad.view.imagesServiceView.length; i++) {
            if ($scope.ad.view.imagesServiceView[i].id == id) return $scope.ad.view.imagesServiceView[i];
        }
    };
    $scope.getImagesGiftViewById = function (id) {
        for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++) {
            if ($scope.ad.view.imagesGiftView[i].id == id) return $scope.ad.view.imagesGiftView[i];
        }
    };

    $scope.unactiveImagesServiceView = function () {
        for (var i = 0; i < $scope.ad.view.imagesServiceView.length; i++) {
            $scope.ad.view.imagesServiceView[i].active = false;
        }
    };

    $scope.unactiveImagesGiftView = function () {
        for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++) {
            $scope.ad.view.imagesGiftView[i].active = false;
        }
    };
    $scope.actionOnWidgetView = function (widgetView, force) {
        if ((force || !$scope.ad.adminEdition) && widgetView && widgetView.object && widgetView.objectType) switch (widgetView.objectType) {
            case "service":
                $scope.setCurrentServiceView(widgetView.object, true);
                break;
            case "category":
                $scope.setCurrentCategoryView(widgetView.object, true);
                break;
            case "productCategory":
                $scope.setCurrentProductCategoryView(widgetView.object, true);
                break;
            case "product":
                $scope.setCurrentProductView(widgetView.object, true);
                break;
            case "loyaltyCard":
                $scope.setCurrentLoyaltyCardView(widgetView.object, true);
                break;
            case "loyaltyCardCategory":
                $scope.setCurrentLoyaltyCardCategoryView(widgetView.object, true);
                break;
            case "cureCategory":
                $scope.setCurrentCureCategoryView(widgetView.object, true);
                break;
            case "cure":
                $scope.setCurrentCureView(widgetView.object, true);
                break;
            case "gift":
                if (typeof widgetView.object === "string") $scope.openLocation('giftItem/type/' + widgetView.object);
                break;
        }
    };
    $scope.setCurrentCategoryView = function (categoryView, gotoPath) {
        $scope.ad.view.currentCategoryView = categoryView;
        if (categoryView.parentCategoryView != null) categoryView.parentCategoryView.showMenu = false;
        if (categoryView.servicesView.length > 0) {
            categoryView.selectedServiceView = categoryView.servicesView.find(function (serviceView) {
                return serviceView.isVisibleOnWebSite;
            });
        }
        $scope.ad.view.currentParentCategoriesViewTree = [];
        var cTreeView = categoryView;
        if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
            cTreeView = cTreeView.parentCategoryView;
        }
        if (gotoPath) $scope.openLocation("category/" + categoryView.getModel().getId());
    };

    $scope.setCurrentCureCategoryView = function (categoryView, gotoPath) {
        if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.ad.view.adminEditPanelPageTab = 4;
            $scope.ad.view.currentCureCategoryView = categoryView;
            if (categoryView.parentCategoryView != null) categoryView.parentCategoryView.showMenu = false;
            if (categoryView.curesView.length > 0) categoryView.selectedCureView = categoryView.curesView[0];
            $scope.ad.view.currentParentCategoriesViewTree = [];
            var cTreeView = categoryView;
            if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
                $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                cTreeView = cTreeView.parentCategoryView;
            }
            if (gotoPath) {
                $scope.openLocation("cureCategory/" + categoryView.getModel().getId());
            }
        }
    };

    $scope.openHomeLocation = function () {
        $scope.openLocation("/home");
    };

    $scope.redirectToHomeWhenAccessIsNotGranted = function () {
        if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.openHomeLocation();
        }
    };

    $scope.setCurrentProductCategoryView = function (categoryView, gotoPath) {
        if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.ad.view.adminEditPanelPageTab = 5;
            $scope.ad.view.currentProductCategoryView = categoryView;
            if (categoryView.parentCategoryView != null) categoryView.parentCategoryView.showMenu = false;
            if (categoryView.productsView.length > 0) categoryView.selectedProductView = categoryView.productsView[0];
            $scope.ad.view.currentParentCategoriesViewTree = [];
            var cTreeView = categoryView;
            if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
                $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                cTreeView = cTreeView.parentCategoryView;
            }
            if (gotoPath) {
                $scope.openLocation("productCategory/" + categoryView.getModel().getId());
            }
        }
    };

    $scope.setCurrentLoyaltyCardCategoryView = function (categoryView, gotoPath) {
        if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.ad.view.adminEditPanelPageTab = 7;
            $scope.ad.view.currentLoyaltyCardCategoryView = categoryView;
            if (categoryView.parentCategoryView != null) categoryView.parentCategoryView.showMenu = false;
            if (categoryView.loyaltyCardsView.length > 0) categoryView.selectedLoyaltyCardView = categoryView.loyaltyCardsView[0];
            $scope.ad.view.currentParentCategoriesViewTree = [];
            var cTreeView = categoryView;
            if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
                $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                cTreeView = cTreeView.parentCategoryView;
            }
            if (gotoPath) {
                $scope.openLocation("loyaltyCardCategory/" + categoryView.getModel().getId());
            }
        }
    };

    $scope.setCurrentPanelPageView = function (gotoPath, tab) {
        if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.ad.view.adminEditPanelPageTab = tab;
            if (gotoPath) {
                $scope.openLocation(gotoPath);
            }
        }
    };

    $scope.setCurrentPageServiceView = function (gotoPath, tab) {
        if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            $scope.ad.view.adminEditPanelPageServiceTab = tab;
            if (gotoPath) {
                $scope.openLocation(gotoPath);
            }
        }
    };

    $scope.onAllowChooseHrChange = function () {
        var displayAllowChooseHrMessageSpecification = new WebSiteSpecifications.DisplayAllowChooseHrMessageSpecification();
        if (displayAllowChooseHrMessageSpecification.isSatisfiedBy($scope.ad.appAttributes.allowChooseHr, $scope.ad.subscriptionsStatus.optionLeCiseau)) {
            var question = void 0;
            if ($scope.ad.subscriptionsStatus.optionReserveWithGoogle) {
                question = gettextCatalog.getString("Le choix du professionnel sera désactivé sur votre site {{brandLabel}} et sur {{allowChooseHrDesactivatedPartnerName}} mais pas sur la plateforme {{allowChooseHrNotDesactivatedPartnerName}}.", { brandLabel: $scope.ad.brand.label, allowChooseHrDesactivatedPartnerName: BasicAuthRole.GOOGLE_ROLE.label, allowChooseHrNotDesactivatedPartnerName: BasicAuthRole.LE_CISEAU_ROLE.label });
            } else {
                question = gettextCatalog.getString("Le choix du professionnel sera désactivé sur votre site {{brandLabel}} mais pas sur la plateforme {{allowChooseHrNotDesactivatedPartnerName}}.", { brandLabel: $scope.ad.brand.label, allowChooseHrNotDesactivatedPartnerName: BasicAuthRole.LE_CISEAU_ROLE.label });
            }
            var description = gettextCatalog.getString("Confirmez-vous votre choix ? ");
            var noMessage = gettextCatalog.getString("Annuler");
            var yesMessage = gettextCatalog.getString("Confirmer");

            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["question"] = question;
                        tableModel["description"] = description;
                        tableModel["noMessage"] = noMessage;
                        tableModel["yesMessage"] = yesMessage;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (responseOk) {
                if (!responseOk) {
                    $scope.ad.appAttributes.allowChooseHr = !$scope.ad.appAttributes.allowChooseHr;
                } else {
                    var webSiteApp = $scope.computeWebSiteApp();
                    $scope.saveAppAttr(webSiteApp, AppCode.WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR);
                    AppSrv.save(webSiteApp);
                }
            });
        }
    };

    $scope.computeWebSiteApp = function () {
        var webSiteApp = AppData.getAppByCode(AppCode.WEBSITE_APP);
        if (!webSiteApp) {
            webSiteApp = new App();
            webSiteApp.setCode(AppCode.WEBSITE_APP);
        }
        return webSiteApp;
    };

    $scope.setCurrentDialog = function (dialogName) {
        if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
            for (var dialog in $scope.ad.dialog) {
                if (dialog === dialogName) {
                    $scope.ad.dialog[dialog] = !$scope.ad.dialog[dialog];
                } else {
                    $scope.ad.dialog[dialog] = false;
                }
            }
        }
    };

    $scope.setCurrentServiceView = function (serviceView, gotoPath) {
        $scope.ad.view.currentServiceView = serviceView;
        if (serviceView.parentCategoryView != null) serviceView.parentCategoryView.showMenu = false;
        $scope.ad.view.currentParentCategoriesViewTree = [serviceView.parentCategoryView];
        var cTreeView = serviceView.parentCategoryView;
        if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
            cTreeView = cTreeView.parentCategoryView;
        }
        if (gotoPath) $scope.openLocation("service/" + serviceView.getModel().getId());
    };
    $scope.setCurrentProductView = function (productView, gotoPath) {
        $scope.ad.view.currentProductView = productView;
        if (productView.parentCategoryView != null) productView.parentCategoryView.showMenu = false;
        $scope.ad.view.currentParentCategoriesViewTree = [productView.parentCategoryView];
        var cTreeView = productView.parentCategoryView;
        if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
            cTreeView = cTreeView.parentCategoryView;
        }
        if (gotoPath) $scope.openLocation("product/" + productView.getModel().getId());
    };

    $scope.setCurrentCureView = function (cureView, gotoPath) {
        $scope.ad.view.currentCureView = cureView;
        if (cureView.parentCategoryView != null) cureView.parentCategoryView.showMenu = false;
        $scope.ad.view.currentParentCategoriesViewTree = [cureView.parentCategoryView];
        var cTreeView = cureView.parentCategoryView;
        if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
            cTreeView = cTreeView.parentCategoryView;
        }
        if (gotoPath) $scope.openLocation("cure/" + cureView.getModel().getId());
    };
    $scope.setCurrentLoyaltyCardView = function (loyaltyCardView, gotoPath) {
        $scope.ad.view.currentLoyaltyCardView = loyaltyCardView;
        if (loyaltyCardView.parentCategoryView != null) loyaltyCardView.parentCategoryView.showMenu = false;
        $scope.ad.view.currentParentCategoriesViewTree = [loyaltyCardView.parentCategoryView];
        var cTreeView = loyaltyCardView.parentCategoryView;
        if (cTreeView.parentCategoryView) while (cTreeView.parentCategoryView != null) {
            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
            cTreeView = cTreeView.parentCategoryView;
        }
        if (gotoPath) $scope.openLocation("loyaltyCard/" + loyaltyCardView.getModel().getId());
    };

    $scope.addServiceViewIndex = function (serviceView) {
        $scope.ad.view.servicesViewIndex.push(serviceView);
    };
    $scope.addProductViewIndex = function (productView) {
        $scope.ad.view.productsViewIndex.push(productView);
    };
    $scope.addCureViewIndex = function (cureView) {
        $scope.ad.view.curesViewIndex.push(cureView);
    };
    $scope.onSearchInputKeyDown = function (event) {
        if (event.keyCode != 13) return;
        // this will finish the current digest before triggering the blur
        $timeout(function () {
            event.target.blur();
        }, 0, false);
        $scope.openLocation("searchedServices");
    };

    $scope.openLocation = function (location) {
        //CHECK START DATE < 1h;
        var now = new Date();
        if (!$scope.ad.tokenAdmin && $scope.ad.startDate && now.getTime() - $scope.ad.startDate.getTime() > 3600000) {
                //3600000
                if ($scope.ad.nativeApp) {
                    if ($scope.ad.nativeApp.token) $window.open("/" + $scope.ad.companyCode + "/nativeApp/" + $scope.ad.nativeApp.os + "/" + $scope.ad.nativeApp.osVersion + "/" + $scope.ad.nativeApp.token, "_self"); //FORCE RELOAD ON HOME
                    else $window.open("/" + $scope.ad.companyCode + "/nativeApp/" + $scope.ad.nativeApp.os + "/" + $scope.ad.nativeApp.osVersion, "_self"); //FORCE RELOAD ON HOME

                } else $window.open("/" + $scope.ad.companyCode + "/" + location, "_self"); //FORCE RELOAD

        } else {
                var index = $location.path().indexOf(WebPreLoaderData.companyCode); //get index of second /
                if (index != -1) //by example html5mode activate
                    $location.path("/" + WebPreLoaderData.companyCode + "/" + location);else $location.path("/" + location);

                $anchorScroll();
            }
    };
    $scope.reloadLocation = function () {
        $route.reload();
    };
    $scope.scrollTo = function (target) {
        var obj = $(target);
        if (obj && obj.offset()) $('html,body').animate({
            scrollTop: obj.offset().top
        }, 'slow');
    };
    $scope.getHrefPath = function (location) {
        var hrefPath = "";
        if (!WebPreLoaderData.isBehindReverseProxy) {
            hrefPath = "/" + WebPreLoaderData.companyCode; //by example html5mode activate
            if ($location.path().indexOf(WebPreLoaderData.companyCode) === -1) hrefPath += "#";
        }
        return hrefPath + "/" + location;
    };

    //search
    $scope.searchWebItem = function (itemView) {
        if (itemView && $scope.ad.view.searchedText) return itemView.search($scope.ad.view.searchedText.toLowerCase());
        return false;
    };

    $scope.loadHomeTextHtml = function () {
        var webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var appAttr = webSiteApp.getAppAttribute("homeTextHtml");
            if (appAttr) if (appAttr.text && appAttr.text != '') $scope.ad.appAttributes.homeTextHtml = appAttr.text;else $scope.ad.appAttributes.homeTextHtml = "";
        }
    };
    $scope.loadCgvHtml = function () {
        var webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var appAttr = webSiteApp.getAppAttribute("cgv");
            if (appAttr && appAttr.text && appAttr.text != '') $scope.ad.appAttributes.cgvHtml = $sce.trustAsHtml(appAttr.text);
        }
    };
    $scope.loadTitle = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var appAttr = webSiteApp.getAppAttribute("titleIsDisplayed");
            if (appAttr) $scope.ad.appAttributes.titleIsDisplayed = appAttr.value == "true";
            appAttr = webSiteApp.getAppAttribute("titleHomeLabel");
            if (appAttr) {
                $scope.ad.appAttributes.titleHomeLabel = appAttr.value;
            }
            appAttr = webSiteApp.getAppAttribute("titleBgColorStart");
            if (appAttr) $scope.ad.appAttributes.titleBgColorStart = appAttr.value;
            appAttr = webSiteApp.getAppAttribute("titleBgColorEnd");
            if (appAttr) $scope.ad.appAttributes.titleBgColorEnd = appAttr.value;
            appAttr = webSiteApp.getAppAttribute("titleFontColor");
            if (appAttr) $scope.ad.appAttributes.titleFontColor = appAttr.value;
        } else {
            $scope.ad.appAttributes.titleHomeLabel = "Carte des soins";
            $scope.ad.appAttributes.titleIsDisplayed = true;
            $scope.ad.appAttributes.titleBgColorStart = "#ff3399";
            $scope.ad.appAttributes.titleBgColorEnd = "#993366";
            $scope.ad.appAttributes.titleFontColor = "#ffffff";
        }
        $scope.ad.view.categoryRootView.label = $scope.ad.appAttributes.servicesLabel;
        $scope.ad.view.productCategoryRootView.label = $scope.ad.appAttributes.productsLabel;
        $scope.ad.view.cureCategoryRootView.label = $scope.ad.appAttributes.curesLabel;
        $scope.ad.view.loyaltyCardCategoryRootView.label = $scope.ad.appAttributes.loyaltyCardsLabel;
    };

    $scope.loadMenu = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var appAttr = webSiteApp.getAppAttribute("menuIsDisplayed");
            if (appAttr) $scope.ad.appAttributes.menuIsDisplayed = appAttr.value == "true";
            appAttr = webSiteApp.getAppAttribute("menuBgColorStart");
            if (appAttr) $scope.ad.appAttributes.menuBgColorStart = appAttr.value;else $scope.ad.appAttributes.menuBgColorStart = null;
            appAttr = webSiteApp.getAppAttribute("menuBgColorEnd");
            if (appAttr) $scope.ad.appAttributes.menuBgColorEnd = appAttr.value;else $scope.ad.appAttributes.menuBgColorEnd = null;
            appAttr = webSiteApp.getAppAttribute("menuFontColor");
            if (appAttr) $scope.ad.appAttributes.menuFontColor = appAttr.value;else $scope.ad.appAttributes.menuFontColor = null;
            appAttr = webSiteApp.getAppAttribute("menuShadowColor");
            if (appAttr) $scope.ad.appAttributes.menuShadowColor = appAttr.value;else $scope.ad.appAttributes.menuShadowColor = null;
        } else {
            $scope.ad.appAttributes.menuIsDisplayed = true;
            $scope.ad.appAttributes.menuBgColorStart = "#FFFFFF";
            $scope.ad.appAttributes.menuBgColorEnd = "#FFFFFF";
            $scope.ad.appAttributes.menuFontColor = "#000000";
        }
    };

    $scope.updateDiscountDays = function () {
        var discountDays = $scope.ad.view.aTableView.getDiscountDays();

        var oldDiscountDays = $scope.ad.appAttributes.discountDays;
        var nowDayId = DaySrv.getIdFromDate(new Date());
        if (oldDiscountDays) {
            var insideNew;
            var newADaysView = discountDays.aDaysView.slice(0);
            for (var i = 0; i < oldDiscountDays.aDaysView.length; i++) {
                insideNew = false;
                for (var j = 0; j < discountDays.aDaysView.length && !insideNew; j++) {
                    insideNew = oldDiscountDays.aDaysView[i].dayId == discountDays.aDaysView[j].dayId;
                }if (!insideNew && oldDiscountDays.aDaysView[i].dayId >= nowDayId) newADaysView.push(oldDiscountDays.aDaysView[i]);
            }
            $scope.ad.appAttributes.discountDays.aDaysView = newADaysView;
        } else $scope.ad.appAttributes.discountDays = discountDays;
    };
    $scope.getMondayAsLabel = function (d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + 1; //don't adjust when day is sunday
        return $filter('date')(new Date(d.setDate(diff)), 'EEEE d MMMM'); //execute angular filter $scope.getDayAsLabel());
    };
    $scope.displayWeekOnAdmin = function (next) {
        if ($scope.ad.view.currentBookingView != null) {
            var date = new Date($scope.ad.view.currentBookingView.date);
            if (next) date.setDate(date.getDate() + 7);else date.setDate(date.getDate() - 7);

            if (DateSrv.daysBetween(date, new Date()) > 7 * $scope.ad.appAttributes.nbBookingWeeks) {
                $scope.dd.view.warningBookingWeek = true;
            } else {
                $scope.ad.view.currentBookingView.date = date;
                var selectedHr = null;
                if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && $scope.ad.appAttributes.allowChooseHr) //preserve hr selection when go to next week
                    selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                $scope.ad.view.aTableView = null;
                DaySrv.getAvailablePeriods(date, 7, next, function (loadedDays, hrSelected, nextDay) {
                    $scope.afterGetAvailablePeriodsOnAdmin(loadedDays, selectedHr, nextDay, next);
                });
            }
        }
    };
    $scope.afterGetAvailablePeriodsOnAdmin = function (loadedDays, previousSelectedHr, nextAvailableDay) {
        if (nextAvailableDay && nextAvailableDay !== $scope.ad.view.currentBookingView.date) {
            $scope.ad.view.currentBookingView.date = nextAvailableDay;
        }

        $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite, $scope);
        var availableHumanResources = [];
        var isAvailable;
        var dayHr;
        var hrId;
        for (var i = 0; i < $scope.ad.view.humanResourcesView.length; i++) {
            isAvailable = false;
            hrId = $scope.ad.view.humanResourcesView[i].getModel().id;
            for (var j = 0; j < loadedDays.length && !isAvailable; j++) {
                if (loadedDays[j]) {
                    dayHr = loadedDays[j].getDayHrByHrId(hrId);
                    if (dayHr && dayHr.availablePeriods && dayHr.availablePeriods.length > 0) isAvailable = true;
                }
            }
            if (isAvailable) availableHumanResources.push($scope.ad.view.humanResourcesView[i]);
        }
        $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);

        if ($scope.ad.appAttributes.discountDays) $scope.ad.view.aTableView.setByDiscountDays($scope.ad.appAttributes.discountDays);
    };
    $scope.loadAppAttr = function (webSiteApp, appAttrCode, type) {

        var appAttr = webSiteApp.getAppAttribute(appAttrCode);
        if (appAttr) {
            if (type === undefined || type == "string" || type == "text") {
                if (type === undefined || type == "string") $scope.ad.appAttributes[appAttrCode] = appAttr.value;else $scope.ad.appAttributes[appAttrCode] = appAttr.text;
            } else if (type == "boolean") $scope.ad.appAttributes[appAttrCode] = appAttr.value == "true";else if (type == "number") {
                if (appAttr.value && appAttr.value != '') {
                    if (typeof appAttr.value === "string") $scope.ad.appAttributes[appAttrCode] = parseFloat(appAttr.value.replace(",", "."));else {
                        if (typeof appAttr.value === "number") $scope.ad.appAttributes[appAttrCode] = appAttr.value;
                    }
                } else $scope.ad.appAttributes[appAttrCode] = 0;
            } else if (type == "int") $scope.ad.appAttributes[appAttrCode] = parseInt(appAttr.value);
        }
    };
    $scope.loadHomeGridWidgetsView = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            $scope.ad.view.homeGridWidgetsView = [];

            var appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var homeGridWidgets = null;
                try {
                    homeGridWidgets = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadHomeGridWidgetsView => JSON.parse error', e);
                }

                if (homeGridWidgets) {
                    for (var i = 0; i < homeGridWidgets.length; i++) {
                        var widgetView = new WidgetView(homeGridWidgets[i], i, true, $scope);
                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                    }
                }
            }
            // sort
            $scope.ad.view.homeGridWidgetsView = $filter('orderBy')($scope.ad.view.homeGridWidgetsView, ['y', 'x']);
        }
    };
    $scope.loadHomeWidgetView = function (webSiteApp, loadHomeWidgetSub) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var appAttr = webSiteApp.getAppAttribute("homeWidget");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var homeWidget = null;
                try {
                    homeWidget = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadHomeWidgetView => JSON.parse error', e);
                }

                if (homeWidget) {
                    if ($scope.ad.view.homeWidgetView && !loadHomeWidgetSub) {
                        var widgetsView = $scope.ad.view.homeWidgetView.widgetsView;
                        $scope.ad.view.homeWidgetView = new WidgetView(homeWidget, 0, loadHomeWidgetSub, $scope);
                        $scope.ad.view.homeWidgetView.widgetsView = widgetsView;
                    } else $scope.ad.view.homeWidgetView = new WidgetView(homeWidget, 0, loadHomeWidgetSub, $scope);
                }
            }
            if (!$scope.ad.view.homeWidgetView) {
                $scope.ad.view.homeWidgetView = new WidgetView(null, 0, false, $scope);
                $scope.ad.view.homeWidgetView.type = "default-offer";
            } else {
                if ($scope.ad.view.homeWidgetView.type != "default-offer" && $scope.ad.view.homeWidgetView.type != "fullscreen-offer" || $scope.ad.view.homeWidgetView.widgetsView.length == 0) $scope.ad.view.homeWidgetView.type = "default-offer";
            }

            var homeItemsView = [];
            // ascendency compatibily : load object by selecting them
            $scope.ad.view.categoryRootView.populateHomeItemsView(homeItemsView);
            $scope.ad.view.productCategoryRootView.populateHomeItemsView(homeItemsView);
            $scope.ad.view.cureCategoryRootView.populateHomeItemsView(homeItemsView);
            homeItemsView = $filter('orderBy')(homeItemsView, 'item.homeOrder');
            $scope.ad.view.homeWidgetView.loadItems(homeItemsView);
        }
    };
    $scope.loadWidgetsView = function (webSiteApp, loadHomeWidgetSub) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");

        if (webSiteApp) {
            // load widgets
            var widgetView = null;
            if ($scope.ad.tokenAdmin) {
                $scope.ad.view.gridOptions.disableResize = false;
                $scope.ad.view.gridOptions.disableDrag = false;
            }

            $scope.loadHomeGridWidgetsView(webSiteApp);
            $scope.loadHomeWidgetView(webSiteApp, loadHomeWidgetSub);

            var appAttr = webSiteApp.getAppAttribute("defaultWidget");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var defaultWidget = null;
                try {
                    defaultWidget = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadWidgetsView => JSON.parse error', e);
                }

                if (defaultWidget) {
                    $scope.ad.view.defaultWidgetView = new WidgetView(defaultWidget, 0, false, $scope);
                }
            }
            if (!$scope.ad.view.defaultWidgetView) $scope.ad.view.defaultWidgetView = new WidgetView(null, 0, false, $scope);
            $scope.ad.view.defaultWidgetView.isDefault = true;
        }
    };
    $scope.loadCategoryDisplay = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");

        if (webSiteApp) {
            $scope.ad.view.categoryRootView.initWebDisplay();
            var appAttr = webSiteApp.getAppAttribute("serviceCategoriesDisplay");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var serviceCategoriesDisplay = null;
                try {
                    serviceCategoriesDisplay = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadCategoryDisplay => JSON.parse error', e);
                }

                if (serviceCategoriesDisplay) {
                    var categoryView;
                    for (var i = 0; i < serviceCategoriesDisplay.length; i++) {
                        categoryView = $scope.getCategoryViewById(serviceCategoriesDisplay[i].id);
                        if (categoryView) categoryView.displayType = serviceCategoriesDisplay[i].type;
                    }
                }
            }
            $scope.ad.view.productCategoryRootView.initWebDisplay();
            var appAttr = webSiteApp.getAppAttribute("productCategoriesDisplay");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var productCategoriesDisplay = null;
                try {
                    productCategoriesDisplay = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadCategoryDisplay productCategoriesDisplay => JSON.parse error', e);
                }

                if (productCategoriesDisplay) {
                    var categoryView;
                    for (var i = 0; i < productCategoriesDisplay.length; i++) {
                        categoryView = $scope.getProductCategoryViewById(productCategoriesDisplay[i].id);
                        if (categoryView) categoryView.displayType = productCategoriesDisplay[i].type;
                    }
                }
            }
            $scope.ad.view.cureCategoryRootView.initWebDisplay();
            var appAttr = webSiteApp.getAppAttribute("cureCategoriesDisplay");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var cureCategoriesDisplay = null;
                try {
                    cureCategoriesDisplay = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadCategoryDisplay cureCategoriesDisplay => JSON.parse error', e);
                }

                if (cureCategoriesDisplay) {
                    var categoryView;
                    for (var i = 0; i < cureCategoriesDisplay.length; i++) {
                        categoryView = $scope.getCureCategoryViewById(cureCategoriesDisplay[i].id);
                        if (categoryView) categoryView.displayType = cureCategoriesDisplay[i].type;
                    }
                }
            }
            $scope.ad.view.loyaltyCardCategoryRootView.initWebDisplay();
            var appAttr = webSiteApp.getAppAttribute("loyaltyCardCategoriesDisplay");
            if (appAttr && appAttr.text && appAttr.text != '') {
                var loyaltyCardCategoriesDisplay = null;
                try {
                    loyaltyCardCategoriesDisplay = JSON.parse(appAttr.text);
                } catch (e) {
                    console.log('loadCategoryDisplay loyaltyCardCategoriesDisplay => JSON.parse error', e);
                }

                if (loyaltyCardCategoriesDisplay) {
                    var categoryView;
                    for (var i = 0; i < loyaltyCardCategoriesDisplay.length; i++) {
                        categoryView = $scope.getLoyaltyCardCategoryViewById(loyaltyCardCategoriesDisplay[i].id);
                        if (categoryView) categoryView.displayType = loyaltyCardCategoriesDisplay[i].type;
                    }
                }
            }
        }
    };
    $scope.loadDesignAttributes = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");

        if (webSiteApp) {
            $scope.loadAppAttr(webSiteApp, "homeDisplayType");
            $scope.loadAppAttr(webSiteApp, "globalBgImage");
            $scope.loadAppAttr(webSiteApp, "globalBgColor");
            $scope.loadAppAttr(webSiteApp, "globalObjectColor");
            $scope.loadAppAttr(webSiteApp, "globalFontFamily");
            $scope.loadAppAttr(webSiteApp, "headerType");
            $scope.loadAppAttr(webSiteApp, "footerBgColor");
            $scope.loadAppAttr(webSiteApp, "footerFontColor");

            if (screen) if (screen.width > 767) //dont slide on mobile
                {
                    $scope.loadAppAttr(webSiteApp, "globalBgImageUseSlide", "boolean");
                    $scope.loadAppAttr(webSiteApp, "globalBgImageOverlay", "boolean");
                    if ($scope.ad.appAttributes.globalBgImageUseSlide) $scope.initSlides();
                } else {
                $scope.ad.view.isOnMobile = true;
            }

            $scope.updateCss();
        } else {
            $scope.ad.appAttributes.globalBgColor = null;
            $scope.ad.appAttributes.globalBgImage = null;
        }
    };
    $scope.loadAdminAttributes = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");

        if (webSiteApp) {
            $scope.loadAppAttr(webSiteApp, "homeLabel");
            $scope.loadAppAttr(webSiteApp, "displayAbout", "boolean");
            $scope.loadAppAttr(webSiteApp, "aboutLabel");
            $scope.loadAppAttr(webSiteApp, "displayContact", "boolean");
            if ($scope.ad.appAttributes.displayContact) {
                $scope.ad.appAttributes.footerTime = false;
                $scope.ad.appAttributes.footerAddress = false;
                $scope.ad.appAttributes.footerMap = false;
                $scope.ad.appAttributes.footerSocial = false;
            }
            $scope.loadAppAttr(webSiteApp, "contactLabel");
            $scope.loadAppAttr(webSiteApp, "displayServices", "boolean");
            $scope.loadAppAttr(webSiteApp, "servicesLabel");
            $scope.loadAppAttr(webSiteApp, "servicesProductsLabel");
            $scope.loadAppAttr(webSiteApp, "servicesCuresLabel");
            $scope.loadAppAttr(webSiteApp, "displayProducts", "boolean");
            $scope.loadAppAttr(webSiteApp, "productsLabel");
            $scope.loadAppAttr(webSiteApp, "displayCures", "boolean");
            $scope.loadAppAttr(webSiteApp, "curesLabel");
            $scope.loadAppAttr(webSiteApp, "displayLoyaltyCards", "boolean");
            $scope.loadAppAttr(webSiteApp, "loyaltyCardsLabel");
            $scope.loadAppAttr(webSiteApp, "giftsLabel");

            $scope.loadAppAttr(webSiteApp, "giftItemDeliveryImageId");
            $scope.loadAppAttr(webSiteApp, "giftItemPrintableImageId");
            $scope.loadAppAttr(webSiteApp, "giftItemMailImageId");

            $scope.loadAppAttr(webSiteApp, "homeAbout", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeAboutSentence");
            $scope.loadAppAttr(webSiteApp, "homeOffer", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeOfferSentence");
            $scope.loadAppAttr(webSiteApp, "homeServiceSentence");
            $scope.loadAppAttr(webSiteApp, "homeCure", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeCureSentence");
            $scope.loadAppAttr(webSiteApp, "homeProduct", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeProductSentence");
            $scope.loadAppAttr(webSiteApp, "hasGiftItem", "boolean");
            $scope.ad.appAttributes.homeService = $scope.ad.appAttributes.displayServices;
            $scope.loadAppAttr(webSiteApp, "homeService", "boolean");
            $scope.ad.appAttributes.homeGiftItem = $scope.ad.appAttributes.hasGiftItem;
            $scope.loadAppAttr(webSiteApp, "homeGiftItem", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeGiftItemSentence");
            $scope.loadAppAttr(webSiteApp, "homeLoyaltyCard", "boolean");
            $scope.loadAppAttr(webSiteApp, "homeLoyaltyCardSentence");
            $scope.loadAppAttr(webSiteApp, "footerTime", "boolean");
            $scope.loadAppAttr(webSiteApp, "footerAddress", "boolean");
            $scope.loadAppAttr(webSiteApp, "footerMap", "boolean");
            $scope.loadAppAttr(webSiteApp, "footerSocial", "boolean");
            $scope.loadAppAttr(webSiteApp, "footerFacebook");
            $scope.loadAppAttr(webSiteApp, "footerTwitter");
            $scope.loadAppAttr(webSiteApp, "footerInstagram");
            $scope.loadAppAttr(webSiteApp, "footerPinterest");
            $scope.loadAppAttr(webSiteApp, "displayFacebook", "boolean");
            $scope.loadAppAttr(webSiteApp, "autoValidateCustomerPost", "boolean");
            $scope.loadAppAttr(webSiteApp, "displayCustomerPost", "boolean");
            $scope.loadAppAttr(webSiteApp, "welcomePictureCustomerPost", "boolean");
            $scope.loadAppAttr(webSiteApp, "customerPostLabel");

            $scope.loadAppAttr(webSiteApp, "facebookLabel");
            $scope.loadAppAttr(webSiteApp, "onlineBooking", "boolean");
            $scope.loadAppAttr(webSiteApp, "allowChooseHr", "boolean");
            $scope.loadAppAttr(webSiteApp, "allowBookingComment", "boolean");
            $scope.loadAppAttr(webSiteApp, "bookingCommentSentence");
            $scope.loadAppAttr(webSiteApp, "hasBookingPayment", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasBookingPaymentAdvance", "boolean");
            $scope.loadAppAttr(webSiteApp, "bookingPaymentAdvancePercent", "int");
            $scope.loadAppAttr(webSiteApp, "hasBookingPaymentMandatory", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasBookingPaymentOnAmount", "boolean");
            $scope.loadAppAttr(webSiteApp, "bookingPaymentOnAmount", "number");
            $scope.loadAppAttr(webSiteApp, "nbBookingWeeks", "int");
            $scope.loadAppAttr(webSiteApp, "nbBookingBeforeTime", "int");
            $scope.loadAppAttr(webSiteApp, "triesTime", "int");
            $scope.loadAppAttr(webSiteApp, "autoFilling", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasCurePayment", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasProductPayment", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasProductDelivery", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasProductDeliveryCharge", "boolean");
            $scope.loadAppAttr(webSiteApp, "productDeliverySentence");
            $scope.loadAppAttr(webSiteApp, "productDeliveryCharge", "number");
            $scope.loadAppAttr(webSiteApp, "hasLoyaltyCardPayment", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasServiceGift", "boolean");
            $scope.loadAppAttr(webSiteApp, "hasGiftItemDelivery", "boolean");
            $scope.loadAppAttr(webSiteApp, "giftItemDeliverySentence");
            $scope.loadAppAttr(webSiteApp, "hasGiftItemDeliveryCharge", "boolean");
            $scope.loadAppAttr(webSiteApp, "giftItemDeliveryCharge", "number");
            $scope.loadAppAttr(webSiteApp, "hasGiftItemMail", "boolean");
            $scope.loadAppAttr(webSiteApp, "googleAnalyticsId");
            $scope.loadAppAttr(webSiteApp, "javascriptOnHeader", "text");
            if ($scope.ad.appAttributes.javascriptOnHeader) $scope.ad.appAttributes.javascriptOnHeader = $scope.ad.appAttributes.javascriptOnHeader.replace(/\\\//g, "/");
            $scope.loadAppAttr(webSiteApp, "javascriptOnBody", "text");
            if ($scope.ad.appAttributes.javascriptOnBody) $scope.ad.appAttributes.javascriptOnBody = $scope.ad.appAttributes.javascriptOnBody.replace(/\\\//g, "/");

            var appAttr = webSiteApp.getAppAttribute("giftImageIds");
            if (appAttr && appAttr.text && appAttr.text !== '') {
                var giftImageIds = appAttr.text.split(";"),
                    image = void 0,
                    imageFromImageData = void 0,
                    imageFromCompanyImage = void 0;

                for (var i = 0; i < giftImageIds.length; i++) {
                    imageFromImageData = ImageData.getById(giftImageIds[i]);
                    imageFromCompanyImage = CompanyImageData.getById(giftImageIds[i]);

                    if (imageFromCompanyImage) {
                        image = imageFromCompanyImage;
                    } else {
                        image = imageFromImageData;
                    }
                    if (image && $scope.ad.view.imagesGiftView.indexOf(image) === -1) $scope.ad.view.imagesGiftView.push(image);
                }
            } else $scope.ad.view.imagesGiftView = $scope.ad.view.imagesServiceView.slice(0);

            $scope.initFlexyFilteredImagesView();

            appAttr = webSiteApp.getAppAttribute("discountDays");
            if (appAttr && appAttr.text && appAttr.text != '') {
                try {
                    $scope.ad.appAttributes.discountDays = JSON.parse(appAttr.text);
                } catch (e) {}
            }
            $scope.updateCss();
        } else {
            $scope.ad.appAttributes.globalBgColor = null;
            $scope.ad.appAttributes.globalBgImage = null;
            $scope.ad.appAttributes.allowChooseHr = false;
            $scope.ad.appAttributes.allowBookingComment = false;
        }
    };

    $scope.initFlexyFilteredImagesView = function () {
        $scope.ad.view.flexyFilteredImagesView = [];

        for (var _i5 = 0; _i5 < $scope.ad.view.imagesServiceView.length; _i5++) {
            var imageServiceView = $scope.ad.view.imagesServiceView[_i5];
            if (imageServiceView.status === 'NotActivated') {
                for (var j = 0; j < $scope.ad.view.imagesGiftView.length; j++) {
                    if (imageServiceView.id === $scope.ad.view.imagesGiftView[j].id) {
                        $scope.ad.view.flexyFilteredImagesView.push(imageServiceView);
                        break;
                    }
                }
            } else {
                $scope.ad.view.flexyFilteredImagesView.push(imageServiceView);
            }
        }
    };

    $scope.updateCss = function () {
        var webStyleSheet = null;
        for (var _i6 = 0; _i6 < document.styleSheets.length && !webStyleSheet; _i6++) {
            var sheet = document.styleSheets[_i6];
            if (sheet.title === 'webSite') {
                webStyleSheet = sheet;
            }
        }

        if (webStyleSheet) {
            if ($scope.ad.appAttributes.globalObjectColorInserted) {
                //remove 6
                for (var _i7 = 0; _i7 < 6; _i7++) {
                    webStyleSheet.deleteRule(webStyleSheet.cssRules.length - 1);
                }
            }

            if ($scope.ad.appAttributes.globalFontFamilyInserted) {
                for (var _i8 = 0; _i8 < 3; _i8++) {
                    webStyleSheet.deleteRule(webStyleSheet.cssRules.length - 1);
                }
            }

            if ($scope.ad.appAttributes.globalObjectColor) {
                webStyleSheet.insertRule("a {text-decoration: none;color: " + $scope.ad.appAttributes.globalObjectColor + " ;cursor: pointer;}", webStyleSheet.cssRules.length);
                webStyleSheet.insertRule(".no-touch  a:hover,a:focus, a:active {text-decoration: underline;color: " + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);
                webStyleSheet.insertRule(".soft-color {color: " + $scope.ad.appAttributes.globalObjectColor + " ;}", webStyleSheet.cssRules.length);
                webStyleSheet.insertRule(".button,.no-touch .button:hover,.no-touch .button-booking-active:hover {background: " + $scope.ad.appAttributes.globalObjectColor + " ;}", webStyleSheet.cssRules.length);
                webStyleSheet.insertRule(".product-specs {color:" + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);
                webStyleSheet.insertRule(".soft-bgcolor {background-color:" + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);

                $scope.ad.appAttributes.globalObjectColorInserted = true;
            }

            if ($scope.ad.appAttributes.globalFontFamily) {
                var font = $scope.getFont($scope.ad.appAttributes.globalFontFamily);
                if (font) {
                    webStyleSheet.insertRule("body, button, table,.dialog-form .ta-editor {font-family:" + font.css + ";}", webStyleSheet.cssRules.length);
                    webStyleSheet.insertRule("body,.dialog-form .ta-editor {font-size:" + font.size + "%;}", webStyleSheet.cssRules.length);
                    webStyleSheet.insertRule(".nav-primary {padding-top : " + font.padding_top + "px}", webStyleSheet.cssRules.length);

                    $scope.ad.appAttributes.globalFontFamilyInserted = true;
                }
            }
        }
    };

    $scope.getFont = function (name) {
        for (var i = 0; i < $scope.ad.view.fontOptions.length; i++) {
            if ($scope.ad.view.fontOptions[i].name == name) return $scope.ad.view.fontOptions[i];
        }return null;
    };
    $scope.loadLogo = function (webSiteApp) {
        if (!webSiteApp) webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            var attribute = webSiteApp.getAppAttribute("logoImageId");
            if (attribute && attribute.value) {
                $scope.ad.appAttributes.logoImageId = parseInt(attribute.value);
                var companyImage = CompanyImageData.getById($scope.ad.appAttributes.logoImageId);
                if (companyImage) {
                    $scope.ad.view.logoImageUrl = companyImage.urlPreview;
                    $scope.ad.view.logoEditPanelTab = 2;
                }
            }
            $scope.ad.appAttributes.logoText = "<h2>" + $scope.ad.view.siteView.name + "</h2>";
            $scope.loadAppAttr(webSiteApp, "logoFontColor");
            $scope.loadAppAttr(webSiteApp, "logoShadowColor");
            $scope.loadAppAttr(webSiteApp, "logoText");
        } else {
            $scope.ad.appAttributes.logoImageId = null;
            $scope.ad.appAttributes.logoFontColor = null;
        }
    };

    $scope.loadAppAttributes = function () {
        $scope.loadTemplateAttributes(null, true);
        $scope.loadAdminAttributes();
        $scope.loadCgvHtml();
        $scope.loadHomeTextHtml();
        $scope.loadTemplates();
        $scope.loadGiftItemImages();
    };

    $scope.loadTemplateAttributes = function (webSiteApp, loadSub) {
        $scope.loadLogo(webSiteApp);
        $scope.loadDesignAttributes(webSiteApp);
        $scope.loadMenu(webSiteApp);
        $scope.loadTitle(webSiteApp);
        $scope.loadPosAttributes(webSiteApp);
        $scope.loadWidgetsView(webSiteApp, loadSub);
        $scope.loadCategoryDisplay(webSiteApp);
    };

    $scope.loadTemplates = function () {
        var i = 1;
        this.ad.view.templates = [];
        var webSiteApp = AppData.getAppByCode("webSite-template" + i);
        while (webSiteApp) {
            var attribute = webSiteApp.getAppAttribute("templateLabel");
            if (attribute) this.ad.view.templates.push({ id: i, label: attribute.value });
            i++;
            webSiteApp = AppData.getAppByCode("webSite-template" + i);
        }
        i = 1;
        this.ad.view.gTemplates = [];
        var webSiteApp = AppData.getAppByCode("webSite-g-template" + i);
        var uselessThemes = Constants.WEBSITE_USELESS_THEME_LABELS;
        while (webSiteApp) {
            var attribute = webSiteApp.getAppAttribute("templateLabel");
            if (attribute && attribute.value && uselessThemes.indexOf(attribute.value) === -1) {
                this.ad.view.gTemplates.push({ id: i, label: attribute.value });
            }
            i++;
            webSiteApp = AppData.getAppByCode("webSite-g-template" + i);
        }
    };
    $scope.loadSelectedTemplate = function (template, isGlobal) {
        if (template) {
            var webSiteApp = null;
            if (isGlobal) webSiteApp = AppData.getAppByCode("webSite-g-template" + template.id);else webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
            if (webSiteApp) $scope.loadTemplateAttributes(webSiteApp, false); //dont load objects from a template
        }
    };
    $scope.initSlides = function () {
        var slides = [];
        for (var _i9 = 0; _i9 < $scope.ad.view.imagesBgCompanyView.length; _i9++) {
            var img = $scope.ad.view.imagesBgCompanyView[_i9];
            if (img && img.url) {
                slides.push({ src: img.url });
            }
        }

        if (!slides.length) {
            return;
        }

        var elem = $("body");
        if (elem[0]._vegas) elem.vegas('options', 'slides', slides);else elem.vegas({
            delay: 15000,
            shuffle: true,
            transition: 'fade',
            transitionDuration: 3000,
            timer: false,
            overlay: $scope.ad.appAttributes.globalBgImageOverlay ? '/lib/vegas/overlays/02.png' : 'none',
            slides: slides
        });
    };
    $scope.loadPosAttributes = function () {
        var webPosApp = AppData.getAppByCode("pos");
        if (webPosApp) {
            var attribute = webPosApp.getAppAttribute("giftMonthValidity");
            if (attribute) {
                var giftMonthValidity = parseInt(attribute.value);
                if (!isNaN(giftMonthValidity)) $scope.ad.appAttributes.giftMonthValidity = giftMonthValidity;
            }
        }
    };
    $scope.addBookingServiceView = function (serviceView) {
        $scope.ad.view.errorMessage = "";
        $scope.ad.view.currentServiceView = serviceView;
        if ($scope.ad.view.currentBookingView == null) $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
        var citsView = null;
        if ($scope.ad.view.customerView) citsView = $scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView(serviceView);
        if (citsView) $scope.addServiceOnBookingOnUserSelectCureItem(citsView);else {
            if ($scope.ad.view.currentSaleView && $scope.ad.view.currentBookingView) {
                $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
            }
            $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking($scope.ad.view.currentServiceView);

            $scope.openLocation("cart");
        }
    };
    $scope.addServiceOnBookingOnUserSelectCureItem = function (citsView) {
        var cureItemServices = $scope.setCureItemServices(citsView.cureItemView.cureItemId, citsView.serviceView.serviceId);

        CureItemSrv.checkCureItemServiceIsUsed(cureItemServices, function (data) {
            if (data.cureItemServices && data.cureItemServices.length === 0) {
                if ($scope.ad.view.currentBookingView == null) $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
                if ($scope.ad.view.currentSaleView) {
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                }
                $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBookingOnUserSelectCureItem(citsView);
                $scope.openLocation("cart");
            } else {
                $scope.ad.view.cureDisplayError = true;
            }
        });
    };

    $scope.setCureItemServices = function (cureItemId, serviceId) {
        var cureItem = new Object(),
            cureItemServices = [];

        cureItem.cureItemId = cureItemId;
        cureItem.serviceId = serviceId;
        cureItemServices.push(cureItem);

        return cureItemServices;
    };

    $scope.addSaleProductView = function (productView) {
        $scope.ad.view.currentProductView = productView;
        if ($scope.ad.view.currentSaleView == null) {
            $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
            $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
        }
        if ($scope.ad.view.currentBookingView) {
            $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
            $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
        }

        $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addProductOnSale(productView, null, true);
        $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
        if ($scope.ad.appAttributes.hasProductDelivery) $scope.ad.view.currentSaleView.setDelivery("address", true, $scope.ad.appAttributes.productDeliveryCharge);
        $scope.openLocation("checkout");
    };
    $scope.addSaleCureView = function (cureView) {
        $scope.ad.view.currentCureView = cureView;
        if ($scope.ad.view.currentSaleView == null) {
            $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
            $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
        }
        if ($scope.ad.view.currentBookingView) {
            $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
            $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
        }

        $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addCureOnSale(cureView, null, true);
        $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
        $scope.openLocation("checkout");
    };
    $scope.addSaleLoyaltyCardView = function (loyaltyCardView) {
        $scope.ad.view.currentLoyaltyCardView = loyaltyCardView;
        if ($scope.ad.view.currentSaleView == null) {
            $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
            $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
        } else if ($scope.ad.view.currentSaleView.loyaltyCardItemView) return;
        if ($scope.ad.view.currentBookingView) {
            $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
            $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
        }

        $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addLoyaltyCardOnSale(loyaltyCardView, null, true);
        $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
        $scope.openLocation("checkout");
    };

    $scope.saveGiftItemImages = function () {
        var webSiteApp = $scope.computeWebSiteApp();
        $scope.saveAppAttr(webSiteApp, "giftItemDeliveryImageId");
        $scope.saveAppAttr(webSiteApp, "giftItemPrintableImageId");
        $scope.saveAppAttr(webSiteApp, "giftItemMailImageId");
        AppSrv.save(webSiteApp);
    };

    $scope.saveGiftItemDeliveryImage = function (image) {
        $scope.ad.appAttributes.giftItemDeliveryImageId = image ? image.id : "";
        $scope.saveGiftItemImages();
        $scope.ad.view.giftItemDeliveryImage = image ? image : { urlPreview: "/img/exemplebon_box.svg" };
    };

    $scope.saveGiftItemPrintableImage = function (image) {
        $scope.ad.appAttributes.giftItemPrintableImageId = image ? image.id : "";
        $scope.saveGiftItemImages();
        $scope.ad.view.giftItemPrintableImage = image ? image : { urlPreview: "/img/exemplebon_print.svg" };
    };

    $scope.saveGiftItemMailImage = function (image) {
        $scope.ad.appAttributes.giftItemMailImageId = image ? image.id : "";
        $scope.saveGiftItemImages();
        $scope.ad.view.giftItemMailImage = image ? image : { urlPreview: "/img/exemplebon_mail.svg" };
    };

    $scope.loadGiftItemImages = function () {
        var webSiteApp = AppData.getAppByCode("webSite");
        if (webSiteApp) {
            $scope.ad.view.giftItemDeliveryImage = $scope.loadGiftItemImage(webSiteApp, "giftItemDeliveryImageId");
            $scope.ad.view.giftItemPrintableImage = $scope.loadGiftItemImage(webSiteApp, "giftItemPrintableImageId");
            $scope.ad.view.giftItemMailImage = $scope.loadGiftItemImage(webSiteApp, "giftItemMailImageId");
        }
    };

    /**
     * Load image from its id find by the appAttribute code.
     * Search first in the imagesServiceView then if nothing found in the imagesCompanyView.
     *
     * @param {string} webSiteApp
     * @param {string} code
     *
     * @return {object} the image or an object with a default url preview image.
     */
    $scope.loadGiftItemImage = function (webSiteApp, code) {
        var appAttr = webSiteApp.getAppAttribute(code);
        if (appAttr && appAttr.value !== "") {
            var id = appAttr.value;
            return $scope.getImagesViewById(id);
        }
        if (code === "giftItemDeliveryImageId") {
            return { urlPreview: "/img/exemplebon_box.svg", label: "" };
        } else if (code === "giftItemPrintableImageId") {
            return { urlPreview: "/img/exemplebon_print.svg", label: "" };
        } else if (code === "giftItemMailImageId") {
            return { urlPreview: "/img/exemplebon_mail.svg", label: "" };
        } else {
            return { urlPreview: "/img/exemplebon.svg", label: "" };
        }
    };

    $scope.addHeadersForMangopay = function () {
        $http.defaults.headers.common.height = window.innerHeight;
        $http.defaults.headers.common.width = window.innerWidth;
        $http.defaults.headers.common.java = navigator.javaEnabled();
        $http.defaults.headers.common.javascript = true;
        $http.defaults.headers.common.language = navigator.language;
        $http.defaults.headers.common.timezoneOffset = new Date().getTimezoneOffset();
        $http.defaults.headers.common.colorDepth = screen.colorDepth;
    };

    $scope.loadAdminFunctions = function () {
        if ($scope.ad.tokenAdmin) {
            var manageSubTabAndImageSelected = function manageSubTabAndImageSelected(giftItemType) {
                var imageIndex = findImageIndexByType($scope.ad.view.imagesServiceView, giftItemType);
                var image = imageIndex !== -1 ? $scope.ad.view.imagesServiceView[imageIndex] : null;
                if (image) {
                    $scope.selectGiftItemImage(image);
                    $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 1;
                    $scope.ad.view.imagesServiceView.splice(0, 0, $scope.ad.view.imagesServiceView.splice(imageIndex, 1)[0]);
                } else {
                    imageIndex = findImageIndexByType($scope.ad.view.imagesCompanyView, giftItemType);
                    var _image = imageIndex !== -1 ? $scope.ad.view.imagesCompanyView[imageIndex] : null;
                    if (_image) {
                        $scope.selectGiftItemImage(_image);
                        $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 2;
                        $scope.ad.view.imagesCompanyView.splice(0, 0, $scope.ad.view.imagesCompanyView.splice(imageIndex, 1)[0]);
                    } else {
                        if ($scope.ad.view.currentGiftItemImage) {
                            $scope.ad.view.currentGiftItemImage.isSelected = false;
                        }
                        $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 1;
                    }
                }
            };

            var initDialogWebSiteEditorCtrl = function initDialogWebSiteEditorCtrl() {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/giftItemEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {});
                $scope.adjustModalPosition();
            };

            var findImageIndexByType = function findImageIndexByType(imagesView, giftItemType) {
                switch (giftItemType) {
                    case "mail":
                        return imagesView.findIndex(function (element) {
                            return element.id == $scope.ad.appAttributes.giftItemMailImageId;
                        });
                    case "delivery":
                        return imagesView.findIndex(function (element) {
                            return element.id == $scope.ad.appAttributes.giftItemDeliveryImageId;
                        });
                    case "printable":
                        return imagesView.findIndex(function (element) {
                            return element.id == $scope.ad.appAttributes.giftItemPrintableImageId;
                        });
                    default:
                        break;
                }
            };

            $scope.ad.view.gridOptions.disableResize = false;
            $scope.ad.view.gridOptions.disableDrag = false;

            $scope.addNewTemplate = function () {
                $scope.ad.view.cTemplate = { id: $scope.ad.view.templates.length + 1, label: "" };
            };
            $scope.saveTemplate = function (template) {
                if (template) {
                    var webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
                    if (!webSiteApp) {
                        webSiteApp = new App();
                        webSiteApp.setCode("webSite-template" + template.id);
                    }
                    $scope.saveLogo(false, webSiteApp);
                    $scope.saveTitle(false, webSiteApp);
                    $scope.saveMenu(false, webSiteApp);
                    $scope.saveDesignAttributes(false, webSiteApp);
                    $scope.saveWidgets(false, webSiteApp);
                    $scope.saveCategoryDisplay(false, webSiteApp);
                    var appAttr = webSiteApp.getAppAttribute("templateLabel");
                    if (appAttr) appAttr.value = template.label;else webSiteApp.addAppAttribute(new AppAttribute("templateLabel", template.label));
                    $scope.ad.view.templates.push(template);
                    $scope.ad.view.cTemplate = null;

                    AppSrv.save(webSiteApp);
                }
            };
            $scope.removeTemplate = function (template) {
                var index = $scope.ad.view.templates.indexOf(template);
                if (index != -1) {
                    var webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
                    if (webSiteApp) AppSrv.remove(webSiteApp);
                    var i = template.id + 1;
                    while (i <= $scope.ad.view.templates.length) {
                        webSiteApp = AppData.getAppByCode("webSite-template" + i);
                        if (webSiteApp) {
                            webSiteApp.code = "webSite-template" + (i - 1);
                            AppSrv.save(webSiteApp);
                        }
                        i++;
                    }
                    $scope.ad.view.templates.splice(index, 1);
                }
            };
            $scope.removeLogoImage = function () {
                $scope.ad.appAttributes.logoImageId = null;
                $scope.ad.view.logoImageUrl = null;
            };
            $scope.saveLogo = function (save, webSiteApp) {
                $scope.ad.view.logoEditPanel = false;

                webSiteApp = $scope.computeWebSiteApp();
                $scope.saveAppAttr(webSiteApp, "logoFontColor");
                $scope.saveAppAttr(webSiteApp, "logoShadowColor");
                $scope.saveAppAttr(webSiteApp, "logoText");
                $scope.saveAppAttr(webSiteApp, "logoImageId");
                if (save) AppSrv.save(webSiteApp);
            };

            $scope.saveTitle = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();

                var appAttr = webSiteApp.getAppAttribute("titleIsDisplayed");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.titleIsDisplayed ? "true" : "false";else webSiteApp.addAppAttribute(new AppAttribute("titleIsDisplayed", $scope.ad.appAttributes.titleIsDisplayed));
                appAttr = webSiteApp.getAppAttribute("titleHomeLabel");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.titleHomeLabel;else webSiteApp.addAppAttribute(new AppAttribute("titleHomeLabel", $scope.ad.appAttributes.titleHomeLabel));
                appAttr = webSiteApp.getAppAttribute("titleBgColorStart");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.titleBgColorStart;else webSiteApp.addAppAttribute(new AppAttribute("titleBgColorStart", $scope.ad.appAttributes.titleBgColorStart));
                appAttr = webSiteApp.getAppAttribute("titleBgColorEnd");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.titleBgColorEnd;else webSiteApp.addAppAttribute(new AppAttribute("titleBgColorEnd", $scope.ad.appAttributes.titleBgColorEnd));
                appAttr = webSiteApp.getAppAttribute("titleFontColor");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.titleFontColor;else webSiteApp.addAppAttribute(new AppAttribute("titleFontColor", $scope.ad.appAttributes.titleFontColor));
                $scope.ad.view.titleEditPanel = false;
                if (save) AppSrv.save(webSiteApp);
            };
            $scope.saveHomeTextHtml = function () {
                var webSiteApp = $scope.computeWebSiteApp();
                var appAttr = webSiteApp.getAppAttribute("homeTextHtml");
                if (!appAttr) {
                    appAttr = new AppAttribute("homeTextHtml", "");
                    appAttr.text = $scope.ad.appAttributes.homeTextHtml;
                    webSiteApp.addAppAttribute(appAttr);
                } else appAttr.text = $scope.ad.appAttributes.homeTextHtml;

                $scope.ad.view.homeTextEditPanel = false;
                AppSrv.save(webSiteApp);
            };
            $scope.saveWidgets = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();
                var appAttr;
                if ($scope.ad.view.homeWidgetView) {
                    appAttr = webSiteApp.getAppAttribute("homeWidget");
                    if (!appAttr) {
                        appAttr = new AppAttribute("homeWidget", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    } else // manage removing
                        if (appAttr.text && appAttr.text != '') {
                            var homeWidget = null;
                            try {
                                homeWidget = JSON.parse(appAttr.text);
                            } catch (e) {}

                            if (homeWidget) {
                                var inside;
                                for (var i = 0; i < homeWidget.widgets.length; i++) {
                                    if (homeWidget.widgets[i].type == 'object' && homeWidget.widgets[i].objectId) {
                                        inside = false;
                                        for (var j = 0; j < $scope.ad.view.homeWidgetView.widgetsView.length; j++) {
                                            if ($scope.ad.view.homeWidgetView.widgetsView[j].type == 'object' && $scope.ad.view.homeWidgetView.widgetsView[j].object && typeof $scope.ad.view.homeWidgetView.widgetsView[j].object.getModel == 'function') {
                                                var obj = $scope.ad.view.homeWidgetView.widgetsView[j].object.getModel();
                                                if (obj && obj.id == homeWidget.widgets[i].objectId) inside = true;
                                            }
                                        }if (!inside) //removed
                                            {
                                                var objectView = null;
                                                switch (homeWidget.widgets[i].objectType) {
                                                    case "service":
                                                        objectView = $scope.getServiceViewById(homeWidget.widgets[i].objectId);
                                                        break;
                                                    case "product":
                                                        objectView = $scope.getProductViewById(homeWidget.widgets[i].objectId);
                                                        break;
                                                    case "cure":
                                                        objectView = $scope.getCureViewById(homeWidget.widgets[i].objectId);
                                                        break;
                                                }
                                                if (objectView) {
                                                    var obj = objectView.getModel();
                                                    if (obj && obj.isOnHome) {
                                                        objectView.isOnHome = false;
                                                        if (homeWidget.widgets[i].objectType == "product") objectView.updateModel(true); //dont update quantity
                                                        else objectView.updateModel();
                                                    }
                                                }
                                            }
                                    }
                                }
                            }
                        }

                    appAttr.text = JSON.stringify($scope.ad.view.homeWidgetView.getObjectResource());
                    // Manage value isOnHome
                    for (var i = 0; i < $scope.ad.view.homeWidgetView.widgetsView.length; i++) {
                        if ($scope.ad.view.homeWidgetView.widgetsView[i].type == 'object' && $scope.ad.view.homeWidgetView.widgetsView[i].object) switch ($scope.ad.view.homeWidgetView.widgetsView[i].objectType) {
                            case "service":
                            case "cure":
                            case "loyaltyCard":
                                var obj = $scope.ad.view.homeWidgetView.widgetsView[i].object.getModel();
                                if (obj && !obj.isOnHome) {
                                    $scope.ad.view.homeWidgetView.widgetsView[i].object.isOnHome = true;
                                    $scope.ad.view.homeWidgetView.widgetsView[i].object.updateModel();
                                }
                                break;
                            case "product":
                                var obj = $scope.ad.view.homeWidgetView.widgetsView[i].object.getModel();
                                if (obj && !obj.isOnHome) {
                                    $scope.ad.view.homeWidgetView.widgetsView[i].object.isOnHome = true;
                                    $scope.ad.view.homeWidgetView.widgetsView[i].object.updateModel(true); //dont update quantity
                                }
                                break;
                        }
                    }
                }
                //homeGridWidgets
                if ($scope.ad.view.homeGridWidgetsView) {
                    appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
                    if (!appAttr) {
                        appAttr = new AppAttribute("homeGridWidgets", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    var widgets = [];
                    for (var i = 0; i < $scope.ad.view.homeGridWidgetsView.length; i++) {
                        widgets.push($scope.ad.view.homeGridWidgetsView[i].getObjectResource());
                    }
                    appAttr.text = JSON.stringify(widgets);
                }

                if (save) AppSrv.save(webSiteApp);
            };
            $scope.saveCategoryDisplay = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();
                var appAttr = null;
                var array = [];
                if ($scope.ad.view.categoryRootView) {
                    appAttr = webSiteApp.getAppAttribute("serviceCategoriesDisplay");
                    if (!appAttr) {
                        appAttr = new AppAttribute("serviceCategoriesDisplay", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    $scope.ad.view.categoryRootView.populateDisplayTypeResource(array);
                    appAttr.text = JSON.stringify(array);
                }
                if ($scope.ad.view.productCategoryRootView) {
                    appAttr = webSiteApp.getAppAttribute("productCategoriesDisplay");
                    if (!appAttr) {
                        appAttr = new AppAttribute("productCategoriesDisplay", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    array = [];
                    $scope.ad.view.productCategoryRootView.populateDisplayTypeResource(array);
                    appAttr.text = JSON.stringify(array);
                }
                if ($scope.ad.view.cureCategoryRootView) {
                    appAttr = webSiteApp.getAppAttribute("cureCategoriesDisplay");
                    if (!appAttr) {
                        appAttr = new AppAttribute("cureCategoriesDisplay", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    array = [];
                    $scope.ad.view.cureCategoryRootView.populateDisplayTypeResource(array);
                    appAttr.text = JSON.stringify(array);
                }
                if ($scope.ad.view.loyaltyCardCategoryRootView) {
                    appAttr = webSiteApp.getAppAttribute("loyaltyCardCategoriesDisplay");
                    if (!appAttr) {
                        appAttr = new AppAttribute("loyaltyCardCategoriesDisplay", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    array = [];
                    $scope.ad.view.loyaltyCardCategoryRootView.populateDisplayTypeResource(array);
                    appAttr.text = JSON.stringify(array);
                }
                if (save) AppSrv.save(webSiteApp);
            };

            $scope.saveAll = function (save, webSiteApp) {
                $scope.saveLogo(false, webSiteApp);
                $scope.saveTitle(false, webSiteApp);
                $scope.saveMenu(false, webSiteApp);
                $scope.saveDesignAttributes(false, webSiteApp);
                $scope.saveWidgets(false, webSiteApp);
                $scope.saveCategoryDisplay(false, webSiteApp);
                $scope.saveAdminAttributes(true, webSiteApp);
                $scope.saveGiftItemImages();
            };

            $scope.saveMenu = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();
                var appAttr = webSiteApp.getAppAttribute("menuIsDisplayed");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.menuIsDisplayed ? "true" : "false";else webSiteApp.addAppAttribute(new AppAttribute("menuIsDisplayed", $scope.ad.appAttributes.menuIsDisplayed));
                appAttr = webSiteApp.getAppAttribute("menuBgColorStart");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.menuBgColorStart;else webSiteApp.addAppAttribute(new AppAttribute("menuBgColorStart", $scope.ad.appAttributes.menuBgColorStart));
                appAttr = webSiteApp.getAppAttribute("menuBgColorEnd");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.menuBgColorEnd;else webSiteApp.addAppAttribute(new AppAttribute("menuBgColorEnd", $scope.ad.appAttributes.menuBgColorEnd));
                appAttr = webSiteApp.getAppAttribute("menuFontColor");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.menuFontColor;else webSiteApp.addAppAttribute(new AppAttribute("menuFontColor", $scope.ad.appAttributes.menuFontColor));
                appAttr = webSiteApp.getAppAttribute("menuShadowColor");
                if (appAttr) appAttr.value = $scope.ad.appAttributes.menuShadowColor;else webSiteApp.addAppAttribute(new AppAttribute("menuShadowColor", $scope.ad.appAttributes.menuShadowColor));
                $scope.ad.view.menuEditPanel = false;
                if (save) AppSrv.save(webSiteApp);
            };

            $scope.saveDesignAttributes = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();
                $scope.saveAppAttr(webSiteApp, "homeDisplayType");
                $scope.saveAppAttr(webSiteApp, "globalBgImage");
                $scope.saveAppAttr(webSiteApp, "globalBgColor");
                $scope.saveAppAttr(webSiteApp, "globalObjectColor");
                $scope.saveAppAttr(webSiteApp, "headerType");
                $scope.saveAppAttr(webSiteApp, "globalFontFamily");
                $scope.saveAppAttr(webSiteApp, "globalBgImageUseSlide");
                $scope.saveAppAttr(webSiteApp, "globalBgImageOverlay");
                $scope.saveAppAttr(webSiteApp, "footerBgColor");
                $scope.saveAppAttr(webSiteApp, "footerFontColor");
            };

            $scope.saveAdminAttributes = function (save, webSiteApp) {
                webSiteApp = $scope.computeWebSiteApp();
                $scope.saveAppAttr(webSiteApp, "homeLabel");
                $scope.saveAppAttr(webSiteApp, "displayAbout");
                $scope.saveAppAttr(webSiteApp, "aboutLabel");
                $scope.saveAppAttr(webSiteApp, "displayContact");
                $scope.saveAppAttr(webSiteApp, "contactLabel");
                $scope.saveAppAttr(webSiteApp, "displayServices");
                $scope.saveAppAttr(webSiteApp, "servicesLabel");
                $scope.saveAppAttr(webSiteApp, "servicesProductsLabel");
                $scope.saveAppAttr(webSiteApp, "servicesCuresLabel");
                $scope.saveAppAttr(webSiteApp, "displayProducts");
                $scope.saveAppAttr(webSiteApp, "productsLabel");
                $scope.saveAppAttr(webSiteApp, "displayCures");
                $scope.saveAppAttr(webSiteApp, "curesLabel");
                $scope.saveAppAttr(webSiteApp, "displayLoyaltyCards");
                $scope.saveAppAttr(webSiteApp, "loyaltyCardsLabel");
                $scope.saveAppAttr(webSiteApp, "giftsLabel");
                $scope.saveAppAttr(webSiteApp, "hasGiftItem");

                $scope.saveAppAttr(webSiteApp, "homeAbout");
                $scope.saveAppAttr(webSiteApp, "homeAboutSentence");
                $scope.saveAppAttr(webSiteApp, "homeOffer");
                $scope.saveAppAttr(webSiteApp, "homeOfferSentence");
                $scope.saveAppAttr(webSiteApp, "homeService");
                $scope.saveAppAttr(webSiteApp, "homeServiceSentence");
                $scope.saveAppAttr(webSiteApp, "homeCure");
                $scope.saveAppAttr(webSiteApp, "homeCureSentence");
                $scope.saveAppAttr(webSiteApp, "homeProduct");
                $scope.saveAppAttr(webSiteApp, "homeProductSentence");
                $scope.saveAppAttr(webSiteApp, "homeGiftItem");
                $scope.saveAppAttr(webSiteApp, "homeGiftItemSentence");
                $scope.saveAppAttr(webSiteApp, "homeLoyaltyCard");
                $scope.saveAppAttr(webSiteApp, "homeLoyaltyCardSentence");
                $scope.saveAppAttr(webSiteApp, "footerTime");
                $scope.saveAppAttr(webSiteApp, "footerAddress");
                $scope.saveAppAttr(webSiteApp, "footerMap");
                $scope.saveAppAttr(webSiteApp, "footerSocial");
                $scope.saveAppAttr(webSiteApp, "footerFacebook");
                $scope.saveAppAttr(webSiteApp, "footerTwitter");
                $scope.saveAppAttr(webSiteApp, "footerInstagram");
                $scope.saveAppAttr(webSiteApp, "footerPinterest");
                $scope.saveAppAttr(webSiteApp, "displayFacebook");
                $scope.saveAppAttr(webSiteApp, "autoValidateCustomerPost");
                $scope.saveAppAttr(webSiteApp, "displayCustomerPost");
                $scope.saveAppAttr(webSiteApp, "welcomePictureCustomerPost");
                $scope.saveAppAttr(webSiteApp, "customerPostLabel");
                $scope.saveAppAttr(webSiteApp, "facebookLabel");
                $scope.saveAppAttr(webSiteApp, "onlineBooking");
                $scope.saveAppAttr(webSiteApp, "allowChooseHr");
                $scope.saveAppAttr(webSiteApp, "allowBookingComment");
                $scope.saveAppAttr(webSiteApp, "bookingCommentSentence");
                $scope.saveAppAttr(webSiteApp, "hasBookingPayment");
                $scope.saveAppAttr(webSiteApp, "hasBookingPaymentAdvance");
                $scope.saveAppAttr(webSiteApp, "bookingPaymentAdvancePercent");
                $scope.saveAppAttr(webSiteApp, "hasBookingPaymentMandatory");
                $scope.saveAppAttr(webSiteApp, "hasBookingPaymentOnAmount");
                $scope.saveAppAttr(webSiteApp, "bookingPaymentOnAmount");
                $scope.saveAppAttr(webSiteApp, "nbBookingWeeks");
                $scope.saveAppAttr(webSiteApp, "nbBookingBeforeTime");
                $scope.saveAppAttr(webSiteApp, "triesTime");
                $scope.saveAppAttr(webSiteApp, "autoFilling");
                $scope.saveAppAttr(webSiteApp, "hasCurePayment");
                $scope.saveAppAttr(webSiteApp, "hasProductPayment");
                $scope.saveAppAttr(webSiteApp, "hasProductDelivery");
                $scope.saveAppAttr(webSiteApp, "hasProductDeliveryCharge");
                $scope.saveAppAttr(webSiteApp, "productDeliverySentence");
                $scope.saveAppAttr(webSiteApp, "productDeliveryCharge");
                $scope.saveAppAttr(webSiteApp, "hasLoyaltyCardPayment");
                $scope.saveAppAttr(webSiteApp, "hasServiceGift");
                $scope.saveAppAttr(webSiteApp, "hasGiftItemDelivery");
                $scope.saveAppAttr(webSiteApp, "giftItemDeliverySentence");
                $scope.saveAppAttr(webSiteApp, "hasGiftItemDeliveryCharge");
                $scope.saveAppAttr(webSiteApp, "giftItemDeliveryCharge");
                $scope.saveAppAttr(webSiteApp, "hasGiftItemMail");
                $scope.saveAppAttr(webSiteApp, "googleAnalyticsId");
                $scope.saveAppAttr(webSiteApp, "javascriptOnHeader", true);
                $scope.saveAppAttr(webSiteApp, "javascriptOnBody", true);

                if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.appAttributes.displayProducts = false;
                    $scope.ad.appAttributes.displayCures = false;
                    $scope.ad.appAttributes.displayLoyaltyCards = false;
                    $scope.ad.appAttributes.homeCure = false;
                    $scope.ad.appAttributes.homeProduct = false;
                    $scope.ad.appAttributes.homeGiftItem = false;
                    $scope.ad.appAttributes.homeLoyaltyCard = false;
                }
                // SPECIFIC FIELDS
                var images = ImageData.getActiveList("");
                var appAttr = webSiteApp.getAppAttribute("giftImageIds");
                if ($scope.ad.view.imagesGiftView.length != images.length || appAttr) //set only if specific
                    {
                        var giftImageIds = "";
                        for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++) {

                            giftImageIds = giftImageIds + $scope.ad.view.imagesGiftView[i].id;
                            if (i + 1 < $scope.ad.view.imagesGiftView.length) giftImageIds = giftImageIds + ";";
                        }

                        if (!appAttr) {
                            appAttr = new AppAttribute("giftImageIds", null);
                            webSiteApp.simpleAddAppAttribute(appAttr);
                        }
                        appAttr.text = giftImageIds;
                    }
                if ($scope.ad.view.aTableView) {
                    console.log("discountDays");
                    console.log($scope.ad.appAttributes.discountDays);

                    appAttr = webSiteApp.getAppAttribute("discountDays");
                    if (!appAttr) {
                        appAttr = new AppAttribute("discountDays", null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }
                    appAttr.text = JSON.stringify($scope.ad.appAttributes.discountDays);
                    console.log(appAttr);
                }

                if (save) {
                    if ($scope.ad.view.adminEditPanelTab == 1 && $scope.ad.view.adminEditPanelDesignTab == 1 && $scope.ad.view.adminEditPanelDesignBgTab == 2) {
                        AppSrv.save(webSiteApp, function () {
                            $timeout(function () {
                                parent.location.reload();
                            }, 1000);
                        });
                    } else {
                        AppSrv.save(webSiteApp, function () {
                            $scope.reloadLocation();
                        });
                    }
                    $scope.toggleAdmin();
                }
            };
            $scope.generateHomeGrids = function () {
                var question = gettextCatalog.getString("Souhaitez vous effacer la page et générer automatiquement les éléments ");

                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/generalConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["question"] = question + "?";
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {

                        var widgetView;
                        var x = 0;
                        var y = 0;
                        $scope.ad.view.homeGridWidgetsView = [];
                        if ($scope.ad.view.categoryRootView.categoriesView.length != 0 || $scope.ad.view.categoryRootView.servicesView.length != 0) {
                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setType('title', true);
                            widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeServiceSentence + "</h1>";
                            widgetView.width = 12;
                            widgetView.height = 2;
                            widgetView.x = 0;
                            widgetView.y = y;
                            widgetView.effect = null;
                            widgetView.fontColor = "black";
                            y += 2;
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            for (var i = 0; i < $scope.ad.view.categoryRootView.categoriesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.categoryRootView.categoriesView[i], "category", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            for (var i = 0; i < $scope.ad.view.categoryRootView.servicesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.categoryRootView.servicesView[i], "service", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }

                            y += widgetView.height;
                        }
                        x = 0;
                        if ($scope.ad.view.cureCategoryRootView.categoriesView.length != 0 || $scope.ad.view.cureCategoryRootView.curesView.length != 0) {
                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setType('title', true);
                            widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeCureSentence + "</h1>";
                            widgetView.width = 12;
                            widgetView.height = 2;
                            widgetView.x = 0;
                            widgetView.y = y;
                            y += 2;
                            widgetView.effect = null;
                            widgetView.fontColor = "black";
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            for (var i = 0; i < $scope.ad.view.cureCategoryRootView.categoriesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.cureCategoryRootView.categoriesView[i], "cureCategory", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            for (var i = 0; i < $scope.ad.view.cureCategoryRootView.curesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.cureCategoryRootView.curesView[i], "cure", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            y += widgetView.height;
                        }
                        if ($scope.ad.view.productCategoryRootView.categoriesView.length != 0 || $scope.ad.view.productCategoryRootView.productsView.length != 0) {
                            x = 0;
                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setType('title', true);
                            widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeProductSentence + "</h1>";
                            widgetView.width = 12;
                            widgetView.height = 2;
                            widgetView.x = 0;
                            widgetView.y = y;
                            y += 2;
                            widgetView.effect = null;
                            widgetView.fontColor = "black";
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            for (var i = 0; i < $scope.ad.view.productCategoryRootView.categoriesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.productCategoryRootView.categoriesView[i], "productCategory", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            for (var i = 0; i < $scope.ad.view.productCategoryRootView.productsView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.productCategoryRootView.productsView[i], "product", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            y += widgetView.height;
                        }
                        x = 0;
                        if ($scope.ad.appAttributes.hasGiftItem) {
                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setType('title', true);
                            widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeGiftItemSentence + "</h1>";
                            widgetView.width = 12;
                            widgetView.height = 2;
                            widgetView.x = 0;
                            widgetView.y = y;
                            y += 2;
                            widgetView.effect = null;
                            widgetView.fontColor = "black";
                            ;

                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setObject("delivery", "gift", true);
                            widgetView.fontColor = "black";
                            widgetView.shadowColor = "white";
                            widgetView.x = x;
                            x = x + 4;
                            widgetView.y = y;
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setObject("mailPrint", "gift", true);
                            widgetView.x = x;
                            widgetView.fontColor = "black";
                            widgetView.shadowColor = "white";

                            x = x + 4;
                            widgetView.y = y;
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setObject("mail", "gift", true);
                            widgetView.x = x;
                            widgetView.fontColor = "black";
                            widgetView.shadowColor = "white";

                            x = x + 4;
                            widgetView.y = y;
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            y += widgetView.height;
                        }
                        if ($scope.ad.view.loyaltyCardCategoryRootView.categoriesView.length != 0 || $scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView.length != 0) {
                            x = 0;
                            widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                            widgetView.setType('title', true);
                            widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeLoyaltyCardSentence + "</h1>";
                            widgetView.width = 12;
                            widgetView.height = 2;
                            widgetView.x = 0;
                            widgetView.y = y;
                            y += 2;
                            widgetView.effect = null;
                            widgetView.fontColor = "black";
                            $scope.ad.view.homeGridWidgetsView.push(widgetView);

                            for (var i = 0; i < $scope.ad.view.loyaltyCardCategoryRootView.categoriesView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.loyaltyCardCategoryRootView.categoriesView[i], "loyaltyCardCategory", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                            for (var i = 0; i < $scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView.length; i++) {
                                widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                widgetView.setObject($scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView[i], "loyaltyCard", true);
                                if (x == 12) {
                                    x = 0;
                                    y += widgetView.height;
                                }
                                widgetView.x = x;
                                x = x + 4;
                                widgetView.y = y;
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                        }
                    }
                });
            };

            $scope.saveAppAttr = function (webSiteApp, appAttrCode, isText) {
                if ($scope.ad.appAttributes[appAttrCode] !== undefined) {
                    var appAttr = webSiteApp.getAppAttribute(appAttrCode);
                    var value;
                    if (typeof $scope.ad.appAttributes[appAttrCode] === "boolean") value = $scope.ad.appAttributes[appAttrCode] ? "true" : "false";else if (typeof $scope.ad.appAttributes[appAttrCode] === "number") value = $scope.ad.appAttributes[appAttrCode].toString();else value = $scope.ad.appAttributes[appAttrCode];

                    if (!appAttr) {
                        appAttr = new AppAttribute(appAttrCode, null);
                        webSiteApp.simpleAddAppAttribute(appAttr);
                    }

                    if (isText !== undefined && isText) appAttr.text = value;else appAttr.value = value;
                }
            };

            $scope.toggleAdmin = function () {
                $scope.ad.adminEdition = !$scope.ad.adminEdition;
                if ($scope.ad.adminEdition) $scope.ad.adminPanel = false; //force true
                $scope.toggleMenu();
            };

            $scope.toggleMenu = function () {
                $scope.ad.adminPanel = !$scope.ad.adminPanel && $scope.ad.adminEdition;
                if ($scope.ad.adminPanel) $spMenu.show();else $spMenu.hide();
                $timeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 500);
            };

            $scope.onStartUploadImage = function () {
                $scope.ad.view.imageUploadRunning = true;
            };
            $scope.onUploadImageSuccess = function (message) {
                $scope.ad.view.imageUploadRunning = false;
                try {
                    var companyImage = JSON.parse(message);
                    if (companyImage && companyImage.urlPreview) {
                        $scope.ad.view.logoImageUrl = companyImage.urlPreview;
                        $scope.ad.appAttributes.logoImageId = companyImage.id;
                    }
                } catch (e) {
                    console.log('onUploadImageSuccess => JSON.parse error', e);
                }
            };

            $scope.onUploadGiftItemsImageSuccess = function (message) {
                $scope.ad.view.imageUploadRunning = false;
                try {
                    var companyImage = JSON.parse(message);
                    if (companyImage) {
                        $scope.ad.view.imagesCompanyView.unshift(companyImage);
                    }
                } catch (e) {
                    console.log('onUploadGiftItemsImageSuccess => JSON.parse error', e);
                }
            };

            $scope.onUploadImageBgSuccess = function (message) {
                $scope.ad.view.imageUploadRunning = false;
                try {
                    var companyImage = JSON.parse(message);
                    if (companyImage) {
                        $scope.ad.view.imagesBgCompanyView.push(companyImage);
                    }
                } catch (e) {
                    console.log('onUploadImageBgSuccess => JSON.parse error', e);
                }
            };

            $scope.onUploadImageAboutSuccess = function (message) {
                $scope.ad.view.imageUploadRunning = false;
                try {
                    var companyImage = JSON.parse(message);
                    if (companyImage) {
                        $scope.ad.view.imagesAboutCompanyView.push(companyImage);
                    }
                } catch (e) {
                    console.log('onUploadImageAboutSuccess => JSON.parse error', e);
                }
            };

            $scope.removeImageAboutCompanyView = function (companyImage) {
                var index = $scope.ad.view.imagesAboutCompanyView.indexOf(companyImage);
                if (index != -1) {
                    $scope.ad.view.imagesAboutCompanyView.splice(index, 1);
                    CompanyImageSrv.remove(companyImage);
                }
            };

            $scope.removeImageBgCompanyView = function (companyImage) {
                var index = $scope.ad.view.imagesBgCompanyView.indexOf(companyImage);
                if (index != -1) {
                    $scope.ad.view.imagesBgCompanyView.splice(index, 1);
                    CompanyImageSrv.remove(companyImage);
                }
            };

            $scope.imageIsSelectedForGift = function (image) {
                if ($scope.ad.view.imagesGiftView) return $scope.ad.view.imagesGiftView.indexOf(image) != -1;

                return false;
            };

            $scope.toggleGiftImage = function (image) {
                var index = $scope.ad.view.imagesGiftView.indexOf(image);
                if (index === -1) {
                    $scope.ad.view.imagesGiftView.push(image);
                } else {
                    $scope.ad.view.imagesGiftView.splice(index, 1);
                }
            };

            $scope.onImageBgUpdate = function () {
                if ($scope.ad.appAttributes.globalBgImageUseSlide) {
                    $scope.ad.appAttributes.globalBgImage = null;
                    $scope.ad.appAttributes.globalBgColor = null;
                }
            };

            $scope.adjustModalPosition = function () {
                $timeout(function () {
                    var elm = $(".modal");
                    if (elm && elm[0]) {
                        var height = $(window).height();
                        var scrollTop = $(window).scrollTop();
                        elm.animate({ top: scrollTop + 50, height: height - 100 });
                    } else $timeout(function () {
                        var elm = $(".modal");
                        if (elm && elm[0]) {
                            var height = $(window).height();
                            var scrollTop = $(window).scrollTop();
                            elm.animate({ top: scrollTop + 50, height: height - 100 });
                        } else $timeout(function () {
                            var elm = $(".modal");
                            if (elm && elm[0]) {
                                var height = $(window).height();
                                var scrollTop = $(window).scrollTop();
                                elm.animate({ top: scrollTop + 50, height: height - 100 });
                            }
                        }, 1000);
                    }, 500);
                }, 200);
            };

            $scope.editCategoryView = function (categoryView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/categoryEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["categoryView"] = categoryView;
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };
            $scope.editServiceView = function (serviceView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/serviceEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["serviceView"] = serviceView;
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };

            $scope.editProductView = function (productView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/productEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["productView"] = productView;
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };
            $scope.editCureView = function (cureView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/cureEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["cureView"] = cureView;
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };

            $scope.editHomeItemsView = function () {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/offerEditor.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };
            $scope.addWidget = function (array, first) {
                if (array) {
                    var newWidgetView = new WidgetView(null, array.length, false, $scope);

                    $scope.editWidgetView(newWidgetView, function () {
                        if (first) {
                            for (var i = 0; i < array.length; i++) {
                                array[i].y += newWidgetView.height;
                            }array.push(newWidgetView);
                            $timeout(function () {
                                window.dispatchEvent(new Event('resize'));
                            }, 500);
                        } else {
                            if (array.length) {
                                var maxY = array[0].y + array[0].height;
                                for (var i = 1; i < array.length; i++) {
                                    if (array[i].y + array[i].height > maxY) maxY = array[i].y + array[i].height;
                                }newWidgetView.y = maxY;
                            }
                            array.push(newWidgetView);
                        }
                    });
                }
            };

            $scope.createAndEditImgWidgetView = function (object) {
                if (object) {
                    var widgetView = object.createImgWidgetView();
                    if (widgetView) $scope.editWidgetView(widgetView);
                }
            };
            $scope.createAndEditSubWidgetView = function (object) {
                if (object) {
                    var widgetView = object.createSubWidgetView();
                    if (widgetView) {
                        if (object.subWidgetsView && object.subWidgetsView.length > 0) widgetView.y = object.subWidgetsView[object.subWidgetsView.length - 1].y + object.subWidgetsView[object.subWidgetsView.length - 1].height + 1;
                        $scope.editWidgetView(widgetView);
                    }
                }
            };
            $scope.editWidgetView = function (widgetView, endFunction) {
                if (widgetView) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: widgetView.isDefault ? '/partials-web/editor/defaultWidgetEditor.html' : '/partials-web/editor/widgetEditor.html',
                        controller: 'WebSiteEditorCtrl',
                        resolve: {
                            dialogsModel: function dialogsModel() {
                                var tableModel = [];
                                tableModel["widgetView"] = widgetView;
                                tableModel["ad"] = $scope.ad;
                                tableModel["parentScope"] = $scope;
                                return tableModel;
                            }
                        }
                    };

                    var d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) {
                            if (endFunction !== undefined) endFunction();
                        }
                    });
                    $scope.adjustModalPosition();
                }
            };
            $scope.changeOrder = function (categoryView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials-web/editor/categoryOrder.html',
                    controller: 'WebSiteEditorCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["categoryView"] = categoryView;
                            tableModel["ad"] = $scope.ad;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {}
                });
                $scope.adjustModalPosition();
            };

            $scope.editGiftItemImage = function (giftItemType) {
                $scope.ad.view.giftItemTypeSelected = giftItemType;
                manageSubTabAndImageSelected(giftItemType);
                initDialogWebSiteEditorCtrl();
            };

            $scope.selectGiftItemImage = function (image) {
                image.isSelected = true;
                if ($scope.ad.view.currentGiftItemImage !== image) {
                    if ($scope.ad.view.currentGiftItemImage) {
                        $scope.ad.view.currentGiftItemImage.isSelected = false;
                    }
                    $scope.ad.view.currentGiftItemImage = image;
                }
            };
        }
    };
}]);

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCureCategoryCtrl', ["$scope", "$rootScope", "$routeParams", "CureCategoryData", function ($scope, $rootScope, $routeParams, CureCategoryData) {
    $scope.dd = {
        currentCategoryId: parseInt($routeParams.categoryId)
    };
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCategoryView)
            {
                var category = CureCategoryData.getById($scope.dd.currentCategoryId);
                if (category) {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentCureCategoryView($scope.ad.view.cureCategoryRootView.getCategoryView(category), false);
                } else {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus.";
                }
            }
    });
}]);

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCureCtrl', ["$log", "$scope", "$anchorScroll", "$rootScope", "$routeParams", "$location", "CureData", "$timeout", function ($log, $scope, $anchorScroll, $rootScope, $routeParams, $location, CureData, $timeout) {
    $scope.currentCureId = parseInt($routeParams.cureId);
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCureView)
            {
                var cure = CureData.getById($scope.currentCureId);
                if (cure) {
                    $scope.ad.msgErrorCure = "";
                    $scope.setCurrentCureView($scope.ad.view.cureCategoryRootView.getCureView(cure), false);
                } else {
                    $scope.ad.msgErrorCure = "Nous sommes désolés mais cette cure n'existe plus ou ne peut plus être achetée.";
                }
                $timeout(function () {
                    if (window.FB) {
                        window.FB.XFBML.parse();
                    }
                }, 200);
            }
    });
}]);

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 11/05/2018
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteCustomerPostCtrl', ["$filter", "$log", "$scope", "$rootScope", "$routeParams", "$location", "$dialog", "CustomerPostData", "CustomerPostView", "gettextCatalog", "CompanyImageData", "ConstantsCustomerPosts", function ($filter, $log, $scope, $rootScope, $routeParams, $location, $dialog, CustomerPostData, CustomerPostView, gettextCatalog, CompanyImageData, ConstantsCustomerPosts) {

    $scope.dd = {
        displayPostMode: false,
        displayConfirmMessage: false,
        customersPostsDisplay: [],
        customersPostsNeedValidation: [],
        sortSelected: "rating.reverse",
        sort: "rating",
        sortReverse: true,
        averageNotation: 0,
        averageNotationDisplay: 0,
        nbActiveRating: 0,
        editedCustomerPostView: null,
        isWaitingForCallback: false,
        percent: {
            one: 0,
            two: 0,
            three: 0,
            four: 0,
            five: 0
        },
        nbRating: {
            one: 0,
            two: 0,
            three: 0,
            four: 0,
            five: 0
        },
        view: {
            postTitle: "",
            postMessage: "",
            postRate: 0,
            postImage: null
        },
        rating: {
            starsClass: []
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: { companyCode: $scope.ad.companyCode, type: 'customer' },
            maxChunkRetries: 1,
            chunkSize: 5 * 1024 * 1024,
            simultaneousUploads: 4,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: $scope.ad.currentUser.token }
        },
        error: {
            display: false,
            message: ""
        },
        colors: ConstantsCustomerPosts,
        starYellowCssClass: "fa fa-star star-y",
        starGreyCssClass: "fa fa-star star"
    };
    $scope.redirectToHomeWhenAccessIsNotGranted();

    $scope.getCharColor = function (firstName) {
        var color = $scope.dd.colors[$scope.getFirstLetterFirstName(firstName)];
        return color;
    };

    $scope.getFirstLetterFirstName = function (firstName) {
        if (firstName != null) return firstName.charAt(0);else return "?";
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            $scope.orderCustomersPost();
            $scope.initTabRating();
        }
    });

    $scope.initTabRating = function () {
        $scope.dd.rating.starsClass = [];
        $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
        $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
        $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
        $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
        $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
    };

    $scope.onSaveSuccess = function () {
        $scope.orderCustomersPost();
        $scope.clearPostView();
        $scope.dd.displayConfirmMessage = true;
        $scope.dd.displayPostMode = false;
    };

    $scope.saveCustomerPost = function () {
        $scope.dd.isWaitingForCallback = true;

        var cpView = new CustomerPostView(null, -1);
        cpView.companyImage = $scope.dd.view.postImage;
        cpView.customer = $scope.ad.view.customerView.getModel();
        cpView.rating = $scope.dd.view.postRate;
        cpView.customerAuthPublish = true;
        cpView.timeCreated = new Date();
        cpView.text = $scope.dd.view.postMessage;
        cpView.title = $scope.dd.view.postTitle;

        if ($scope.ad.appAttributes.autoValidateCustomerPost) {
            cpView.proAuthPublish = true;
            cpView.timePublished = new Date();
        } else {
            cpView.proAuthPublish = false;
            cpView.timePublished = null;
        }
        cpView.updateModel($scope.onSaveSuccess);
    };

    $scope.addRatingByNotation = function (customerPost) {
        if (customerPost.rating == 1) {
            $scope.dd.nbRating.one++;
        } else if (customerPost.rating == 2) {
            $scope.dd.nbRating.two++;
        } else if (customerPost.rating == 3) {
            $scope.dd.nbRating.three++;
        } else if (customerPost.rating == 4) {
            $scope.dd.nbRating.four++;
        } else if (customerPost.rating == 5) {
            $scope.dd.nbRating.five++;
        }
    };

    $scope.getAverageRating = function () {
        var nbRate = 0;
        var totalRate = 0;
        $scope.dd.nbRating.one = 0;
        $scope.dd.nbRating.two = 0;
        $scope.dd.nbRating.three = 0;
        $scope.dd.nbRating.four = 0;
        $scope.dd.nbRating.five = 0;

        for (var i = 0; i < $scope.dd.customersPostsDisplay.length; i++) {
            if (!$scope.dd.customersPostsDisplay[i].proAuthPublish) {
                continue;
            }
            if (isNaN($scope.dd.customersPostsDisplay[i].rating)) totalRate += 0;else {
                totalRate += $scope.dd.customersPostsDisplay[i].rating;
                $scope.addRatingByNotation($scope.dd.customersPostsDisplay[i]);
            }
            nbRate++;
        }
        if (nbRate > 0) {
            $scope.dd.percent.one = Math.round($scope.dd.nbRating.one * 100 / nbRate * 100) / 100;
            $scope.dd.percent.two = Math.round($scope.dd.nbRating.two * 100 / nbRate * 100) / 100;
            $scope.dd.percent.three = Math.round($scope.dd.nbRating.three * 100 / nbRate * 100) / 100;
            $scope.dd.percent.four = Math.round($scope.dd.nbRating.four * 100 / nbRate * 100) / 100;
            $scope.dd.percent.five = Math.round($scope.dd.nbRating.five * 100 / nbRate * 100) / 100;
            $scope.dd.averageNotation = totalRate / nbRate;
        }
        $scope.dd.averageNotationDisplay = $filter('smartNumber')($scope.dd.averageNotation, 2);
        $scope.dd.nbActiveRating = nbRate;
    };

    $scope.validateCustomerPost = function (customerPostView) {
        customerPostView.proAuthPublish = true;
        customerPostView.updateModel($scope.orderCustomersPost);
    };

    $scope.unValidateCustomerPost = function (customerPostView) {
        customerPostView.proAuthPublish = false;
        customerPostView.updateModel($scope.orderCustomersPost);
    };

    $scope.deleteCustomerPost = function (customerPostView) {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/removeConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = " " + gettextCatalog.getString("cet avis");

                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                var index = $scope.dd.customersPostsDisplay.indexOf(customerPostView);
                if (index != -1) {
                    $scope.dd.customersPostsDisplay.splice(index, 1);
                }
                var index = $scope.dd.customersPostsNeedValidation.indexOf(customerPostView);
                if (index != -1) {
                    $scope.dd.customersPostsNeedValidation.splice(index, 1);
                }
                customerPostView.removeModel();
                $scope.getAverageRating();
            }
        });
    };

    $scope.orderCustomersPost = function () {
        if ($scope.dd.sortSelected.indexOf('.reverse') !== -1) {
            $scope.dd.sortReverse = true;
            $scope.dd.sort = $scope.dd.sortSelected.replace('.reverse', '');
        } else {
            $scope.dd.sortReverse = false;
            $scope.dd.sort = $scope.dd.sortSelected;
        }

        var customersPosts = CustomerPostData.getActiveList();
        $scope.dd.customersPostsNeedValidation = [];
        $scope.dd.customersPostsDisplay = [];
        for (var i = 0; i < customersPosts.length; i++) {
            var customerPost = customersPosts[i];
            if (customerPost.text) {
                var customerPostView = new CustomerPostView(customerPost, CustomerPostData.getIndexOf(customerPost));

                if (customerPostView.customer == null) {
                    customerPostView.customer = {};
                    customerPostView.customer.lastName = customerPostView.getModel().customerLastName;
                    customerPostView.customer.firstName = customerPostView.getModel().customerFirstName;
                }
                customerPostView.text = customerPostView.text.replace(new RegExp('\n', 'g'), '<br/>');
                if (customersPosts[i].proAuthPublish) {
                    $scope.dd.customersPostsDisplay.push(customerPostView);
                } else {
                    $scope.dd.customersPostsNeedValidation.push(customerPostView);
                }
            }
        }
        $scope.getAverageRating();
    };

    $scope.clearPostView = function () {
        $scope.dd.view.postMessage = "";
        $scope.dd.view.postTitle = "";
        $scope.dd.view.postImage = null;
        $scope.dd.view.postRate = 0;
        $scope.dd.view.postImage = null;
        $scope.dd.error.display = false;
        $scope.dd.error.message = "";
        $scope.dd.displayPostMode = false;
        $scope.dd.displayConfirmMessage = false;
        $scope.dd.view.imageUploadRunning = false;
        $scope.dd.isWaitingForCallback = false;
        $scope.initTabRating();
    };

    $scope.onStarsClassChange = function (indexStar, isOnMouseOver) {
        if (!isOnMouseOver) indexStar = this.dd.view.postRate - 1;
        for (var i = 0; i <= indexStar; i++) {
            $scope.dd.rating.starsClass[i] = $scope.dd.starYellowCssClass;
        }
        for (var _i = indexStar + 1; _i < this.dd.rating.starsClass.length; _i++) {
            $scope.dd.rating.starsClass[_i] = $scope.dd.starGreyCssClass;
        }
    };

    $scope.onChangeRate = function (rate) {
        $scope.dd.view.postRate = rate;
        $scope.onStarsClassChange(rate - 1);
    };

    $scope.onUploadImageSuccess = function (message) {
        $scope.dd.view.imageUploadRunning = false;
        try {
            var companyImage = JSON.parse(message);
            $scope.dd.view.postImage = companyImage;
            if (CompanyImageData.getById(companyImage.id) == null) {
                CompanyImageData.add(companyImage);
            }
        } catch (e) {
            console.log('onUploadImageSuccess JSON.parse error', e);
        }
    };

    $scope.onUploadImageError = function (message) {
        $scope.dd.view.imageUploadRunning = false;
        $scope.dd.error.display = true;
        $scope.dd.error.message = gettextCatalog.getString("Impossible d'importer l'image sélectionnée.");
    };

    $scope.onStartUploadImage = function () {
        $scope.dd.view.imageUploadRunning = true;
    };

    $scope.canPost = function () {
        if ($scope.dd.view.postTitle == null || $scope.dd.view.postTitle === "" || $scope.dd.view.postMessage == null || $scope.dd.view.postMessage === "" || $scope.dd.view.postRate === 0 || $scope.dd.view.imageUploadRunning) {
            $scope.dd.error.display = true;
            return false;
        }
        $scope.dd.error.display = false;
        return true;
    };

    $scope.displayErrorMessage = function () {
        if ($scope.dd.view.postTitle == null || $scope.dd.view.postTitle == "" || $scope.dd.view.postMessage == null || $scope.dd.view.postMessage == "") {
            $scope.dd.error.message = gettextCatalog.getString("Veuillez renseigner les champs obligatoires (Titre, Message).");
        } else if ($scope.dd.view.imageUploadRunning == true) {
            $scope.dd.error.message = gettextCatalog.getString("L'image est en cours de téléchargement, veuillez attendre la fin du téléchargement pour valider votre avis.");
        } else if ($scope.dd.view.postRate === 0) {
            $scope.dd.error.message = gettextCatalog.getString("Veuillez ajouter une note en cliquant sur une des étoiles avant de poster votre avis.");
        }
    };
}]);

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteEditorCtrl', ["$scope", "$filter", "dialog", "dialogsModel", "$dialog", "CompanyImageSrv", "AppAttribute", "AppData", "App", "AppSrv", "WidgetView", "$timeout", "CategoryView", "CureCategoryView", "ProductCategoryView", "LoyaltyCardCategoryView", "LanguageManager", function ($scope, $filter, dialog, dialogsModel, $dialog, CompanyImageSrv, AppAttribute, AppData, App, AppSrv, WidgetView, $timeout, CategoryView, CureCategoryView, ProductCategoryView, LoyaltyCardCategoryView, LanguageManager) {
    $scope.ad = dialogsModel.ad;
    $scope.parentScope = dialogsModel.parentScope;
    var token = $scope.ad.tokenAdmin;
    $scope.dd = {
        view: {
            editType: dialogsModel.editType,
            visible: true,
            displayError: false,
            tab: 0,
            subTab: $scope.ad.view.dialogWebSiteEditorCtrl.subTab,
            tabOffer: 0,
            edited: {
                categoryView: dialogsModel.categoryView,
                serviceView: dialogsModel.serviceView,
                productView: dialogsModel.productView,
                cureView: dialogsModel.cureView,
                loyaltyCardView: dialogsModel.loyaltyCardView,
                widgetView: dialogsModel.widgetView
            },
            imageUploadRunning: false,
            serviceCategoryRootView: $scope.ad.view.categoryRootView, //for selector
            cServiceCategoryView: $scope.ad.view.categoryRootView,
            cProductCategoryView: $scope.ad.view.productCategoryRootView,
            cCureCategoryView: $scope.ad.view.cureCategoryRootView,
            cLoyaltyCardCategoryView: $scope.ad.view.loyaltyCardCategoryRootView,
            previousHomeItemsView: $scope.ad.view.homeItemsView.slice(0),
            hsHr: $scope.ad.view.humanResourcesView.length != 0,
            hsPr: $scope.ad.view.physicalResourcesView.length != 0
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: null,
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            chunkSize: 1024 * 1024 * 5,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: token }
        },
        timeoutReload: null
    };

    if (dialogsModel.categoryView) {
        if (dialogsModel.categoryView instanceof CategoryView) $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'service' };
        if (dialogsModel.categoryView instanceof CureCategoryView) $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'cure' };
        if (dialogsModel.categoryView instanceof ProductCategoryView) $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'product' };
        if (dialogsModel.categoryView instanceof LoyaltyCardCategoryView) $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'loyaltyCard' };
    }
    if (dialogsModel.serviceView) {
        $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'service' };
        dialogsModel.serviceView.initSkills($scope.ad.view.humanResourcesView, $scope.ad.view.physicalResourcesView);
        if (!dialogsModel.serviceView.getModel()) $scope.dd.view.tab = 1;
    }
    if (dialogsModel.productView) {
        $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'product' };
        if (!dialogsModel.productView.getModel()) $scope.dd.view.tab = 1;
    }

    if (dialogsModel.cureView) {
        $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'cure' };
        if (!dialogsModel.cureView.getModel()) $scope.dd.view.tab = 1;
    }
    if (dialogsModel.loyaltyCardView) {
        $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'loyaltyCard' };
        if (!dialogsModel.loyaltyCardView.getModel()) $scope.dd.view.tab = 1;
    }

    if (dialogsModel.widgetView) {
        $scope.dd.flowConfig.query = { companyCode: $scope.ad.companyCode, type: 'widget' };
        dialogsModel.widgetView.displaySelectorLarge = dialogsModel.widgetView.widgetsView.length == 0;
        if ($scope.dd.view.edited.widgetView.type == 'default-offer' || $scope.dd.view.edited.widgetView.type == 'fullscreen-offer' || $scope.dd.view.edited.widgetView.widgetsView.length > 0) $scope.dd.view.tabOffer = 1;
    }

    console.log($scope.dd.view);
    $scope.close = function () {
        dialog.close(true);
    };

    $scope.saveEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView.updateModel();
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
        dialog.close(true);
    };
    $scope.cancelEditedCategory = function () {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
        dialog.close(false);
    };
    $scope.saveEditedService = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.edited.serviceView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.serviceView = null;
            dialog.close(true);
        }
    };
    $scope.cancelEditedService = function () {
        $scope.dd.view.edited.serviceView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.serviceView = null;
        dialog.close(false);
    };
    $scope.duplicateService = function (serviceView) {
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged()) $scope.dd.view.edited.serviceView.updateModel();

        $scope.dd.view.edited.serviceView = serviceView.getClone();
        if ($scope.dd.view.edited.serviceView.label && $scope.dd.view.edited.serviceView.label != '') $scope.dd.view.edited.serviceView.label = "Copie de " + $scope.dd.view.edited.serviceView.label;
        if (serviceView.parentCategoryView) {
            serviceView.parentCategoryView.addServiceView($scope.dd.view.edited.serviceView);
            if (serviceView.parentCategoryView.image && serviceView.parentCategoryView.image !== null) $scope.dd.view.edited.serviceView.setImage(serviceView.parentCategoryView.image, true);
        }
    };

    $scope.saveEditedProduct = function () {
        if ($scope.dd.view.edited.productView) {
            $scope.dd.view.edited.productView.updateModel(true); //don't save quantity
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.productView = null;
            $scope.displayChangeMsg = false;
            $scope.dd.view.filterProductsView = null;
            $scope.dd.view.filter = "";
            dialog.close(true);
        }
    };
    $scope.cancelEditedProduct = function () {
        if ($scope.dd.view.edited.productView) {
            $scope.dd.view.edited.productView.reloadModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.productView = null;
            $scope.dd.view.filterProductsView = null;
            $scope.dd.view.filter = "";
            $scope.displayChangeMsg = false;
            dialog.close(false);
        }
    };
    $scope.saveEditedCure = function () {
        if ($scope.dd.view.edited.cureView) {
            $scope.dd.view.edited.cureView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.cureView = null;
            $scope.displayChangeMsg = false;
            dialog.close(true);
        }
    };
    $scope.cancelEditedCure = function () {
        $scope.dd.view.edited.cureView.reloadModel();
        $scope.dd.view.displayError = false;

        $scope.dd.view.edited.cureView = null;
        $scope.displayChangeMsg = false;
        dialog.close(false);
    };
    $scope.saveEditedLoyaltyCard = function () {
        if ($scope.dd.view.edited.loyaltyCardView) {
            $scope.dd.view.edited.loyaltyCardView.updateModel();
            $scope.dd.view.displayError = false;

            $scope.dd.view.edited.loyaltyCardView = null;
            $scope.displayChangeMsg = false;
            dialog.close(true);
        }
    };

    $scope.cancelEditedLoyaltyCard = function () {
        $scope.dd.view.edited.loyaltyCardView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.loyaltyCardView = null;
        $scope.displayChangeMsg = false;
        dialog.close(false);
    };

    $scope.saveEditedGiftItem = function () {
        saveEditedGiftItemByType($scope.ad.view.giftItemTypeSelected, $scope.ad.view.currentGiftItemImage);
        $scope.ad.view.giftItemTypeSelected = "";
        dialog.close(false);
    };

    function saveEditedGiftItemByType(giftItemTypeSelected, image) {
        switch (giftItemTypeSelected) {
            case "delivery":
                $scope.ad.view.domainView.saveGiftItemDeliveryImage(image);
                break;
            case "printable":
                $scope.ad.view.domainView.saveGiftItemPrintableImage(image);
                break;
            case "mail":
                $scope.ad.view.domainView.saveGiftItemMailImage(image);
                break;
            default:
                break;
        }
    }

    $scope.cancelEditedGiftItem = function () {
        dialog.close(false);
    };

    $scope.onStartUploadImage = function (message) {
        $scope.dd.view.imageUploadRunning = true;
    };

    $scope.initGiftItemFlowConfig = function () {
        $scope.dd.flowConfig.query = {
            companyCode: $scope.ad.companyCode,
            type: 'giftItem'
        };
        return $scope.dd.flowConfig;
    };

    $scope.onUploadImageSuccess = function (message) {
        $scope.dd.view.imageUploadRunning = false;
        var companyImage = null;
        try {
            companyImage = JSON.parse(message);
            $scope.ad.view.imagesCompanyView.unshift(companyImage);
            if (companyImage && companyImage.type === "giftItem") {
                $scope.updateCurrentGiftItemImage(companyImage);
            } else {
                if ($scope.dd.view.edited.serviceView) {
                    $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
                }
                if ($scope.dd.view.edited.categoryView) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
                }
                if ($scope.dd.view.edited.productView) {
                    $scope.dd.view.edited.productView.setCompanyImage(companyImage);
                }
                if ($scope.dd.view.edited.cureView) {
                    $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
                }
                if ($scope.dd.view.edited.loyaltyCardView) {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
                }
                if ($scope.dd.view.edited.widgetView) {
                    $scope.dd.view.edited.widgetView.setImage(companyImage, !$scope.dd.view.edited.widgetView.pWidgetView);
                }
            }
        } catch (error) {
            console.error("WebSiteEditorCtrl.onUploadImageSuccess: %s, JSON: {%s} ", error.message, message);
        }
    };

    $scope.imageIsSelected = function (image) {
        if ($scope.dd.view.edited.serviceView) {
            if (!$scope.dd.view.edited.serviceView.companyImage && $scope.dd.view.edited.serviceView.image === image) return true;
        } else if ($scope.dd.view.edited.productView) {
            if (!$scope.dd.view.edited.productView.companyImage && $scope.dd.view.edited.productView.image === image) return true;
        } else if ($scope.dd.view.edited.cureView) {
            if (!$scope.dd.view.edited.cureView.companyImage && $scope.dd.view.edited.cureView.image === image) return true;
        } else if ($scope.dd.view.edited.loyaltyCardView) {
            if (!$scope.dd.view.edited.loyaltyCardView.companyImage && $scope.dd.view.edited.loyaltyCardView.image === image) return true;
        } else if ($scope.dd.view.edited.categoryView && !$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image) return true;else if ($scope.dd.view.edited.widgetView && $scope.dd.view.edited.widgetView.img == image) return true;

        return false;
    };

    $scope.companyImageIsSelected = function (companyImage) {
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.companyImage === companyImage) return true;

        if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.companyImage === companyImage) return true;

        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.companyImage === companyImage) return true;

        if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.companyImage === companyImage) return true;

        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage) return true;

        if ($scope.dd.view.edited.widgetView && $scope.dd.view.edited.widgetView.img == companyImage) return true;

        return false;
    };

    $scope.setImage = function (image) {
        if ($scope.dd.view.edited.serviceView) {
            if (image === $scope.dd.view.edited.serviceView.image) {
                if ($scope.dd.view.edited.serviceView.image != null) {
                    $scope.dd.view.edited.serviceView.setImage(null);
                } else {
                    $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.serviceView.setImage(image);
            } else {
                $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
            }
        }
        if ($scope.dd.view.edited.productView) {
            if (image === $scope.dd.view.edited.productView.image) {
                if ($scope.dd.view.edited.productView.image != null) {
                    $scope.dd.view.edited.productView.setImage(null);
                } else {
                    $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.productView.setImage(image);
            } else {
                $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
            }
        }
        if ($scope.dd.view.edited.cureView) {
            if (image === $scope.dd.view.edited.cureView.image) {
                if ($scope.dd.view.edited.cureView.image != null) {
                    $scope.dd.view.edited.cureView.setImage(null);
                } else {
                    $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.cureView.setImage(image);
            } else {
                $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
            }
        }
        if ($scope.dd.view.edited.loyaltyCardView) {
            if (image === $scope.dd.view.edited.loyaltyCardView.image) {
                if ($scope.dd.view.edited.loyaltyCardView.image != null) {
                    $scope.dd.view.edited.loyaltyCardView.setImage(null);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.loyaltyCardView.setImage(image);
            } else {
                $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
            }
        }
        if ($scope.dd.view.edited.categoryView) {
            if (image === $scope.dd.view.edited.categoryView.image) {
                if ($scope.dd.view.edited.categoryView.image != null) {
                    $scope.dd.view.edited.categoryView.setImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.categoryView.setImage(image);
            } else {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
        if ($scope.dd.view.edited.widgetView) {
            if (image) {
                $scope.dd.view.edited.widgetView.setImage(image, !$scope.dd.view.edited.widgetView.pWidgetView);
            }
        }
    };
    $scope.setCompanyImage = function (companyImage) {
        if ($scope.dd.view.edited.serviceView) {
            if (companyImage === $scope.dd.view.edited.serviceView.companyImage) {
                if ($scope.dd.view.edited.serviceView.companyImage != null) {
                    $scope.dd.view.edited.serviceView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
            }
        }
        if ($scope.dd.view.edited.productView) {
            if (companyImage === $scope.dd.view.edited.productView.companyImage) {
                if ($scope.dd.view.edited.productView.companyImage != null) {
                    $scope.dd.view.edited.productView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.productView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
            }
        }
        if ($scope.dd.view.edited.cureView) {
            if (companyImage === $scope.dd.view.edited.cureView.companyImage) {
                if ($scope.dd.view.edited.cureView.companyImage != null) {
                    $scope.dd.view.edited.cureView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
            }
        }
        if ($scope.dd.view.edited.loyaltyCardView) {
            if (companyImage === $scope.dd.view.edited.loyaltyCardView.companyImage) {
                if ($scope.dd.view.edited.loyaltyCardView.companyImage != null) {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
            }
        }
        if ($scope.dd.view.edited.categoryView) {
            if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                if ($scope.dd.view.edited.categoryView.companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
        if ($scope.dd.view.edited.widgetView) {
            if (companyImage) {
                $scope.dd.view.edited.widgetView.setImage(companyImage, !$scope.dd.view.edited.widgetView.pWidgetView);
            }
        }
    };

    $scope.updateCurrentGiftItemImage = function (image) {
        image.isSelected = !image.isSelected;
        if ($scope.ad.view.currentGiftItemImage !== image) {
            if ($scope.ad.view.currentGiftItemImage) {
                $scope.ad.view.currentGiftItemImage.isSelected = false;
            }
            $scope.ad.view.currentGiftItemImage = image;
        }
        if (!image.isSelected) {
            $scope.ad.view.currentGiftItemImage = null;
        }
    };

    $scope.openDeletedServiceViewConfirmDialog = function () {
        if ($scope.dd.view.edited.serviceView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.serviceView.label;
                        return tableModel;
                    }
                }
            };
            $scope.dd.view.visible = false;
            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.removeEditedService();
                    dialog.close(true);
                } else $scope.dd.view.visible = true;
            });
        }
    };

    $scope.openDeletedCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    }
                }
            };
            $scope.dd.view.visible = false;
            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.removeEditedCategory();
                    dialog.close(true);
                } else $scope.dd.view.visible = true;
            });
        }
    };

    $scope.removeEditedService = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.edited.serviceView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.serviceView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeServiceView($scope.dd.view.edited.serviceView);

            $scope.dd.view.edited.serviceView = null;
            $scope.displayChangeMsg = false;
        }
    };

    $scope.removeEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }
    };

    $scope.removeImageServiceCompanyView = function (companyImage) {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/removeConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = companyImage.label;
                    return tableModel;
                }
            }
        };
        $scope.dd.view.visible = false;
        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                var index = $scope.ad.view.imagesCompanyView.indexOf(companyImage);
                if (index != -1) {
                    $scope.ad.view.imagesCompanyView.splice(index, 1);
                    CompanyImageSrv.remove(companyImage);
                    saveEditedGiftItemByType($scope.ad.view.giftItemTypeSelected, null);
                }
            }
            $scope.dd.view.visible = true;
        });
    };

    $scope.changeHomeServicePositionView = function (itemView, indexTarget) {
        //Change the category position
        // This : parentCategory
        // serviceView : service to move to indexTarget

        var index = $scope.ad.view.homeItemsView.indexOf(itemView);
        if (indexTarget != -1 && index != -1 && indexTarget <= $scope.ad.view.homeItemsView.length) {
            $scope.ad.view.homeItemsView.splice(index, 1); //remove it
            if (indexTarget == $scope.ad.view.homeItemsView.length) $scope.ad.view.homeItemsView.push(itemView);else $scope.ad.view.homeItemsView.splice(indexTarget, 0, itemView); //insert
            $scope.updateHomeOrder();
        }
    };

    $scope.updateHomeOrder = function () {
        for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++) {
            $scope.ad.view.homeItemsView[i].item.homeOrder = i;
        }
    };

    $scope.toggleHomeItem = function (itemView, type) {
        var index = $scope.getHomeItemIndex(itemView);
        if (index == -1) {
            $scope.ad.view.homeItemsView.push({ type: type, item: itemView, active: false });
            itemView.isOnHome = true;
        } else {
            $scope.ad.view.homeItemsView.splice(index, 1); //remove
            itemView.isOnHome = false;
        }
        $scope.updateHomeOrder();
    };

    $scope.getHomeItemIndex = function (item) {
        for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++) {
            if ($scope.ad.view.homeItemsView[i].item == item) return i;
        }return -1;
    };

    $scope.cancelHomeItems = function () {
        $scope.ad.view.homeItemsView = $scope.dd.view.previousHomeItemsView;
        for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++) {
            $scope.ad.view.homeItemsView[i].item.reloadModel();
        }dialog.close(false);
    };

    $scope.saveHomeItems = function () {
        var saveArray = [];
        var item;
        for (var i = 0; i < $scope.dd.view.previousHomeItemsView.length; i++) {
            item = $scope.dd.view.previousHomeItemsView[i].item.getModel();
            if (item && $scope.dd.view.previousHomeItemsView[i].item.isOnHome != item.isOnHome) saveArray.push($scope.dd.view.previousHomeItemsView[i].item);
        }

        for (var i = 0; i < $scope.ad.view.homeItemsView.length; i++) {
            item = $scope.ad.view.homeItemsView[i].item.getModel();
            if (item && ($scope.ad.view.homeItemsView[i].item.isOnHome != item.isOnHome || $scope.ad.view.homeItemsView[i].item.homeOrder != item.homeOrder) && saveArray.indexOf($scope.ad.view.homeItemsView[i].item) == -1) saveArray.push($scope.ad.view.homeItemsView[i].item);
        }
        for (var i = 0; i < saveArray.length; i++) {
            saveArray[i].updateModel();
        }$scope.ad.view.homeItemsView = $filter('orderBy')($scope.ad.view.homeItemsView.slice(0), 'item.homeOrder'); //force reload
        dialog.close(true);
    };

    $scope.updateGrid = function () {
        if (!$scope.dd.timeoutReload) {
            var array = $scope.ad.view.homeItemsView;
            $scope.ad.view.homeItemsView = null;
            $scope.dd.timeoutReload = $timeout(function () {
                $scope.ad.view.homeItemsView = array;
                $scope.dd.timeoutReload = null;
            }, 2000);
        }
    };
    $scope.editSubWidgetView = function (widgetView, editType) {
        if (widgetView.type == 'video') return;
        if (widgetView.type == 'object' && editType == 'object') {
            console.log($scope.parentScope);
            switch (widgetView.objectType) {
                case "category":
                case "cureCategory":
                case "productCategory":
                case "loyaltyCardCategory":
                    $scope.parentScope.editCategoryView(widgetView.object);
                    break;
                case "service":
                    $scope.parentScope.editServiceView(widgetView.object);
                    break;
                case "product":
                    $scope.parentScope.editProductView(widgetView.object);
                    break;
                case "cure":
                    $scope.parentScope.editCureView(widgetView.object);
                    break;
                case "gift":
                    break;
            }
            return;
        }

        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials-web/editor/subWidgetEditor.html',
            controller: 'WebSiteEditorCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["widgetView"] = widgetView;
                    tableModel["ad"] = $scope.ad;
                    tableModel["editType"] = editType;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {}
        });
        //$scope.adjustModalPosition();
        $timeout(function () {
            var elm = $(".modal");
            if (elm && elm[0]) {
                var height = $(window).height();
                var scrollTop = $(window).scrollTop();
                elm.animate({ top: scrollTop + 50, height: height - 100 });
            } else $timeout(function () {
                var elm = $(".modal");
                if (elm && elm[0]) {
                    var height = $(window).height();
                    var scrollTop = $(window).scrollTop();
                    elm.animate({ top: scrollTop + 50, height: height - 100 });
                }
            }, 1000);
        }, 500);
    };

    $scope.saveDefaultWidget = function (widgetView) {
        if (widgetView) {
            for (var i = 0; i < $scope.ad.view.homeGridWidgetsView.length; i++) {
                $scope.ad.view.homeGridWidgetsView[i].updateFromDefault(widgetView);
            }var webSiteApp = AppData.getAppByCode("webSite");
            if (!webSiteApp) {
                webSiteApp = new App();
                webSiteApp.setCode("webSite");
            }
            var appAttr = webSiteApp.getAppAttribute("defaultWidget");
            if (!appAttr) {
                appAttr = new AppAttribute("defaultWidget", null);
                webSiteApp.simpleAddAppAttribute(appAttr);
            }
            appAttr.text = JSON.stringify(widgetView.getObjectResource());

            AppSrv.save(webSiteApp);
            dialog.close(true);
        }
    };

    $scope.saveWidgets = function (widgetView) {
        if (widgetView && widgetView.object) //save object
            {
                widgetView.object.updateModel();
            }
        dialog.close(true);
    };

    $scope.removeWidget = function (widgetView) {
        var index = $scope.ad.view.homeGridWidgetsView.indexOf(widgetView);
        if (index != -1) $scope.ad.view.homeGridWidgetsView.splice(index, 1);
        $scope.saveWidgets();
    };
    $scope.cancelWidgetView = function (widgetView) {
        if (widgetView) if (widgetView.type == "fullscreen-offer" || widgetView.type == "default-offer") {
            $scope.parentScope.loadHomeWidgetView(null, true);
        } else {
            var webSiteApp = AppData.getAppByCode("webSite");
            if (webSiteApp) {

                var appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
                if (appAttr && appAttr.text && appAttr.text != '') {
                    var homeGridWidgets = null;
                    try {
                        homeGridWidgets = JSON.parse(appAttr.text);
                    } catch (e) {
                        console.log('cancelWidgetView SON.parse error', e);
                    }

                    if (homeGridWidgets) {
                        if (widgetView.index != -1 && widgetView.index < homeGridWidgets.length) $scope.ad.view.homeGridWidgetsView[widgetView.index].loadDataFrom(homeGridWidgets[widgetView.index], true);
                    }
                }
            }
        }
        dialog.close(false);
    };

    if (dialogsModel.serviceView) dialogsModel.serviceView.initSkills($scope.ad.view.humanResourcesView, $scope.ad.view.physicalResourcesView);
}]);

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteForgotPwdCtrl', ["$log", "$scope", "$rootScope", "$routeParams", "Auth", "CustomerSrv", "CustomerView", "CustomerData", "WebPreLoaderData", "Constants", function ($log, $scope, $rootScope, $routeParams, Auth, CustomerSrv, CustomerView, CustomerData, WebPreLoaderData, Constants) {
    $scope.dd = {
        view: {
            waitServerResponse: false,
            mailSent: false,
            mailNotSent: false,
            errorMessage: null
        }
    };

    $scope.$watch('ad.view.loaded', function (newValue, oldValue) {
        if (newValue) {
            if ($routeParams.token && $routeParams.email) //received change pwd request
                {
                    Auth.loginToWebSiteByToken($routeParams.email, WebPreLoaderData.companyCode, $routeParams.token);
                    CustomerSrv.getByEmail($routeParams.email, function (customer) {
                        if (!$scope.ad.view.customerView) {
                            $scope.ad.view.customerView = new CustomerView(customer, CustomerData.getIndexOf(customer), $scope);
                            $scope.ad.view.customerView.initCustomerHistoryDatas(customer);
                        }
                        $scope.ad.customerConnected = true;
                    }, function () {
                        //error
                        //remove cookie and login Anonymous
                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                        $scope.loginAnonymous();
                    });
                }
        }
    });

    $scope.afterSaveSuccess = function (customer) {
        $scope.dd.view.waitServerResponse = false;
        console.log("afterSaveSuccess");
        console.log(customer);
        if (customer != null) {
            $scope.ad.view.customerView.password = null; //hide by security
            $scope.ad.view.customerView.passwordAgain = null; //hide by security
            $scope.ad.view.customerView.currentPassword = null; //hide by security
            $scope.ad.view.customerView.loadDataFrom(customer);
            $scope.openLocation('account');
        }
    };
    $scope.afterSaveError = function (errorCode, errorMessage) {
        console.log(errorMessage);
        $scope.dd.view.errorMessage = errorMessage;
        $scope.dd.view.waitServerResponse = false;
    };
    $scope.changePwd = function () {
        console.log("changePwd");
        console.log($scope.ad.view.customerView);
        if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse) if ($scope.ad.view.customerView.canChangePwdOnWeb !== undefined && $scope.ad.view.customerView.canChangePwdOnWeb()) {
            $scope.dd.view.waitServerResponse = true;
            var customer = $scope.ad.view.customerView.getModel();
            $scope.ad.view.customerView.copyDataTo(customer);
            CustomerSrv.changePwd(customer, $scope.afterSaveSuccess, $scope.afterSaveError);
        } else $scope.dd.view.displayError = true;
    };

    $scope.forgotPwd = function () {
        if ($scope.ad.view.customerView && $scope.ad.view.customerView.email && $scope.ad.view.customerView.email != "") {
            var emailVerification = $scope.validateEmailFormat($scope.ad.view.customerView.email);
            if (emailVerification) {
                $scope.dd.view.waitServerResponse = true;
                CustomerSrv.forgotPwd($scope.ad.view.customerView.email, function () {
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.mailSent = true;
                    $scope.dd.view.errorMessage = null;
                }, function (message) {
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.mailNotSent = true;
                    $scope.dd.view.errorMessage = message;
                });
            }
        }
    };

    $scope.validateEmailFormat = function (email) {
        var regex = new RegExp(Constants.EMAIL, 'i');
        return regex.test(email);
    };
}]);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteGiftItemCtrl', ["$log", "$scope", "$anchorScroll", "$rootScope", "$routeParams", "$window", "$location", "SaleView", "GiftItemView", "CustomerView", "SaleProductView", "$filter", "ServiceData", function ($log, $scope, $anchorScroll, $rootScope, $routeParams, $window, $location, SaleView, GiftItemView, CustomerView, SaleProductView, $filter, ServiceData) {
    $scope.type = $routeParams.type;
    $scope.currentImageId = $routeParams.imageId;
    $scope.currentServiceId = $routeParams.serviceId;
    $scope.dd = {
        view: {
            giftItemView: null,
            benCustomerView: null,
            chargePrice: 0,
            displayAmountInput: false,
            displayAmountInputError: false,
            defaultCode: "2015022100070",
            serviceView: null,
            pageTitle: "",
            labelGift: "bon"

        }
    };
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if ($location.path().indexOf("/giftItem/") != -1) {
                if ($scope.currentServiceId) {
                    var service = ServiceData.getById($scope.currentServiceId);
                    $scope.dd.view.serviceView = $scope.ad.view.categoryRootView.getServiceView(service);
                    if ($scope.dd.view.serviceView) {
                        $scope.dd.view.giftItemView = new GiftItemView(null, -1);
                        $scope.dd.view.benCustomerView = new CustomerView(null, -1, $scope);
                        $scope.dd.view.giftItemView.validityDate = new Date();
                        $scope.dd.view.giftItemView.validityDate.setMonth($scope.dd.view.giftItemView.validityDate.getMonth() + $scope.ad.appAttributes.giftMonthValidity);

                        if ($scope.dd.view.serviceView.hasInternetPrice) $scope.dd.view.giftItemView.price = $scope.dd.view.serviceView.internetPrice;else $scope.dd.view.giftItemView.price = $scope.dd.view.serviceView.price;
                        $scope.dd.view.giftItemView.originalPrice = $scope.dd.view.giftItemView.price;
                        $scope.dd.view.giftItemView.serviceView = $scope.dd.view.serviceView;
                    } else $scope.openLocation("home");

                    if ($scope.type == "delivery" && $scope.ad.appAttributes.hasGiftItemDeliveryCharge) $scope.dd.view.chargePrice = $scope.ad.appAttributes.giftItemDeliveryCharge; //default

                    $scope.dd.view.pageTitle = "Bon cadeau ";
                } else {
                    $scope.unactiveImagesGiftView();
                    $scope.dd.view.giftItemView = new GiftItemView(null, -1);
                    $scope.dd.view.benCustomerView = new CustomerView(null, -1, $scope);
                    $scope.dd.view.giftItemView.originalPriceSelect = 50; //default
                    $scope.dd.view.giftItemView.validityDate = new Date();
                    $scope.dd.view.giftItemView.validityDate.setMonth($scope.dd.view.giftItemView.validityDate.getMonth() + $scope.ad.appAttributes.giftMonthValidity);
                    if ($scope.currentImageId && $scope.currentImageId != '') {
                        $scope.currentImage = $scope.getImagesGiftViewById($scope.currentImageId);
                        if ($scope.currentImage) {
                            $scope.ad.msgErrorService = "";
                            $scope.currentImage.active = true;
                        } else {
                            $scope.ad.msgErrorService = "Nous sommes désolés mais ce design n'existe plus.";
                        }
                    } else if ($scope.type == "delivery" && $scope.ad.appAttributes.hasGiftItemDeliveryCharge) $scope.dd.view.chargePrice = $scope.ad.appAttributes.giftItemDeliveryCharge; //default
                    var elm = $("#barcode");
                    if (elm) elm.JsBarcode($scope.dd.view.defaultCode, { format: "EAN", displayValue: false, fontSize: 16, height: 30 });
                    $scope.onCurrentGiftItemPriceChange();
                    $scope.dd.view.pageTitle = "Chèque cadeau ";
                    $scope.dd.view.labelGift = "chèque";
                }

                switch ($scope.type) {
                    case "mail":
                        $scope.dd.view.pageTitle = $scope.dd.view.pageTitle + "envoyé par email";
                        break;
                    case "mailPrint":
                        $scope.dd.view.pageTitle = $scope.dd.view.pageTitle + "à imprimer";
                        break;
                    case "delivery":
                        $scope.dd.view.pageTitle = $scope.dd.view.pageTitle + "livré chez vous";
                        break;
                }
            }
        }
    });

    $scope.openGiftItemDelivery = function () {
        if ($scope.currentServiceId) $scope.openLocation("giftItem/type/delivery/service/" + $scope.currentServiceId);else $scope.openLocation("giftItem/type/delivery");
    };

    $scope.openGiftItemsMail = function (type) {
        if ($scope.currentServiceId) $scope.openLocation("giftItem/type/" + type + "/service/" + $scope.currentServiceId);else $scope.openLocation("giftItemsMail/type/" + type);
    };

    $scope.addGiftItem = function () {
        if ($scope.dd.view.giftItemView) {
            if (isNaN($scope.dd.view.giftItemView.originalPrice) || $scope.dd.view.giftItemView.originalPrice < 5 || $scope.dd.view.giftItemView.originalPrice > 1000) {
                $scope.dd.view.displayAmountInputError = true;
                return;
            }
            if ($scope.ad.view.customerView && $scope.ad.customerConnected) {
                if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                    alert("Vous devez indiquer un email dans 'Mon compte'");
                    return;
                }
            }

            if ($scope.type === "mail") {
                if (!$scope.dd.view.benCustomerView.lastName || $scope.dd.view.benCustomerView.lastName === '' || !$scope.dd.view.benCustomerView.firstName || $scope.dd.view.benCustomerView.firstName === '' || !$scope.dd.view.benCustomerView.email || $scope.dd.view.benCustomerView.email === '' || !$scope.dd.view.giftItemView.messageTitle || $scope.dd.view.giftItemView.messageTitle === '' || !$scope.dd.view.giftItemView.message || $scope.dd.view.giftItemView.message === '') {
                    $scope.dd.view.displayError = true;
                    return;
                }
            }

            if ($scope.type === "mailPrint") {
                if (!$scope.dd.view.giftItemView.messageTitle || $scope.dd.view.giftItemView.messageTitle === '' || !$scope.dd.view.giftItemView.message || $scope.dd.view.giftItemView.message === '') {
                    $scope.dd.view.displayError = true;
                    return;
                }
            }

            if ($scope.ad.view.currentSaleView === null) {
                $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
                $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
            }
            if ($scope.ad.view.currentBookingView) {
                $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
            }

            var giftItemView = $scope.dd.view.giftItemView;
            giftItemView.updatePriceHT();
            $scope.ad.view.currentSaleView.addGiftItemView(giftItemView, true);
            switch ($scope.type) {
                case "mail":
                    giftItemView.imageUrl = null;
                    if (giftItemView.serviceView && giftItemView.serviceView.imageDisplayed) giftItemView.imageUrl = giftItemView.serviceView.imageDisplayed.url;else for (var i = 0; i < $scope.ad.view.imagesGiftView.length && !giftItemView.imageUrl; i++) {
                        if ($scope.ad.view.imagesGiftView[i].active) giftItemView.imageUrl = $scope.ad.view.imagesGiftView[i].url;
                    }giftItemView.editionType = "email";
                    giftItemView.customerView = $scope.dd.view.benCustomerView;
                    break;
                case "mailPrint":
                    giftItemView.imageUrl = null;
                    if (giftItemView.serviceView && giftItemView.serviceView.imageDisplayed) giftItemView.imageUrl = giftItemView.serviceView.imageDisplayed.url;else for (var i = 0; i < $scope.ad.view.imagesGiftView.length && !giftItemView.imageUrl; i++) {
                        if ($scope.ad.view.imagesGiftView[i].active) giftItemView.imageUrl = $scope.ad.view.imagesGiftView[i].url;
                    }giftItemView.editionType = "email";
                    break;
                case "delivery":
                    giftItemView.editionType = "delivery";
                    $scope.ad.view.currentSaleView.setDelivery("address", true, $scope.dd.view.chargePrice);
                    break;
            }

            $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
            $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
            $scope.openLocation("checkout");
        }
    };

    $scope.onCurrentGiftItemPriceChange = function () {
        if ($scope.dd.view.giftItemView.originalPriceSelect != "-1") {
            $scope.dd.view.giftItemView.originalPrice = parseInt($scope.dd.view.giftItemView.originalPriceSelect);
            $scope.dd.view.displayAmountInput = false;
        } else {
            $scope.dd.view.displayAmountInput = true;
            $scope.dd.view.giftItemView.originalPrice = 50;
            $scope.dd.view.giftItemView.originalPriceInput = 50;
        }
        $scope.dd.view.giftItemView.price = $scope.dd.view.giftItemView.originalPrice;
    };
}]);

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: sebastienbeaujard
* Date: 28/07/13
* Time: 09:22
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.controllers').controller('WebSiteHomeCtrl', ["$scope", function ($scope) {
    $scope.ad.view.currentCategoryView = $scope.ad.view.categoryRootView;
    $scope.ad.view.currentProductCategoryView = $scope.ad.view.productCategoryRootView;
    $scope.ad.view.currentCureCategoryView = $scope.ad.view.cureCategoryRootView;
    $scope.ad.view.currentLoyaltyCardCategoryView = $scope.ad.view.loyaltyCardCategoryRootView;
}]);

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteLoginRegisterCtrl', ["$log", "$scope", "$rootScope", "Auth", "WebPreLoaderData", "CustomerView", "CustomerSrv", "CustomerData", "Customer", "CookieFactory", "MobileDeviceSrv", "OptInOutService", "Constants", function ($log, $scope, $rootScope, Auth, WebPreLoaderData, CustomerView, CustomerSrv, CustomerData, Customer, CookieFactory, MobileDeviceSrv, OptInOutService, Constants) {

    //Categories.query($scope,false);
    $scope.dd = {
        view: {
            displayError: false,
            displayErrorLogin: false,
            displayErrorMsg: false,
            displayErrorPhoneNumber: false,
            isSmsActivationCodeValidated: false,
            isSmsActivationCodeSent: false,
            smsActivationCode: null,
            waitServerResponse: false,
            errorMessage: null,
            displayCantSendSms: false,
            cookieError: false
        },
        smsActivationCodeSent: null,
        emailValidator: Constants.EMAIL
    };
    if ($scope.ad.view && !$scope.ad.view.customerView) {
        $scope.ad.view.customerView = new CustomerView();
        $scope.ad.view.customerView.domainView = $scope;
    }
    var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
    if (smsTries) {
        var now = new Date();
        var lastTry = new Date(smsTries.date);
        if (now - lastTry.getTime() < 1000 * 60 * 60 * 24) //less than one day
            {
                if (smsTries.nb >= 3) //last try was less than one day and 3 tries
                    $scope.dd.view.displayCantSendSms = true;
            } else {
            smsTries.nb = 0; //more than one day : reset to 0
            CookieFactory.setCookie('flexyBeauty-smsTries', smsTries);
        }
    } else {
        CookieFactory.setCookie('flexyBeauty-smsTries', { nb: 0, date: new Date() }); //check that cookie can be saved
        smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
        if (!smsTries) {
            $scope.dd.view.displayCantSendSms = true;
            $scope.dd.view.cookieError = true;
        }
    }
    $scope.login = function () {
        if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse) if ($scope.ad.view.customerView.canLoginOnWeb()) {
            $scope.dd.view.waitServerResponse = true;
            var customer = new Customer();
            if ($scope.ad.view.customerView.login && $scope.ad.view.customerView.login != '') if ($scope.ad.view.customerView.login.indexOf("@") != -1) //email
                customer.email = $scope.ad.view.customerView.login;else customer.phone = $scope.ad.view.customerView.login;
            customer.password = $scope.ad.view.customerView.password;
            Auth.loginToWebSite(WebPreLoaderData.companyCode, customer, function () {
                //Success login get Customer data from it
                CustomerSrv.getData(customer, $scope.afterLoginSuccess, $scope.afterLoginError);
            }, $scope.afterLoginError);
        } else $scope.dd.view.displayErrorLogin = true;
    };

    $scope.afterLoginSuccess = function (customer) {
        $scope.dd.view.waitServerResponse = false;
        if (customer !== null) {
            customer.password = null; //hide by security
            if ($scope.ad.nativeApp && $scope.ad.nativeApp.token) {
                MobileDeviceSrv.setCustomer($scope.ad.nativeApp, customer.id);
            }
            $scope.ad.view.customerView.loadDataFrom(customer);
            $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
            $scope.ad.view.customerView.password = null; //hide by security
            $scope.ad.view.customerView.passwordAgain = null; //hide by security
            $scope.ad.customerConnected = true;
            $scope.openLocation("account");
        }
    };

    $scope.afterLoginError = function (errorCode, errorMessage) {
        $scope.dd.view.errorMessage = errorMessage;
        $scope.dd.view.waitServerResponse = false;
    };

    $scope.register = function () {
        var customerView = $scope.ad.view.customerView;
        if (!customerView || $scope.dd.view.waitServerResponse) {
            return;
        }

        if (!customerView.canRegisterOnWeb(true)) {
            $scope.dd.view.displayError = true;
            return;
        }

        $scope.dd.view.waitServerResponse = true;

        var customer = new Customer();
        customerView.copyDataTo(customer);

        CustomerSrv.register(customer, function (res) {
            customer.id = res.userId;

            if (customer.id && customerView && customerView.optInOutView) {
                OptInOutService.create({
                    customerId: customer.id,
                    optInOut: customerView.optInOutView
                }).then(function (data) {

                    Auth.changeUserFromWebSite(customer, res.companyCode, res.token);
                    $scope.afterLoginSuccess(customer);
                }, function (error) {
                    if (error) {
                        if (error.data) {
                            $scope.afterLoginError(error.status, error.data.message);
                        }
                        if (error.consumerMessage) {
                            $scope.afterLoginError(error.status, error.consumerMessage);
                        }
                    }
                });
            }
        }, function (error) {
            if (error && error.data) {
                $scope.afterLoginError(error.status, error.data.message);
            }
        });
    };

    $scope.sendSmsActivationCode = function () {
        if (!$scope.ad.view.customerView || !$scope.ad.view.customerView.phone || $scope.dd.view.displayErrorPhoneNumber) {
            $scope.dd.view.displayErrorMsg = true;
            $scope.dd.view.displayError = true;
            return;
        }
        var customer = new Customer();
        $scope.ad.view.customerView.copyDataTo(customer);
        $scope.dd.view.waitServerResponse = true;
        $scope.dd.view.errorMessage = null;
        CustomerSrv.sendSmsActivationCode(customer, function (smsActivationCodeSent) {
            //success sent
            $scope.dd.smsActivationCodeSent = smsActivationCodeSent;
            $scope.dd.view.isSmsActivationCodeSent = true;
            $scope.dd.view.waitServerResponse = false;
            $scope.dd.view.displayError = false;
            $scope.dd.view.displayErrorMsg = false;
            if (smsTries) {
                smsTries.nb++;
                smsTries.date = new Date();
                CookieFactory.setCookie('flexyBeauty-smsTries', smsTries);
                if (smsTries.nb >= 3) $scope.dd.view.displayCantSendSms = true;
            }
        }, function (errorCode, errorMessage) {
            $scope.dd.view.isSmsActivationCodeSent = false;
            $scope.dd.view.waitServerResponse = false; //TODO MANAGE ERROR
            $scope.dd.view.displayError = true;
            $scope.dd.view.displayErrorMsg = true;
            $scope.dd.view.errorMessage = errorMessage;
        });
        $scope.dd.view.displayError = false;
    };
    $scope.validateSmsActivationCode = function () {
        if ($scope.dd.smsActivationCodeSent == $scope.dd.view.smsActivationCode) {
            $scope.dd.view.isSmsActivationCodeValidated = true;
            $scope.dd.view.displayError = false;
            $scope.ad.view.customerView.isVerified = true;
        } else $scope.dd.view.displayError = true;
    };
}]);

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteLoyaltyCardCategoryCtrl', ["$scope", "$rootScope", "$routeParams", "LoyaltyCardCategoryData", function ($scope, $rootScope, $routeParams, LoyaltyCardCategoryData) {
    $scope.dd = {
        currentCategoryId: parseInt($routeParams.categoryId)
    };
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCategoryView)
            {
                var category = LoyaltyCardCategoryData.getById($scope.dd.currentCategoryId);
                if (category) {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentLoyaltyCardCategoryView($scope.ad.view.loyaltyCardCategoryRootView.getCategoryView(category), false);
                } else {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus.";
                }
            }
    });
}]);

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteLoyaltyCardCtrl', ["$log", "$scope", "$anchorScroll", "$rootScope", "$routeParams", "$location", "LoyaltyCardData", "$timeout", "gettextCatalog", function ($log, $scope, $anchorScroll, $rootScope, $routeParams, $location, LoyaltyCardData, $timeout, gettextCatalog) {
    $scope.currentLoyaltyCardId = parseInt($routeParams.loyaltyCardId);
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentLoyaltyCardView)
            {
                var loyaltyCard = LoyaltyCardData.getById($scope.currentLoyaltyCardId);
                if (loyaltyCard) {
                    $scope.ad.msgErrorLoyaltyCard = "";
                    $scope.setCurrentLoyaltyCardView($scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardView(loyaltyCard), false);
                } else {
                    var msgError = gettextCatalog.getString("Nous sommes désolés mais cette carte de fidélité n'existe plus ou ne peut plus être achetée");
                    $scope.ad.msgErrorLoyaltyCard = msgError + ".";
                }
                $timeout(function () {
                    if (window.FB) {
                        window.FB.XFBML.parse();
                    }
                }, 200);
            }
    });
}]);

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteProductCategoryCtrl', ["$scope", "$rootScope", "$routeParams", "ProductCategoryData", function ($scope, $rootScope, $routeParams, ProductCategoryData) {
    $scope.dd = {
        currentCategoryId: parseInt($routeParams.categoryId)
    };
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentCategoryView)
            {
                var category = ProductCategoryData.getById($scope.dd.currentCategoryId);
                if (category) {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentProductCategoryView($scope.ad.view.productCategoryRootView.getCategoryView(category), false);
                } else {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus ou n'est plus réservable.";
                }
            }
    });
}]);

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteProductCtrl', ["$log", "$scope", "$anchorScroll", "$rootScope", "$routeParams", "$location", "ProductData", "$timeout", function ($log, $scope, $anchorScroll, $rootScope, $routeParams, $location, ProductData, $timeout) {
    $scope.currentProductId = parseInt($routeParams.productId);
    $scope.redirectToHomeWhenAccessIsNotGranted();
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentProductView)
            {
                var product = ProductData.getById($scope.currentProductId);
                if (product) {
                    $scope.ad.msgErrorProduct = "";
                    $scope.setCurrentProductView($scope.ad.view.productCategoryRootView.getProductView(product), false);
                } else {
                    $scope.ad.msgErrorProduct = "Nous sommes désolés mais cette prestation n'existe plus ou n'est plus réservable.";
                }
                $timeout(function () {
                    if (window.FB) {
                        window.FB.XFBML.parse();
                    }
                }, 200);
            }
    });
}]);

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteServiceCtrl', ["$log", "$scope", "$anchorScroll", "$rootScope", "$routeParams", "$location", "ServiceData", "$timeout", function ($log, $scope, $anchorScroll, $rootScope, $routeParams, $location, ServiceData, $timeout) {
    $scope.currentServiceId = parseInt($routeParams.serviceId);

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) // && !$scope.ad.view.currentServiceView)
            {
                var service = ServiceData.getById($scope.currentServiceId);
                if (service && service.isVisibleOnWebSite) {
                    $scope.ad.msgErrorService = "";
                    $scope.setCurrentServiceView($scope.ad.view.categoryRootView.getServiceView(service), false);
                } else {
                    $scope.ad.msgErrorService = "Nous sommes désolés mais cette prestation n'existe plus ou n'est plus réservable.";
                }
                $timeout(function () {
                    if (window.FB) {
                        window.FB.XFBML.parse();
                    }
                }, 300);
            }
    });
}]);

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteValidateAccountCtrl', ["$log", "$scope", "$rootScope", "$routeParams", "Auth", "CustomerSrv", "CustomerView", "CustomerData", "BookingView", "BookingData", "DaySrv", "WebPreLoaderData", function ($log, $scope, $rootScope, $routeParams, Auth, CustomerSrv, CustomerView, CustomerData, BookingView, BookingData, DaySrv, WebPreLoaderData) {

    $scope.$watch('ad.view.loaded', function (newValue, oldValue) {
        if (newValue) {
            if ($routeParams.token && $routeParams.email) //received change pwd request
                {
                    Auth.loginToWebSiteByToken($routeParams.email, WebPreLoaderData.companyCode, $routeParams.token);
                    CustomerSrv.getByEmail($routeParams.email, function (customer) {
                        customer.isVerified = true;
                        if (!$scope.ad.view.customerView) $scope.ad.view.customerView = new CustomerView(customer, CustomerData.getIndexOf(customer), $scope);else $scope.ad.view.customerView.isVerified = true;
                        $scope.ad.customerConnected = true;
                        CustomerSrv.saveAccount(customer, $scope.onAccountValidated);
                    }, function () {
                        //error
                        //remove cookie and login Anonymous
                        console.log("login official error");
                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                    });
                }
        }
    });

    $scope.onAccountValidated = function () {
        CustomerSrv.getBookings($scope.ad.view.customerView.getModel(), function (bookings) {
            var bookingView;
            console.log(bookings);
            if (bookings) {
                $scope.ad.view.customerView.pastBookingsView = [];
                $scope.ad.view.customerView.futureBookingsView = [];

                for (var i = 0; i < bookings.length; i++) {
                    bookingView = new BookingView(bookings[i], BookingData.getIndexOf(bookings[i]), $scope);
                    bookingView.date = DaySrv.getDateFromId(bookings[i].day.id);
                    $scope.ad.view.customerView.addBookingView(bookingView);
                }
                console.log($scope.ad.view.customerView);
            }
        });
    };
}]);

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Directives */

angular.module('FlexyBeautyApp.directives').directive('appVersion', ['version', function (version) {
    return function (scope, elm, attrs) {
        elm.text(version);
    };
}]).directive('fbwrappermenu', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var ngMenuItemGet = $parse(attrs.fbwrappermenu);
            var categoryView = null;
            if (ngMenuItemGet && ngMenuItemGet(scope)) categoryView = ngMenuItemGet(scope);
            var mouseEnterProcess = false;
            element.bind('mouseenter', function () {
                mouseEnterProcess = true;
                if (categoryView) categoryView.showMenu = true;
                $timeout(function () {
                    mouseEnterProcess = false;
                }, 200); //when we use a touch pad : mousenter and mouseup can occur one after the second. Then if mouse enter display the menu, mouseup mustnot hide.
            });
            element.bind('mouseleave', function () {
                if (categoryView) categoryView.showMenu = false;
                scope.$apply();
            });
            element.bind('mouseup', function () {
                if (!mouseEnterProcess) {
                    scope.setCurrentCategoryView(scope.ad.view.categoryRootView, true);
                    scope.$apply();
                }
            });
        }
    };
}]).directive("tooltipsModal", function () {
    return {
        restrict: 'E',
        scope: {
            position: '@tooltipsPosition',
            title: '@tooltipsTitle',
            description: '@tooltipsDescription',
            picture: '@tooltipsPicture',
            button: '@tooltipsButton'
        },
        templateUrl: '/partials-web/editor/tooltips.html'
    };
}).directive('ngKeydown', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            // this next line will convert the string
            // function name into an actual function
            var functionToCall = scope.$eval(attrs.ngKeydown);
            elem.on('keydown', function (e) {
                // on the keydown event, call my function
                // and pass it the keycode of the key
                // that was pressed
                // ex: if ENTER was pressed, e.which == 13
                functionToCall(e);
            });
        }
    };
});

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('WebsiteSubdomain', function () {

    var websiteSubdomain = {
        ABOUT: "about",
        ACCOUNT: "account",
        ADMIN: "admin",
        BOOKING: "booking",
        CART: "cart",
        CATEGORY: "category",
        CHECKOUT: "checkout",
        CONTACT: "contact",
        CUSTOMER_POST: "customerPost",
        CGV: "cgv",
        CURE: "cure",
        CURE_CATEG: "cureCategory",
        FORGOT_PWD: "forgotPwd",
        GIFT_ITEM: "giftItem",
        GIFT_ITEMS: "giftItems",
        GIFT_ITEMS_MAIL: "giftItemsMail",
        HOME: "home",
        IMAGES: "images",
        LEGAL: "legal",
        LOGIN: "login",
        LOYALTY_CARD: "loyaltyCard",
        LOYALTY_CARD_CATEG: "loyaltyCardCategory",
        MOBILE_CART: "mobileCart",
        NATIVE_APP: "nativeApp",
        PRODUCT: "product",
        PRODUCT_CATEG: "productCategory",
        REGISTER: "register",
        SEARCHED_SERVICES: "searchedServices",
        SERVICE: "service",
        VALIDATE_ACCOUNT: "validateAccount"
    };

    return websiteSubdomain;
});

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ActivityView', ["$log", "HumanResourceData", "SiteData", "DayData", "Activity", "WorkingPeriodDayHrSrv", "ActivitySrv", "DayHrSrv", "Period", "ActivityData", function ($log, HumanResourceData, SiteData, DayData, Activity, WorkingPeriodDayHrSrv, ActivitySrv, DayHrSrv, Period, ActivityData) {

    var ActivityView = function ActivityView(activity) {
        //actIndex : activity index inside hrday
        this.actIndex = ActivityData.getIndexOf(activity); //model Index ActivityData
        this.label = null;
        this.period = new Period(); //period of activity

        if (activity !== undefined && activity != null) this.loadDataFrom(activity);
    };
    ActivityView.prototype.copyDataTo = function (activity) //
    {
        activity.setPeriod(this.period);
        activity.label = this.label;
    };
    ActivityView.prototype.loadDataFrom = function (activity) //
    {
        if (activity) {
            this.label = activity.label;
            this.setPeriod(activity.period);
        }
    };

    ActivityView.prototype.setPeriod = function (period) {
        if (period) {
            this.period = new Period(period);
        }
    };

    ActivityView.prototype.setPeriodStart = function (start) {
        if (!this.period) {
            this.period = new Period();
            this.period.setEnd(start);
        }
        this.period.setStart(start);
    };
    ActivityView.prototype.setPeriodDuration = function (duration) {
        if (this.period) {
            this.period.setDuration(duration);
        }
    };
    ActivityView.prototype.getModel = function () {
        if (this.actIndex != -1) return ActivityData.getByIndex(this.actIndex);
        return null;
    };
    ActivityView.prototype.reloadModel = function () {
        var activity = this.getModel();
        if (activity) this.loadDataFrom(activity);
    };

    return ActivityView;
}]);

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('AvailableDayHrView', ["$log", "DayHrData", "Period", function ($log, DayHrData, Period) {
    //special object contains available period for a day and an hr
    var AvailableDayHrView = function AvailableDayHrView(dayHr, hrView, aDayView) {
        this.hrView = hrView;
        this.dayHrIndex = -1; // index inside DayHrData
        this.aDayView = aDayView;
        this.availablePeriods = []; // periods availables

        //Load activities of dayhr
        if (dayHr !== undefined && dayHr) {
            this.dayHrIndex = DayHrData.getIndexOf(dayHr);
            for (var i = 0; i < dayHr.availablePeriods.length; i++) {
                this.availablePeriods.push(new Period(dayHr.availablePeriods[i]));
            }
            if (this.availablePeriods.length > 0) {
                this.availablePeriods.sort(Period.prototype.compare);
            }
        }
    };

    AvailableDayHrView.prototype.getModel = function () {

        if (this.dayHrIndex != -1) {
            return DayHrData.getByIndex(this.dayHrIndex);
        }
        return null;
    };

    AvailableDayHrView.prototype.isAvailableForBookingView = function (bookingView, cPeriod) {
        var isAvailable = false;
        isAvailable = this.isAvailableForPeriod(bookingView.period, cPeriod);
        /*
                    for (var i= 0; i<bookingView.bookingServicesView.length;i++)
                    {
                        isAvailable = this.isAvailableForPeriod(bookingView.bookingServicesView[i].period);
                    }
        */
        return isAvailable;
    };

    AvailableDayHrView.prototype.isAvailableForBookingServiceView = function (bsView) {
        if (!bsView || !bsView.period) {
            return false;
        }
        if (!this.hrView.knowsServiceView(bsView.serviceView)) {
            return false;
        }
        return this.isAvailableForPeriod(bsView.period);
    };

    AvailableDayHrView.prototype.isAvailableForPeriod = function (period) {
        var isAvailable = false;
        if (period) {
            for (var i = 0; i < this.availablePeriods.length && !isAvailable && this.availablePeriods[i].start.getTime() <= period.start.getTime(); i++) {
                isAvailable = this.availablePeriods[i].contains(period);
            }
        }
        return isAvailable;
    };

    AvailableDayHrView.prototype.getAvailablePeriodByStart = function (start) {
        for (var i = 0; i < this.availablePeriods.length && this.availablePeriods[i].start.getTime() <= start.getTime(); i++) {
            //ordered then test if out of period
            if (this.availablePeriods[i].start.getTime() <= start.getTime() && this.availablePeriods[i].end.getTime() >= start.getTime() && this.availablePeriods[i].duration != 0) {
                return this.availablePeriods[i];
            }
        }
        return null;
    };

    AvailableDayHrView.prototype.getNextAvailablePeriodByStart = function (start) {
        for (var i = 0; i < this.availablePeriods.length; i++) {
            if (this.availablePeriods[i].start.getTime() >= start.getTime() && this.availablePeriods[i].duration != 0) {
                //return first next
                return this.availablePeriods[i];
            }
        }
        return null;
    };

    return AvailableDayHrView;
}]);

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('AvailableDayPrView', ["$log", "DayPrData", "Period", function ($log, DayPrData, Period) {
    //special object contains available period for a day and an pr
    var AvailableDayPrView = function AvailableDayPrView(dayPr, prView, prUnitId, aDayView) {
        this.prView = prView;
        this.prUnitId = prUnitId;
        this.dayPrIndex = -1; // index inside DayPrData
        this.aDayView = aDayView;
        this.availablePeriods = []; // periods availables


        //Load activities of daypr
        if (dayPr !== undefined && dayPr) {
            this.dayPrIndex = DayPrData.getIndexOf(dayPr);
            for (var i = 0; i < dayPr.availablePeriods.length; i++) {
                this.availablePeriods.push(new Period(dayPr.availablePeriods[i]));
            }
            if (this.availablePeriods.length > 0) {
                this.availablePeriods.sort(Period.prototype.compare);
            }
        }
    };

    AvailableDayPrView.prototype.getModel = function () {

        if (this.dayPrIndex != -1) {
            return DayPrData.getByIndex(this.dayPrIndex);
        }
        return null;
    };

    AvailableDayPrView.prototype.isAvailableForBookingView = function (bookingView, cPeriod) {
        var isAvailable = false;
        isAvailable = this.isAvailableForPeriod(bookingView.period, cPeriod);
        /*
                    for (var i= 0; i<bookingView.bookingServicesView.length;i++)
                    {
                        isAvailable = this.isAvailableForPeriod(bookingView.bookingServicesView[i].period);
                    }
        */
        return isAvailable;
    };

    AvailableDayPrView.prototype.isAvailableForBookingServiceView = function (bsView) {
        if (!bsView || !bsView.period) return false;
        if (!this.prView.knowsServiceView(bsView.serviceView)) return false;
        return this.isAvailableForPeriod(bsView.period);
    };

    AvailableDayPrView.prototype.isAvailableForPeriod = function (period, cPeriod) {
        var isAvailable = false;
        var i = 0;
        if (period) for (i = 0; i < this.availablePeriods.length && !isAvailable && this.availablePeriods[i].start.getTime() <= period.start.getTime(); i++) {
            isAvailable = this.availablePeriods[i].contains(period);
        }return isAvailable;
    };

    AvailableDayPrView.prototype.getAvailablePeriodByStart = function (start) {
        for (var i = 0; i < this.availablePeriods.length && this.availablePeriods[i].start.getTime() <= start.getTime(); i++) {
            //ordered then test if out of period
            if (this.availablePeriods[i].start.getTime() <= start.getTime() && this.availablePeriods[i].end.getTime() >= start.getTime()) return this.availablePeriods[i];
        }return null;
    };

    AvailableDayPrView.prototype.getNextAvailablePeriodByStart = function (start) {
        for (var i = 0; i < this.availablePeriods.length; i++) {
            if (this.availablePeriods[i].start.getTime() >= start.getTime()) //return first next
                return this.availablePeriods[i];
        }return null;
    };

    return AvailableDayPrView;
}]);

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('AvailableDayView', ["$filter", "DayData", "DaySrv", "DateSrv", "HumanResourceData", "AvailableDayHrView", "AvailableDayPrView", "Period", function ($filter, DayData, DaySrv, DateSrv, HumanResourceData, AvailableDayHrView, AvailableDayPrView, Period) {
    //Special object fusion of Day and site->WorkingPeriodDay
    var AvailableDayView = function AvailableDayView(day, dayIndex, aView) {
        this.ROUNDED_TIME_MINUTES = 15;
        this.dayIndex = dayIndex; // index of model day
        this.date = null;
        this.label = "";
        this.labelC = ""; //label capitalized
        this.labelDayOfWC = ""; //Day of week capitalized
        this.labelDay = "";
        this.labelMonth = "";
        this.aView = aView; //planningTable view
        this.aDayHrsView = [];
        this.aDayPrsView = [];
        this.globalATimesView = [];
        this.hasDiscount = false;
        // Times of a possible booking
        //              [    { period:
        //                    hrsView : []} // HrsView availables for booking
        //              ]
        this.aSlotsView = []; //lines of the planning (10h00,12h00,14h00 etcc.)
        //aSlotView = [ SLOT (13h00/14h00)
        //    {
        //        aTimesView :
        //              [ // Times of a possible booking
        //                  { period:
        //                    hrsView : [] }// HrsView availables for booking
        //              ],
        //         discount : 0
        //
        //    }

        var days = DayData.getActiveList();
        if (dayIndex != -1) {
            this.date = DaySrv.getDateFromId(day.id);
            if (this.date) {
                this.labelDay = $filter('date')(this.date, 'dd'); //execute angular filter
                this.labelMonth = $filter('date')(this.date, 'MM'); //execute angular filter
            }
        }
        if (this.label.length > 0) this.labelC = this.label.charAt(0).toUpperCase() + this.label.substring(1);

        this.labelDayOfWC = $filter('date')(this.date, 'EEE');
        if (this.labelDayOfWC.length > 0) this.labelDayOfWC = this.labelDayOfWC.charAt(0).toUpperCase() + this.labelDayOfWC.substring(1, 3);

        var dayHr = null;
        var hr = null;
        var humanResourcesView = this.aView.domainView.getHumanResourcesView();
        for (var k = 0; k < humanResourcesView.length; k++) {
            dayHr = null;
            if (dayIndex !== undefined && dayIndex != -1) {
                hr = humanResourcesView[k].getModel();
                if (hr && hr.hasPlanning) dayHr = days[dayIndex].getDayHrByHrId(hr.id);
                if (dayHr) this.aDayHrsView.push(new AvailableDayHrView(dayHr, humanResourcesView[k], this));
            }
        }
        var dayPr = null;
        var pr = null;
        var aDayPrView;
        var physicalResourcesView = this.aView.domainView.getPhysicalResourcesView();
        for (var k = 0; k < physicalResourcesView.length; k++) {
            pr = physicalResourcesView[k].getModel();
            if (pr && pr.number) {

                for (var u = 1; u <= pr.number; u++) {
                    dayPr = day.getDayPrByPrId(pr.id, u);
                    aDayPrView = new AvailableDayPrView(dayPr, physicalResourcesView[k], u, this);
                    this.aDayPrsView.push(aDayPrView);
                }
            }
        }
        //init line period
        for (var j = 0; j < aView.aSlotsRefView.length; j++) {
            var slot = {
                aTimesView: [], //Time added
                discount: 0
            };

            this.aSlotsView.push(slot);
        }
    };
    AvailableDayView.prototype.getModel = function () {
        return DayData.getByIndex(this.dayIndex);
    };

    AvailableDayView.prototype.getPlgDayHrViewByHrId = function (hrId) {
        if (this.aDayHrsView) for (var k = 0; k < this.aDayHrsView.length; k++) {
            if (this.aDayHrsView[k].hrView) {
                var hr = this.aDayHrsView[k].hrView.getModel();
                if (hr && hr.id == hrId) return this.aDayHrsView[k];
            }
        }return null;
    };

    AvailableDayView.prototype.getADayHrsViewWithPeriod = function () {
        var aDayHrsViewWithPeriod = [];
        if (this.aDayHrsView) for (var k = 0; k < this.aDayHrsView.length; k++) {
            if (this.aDayHrsView[k].availablePeriods && this.aDayHrsView[k].availablePeriods.length > 0) aDayHrsViewWithPeriod.push(this.aDayHrsView[k]);
        }return aDayHrsViewWithPeriod;
    };
    AvailableDayView.prototype.getADayPrsViewWithPeriod = function () {
        var aDayPrsViewWithPeriod = [];
        if (this.aDayPrsView) for (var k = 0; k < this.aDayPrsView.length; k++) {
            if (this.aDayPrsView[k].availablePeriods && this.aDayPrsView[k].availablePeriods.length > 0) aDayPrsViewWithPeriod.push(this.aDayPrsView[k]);
        }return aDayPrsViewWithPeriod;
    };

    AvailableDayView.prototype.getDayHrView = function (hrView) {
        for (var k = 0; k < this.aDayHrsView.length; k++) {
            if (this.aDayHrsView[k].hrView === hrView) return this.aDayHrsView[k];
        }
        //not found ? Create it?

        return null;
    };

    AvailableDayView.prototype.getDayPrView = function (prView) {
        for (var k = 0; k < this.aDayPrsView.length; k++) {
            if (this.aDayPrsView[k].prView === prView) return this.aDayPrsView[k];
        }
        //not found ? Create it?

        return null;
    };
    AvailableDayView.prototype.addPeriodToGlobalATimesViewHr = function (period, hrView) {
        // check if exist.
        if (this.globalATimesView) {
            var alreadyExist = false;
            var i;
            for (i = 0; i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() <= period.start.getTime(); i++) {
                if (this.globalATimesView[i].period.start.getTime() == period.start.getTime()) alreadyExist = true;
            }if (alreadyExist) {
                this.globalATimesView[i - 1].hrsView.push(hrView);
            } else if (i < this.globalATimesView.length) {

                if (this.aView.triesTime <= this.aView.triesTimeLimit && i > 0 && period.start.getTime() - this.globalATimesView[i - 1].period.start.getTime() < this.aView.triesTime) // if try to insert a time close to previous one
                    {
                        if (period.start.getTime() % this.aView.triesTime == 0) //check period is a product to this.aView.triesTime : periodic hours (every 15 minuts by example)
                            //replace  this.globalATimesView.
                            {
                                this.globalATimesView.splice(i - 1, 1, {
                                    period: period,
                                    hrsView: [hrView]
                                });
                                //check also next
                                if (i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() - period.start.getTime() < this.aView.triesTime) this.globalATimesView.splice(i, 1); //remove next if close
                            }
                        //else don't insert
                    } else if (this.aView.triesTime <= this.aView.triesTimeLimit && i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() - period.start.getTime() < this.aView.triesTime)
                    // if try to insert a time close to next one
                    {
                        if (period.start.getTime() % this.aView.triesTime == 0) //check period is a product to this.aView.triesTime:
                            //replace  this.globalATimesView.
                            this.globalATimesView.splice(i, 1, {
                                period: period,
                                hrsView: [hrView]
                            });
                        //else don't insert
                    } else //insert (not replace)
                    this.globalATimesView.splice(i, 0, {
                        period: period,
                        hrsView: [hrView]
                    });
            } else {
                this.globalATimesView.push({
                    period: period,
                    hrsView: [hrView]
                });
            }
        }
    };
    AvailableDayView.prototype.addPeriodToGlobalATimesViewPr = function (period, prView) {
        // check if exist.
        if (this.globalATimesView) {
            var alreadyExist = false;
            var i;
            for (i = 0; i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() <= period.start.getTime(); i++) {
                if (this.globalATimesView[i].period.start.getTime() == period.start.getTime()) alreadyExist = true;
            }if (alreadyExist) {
                this.globalATimesView[i - 1].prsView.push(prView);
            } else if (i < this.globalATimesView.length) {

                if (i > 0 && period.start.getTime() - this.globalATimesView[i - 1].period.start.getTime() < this.aView.triesTime) // if try to insert a time close to previous one
                    {
                        if (period.start.getTime() % this.aView.triesTime == 0) //check period is a product to this.aView.triesTime : periodic hours (every 15 minuts by example)
                            //replace  this.globalATimesView.
                            {
                                this.globalATimesView.splice(i - 1, 1, {
                                    period: period,
                                    prsView: [prView]
                                });
                                //check also next
                                if (i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() - period.start.getTime() < this.aView.triesTime) this.globalATimesView.splice(i, 1); //remove next if close
                            }
                        //else don't insert
                    } else if (i < this.globalATimesView.length && this.globalATimesView[i].period.start.getTime() - period.start.getTime() < this.aView.triesTime)
                    // if try to insert a time close to next one
                    {
                        if (period.start.getTime() % this.aView.triesTime == 0) //check period is a product to this.aView.triesTime:
                            //replace  this.globalATimesView.
                            this.globalATimesView.splice(i, 1, {
                                period: period,
                                prsView: [prView]
                            });
                        //else don't insert
                    } else //insert (not replace)
                    this.globalATimesView.splice(i, 0, {
                        period: period,
                        prsView: [prView]
                    });
            } else {
                this.globalATimesView.push({
                    period: period,
                    prsView: [prView]
                });
            }
        }
    };

    AvailableDayView.prototype.updateAvailability = function (bookingView) {
        var hasAvailability = false;

        //Clear
        this.globalATimesView = [];
        bookingView.aDayView = this; //try this day

        var onlyPhysical = false;
        for (var i = 0; i < bookingView.bookingServicesView.length && !onlyPhysical; i++) {
            if (bookingView.bookingServicesView[i].serviceView.nbPrsNeeded > 0) onlyPhysical = true;
        }if (onlyPhysical) for (var _i = 0; _i < bookingView.bookingServicesView.length && onlyPhysical; _i++) {
            if (bookingView.bookingServicesView[_i].serviceView.nbHrsNeeded > 0) onlyPhysical = false;
        }if (onlyPhysical) {
            for (var k = 0; k < this.aDayPrsView.length; k++) {
                hasAvailability = this.updateAvailabilityForADayPrView(bookingView, this.aDayPrsView[k]) || hasAvailability;
            }
        } else {
            if (this.aDayHrsView.length == 0) return false;
            var aDayHrView = null;
            if (this.aView.selected.humanResourceView != null) {
                aDayHrView = this.getDayHrView(this.aView.selected.humanResourceView);
                hasAvailability = this.updateAvailabilityForADayHrView(bookingView, aDayHrView, true);
            } else {
                for (var _k = 0; _k < this.aDayHrsView.length; _k++) {
                    hasAvailability = this.updateAvailabilityForADayHrView(bookingView, this.aDayHrsView[_k], false) || hasAvailability;
                }
            }
        }

        //all timesView availables has been stored inside this.globalATimesView. Now need to put them inside this.aSlotsView;
        this.updateASlotsView(this.globalATimesView);

        return hasAvailability;
    };

    AvailableDayView.prototype.updateASlotsView = function (globalATimesView) {
        //all timesView availables stored inside globalATimesView will be put inside this.aSlotsView;
        var periodTime = void 0;
        var aSlotView = void 0;
        //clear
        for (var p = 0; p < this.aSlotsView.length; p++) {
            this.aSlotsView[p].aTimesView = [];
        }for (var t = 0; t < globalATimesView.length; t++) {
            periodTime = globalATimesView[t].period.start.getTime();
            aSlotView = null;
            for (var s = 0; s < this.aView.aSlotsRefView.length; s++) {
                if (this.aView.aSlotsRefView[s].start.getTime() <= periodTime && this.aView.aSlotsRefView[s].end.getTime() > periodTime) aSlotView = this.aSlotsView[s];
            }
            if (aSlotView) aSlotView.aTimesView.push(globalATimesView[t]);
        }
    };

    AvailableDayView.prototype.updateAvailabilityForADayHrView = function (bookingView, aDayHrView, chooseHr) {
        var hasAvailability = false;
        if (bookingView && bookingView.bookingServicesView.length > 0 && aDayHrView && aDayHrView.availablePeriods.length > 0 && aDayHrView.hrView) {
            var currentPeriod = new Period(aDayHrView.availablePeriods[0]); //init with first availability of DayHr
            currentPeriod.setDuration(this.aView.triesTime); //Will try every n minutes (App website parameter)
            var aPeriod = void 0;
            var index = void 0;
            var nbNotRoundedPeriod = 0;
            //when availability start at not a rounded time(rounded time minutes = 00/15/30/45) (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45
            //nbNotRoundedPeriod allow to goback to a rounded time (10h45) after 2 propositions of not rounded time (10h20 10h35)
            //if not rounded init nbNotRoundedPeriod=1
            if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                nbNotRoundedPeriod++;
            }
            var tryNextTime = true;
            var maxLoop = 1000;
            do {
                if (nbNotRoundedPeriod == 3) {
                    //tried 2 times without rounded time (00/15/30/45)
                    currentPeriod = this.computePeriodFromMidnight(currentPeriod);
                }

                //Test if it's possible according the selected user
                bookingView.moveToStart(currentPeriod.start);
                aPeriod = aDayHrView.getAvailablePeriodByStart(bookingView.period.start);
                if (aPeriod) {
                    if (bookingView.isBookable(this, chooseHr ? aDayHrView : null)) {

                        //Need to check if it's available for PR and Secondaries
                        this.addPeriodToGlobalATimesViewHr(new Period(currentPeriod), aDayHrView.hrView);
                        hasAvailability = true;

                        currentPeriod.moveToStart(currentPeriod.end);
                        currentPeriod = this.computePeriodFromDayPlanningStartIfNeeded(currentPeriod);

                        if (nbNotRoundedPeriod != 0) {
                            nbNotRoundedPeriod++;
                        }
                    } else {
                        //Not Available for HR

                        //adjust currentPeriod to start of next availablePeriods but need to test if this is the last available period or not
                        index = aDayHrView.availablePeriods.indexOf(aPeriod);
                        if (index != aDayHrView.availablePeriods.length - 1) {
                            //Not last

                            if (currentPeriod.end.getTime() < aDayHrView.availablePeriods[index + 1].start.getTime()) {
                                //not jump to next in case of multiple bookingsService

                                currentPeriod.moveToStart(currentPeriod.end);
                                if (nbNotRoundedPeriod != 0) {
                                    nbNotRoundedPeriod++;
                                }
                            } else {
                                currentPeriod.moveToStart(aDayHrView.availablePeriods[index + 1].start);
                                if (this.aView.triesTime <= this.aView.triesTimeLimit) {
                                    nbNotRoundedPeriod = 1;
                                }
                            }
                        } else {
                            //continue for manage multi
                            currentPeriod.moveToStart(currentPeriod.end);
                            if (nbNotRoundedPeriod != 0) {
                                nbNotRoundedPeriod++;
                            }
                        }
                    }
                } else {
                    aPeriod = aDayHrView.getNextAvailablePeriodByStart(bookingView.period.start);
                    if (aPeriod) {
                        //start at next period
                        currentPeriod.moveToStart(aPeriod.start);
                        nbNotRoundedPeriod = 0;
                        if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                            nbNotRoundedPeriod++;
                        }
                    } else {
                        currentPeriod.moveToStart(currentPeriod.end);
                        if (nbNotRoundedPeriod != 0) {
                            nbNotRoundedPeriod++;
                        }
                    }
                }
                if (currentPeriod.end.getTime() > this.aView.aSlotsRefView[this.aView.aSlotsRefView.length - 1].end.getTime()) {
                    tryNextTime = false;
                }
                maxLoop--;
            } while (tryNextTime && maxLoop > 0);
        }
        return hasAvailability;
    };

    AvailableDayView.prototype.updateAvailabilityForADayPrView = function (bookingView, aDayPrView) {
        var hasAvailability = false;
        if (bookingView && bookingView.bookingServicesView.length > 0 && aDayPrView && aDayPrView.availablePeriods.length > 0 && aDayPrView.prView) {
            var currentPeriod = new Period(aDayPrView.availablePeriods[0]); //init with first availability of DayPr
            currentPeriod.setDuration(this.aView.triesTime); //Will try every n minutes
            var aPeriod = void 0;
            var index = void 0;
            var nbNotRoundedPeriod = 0;
            //when availability start at not a rounded time (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45
            //  nbNotRoundedPeriod allow to goback to a rounded time (10h45) after 2 propositions of not rounded time (10h20 10h35)
            if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                nbNotRoundedPeriod++;
            }

            var tryNextTime = true;
            var maxLoop = 1000;
            do {

                if (nbNotRoundedPeriod == 3) {
                    //tried 2 times a hours with some minutes of "decalage"
                    currentPeriod = this.computePeriodFromMidnight(currentPeriod);
                }

                //Test if it's possible according the selected user
                bookingView.moveToStart(currentPeriod.start);
                aPeriod = aDayPrView.getAvailablePeriodByStart(bookingView.period.start);
                if (aPeriod) {
                    if (bookingView.isBookable(this, null)) {
                        //Available for PR

                        this.addPeriodToGlobalATimesViewPr(new Period(currentPeriod), aDayPrView.prView);
                        hasAvailability = true;
                        //}
                        currentPeriod.moveToStart(currentPeriod.end);
                        currentPeriod = this.computePeriodFromDayPlanningStartIfNeeded(currentPeriod);
                        if (nbNotRoundedPeriod != 0) {
                            nbNotRoundedPeriod++;
                        }
                    } else {
                        //Not Available for pr
                        //adjust currentPeriod to start of next availablePeriods but need to test if this is the last available period or not
                        index = aDayPrView.availablePeriods.indexOf(aPeriod);
                        if (index != aDayPrView.availablePeriods.length - 1) {
                            //Not last

                            if (currentPeriod.end.getTime() < aDayPrView.availablePeriods[index + 1].start.getTime()) {
                                //not jump to next in case of multiple bookingsService
                                currentPeriod.moveToStart(currentPeriod.end);
                                if (nbNotRoundedPeriod != 0) nbNotRoundedPeriod++;
                            } else {
                                currentPeriod.moveToStart(aDayPrView.availablePeriods[index + 1].start);
                                if (this.aView.triesTime <= this.aView.triesTimeLimit) nbNotRoundedPeriod = 1;
                            }
                        } else {
                            //continue for manage multi
                            currentPeriod.moveToStart(currentPeriod.end);
                            if (nbNotRoundedPeriod != 0) {
                                nbNotRoundedPeriod++;
                            }
                        }
                    }
                } else {
                    aPeriod = aDayPrView.getNextAvailablePeriodByStart(bookingView.period.start);
                    if (aPeriod) //start at next period
                        {
                            currentPeriod.moveToStart(aPeriod.start);
                            nbNotRoundedPeriod = 0;
                            if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                                nbNotRoundedPeriod++;
                            }
                        } else {
                        currentPeriod.moveToStart(currentPeriod.end);
                        if (nbNotRoundedPeriod != 0) nbNotRoundedPeriod++;
                    }
                }
                if (currentPeriod.end.getTime() > this.aView.aSlotsRefView[this.aView.aSlotsRefView.length - 1].end.getTime()) {
                    tryNextTime = false;
                }
                maxLoop--;
            } while (tryNextTime && maxLoop > 0);
        }
        return hasAvailability;
    };

    AvailableDayView.prototype.checkIfNotRoundedTime = function (time) {
        return this.aView.triesTime <= this.aView.triesTimeLimit && time && !Number.isInteger(time.getTime() / this.ROUNDED_TIME_MINUTES);
    };

    AvailableDayView.prototype.computePeriodFromMidnight = function (currentPeriod) {
        var period = new Period(currentPeriod);
        period.start.setTime(Math.round(period.start.getTime() / this.aView.triesTime) * this.aView.triesTime);
        period.adjustEnd();
        return period;
    };

    AvailableDayView.prototype.computePeriodFromDayPlanningStartIfNeeded = function (currentPeriod) {
        var newPeriod = new Period(currentPeriod);
        if (this.aView.triesTime > this.aView.triesTimeLimit && this.aView.autoFilling) {
            newPeriod = this.computePeriodFromDayPlanningStart(newPeriod);
        }
        return newPeriod;
    };

    AvailableDayView.prototype.computePeriodFromDayPlanningStart = function (currentPeriod) {
        var newPeriod = new Period(currentPeriod);
        var timeFromDayStart = newPeriod.start.getTime() - this.aView.period.start.getTime();
        var rawSlotNumber = timeFromDayStart / this.aView.triesTime;
        var slotNumber = Math.floor(rawSlotNumber);
        var durationBeforeStartTime = slotNumber * this.aView.triesTime;
        var startTime = durationBeforeStartTime + this.aView.period.start.getTime();
        newPeriod.start.setTime(startTime);
        newPeriod.adjustEnd();

        return newPeriod;
    };

    AvailableDayView.prototype.setResourcesOnBooking = function (bookingView) {
        var bookable = false;
        if (this.aView.selected.aTimeView != null && bookingView) {
            var aTimeView = this.aView.selected.aTimeView;
            var hrView = null;
            if (aTimeView.hrsView && aTimeView.hrsView.length > 0 && aTimeView.hrsView[0]) hrView = this.getDayHrView(aTimeView.hrsView[0]);

            if (hrView) bookable = bookingView.isBookable(this, hrView);

            if (!bookable) bookable = bookingView.isBookable(this, this.aView.selected.humanResourceView);
        }
        return bookable;
    };

    AvailableDayView.prototype.getFirstAvailableDayRView = function (listADayRsView, bsView) {
        for (var k = 0; k < listADayRsView.length; k++) {
            if (listADayRsView[k].isAvailableForBookingServiceView(bsView)) return listADayRsView[k];
        }
        return null;
    };
    AvailableDayView.prototype.getDiscountDays = function () {
        var discountDay = { dayId: DaySrv.getIdFromDate(this.date), aSlotsView: [] };

        for (var p = 0; p < this.aSlotsView.length; p++) {
            if (this.aSlotsView[p].discount != 0) discountDay.aSlotsView.push({ hour: this.aView.aSlotsRefView[p].start.hour, discount: this.aSlotsView[p].discount });
        }return discountDay;
    };
    AvailableDayView.prototype.setByDiscountDays = function (discountDay) {
        this.hasDiscount = false;
        for (var i = 0; i < discountDay.aSlotsView.length; i++) {
            for (var p = 0; p < this.aSlotsView.length; p++) {
                if (this.aView.aSlotsRefView[p].start.hour == discountDay.aSlotsView[i].hour) {
                    this.aSlotsView[p].discount = Math.abs(discountDay.aSlotsView[i].discount);
                    if (this.aSlotsView[p].discount != 0) this.hasDiscount = true;
                }
            }
        }
    };
    AvailableDayView.prototype.updateDiscount = function (index, value) {
        this.aSlotsView[index].discount += value;
        this.aView.domainView.updateDiscountDays();
    };
    return AvailableDayView;
}]);

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('AvailableTableView', ["$timeout", "Period", "DaySrv", "DayData", "SiteData", "AvailableDayView", "DateSrv", function ($timeout, Period, DaySrv, DayData, SiteData, AvailableDayView, DateSrv) {

    var AvailableTableView = function AvailableTableView(site, domainView) {
        //Load planning view according site
        // If first date values is filled : the view is related to the planning
        // if not it's related to the config week of persons

        this.domainView = domainView; //Set by initializer
        this.aSlotsRefView = []; //lines of the planning (10h00,12h00,14h00 etcc.) : contains period
        this.aDaysView = [];
        this.aDaysViewDisplayed = [];
        this.period = site.getMaxOpeningPeriod();
        this.loading = true;
        this.firstDateDisplayed = null;
        this.firstDayIndexDisplayed = null;
        this.modelTodayIndex = -1;
        this.triesTime = domainView.ad.appAttributes.triesTime;
        this.autoFilling = domainView.ad.appAttributes.autoFilling;
        this.triesTimeLimit = 55; //when availability start at not a rounded time (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45. This behaviour start if triesTime <=  triesTimeLimit
        this.tableModeHour = this.triesTime < 60;
        this.hasDiscount = false;
        var today = new Date();
        this.modelTodayIndex = today.getDay() - 1; //day of week;
        if (this.modelTodayIndex == -1) //Sunday
            this.modelTodayIndex = 6; //Sunday
        this.firstDayIndexDisplayed = this.modelTodayIndex;
        this.selected = {
            humanResourceView: null,
            aSlotView: null,
            aTimeView: null,
            hasAvailability: false

        };
        this.initTime(this.period);

        //working Period aggregation
        var nbWeeks = 1;
        for (var w = 0; w < nbWeeks; w++) {
            this.addWeekView(site, w * 7, false);
        } //this.updateDisplay(this.getFirstADayViewByDayIndex(this.firstDayIndexDisplayed));

        this.loading = false;
    };

    AvailableTableView.prototype.initTime = function (period) {
        //3 periods : morning , start afternoon, end afternoon

        var cPeriod;
        var hour = period.start.hour;
        this.aSlotsRefView = [];
        while (hour <= period.end.hour) {
            cPeriod = new Period();
            cPeriod.setStartHour(hour);
            cPeriod.setEndHour(hour + 1);
            this.aSlotsRefView.push(cPeriod);
            hour++;
        }
    };
    AvailableTableView.prototype.addWeekView = function (site, dayIndexStart, insertBefore) {
        var days = DayData.getActiveList();
        var dayOfWeekView = null;
        var aDayViewLastIndex = 0;
        for (var i = dayIndexStart; i < days.length && i < dayIndexStart + 7; i++) //Days of week
        {
            dayOfWeekView = new AvailableDayView(days[i], i, this);
            if (insertBefore) {
                this.aDaysView.splice(aDayViewLastIndex, 0, dayOfWeekView);
                aDayViewLastIndex++;
            } else this.aDaysView.push(dayOfWeekView);
        }
    };
    AvailableTableView.prototype.updateAvailability = function (bookingView) {
        if (this.selected) {
            this.selected.hasAvailability = false;
            for (var i = 0; i < this.aDaysView.length; i++) {
                this.selected.hasAvailability = this.aDaysView[i].updateAvailability(bookingView) || this.selected.hasAvailability;
            }
        }
    };
    AvailableTableView.prototype.getDiscountDays = function () {
        var discountWeek = { aDaysView: [] };
        var discountDay;
        for (var k = 0; k < this.aDaysView.length; k++) {
            discountDay = this.aDaysView[k].getDiscountDays();
            if (discountDay) discountWeek.aDaysView.push(discountDay);
        }

        return discountWeek;
    };
    AvailableTableView.prototype.setByDiscountDays = function (discountDays) {
        for (var i = 0; i < discountDays.aDaysView.length; i++) {
            for (var k = 0; k < this.aDaysView.length; k++) {
                if (discountDays.aDaysView[i].dayId == DaySrv.getIdFromDate(this.aDaysView[k].date)) {
                    this.aDaysView[k].setByDiscountDays(discountDays.aDaysView[i]);
                    if (this.aDaysView[k].hasDiscount) this.hasDiscount = true;
                }
            }
        }
    };
    AvailableTableView.prototype.getFirstADayViewByDayIndex = function (dayIndex) {
        //return first aDaysView with a model index >= dayIndex (first open day)
        for (var k = 0; k < this.aDaysView.length; k++) {
            if (this.aDaysView[k].dayIndex >= dayIndex) return this.aDaysView[k];
        }return null;
    };

    AvailableTableView.prototype.updateDisplay = function (firstADayViewParam) {
        var nbDisplayedLimit = this.dim.nbDays;
        var firstADayView;
        if (firstADayViewParam) firstADayView = firstADayViewParam;
        if (this.dim.nbDays == 7) //displayWeekMode
            {
                var indexTarget;
                nbDisplayedLimit = this.nbOpenDaysByWeek;
                indexTarget = Math.floor(this.firstDayIndexDisplayed / 7) * 7; //round to first day of week
                if (indexTarget != this.firstDayIndexDisplayed) {
                    firstADayView = this.getFirstADayViewByDayIndex(indexTarget);
                    this.firstDayIndexDisplayed = firstADayView.dayIndex;
                }
            }
        if (!firstADayView) {
            firstADayView = this.getFirstADayViewByDayIndex(this.firstDayIndexDisplayed);
            this.firstDayIndexDisplayed = firstADayView.dayIndex;
        }
        //Display Only Open Days : add correct days to aDaysViewDisplayed
        var nbDisplayed = 0;
        this.firstDateDisplayed = firstADayView.date;
        this.aDaysViewDisplayed = [];
        var k;
        for (k = this.aDaysView.indexOf(firstADayView); k < this.aDaysView.length && nbDisplayed < nbDisplayedLimit; k++) {
            if (this.aDaysView[k].dayIndex >= this.firstDayIndexDisplayed) {
                this.aDaysViewDisplayed.push(this.aDaysView[k]);
                nbDisplayed++;
            }
        }if (nbDisplayed != this.dim.nbDaysDisplayed) this.updateFontSize();
        this.dim.nbDaysDisplayed = nbDisplayed;
    };

    return AvailableTableView;
}]);

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('BookingServiceView', ["ActivityView", "BookingService", "DayHrData", "DayPrData", "ActivityData", "Period", "PhysicalResourceData", function (ActivityView, BookingService, DayHrData, DayPrData, ActivityData, Period, PhysicalResourceData) {
    //BookingServiceView inherit from ActivityView

    var BookingServiceView = function BookingServiceView(bookingService, bsIndex, bookingView) {
        //bookingService : model object
        //bsIndex : index inside booking
        //bookingView : bookingView parent
        this.bsIndex = bsIndex; //model index on booking
        this.bookingView = bookingView;
        this.serviceView = null;
        this.isPackage = false;
        this.originalPrice = 0;
        this.price = 0;
        this.priceHT = 0;
        this.discountPercent = 0;
        this.hrRequest = false;
        this.aDayHrView = null;
        this.aDayPrView = null;
        this.secondariesADayHrsNeededView = []; // contains [{ aDayHrView : obj }]
        this.secondariesADayPrsNeededView = []; // contains [{ aDayHrView : obj }]
        this.billPosition = bsIndex + 1; //position inside booking ->
        this.subBsView = []; // subBooking services View
        this.cureItemToServiceUsageView = null;
        ActivityView.call(this, bookingService); //call ActivityView.constructor -> call BookingServiceView.loadDataFrom
    };

    BookingServiceView.prototype = Object.create(ActivityView.prototype); //inherit functions from ActivityView

    //override  ActivityView.prototype.loadDataFrom
    BookingServiceView.prototype.loadDataFrom = function (bookingService) {
        //Call super function ActivityView.prototype.loadDataFrom
        ActivityView.prototype.loadDataFrom.call(this, bookingService);

        //Manage specifics fields of BookingServiceView
        this.price = bookingService.price;
        this.updatePriceHT();
        this.isPackage = bookingService.isPackage;
        this.hrRequest = bookingService.hrRequest;
        this.originalPrice = bookingService.originalPrice;
        this.discountPercent = bookingService.discountPercent;
        if (bookingService.service) this.serviceView = this.bookingView.domainView.getServiceView(bookingService.service);
        if (this.isPackage) {
            this.subBsView = [];
            for (var i = 0; i < bookingService.subBookingServices.length; i++) {
                var bsV = new BookingServiceView(bookingService.subBookingServices[i], this.bsIndex, this.bookingView);
                bsV.pTView = this.pTView;
                this.subBsView.push(bsV);
            }
        }
    };

    BookingServiceView.prototype.copyDataTo = function (bookingService) {
        if (bookingService) {
            bookingService.setPeriod(this.period);
            bookingService.label = this.label;
            bookingService.service = this.serviceView.getModel();
            bookingService.isPackage = this.isPackage;
            bookingService.hrRequest = this.hrRequest;
            bookingService.price = this.price;
            bookingService.originalPrice = this.originalPrice;
            bookingService.discountPercent = this.discountPercent;

            var day, hr, pr, dayHr, dayPr;
            if (!this.isPackage) {
                if (this.aDayHrView && this.aDayHrView.hrView) {
                    day = this.aDayHrView.aDayView.getModel();
                    hr = this.aDayHrView.hrView.getModel();
                    if (day && hr) {
                        dayHr = this.aDayHrView.getModel();
                        if (!dayHr) dayHr = day.createAndAddDayHr(hr.id);
                        bookingService.dayHr = dayHr;

                        for (var i = 0; i < bookingService.secondariesDayHrs.length; i++) {
                            bookingService.secondariesDayHrs[i].removeActivity(bookingService);
                        }bookingService.secondariesDayHrs = [];
                        for (var i = 0; i < this.secondariesADayHrsNeededView.length; i++) {
                            if (this.secondariesADayHrsNeededView[i].aDayHrView) {
                                dayHr = this.secondariesADayHrsNeededView[i].aDayHrView.getModel();
                                if (!dayHr) // create dayHr
                                    {
                                        hr = this.secondariesADayHrsNeededView[i].aDayHrView.hrView.getModel();
                                        day = this.secondariesADayHrsNeededView[i].aDayHrView.plgDayView.getModel();
                                        dayHr = day.createAndAddDayHr(hr.id);
                                        this.secondariesADayHrsNeededView[i].aDayHrView.dayHrIndex = DayHrData.getIndexOf(dayHr);
                                    }
                                dayHr.addActivity(bookingService, false);
                            }
                        }
                    }
                }
                if (this.aDayPrView && this.aDayPrView.prView) {
                    day = this.aDayPrView.aDayView.getModel();
                    pr = this.aDayPrView.prView.getModel();
                    if (day && pr) {
                        dayPr = this.aDayPrView.getModel();
                        if (!dayPr) dayPr = day.createAndAddDayPr(pr.id, this.aDayPrView.prUnitId);
                        bookingService.dayPr = dayPr;
                        for (var i = 0; i < bookingService.secondariesDayPrs.length; i++) {
                            bookingService.secondariesDayPrs[i].removeActivity(bookingService);
                        }bookingService.secondariesDayPrs = [];
                        for (var i = 0; i < this.secondariesADayPrsNeededView.length; i++) {
                            if (this.secondariesADayPrsNeededView[i].aDayPrView) {
                                dayPr = this.secondariesADayPrsNeededView[i].aDayPrView.getModel();
                                if (!dayPr) // create dayPr
                                    {
                                        pr = this.secondariesADayPrsNeededView[i].aDayPrView.prView.getModel();
                                        day = this.secondariesADayPrsNeededView[i].aDayPrView.plgDayView.getModel();
                                        dayPr = day.createAndAddDayPr(pr.id, this.secondariesADayPrsNeededView[i].aDayPrView.prUnitId);
                                        this.secondariesADayPrsNeededView[i].aDayPrView.dayPrIndex = DayPrData.getIndexOf(dayPr);
                                    }
                                dayPr.addActivity(bookingService, false);
                            }
                        }
                    }
                }
            }
        }
    };
    BookingServiceView.prototype.moveToPeriodStart = function (start) {
        if (this.period) this.period.moveToStart(start);
    };
    BookingServiceView.prototype.updatePriceHT = function () {
        if (this.bookingView && this.bookingView.domainView) this.priceHT = Math.round(100 / (100 + this.bookingView.domainView.getDefaultVatTax()) * this.price * 100) / 100;
    };
    BookingServiceView.prototype.updatePrice = function (parentBs) {
        if (this.cureItemToServiceUsage) return;
        var oriPrice = this.originalPrice;
        var discount = 0;
        var discountPercent = this.discountPercent;
        if (parentBs !== undefined && parentBs != null) //use parentBs discount percent
            discountPercent = parentBs.discountPercent;
        if (this) if (discountPercent && typeof discountPercent === 'string') {
            discountPercent = discountPercent.replace(",", ".").replace(" ", "");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent != 0) discount = Math.round(discountPercent * oriPrice / 100 * 100) / 100;

        if (oriPrice - discount != this.price) {
            this.price = oriPrice - discount;
            this.updatePriceHT();
            if (this.bookingView) {
                this.bookingView.updateGlobalBookingDataFromBS();
                if (this.bookingView.saleView) {
                    this.bookingView.saleView.resetPayments();
                    this.bookingView.saleView.calculateSaleFields();
                }
            }
        }
        for (var i = 0; i < this.subBsView.length; i++) {
            this.subBsView[i].updatePrice(this);
        }
    };

    BookingServiceView.prototype.updateService = function () {
        if (!this.cureItemToServiceUsageView) this.setService(this.serviceView);
    };

    BookingServiceView.prototype.addDiscount = function (discount) {
        var discountTab = void 0;
        if (!this.cureItemToServiceUsageView && discount) {
            discountTab = [this.discountPercent, discount];
            this.discountPercent = this.calculateDiscount(discountTab);
            this.updatePrice();
        }
    };

    BookingServiceView.prototype.calculateDiscount = function (discountTab) {
        var totalDiscount = 0;
        for (var i = 0; i < discountTab.length; i++) {
            if (!isNaN(discountTab[i])) {
                totalDiscount = (1 - (1 - totalDiscount / 100) * (1 - discountTab[i] / 100)) * 100;
            }
        }
        return totalDiscount;
    };

    BookingServiceView.prototype.updateCureItemAfterReload = function (cureItemToServiceView) {
        if (this.cureItemToServiceUsageView && this.cureItemToServiceUsageView.cureItemToServiceView) this.cureItemToServiceUsageView.cureItemToServiceView.removeCureItemToServiceUsageView(this.cureItemToServiceUsageView);

        if (cureItemToServiceView) cureItemToServiceView.addUsageFromBookingServiceView(this); //new one //this.cureItemToServiceUsageView is updated

    };

    BookingServiceView.prototype.setService = function (serviceView, duration) {
        this.serviceView = serviceView;
        if (serviceView != null) {
            this.label = serviceView.label;
            this.isPackage = serviceView.isPackage;
            if (serviceView.hasInternetPrice) //on customer site only
                {
                    this.price = serviceView.internetPrice;
                    this.discountPercent = serviceView.internetDiscountPercent;
                } else {
                this.price = serviceView.price;
                this.discountPercent = 0;
            }
            this.originalPrice = serviceView.price;
            this.updatePriceHT();
            if (!this.period) this.period = new Period();

            if (this.isPackage) {
                var start = this.period.start;
                this.subBsView = [];
                for (var i = 0; i < serviceView.subServicesView.length; i++) {
                    var bsView = new BookingServiceView(null, -1, this.bookingView);
                    bsView.setPeriodStart(start);
                    bsView.setService(serviceView.subServicesView[i]);
                    this.subBsView.push(bsView);
                    start = bsView.period.end;
                }
            } else {
                this.secondariesPlgDayHrsNeededView = [];
                if (serviceView.nbHrsNeeded > 1) for (var i = 1; i < serviceView.nbHrsNeeded; i++) {
                    this.secondariesPlgDayHrsNeededView.push({ plgDayHrView: null });
                }this.secondariesPlgDayPrsNeededView = [];
                if (serviceView.nbPrsNeeded > 1) for (var i = 1; i < serviceView.nbPrsNeeded; i++) {
                    this.secondariesPlgDayPrsNeededView.push({ plgDayPrView: null });
                }
            }
            if (duration !== undefined && duration) this.setPeriodDuration(duration);else this.setPeriodDuration(serviceView.duration);
        }
    };

    BookingServiceView.prototype.isBookable = function (aDayView, aDayHrView, aListADayHrsView, aListADayPrsView) {
        var isBookable = true;
        if (this.isPackage) {
            for (var i = 0; i < this.subBsView.length; i++) {
                isBookable = isBookable && this.subBsView[i].hasAvailability(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
            }
        } else {
            isBookable = this.hasAvailability(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
        }
        return isBookable;
    };
    BookingServiceView.prototype.hasAvailability = function (aDayView, aDayHrView, aListADayHrsView, aListADayPrsView) {
        var isBookable = true;
        if (aDayView && this.serviceView) {
            isBookable = this.hasHrAvailability(aDayView, aDayHrView, aListADayHrsView) && this.hasPrAvailability(aDayView, aListADayPrsView);
        }
        return isBookable;
    };

    BookingServiceView.prototype.hasPrAvailability = function (aDayView, aListADayPrsView) {
        var isBookable = true;
        var aDayPrViewOk = void 0;
        var index = void 0;
        var listADayPrsView = aListADayPrsView.slice(0); //clone
        this.secondariesADayPrsNeededView = [];
        if (this.serviceView.nbPrsNeeded != 0) {
            if (aListADayPrsView.length == 0) {
                return false;
            }
            aDayPrViewOk = aDayView.getFirstAvailableDayRView(listADayPrsView, this); //No specifc  pr needed
            if (aDayPrViewOk) {
                index = listADayPrsView.indexOf(aDayPrViewOk);
                if (index != -1) {
                    listADayPrsView.splice(index, 1); //remove it to try next
                }
                this.aDayPrView = aDayPrViewOk;
            } else {
                return false;
            }
            for (var nbP = 1; nbP < this.serviceView.nbPrsNeeded; nbP++) {
                aDayPrViewOk = aDayView.getFirstAvailableDayRView(listADayPrsView, this);
                this.secondariesADayPrsNeededView.push({ aDayPrView: aDayPrViewOk });
                index = listADayPrsView.indexOf(aDayPrViewOk);
                if (index != -1) {
                    listADayPrsView.splice(index, 1); //remove it to try next
                }
                isBookable = isBookable && aDayPrViewOk != null;
            }
            if (this.aDayPrView) {
                //push pr  in first of the list

                index = aListADayPrsView.indexOf(this.aDayPrView);
                if (index != -1) {
                    aListADayPrsView.splice(index, 1); //remove it to try next
                    aListADayPrsView.unshift(this.aDayPrView);
                }
            }
        }
        return isBookable;
    };

    BookingServiceView.prototype.hasHrAvailability = function (aDayView, aDayHrView, aListADayHrsView, chooseHr) {
        var isBookable = true;
        var aDayHrViewOk = void 0;
        var listADayHrsView = aListADayHrsView.slice(0); //clone
        var index = void 0;
        this.secondariesADayHrsNeededView = [];
        if (this.serviceView.nbHrsNeeded != 0) {
            if (aListADayHrsView.length == 0) {
                return false;
            }
            if (aDayHrView) {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView([aDayHrView], this);
            } else {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView(listADayHrsView, this); //No specifc hr needed
            }
            if (aDayHrViewOk) {
                index = listADayHrsView.indexOf(aDayHrViewOk);
                if (index != -1) {
                    listADayHrsView.splice(index, 1); //remove it to try next
                }
                this.aDayHrView = aDayHrViewOk;
            } else {
                return false;
            }
            for (var nbH = 1; nbH < this.serviceView.nbHrsNeeded; nbH++) {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView(listADayHrsView, this);
                this.secondariesADayHrsNeededView.push({ aDayHrView: aDayHrViewOk });
                index = listADayHrsView.indexOf(aDayHrViewOk);
                if (index != -1) {
                    listADayHrsView.splice(index, 1); //remove it to try next
                }
                isBookable = isBookable && aDayHrViewOk != null;
            }
            if (this.aDayHrView) {
                //push hr in first of the list

                index = aListADayHrsView.indexOf(this.aDayHrView);
                if (index != -1) {
                    aListADayHrsView.splice(index, 1); //remove it to try next
                    aListADayHrsView.unshift(this.aDayHrView);
                }
            }
        }
        return isBookable;
    };

    BookingServiceView.prototype.addTime = function (time) {
        if (this.period) this.period.addTime(time);
        if (this.isPackage) for (var i = 0; i < this.subBsView.length; i++) {
            this.subBsView[i].addTime(time);
        }
    };

    BookingServiceView.prototype.isAvailableForSecondaries = function (aDayView, assignedADayHrView, assign) {
        if (!this.serviceView) return false;
        if (this.serviceView.nbHrsNeeded > 1) {
            var listADayHrsView = aDayView.aDayHrsView.slice(0);
            //Remove current one
            var index = listADayHrsView.indexOf(assignedADayHrView);
            if (index != -1) listADayHrsView.splice(index, 1);
            var aDayHrView;
            for (var i = 0; i < this.secondariesADayHrsNeededView.length; i++) {
                aDayHrView = aDayView.getFirstAvailableDayRView(listADayHrsView, this);
                if (aDayHrView) {
                    index = listADayHrsView.indexOf(aDayHrView);
                    if (index != -1) listADayHrsView.splice(index, 1); //remove
                    if (assign) this.secondariesADayHrsNeededView[i].aDayHrView = aDayHrView;
                } else return false;
            }
        }
        if (this.serviceView.nbPrsNeeded > 0) {
            var listADayPrsView = aDayView.aDayPrsView.slice(0);
            var aDayPrView;
            aDayPrView = aDayView.getFirstAvailableDayRView(listADayPrsView, this);
            if (aDayPrView) {
                index = listADayPrsView.indexOf(aDayPrView);
                if (index != -1) listADayPrsView.splice(index, 1); //remove
                if (assign) this.aDayPrView = aDayPrView;
            } else return false;
            for (var i = 0; i < this.secondariesADayPrsNeededView.length; i++) {
                aDayPrView = aDayView.getFirstAvailableDayRView(listADayPrsView, this);
                if (aDayPrView) {
                    index = listADayPrsView.indexOf(aDayPrView);
                    if (index != -1) listADayPrsView.splice(index, 1); //remove
                    if (assign) this.secondariesADayPrsNeededView[i].aDayPrView = aDayPrView;
                } else return false;
            }
        }
        return true;
    };
    BookingServiceView.prototype.linkToBooking = function (bookingService) {
        var newBooking = this.bookingView.getModel();
        if (bookingService.booking && newBooking !== bookingService.booking) //remove
            bookingService.booking.removeBookingService(bookingService);

        if (newBooking) //Force add because removed by booking.updateModel
            newBooking.addBookingService(bookingService);
    };
    BookingServiceView.prototype.updateModel = function (linkToBooking) {
        var bookingService = this.getModel();
        if (!bookingService) //must create model
            {
                bookingService = new BookingService();
                this.actIndex = ActivityData.getIndexOf(bookingService);
            }
        this.copyDataTo(bookingService);
        if (linkToBooking) {
            this.linkToBooking(bookingService);

            if (this.isPackage) {
                bookingService.subBookingServices = [];
                for (var i = 0; i < this.subBsView.length; i++) {
                    var subBs = this.subBsView[i].updateModel(false);
                    if (subBs) bookingService.addSubBs(subBs);
                }
            }
        }
        return bookingService;
    };

    return BookingServiceView;
}]);

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('BookingView', ["$log", "BookingServiceView", "Booking", "BookingSrv", "DayData", "HumanResourceData", "ServiceData", "CustomerData", "BookingData", "CustomerView", "Period", "DaySrv", "Customer", "PhysicalResourceData", "DayView", "SaleData", "SaleView", "BookingCreator", "BookingPartnerSettings", "BasicAuthRoleFactory", "BookingSettings", "BookingPartnerSettingsFactory", function ($log, BookingServiceView, Booking, BookingSrv, DayData, HumanResourceData, ServiceData, CustomerData, BookingData, CustomerView, Period, DaySrv, Customer, PhysicalResourceData, DayView, SaleData, SaleView, BookingCreator, BookingPartnerSettings, BasicAuthRoleFactory, BookingSettings, BookingPartnerSettingsFactory) {

    var BookingView = function BookingView(booking, bookingIndex, domainView) {
        this.bookingIndex = bookingIndex;
        this.label = null;
        this.domainView = domainView;
        this.price = 0;
        this.creator = BookingCreator.WEBSITE.key;
        this.customerView = null;
        this.period = new Period(); //period of booking
        this.itnDurationD = 0; //displayed
        this.date = null;
        this.aDayView = null;
        this.status = "created";
        this.bookingServicesView = [];
        this.customerComment = "";
        this.saleView = null;
        this.hasSale = false;
        if (booking) this.loadDataFrom(booking);else this.date = new Date();
        this.basicAuthRoleFactory = BasicAuthRoleFactory;
        this.bookingSettings = BookingSettings;
    };

    BookingView.prototype.copyDataTo = function (booking) //
    {
        booking.setPeriod(this.period);
        booking.label = this.label;
        booking.price = this.price;
        booking.status = this.status;
        booking.creator = this.creator;
        if (this.customerComment && this.customerComment !== "") booking.comment = "Commentaire du client : \n\"" + this.customerComment + "\"";
        if (this.customerView) {
            booking.customer = this.customerView.getModel();
            if (!booking.customer) {
                booking.customer = new Customer();
                this.customerView.copyDataTo(booking.customer);
            }
        }
        if (this.saleView) booking.sale = this.saleView.getModel();else booking.sale = null;
    };

    BookingView.prototype.loadDataFrom = function (booking) //
    {
        if (booking) {
            this.label = booking.label;
            this.price = booking.price;
            this.status = booking.status;
            this.creator = booking.creator;
            this.setPeriod(booking.period);
            this.hasSale = booking._saleId != null;
            if (booking.day) this.date = DaySrv.getDateFromId(booking.day.id);else this.date = new Date();
            if (booking.customer) {
                this.customerView = this.domainView.getCustomerView(booking.customer);
            }
            var bsV;
            this.bookingServicesView = [];
            for (var i = 0; i < booking.bookingServices.length; i++) {
                bsV = new BookingServiceView(booking.bookingServices[i], i, this);
                this.bookingServicesView.push(bsV);
            }

            if (booking.sale) {
                var dayView = null;
                if (booking.sale.day) dayView = new DayView(DayData.getIndexOf(booking.sale.day));
                this.saleView = new SaleView(booking.sale, SaleData.getIndexOf(booking.sale), dayView, this, this.domainView.ad.view);
            } else this.saleView = null;

            this.updateGlobalBookingDataFromBS();
        }
    };

    BookingView.prototype.moveToStart = function (start) {
        if (this.period) {
            var startTime = this.period.start.getTime();
            this.period.moveToStart(start);
            var updateTime = this.period.start.getTime() - startTime;
            for (var i = 0; i < this.bookingServicesView.length; i++) {
                this.bookingServicesView[i].addTime(updateTime);
            }
        }
    };

    BookingView.prototype.isBookable = function (aDayView, aDayHrView) {
        var isBookable = true;
        var aListADayHrsView = aDayView.getADayHrsViewWithPeriod(); //clone because reorder it.
        var aListADayPrsView = aDayView.getADayPrsViewWithPeriod(); //clone because reorder it.
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            isBookable = isBookable && this.bookingServicesView[i].isBookable(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
        }
        return isBookable;
    };

    BookingView.prototype.setPeriod = function (period) {
        if (period) this.period = new Period(period);
    };

    BookingView.prototype.setPeriodStart = function (start) {
        if (!this.period) this.period = new Period();
        this.period.setStart(start);
    };

    BookingView.prototype.setPeriodEnd = function (end) {
        if (!this.period) this.period = new Period();
        this.period.setEnd(end);
    };

    BookingView.prototype.setADayHrView = function (aDayHrView) {
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (this.bookingServicesView[i].serviceView.nbHrsNeeded > 0) this.bookingServicesView[i].aDayHrView = aDayHrView;
        }
    };

    BookingView.prototype.setADayPrView = function (aDayPrView) {
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (this.bookingServicesView[i].serviceView.nbPrsNeeded > 0) this.bookingServicesView[i].aDayPrView = aDayPrView;
        }
    };

    BookingView.prototype.getBookingServiceViewById = function (id) {
        var bs;
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            bs = this.bookingServicesView[i].getModel();
            if (bs && bs.id == id) return this.bookingServicesView[i];
        }
        return null;
    };

    BookingView.prototype.removeModel = function (successFunction, errorFunction) {
        var booking = this.getModel();
        if (booking) {
            BookingSrv.remove(booking, successFunction, errorFunction); // remove from model
            this.customerView.removeBookingView(this); //remove from view
        }
    };

    BookingView.prototype.reloadModel = function () {
        var booking = this.getModel();
        if (booking) {
            this.loadDataFrom(booking);
        }
    };

    BookingView.prototype.getModel = function () {
        if (this.bookingIndex !== -1) return BookingData.getByIndex(this.bookingIndex);
        return null;
    };

    BookingView.prototype.updateModel = function (successFunction, errorFunction) {
        if (this.bookingServicesView.length === 0 || !this.aDayView) //delete it
            alert("error : no services to save or day not set");else {

            var day = this.aDayView.getModel();
            var booking = void 0;
            if (this.bookingIndex === -1) // creation
                {
                    booking = new Booking(null, day);
                    this.bookingIndex = BookingData.getIndexOf(booking);
                } else booking = this.getModel();
            this.copyDataTo(booking);

            booking.bookingServices = [];
            for (var i = 0; i < this.bookingServicesView.length; i++) {
                this.bookingServicesView[i].updateModel(true);
            }if (this.saleView) this.saleView.initModel();
            BookingSrv.onlineSave(booking, successFunction, errorFunction);
        }
        return true;
    };
    BookingView.prototype.hasService = function (serviceView) {
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (this.bookingServicesView[i].serviceView === serviceView) return true;
        }return false;
    };

    BookingView.prototype.updateGlobalBookingDataFromBS = function () {
        this.itnDurationD = 0;
        if (this.bookingServicesView.length != 0 && this.bookingServicesView[0].period) {
            var start = this.bookingServicesView[0].period.start;
            var end = this.bookingServicesView[0].period.end;
            if (this.bookingServicesView[0].serviceView) this.itnDurationD += this.bookingServicesView[0].serviceView.itnDurationD;
            for (var i = 1; i < this.bookingServicesView.length; i++) {
                if (this.bookingServicesView[i].period.start.getTime() < start.getTime()) start = this.bookingServicesView[i].period.start;
                if (this.bookingServicesView[i].period.end.getTime() > end.getTime()) end = this.bookingServicesView[i].period.end;

                if (this.bookingServicesView[i].serviceView) this.itnDurationD += this.bookingServicesView[i].serviceView.itnDurationD;
            }
            this.setPeriodStart(start);
            this.setPeriodEnd(end);
        } else {
            this.setPeriodEnd(this.period.start);
        }
        this.price = 0;
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            this.price += this.bookingServicesView[i].price;
        }if (this.saleView) this.saleView.calculateSaleFields();
    };
    BookingView.prototype.addBookingServiceView = function (bsView, endFunction) {
        var index = this.bookingServicesView.indexOf(bsView);
        if (index == -1) {
            this.bookingServicesView.push(bsView);
            bsView.bookingView = this;
            bsView.billPosition = this.bookingServicesView.length;

            //update booking price
            this.price += bsView.price;
            //change period start/end
            this.updateGlobalBookingDataFromBS();

            if (endFunction !== undefined) endFunction(bsView);

            this.domainView.$emit("bookingUpdated");
        }
    };
    BookingView.prototype.addServiceOnBookingOnUserSelectCureItem = function (cureItemToServiceView) {
        if (cureItemToServiceView && cureItemToServiceView.serviceView && cureItemToServiceView.quantity > cureItemToServiceView.usedQuantity) {
            var bookingView = this;
            this.addServiceOnBooking(cureItemToServiceView.serviceView, function (bsView) {
                bookingView.setCureUsageOnBookingServiceView(cureItemToServiceView, bsView);
            });
        }
    };

    BookingView.prototype.updateBookingsServicesFromCustomerCures = function (customerView) {
        if (this.bookingServicesView) {
            for (var i = 0; i < this.bookingServicesView.length; i++) {

                if (this.bookingServicesView[i]) {
                    var citsView = customerView.getFirstCureItemToServiceViewByServiceView(this.bookingServicesView[i].serviceView);
                    if (citsView) this.setCureUsageOnBookingServiceView(citsView, this.bookingServicesView[i]);
                }
            }
        }
    };
    BookingView.prototype.setCureUsageOnBookingServiceView = function (cureItemToServiceView, bsView) {
        cureItemToServiceView.addUsageFromBookingServiceView(bsView);
        bsView.price = 0;
        bsView.bookingView.updateGlobalBookingDataFromBS();
    };
    BookingView.prototype.resetBillPosition = function () {
        //Todo order
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (this.bookingServicesView[i].billPosition = i + 1) ;
        }
    };
    BookingView.prototype.addServiceOnBooking = function (serviceView, endFunction) {

        var bsView = new BookingServiceView(null, -1, this);
        bsView.period.moveToStart(this.period.end);
        bsView.setService(serviceView); //set activity end using service duration

        this.addBookingServiceView(bsView, endFunction); //add bs to booking view
        return bsView;
    };

    BookingView.prototype.removeServiceOnBooking = function (serviceView) {
        for (var i = this.bookingServicesView.length - 1; i >= 0; i--) {
            if (this.bookingServicesView[i].serviceView === serviceView) {
                this.removeBookingServiceView(this.bookingServicesView[i], true);

                return;
            }
        }
    };
    BookingView.prototype.removeBookingServiceView = function (bsView, adjustNextBookings) {
        var index = this.bookingServicesView.indexOf(bsView);
        if (index === -1) {
            return; //TODO raise error
        }
        var start = this.bookingServicesView[index].period.start;

        this.bookingServicesView.splice(index, 1);
        if (adjustNextBookings) {
            var i = index;
            for (i; i < this.bookingServicesView.length; i++) {
                var bookingServiceView = this.bookingServicesView[i];
                bookingServiceView.moveToPeriodStart(start);
                for (var j = 0; j < bookingServiceView.subBsView.length; j++) {
                    var subBookingServiceView = bookingServiceView.subBsView[j];
                    subBookingServiceView.moveToPeriodStart(start);
                    start = subBookingServiceView.period.end;
                }
                start = bookingServiceView.period.end;
            }
        }
        this.resetBillPosition();
        this.price -= bsView.price;
        this.updateGlobalBookingDataFromBS();

        this.domainView.$emit("bookingUpdated");
    };

    BookingView.prototype.getHumanResourcesViewWhoKnow = function (humanResourcesView) {
        var humanResourcesViewWhoKnow = [];
        var needHr = false;
        for (var j = 0; j < this.bookingServicesView.length; j++) {
            if (this.bookingServicesView[j].serviceView && this.bookingServicesView[j].serviceView.nbHrsNeeded > 0) needHr = true;
        }if (needHr && humanResourcesView) for (var i = 0; i < humanResourcesView.length; i++) {
            var knowAll = true;
            for (var j = 0; j < this.bookingServicesView.length && knowAll; j++) {
                if (!humanResourcesView[i].getModel().hasService(this.bookingServicesView[j].serviceView.getModel())) knowAll = false;
            }if (knowAll && humanResourcesViewWhoKnow.indexOf(humanResourcesView[i]) == -1) humanResourcesViewWhoKnow.push(humanResourcesView[i]);
        }
        return humanResourcesViewWhoKnow;
    };

    BookingView.prototype.isAvailableForSecondaries = function (aDayView, assignedADayHrView, assign) {
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (!this.bookingServicesView[i].isAvailableForSecondaries(aDayView, assignedADayHrView, assign)) return false;
        }
        return true;
    };
    BookingView.prototype.canBook = function () //
    {
        if (this.bookingServicesView.length == 0 || !this.aDayView) return false;
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (!this.bookingServicesView[i].isPackage && (!this.bookingServicesView[i].serviceView || !this.bookingServicesView[i].aDayHrView && !this.bookingServicesView[i].aDayPrView)) return false;
        }
        return true;
    };
    BookingView.prototype.getProductsOfServices = function () //
    {
        var productsOfServicesView = [];
        for (var i = 0; i < this.bookingServicesView.length; i++) {
            if (this.bookingServicesView[i].serviceView) {
                for (var j = 0; j < this.bookingServicesView[i].serviceView.productsView.length; j++) {
                    if (this.bookingServicesView.indexOf(this.bookingServicesView[i].serviceView.productsView[j])) productsOfServicesView.push(this.bookingServicesView[i].serviceView.productsView[j]);
                }
            }
        }
        return productsOfServicesView;
    };
    BookingView.prototype.getCureItemsService = function () {
        var cureItemServices = [];
        for (var i = 0; i <= this.bookingServicesView.length; i++) {
            var cureItem = new Object();
            if (this.bookingServicesView[i] && this.bookingServicesView[i].cureItemToServiceUsageView) {
                cureItem.cureItemId = this.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId;
                cureItem.serviceId = this.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.serviceId;
                cureItemServices.push(cureItem);
            }
        }
        return cureItemServices;
    };

    BookingView.prototype.checkBookingSettings = function (setting) {
        return BookingPartnerSettingsFactory.checkBookingPartnerSettings(setting, this.creator);
    };

    return BookingView;
}]);

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var specificationSync = __webpack_require__(183).SpecificationSync;

var createSpecification = function createSpecification(isSatisfiedByFunction) {
    var specificationObject = function specificationObject() {};
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services").factory("WebSiteSpecifications", [function () {
    var specifications = {};

    specifications.DisplayAllowChooseHrMessageSpecification = createSpecification(function (allowChooseHr, isActiveLeCiseauOption) {
        return !allowChooseHr && isActiveLeCiseauOption;
    });

    return specifications;
}]);

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('OptInOutResource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/v2/customers/:customerId/opt-in-out', {}, {
        create: { method: 'POST' },
        update: { method: 'PUT' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('OptInOutService', ["$log", "OptInOutResource", "Brand", function ($log, OptInOutResource, Brand) {
    var getObjectResource = function getObjectResource(optInOut) {
        var optInOutRes = new OptInOutResource();

        optInOutRes.isSmsCampaignAllowed = optInOut.isSmsCampaignAllowed || false;
        optInOutRes.isNotificationCampaignAllowed = optInOut.isNotificationCampaignAllowed || false;
        optInOutRes.isEmailCampaignAllowed = optInOut.isEmailCampaignAllowed || false;
        optInOutRes.isExternalOptInOut = optInOut.isExternalOptInOut || false;
        optInOutRes.origin = "Site Internet " + Brand.label;
        optInOutRes.consentDate = optInOut.consentDate || new Date();

        return optInOutRes;
    };

    var service = {};

    /* get a single optInOut with params = { customerId, id } */
    service.get = function (params) {
        return OptInOutResource.get({ customerId: params.customerId }).$promise;
    };

    /* create a new optInOut with params = { customerId, optInOut } */
    service.create = function (params) {
        var optInOutRes = getObjectResource(params.optInOut);
        return optInOutRes.$create({ customerId: params.customerId });
    };

    /* update existing optInOut with params = { customerId, optInOut } */
    service.update = function (params) {
        var optInOutRes = getObjectResource(params.optInOut);
        return optInOutRes.$update({ customerId: params.customerId });
    };

    return service;
}]);

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
__webpack_require__(297);
__webpack_require__(292);
__webpack_require__(304);
__webpack_require__(294);
__webpack_require__(308);
__webpack_require__(298);
__webpack_require__(306);
__webpack_require__(303);
__webpack_require__(310);
__webpack_require__(309);
__webpack_require__(299);
__webpack_require__(307);
__webpack_require__(293);
__webpack_require__(295);
__webpack_require__(302);
__webpack_require__(305);
__webpack_require__(291);
__webpack_require__(311);
__webpack_require__(296);
__webpack_require__(301);
__webpack_require__(300);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(374);
__webpack_require__(373);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(120);
__webpack_require__(136);
__webpack_require__(151);
__webpack_require__(145);
__webpack_require__(150);
__webpack_require__(143);
__webpack_require__(160);
__webpack_require__(152);
__webpack_require__(161);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(86);
__webpack_require__(89);
__webpack_require__(144);
__webpack_require__(147);
__webpack_require__(146);
__webpack_require__(148);
__webpack_require__(159);
__webpack_require__(155);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(156);
__webpack_require__(141);
__webpack_require__(137);
__webpack_require__(140);
__webpack_require__(139);
__webpack_require__(138);
__webpack_require__(149);
__webpack_require__(162);
__webpack_require__(164);
__webpack_require__(368);
__webpack_require__(571);
__webpack_require__(526);
__webpack_require__(165);
module.exports = __webpack_require__(290);


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SiteView', ["$sce", "Site", "SiteSrv", "SiteData", "WorkingPeriodView", "Format", "AppData", "AppCode", function ($sce, Site, SiteSrv, SiteData, WorkingPeriodView, Format, AppData, AppCode) {

    var SiteView = function SiteView(site) {
        this.preposition = null;
        this.name = null;
        this.phone = null;
        this.emailContact = null;
        this.emailBooking = null;
        this.fax = null;
        this.address = null;
        this.postalCode = null;
        this.city = null;
        this.country = "FR";
        this.timeZone = "Europe/Paris";
        this.departement = null;
        this.siret = null;
        this.vatNumber = null;
        this.nafCode = null;
        this.rcs = null;
        this.webSiteDir = null;
        this.workingPeriodsView = [];
        this.googleMapUrl = null;
        this.ownerId = null;
        this.legalName = null;
        this.legalAddress = null;
        this.legalCity = null;
        this.legalZip = null;
        this.legalCountry = null;
        this.greffeCity = null;
        this.juridicForm = null;

        if (site != undefined && site) {
            this.loadDataFrom(site);
        }
    };
    SiteView.prototype.loadDataFrom = function (site) {
        this.name = site.name;
        this.preposition = site.preposition;
        this.phone = Format.formatNumber(site.phone);
        this.emailContact = site.emailContact;
        this.emailBooking = site.emailBooking;
        this.fax = site.fax;
        this.address = site.address;
        this.postalCode = site.postalCode;
        this.city = site.city;
        if (site.country) this.country = site.country;
        if (site.timeZone) this.timeZone = site.timeZone;
        this.siret = site.siret;
        this.vatNumber = site.vatNumber;
        this.rcs = site.rcs;
        this.shareCapital = site.shareCapital;
        this.nafCode = site.nafCode;
        this.webSiteDir = site.webSiteDir;
        this.ownerId = site.ownerId;
        this.legalName = site.legalName;
        this.legalAddress = site.legalAddress ? site.legalAddress : this.address;
        this.legalCity = site.legalCity ? site.legalCity : this.city;
        this.legalZip = site.legalZip ? site.legalZip : this.postalCode;
        this.legalCountry = site.legalCountry ? site.country : this.country;
        this.greffeCity = site.greffeCity;
        this.juridicForm = site.juridicForm;
        if (this.address && this.address !== "" && this.postalCode && this.postalCode !== "" && this.city && this.city !== "") {
            var GOOGLE_MAPS_FIELD_SEPARATOR = ",";
            var GOOGLE_MAPS_SPACE_ESCAPED = '+';
            var googleMapUrl = "https://www.google.com/maps/embed/v1/place?key=AIzaSyAae8fgXj1u1KmT2XPO0vVxTWL8WcdIK9A&q=" + this.address.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED) + GOOGLE_MAPS_FIELD_SEPARATOR + this.postalCode.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED) + GOOGLE_MAPS_FIELD_SEPARATOR + this.city.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED);
            // Google Maps need information to place on map
            // It can manage both country name and code
            if (this.country && this.country !== "") googleMapUrl += GOOGLE_MAPS_FIELD_SEPARATOR + this.country.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED);

            this.googleMapUrl = $sce.trustAsResourceUrl(googleMapUrl);
        }
        this.departement = site.departement;
        this.workingPeriodsView = [];
        if (site.workingPeriods) for (var k = 0; k < site.workingPeriods.length; k++) {
            this.workingPeriodsView.push(new WorkingPeriodView(site.workingPeriods[k], k));
        }
    };
    SiteView.prototype.copyDataTo = function (site) {
        //Assume here than the object in parameter contains only id (must load them)
        site.name = this.name;
        site.preposition = this.preposition;

        if (this.phone != undefined && this.phone != null) {
            if (this.phone[0] == '+') {
                // if + : delete all spaces
                do {
                    this.phone = this.phone.replace(" ", '');
                    site.phone = this.phone;
                } while (this.phone.search(" ") != -1);
            } else {
                site.phone = this.phone.replace(/[^0-9]/g, '');
            }
        }

        site.emailContact = this.emailContact;
        site.emailBooking = this.emailBooking;
        site.fax = this.fax;
        site.address = this.address;
        site.postalCode = this.postalCode;
        site.city = this.city;
        site.country = this.country;
        site.timeZone = this.timeZone;
        site.departement = this.departement;
        site.siret = this.siret;
        site.nafCode = this.nafCode;
        site.vatNumber = this.vatNumber;
        site.rcs = this.rcs;
        site.shareCapital = this.shareCapital;
        site.webSiteDir = this.webSiteDir;
        site.ownerId = this.ownerId;
        site.ownerEmail = this.ownerEmail;
        site.ownerMobile = this.ownerMobile;
        site.legalName = this.legalName;
        site.legalAddress = this.legalAddress;
        site.legalCity = this.legalCity;
        site.legalZip = this.legalZip;
        site.legalCountry = this.legalCountry;
        site.greffeCity = this.greffeCity;
        site.juridicForm = this.juridicForm;
    };

    SiteView.prototype.getModel = function () {
        return SiteData.defaultSite;
    };

    SiteView.prototype.updateModel = function (workingPeriodDayViewsToClose, successFunction, errorFunction) {
        var site = this.getModel();
        if (site == null) {
            site = new Site();
        }

        this.copyDataTo(site);

        for (var k = 0; k < this.workingPeriodsView.length; k++) {
            this.workingPeriodsView[k].updateModel(workingPeriodDayViewsToClose);
        }

        //manage deletion of workingPeriod
        var bsDeleted = void 0;
        var index = 0;
        for (var i = 0; i < site.workingPeriods.length;) {
            if (site.workingPeriods[i].id) {
                bsDeleted = true;
                for (var j = 0; j < this.workingPeriodsView.length && bsDeleted; j++) {
                    if (index == this.workingPeriodsView[j].modelIndex) {
                        bsDeleted = false;
                    }
                }
                if (bsDeleted) {
                    site.removeWorkingPeriod(site.workingPeriods[i]);
                } else {
                    i++;
                }
            } else {
                i++;
            }
            index++;
        }
        for (var _i = 0; _i < this.workingPeriodsView.length; _i++) {
            this.workingPeriodsView[_i].modelIndex = _i; //reset index
        }

        SiteSrv.save(site, successFunction, errorFunction);
    };
    SiteView.prototype.saveFromCompanyCode = function (companyCode) {
        var site = this.getModel();
        if (site) {
            this.copyDataTo(site);
            SiteSrv.saveFromCode(companyCode, site);
        }
    };

    SiteView.prototype.reloadModel = function () {
        var site = this.getModel();
        if (site) {
            this.loadDataFrom(site);
        }
    };

    SiteView.prototype.removeWorkingPeriodView = function (wpView) {
        var index = this.workingPeriodsView.indexOf(wpView);
        if (index != -1) this.workingPeriodsView.splice(index, 1);
    };
    SiteView.prototype.intersectWorkingPeriodsView = function (wpView) {
        var intersect = false;
        for (var i = 0; i < this.workingPeriodsView.length && !intersect; i++) {
            if (this.workingPeriodsView[i] !== wpView && this.workingPeriodsView[i].intersect(wpView)) intersect = true;
        }
        return intersect;
    };
    SiteView.prototype.addWorkingPeriodView = function (wpView) {
        var index = this.workingPeriodsView.indexOf(wpView);
        if (index == -1) this.workingPeriodsView.push(wpView);
    };

    SiteView.prototype.canSave = function (hasWebsiteAccess) {
        var isValid = this.name && this.name !== '' && this.workingPeriodsView.length > 0 && this.ownerId && this.legalName && this.address && this.city && this.postalCode && this.phone;

        if (isValid && hasWebsiteAccess) {
            isValid = this.emailContact && this.webSiteDir;
        }

        if (isValid && this.isFrance()) {
            isValid = this.siret && this.vatNumber;
        }

        if (isValid && this.checkAddressDifferentHeadOffice()) {
            isValid = this.legalAddress && this.legalCity && this.legalZip && this.legalCountry;
        }

        if (isValid && this.isAdvanceMng()) {
            isValid = this.rcs != null;
        }
        return isValid;
    };

    SiteView.prototype.checkAddressDifferentHeadOffice = function () {
        return this.address !== this.legalAddress || this.city !== this.legalCity || this.country !== this.legalCountry || this.postalCode !== this.legalZip;
    };
    SiteView.prototype.hasValidWorkPhone = function () {
        // if site has a valid work phone number
        if (this.phone == null || this.phone == "") return true;
        if (this.phone && this.phone.length > 0) {
            if (this.phone[0] == 0 && this.phone.replace(/[^0-9]/g, '').length == 10 && this.phone.length == 14) {
                // if length with only numbers equals 10 and if the first number is 0
                // french number
                return true;
            }
            if (this.phone[0] == '+') {
                // international number
                return true;
            }
        }

        return false;
    };

    SiteView.prototype.updateVatNumber = function () {
        if (this.country === "FR") {
            var siret = this.siret;
            siret = siret.replace(/\s/g, '');
            var siren = siret && siret.length > 9 ? siret.substring(0, 9) : null;
            if (siren && !isNaN(siren)) {
                var tvaCode = (siren % 97 * 3 + 12) % 97;
                this.vatNumber = '' + tvaCode + siren;
            }
        }
    };

    SiteView.prototype.isFrance = function () {
        return this.country === "FR";
    };

    SiteView.prototype.isAdvanceMng = function () {
        var posApp = AppData.getAppByCode(AppCode.POS_APP);
        if (posApp !== null) {
            var isAdvanceAttr = posApp.getAppAttribute("advanceMng");
            return isAdvanceAttr && isAdvanceAttr.value === "true";
        } else {
            return false;
        }
    };

    return SiteView;
}]);

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodView', ["$log", "WorkingPeriodDayView", "DateSrv", "WorkingPeriodDay", "Period", "SiteData", "WorkingPeriod", "$locale", "gettextCatalog", "moment", function ($log, WorkingPeriodDayView, DateSrv, WorkingPeriodDay, Period, SiteData, WorkingPeriod, $locale, gettextCatalog, moment) {

    var WorkingPeriodView = function WorkingPeriodView(workingPeriod, modelIndex) {
        this.modelIndex = -1;
        this.workingPeriodDaysView = [];
        this.labels = [];
        this.period = new Period();
        if (modelIndex !== undefined) this.modelIndex = modelIndex;

        if (workingPeriod !== undefined && workingPeriod) {
            this.period.start.setTimeByHm(workingPeriod.period.start.hour, workingPeriod.period.start.minute);
            this.period.end.setTimeByHm(workingPeriod.period.end.hour, workingPeriod.period.end.minute);

            for (var k = 0; k < workingPeriod.workingPeriodDays.length; k++) {
                this.workingPeriodDaysView.push(new WorkingPeriodDayView(workingPeriod.workingPeriodDays[k], k));
            }
        } else {
            for (var i = 0; i < 7; i++) {
                //Seven days
                this.workingPeriodDaysView.push(new WorkingPeriodDayView());
            } //Default values

            this.period.start.setTimeByHm(10, 0);
            this.period.end.setTimeByHm(19, 0);
        }
        this.update();
    };

    WorkingPeriodView.prototype.getModel = function () {
        if (this.modelIndex != -1) return SiteData.defaultSite.workingPeriods[this.modelIndex];
        return null;
    };

    WorkingPeriodView.prototype.updateModel = function (workingPeriodDayViewsToClose) {
        var workingPeriod = this.getModel();
        if (!workingPeriod) {
            workingPeriod = new WorkingPeriod(null, SiteData.defaultSite);
            this.modelIndex = SiteData.defaultSite.addWorkingPeriod(workingPeriod);
        }

        workingPeriod.period = new Period(this.period);

        var workingPeriodDay = void 0;
        for (var k = 0; k < this.workingPeriodDaysView.length; k++) {
            if (this.workingPeriodDaysView[k].modelIndex == null) {
                workingPeriodDay = new WorkingPeriodDay();
                this.workingPeriodDaysView[k].modelIndex = workingPeriod.addWorkingPeriodDay(workingPeriodDay);
            } else {
                workingPeriodDay = workingPeriod.workingPeriodDays[this.workingPeriodDaysView[k].modelIndex];
            }
            var needToCleanWorkingPeriodDayResources = workingPeriodDayViewsToClose && workingPeriodDayViewsToClose.indexOf(this.workingPeriodDaysView[k]) != -1;
            this.workingPeriodDaysView[k].updateModel(workingPeriodDay, needToCleanWorkingPeriodDayResources);
        }
    };

    WorkingPeriodView.prototype.nbOpenDays = function () {
        var openDays = 0;
        for (var k = 0; k < this.workingPeriodDaysView.length; k++) {
            if (this.workingPeriodDaysView[k].openDay) openDays++;
        }return openDays;
    };

    WorkingPeriodView.prototype.intersect = function (workingPeriodView) {
        var intersect = false;
        if (this.period.intersect(workingPeriodView.period)) {
            for (var k = 0; k < this.workingPeriodDaysView.length && !intersect; k++) {
                if (this.workingPeriodDaysView[k].openDay && workingPeriodView.workingPeriodDaysView[k].openDay) intersect = true;
            }
        }
        return intersect;
    };

    WorkingPeriodView.prototype.update = function () {
        this.updateTimesStr();
        this.updateLabels();
    };

    WorkingPeriodView.prototype.updateTimesStr = function () {
        this.period.start.label = moment().hour(this.period.start.hour).minute(this.period.start.minute).format("LT");
        this.period.end.label = moment().hour(this.period.end.hour).minute(this.period.end.minute).format("LT");
    };

    WorkingPeriodView.prototype.updateLabels = function () {
        this.labels = [];
        var daysLabel = DateSrv.daysOfWeekLabel;
        var startPeriod = -1;
        var isFirstWord = true;

        for (var i = 0; i < this.workingPeriodDaysView.length; i++) {
            if (this.workingPeriodDaysView[i].openDay) {
                if (startPeriod == -1) startPeriod = i;
            } else {
                if (startPeriod != -1) //end of period
                    {
                        if (startPeriod + 1 < i) //More than one day
                            {
                                this.addDaysOnLabels(isFirstWord, startPeriod, i, daysLabel);
                                isFirstWord = false;
                            } else {
                            if (isFirstWord) {
                                this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriod]));
                                isFirstWord = false;
                            } else {
                                this.labels.push(daysLabel[startPeriod]);
                            }
                        }
                        startPeriod = -1;
                    }
            }
        }
        if (startPeriod != -1) //end of period
            {
                this.addDaysOnLabels(isFirstWord, startPeriod, this.workingPeriodDaysView.length, daysLabel);
            }

        if (this.labels.length == 0) {
            var noDay = gettextCatalog.getString("Aucun jour");

            this.labels.push(noDay);
        }
    };

    WorkingPeriodView.prototype.addDaysOnLabels = function (isFirstWord, startPeriodIndex, endPeriodIndex, daysLabel) {
        var firstWord = gettextCatalog.getString("Du");
        var word = gettextCatalog.getString("du");
        var at = gettextCatalog.getString("au");
        var nextPeriodIndex = startPeriodIndex + 1;
        if (nextPeriodIndex === endPeriodIndex) {
            if (isFirstWord) {
                this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriodIndex]));
            } else {
                this.labels.push(daysLabel[startPeriodIndex]);
            }
        } else if (nextPeriodIndex !== endPeriodIndex - 1) {
            if (this.labels.length === 0) {
                word = firstWord;
            }
            this.labels.push(word + " " + daysLabel[startPeriodIndex] + " " + at + " " + daysLabel[endPeriodIndex - 1]);
        } else if (isFirstWord) {
            this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriodIndex]), daysLabel[endPeriodIndex - 1]);
        } else {
            this.labels.push(daysLabel[startPeriodIndex], daysLabel[endPeriodIndex - 1]);
        }
    };

    WorkingPeriodView.prototype.uppercaseFirstLetter = function (word) {
        return word.replace(/(?:^|\s)\S/g, function (firstLetter) {
            return firstLetter.toUpperCase();
        });
    };

    return WorkingPeriodView;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayView', ["WorkingPeriodDayHrView", function (WorkingPeriodDayHrView) {

    var WorkingPeriodDayView = function WorkingPeriodDayView(workingPeriodDay, modelIndex) {
        this.openDay = false;
        this.modelIndex = null;
        if (modelIndex !== undefined) this.modelIndex = modelIndex;
        if (workingPeriodDay !== undefined && workingPeriodDay) {
            this.openDay = workingPeriodDay.openDay;
        }
    };

    WorkingPeriodDayView.prototype.updateModel = function (workingPeriodDay, needToCleanWorkingPeriodDayResources) {
        workingPeriodDay.openDay = this.openDay;
        if (needToCleanWorkingPeriodDayResources) {
            workingPeriodDay.workingPeriodDayHrs = [];
            workingPeriodDay.workingPeriodDayPrs = [];
        }
    };

    return WorkingPeriodDayView;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayHrView', ["gettextCatalog", function (gettextCatalog) {

    var WorkingPeriodDayHrView = function WorkingPeriodDayHrView(specificResource, modelIndex) {
        if (specificResource !== undefined && specificResource) {
            this.modelIndex = modelIndex;
            this.start = { hour: specificResource.start.hour, minute: specificResource.start.minute };
            this.end = { hour: specificResource.end.hour, minute: specificResource.end.minute };
            this.enable = specificResource.enable;
            this.update();
        }
    };

    WorkingPeriodDayHrView.prototype.update = function () {
        this.updateTimesStr();
    };

    WorkingPeriodDayHrView.prototype.updateTimesStr = function () {
        var hourSeparator = gettextCatalog.getString("h");
        this.start.label = this.start.hour + hourSeparator + (this.start.minute < 10 ? "0" : "") + this.start.minute;
        this.end.label = this.end.hour + hourSeparator + (this.end.minute < 10 ? "0" : "") + this.end.minute;
    };

    return WorkingPeriodDayHrView;
}]);

/***/ })

},[805]);


// WEBPACK FOOTER //
// website.bundle.min.cfaf1166f332467b8f08.js